var G_ = Object.defineProperty;
var K_ = (e, t, n) => t in e ? G_(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ae = (e, t, n) => (K_(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as b from "react";
import ie, { createElement as Le, useLayoutEffect as Rs, forwardRef as At, useRef as Ue, useEffect as Ke, useCallback as je, Children as fs, isValidElement as Sc, cloneElement as ml, Fragment as q_, useState as _t, useMemo as fr, createContext as Ii, useContext as bl, useReducer as t0, Component as X_ } from "react";
import * as Yn from "react-dom";
import Z_, { flushSync as Sf } from "react-dom";
function Q_(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _d = { exports: {} }, Hs = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ag;
function J_() {
  if (ag)
    return Hs;
  ag = 1;
  var e = ie, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(a, c, l) {
    var u, d = {}, f = null, h = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      r.call(c, u) && !s.hasOwnProperty(u) && (d[u] = c[u]);
    if (a && a.defaultProps)
      for (u in c = a.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: a, key: f, ref: h, props: d, _owner: o.current };
  }
  return Hs.Fragment = n, Hs.jsx = i, Hs.jsxs = i, Hs;
}
var Ys = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cg;
function eS() {
  return cg || (cg = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ie, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(L) {
      if (L === null || typeof L != "object")
        return null;
      var ue = p && L[p] || L[g];
      return typeof ue == "function" ? ue : null;
    }
    var y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(L) {
      {
        for (var ue = arguments.length, ye = new Array(ue > 1 ? ue - 1 : 0), Fe = 1; Fe < ue; Fe++)
          ye[Fe - 1] = arguments[Fe];
        w("error", L, ye);
      }
    }
    function w(L, ue, ye) {
      {
        var Fe = y.ReactDebugCurrentFrame, it = Fe.getStackAddendum();
        it !== "" && (ue += "%s", ye = ye.concat([it]));
        var ft = ye.map(function(Je) {
          return String(Je);
        });
        ft.unshift("Warning: " + ue), Function.prototype.apply.call(console[L], console, ft);
      }
    }
    var C = !1, x = !1, E = !1, S = !1, M = !1, T;
    T = Symbol.for("react.module.reference");
    function P(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === r || L === s || M || L === o || L === l || L === u || S || L === h || C || x || E || typeof L == "object" && L !== null && (L.$$typeof === f || L.$$typeof === d || L.$$typeof === i || L.$$typeof === a || L.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === T || L.getModuleId !== void 0));
    }
    function k(L, ue, ye) {
      var Fe = L.displayName;
      if (Fe)
        return Fe;
      var it = ue.displayName || ue.name || "";
      return it !== "" ? ye + "(" + it + ")" : ye;
    }
    function I(L) {
      return L.displayName || "Context";
    }
    function O(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case a:
            var ue = L;
            return I(ue) + ".Consumer";
          case i:
            var ye = L;
            return I(ye._context) + ".Provider";
          case c:
            return k(L, L.render, "ForwardRef");
          case d:
            var Fe = L.displayName || null;
            return Fe !== null ? Fe : O(L.type) || "Memo";
          case f: {
            var it = L, ft = it._payload, Je = it._init;
            try {
              return O(Je(ft));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, R = 0, N, $, F, V, D, H, j;
    function U() {
    }
    U.__reactDisabledLog = !0;
    function K() {
      {
        if (R === 0) {
          N = console.log, $ = console.info, F = console.warn, V = console.error, D = console.group, H = console.groupCollapsed, j = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: U,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        R++;
      }
    }
    function G() {
      {
        if (R--, R === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, L, {
              value: N
            }),
            info: A({}, L, {
              value: $
            }),
            warn: A({}, L, {
              value: F
            }),
            error: A({}, L, {
              value: V
            }),
            group: A({}, L, {
              value: D
            }),
            groupCollapsed: A({}, L, {
              value: H
            }),
            groupEnd: A({}, L, {
              value: j
            })
          });
        }
        R < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B = y.ReactCurrentDispatcher, z;
    function W(L, ue, ye) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (it) {
            var Fe = it.stack.trim().match(/\n( *(at )?)/);
            z = Fe && Fe[1] || "";
          }
        return `
` + z + L;
      }
    }
    var X = !1, J;
    {
      var Q = typeof WeakMap == "function" ? WeakMap : Map;
      J = new Q();
    }
    function Y(L, ue) {
      if (!L || X)
        return "";
      {
        var ye = J.get(L);
        if (ye !== void 0)
          return ye;
      }
      var Fe;
      X = !0;
      var it = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ft;
      ft = B.current, B.current = null, K();
      try {
        if (ue) {
          var Je = function() {
            throw Error();
          };
          if (Object.defineProperty(Je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Je, []);
            } catch (Or) {
              Fe = Or;
            }
            Reflect.construct(L, [], Je);
          } else {
            try {
              Je.call();
            } catch (Or) {
              Fe = Or;
            }
            L.call(Je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Or) {
            Fe = Or;
          }
          L();
        }
      } catch (Or) {
        if (Or && Fe && typeof Or.stack == "string") {
          for (var Xe = Or.stack.split(`
`), hn = Fe.stack.split(`
`), Ht = Xe.length - 1, qt = hn.length - 1; Ht >= 1 && qt >= 0 && Xe[Ht] !== hn[qt]; )
            qt--;
          for (; Ht >= 1 && qt >= 0; Ht--, qt--)
            if (Xe[Ht] !== hn[qt]) {
              if (Ht !== 1 || qt !== 1)
                do
                  if (Ht--, qt--, qt < 0 || Xe[Ht] !== hn[qt]) {
                    var Fn = `
` + Xe[Ht].replace(" at new ", " at ");
                    return L.displayName && Fn.includes("<anonymous>") && (Fn = Fn.replace("<anonymous>", L.displayName)), typeof L == "function" && J.set(L, Fn), Fn;
                  }
                while (Ht >= 1 && qt >= 0);
              break;
            }
        }
      } finally {
        X = !1, B.current = ft, G(), Error.prepareStackTrace = it;
      }
      var Zo = L ? L.displayName || L.name : "", ig = Zo ? W(Zo) : "";
      return typeof L == "function" && J.set(L, ig), ig;
    }
    function ce(L, ue, ye) {
      return Y(L, !1);
    }
    function ee(L) {
      var ue = L.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function ne(L, ue, ye) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return Y(L, ee(L));
      if (typeof L == "string")
        return W(L);
      switch (L) {
        case l:
          return W("Suspense");
        case u:
          return W("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case c:
            return ce(L.render);
          case d:
            return ne(L.type, ue, ye);
          case f: {
            var Fe = L, it = Fe._payload, ft = Fe._init;
            try {
              return ne(ft(it), ue, ye);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, pe = {}, Ee = y.ReactDebugCurrentFrame;
    function se(L) {
      if (L) {
        var ue = L._owner, ye = ne(L.type, L._source, ue ? ue.type : null);
        Ee.setExtraStackFrame(ye);
      } else
        Ee.setExtraStackFrame(null);
    }
    function ke(L, ue, ye, Fe, it) {
      {
        var ft = Function.call.bind(de);
        for (var Je in L)
          if (ft(L, Je)) {
            var Xe = void 0;
            try {
              if (typeof L[Je] != "function") {
                var hn = Error((Fe || "React class") + ": " + ye + " type `" + Je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[Je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw hn.name = "Invariant Violation", hn;
              }
              Xe = L[Je](ue, Je, Fe, ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ht) {
              Xe = Ht;
            }
            Xe && !(Xe instanceof Error) && (se(it), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Fe || "React class", ye, Je, typeof Xe), se(null)), Xe instanceof Error && !(Xe.message in pe) && (pe[Xe.message] = !0, se(it), v("Failed %s type: %s", ye, Xe.message), se(null));
          }
      }
    }
    var we = Array.isArray;
    function Oe(L) {
      return we(L);
    }
    function Ie(L) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, ye = ue && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return ye;
      }
    }
    function fe(L) {
      try {
        return q(L), !1;
      } catch {
        return !0;
      }
    }
    function q(L) {
      return "" + L;
    }
    function te(L) {
      if (fe(L))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ie(L)), q(L);
    }
    var oe = y.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ve, xe, Me;
    Me = {};
    function qe(L) {
      if (de.call(L, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function Ze(L) {
      if (de.call(L, "key")) {
        var ue = Object.getOwnPropertyDescriptor(L, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function nt(L, ue) {
      if (typeof L.ref == "string" && oe.current && ue && oe.current.stateNode !== ue) {
        var ye = O(oe.current.type);
        Me[ye] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(oe.current.type), L.ref), Me[ye] = !0);
      }
    }
    function Kt(L, ue) {
      {
        var ye = function() {
          ve || (ve = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        ye.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: ye,
          configurable: !0
        });
      }
    }
    function dn(L, ue) {
      {
        var ye = function() {
          xe || (xe = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        ye.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: ye,
          configurable: !0
        });
      }
    }
    var rn = function(L, ue, ye, Fe, it, ft, Je) {
      var Xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: L,
        key: ue,
        ref: ye,
        props: Je,
        // Record the component responsible for creating this element.
        _owner: ft
      };
      return Xe._store = {}, Object.defineProperty(Xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.defineProperty(Xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: it
      }), Object.freeze && (Object.freeze(Xe.props), Object.freeze(Xe)), Xe;
    };
    function _n(L, ue, ye, Fe, it) {
      {
        var ft, Je = {}, Xe = null, hn = null;
        ye !== void 0 && (te(ye), Xe = "" + ye), Ze(ue) && (te(ue.key), Xe = "" + ue.key), qe(ue) && (hn = ue.ref, nt(ue, it));
        for (ft in ue)
          de.call(ue, ft) && !re.hasOwnProperty(ft) && (Je[ft] = ue[ft]);
        if (L && L.defaultProps) {
          var Ht = L.defaultProps;
          for (ft in Ht)
            Je[ft] === void 0 && (Je[ft] = Ht[ft]);
        }
        if (Xe || hn) {
          var qt = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          Xe && Kt(Je, qt), hn && dn(Je, qt);
        }
        return rn(L, Xe, hn, it, Fe, oe.current, Je);
      }
    }
    var fn = y.ReactCurrentOwner, $n = y.ReactDebugCurrentFrame;
    function me(L) {
      if (L) {
        var ue = L._owner, ye = ne(L.type, L._source, ue ? ue.type : null);
        $n.setExtraStackFrame(ye);
      } else
        $n.setExtraStackFrame(null);
    }
    var De;
    De = !1;
    function Ne(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function Qe() {
      {
        if (fn.current) {
          var L = O(fn.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function Be(L) {
      {
        if (L !== void 0) {
          var ue = L.fileName.replace(/^.*[\\\/]/, ""), ye = L.lineNumber;
          return `

Check your code at ` + ue + ":" + ye + ".";
        }
        return "";
      }
    }
    var Mt = {};
    function ze(L) {
      {
        var ue = Qe();
        if (!ue) {
          var ye = typeof L == "string" ? L : L.displayName || L.name;
          ye && (ue = `

Check the top-level render call using <` + ye + ">.");
        }
        return ue;
      }
    }
    function Kn(L, ue) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var ye = ze(ue);
        if (Mt[ye])
          return;
        Mt[ye] = !0;
        var Fe = "";
        L && L._owner && L._owner !== fn.current && (Fe = " It was passed a child from " + O(L._owner.type) + "."), me(L), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ye, Fe), me(null);
      }
    }
    function Sn(L, ue) {
      {
        if (typeof L != "object")
          return;
        if (Oe(L))
          for (var ye = 0; ye < L.length; ye++) {
            var Fe = L[ye];
            Ne(Fe) && Kn(Fe, ue);
          }
        else if (Ne(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var it = m(L);
          if (typeof it == "function" && it !== L.entries)
            for (var ft = it.call(L), Je; !(Je = ft.next()).done; )
              Ne(Je.value) && Kn(Je.value, ue);
        }
      }
    }
    function Eo(L) {
      {
        var ue = L.type;
        if (ue == null || typeof ue == "string")
          return;
        var ye;
        if (typeof ue == "function")
          ye = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === d))
          ye = ue.propTypes;
        else
          return;
        if (ye) {
          var Fe = O(ue);
          ke(ye, L.props, "prop", Fe, L);
        } else if (ue.PropTypes !== void 0 && !De) {
          De = !0;
          var it = O(ue);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", it || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Sr(L) {
      {
        for (var ue = Object.keys(L.props), ye = 0; ye < ue.length; ye++) {
          var Fe = ue[ye];
          if (Fe !== "children" && Fe !== "key") {
            me(L), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Fe), me(null);
            break;
          }
        }
        L.ref !== null && (me(L), v("Invalid attribute `ref` supplied to `React.Fragment`."), me(null));
      }
    }
    function tr(L, ue, ye, Fe, it, ft) {
      {
        var Je = P(L);
        if (!Je) {
          var Xe = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (Xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var hn = Be(it);
          hn ? Xe += hn : Xe += Qe();
          var Ht;
          L === null ? Ht = "null" : Oe(L) ? Ht = "array" : L !== void 0 && L.$$typeof === t ? (Ht = "<" + (O(L.type) || "Unknown") + " />", Xe = " Did you accidentally export a JSX literal instead of a component?") : Ht = typeof L, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ht, Xe);
        }
        var qt = _n(L, ue, ye, it, ft);
        if (qt == null)
          return qt;
        if (Je) {
          var Fn = ue.children;
          if (Fn !== void 0)
            if (Fe)
              if (Oe(Fn)) {
                for (var Zo = 0; Zo < Fn.length; Zo++)
                  Sn(Fn[Zo], L);
                Object.freeze && Object.freeze(Fn);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(Fn, L);
        }
        return L === r ? Sr(qt) : Eo(qt), qt;
      }
    }
    function wu(L, ue, ye) {
      return tr(L, ue, ye, !0);
    }
    function Bs(L, ue, ye) {
      return tr(L, ue, ye, !1);
    }
    var xa = Bs, xu = wu;
    Ys.Fragment = r, Ys.jsx = xa, Ys.jsxs = xu;
  }()), Ys;
}
process.env.NODE_ENV === "production" ? _d.exports = J_() : _d.exports = eS();
var Of = _d.exports;
const It = Of.Fragment, _ = Of.jsx, Z = Of.jsxs;
function n0(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = n0(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function r0() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = n0(e)) && (r && (r += " "), r += t);
  return r;
}
const lg = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, ug = r0, En = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return ug(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: s } = t, i = Object.keys(o).map((l) => {
    const u = n == null ? void 0 : n[l], d = s == null ? void 0 : s[l];
    if (u === null)
      return null;
    const f = lg(u) || lg(d);
    return o[l][f];
  }), a = n && Object.entries(n).reduce((l, u) => {
    let [d, f] = u;
    return f === void 0 || (l[d] = f), l;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [g, m] = p;
      return Array.isArray(m) ? m.includes({
        ...s,
        ...a
      }[g]) : {
        ...s,
        ...a
      }[g] === m;
    }) ? [
      ...l,
      d,
      f
    ] : l;
  }, []);
  return ug(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function tS(e, t) {
  return function(r, ...o) {
    const s = new URL(e);
    return s.searchParams.set("code", r.toString()), o.forEach((i) => s.searchParams.append("args[]", i)), `${t} error #${r}; visit ${s} for the full message.`;
  };
}
const nS = tS("https://base-ui.com/production-error", "Base UI"), rt = nS, dg = {};
function gn(e, t) {
  const n = b.useRef(dg);
  return n.current === dg && (n.current = e(t)), n;
}
function Vr(e, t, n, r) {
  const o = gn(o0).current;
  return oS(o, e, t, n, r) && s0(o, [e, t, n, r]), o.callback;
}
function rS(e) {
  const t = gn(o0).current;
  return sS(t, e) && s0(t, e), t.callback;
}
function o0() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function oS(e, t, n, r, o) {
  return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== o;
}
function sS(e, t) {
  return e.refs.length !== t.length || e.refs.some((n, r) => n !== t[r]);
}
function s0(e, t) {
  if (e.refs = t, t.every((n) => n == null)) {
    e.callback = null;
    return;
  }
  e.callback = (n) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), n != null) {
      const r = Array(t.length).fill(null);
      for (let o = 0; o < t.length; o += 1) {
        const s = t[o];
        if (s != null)
          switch (typeof s) {
            case "function": {
              const i = s(n);
              typeof i == "function" && (r[o] = i);
              break;
            }
            case "object": {
              s.current = n;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let o = 0; o < t.length; o += 1) {
          const s = t[o];
          if (s != null)
            switch (typeof s) {
              case "function": {
                const i = r[o];
                typeof i == "function" ? i() : s(null);
                break;
              }
              case "object": {
                s.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const iS = parseInt(b.version, 10);
function Mf(e) {
  return iS >= e;
}
function fg(e) {
  if (!/* @__PURE__ */ b.isValidElement(e))
    return null;
  const t = e, n = t.props;
  return (Mf(19) ? n == null ? void 0 : n.ref : t.ref) ?? null;
}
function Sd(e, t) {
  if (e && !t)
    return e;
  if (!e && t)
    return t;
  if (e || t)
    return {
      ...e,
      ...t
    };
}
let Od;
process.env.NODE_ENV !== "production" && (Od = /* @__PURE__ */ new Set());
function vl(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    Od.has(t) || (Od.add(t), console.warn(`Base UI: ${t}`));
  }
}
function an() {
}
const ys = Object.freeze([]), wt = Object.freeze({});
function aS(e, t) {
  const n = {};
  for (const r in e) {
    const o = e[r];
    if (t != null && t.hasOwnProperty(r)) {
      const s = t[r](o);
      s != null && Object.assign(n, s);
      continue;
    }
    o === !0 ? n[`data-${r.toLowerCase()}`] = "" : o && (n[`data-${r.toLowerCase()}`] = o.toString());
  }
  return n;
}
function cS(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function i0(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const Tf = {};
function Zt(e, t, n, r, o) {
  if (!n && !r && !o && !e)
    return Oc(t);
  let s = Oc(e);
  return t && (s = li(s, t)), n && (s = li(s, n)), r && (s = li(s, r)), o && (s = li(s, o)), s;
}
function lS(e) {
  if (e.length === 0)
    return Tf;
  if (e.length === 1)
    return Oc(e[0]);
  let t = Oc(e[0]);
  for (let n = 1; n < e.length; n += 1)
    t = li(t, e[n]);
  return t;
}
function Oc(e) {
  return kf(e) ? {
    ...c0(e, Tf)
  } : uS(e);
}
function li(e, t) {
  return kf(t) ? c0(t, e) : dS(e, t);
}
function uS(e) {
  const t = {
    ...e
  };
  for (const n in t) {
    const r = t[n];
    a0(n, r) && (t[n] = l0(r));
  }
  return t;
}
function dS(e, t) {
  if (!t)
    return e;
  for (const n in t) {
    const r = t[n];
    switch (n) {
      case "style": {
        e[n] = Sd(e.style, r);
        break;
      }
      case "className": {
        e[n] = u0(e.className, r);
        break;
      }
      default:
        a0(n, r) ? e[n] = fS(e[n], r) : e[n] = r;
    }
  }
  return e;
}
function a0(e, t) {
  const n = e.charCodeAt(0), r = e.charCodeAt(1), o = e.charCodeAt(2);
  return n === 111 && r === 110 && o >= 65 && o <= 90 && (typeof t == "function" || typeof t > "u");
}
function kf(e) {
  return typeof e == "function";
}
function c0(e, t) {
  return kf(e) ? e(t) : e ?? Tf;
}
function fS(e, t) {
  return t ? e ? (...n) => {
    const r = n[0];
    if (d0(r)) {
      const s = r;
      Mc(s);
      const i = t(...n);
      return s.baseUIHandlerPrevented || e == null || e(...n), i;
    }
    const o = t(...n);
    return e == null || e(...n), o;
  } : l0(t) : e;
}
function l0(e) {
  return e && ((...t) => {
    const n = t[0];
    return d0(n) && Mc(n), e(...t);
  });
}
function Mc(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function u0(e, t) {
  return t ? e ? t + " " + e : t : e;
}
function d0(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
function $e(e, t, n = {}) {
  const r = t.render, o = hS(t, n);
  if (n.enabled === !1)
    return null;
  const s = n.state ?? wt;
  return vS(e, r, o, s);
}
function hS(e, t = {}) {
  const {
    className: n,
    style: r,
    render: o
  } = e, {
    state: s = wt,
    ref: i,
    props: a,
    stateAttributesMapping: c,
    enabled: l = !0
  } = t, u = l ? cS(n, s) : void 0, d = l ? i0(r, s) : void 0, f = l ? aS(s, c) : wt, h = l && a ? pS(a) : void 0, p = l ? Sd(f, h) ?? {} : wt;
  return typeof document < "u" && (l ? Array.isArray(i) ? p.ref = rS([p.ref, fg(o), ...i]) : p.ref = Vr(p.ref, fg(o), i) : Vr(null, null)), l ? (u !== void 0 && (p.className = u0(p.className, u)), d !== void 0 && (p.style = Sd(p.style, d)), p) : wt;
}
function pS(e) {
  return Array.isArray(e) ? lS(e) : Zt(void 0, e);
}
const gS = Symbol.for("react.lazy"), mS = /^[A-Z][A-Za-z0-9$]*$/, bS = /[a-z]/;
function vS(e, t, n, r) {
  if (t) {
    if (typeof t == "function")
      return process.env.NODE_ENV !== "production" && yS(t), t(n, r);
    const o = Zt(n, t.props);
    o.ref = n.ref;
    let s = t;
    if ((s == null ? void 0 : s.$$typeof) === gS && (s = b.Children.toArray(t)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ b.isValidElement(s))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ b.cloneElement(s, o);
  }
  if (e && typeof e == "string")
    return wS(e, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : rt(8));
}
function yS(e) {
  const t = e.name;
  t.length !== 0 && mS.test(t) && bS.test(t) && vl(`The \`render\` prop received a function named \`${t}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function wS(e, t) {
  return e === "button" ? /* @__PURE__ */ Le("button", {
    type: "button",
    ...t,
    key: t.key
  }) : e === "img" ? /* @__PURE__ */ Le("img", {
    alt: "",
    ...t,
    key: t.key
  }) : /* @__PURE__ */ b.createElement(e, t);
}
function Is(e) {
  return $e(e.defaultTagName ?? "div", e, e);
}
function xS() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = f0(t)) && (r && (r += " "), r += n);
  return r;
}
function f0(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = f0(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Pf = "-";
function CS(e) {
  var t = _S(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function s(a) {
    var c = a.split(Pf);
    return c[0] === "" && c.length !== 1 && c.shift(), h0(c, t) || ES(a);
  }
  function i(a, c) {
    var l = n[a] || [];
    return c && o[a] ? [].concat(l, o[a]) : l;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: i
  };
}
function h0(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? h0(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var s = e.join(Pf);
    return (i = t.validators.find(function(a) {
      var c = a.validator;
      return c(s);
    })) == null ? void 0 : i.classGroupId;
  }
}
var hg = /^\[(.+)\]$/;
function ES(e) {
  if (hg.test(e)) {
    var t = hg.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function _S(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = OS(Object.entries(e.classGroups), n);
  return o.forEach(function(s) {
    var i = s[0], a = s[1];
    Md(a, r, i, t);
  }), r;
}
function Md(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var s = o === "" ? t : pg(t, o);
      s.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (SS(o)) {
        Md(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(i) {
      var a = i[0], c = i[1];
      Md(c, pg(t, a), n, r);
    });
  });
}
function pg(e, t) {
  var n = e;
  return t.split(Pf).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function SS(e) {
  return e.isThemeGetter;
}
function OS(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], s = o.map(function(i) {
      return typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(a) {
        var c = a[0], l = a[1];
        return [t + c, l];
      })) : i;
    });
    return [r, s];
  }) : e;
}
function MS(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(s, i) {
    n.set(s, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var a = n.get(i);
      if (a !== void 0)
        return a;
      if ((a = r.get(i)) !== void 0)
        return o(i, a), a;
    },
    set: function(i, a) {
      n.has(i) ? n.set(i, a) : o(i, a);
    }
  };
}
var p0 = "!";
function TS(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(i) {
    for (var a = [], c = 0, l = 0, u, d = 0; d < i.length; d++) {
      var f = i[d];
      if (c === 0) {
        if (f === r && (n || i.slice(d, d + o) === t)) {
          a.push(i.slice(l, d)), l = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? c++ : f === "]" && c--;
    }
    var h = a.length === 0 ? i : i.substring(l), p = h.startsWith(p0), g = p ? h.substring(1) : h, m = u && u > l ? u - l : void 0;
    return {
      modifiers: a,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
}
function kS(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function PS(e) {
  return {
    cache: MS(e.cacheSize),
    splitModifiers: TS(e),
    ...CS(e)
  };
}
var RS = /\s+/;
function IS(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, s = /* @__PURE__ */ new Set();
  return e.trim().split(RS).map(function(i) {
    var a = n(i), c = a.modifiers, l = a.hasImportantModifier, u = a.baseClassName, d = a.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), h = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      h = !1;
    }
    var p = kS(c).join(":"), g = l ? p + p0 : p;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: i,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var a = i.modifierId, c = i.classGroupId, l = i.hasPostfixModifier, u = a + c;
    return s.has(u) ? !1 : (s.add(u), o(c, l).forEach(function(d) {
      return s.add(a + d);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function DS() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, s, i = a;
  function a(l) {
    var u = t[0], d = t.slice(1), f = d.reduce(function(h, p) {
      return p(h);
    }, u());
    return r = PS(f), o = r.cache.get, s = r.cache.set, i = c, c(l);
  }
  function c(l) {
    var u = o(l);
    if (u)
      return u;
    var d = IS(l, r);
    return s(l, d), d;
  }
  return function() {
    return i(xS.apply(null, arguments));
  };
}
function Tt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var g0 = /^\[(?:([a-z-]+):)?(.+)\]$/i, NS = /^\d+\/\d+$/, AS = /* @__PURE__ */ new Set(["px", "full", "screen"]), $S = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, FS = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, LS = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function qn(e) {
  return Ao(e) || AS.has(e) || NS.test(e) || Td(e);
}
function Td(e) {
  return Ko(e, "length", zS);
}
function VS(e) {
  return Ko(e, "size", m0);
}
function WS(e) {
  return Ko(e, "position", m0);
}
function BS(e) {
  return Ko(e, "url", jS);
}
function Ca(e) {
  return Ko(e, "number", Ao);
}
function Ao(e) {
  return !Number.isNaN(Number(e));
}
function HS(e) {
  return e.endsWith("%") && Ao(e.slice(0, -1));
}
function zs(e) {
  return gg(e) || Ko(e, "number", gg);
}
function tt(e) {
  return g0.test(e);
}
function js() {
  return !0;
}
function Qr(e) {
  return $S.test(e);
}
function YS(e) {
  return Ko(e, "", US);
}
function Ko(e, t, n) {
  var r = g0.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function zS(e) {
  return FS.test(e);
}
function m0() {
  return !1;
}
function jS(e) {
  return e.startsWith("url(");
}
function gg(e) {
  return Number.isInteger(Number(e));
}
function US(e) {
  return LS.test(e);
}
function GS() {
  var e = Tt("colors"), t = Tt("spacing"), n = Tt("blur"), r = Tt("brightness"), o = Tt("borderColor"), s = Tt("borderRadius"), i = Tt("borderSpacing"), a = Tt("borderWidth"), c = Tt("contrast"), l = Tt("grayscale"), u = Tt("hueRotate"), d = Tt("invert"), f = Tt("gap"), h = Tt("gradientColorStops"), p = Tt("gradientColorStopPositions"), g = Tt("inset"), m = Tt("margin"), y = Tt("opacity"), v = Tt("padding"), w = Tt("saturate"), C = Tt("scale"), x = Tt("sepia"), E = Tt("skew"), S = Tt("space"), M = Tt("translate"), T = function() {
    return ["auto", "contain", "none"];
  }, P = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, k = function() {
    return ["auto", tt, t];
  }, I = function() {
    return [tt, t];
  }, O = function() {
    return ["", qn];
  }, A = function() {
    return ["auto", Ao, tt];
  }, R = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, N = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, $ = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, F = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, V = function() {
    return ["", "0", tt];
  }, D = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, H = function() {
    return [Ao, Ca];
  }, j = function() {
    return [Ao, tt];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [js],
      spacing: [qn],
      blur: ["none", "", Qr, tt],
      brightness: H(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Qr, tt],
      borderSpacing: I(),
      borderWidth: O(),
      contrast: H(),
      grayscale: V(),
      hueRotate: j(),
      invert: V(),
      gap: I(),
      gradientColorStops: [e],
      gradientColorStopPositions: [HS, Td],
      inset: k(),
      margin: k(),
      opacity: H(),
      padding: I(),
      saturate: H(),
      scale: H(),
      sepia: V(),
      skew: j(),
      space: I(),
      translate: I()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", tt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Qr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(R(), [tt])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: P()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": P()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": P()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: T()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": T()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": T()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", zs]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: k()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", tt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: V()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: V()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", zs]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [js]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", zs]
        }, tt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": A()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": A()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [js]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [zs]
        }, tt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": A()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": A()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", tt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", tt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(F())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(F(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(F(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", tt, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", tt, qn]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Qr]
        }, Qr, tt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [tt, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", tt, qn]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [tt, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Qr, Td]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ca]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [js]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", tt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ao, Ca]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", tt, qn]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", tt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", tt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(N(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", qn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", tt, qn]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", tt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", tt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(R(), [WS])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", VS]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, BS]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(N(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: N()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(N())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [tt, qn]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [qn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: O()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [qn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Qr, YS]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [js]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Qr, tt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [x]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [x]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", tt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: j()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", tt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: j()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", tt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [zs, tt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [E]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [E]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", tt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", tt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", tt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qn, Ca]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var KS = /* @__PURE__ */ DS(GS);
function le(...e) {
  return KS(r0(e));
}
const Rf = En(
  "relative inline-flex select-none items-center justify-center gap-2 overflow-hidden rounded-md border border-transparent font-medium transition-colors duration-75 focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "border-info-bolder bg-info-bold text-foundations-inverse hover:border-info-boldest hover:bg-info-bolder hover:shadow-sm focus-visible:border-info-boldest focus-visible:shadow-sm focus-visible:ring-info-boldest active:bg-info-boldest [&_[data-slot=spinner-container]]:bg-foundations-subtlest [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        secondary: "border-foundations-bold bg-foundations-default text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle",
        tertiary: "text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:shadow-sm focus-visible:ring-info-bold active:bg-foundations-subtler active:text-foundations-bold  [&_[data-slot=spinner-container]]:bg-foundations-default [&_[data-slot=spinner-icon]]:border-info-boldest [&_[data-slot=spinner-icon]]:border-r-info-subtle"
      },
      size: {
        xs: "px-4 py-1.5 text-xs [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        sm: "px-6 py-2.5 text-sm [&_[data-slot=spinner-icon]]:size-5 [&_svg:not([class*='size-'])]:size-5",
        md: "px-6 py-3 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6",
        lg: "px-8 py-4 text-base [&_[data-slot=spinner-icon]]:size-6 [&_svg:not([class*='size-'])]:size-6"
      },
      disabled: {
        true: ""
      },
      colorScheme: {
        danger: "",
        success: "",
        inverse: ""
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        colorScheme: "danger",
        className: "border-danger-bolder bg-danger-bold hover:border-danger-boldest hover:bg-danger-bolder focus-visible:border-danger-boldest focus-visible:ring-danger-boldest active:bg-danger-boldest [&_[data-slot=spinner-icon]]:border-red-700 [&_[data-slot=spinner-icon]]:border-r-red-300"
      },
      {
        variant: "primary",
        colorScheme: "success",
        className: "border-success-bolder bg-success-bold hover:border-success-boldest hover:bg-success-bolder focus-visible:border-success-boldest focus-visible:ring-success-boldest active:bg-success-boldest [&_[data-slot=spinner-icon]]:border-green-700 [&_[data-slot=spinner-icon]]:border-r-green-300"
      },
      {
        variant: "primary",
        colorScheme: "inverse",
        className: "border-info-bold bg-foundations-default text-info hover:border-info-bold hover:bg-info-subtler focus-visible:border-info-bold focus-visible:ring-info-bold active:bg-info-subtler active:text-info disabled:text-foundations-subtler "
      },
      {
        variant: "secondary",
        colorScheme: "danger",
        className: "border border-danger-subtle text-danger hover:bg-danger-subtler hover:text-danger focus-visible:border-danger-subtle focus-visible:ring-danger-subtle active:border-danger-subtler active:bg-danger-subtler active:text-danger"
      },
      {
        variant: "secondary",
        colorScheme: "success",
        className: "border border-success-subtle text-success hover:bg-success-subtler hover:text-success focus-visible:border-success-subtle focus-visible:ring-success-subtle active:border-success-subtler active:bg-success-subtler active:text-success"
      },
      {
        variant: "primary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtler disabled:text-foundations-subtler"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "disabled:border-foundations-subtle disabled:bg-foundations-subtlest disabled:text-foundations-subtler"
      },
      {
        variant: "tertiary",
        disabled: !0,
        className: "disabled:text-foundations-subtler"
      },
      {
        colorScheme: "inverse",
        disabled: !0,
        className: "disabled:border-foundations-bold disabled:bg-foundations-subtler disabled:!text-foundations-subtler"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), Tc = b.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    children: s,
    render: i,
    ...a
  }, c) => {
    const l = {
      type: "button",
      className: le(
        Rf({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: e
        })
      ),
      disabled: a.disabled || r,
      children: /* @__PURE__ */ Z(It, { children: [
        s,
        r && /* @__PURE__ */ _(b0, {})
      ] }),
      "data-slot": "button"
    };
    return Is({
      defaultTagName: "button",
      render: i,
      ref: c,
      props: Zt(l, a)
    });
  }
);
Tc.displayName = "Button";
const b0 = () => /* @__PURE__ */ _(
  "div",
  {
    "data-slot": "spinner-container",
    className: "absolute inset-0 flex items-center justify-center",
    children: /* @__PURE__ */ _(
      "div",
      {
        "data-slot": "spinner-icon",
        className: " animate-spin rounded-full border-4"
      }
    )
  }
), qS = ie.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    role: "group",
    ref: n,
    className: le(
      "flex [&>button:focus]:z-10 [&>button:not(:first-of-type)]:rounded-l-none [&>button:not(:focus-visible):not(:last-of-type)]:border-r-transparent [&>button:not(:last-of-type)]:rounded-r-none",
      e
    ),
    ...t
  }
));
qS.displayName = "ButtonGroup";
const XS = En("", {
  variants: {
    size: {
      xs: "p-1 [&_svg:not([class*='size-'])]:size-4",
      sm: "p-2.5 [&_svg:not([class*='size-'])]:size-5",
      md: "p-3 [&_svg:not([class*='size-'])]:size-6",
      lg: "p-4 [&_svg:not([class*='size-'])]:size-6"
    },
    shape: {
      circle: "rounded-full"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), Di = b.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    isLoading: r,
    colorScheme: o,
    shape: s,
    render: i,
    children: a,
    ...c
  }, l) => {
    const u = {
      type: "button",
      className: le(
        Rf({
          variant: t,
          size: n,
          colorScheme: o,
          disabled: c.disabled || r
        }),
        XS({
          size: n,
          shape: s,
          className: e
        })
      ),
      disabled: c.disabled || r,
      children: /* @__PURE__ */ Z(It, { children: [
        a,
        r && /* @__PURE__ */ _(b0, {})
      ] }),
      "data-slot": "icon-button"
    };
    return Is({
      defaultTagName: "button",
      render: i,
      ref: l,
      props: Zt(u, c)
    });
  }
);
Di.displayName = "IconButton";
const kd = [];
let Pd;
function ZS() {
  return Pd;
}
function QS(e) {
  kd.push(e);
}
function If(e) {
  const t = (n, r) => {
    const o = gn(JS).current;
    let s;
    try {
      Pd = o;
      for (const i of kd)
        i.before(o);
      s = e(n, r);
      for (const i of kd)
        i.after(o);
      o.didInitialize = !0;
    } finally {
      Pd = void 0;
    }
    return s;
  };
  return t.displayName = e.displayName || e.name, t;
}
function v0(e) {
  return /* @__PURE__ */ b.forwardRef(If(e));
}
function JS() {
  return {
    didInitialize: !1
  };
}
function yl(e) {
  const t = b.useRef(!0);
  t.current && (t.current = !1, e());
}
const eO = () => {
}, be = typeof document < "u" ? b.useLayoutEffect : eO, Df = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Df.displayName = "TooltipRootContext");
function Zi(e) {
  const t = b.useContext(Df);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : rt(72));
  return t;
}
const tO = [];
function wl(e) {
  b.useEffect(e, tO);
}
const Us = 0;
class xn {
  constructor() {
    ae(this, "currentId", Us);
    ae(this, "clear", () => {
      this.currentId !== Us && (clearTimeout(this.currentId), this.currentId = Us);
    });
    ae(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new xn();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Us, n();
    }, t);
  }
  isStarted() {
    return this.currentId !== Us;
  }
}
function ln() {
  const e = gn(xn.create).current;
  return wl(e.disposeEffect), e;
}
const Ds = typeof navigator < "u", Cu = nO(), y0 = oO(), w0 = rO(), x0 = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), C0 = (
  // iPads can claim to be MacIntel
  Cu.platform === "MacIntel" && Cu.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Cu.platform)
), E0 = Ds && /apple/i.test(navigator.vendor), Rd = Ds && /android/i.test(y0) || /android/i.test(w0), _0 = Ds && y0.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, S0 = w0.includes("jsdom/");
function nO() {
  if (!Ds)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const e = navigator.userAgentData;
  return e != null && e.platform ? {
    platform: e.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function rO() {
  if (!Ds)
    return "";
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map(({
    brand: t,
    version: n
  }) => `${t}/${n}`).join(" ") : navigator.userAgent;
}
function oO() {
  if (!Ds)
    return "";
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform ?? "";
}
function kn(e) {
  e.preventDefault(), e.stopPropagation();
}
function sO(e) {
  return "nativeEvent" in e;
}
function O0(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : Rd && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function M0(e) {
  return S0 ? !1 : !Rd && e.width === 0 && e.height === 0 || Rd && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Bo(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function iO(e) {
  const t = e.type;
  return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
function xl() {
  return typeof window < "u";
}
function un(e) {
  return Nf(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ot(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function wr(e) {
  var t;
  return (t = (Nf(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nf(e) {
  return xl() ? e instanceof Node || e instanceof Ot(e).Node : !1;
}
function Ge(e) {
  return xl() ? e instanceof Element || e instanceof Ot(e).Element : !1;
}
function vt(e) {
  return xl() ? e instanceof HTMLElement || e instanceof Ot(e).HTMLElement : !1;
}
function ws(e) {
  return !xl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ot(e).ShadowRoot;
}
function mo(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Cn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function aO(e) {
  return /^(table|td|th)$/.test(un(e));
}
function Cl(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const cO = /transform|translate|scale|rotate|perspective|filter/, lO = /paint|layout|strict|content/, _o = (e) => !!e && e !== "none";
let Eu;
function Af(e) {
  const t = Ge(e) ? Cn(e) : e;
  return _o(t.transform) || _o(t.translate) || _o(t.scale) || _o(t.rotate) || _o(t.perspective) || !El() && (_o(t.backdropFilter) || _o(t.filter)) || cO.test(t.willChange || "") || lO.test(t.contain || "");
}
function uO(e) {
  let t = mr(e);
  for (; vt(t) && !hr(t); ) {
    if (Af(t))
      return t;
    if (Cl(t))
      return null;
    t = mr(t);
  }
  return null;
}
function El() {
  return Eu == null && (Eu = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Eu;
}
function hr(e) {
  return /^(html|body|#document)$/.test(un(e));
}
function Cn(e) {
  return Ot(e).getComputedStyle(e);
}
function _l(e) {
  return Ge(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function mr(e) {
  if (un(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ws(e) && e.host || // Fallback.
    wr(e)
  );
  return ws(t) ? t.host : t;
}
function T0(e) {
  const t = mr(e);
  return hr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : vt(t) && mo(t) ? t : T0(t);
}
function Ni(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = T0(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Ot(o);
  if (s) {
    const a = Id(i);
    return t.concat(i, i.visualViewport || [], mo(o) ? o : [], a && n ? Ni(a) : []);
  } else
    return t.concat(o, Ni(o, [], n));
}
function Id(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const Dd = "data-base-ui-focusable", k0 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", co = "ArrowLeft", lo = "ArrowRight", $f = "ArrowUp", Qi = "ArrowDown";
function Xt(e) {
  var n;
  let t = e.activeElement;
  for (; ((n = t == null ? void 0 : t.shadowRoot) == null ? void 0 : n.activeElement) != null; )
    t = t.shadowRoot.activeElement;
  return t;
}
function Re(e, t) {
  var r;
  if (!e || !t)
    return !1;
  const n = (r = t.getRootNode) == null ? void 0 : r.call(t);
  if (e.contains(t))
    return !0;
  if (n && ws(n)) {
    let o = t;
    for (; o; ) {
      if (e === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function Dt(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function kc(e, t) {
  if (!Ge(e))
    return !1;
  const n = e;
  if (t.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, r] of t.entries())
    if (Re(r, n))
      return !r.hasAttribute("data-trigger-disabled");
  return !1;
}
function _u(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function dO(e) {
  return e.matches("html,body");
}
function Sl(e) {
  return vt(e) && e.matches(k0);
}
function fO(e) {
  return (e == null ? void 0 : e.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${k0}`)) != null;
}
function Nd(e) {
  return e ? e.getAttribute("role") === "combobox" && Sl(e) : !1;
}
function Pc(e) {
  if (!e || S0)
    return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Ad(e) {
  return e ? e.hasAttribute(Dd) ? e : e.querySelector(`[${Dd}]`) || e : null;
}
function hO(e, t) {
  return t != null && !Bo(t) ? 0 : typeof e == "function" ? e() : e;
}
function Rc(e, t, n) {
  const r = hO(e, n);
  return typeof r == "number" ? r : r == null ? void 0 : r[t];
}
function mg(e) {
  return typeof e == "function" ? e() : e;
}
function P0(e, t) {
  return t || e === "click" || e === "mousedown";
}
function pO(e) {
  return (e == null ? void 0 : e.includes("mouse")) && e !== "mousedown";
}
const xs = "none", br = "trigger-press", Pt = "trigger-hover", hs = "trigger-focus", Ff = "outside-press", Ol = "item-press", R0 = "close-press", Ho = "focus-out", Ji = "escape-key", $d = "list-navigation", gO = "cancel-open", ui = "sibling-open", I0 = "disabled", bg = "missing", vg = "initial", Ml = "imperative-action";
function Ve(e, t, n, r) {
  let o = !1, s = !1;
  const i = r ?? wt;
  return {
    reason: e,
    event: t ?? new Event("base-ui"),
    cancel() {
      o = !0;
    },
    allowPropagation() {
      s = !0;
    },
    get isCanceled() {
      return o;
    },
    get isPropagationAllowed() {
      return s;
    },
    trigger: n,
    ...i
  };
}
const Lf = /* @__PURE__ */ b.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new xn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Lf.displayName = "FloatingDelayGroupContext");
function mO(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: r = 0
  } = e, o = b.useRef(n), s = b.useRef(n), i = b.useRef(null), a = b.useRef(null), c = ln();
  return /* @__PURE__ */ _(Lf.Provider, {
    value: b.useMemo(() => ({
      hasProvider: !0,
      delayRef: o,
      initialDelayRef: s,
      currentIdRef: i,
      timeoutMs: r,
      currentContextRef: a,
      timeout: c
    }), [r, c]),
    children: t
  });
}
function bO(e, t = {
  open: !1
}) {
  const {
    open: n
  } = t, r = "rootStore" in e ? e.rootStore : e, o = r.useState("floatingId"), s = b.useContext(Lf), {
    currentIdRef: i,
    delayRef: a,
    timeoutMs: c,
    initialDelayRef: l,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = s, [h, p] = b.useState(!1);
  return be(() => {
    function g() {
      var m;
      p(!1), (m = u.current) == null || m.setIsInstantPhase(!1), i.current = null, u.current = null, a.current = l.current;
    }
    if (i.current && !n && i.current === o) {
      if (p(!1), c) {
        const m = o;
        return f.start(c, () => {
          r.select("open") || i.current && i.current !== m || g();
        }), () => {
          f.clear();
        };
      }
      g();
    }
  }, [n, o, i, a, c, l, u, f, r]), be(() => {
    if (!n)
      return;
    const g = u.current, m = i.current;
    f.clear(), u.current = {
      onOpenChange: r.setOpen,
      setIsInstantPhase: p
    }, i.current = o, a.current = {
      open: 0,
      close: Rc(l.current, "close")
    }, m !== null && m !== o ? (p(!0), g == null || g.setIsInstantPhase(!0), g == null || g.onOpenChange(!1, Ve(xs))) : (p(!1), g == null || g.setIsInstantPhase(!1));
  }, [n, o, r, i, a, l, u, f]), be(() => () => {
    u.current = null;
  }, [u]), b.useMemo(() => ({
    hasProvider: d,
    delayRef: a,
    isInstantPhase: h
  }), [d, a, h]);
}
function We(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function er(...e) {
  return () => {
    for (let t = 0; t < e.length; t += 1) {
      const n = e[t];
      n && n();
    }
  };
}
function Yt(e) {
  const t = gn(vO, e).current;
  return t.next = e, be(t.effect), t;
}
function vO(e) {
  const t = {
    current: e,
    next: e,
    effect: () => {
      t.current = t.next;
    }
  };
  return t;
}
const Wn = {
  ...b
}, Su = Wn.useInsertionEffect, yO = (
  // React 17 doesn't have useInsertionEffect.
  Su && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  Su !== Wn.useLayoutEffect ? Su : (e) => e()
);
function Se(e) {
  const t = gn(wO).current;
  return t.next = e, yO(t.effect), t.trampoline;
}
function wO() {
  const e = {
    next: void 0,
    callback: xO,
    trampoline: (...t) => {
      var n;
      return (n = e.callback) == null ? void 0 : n.call(e, ...t);
    },
    effect: () => {
      e.callback = e.next;
    }
  };
  return e;
}
function xO() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const Ea = null;
let yg = globalThis.requestAnimationFrame;
class CO {
  constructor() {
    /* This implementation uses an array as a backing data-structure for frame callbacks.
     * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
     * never calls the native `cancelAnimationFrame` if there are no frames left. This can
     * be much more efficient if there is a call pattern that alterns as
     * "request-cancel-request-cancel-…".
     * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
     * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
    ae(this, "callbacks", []);
    ae(this, "callbacksCount", 0);
    ae(this, "nextId", 1);
    ae(this, "startId", 1);
    ae(this, "isScheduled", !1);
    ae(this, "tick", (t) => {
      var o;
      this.isScheduled = !1;
      const n = this.callbacks, r = this.callbacksCount;
      if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, r > 0)
        for (let s = 0; s < n.length; s += 1)
          (o = n[s]) == null || o.call(n, t);
    });
  }
  request(t) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(t), this.callbacksCount += 1;
    const r = process.env.NODE_ENV !== "production" && yg !== requestAnimationFrame && (yg = requestAnimationFrame, !0);
    return (!this.isScheduled || r) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(t) {
    const n = t - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const _a = new CO();
class bn {
  constructor() {
    ae(this, "currentId", Ea);
    ae(this, "cancel", () => {
      this.currentId !== Ea && (_a.cancel(this.currentId), this.currentId = Ea);
    });
    ae(this, "disposeEffect", () => this.cancel);
  }
  static create() {
    return new bn();
  }
  static request(t) {
    return _a.request(t);
  }
  static cancel(t) {
    return _a.cancel(t);
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(t) {
    this.cancel(), this.currentId = _a.request(() => {
      this.currentId = Ea, t();
    });
  }
}
function Ai() {
  const e = gn(bn.create).current;
  return wl(e.disposeEffect), e;
}
function Ye(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
const D0 = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Tl = {
  ...D0,
  position: "fixed",
  top: 0,
  left: 0
}, EO = {
  ...D0,
  position: "absolute"
}, Hn = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const [r, o] = b.useState();
  return be(() => {
    E0 && o("button");
  }, []), /* @__PURE__ */ _("span", {
    ...t,
    ref: n,
    style: Tl,
    "aria-hidden": r ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: r
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Hn.displayName = "FocusGuard");
const _O = ["top", "right", "bottom", "left"], Cs = Math.min, Rn = Math.max, Ic = Math.round, $o = Math.floor, pr = (e) => ({
  x: e,
  y: e
}), SO = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Fd(e, t, n) {
  return Rn(e, Cs(t, n));
}
function Wr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function wn(e) {
  return e.split("-")[0];
}
function bo(e) {
  return e.split("-")[1];
}
function Vf(e) {
  return e === "x" ? "y" : "x";
}
function Wf(e) {
  return e === "y" ? "height" : "width";
}
function Bn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Bf(e) {
  return Vf(Bn(e));
}
function OO(e, t, n) {
  n === void 0 && (n = !1);
  const r = bo(e), o = Bf(e), s = Wf(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = Dc(i)), [i, Dc(i)];
}
function MO(e) {
  const t = Dc(e);
  return [Ld(e), t, Ld(t)];
}
function Ld(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const wg = ["left", "right"], xg = ["right", "left"], TO = ["top", "bottom"], kO = ["bottom", "top"];
function PO(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? xg : wg : t ? wg : xg;
    case "left":
    case "right":
      return t ? TO : kO;
    default:
      return [];
  }
}
function RO(e, t, n, r) {
  const o = bo(e);
  let s = PO(wn(e), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), t && (s = s.concat(s.map(Ld)))), s;
}
function Dc(e) {
  const t = wn(e);
  return SO[t] + e.slice(t.length);
}
function IO(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function N0(e) {
  return typeof e != "number" ? IO(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Nc(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Sa(e, t, n) {
  return Math.floor(e / t) !== n;
}
function $i(e, t) {
  return t < 0 || t >= e.length;
}
function lc(e, t) {
  return sn(e.current, {
    disabledIndices: t
  });
}
function Vd(e, t) {
  return sn(e.current, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function sn(e, {
  startingIndex: t = -1,
  decrement: n = !1,
  disabledIndices: r,
  amount: o = 1
} = {}) {
  let s = t;
  do
    s += n ? -o : o;
  while (s >= 0 && s <= e.length - 1 && Fr(e, s, r));
  return s;
}
function A0(e, {
  event: t,
  orientation: n,
  loopFocus: r,
  onLoop: o,
  rtl: s,
  cols: i,
  disabledIndices: a,
  minIndex: c,
  maxIndex: l,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, h;
  if (t.key === $f ? h = "up" : t.key === Qi && (h = "down"), h) {
    const p = [], g = [];
    let m = !1, y = 0;
    {
      let T = null, P = -1;
      e.forEach((k, I) => {
        if (k == null)
          return;
        y += 1;
        const O = k.closest('[role="row"]');
        O && (m = !0), (O !== T || P === -1) && (T = O, P += 1, p[P] = []), p[P].push(I), g[I] = P;
      });
    }
    let v = !1, w = 0;
    if (m)
      for (const T of p) {
        const P = T.length;
        P > w && (w = P), P !== i && (v = !0);
      }
    const C = v && y < e.length, x = w || i, E = (T) => {
      if (!v || u === -1)
        return;
      const P = g[u];
      if (P == null)
        return;
      const k = p[P].indexOf(u), I = T === "up" ? -1 : 1;
      for (let O = P + I, A = 0; A < p.length; A += 1, O += I) {
        if (O < 0 || O >= p.length) {
          if (!r || C)
            return;
          if (O = O < 0 ? p.length - 1 : 0, o) {
            const N = Math.min(k, p[O].length - 1), $ = p[O][N] ?? p[O][0], F = o(t, u, $);
            O = g[F] ?? O;
          }
        }
        const R = p[O];
        for (let N = Math.min(k, R.length - 1); N >= 0; N -= 1) {
          const $ = R[N];
          if (!Fr(e, $, a))
            return $;
        }
      }
    }, S = (T) => {
      if (!C || u === -1)
        return;
      const P = u % x, k = T === "up" ? -x : x, I = l - l % x, O = $o(l / x) + 1;
      for (let A = u - P + k, R = 0; R < O; R += 1, A += k) {
        if (A < 0 || A > l) {
          if (!r)
            return;
          A = A < 0 ? I : 0;
        }
        const N = Math.min(A + x - 1, l);
        for (let $ = Math.min(A + P, N); $ >= A; $ -= 1)
          if (!Fr(e, $, a))
            return $;
      }
    };
    d && kn(t);
    const M = E(h) ?? S(h);
    if (M !== void 0)
      f = M;
    else if (u === -1)
      f = h === "up" ? l : c;
    else if (f = sn(e, {
      startingIndex: u,
      amount: x,
      decrement: h === "up",
      disabledIndices: a
    }), r) {
      if (h === "up" && (u - x < c || f < 0)) {
        const T = u % x, P = l % x, k = l - (P - T);
        P === T ? f = l : f = P > T ? k : k - x, o && (f = o(t, u, f));
      }
      h === "down" && u + x > l && (f = sn(e, {
        startingIndex: u % x - x,
        amount: x,
        disabledIndices: a
      }), o && (f = o(t, u, f)));
    }
    $i(e, f) && (f = u);
  }
  if (n === "both") {
    const p = $o(u / i);
    t.key === (s ? co : lo) && (d && kn(t), u % i !== i - 1 ? (f = sn(e, {
      startingIndex: u,
      disabledIndices: a
    }), r && Sa(f, i, p) && (f = sn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f)))) : r && (f = sn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f))), Sa(f, i, p) && (f = u)), t.key === (s ? lo : co) && (d && kn(t), u % i !== 0 ? (f = sn(e, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: a
    }), r && Sa(f, i, p) && (f = sn(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), o && (f = o(t, u, f)))) : r && (f = sn(e, {
      startingIndex: u + (i - u % i),
      decrement: !0,
      disabledIndices: a
    }), o && (f = o(t, u, f))), Sa(f, i, p) && (f = u));
    const g = $o(l / i) === p;
    $i(e, f) && (r && g ? (f = t.key === (s ? lo : co) ? l : sn(e, {
      startingIndex: u - u % i - 1,
      disabledIndices: a
    }), o && (f = o(t, u, f))) : f = u);
  }
  return f;
}
function $0(e, t, n) {
  const r = [];
  let o = 0;
  return e.forEach(({
    width: s,
    height: i
  }, a) => {
    if (s > t && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${a} is greater than grid columns`);
    let c = !1;
    for (n && (o = 0); !c; ) {
      const l = [];
      for (let u = 0; u < s; u += 1)
        for (let d = 0; d < i; d += 1)
          l.push(o + u + d * t);
      o % t + s <= t && l.every((u) => r[u] == null) ? (l.forEach((u) => {
        r[u] = a;
      }), c = !0) : o += 1;
    }
  }), [...r];
}
function F0(e, t, n, r, o) {
  if (e === -1)
    return -1;
  const s = n.indexOf(e), i = t[e];
  switch (o) {
    case "tl":
      return s;
    case "tr":
      return i ? s + i.width - 1 : s;
    case "bl":
      return i ? s + (i.height - 1) * r : s;
    case "br":
      return n.lastIndexOf(e);
    default:
      return -1;
  }
}
function L0(e, t) {
  return t.flatMap((n, r) => e.includes(n) ? [r] : []);
}
function Fr(e, t, n) {
  if (typeof n == "function" ? n(t) : (n == null ? void 0 : n.includes(t)) ?? !1)
    return !0;
  const o = e[t];
  return o ? kl(o) ? !n && (o.hasAttribute("disabled") || o.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function DO(e) {
  return e.visibility === "hidden" || e.visibility === "collapse";
}
function kl(e, t = e ? Cn(e) : null) {
  return !e || !e.isConnected || !t || DO(t) ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : t.display !== "none" && t.display !== "contents";
}
const NO = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function AO(e) {
  const t = e.assignedSlot;
  if (t)
    return t;
  if (e.parentElement)
    return e.parentElement;
  const n = e.getRootNode();
  return ws(n) ? n.host : null;
}
function Wd(e) {
  for (const t of Array.from(e.children))
    if (un(t) === "summary")
      return t;
  return null;
}
function $O(e, t) {
  const n = Wd(t);
  return !!n && (e === n || Re(n, e));
}
function V0(e) {
  const t = e ? un(e) : "";
  return e != null && e.matches(NO) && (t !== "summary" || e.parentElement != null && un(e.parentElement) === "details" && Wd(e.parentElement) === e) && (t !== "details" || Wd(e) == null) && (t !== "input" || e.type !== "hidden");
}
function W0(e) {
  if (!V0(e) || !e.isConnected || e.matches(":disabled"))
    return !1;
  for (let t = e; t; t = AO(t)) {
    const n = t !== e, r = un(t) === "slot";
    if (t.hasAttribute("inert") || n && un(t) === "details" && !t.open && !$O(e, t) || t.hasAttribute("hidden") || !r && !FO(t, n))
      return !1;
  }
  return !0;
}
function FO(e, t) {
  const n = Cn(e);
  return t ? n.display !== "none" : kl(e, n);
}
function B0(e) {
  const t = e.tabIndex;
  if (t < 0) {
    const n = un(e);
    if (n === "details" || n === "audio" || n === "video" || vt(e) && e.isContentEditable)
      return 0;
  }
  return t;
}
function Ou(e) {
  if (un(e) !== "input")
    return null;
  const t = e;
  return t.type === "radio" && t.name !== "" ? t : null;
}
function LO(e, t) {
  const n = Ou(e);
  if (!n)
    return !0;
  const r = t.find((o) => {
    const s = Ou(o);
    return (s == null ? void 0 : s.name) === n.name && s.form === n.form && s.checked;
  });
  return r ? r === n : t.find((o) => {
    const s = Ou(o);
    return (s == null ? void 0 : s.name) === n.name && s.form === n.form;
  }) === n;
}
function H0(e) {
  if (vt(e) && un(e) === "slot") {
    const t = e.assignedElements({
      flatten: !0
    });
    if (t.length > 0)
      return t;
  }
  return vt(e) && e.shadowRoot ? Array.from(e.shadowRoot.children) : Array.from(e.children);
}
function Y0(e, t) {
  H0(e).forEach((n) => {
    V0(n) && t.push(n), Y0(n, t);
  });
}
function z0(e, t, n) {
  H0(e).forEach((r) => {
    vt(r) && r.matches(t) && n.push(r), z0(r, t, n);
  });
}
function Hf(e) {
  return W0(e) && B0(e) >= 0;
}
function j0(e) {
  const t = [];
  return Y0(e, t), t.filter(W0);
}
function ea(e) {
  const t = j0(e);
  return t.filter((n) => B0(n) >= 0 && LO(n, t));
}
function U0(e, t) {
  const n = ea(e), r = n.length;
  if (r === 0)
    return;
  const o = Xt(Ye(e)), s = n.indexOf(o), i = s === -1 ? t === 1 ? 0 : r - 1 : s + t;
  return n[i];
}
function Yf(e) {
  return U0(Ye(e).body, 1) || e;
}
function G0(e) {
  return U0(Ye(e).body, -1) || e;
}
function K0(e, t) {
  if (!e)
    return null;
  const n = ea(Ye(e).body), r = n.length;
  if (r === 0)
    return null;
  const o = n.indexOf(e);
  if (o === -1)
    return null;
  const s = (o + t + r) % r;
  return n[s];
}
function VO(e) {
  return K0(e, 1);
}
function WO(e) {
  return K0(e, -1);
}
function ps(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Re(n, r);
}
function BO(e) {
  ea(e).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Cg(e) {
  const t = [];
  z0(e, "[data-tabindex]", t), t.forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function fo(e, t, n = !0) {
  return e.filter((o) => o.parentId === t).flatMap((o) => {
    var s;
    return [...!n || (s = o.context) != null && s.open ? [o] : [], ...fo(e, o.id, n)];
  });
}
function Eg(e, t) {
  var o;
  let n = [], r = (o = e.find((s) => s.id === t)) == null ? void 0 : o.parentId;
  for (; r; ) {
    const s = e.find((i) => i.id === r);
    r = s == null ? void 0 : s.parentId, s && (n = n.concat(s));
  }
  return n;
}
function Fi(e) {
  return `data-base-ui-${e}`;
}
let Oa = 0;
function uc(e, t = {}) {
  const {
    preventScroll: n = !1,
    sync: r = !1,
    shouldFocus: o
  } = t;
  cancelAnimationFrame(Oa);
  function s() {
    o && !o() || e == null || e.focus({
      preventScroll: n
    });
  }
  if (r)
    return s(), an;
  const i = requestAnimationFrame(s);
  return Oa = i, () => {
    Oa === i && (cancelAnimationFrame(i), Oa = 0);
  };
}
const Mu = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, _g = "data-base-ui-inert", Bd = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let Gs = /* @__PURE__ */ new WeakMap(), Tu = 0;
function HO(e) {
  return Bd[e];
}
function q0(e) {
  return e ? ws(e) ? e.host : q0(e.parentNode) : null;
}
const ku = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = q0(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null), Sg = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    let r = n;
    for (; r && !t.has(r); )
      t.add(r), r = r.parentNode;
  }), t;
}, Og = (e, t, n) => {
  const r = [], o = (s) => {
    !s || n.has(s) || Array.from(s.children).forEach((i) => {
      un(i) !== "script" && (t.has(i) ? o(i) : r.push(i));
    });
  };
  return o(e), r;
};
function YO(e, t, n, r, {
  mark: o = !0,
  markerIgnoreElements: s = []
}) {
  const i = r ? "inert" : n ? "aria-hidden" : null;
  let a = null, c = null;
  const l = ku(t, e), u = o ? ku(t, s) : [], d = new Set(u), f = o ? Og(t, Sg(l), new Set(l)).filter((g) => !d.has(g)) : [], h = [], p = [];
  if (i) {
    const g = Mu[i], m = HO(i);
    c = m, a = g;
    const y = ku(t, Array.from(t.querySelectorAll("[aria-live]"))), v = l.concat(y);
    Og(t, Sg(v), new Set(v)).forEach((C) => {
      const x = C.getAttribute(i), E = x !== null && x !== "false", S = (g.get(C) || 0) + 1;
      g.set(C, S), h.push(C), S === 1 && E && m.add(C), E || C.setAttribute(i, i === "inert" ? "" : "true");
    });
  }
  return o && f.forEach((g) => {
    const m = (Gs.get(g) || 0) + 1;
    Gs.set(g, m), p.push(g), m === 1 && g.setAttribute(_g, "");
  }), Tu += 1, () => {
    a && h.forEach((g) => {
      const y = (a.get(g) || 0) - 1;
      a.set(g, y), y || (!(c != null && c.has(g)) && i && g.removeAttribute(i), c == null || c.delete(g));
    }), o && p.forEach((g) => {
      const m = (Gs.get(g) || 0) - 1;
      Gs.set(g, m), m || g.removeAttribute(_g);
    }), Tu -= 1, Tu || (Mu.inert = /* @__PURE__ */ new WeakMap(), Mu["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Bd.inert = /* @__PURE__ */ new WeakSet(), Bd["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Gs = /* @__PURE__ */ new WeakMap());
  };
}
function Mg(e, t = {}) {
  const {
    ariaHidden: n = !1,
    inert: r = !1,
    mark: o = !0,
    markerIgnoreElements: s = []
  } = t, i = Ye(e[0]).body;
  return YO(e, i, n, r, {
    mark: o,
    markerIgnoreElements: s
  });
}
let Tg = 0;
function zO(e, t = "mui") {
  const [n, r] = b.useState(e), o = e || n;
  return b.useEffect(() => {
    n == null && (Tg += 1, r(`${t}-${Tg}`));
  }, [n, t]), o;
}
const kg = Wn.useId;
function Br(e, t) {
  if (kg !== void 0) {
    const n = kg();
    return e ?? (t ? `${t}-${n}` : n);
  }
  return zO(e, t);
}
const jO = 500, X0 = 500, UO = {
  style: {
    transition: "none"
  }
}, zf = "data-base-ui-click-trigger", GO = "data-base-ui-swipe-ignore", KO = "data-swipe-ignore", qO = `[${GO}]`, XO = `[${KO}]`, ZO = {
  fallbackAxisSide: "none"
}, jf = {
  fallbackAxisSide: "end"
}, QO = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, Uf = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (Uf.displayName = "PortalContext");
const Z0 = () => b.useContext(Uf), JO = Fi("portal");
function Q0(e = {}) {
  const {
    ref: t,
    container: n,
    componentProps: r = wt,
    elementProps: o
  } = e, s = Br(), i = Z0(), a = i == null ? void 0 : i.portalNode, [c, l] = b.useState(null), [u, d] = b.useState(null), f = Se((m) => {
    m !== null && d(m);
  }), h = b.useRef(null);
  be(() => {
    if (n === null) {
      h.current && (h.current = null, d(null), l(null));
      return;
    }
    if (s == null)
      return;
    const m = (n && (Nf(n) ? n : n.current)) ?? a ?? document.body;
    if (m == null) {
      h.current && (h.current = null, d(null), l(null));
      return;
    }
    h.current !== m && (h.current = m, d(null), l(m));
  }, [n, a, s]);
  const p = $e("div", r, {
    ref: [t, f],
    props: [{
      id: s,
      [JO]: ""
    }, o]
  });
  return {
    portalNode: u,
    portalSubtree: c && p ? /* @__PURE__ */ Yn.createPortal(p, c) : null
  };
}
const Pl = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    container: a,
    renderGuards: c,
    ...l
  } = t, {
    portalNode: u,
    portalSubtree: d
  } = Q0({
    container: a,
    ref: n,
    componentProps: t,
    elementProps: l
  }), f = b.useRef(null), h = b.useRef(null), p = b.useRef(null), g = b.useRef(null), [m, y] = b.useState(null), v = b.useRef(!1), w = m == null ? void 0 : m.modal, C = m == null ? void 0 : m.open, x = typeof c == "boolean" ? c : !!m && !m.modal && m.open && !!u;
  b.useEffect(() => {
    if (!u || w)
      return;
    function S(M) {
      u && M.relatedTarget && ps(M) && (M.type === "focusin" ? v.current && (Cg(u), v.current = !1) : (BO(u), v.current = !0));
    }
    return er(We(u, "focusin", S, !0), We(u, "focusout", S, !0));
  }, [u, w]), b.useEffect(() => {
    !u || C !== !1 || (Cg(u), v.current = !1);
  }, [C, u]);
  const E = b.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: h,
    beforeInsideRef: p,
    afterInsideRef: g,
    portalNode: u,
    setFocusManagerState: y
  }), [u]);
  return /* @__PURE__ */ Z(b.Fragment, {
    children: [d, /* @__PURE__ */ Z(Uf.Provider, {
      value: E,
      children: [x && u && /* @__PURE__ */ _(Hn, {
        "data-type": "outside",
        ref: f,
        onFocus: (S) => {
          var M;
          if (ps(S, u))
            (M = p.current) == null || M.focus();
          else {
            const T = m ? m.domReference : null, P = G0(T);
            P == null || P.focus();
          }
        }
      }), x && u && /* @__PURE__ */ _("span", {
        "aria-owns": u.id,
        style: QO
      }), u && /* @__PURE__ */ Yn.createPortal(i, u), x && u && /* @__PURE__ */ _(Hn, {
        "data-type": "outside",
        ref: h,
        onFocus: (S) => {
          var M;
          if (ps(S, u))
            (M = g.current) == null || M.focus();
          else {
            const T = m ? m.domReference : null, P = Yf(T);
            P == null || P.focus(), m != null && m.closeOnFocusOut && (m == null || m.onOpenChange(!1, Ve(Ho, S.nativeEvent)));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Pl.displayName = "FloatingPortal");
function J0() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
class Gf {
  constructor() {
    ae(this, "nodesRef", {
      current: []
    });
    ae(this, "events", J0());
  }
  addNode(t) {
    this.nodesRef.current.push(t);
  }
  removeNode(t) {
    const n = this.nodesRef.current.findIndex((r) => r === t);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const Kf = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (Kf.displayName = "FloatingNodeContext");
const qf = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && (qf.displayName = "FloatingTreeContext");
const Kr = () => {
  var e;
  return ((e = b.useContext(Kf)) == null ? void 0 : e.id) || null;
}, vo = (e) => {
  const t = b.useContext(qf);
  return e ?? t;
};
function Xf(e) {
  const t = Br(), n = vo(e), r = Kr();
  return be(() => {
    if (!t)
      return;
    const o = {
      id: t,
      parentId: r
    };
    return n == null || n.addNode(o), () => {
      n == null || n.removeNode(o);
    };
  }, [n, t, r]), t;
}
function ey(e) {
  const {
    children: t,
    id: n
  } = e, r = Kr();
  return /* @__PURE__ */ _(Kf.Provider, {
    value: b.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r]),
    children: t
  });
}
function ty(e) {
  const {
    children: t,
    externalTree: n
  } = e, r = gn(() => n ?? new Gf()).current;
  return /* @__PURE__ */ _(qf.Provider, {
    value: r,
    children: t
  });
}
function Tr(e) {
  return e == null ? e : "current" in e ? e.current : e;
}
function eM(e, t) {
  const n = Ot(Dt(e));
  return e instanceof n.KeyboardEvent ? "keyboard" : e instanceof n.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof n.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
const Pg = 20;
let oo = [];
function Zf() {
  oo = oo.filter((e) => {
    var t;
    return (t = e.deref()) == null ? void 0 : t.isConnected;
  });
}
function tM(e) {
  Zf(), e && un(e) !== "body" && (oo.push(new WeakRef(e)), oo.length > Pg && (oo = oo.slice(-Pg)));
}
function Pu() {
  var e;
  return Zf(), (e = oo[oo.length - 1]) == null ? void 0 : e.deref();
}
function nM(e) {
  return e ? Hf(e) ? e : ea(e)[0] || e : null;
}
function Rg(e, t) {
  var s;
  if (e.hasAttribute("tabindex") && !e.hasAttribute("data-tabindex") || !t.current.includes("floating") && !((s = e.getAttribute("role")) != null && s.includes("dialog")))
    return;
  const r = j0(e).filter((i) => {
    const a = i.getAttribute("data-tabindex") || "";
    return Hf(i) || i.hasAttribute("data-tabindex") && !a.startsWith("-");
  }), o = e.getAttribute("tabindex");
  t.current.includes("floating") || r.length === 0 ? o !== "0" && e.setAttribute("tabindex", "0") : (o !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function Qf(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    initialFocus: o = !0,
    returnFocus: s = !0,
    restoreFocus: i = !1,
    modal: a = !0,
    closeOnFocusOut: c = !0,
    openInteractionType: l = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: h,
    getInsideElements: p
  } = e, g = "rootStore" in t ? t.rootStore : t, m = g.useState("open"), y = g.useState("domReferenceElement"), v = g.useState("floatingElement"), {
    events: w,
    dataRef: C
  } = g.context, x = Se(() => {
    var Y;
    return (Y = C.current.floatingContext) == null ? void 0 : Y.nodeId;
  }), E = o === !1, S = Nd(y) && E, M = b.useRef(["content"]), T = Yt(o), P = Yt(s), k = Yt(l), I = vo(h), O = Z0(), A = b.useRef(!1), R = b.useRef(!1), N = b.useRef(!1), $ = b.useRef(null), F = b.useRef(""), V = b.useRef(""), D = b.useRef(null), H = b.useRef(null), j = Vr(D, f, O == null ? void 0 : O.beforeInsideRef), U = Vr(H, O == null ? void 0 : O.afterInsideRef), K = ln(), G = ln(), B = Ai(), z = O != null, W = Ad(v), X = Se((Y = W) => Y ? ea(Y) : []), J = Se(() => (p == null ? void 0 : p().filter((Y) => Y != null)) ?? []);
  b.useEffect(() => {
    if (r || !a)
      return;
    function Y(ee) {
      ee.key === "Tab" && Re(W, Xt(Ye(W))) && X().length === 0 && !S && kn(ee);
    }
    const ce = Ye(W);
    return We(ce, "keydown", Y);
  }, [r, W, a, S, X]), b.useEffect(() => {
    if (r || !m)
      return;
    const Y = Ye(W);
    function ce() {
      N.current = !1;
    }
    function ee(de) {
      const pe = Dt(de), Ee = J(), se = Re(v, pe) || Re(y, pe) || Re(O == null ? void 0 : O.portalNode, pe) || Ee.some((ke) => ke === pe || Re(ke, pe));
      N.current = !se, V.current = de.pointerType || "keyboard", pe != null && pe.closest(`[${zf}]`) && (R.current = !0);
    }
    function ne() {
      V.current = "keyboard";
    }
    return er(We(Y, "pointerdown", ee, !0), We(Y, "pointerup", ce, !0), We(Y, "pointercancel", ce, !0), We(Y, "keydown", ne, !0));
  }, [r, v, y, W, m, O, J]), b.useEffect(() => {
    if (r || !c)
      return;
    const Y = Ye(W);
    function ce() {
      R.current = !0, G.start(0, () => {
        R.current = !1;
      });
    }
    function ee(Ee) {
      const se = Dt(Ee);
      Hf(se) && ($.current = se);
    }
    function ne(Ee) {
      const se = Ee.relatedTarget, ke = Ee.currentTarget, we = Dt(Ee);
      queueMicrotask(() => {
        const Oe = x(), Ie = g.context.triggerElements, fe = J(), q = (se == null ? void 0 : se.hasAttribute(Fi("focus-guard"))) && [D.current, H.current, O == null ? void 0 : O.beforeInsideRef.current, O == null ? void 0 : O.afterInsideRef.current, O == null ? void 0 : O.beforeOutsideRef.current, O == null ? void 0 : O.afterOutsideRef.current, Tr(d), Tr(u)].includes(se), te = !(Re(y, se) || Re(v, se) || Re(se, v) || Re(O == null ? void 0 : O.portalNode, se) || fe.some((oe) => oe === se || Re(oe, se)) || se != null && Ie.hasElement(se) || Ie.hasMatchingElement((oe) => Re(oe, se)) || q || I && (fo(I.nodesRef.current, Oe).find((oe) => {
          var re, ve;
          return Re((re = oe.context) == null ? void 0 : re.elements.floating, se) || Re((ve = oe.context) == null ? void 0 : ve.elements.domReference, se);
        }) || Eg(I.nodesRef.current, Oe).find((oe) => {
          var re, ve, xe;
          return [(re = oe.context) == null ? void 0 : re.elements.floating, Ad((ve = oe.context) == null ? void 0 : ve.elements.floating)].includes(se) || ((xe = oe.context) == null ? void 0 : xe.elements.domReference) === se;
        })));
        if (ke === y && W && Rg(W, M), i && ke !== y && !kl(we) && Xt(Y) === Y.body) {
          if (vt(W) && (W.focus(), i === "popup")) {
            B.request(() => {
              W.focus();
            });
            return;
          }
          const oe = X(), re = $.current, ve = (re && oe.includes(re) ? re : null) || oe[oe.length - 1] || W;
          vt(ve) && ve.focus();
        }
        if (C.current.insideReactTree) {
          C.current.insideReactTree = !1;
          return;
        }
        (S || !a) && se && te && !R.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (S || se !== Pu()) && (A.current = !0, g.setOpen(!1, Ve(Ho, Ee)));
      });
    }
    function de() {
      N.current || (C.current.insideReactTree = !0, K.start(0, () => {
        C.current.insideReactTree = !1;
      }));
    }
    const pe = vt(y) ? y : null;
    if (!(!v && !pe))
      return er(pe && We(pe, "focusout", ne), pe && We(pe, "pointerdown", ce), v && We(v, "focusin", ee), v && We(v, "focusout", ne), v && O && We(v, "focusout", de, !0));
  }, [r, y, v, W, a, I, O, g, c, i, X, S, x, M, C, K, G, B, u, d, J]), b.useEffect(() => {
    var ke, we, Oe;
    if (r || !v || !m)
      return;
    const Y = Array.from(((ke = O == null ? void 0 : O.portalNode) == null ? void 0 : ke.querySelectorAll(`[${Fi("portal")}]`)) || []), ee = (Oe = (we = (I ? Eg(I.nodesRef.current, x()) : []).find((Ie) => {
      var fe;
      return Nd(((fe = Ie.context) == null ? void 0 : fe.elements.domReference) || null);
    })) == null ? void 0 : we.context) == null ? void 0 : Oe.elements.domReference, de = [...[v, ...Y, D.current, H.current, O == null ? void 0 : O.beforeOutsideRef.current, O == null ? void 0 : O.afterOutsideRef.current, ...J()], ee, Tr(d), Tr(u), S ? y : null].filter((Ie) => Ie != null), pe = Mg(de, {
      ariaHidden: a || S,
      mark: !1
    }), Ee = [v, ...Y].filter((Ie) => Ie != null), se = Mg(Ee);
    return () => {
      se(), pe();
    };
  }, [m, r, y, v, a, O, S, I, x, u, d, J]), be(() => {
    if (!m || r || !vt(W))
      return;
    const Y = Ye(W), ce = Xt(Y);
    queueMicrotask(() => {
      const ee = T.current, ne = typeof ee == "function" ? ee(k.current || "") : ee;
      if (ne === void 0 || ne === !1 || Re(W, ce))
        return;
      let pe = null;
      const Ee = () => (pe == null && (pe = X(W)), pe[0] || W);
      let se;
      ne === !0 || ne === null ? se = Ee() : se = Tr(ne), se = se || Ee();
      const ke = Re(W, Xt(Y));
      uc(se, {
        preventScroll: se === W,
        shouldFocus() {
          if (ke)
            return !0;
          const we = Xt(Y);
          return !(we !== se && Re(W, we));
        }
      });
    });
  }, [r, m, W, X, T, k]), be(() => {
    if (r || !W)
      return;
    const Y = Ye(W), ce = Xt(Y);
    tM(ce);
    function ee(de) {
      if (de.open || (F.current = eM(de.nativeEvent, V.current)), de.reason === Pt && de.nativeEvent.type === "mouseleave" && (A.current = !0), de.reason === Ff)
        if (de.nested)
          A.current = !1;
        else if (O0(de.nativeEvent) || M0(de.nativeEvent))
          A.current = !1;
        else {
          let pe = !1;
          Ye(W).createElement("div").focus({
            get preventScroll() {
              return pe = !0, !1;
            }
          }), pe ? A.current = !1 : A.current = !0;
        }
    }
    w.on("openchange", ee);
    function ne() {
      const de = P.current;
      let pe = typeof de == "function" ? de(F.current) : de;
      if (pe === void 0 || pe === !1)
        return null;
      if (pe === null && (pe = !0), typeof pe == "boolean")
        return y != null && y.isConnected ? y : Pu() || null;
      const Ee = y != null && y.isConnected ? y : Pu();
      return Tr(pe) || Ee || null;
    }
    return () => {
      w.off("openchange", ee);
      const de = Xt(Y), pe = J(), Ee = Re(v, de) || pe.some((we) => we === de || Re(we, de)) || I && fo(I.nodesRef.current, x(), !1).some((we) => {
        var Oe;
        return Re((Oe = we.context) == null ? void 0 : Oe.elements.floating, de);
      }), se = P.current, ke = ne();
      queueMicrotask(() => {
        const we = nM(ke), Oe = typeof se != "boolean";
        se && !A.current && vt(we) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!Oe && we !== de && de !== Y.body) || Ee) && we.focus({
          preventScroll: !0
        }), A.current = !1;
      });
    };
  }, [r, v, W, P, w, I, y, x, J]), be(() => {
    if (!x0 || m || !v)
      return;
    const Y = Xt(Ye(v));
    !vt(Y) || !Sl(Y) || Re(v, Y) && Y.blur();
  }, [m, v]), be(() => {
    if (!(r || !O))
      return O.setFocusManagerState({
        modal: a,
        closeOnFocusOut: c,
        open: m,
        onOpenChange: g.setOpen,
        domReference: y
      }), () => {
        O.setFocusManagerState(null);
      };
  }, [r, O, a, m, g, c, y]), be(() => {
    if (!(r || !W))
      return Rg(W, M), () => {
        queueMicrotask(Zf);
      };
  }, [r, W, M]);
  const Q = !r && (a ? !S : !0) && (z || a);
  return /* @__PURE__ */ Z(b.Fragment, {
    children: [Q && /* @__PURE__ */ _(Hn, {
      "data-type": "inside",
      ref: j,
      onFocus: (Y) => {
        var ce;
        if (a) {
          const ee = X();
          uc(ee[ee.length - 1]);
        } else if (O != null && O.portalNode)
          if (A.current = !1, ps(Y, O.portalNode)) {
            const ee = Yf(y);
            ee == null || ee.focus();
          } else
            (ce = Tr(d ?? O.beforeOutsideRef)) == null || ce.focus();
      }
    }), n, Q && /* @__PURE__ */ _(Hn, {
      "data-type": "inside",
      ref: U,
      onFocus: (Y) => {
        var ce;
        if (a)
          uc(X()[0]);
        else if (O != null && O.portalNode)
          if (c && (A.current = !0), ps(Y, O.portalNode)) {
            const ee = G0(y);
            ee == null || ee.focus();
          } else
            (ce = Tr(u ?? O.afterOutsideRef)) == null || ce.focus();
      }
    })]
  });
}
function Rl(e, t = {}) {
  const {
    enabled: n = !0,
    event: r = "click",
    toggle: o = !0,
    ignoreMouse: s = !1,
    stickIfOpen: i = !0,
    touchOpenDelay: a = 0,
    reason: c = br
  } = t, l = "rootStore" in e ? e.rootStore : e, u = l.context.dataRef, d = b.useRef(void 0), f = Ai(), h = ln(), p = b.useMemo(() => {
    function g(y, v, w, C) {
      const x = Ve(c, v, w);
      y && C === "touch" && a > 0 ? h.start(a, () => {
        l.setOpen(!0, x);
      }) : l.setOpen(y, x);
    }
    function m(y, v, w) {
      const C = u.current.openEvent, x = l.select("domReferenceElement") !== v;
      return y && x || !y || !o ? !0 : C && i ? !w(C.type) : !1;
    }
    return {
      onPointerDown(y) {
        d.current = y.pointerType;
      },
      onMouseDown(y) {
        const v = d.current, w = y.nativeEvent, C = l.select("open");
        if (y.button !== 0 || r === "click" || Bo(v, !0) && s)
          return;
        const x = m(C, y.currentTarget, (M) => M === "click" || M === "mousedown"), E = Dt(w);
        if (Sl(E)) {
          g(x, w, E, v);
          return;
        }
        const S = y.currentTarget;
        f.request(() => {
          g(x, w, S, v);
        });
      },
      onClick(y) {
        if (r === "mousedown-only")
          return;
        const v = d.current;
        if (r === "mousedown" && v) {
          d.current = void 0;
          return;
        }
        if (Bo(v, !0) && s)
          return;
        const w = l.select("open"), C = m(w, y.currentTarget, (x) => x === "click" || x === "mousedown" || x === "keydown" || x === "keyup");
        g(C, y.nativeEvent, y.currentTarget, v);
      },
      onKeyDown() {
        d.current = void 0;
      }
    };
  }, [u, r, s, c, l, i, o, f, h, a]);
  return b.useMemo(() => n ? {
    reference: p
  } : wt, [n, p]);
}
function rM(e, t) {
  let n = null, r = null, o = !1;
  return {
    contextElement: e || void 0,
    getBoundingClientRect() {
      var h;
      const s = (e == null ? void 0 : e.getBoundingClientRect()) || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, i = t.axis === "x" || t.axis === "both", a = t.axis === "y" || t.axis === "both", c = ["mouseenter", "mousemove"].includes(((h = t.dataRef.current.openEvent) == null ? void 0 : h.type) || "") && t.pointerType !== "touch";
      let l = s.width, u = s.height, d = s.x, f = s.y;
      return n == null && t.x && i && (n = s.x - t.x), r == null && t.y && a && (r = s.y - t.y), d -= n || 0, f -= r || 0, l = 0, u = 0, !o || c ? (l = t.axis === "y" ? s.width : 0, u = t.axis === "x" ? s.height : 0, d = i && t.x != null ? t.x : d, f = a && t.y != null ? t.y : f) : o && !c && (u = t.axis === "x" ? s.height : u, l = t.axis === "y" ? s.width : l), o = !0, {
        width: l,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + l,
        bottom: f + u,
        left: d
      };
    }
  };
}
function Ig(e) {
  return e != null && e.clientX != null;
}
function oM(e, t = {}) {
  const {
    enabled: n = !0,
    axis: r = "both"
  } = t, o = "rootStore" in e ? e.rootStore : e, s = o.useState("open"), i = o.useState("floatingElement"), a = o.useState("domReferenceElement"), c = o.context.dataRef, l = b.useRef(!1), u = b.useRef(null), [d, f] = b.useState(), [h, p] = b.useState([]), g = Se((C) => {
    o.set("positionReference", C);
  }), m = Se((C, x, E) => {
    l.current || c.current.openEvent && !Ig(c.current.openEvent) || o.set("positionReference", rM(E ?? a, {
      x: C,
      y: x,
      axis: r,
      dataRef: c,
      pointerType: d
    }));
  }), y = Se((C) => {
    s ? u.current || (m(C.clientX, C.clientY, C.currentTarget), p([])) : m(C.clientX, C.clientY, C.currentTarget);
  }), v = Bo(d) ? i : s;
  b.useEffect(() => {
    if (!n) {
      g(a);
      return;
    }
    if (!v)
      return;
    function C() {
      var S;
      (S = u.current) == null || S.call(u), u.current = null;
    }
    const x = Ot(i);
    function E(S) {
      const M = Dt(S);
      Re(i, M) ? C() : m(S.clientX, S.clientY);
    }
    return !c.current.openEvent || Ig(c.current.openEvent) ? u.current = We(x, "mousemove", E) : g(a), C;
  }, [v, n, i, c, a, o, m, g, h]), b.useEffect(() => () => {
    o.set("positionReference", null);
  }, [o]), b.useEffect(() => {
    n && !i && (l.current = !1);
  }, [n, i]), b.useEffect(() => {
    !n && s && (l.current = !0);
  }, [n, s]);
  const w = b.useMemo(() => {
    function C(x) {
      f(x.pointerType);
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove: y,
      onMouseEnter: y
    };
  }, [y]);
  return b.useMemo(() => n ? {
    reference: w,
    trigger: w
  } : {}, [n, w]);
}
const sM = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function iM() {
  return !1;
}
function aM(e) {
  return {
    escapeKey: typeof e == "boolean" ? e : (e == null ? void 0 : e.escapeKey) ?? !1,
    outsidePress: typeof e == "boolean" ? e : (e == null ? void 0 : e.outsidePress) ?? !0
  };
}
function Il(e, t = {}) {
  const {
    enabled: n = !0,
    escapeKey: r = !0,
    outsidePress: o = !0,
    outsidePressEvent: s = "sloppy",
    referencePress: i = iM,
    referencePressEvent: a = "sloppy",
    bubbles: c,
    externalTree: l
  } = t, u = "rootStore" in e ? e.rootStore : e, d = u.useState("open"), f = u.useState("floatingElement"), {
    dataRef: h
  } = u.context, p = vo(l), g = Se(typeof o == "function" ? o : () => !1), m = typeof o == "function" ? g : o, y = m !== !1, v = Se(() => s), {
    escapeKey: w,
    outsidePress: C
  } = aM(c), x = b.useRef(!1), E = b.useRef(!1), S = b.useRef(!1), M = b.useRef(!1), T = b.useRef(""), P = b.useRef(null), k = ln(), I = ln(), O = Se(() => {
    I.clear(), h.current.insideReactTree = !1;
  }), A = Se((U) => {
    var B;
    const K = (B = h.current.floatingContext) == null ? void 0 : B.nodeId;
    return (p ? fo(p.nodesRef.current, K) : []).some((z) => {
      var W;
      return ((W = z.context) == null ? void 0 : W.open) && !z.context.dataRef.current[U];
    });
  }), R = Se((U) => _u(U, u.select("floatingElement")) || _u(U, u.select("domReferenceElement"))), N = Se((U) => {
    i() && u.setOpen(!1, Ve(br, U.nativeEvent));
  }), $ = Se((U) => {
    if (!d || !n || !r || U.key !== "Escape" || M.current || !w && A("__escapeKeyBubbles"))
      return;
    const K = sO(U) ? U.nativeEvent : U, G = Ve(Ji, K);
    u.setOpen(!1, G), G.isCanceled || U.preventDefault(), !w && !G.isPropagationAllowed && U.stopPropagation();
  }), F = Se(() => {
    h.current.insideReactTree = !0, I.start(0, O);
  }), V = Se((U) => {
    if (!d || !n || U.button !== 0)
      return;
    const K = Dt(U.nativeEvent);
    Re(u.select("floatingElement"), K) && (x.current || (x.current = !0, E.current = !1));
  }), D = Se((U) => {
    !d || !n || (U.defaultPrevented || U.nativeEvent.defaultPrevented) && x.current && (E.current = !0);
  });
  b.useEffect(() => {
    if (!d || !n)
      return;
    h.current.__escapeKeyBubbles = w, h.current.__outsidePressBubbles = C;
    const U = new xn(), K = new xn();
    function G() {
      U.clear(), M.current = !0;
    }
    function B() {
      U.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        El() ? 5 : 0,
        () => {
          M.current = !1;
        }
      );
    }
    function z() {
      S.current = !0, K.start(0, () => {
        S.current = !1;
      });
    }
    function W() {
      x.current = !1, E.current = !1;
    }
    function X() {
      const q = T.current, te = q === "pen" || !q ? "mouse" : q, oe = v(), re = typeof oe == "function" ? oe() : oe;
      return typeof re == "string" ? re : re[te];
    }
    function J(q) {
      const te = X();
      return te === "intentional" && q.type !== "click" || te === "sloppy" && q.type === "click";
    }
    function Q(q) {
      var re;
      const te = (re = h.current.floatingContext) == null ? void 0 : re.nodeId, oe = p && fo(p.nodesRef.current, te).some((ve) => {
        var xe;
        return _u(q, (xe = ve.context) == null ? void 0 : xe.elements.floating);
      });
      return R(q) || oe;
    }
    function Y(q) {
      if (J(q)) {
        q.type !== "click" && !R(q) && (K.clear(), S.current = !1), O();
        return;
      }
      if (h.current.insideReactTree) {
        O();
        return;
      }
      const te = Dt(q), oe = `[${Fi("inert")}]`, re = Ge(te) ? te.getRootNode() : null, ve = Array.from((ws(re) ? re : Ye(u.select("floatingElement"))).querySelectorAll(oe)), xe = u.context.triggerElements;
      if (te && (xe.hasElement(te) || xe.hasMatchingElement((qe) => Re(qe, te))))
        return;
      let Me = Ge(te) ? te : null;
      for (; Me && !hr(Me); ) {
        const qe = mr(Me);
        if (hr(qe) || !Ge(qe))
          break;
        Me = qe;
      }
      if (!(ve.length && Ge(te) && !dO(te) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !Re(te, u.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      ve.every((qe) => !Re(Me, qe)))) {
        if (vt(te) && !("touches" in q)) {
          const qe = hr(te), Ze = Cn(te), nt = /auto|scroll/, Kt = qe || nt.test(Ze.overflowX), dn = qe || nt.test(Ze.overflowY), rn = Kt && te.clientWidth > 0 && te.scrollWidth > te.clientWidth, _n = dn && te.clientHeight > 0 && te.scrollHeight > te.clientHeight, fn = Ze.direction === "rtl", $n = _n && (fn ? q.offsetX <= te.offsetWidth - te.clientWidth : q.offsetX > te.clientWidth), me = rn && q.offsetY > te.clientHeight;
          if ($n || me)
            return;
        }
        if (!Q(q)) {
          if (X() === "intentional" && S.current) {
            K.clear(), S.current = !1;
            return;
          }
          typeof m == "function" && !m(q) || A("__outsidePressBubbles") || (u.setOpen(!1, Ve(Ff, q)), O());
        }
      }
    }
    function ce(q) {
      X() !== "sloppy" || q.pointerType === "touch" || !u.select("open") || !n || R(q) || Y(q);
    }
    function ee(q) {
      if (X() !== "sloppy" || !u.select("open") || !n || R(q))
        return;
      const te = q.touches[0];
      te && (P.current = {
        startTime: Date.now(),
        startX: te.clientX,
        startY: te.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, k.start(1e3, () => {
        P.current && (P.current.dismissOnTouchEnd = !1, P.current.dismissOnMouseDown = !1);
      }));
    }
    function ne(q, te) {
      const oe = Dt(q);
      if (!oe)
        return;
      const re = We(oe, q.type, () => {
        te(q), re();
      });
    }
    function de(q) {
      T.current = "touch", ne(q, ee);
    }
    function pe(q) {
      k.clear(), q.type === "pointerdown" && (T.current = q.pointerType), !(q.type === "mousedown" && P.current && !P.current.dismissOnMouseDown) && ne(q, (te) => {
        te.type === "pointerdown" ? ce(te) : Y(te);
      });
    }
    function Ee(q) {
      if (!x.current)
        return;
      const te = E.current;
      if (W(), X() === "intentional") {
        if (q.type === "pointercancel") {
          te && z();
          return;
        }
        if (!Q(q)) {
          if (te) {
            z();
            return;
          }
          typeof m == "function" && !m(q) || (K.clear(), S.current = !0, O());
        }
      }
    }
    function se(q) {
      if (X() !== "sloppy" || !P.current || R(q))
        return;
      const te = q.touches[0];
      if (!te)
        return;
      const oe = Math.abs(te.clientX - P.current.startX), re = Math.abs(te.clientY - P.current.startY), ve = Math.sqrt(oe * oe + re * re);
      ve > 5 && (P.current.dismissOnTouchEnd = !0), ve > 10 && (Y(q), k.clear(), P.current = null);
    }
    function ke(q) {
      ne(q, se);
    }
    function we(q) {
      X() !== "sloppy" || !P.current || R(q) || (P.current.dismissOnTouchEnd && Y(q), k.clear(), P.current = null);
    }
    function Oe(q) {
      ne(q, we);
    }
    const Ie = Ye(f), fe = er(r && er(We(Ie, "keydown", $), We(Ie, "compositionstart", G), We(Ie, "compositionend", B)), y && er(We(Ie, "click", pe, !0), We(Ie, "pointerdown", pe, !0), We(Ie, "pointerup", Ee, !0), We(Ie, "pointercancel", Ee, !0), We(Ie, "mousedown", pe, !0), We(Ie, "mouseup", Ee, !0), We(Ie, "touchstart", de, !0), We(Ie, "touchmove", ke, !0), We(Ie, "touchend", Oe, !0)));
    return () => {
      fe(), U.clear(), K.clear(), W(), S.current = !1;
    };
  }, [h, f, r, y, m, d, n, w, C, $, O, v, A, R, p, u, k]), b.useEffect(O, [m, O]);
  const H = b.useMemo(() => ({
    onKeyDown: $,
    [sM[a]]: N,
    ...a !== "intentional" && {
      onClick: N
    }
  }), [$, N, a]), j = b.useMemo(() => ({
    onKeyDown: $,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: D,
    onMouseDown: D,
    onClickCapture: F,
    onMouseDownCapture(U) {
      F(), V(U);
    },
    onPointerDownCapture(U) {
      F(), V(U);
    },
    onMouseUpCapture: F,
    onTouchEndCapture: F,
    onTouchMoveCapture: F
  }), [$, F, V, D]);
  return b.useMemo(() => n ? {
    reference: H,
    floating: j,
    trigger: H
  } : {}, [n, H, j]);
}
function Dg(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = Bn(t), i = Bf(t), a = Wf(i), c = wn(t), l = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (bo(t)) {
    case "start":
      h[i] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && l ? -1 : 1);
      break;
  }
  return h;
}
async function cM(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: a,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Wr(t, e), p = N0(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], y = Nc(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), v = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), C = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Nc(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: v,
    offsetParent: w,
    strategy: c
  }) : v);
  return {
    top: (y.top - x.top + p.top) / C.y,
    bottom: (x.bottom - y.bottom + p.bottom) / C.y,
    left: (y.left - x.left + p.left) / C.x,
    right: (x.right - y.right + p.right) / C.x
  };
}
const lM = 50, uM = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = i.detectOverflow ? i : {
    ...i,
    detectOverflow: cM
  }, c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Dg(l, r, c), f = r, h = 0;
  const p = {};
  for (let g = 0; g < s.length; g++) {
    const m = s[g];
    if (!m)
      continue;
    const {
      name: y,
      fn: v
    } = m, {
      x: w,
      y: C,
      data: x,
      reset: E
    } = await v({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, d = C ?? d, p[y] = {
      ...p[y],
      ...x
    }, E && h < lM && (h++, typeof E == "object" && (E.placement && (f = E.placement), E.rects && (l = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: u,
      y: d
    } = Dg(l, f, c)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
}, dM = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...m
      } = Wr(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const y = wn(o), v = Bn(a), w = wn(a) === a, C = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), x = f || (w || !g ? [Dc(a)] : MO(a)), E = p !== "none";
      !f && E && x.push(...RO(a, g, p, C));
      const S = [a, ...x], M = await c.detectOverflow(t, m), T = [];
      let P = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && T.push(M[y]), d) {
        const A = OO(o, i, C);
        T.push(M[A[0]], M[A[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: T
      }], !T.every((A) => A <= 0)) {
        var k, I;
        const A = (((k = s.flip) == null ? void 0 : k.index) || 0) + 1, R = S[A];
        if (R && (!(d === "alignment" ? v !== Bn(R) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((F) => Bn(F.placement) === v ? F.overflows[0] > 0 : !0)))
          return {
            data: {
              index: A,
              overflows: P
            },
            reset: {
              placement: R
            }
          };
        let N = (I = P.filter(($) => $.overflows[0] <= 0).sort(($, F) => $.overflows[1] - F.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!N)
          switch (h) {
            case "bestFit": {
              var O;
              const $ = (O = P.filter((F) => {
                if (E) {
                  const V = Bn(F.placement);
                  return V === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((V) => V > 0).reduce((V, D) => V + D, 0)]).sort((F, V) => F[1] - V[1])[0]) == null ? void 0 : O[0];
              $ && (N = $);
              break;
            }
            case "initialPlacement":
              N = a;
              break;
          }
        if (o !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
function Ng(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ag(e) {
  return _O.some((t) => e[t] >= 0);
}
const fM = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...s
      } = Wr(e, t);
      switch (o) {
        case "referenceHidden": {
          const i = await r.detectOverflow(t, {
            ...s,
            elementContext: "reference"
          }), a = Ng(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Ag(a)
            }
          };
        }
        case "escaped": {
          const i = await r.detectOverflow(t, {
            ...s,
            altBoundary: !0
          }), a = Ng(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Ag(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ny = /* @__PURE__ */ new Set(["left", "top"]);
async function hM(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = wn(n), a = bo(n), c = Bn(n) === "y", l = ny.has(i) ? -1 : 1, u = s && c ? -1 : 1, d = Wr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), c ? {
    x: h * u,
    y: f * l
  } : {
    x: f * l,
    y: h * u
  };
}
const pM = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: i,
        middlewareData: a
      } = t, c = await hM(t, e);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: s + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, gM = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: s
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: c = {
          fn: (y) => {
            let {
              x: v,
              y: w
            } = y;
            return {
              x: v,
              y: w
            };
          }
        },
        ...l
      } = Wr(e, t), u = {
        x: n,
        y: r
      }, d = await s.detectOverflow(t, l), f = Bn(wn(o)), h = Vf(f);
      let p = u[h], g = u[f];
      if (i) {
        const y = h === "y" ? "top" : "left", v = h === "y" ? "bottom" : "right", w = p + d[y], C = p - d[v];
        p = Fd(w, p, C);
      }
      if (a) {
        const y = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", w = g + d[y], C = g - d[v];
        g = Fd(w, g, C);
      }
      const m = c.fn({
        ...t,
        [h]: p,
        [f]: g
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [h]: i,
            [f]: a
          }
        }
      };
    }
  };
}, mM = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: i
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Wr(e, t), u = {
        x: n,
        y: r
      }, d = Bn(o), f = Vf(d);
      let h = u[f], p = u[d];
      const g = Wr(a, t), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const w = f === "y" ? "height" : "width", C = s.reference[f] - s.floating[w] + m.mainAxis, x = s.reference[f] + s.reference[w] - m.mainAxis;
        h < C ? h = C : h > x && (h = x);
      }
      if (l) {
        var y, v;
        const w = f === "y" ? "width" : "height", C = ny.has(wn(o)), x = s.reference[d] - s.floating[w] + (C && ((y = i.offset) == null ? void 0 : y[d]) || 0) + (C ? 0 : m.crossAxis), E = s.reference[d] + s.reference[w] + (C ? 0 : ((v = i.offset) == null ? void 0 : v[d]) || 0) - (C ? m.crossAxis : 0);
        p < x ? p = x : p > E && (p = E);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, bM = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: s,
        platform: i,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...l
      } = Wr(e, t), u = await i.detectOverflow(t, l), d = wn(o), f = bo(o), h = Bn(o) === "y", {
        width: p,
        height: g
      } = s.floating;
      let m, y;
      d === "top" || d === "bottom" ? (m = d, y = f === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = d, m = f === "end" ? "top" : "bottom");
      const v = g - u.top - u.bottom, w = p - u.left - u.right, C = Cs(g - u[m], v), x = Cs(p - u[y], w), E = !t.middlewareData.shift;
      let S = C, M = x;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (M = w), (r = t.middlewareData.shift) != null && r.enabled.y && (S = v), E && !f) {
        const P = Rn(u.left, 0), k = Rn(u.right, 0), I = Rn(u.top, 0), O = Rn(u.bottom, 0);
        h ? M = p - 2 * (P !== 0 || k !== 0 ? P + k : Rn(u.left, u.right)) : S = g - 2 * (I !== 0 || O !== 0 ? I + O : Rn(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: M,
        availableHeight: S
      });
      const T = await i.getDimensions(a.floating);
      return p !== T.width || g !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ry(e) {
  const t = Cn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = vt(e), s = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, a = Ic(n) !== s || Ic(r) !== i;
  return a && (n = s, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function Jf(e) {
  return Ge(e) ? e : e.contextElement;
}
function gs(e) {
  const t = Jf(e);
  if (!vt(t))
    return pr(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = ry(t);
  let i = (s ? Ic(n.width) : n.width) / r, a = (s ? Ic(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const vM = /* @__PURE__ */ pr(0);
function oy(e) {
  const t = Ot(e);
  return !El() || !t.visualViewport ? vM : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function yM(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ot(e) ? !1 : t;
}
function Yo(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = Jf(e);
  let i = pr(1);
  t && (r ? Ge(r) && (i = gs(r)) : i = gs(e));
  const a = yM(s, n, r) ? oy(s) : pr(0);
  let c = (o.left + a.x) / i.x, l = (o.top + a.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s) {
    const f = Ot(s), h = r && Ge(r) ? Ot(r) : r;
    let p = f, g = Id(p);
    for (; g && r && h !== p; ) {
      const m = gs(g), y = g.getBoundingClientRect(), v = Cn(g), w = y.left + (g.clientLeft + parseFloat(v.paddingLeft)) * m.x, C = y.top + (g.clientTop + parseFloat(v.paddingTop)) * m.y;
      c *= m.x, l *= m.y, u *= m.x, d *= m.y, c += w, l += C, p = Ot(g), g = Id(p);
    }
  }
  return Nc({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function Dl(e, t) {
  const n = _l(e).scrollLeft;
  return t ? t.left + n : Yo(wr(e)).left + n;
}
function sy(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Dl(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function wM(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", i = wr(r), a = t ? Cl(t.floating) : !1;
  if (r === i || a && s)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = pr(1);
  const u = pr(0), d = vt(r);
  if ((d || !d && !s) && ((un(r) !== "body" || mo(i)) && (c = _l(r)), d)) {
    const h = Yo(r);
    l = gs(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const f = i && !d && !s ? sy(i, c) : pr(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
    y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
  };
}
function xM(e) {
  return Array.from(e.getClientRects());
}
function CM(e) {
  const t = wr(e), n = _l(e), r = e.ownerDocument.body, o = Rn(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = Rn(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + Dl(e);
  const a = -n.scrollTop;
  return Cn(r).direction === "rtl" && (i += Rn(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: i,
    y: a
  };
}
const $g = 25;
function EM(e, t) {
  const n = Ot(e), r = wr(e), o = n.visualViewport;
  let s = r.clientWidth, i = r.clientHeight, a = 0, c = 0;
  if (o) {
    s = o.width, i = o.height;
    const u = El();
    (!u || u && t === "fixed") && (a = o.offsetLeft, c = o.offsetTop);
  }
  const l = Dl(r);
  if (l <= 0) {
    const u = r.ownerDocument, d = u.body, f = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, p = Math.abs(r.clientWidth - d.clientWidth - h);
    p <= $g && (s -= p);
  } else
    l <= $g && (s += l);
  return {
    width: s,
    height: i,
    x: a,
    y: c
  };
}
function _M(e, t) {
  const n = Yo(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = vt(e) ? gs(e) : pr(1), i = e.clientWidth * s.x, a = e.clientHeight * s.y, c = o * s.x, l = r * s.y;
  return {
    width: i,
    height: a,
    x: c,
    y: l
  };
}
function Fg(e, t, n) {
  let r;
  if (t === "viewport")
    r = EM(e, n);
  else if (t === "document")
    r = CM(wr(e));
  else if (Ge(t))
    r = _M(t, n);
  else {
    const o = oy(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Nc(r);
}
function iy(e, t) {
  const n = mr(e);
  return n === t || !Ge(n) || hr(n) ? !1 : Cn(n).position === "fixed" || iy(n, t);
}
function SM(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ni(e, [], !1).filter((a) => Ge(a) && un(a) !== "body"), o = null;
  const s = Cn(e).position === "fixed";
  let i = s ? mr(e) : e;
  for (; Ge(i) && !hr(i); ) {
    const a = Cn(i), c = Af(i);
    !c && a.position === "fixed" && (o = null), (s ? !c && !o : !c && a.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || mo(i) && !c && iy(e, i)) ? r = r.filter((u) => u !== i) : o = a, i = mr(i);
  }
  return t.set(e, r), r;
}
function OM(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Cl(t) ? [] : SM(t, this._c) : [].concat(n), r], a = Fg(t, i[0], o);
  let c = a.top, l = a.right, u = a.bottom, d = a.left;
  for (let f = 1; f < i.length; f++) {
    const h = Fg(t, i[f], o);
    c = Rn(h.top, c), l = Cs(h.right, l), u = Cs(h.bottom, u), d = Rn(h.left, d);
  }
  return {
    width: l - d,
    height: u - c,
    x: d,
    y: c
  };
}
function MM(e) {
  const {
    width: t,
    height: n
  } = ry(e);
  return {
    width: t,
    height: n
  };
}
function TM(e, t, n) {
  const r = vt(t), o = wr(t), s = n === "fixed", i = Yo(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = pr(0);
  function l() {
    c.x = Dl(o);
  }
  if (r || !r && !s)
    if ((un(t) !== "body" || mo(o)) && (a = _l(t)), r) {
      const h = Yo(t, !0, s, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else
      o && l();
  s && !r && o && l();
  const u = o && !r && !s ? sy(o, a) : pr(0), d = i.left + a.scrollLeft - c.x - u.x, f = i.top + a.scrollTop - c.y - u.y;
  return {
    x: d,
    y: f,
    width: i.width,
    height: i.height
  };
}
function Ru(e) {
  return Cn(e).position === "static";
}
function Lg(e, t) {
  if (!vt(e) || Cn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return wr(e) === n && (n = n.ownerDocument.body), n;
}
function ay(e, t) {
  const n = Ot(e);
  if (Cl(e))
    return n;
  if (!vt(e)) {
    let o = mr(e);
    for (; o && !hr(o); ) {
      if (Ge(o) && !Ru(o))
        return o;
      o = mr(o);
    }
    return n;
  }
  let r = Lg(e, t);
  for (; r && aO(r) && Ru(r); )
    r = Lg(r, t);
  return r && hr(r) && Ru(r) && !Af(r) ? n : r || uO(e) || n;
}
const kM = async function(e) {
  const t = this.getOffsetParent || ay, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: TM(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function PM(e) {
  return Cn(e).direction === "rtl";
}
const RM = {
  convertOffsetParentRelativeRectToViewportRelativeRect: wM,
  getDocumentElement: wr,
  getClippingRect: OM,
  getOffsetParent: ay,
  getElementRects: kM,
  getClientRects: xM,
  getDimensions: MM,
  getScale: gs,
  isElement: Ge,
  isRTL: PM
};
function cy(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function IM(e, t) {
  let n = null, r;
  const o = wr(e);
  function s() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), s();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: h
    } = l;
    if (a || t(), !f || !h)
      return;
    const p = $o(d), g = $o(o.clientWidth - (u + f)), m = $o(o.clientHeight - (d + h)), y = $o(u), w = {
      rootMargin: -p + "px " + -g + "px " + -m + "px " + -y + "px",
      threshold: Rn(0, Cs(1, c)) || 1
    };
    let C = !0;
    function x(E) {
      const S = E[0].intersectionRatio;
      if (S !== c) {
        if (!C)
          return i();
        S ? i(!1, S) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !cy(l, e.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function Vg(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Jf(e), u = o || s ? [...l ? Ni(l) : [], ...t ? Ni(t) : []] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), s && y.addEventListener("resize", n);
  });
  const d = l && a ? IM(l, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === l && h && t && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), n();
  }), l && !c && h.observe(l), t && h.observe(t));
  let p, g = c ? Yo(e) : null;
  c && m();
  function m() {
    const y = Yo(e);
    g && !cy(g, y) && n(), g = y, p = requestAnimationFrame(m);
  }
  return n(), () => {
    var y;
    u.forEach((v) => {
      o && v.removeEventListener("scroll", n), s && v.removeEventListener("resize", n);
    }), d == null || d(), (y = h) == null || y.disconnect(), h = null, c && cancelAnimationFrame(p);
  };
}
const DM = pM, NM = gM, AM = dM, $M = bM, FM = fM, LM = mM, VM = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: RM,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return uM(e, t, {
    ...o,
    platform: s
  });
};
var WM = typeof document < "u", BM = function() {
}, dc = WM ? Rs : BM;
function Ac(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Ac(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !Ac(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ly(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Wg(e, t) {
  const n = ly(e);
  return Math.round(t * n) / n;
}
function Iu(e) {
  const t = b.useRef(e);
  return dc(() => {
    t.current = e;
  }), t;
}
function HM(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = b.useState(r);
  Ac(f, r) || h(r);
  const [p, g] = b.useState(null), [m, y] = b.useState(null), v = b.useCallback((F) => {
    F !== E.current && (E.current = F, g(F));
  }, []), w = b.useCallback((F) => {
    F !== S.current && (S.current = F, y(F));
  }, []), C = s || p, x = i || m, E = b.useRef(null), S = b.useRef(null), M = b.useRef(u), T = c != null, P = Iu(c), k = Iu(o), I = Iu(l), O = b.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const F = {
      placement: t,
      strategy: n,
      middleware: f
    };
    k.current && (F.platform = k.current), VM(E.current, S.current, F).then((V) => {
      const D = {
        ...V,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      A.current && !Ac(M.current, D) && (M.current = D, Yn.flushSync(() => {
        d(D);
      }));
    });
  }, [f, t, n, k, I]);
  dc(() => {
    l === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [l]);
  const A = b.useRef(!1);
  dc(() => (A.current = !0, () => {
    A.current = !1;
  }), []), dc(() => {
    if (C && (E.current = C), x && (S.current = x), C && x) {
      if (P.current)
        return P.current(C, x, O);
      O();
    }
  }, [C, x, O, P, T]);
  const R = b.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: v,
    setFloating: w
  }), [v, w]), N = b.useMemo(() => ({
    reference: C,
    floating: x
  }), [C, x]), $ = b.useMemo(() => {
    const F = {
      position: n,
      left: 0,
      top: 0
    };
    if (!N.floating)
      return F;
    const V = Wg(N.floating, u.x), D = Wg(N.floating, u.y);
    return a ? {
      ...F,
      transform: "translate(" + V + "px, " + D + "px)",
      ...ly(N.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: V,
      top: D
    };
  }, [n, a, N.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: O,
    refs: R,
    elements: N,
    floatingStyles: $
  }), [u, O, R, N, $]);
}
const YM = (e, t) => {
  const n = DM(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, zM = (e, t) => {
  const n = NM(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, jM = (e, t) => ({
  fn: LM(e).fn,
  options: [e, t]
}), UM = (e, t) => {
  const n = AM(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, GM = (e, t) => {
  const n = $M(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, KM = (e, t) => {
  const n = FM(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, ge = (e, t, n, r, o, s, ...i) => {
  if (i.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : rt(1));
  let a;
  if (e && t && n && r && o && s)
    a = (c, l, u, d) => {
      const f = e(c, l, u, d), h = t(c, l, u, d), p = n(c, l, u, d), g = r(c, l, u, d), m = o(c, l, u, d);
      return s(f, h, p, g, m, l, u, d);
    };
  else if (e && t && n && r && o)
    a = (c, l, u, d) => {
      const f = e(c, l, u, d), h = t(c, l, u, d), p = n(c, l, u, d), g = r(c, l, u, d);
      return o(f, h, p, g, l, u, d);
    };
  else if (e && t && n && r)
    a = (c, l, u, d) => {
      const f = e(c, l, u, d), h = t(c, l, u, d), p = n(c, l, u, d);
      return r(f, h, p, l, u, d);
    };
  else if (e && t && n)
    a = (c, l, u, d) => {
      const f = e(c, l, u, d), h = t(c, l, u, d);
      return n(f, h, l, u, d);
    };
  else if (e && t)
    a = (c, l, u, d) => {
      const f = e(c, l, u, d);
      return t(f, l, u, d);
    };
  else if (e)
    a = e;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return a;
};
var Hd = { exports: {} }, Du = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bg;
function qM() {
  if (Bg)
    return Du;
  Bg = 1;
  var e = ie;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, i = e.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, m = p[1];
    return s(
      function() {
        g.value = h, g.getSnapshot = f, c(g) && m({ inst: g });
      },
      [d, h, f]
    ), o(
      function() {
        return c(g) && m({ inst: g }), d(function() {
          c(g) && m({ inst: g });
        });
      },
      [d]
    ), i(h), h;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : a;
  return Du.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Du;
}
var Nu = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hg;
function XM() {
  return Hg || (Hg = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function t(h, p) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = p();
      if (!d) {
        var m = p();
        s(g, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      m = i({
        inst: { value: g, getSnapshot: p }
      });
      var y = m[0].inst, v = m[1];
      return c(
        function() {
          y.value = g, y.getSnapshot = p, n(y) && v({ inst: y });
        },
        [h, g, p]
      ), a(
        function() {
          return n(y) && v({ inst: y }), h(function() {
            n(y) && v({ inst: y });
          });
        },
        [h]
      ), l(g), g;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var g = p();
        return !s(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = ie, s = typeof Object.is == "function" ? Object.is : e, i = o.useState, a = o.useEffect, c = o.useLayoutEffect, l = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Nu.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Nu;
}
process.env.NODE_ENV === "production" ? Hd.exports = qM() : Hd.exports = XM();
var Nl = Hd.exports, Yd = { exports: {} }, Au = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yg;
function ZM() {
  if (Yg)
    return Au;
  Yg = 1;
  var e = ie, t = Nl;
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, s = e.useRef, i = e.useEffect, a = e.useMemo, c = e.useDebugValue;
  return Au.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
    var p = s(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = a(
      function() {
        function y(E) {
          if (!v) {
            if (v = !0, w = E, E = f(E), h !== void 0 && g.hasValue) {
              var S = g.value;
              if (h(S, E))
                return C = S;
            }
            return C = E;
          }
          if (S = C, r(w, E))
            return S;
          var M = f(E);
          return h !== void 0 && h(S, M) ? (w = E, S) : (w = E, C = M);
        }
        var v = !1, w, C, x = d === void 0 ? null : d;
        return [
          function() {
            return y(u());
          },
          x === null ? void 0 : function() {
            return y(x());
          }
        ];
      },
      [u, d, f, h]
    );
    var m = o(l, p[0], p[1]);
    return i(
      function() {
        g.hasValue = !0, g.value = m;
      },
      [m]
    ), c(m), m;
  }, Au;
}
var $u = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zg;
function QM() {
  return zg || (zg = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, u) {
      return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = ie, n = Nl, r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, s = t.useRef, i = t.useEffect, a = t.useMemo, c = t.useDebugValue;
    $u.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
      var p = s(null);
      if (p.current === null) {
        var g = { hasValue: !1, value: null };
        p.current = g;
      } else
        g = p.current;
      p = a(
        function() {
          function y(E) {
            if (!v) {
              if (v = !0, w = E, E = f(E), h !== void 0 && g.hasValue) {
                var S = g.value;
                if (h(S, E))
                  return C = S;
              }
              return C = E;
            }
            if (S = C, r(w, E))
              return S;
            var M = f(E);
            return h !== void 0 && h(S, M) ? (w = E, S) : (w = E, C = M);
          }
          var v = !1, w, C, x = d === void 0 ? null : d;
          return [
            function() {
              return y(u());
            },
            x === null ? void 0 : function() {
              return y(x());
            }
          ];
        },
        [u, d, f, h]
      );
      var m = o(l, p[0], p[1]);
      return i(
        function() {
          g.hasValue = !0, g.value = m;
        },
        [m]
      ), c(m), m;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), $u;
}
process.env.NODE_ENV === "production" ? Yd.exports = ZM() : Yd.exports = QM();
var JM = Yd.exports;
const eT = Mf(19), tT = eT ? rT : oT;
function uy(e, t, n, r, o) {
  return tT(e, t, n, r, o);
}
function nT(e, t, n, r, o) {
  const s = b.useCallback(() => t(e.getSnapshot(), n, r, o), [e, t, n, r, o]);
  return Nl.useSyncExternalStore(e.subscribe, s, s);
}
QS({
  before(e) {
    e.syncIndex = 0, e.didInitialize || (e.syncTick = 1, e.syncHooks = [], e.didChangeStore = !0, e.getSnapshot = () => {
      let t = !1;
      for (let n = 0; n < e.syncHooks.length; n += 1) {
        const r = e.syncHooks[n], o = r.selector(r.store.state, r.a1, r.a2, r.a3);
        (r.didChange || !Object.is(r.value, o)) && (t = !0, r.value = o, r.didChange = !1);
      }
      return t && (e.syncTick += 1), e.syncTick;
    });
  },
  after(e) {
    e.syncHooks.length > 0 && (e.didChangeStore && (e.didChangeStore = !1, e.subscribe = (t) => {
      const n = /* @__PURE__ */ new Set();
      for (const o of e.syncHooks)
        n.add(o.store);
      const r = [];
      for (const o of n)
        r.push(o.subscribe(t));
      return () => {
        for (const o of r)
          o();
      };
    }), Nl.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getSnapshot));
  }
});
function rT(e, t, n, r, o) {
  const s = ZS();
  if (!s)
    return nT(e, t, n, r, o);
  const i = s.syncIndex;
  s.syncIndex += 1;
  let a;
  return s.didInitialize ? (a = s.syncHooks[i], (a.store !== e || a.selector !== t || !Object.is(a.a1, n) || !Object.is(a.a2, r) || !Object.is(a.a3, o)) && (a.store !== e && (s.didChangeStore = !0), a.store = e, a.selector = t, a.a1 = n, a.a2 = r, a.a3 = o, a.didChange = !0)) : (a = {
    store: e,
    selector: t,
    a1: n,
    a2: r,
    a3: o,
    value: t(e.getSnapshot(), n, r, o),
    didChange: !1
  }, s.syncHooks.push(a)), a.value;
}
function oT(e, t, n, r, o) {
  return JM.useSyncExternalStoreWithSelector(e.subscribe, e.getSnapshot, e.getSnapshot, (s) => t(s, n, r, o));
}
class sT {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(t) {
    /**
     * Registers a listener that will be called whenever the store's state changes.
     *
     * @param fn The listener function to be called on state changes.
     * @returns A function to unsubscribe the listener.
     */
    ae(this, "subscribe", (t) => (this.listeners.add(t), () => {
      this.listeners.delete(t);
    }));
    /**
     * Returns the current state of the store.
     */
    ae(this, "getSnapshot", () => this.state);
    this.state = t, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(t) {
    if (this.state === t)
      return;
    this.state = t, this.updateTick += 1;
    const n = this.updateTick;
    for (const r of this.listeners) {
      if (n !== this.updateTick)
        return;
      r(t);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(t) {
    for (const n in t)
      if (!Object.is(this.state[n], t[n])) {
        this.setState({
          ...this.state,
          ...t
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(t, n) {
    Object.is(this.state[t], n) || this.setState({
      ...this.state,
      [t]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const t = {
      ...this.state
    };
    this.setState(t);
  }
  use(t, n, r, o) {
    return uy(this, t, n, r, o);
  }
}
class Ns extends sT {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(t, n = {}, r) {
    super(t), this.context = n, this.selectors = r;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(t, n) {
    b.useDebugValue(t);
    const r = this;
    be(() => {
      r.state[t] !== n && r.set(t, n);
    }, [r, t, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(t, n) {
    const r = this;
    be(() => (r.state[t] !== n && r.set(t, n), () => {
      r.set(t, void 0);
    }), [r, t, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(t) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      b.useDebugValue(t, (i) => Object.keys(i));
      const o = b.useRef(Object.keys(t)).current, s = Object.keys(t);
      (o.length !== s.length || o.some((i, a) => i !== s[a])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const r = Object.values(t);
    be(() => {
      n.update(t);
    }, [n, ...r]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(t, n) {
    b.useDebugValue(t);
    const r = this, o = n !== void 0;
    if (be(() => {
      o && !Object.is(r.state[t], n) && r.setState({
        ...r.state,
        [t]: n
      });
    }, [r, t, n, o]), process.env.NODE_ENV !== "production") {
      const s = this.controlledValues ?? (this.controlledValues = /* @__PURE__ */ new Map());
      s.has(t) || s.set(t, o);
      const i = s.get(t);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${t.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(t, n, r, o) {
    const s = this.selectors[t];
    return s(this.state, n, r, o);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(t, n, r, o) {
    return b.useDebugValue(t), uy(this, this.selectors[t], n, r, o);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(t, n) {
    b.useDebugValue(t);
    const r = Se(n ?? an);
    this.context[t] = r;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(t) {
    const n = b.useRef(void 0);
    return n.current === void 0 && (n.current = (r) => {
      this.set(t, r);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(t, n) {
    let r;
    typeof t == "function" ? r = t : r = this.selectors[t];
    let o = r(this.state);
    return n(o, o, this), this.subscribe((s) => {
      const i = r(s);
      if (!Object.is(o, i)) {
        const a = o;
        o = i, n(i, a, this);
      }
    });
  }
}
const iT = {
  open: ge((e) => e.open),
  transitionStatus: ge((e) => e.transitionStatus),
  domReferenceElement: ge((e) => e.domReferenceElement),
  referenceElement: ge((e) => e.positionReference ?? e.referenceElement),
  floatingElement: ge((e) => e.floatingElement),
  floatingId: ge((e) => e.floatingId)
};
class Al extends Ns {
  constructor(n) {
    const {
      syncOnly: r,
      nested: o,
      onOpenChange: s,
      triggerElements: i,
      ...a
    } = n;
    super({
      ...a,
      positionReference: a.referenceElement,
      domReferenceElement: a.referenceElement
    }, {
      onOpenChange: s,
      dataRef: {
        current: {}
      },
      events: J0(),
      nested: o,
      triggerElements: i
    }, iT);
    /**
     * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
     */
    ae(this, "syncOpenEvent", (n, r) => {
      (!n || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
      // click events to upgrade a hover-open.
      r != null && iO(r)) && (this.context.dataRef.current.openEvent = n ? r : void 0);
    });
    /**
     * Runs the root-owned side effects for an open state change.
     */
    ae(this, "dispatchOpenChange", (n, r) => {
      this.syncOpenEvent(n, r.event);
      const o = {
        open: n,
        reason: r.reason,
        nativeEvent: r.event,
        nested: this.context.nested,
        triggerElement: r.trigger
      };
      this.context.events.emit("openchange", o);
    });
    /**
     * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
     *
     * @param newOpen The new open state.
     * @param eventDetails Details about the event that triggered the open state change.
     */
    ae(this, "setOpen", (n, r) => {
      var o, s, i, a;
      if (this.syncOnly) {
        (s = (o = this.context).onOpenChange) == null || s.call(o, n, r);
        return;
      }
      this.dispatchOpenChange(n, r), (a = (i = this.context).onOpenChange) == null || a.call(i, n, r);
    });
    this.syncOnly = r;
  }
}
function dy(e) {
  const {
    popupStore: t,
    treatPopupAsFloatingElement: n = !1,
    floatingRootContext: r,
    floatingId: o,
    nested: s,
    onOpenChange: i
  } = e, a = t.useState("open"), c = t.useState("activeTriggerElement"), l = t.useState(n ? "popupElement" : "positionerElement"), u = t.context.triggerElements, d = i, f = b.useRef(null);
  r === void 0 && f.current === null && (f.current = new Al({
    open: a,
    transitionStatus: void 0,
    referenceElement: c,
    floatingElement: l,
    triggerElements: u,
    onOpenChange: d,
    floatingId: o,
    syncOnly: !0,
    nested: s
  }));
  const h = r ?? f.current;
  return t.useSyncedValue("floatingId", o), be(() => {
    const p = {
      open: a,
      floatingId: o,
      referenceElement: c,
      floatingElement: l
    };
    Ge(c) && (p.domReferenceElement = c), h.state.positionReference === h.state.referenceElement && (p.positionReference = c), h.update(p);
  }, [a, o, c, l, h]), h.context.onOpenChange = d, h.context.nested = s, h;
}
function ta(e, t = !1, n = !1) {
  const [r, o] = b.useState(e && t ? "idle" : void 0), [s, i] = b.useState(e);
  return e && !s && (i(!0), o("starting")), !e && s && r !== "ending" && !n && o("ending"), !e && !s && r === "ending" && o(void 0), be(() => {
    if (!e && s && r !== "ending" && n) {
      const a = bn.request(() => {
        o("ending");
      });
      return () => {
        bn.cancel(a);
      };
    }
  }, [e, s, r, n]), be(() => {
    if (!e || t)
      return;
    const a = bn.request(() => {
      o(void 0);
    });
    return () => {
      bn.cancel(a);
    };
  }, [t, e]), be(() => {
    if (!e || !t)
      return;
    e && s && r !== "idle" && o("starting");
    const a = bn.request(() => {
      o("idle");
    });
    return () => {
      bn.cancel(a);
    };
  }, [t, e, s, r]), {
    mounted: s,
    setMounted: i,
    transitionStatus: r
  };
}
let Hr = /* @__PURE__ */ function(e) {
  return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({});
const aT = {
  [Hr.startingStyle]: ""
}, cT = {
  [Hr.endingStyle]: ""
}, Un = {
  transitionStatus(e) {
    return e === "starting" ? aT : e === "ending" ? cT : null;
  }
};
function $l(e, t = !1, n = !0) {
  const r = Ai();
  return Se((o, s = null) => {
    r.cancel();
    const i = Tr(e);
    if (i == null)
      return;
    const a = i, c = () => {
      Yn.flushSync(o);
    };
    if (typeof a.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      o();
      return;
    }
    function l() {
      Promise.all(a.getAnimations().map((u) => u.finished)).then(() => {
        s != null && s.aborted || c();
      }).catch(() => {
        if (n) {
          s != null && s.aborted || c();
          return;
        }
        const u = a.getAnimations();
        !(s != null && s.aborted) && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && l();
      });
    }
    if (t) {
      const u = Hr.startingStyle;
      if (!a.hasAttribute(u)) {
        r.request(l);
        return;
      }
      const d = new MutationObserver(() => {
        a.hasAttribute(u) || (d.disconnect(), l());
      });
      d.observe(a, {
        attributes: !0,
        attributeFilter: [u]
      }), s == null || s.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    r.request(l);
  });
}
function xr(e) {
  const {
    enabled: t = !0,
    open: n,
    ref: r,
    onComplete: o
  } = e, s = Se(o), i = $l(r, n, !1);
  b.useEffect(() => {
    if (!t)
      return;
    const a = new AbortController();
    return i(s, a.signal), () => {
      a.abort();
    };
  }, [t, n, s, i]);
}
const As = {
  tabIndex: -1,
  [Dd]: ""
};
function eh(e, t, n = !1) {
  const r = Br(), o = Kr() != null, s = b.useRef(null);
  e === void 0 && s.current === null && (s.current = t(r, o));
  const i = e ?? s.current;
  return dy({
    popupStore: i,
    treatPopupAsFloatingElement: n,
    floatingRootContext: i.state.floatingRootContext,
    floatingId: r,
    nested: o,
    onOpenChange: i.setOpen
  }), {
    store: i,
    internalStore: s.current
  };
}
function fy(e, t) {
  const n = b.useRef(null), r = b.useRef(null);
  return b.useCallback((o) => {
    if (e === void 0)
      return;
    let s = !1;
    if (n.current !== null) {
      const i = n.current, a = r.current, c = t.context.triggerElements.getById(i);
      a && c === a && (t.context.triggerElements.delete(i), s = !0), n.current = null, r.current = null;
    }
    if (o !== null && (n.current = e, r.current = o, t.context.triggerElements.add(e, o), s = !0), s) {
      const i = t.context.triggerElements.size;
      t.select("open") && t.state.triggerCount !== i && t.set("triggerCount", i);
    }
  }, [t, e]);
}
function th(e, t, n) {
  const r = (n == null ? void 0 : n.id) ?? null;
  (r || t) && (e.activeTriggerId = r, e.activeTriggerElement = n ?? null);
}
function Fl(e, t, n, r) {
  const o = n.useState("isMountedByTrigger", e), s = fy(e, n), i = Se((a) => {
    if (s(a), !a)
      return;
    const c = n.select("open"), l = n.select("activeTriggerId");
    if (l === e) {
      n.update({
        activeTriggerElement: a,
        ...c ? r : null
      });
      return;
    }
    l == null && c && n.update({
      activeTriggerId: e,
      activeTriggerElement: a,
      ...r
    });
  });
  return be(() => {
    o && n.update({
      activeTriggerElement: t.current,
      ...r
    });
  }, [o, n, t, ...Object.values(r)]), {
    registerTrigger: i,
    isMountedByThisTrigger: o
  };
}
function Ll(e) {
  const t = e.useState("open"), n = e.useState("triggerCount");
  be(() => {
    if (!t) {
      e.state.triggerCount !== 0 && e.set("triggerCount", 0);
      return;
    }
    const r = e.context.triggerElements.size, o = {};
    if (e.state.triggerCount !== r && (o.triggerCount = r), !e.select("activeTriggerId") && r === 1) {
      const s = e.context.triggerElements.entries().next();
      if (!s.done) {
        const [i, a] = s.value;
        o.activeTriggerId = i, o.activeTriggerElement = a;
      }
    }
    (o.triggerCount !== void 0 || o.activeTriggerId !== void 0) && e.update(o);
  }, [t, e, n]);
}
function Vl(e, t, n) {
  const {
    mounted: r,
    setMounted: o,
    transitionStatus: s
  } = ta(e);
  t.useSyncedValues({
    mounted: r,
    transitionStatus: s
  });
  const i = Se(() => {
    var c, l;
    o(!1), t.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1,
      preventUnmountingOnClose: !1
    }), n == null || n(), (l = (c = t.context).onOpenChangeComplete) == null || l.call(c, !1);
  }), a = t.useState("preventUnmountingOnClose");
  return xr({
    enabled: r && !e && !a,
    open: e,
    ref: t.context.popupRef,
    onComplete() {
      e || i();
    }
  }), {
    forceUnmount: i,
    transitionStatus: s
  };
}
function Wl(e, t) {
  e.useSyncedValues(t), be(() => () => {
    e.update({
      activeTriggerProps: wt,
      inactiveTriggerProps: wt,
      popupProps: wt
    });
  }, [e]);
}
function hy(e, t) {
  be(() => {
    !t && e.state.openMethod !== null && e.set("openMethod", null);
  }, [t, e]), be(() => () => {
    e.state.openMethod !== null && e.set("openMethod", null);
  }, [e]);
}
class $s {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(t, n) {
    const r = this.idMap.get(t);
    if (r !== n && (r !== void 0 && this.elementsSet.delete(r), this.elementsSet.add(n), this.idMap.set(t, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(t) {
    const n = this.idMap.get(t);
    n && (this.elementsSet.delete(n), this.idMap.delete(t));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(t) {
    return this.elementsSet.has(t);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(t) {
    for (const n of this.elementsSet)
      if (t(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(t) {
    return this.idMap.get(t);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function lT() {
  return new Al({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new $s(),
    floatingId: void 0,
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function Bl() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: lT(),
    floatingId: void 0,
    triggerCount: 0,
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: wt,
    inactiveTriggerProps: wt,
    popupProps: wt
  };
}
function nh(e, t, n = !1) {
  return new Al({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: e,
    floatingId: t,
    syncOnly: !0,
    nested: n,
    onOpenChange: void 0
  });
}
const xi = ge((e) => e.triggerIdProp ?? e.activeTriggerId), rh = ge((e) => e.openProp ?? e.open), jg = ge((e) => {
  var n;
  return (((n = e.popupElement) == null ? void 0 : n.id) ?? e.floatingId) || void 0;
});
function py(e, t) {
  return t !== void 0 && rh(e) && xi(e) === t;
}
function uT(e, t) {
  return py(e, t) ? !0 : t !== void 0 && rh(e) && xi(e) == null && e.triggerCount === 1;
}
const Hl = {
  open: rh,
  mounted: ge((e) => e.mounted),
  transitionStatus: ge((e) => e.transitionStatus),
  floatingRootContext: ge((e) => e.floatingRootContext),
  triggerCount: ge((e) => e.triggerCount),
  preventUnmountingOnClose: ge((e) => e.preventUnmountingOnClose),
  payload: ge((e) => e.payload),
  activeTriggerId: xi,
  activeTriggerElement: ge((e) => e.mounted ? e.activeTriggerElement : null),
  popupId: jg,
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: ge((e, t) => t !== void 0 && xi(e) === t),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: ge((e, t) => py(e, t)),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: ge((e, t) => t !== void 0 && xi(e) === t && e.mounted),
  triggerProps: ge((e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps),
  /**
   * Popup id for the trigger that currently owns the open popup.
   */
  triggerPopupId: ge((e, t) => uT(e, t) ? jg(e) : void 0),
  popupProps: ge((e) => e.popupProps),
  popupElement: ge((e) => e.popupElement),
  positionerElement: ge((e) => e.positionerElement)
};
function dT(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r = {}
  } = e, o = Br(), s = Kr() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = r.reference;
    a && !Ge(a) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const i = gn(() => new Al({
    open: t,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: r.reference ?? null,
    floatingElement: r.floating ?? null,
    triggerElements: new $s(),
    floatingId: o,
    syncOnly: !1,
    nested: s
  })).current;
  return be(() => {
    const a = {
      open: t,
      floatingId: o
    };
    r.reference !== void 0 && (a.referenceElement = r.reference, a.domReferenceElement = Ge(r.reference) ? r.reference : null), r.floating !== void 0 && (a.floatingElement = r.floating), i.update(a);
  }, [t, o, r.reference, r.floating, i]), i.context.onOpenChange = n, i.context.nested = s, i;
}
function fT(e = {}) {
  const {
    nodeId: t,
    externalTree: n
  } = e, r = dT(e), o = e.rootContext || r, s = o.useState("referenceElement"), i = o.useState("floatingElement"), a = o.useState("domReferenceElement"), c = o.useState("open"), l = o.useState("floatingId"), [u, d] = b.useState(null), [f, h] = b.useState(void 0), [p, g] = b.useState(void 0), m = b.useRef(null), y = vo(n), v = b.useMemo(() => ({
    reference: s,
    floating: i,
    domReference: a
  }), [s, i, a]), w = HM({
    ...e,
    elements: {
      ...v,
      ...u && {
        reference: u
      }
    }
  }), C = Ge(f) ? f : null, x = p === void 0 ? o.state.floatingElement : p;
  o.useSyncedValue("referenceElement", f ?? null), o.useSyncedValue("domReferenceElement", f === void 0 ? a : C), o.useSyncedValue("floatingElement", x);
  const E = b.useCallback((I) => {
    const O = Ge(I) ? {
      getBoundingClientRect: () => I.getBoundingClientRect(),
      getClientRects: () => I.getClientRects(),
      contextElement: I
    } : I;
    d(O), w.refs.setReference(O);
  }, [w.refs]), S = b.useCallback((I) => {
    (Ge(I) || I === null) && (m.current = I, h(I)), (Ge(w.refs.reference.current) || w.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    I !== null && !Ge(I)) && w.refs.setReference(I);
  }, [w.refs, h]), M = b.useCallback((I) => {
    g(I), w.refs.setFloating(I);
  }, [w.refs]), T = b.useMemo(() => ({
    ...w.refs,
    setReference: S,
    setFloating: M,
    setPositionReference: E,
    domReference: m
  }), [w.refs, S, M, E]), P = b.useMemo(() => ({
    ...w.elements,
    domReference: a
  }), [w.elements, a]), k = b.useMemo(() => ({
    ...w,
    dataRef: o.context.dataRef,
    open: c,
    onOpenChange: o.setOpen,
    events: o.context.events,
    floatingId: l,
    refs: T,
    elements: P,
    nodeId: t,
    rootStore: o
  }), [w, T, P, t, o, c, l]);
  return be(() => {
    a && (m.current = a);
  }, [a]), be(() => {
    o.context.dataRef.current.floatingContext = k;
    const I = y == null ? void 0 : y.nodesRef.current.find((O) => O.id === t);
    I && (I.context = k);
  }), b.useMemo(() => ({
    ...w,
    context: k,
    refs: T,
    elements: P,
    rootStore: o
  }), [w, T, P, k, o]);
}
const Fu = _0 && E0;
function gy(e, t = {}) {
  const {
    enabled: n = !0,
    delay: r
  } = t, o = "rootStore" in e ? e.rootStore : e, {
    events: s,
    dataRef: i
  } = o.context, a = b.useRef(!1), c = b.useRef(null), l = b.useRef(!0), u = ln();
  b.useEffect(() => {
    const f = o.select("domReferenceElement");
    if (!n)
      return;
    const h = Ot(f);
    function p() {
      const y = o.select("domReferenceElement");
      !o.select("open") && vt(y) && y === Xt(Ye(y)) && (a.current = !0);
    }
    function g() {
      l.current = !0;
    }
    function m() {
      l.current = !1;
    }
    return er(We(h, "blur", p), Fu && We(h, "keydown", g, !0), Fu && We(h, "pointerdown", m, !0));
  }, [o, n]), b.useEffect(() => {
    if (!n)
      return;
    function f(h) {
      if (h.reason === br || h.reason === Ji) {
        const p = o.select("domReferenceElement");
        Ge(p) && (c.current = p, a.current = !0);
      }
    }
    return s.on("openchange", f), () => {
      s.off("openchange", f);
    };
  }, [s, n, o]);
  const d = b.useMemo(() => {
    function f() {
      a.current = !1, c.current = null;
    }
    return {
      onMouseLeave() {
        f();
      },
      onFocus(h) {
        const p = h.currentTarget;
        if (a.current) {
          if (c.current === p)
            return;
          f();
        }
        const g = Dt(h.nativeEvent);
        if (Ge(g)) {
          if (Fu && !h.relatedTarget) {
            if (!l.current && !Sl(g))
              return;
          } else if (!Pc(g))
            return;
        }
        const m = kc(h.relatedTarget, o.context.triggerElements), {
          nativeEvent: y,
          currentTarget: v
        } = h, w = typeof r == "function" ? r() : r;
        if (o.select("open") && m || w === 0 || w === void 0) {
          o.setOpen(!0, Ve(hs, y, v));
          return;
        }
        u.start(w, () => {
          a.current || o.setOpen(!0, Ve(hs, y, v));
        });
      },
      onBlur(h) {
        f();
        const p = h.relatedTarget, g = h.nativeEvent, m = Ge(p) && p.hasAttribute(Fi("focus-guard")) && p.getAttribute("data-type") === "outside";
        u.start(0, () => {
          var C;
          const y = o.select("domReferenceElement"), v = Xt(Ye(y));
          !p && v === y || Re((C = i.current.floatingContext) == null ? void 0 : C.refs.floating.current, v) || Re(y, v) || m || kc(p ?? v, o.context.triggerElements) || o.setOpen(!1, Ve(hs, g));
        });
      }
    };
  }, [i, r, o, u]);
  return b.useMemo(() => n ? {
    reference: d,
    trigger: d
  } : {}, [n, d]);
}
class oh {
  constructor() {
    ae(this, "dispose", () => {
      this.openChangeTimeout.clear(), this.restTimeout.clear();
    });
    ae(this, "disposeEffect", () => this.dispose);
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new xn(), this.restTimeout = new xn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new oh();
  }
}
const $c = /* @__PURE__ */ new WeakMap();
function Fc(e) {
  var n, r, o;
  if (!e.performedPointerEventsMutation)
    return;
  const t = e.pointerEventsScopeElement;
  t && $c.get(t) === e && ((n = e.pointerEventsScopeElement) == null || n.style.removeProperty("pointer-events"), (r = e.pointerEventsReferenceElement) == null || r.style.removeProperty("pointer-events"), (o = e.pointerEventsFloatingElement) == null || o.style.removeProperty("pointer-events"), $c.delete(t)), e.performedPointerEventsMutation = !1, e.pointerEventsScopeElement = null, e.pointerEventsReferenceElement = null, e.pointerEventsFloatingElement = null;
}
function my(e, t) {
  const {
    scopeElement: n,
    referenceElement: r,
    floatingElement: o
  } = t, s = $c.get(n);
  s && s !== e && Fc(s), Fc(e), e.performedPointerEventsMutation = !0, e.pointerEventsScopeElement = n, e.pointerEventsReferenceElement = r, e.pointerEventsFloatingElement = o, $c.set(n, e), n.style.pointerEvents = "none", r.style.pointerEvents = "auto", o.style.pointerEvents = "auto";
}
function sh(e) {
  const t = e.context.dataRef.current, n = gn(() => t.hoverInteractionState ?? oh.create()).current;
  return t.hoverInteractionState || (t.hoverInteractionState = n), wl(t.hoverInteractionState.disposeEffect), t.hoverInteractionState;
}
function ih(e, t = {}) {
  const {
    enabled: n = !0,
    closeDelay: r = 0,
    nodeId: o
  } = t, s = "rootStore" in e ? e.rootStore : e, i = s.useState("open"), a = s.useState("floatingElement"), c = s.useState("domReferenceElement"), {
    dataRef: l
  } = s.context, u = vo(), d = Kr(), f = sh(s), h = ln(), p = Se(() => {
    var y;
    return P0((y = l.current.openEvent) == null ? void 0 : y.type, f.interactedInside);
  }), g = Se(() => {
    var y;
    return pO((y = l.current.openEvent) == null ? void 0 : y.type);
  }), m = Se(() => {
    Fc(f);
  });
  be(() => {
    i || (f.pointerType = void 0, f.restTimeoutPending = !1, f.interactedInside = !1, m());
  }, [i, f, m]), b.useEffect(() => m, [m]), be(() => {
    var y, v, w, C, x;
    if (n && i && (y = f.handleCloseOptions) != null && y.blockPointerEvents && g() && Ge(c) && a) {
      const E = c, S = a, M = Ye(a), T = (w = (v = u == null ? void 0 : u.nodesRef.current.find((O) => O.id === d)) == null ? void 0 : v.context) == null ? void 0 : w.elements.floating;
      T && (T.style.pointerEvents = "");
      const P = f.pointerEventsScopeElement !== S ? f.pointerEventsScopeElement : null, k = T !== S ? T : null, I = ((x = (C = f.handleCloseOptions) == null ? void 0 : C.getScope) == null ? void 0 : x.call(C)) ?? P ?? k ?? E.closest("[data-rootownerid]") ?? M.body;
      return my(f, {
        scopeElement: I,
        referenceElement: E,
        floatingElement: S
      }), () => {
        m();
      };
    }
  }, [n, i, c, a, f, g, u, d, m]), b.useEffect(() => {
    if (!n)
      return;
    function y() {
      return !!(u && d && fo(u.nodesRef.current, d).length > 0);
    }
    function v(M) {
      const T = Rc(r, "close", f.pointerType), P = () => {
        s.setOpen(!1, Ve(Pt, M)), u == null || u.events.emit("floating.closed", M);
      };
      T ? f.openChangeTimeout.start(T, P) : (f.openChangeTimeout.clear(), P());
    }
    function w(M) {
      const T = Dt(M);
      if (!fO(T)) {
        f.interactedInside = !1;
        return;
      }
      f.interactedInside = (T == null ? void 0 : T.closest("[aria-haspopup]")) != null;
    }
    function C() {
      f.openChangeTimeout.clear(), h.clear(), u == null || u.events.off("floating.closed", E), m();
    }
    function x(M) {
      var I;
      if (y() && u) {
        u.events.on("floating.closed", E);
        return;
      }
      if (kc(M.relatedTarget, s.context.triggerElements))
        return;
      const T = ((I = l.current.floatingContext) == null ? void 0 : I.nodeId) ?? o, P = M.relatedTarget;
      if (!(u && T && Ge(P) && fo(u.nodesRef.current, T, !1).some((O) => {
        var A;
        return Re((A = O.context) == null ? void 0 : A.elements.floating, P);
      }))) {
        if (f.handler) {
          f.handler(M);
          return;
        }
        m(), p() || v(M);
      }
    }
    function E(M) {
      !u || !d || y() || h.start(0, () => {
        u.events.off("floating.closed", E), s.setOpen(!1, Ve(Pt, M)), u.events.emit("floating.closed", M);
      });
    }
    const S = a;
    return er(S && We(S, "mouseenter", C), S && We(S, "mouseleave", x), S && We(S, "pointerdown", w, !0), () => {
      u == null || u.events.off("floating.closed", E);
    });
  }, [n, a, s, l, r, o, p, m, f, u, d, h]);
}
const hT = {
  current: null
};
function Yl(e, t = {}) {
  var R;
  const {
    enabled: n = !0,
    delay: r = 0,
    handleClose: o = null,
    mouseOnly: s = !1,
    restMs: i = 0,
    move: a = !0,
    triggerElementRef: c = hT,
    externalTree: l,
    isActiveTrigger: u = !0,
    getHandleCloseContext: d,
    isClosing: f,
    shouldOpen: h
  } = t, p = "rootStore" in e ? e.rootStore : e, {
    dataRef: g,
    events: m
  } = p.context, y = vo(l), v = sh(p), w = b.useRef(!1), C = Yt(o), x = Yt(r), E = Yt(i), S = Yt(n), M = Yt(h), T = Yt(f), P = Se(() => {
    var N;
    return P0((N = g.current.openEvent) == null ? void 0 : N.type, v.interactedInside);
  }), k = Se(() => {
    var N;
    return ((N = M.current) == null ? void 0 : N.call(M)) !== !1;
  }), I = Se((N, $, F) => {
    const V = p.context.triggerElements;
    if (V.hasElement($))
      return !N || !Re(N, $);
    if (!Ge(F))
      return !1;
    const D = F;
    return V.hasMatchingElement((H) => Re(H, D)) && (!N || !Re(N, D));
  }), O = Se(() => {
    if (!v.handler)
      return;
    Ye(p.select("domReferenceElement")).removeEventListener("mousemove", v.handler), v.handler = void 0;
  }), A = Se(() => {
    Fc(v);
  });
  return u && (v.handleCloseOptions = (R = C.current) == null ? void 0 : R.__options), b.useEffect(() => O, [O]), b.useEffect(() => {
    if (!n)
      return;
    function N($) {
      $.open ? w.current = !1 : (w.current = $.reason === Pt, O(), v.openChangeTimeout.clear(), v.restTimeout.clear(), v.blockMouseMove = !0, v.restTimeoutPending = !1);
    }
    return m.on("openchange", N), () => {
      m.off("openchange", N);
    };
  }, [n, m, v, O]), b.useEffect(() => {
    if (!n)
      return;
    function N(D, H = !0) {
      const j = Rc(x.current, "close", v.pointerType);
      j ? v.openChangeTimeout.start(j, () => {
        p.setOpen(!1, Ve(Pt, D)), y == null || y.events.emit("floating.closed", D);
      }) : H && (v.openChangeTimeout.clear(), p.setOpen(!1, Ve(Pt, D)), y == null || y.events.emit("floating.closed", D));
    }
    const $ = c.current ?? (u ? p.select("domReferenceElement") : null);
    if (!Ge($))
      return;
    function F(D) {
      var ne;
      if (v.openChangeTimeout.clear(), v.blockMouseMove = !1, s && !Bo(v.pointerType))
        return;
      const H = mg(E.current), j = Rc(x.current, "open", v.pointerType), U = Dt(D), K = D.currentTarget ?? null, G = p.select("domReferenceElement");
      let B = K;
      if (Ge(U) && !p.context.triggerElements.hasElement(U)) {
        for (const de of p.context.triggerElements.elements())
          if (Re(de, U)) {
            B = de;
            break;
          }
      }
      Ge(K) && Ge(G) && !p.context.triggerElements.hasElement(K) && Re(K, G) && (B = G);
      const z = B == null ? !1 : I(G, B, U), W = p.select("open"), X = ((ne = T.current) == null ? void 0 : ne.call(T)) ?? p.select("transitionStatus") === "ending", J = !W && X && w.current, Q = !z && Ge(B) && Ge(G) && Re(G, B) && J, Y = H > 0 && !j, ce = z && (W || J) || Q, ee = !W || z;
      if (ce) {
        k() && p.setOpen(!0, Ve(Pt, D, B));
        return;
      }
      Y || (j ? v.openChangeTimeout.start(j, () => {
        ee && k() && p.setOpen(!0, Ve(Pt, D, B));
      }) : ee && k() && p.setOpen(!0, Ve(Pt, D, B)));
    }
    function V(D) {
      if (P()) {
        A();
        return;
      }
      O();
      const H = p.select("domReferenceElement"), j = Ye(H);
      v.restTimeout.clear(), v.restTimeoutPending = !1;
      const U = g.current.floatingContext ?? (d == null ? void 0 : d());
      if (kc(D.relatedTarget, p.context.triggerElements))
        return;
      if (C.current && U) {
        p.select("open") || v.openChangeTimeout.clear();
        const G = c.current;
        v.handler = C.current({
          ...U,
          tree: y,
          x: D.clientX,
          y: D.clientY,
          onClose() {
            A(), O(), S.current && !P() && G === p.select("domReferenceElement") && N(D, !0);
          }
        }), j.addEventListener("mousemove", v.handler), v.handler(D);
        return;
      }
      (v.pointerType === "touch" ? !Re(p.select("floatingElement"), D.relatedTarget) : !0) && N(D);
    }
    return a ? er(We($, "mousemove", F, {
      once: !0
    }), We($, "mouseenter", F), We($, "mouseleave", V)) : er(We($, "mouseenter", F), We($, "mouseleave", V));
  }, [O, A, g, x, p, n, C, v, u, I, P, s, a, E, c, y, S, d, T, k]), b.useMemo(() => {
    if (!n)
      return;
    function N($) {
      v.pointerType = $.pointerType;
    }
    return {
      onPointerDown: N,
      onPointerEnter: N,
      onMouseMove($) {
        var G, B, z;
        const {
          nativeEvent: F
        } = $, V = $.currentTarget, D = p.select("domReferenceElement"), H = p.select("open"), j = I(D, V, $.target);
        if (s && !Bo(v.pointerType))
          return;
        if (H && j && ((G = v.handleCloseOptions) != null && G.blockPointerEvents)) {
          const W = p.select("floatingElement");
          if (W) {
            const X = ((z = (B = v.handleCloseOptions) == null ? void 0 : B.getScope) == null ? void 0 : z.call(B)) ?? V.ownerDocument.body;
            my(v, {
              scopeElement: X,
              referenceElement: V,
              floatingElement: W
            });
          }
        }
        const U = mg(E.current);
        if (H && !j || U === 0 || !j && v.restTimeoutPending && $.movementX ** 2 + $.movementY ** 2 < 2)
          return;
        v.restTimeout.clear();
        function K() {
          if (v.restTimeoutPending = !1, P())
            return;
          const W = p.select("open");
          !v.blockMouseMove && (!W || j) && k() && p.setOpen(!0, Ve(Pt, F, V));
        }
        v.pointerType === "touch" ? Yn.flushSync(() => {
          K();
        }) : j && H ? K() : (v.restTimeoutPending = !0, v.restTimeout.start(U, K));
      }
    };
  }, [n, v, P, I, s, p, E, k]);
}
const pT = "Escape";
function zl(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function Ma(e, t) {
  return zl(t, e === $f || e === Qi, e === co || e === lo);
}
function Lu(e, t, n) {
  return zl(t, e === Qi, n ? e === co : e === lo) || e === "Enter" || e === " " || e === "";
}
function gT(e, t, n) {
  return zl(t, n ? e === co : e === lo, e === Qi);
}
function mT(e, t, n, r) {
  const o = n ? e === lo : e === co, s = e === $f;
  return t === "both" || t === "horizontal" && r && r > 1 ? e === pT : zl(t, o, s);
}
function bT(e, t) {
  const {
    listRef: n,
    activeIndex: r,
    onNavigate: o = () => {
    },
    enabled: s = !0,
    selectedIndex: i = null,
    allowEscape: a = !1,
    loopFocus: c = !1,
    nested: l = !1,
    rtl: u = !1,
    virtual: d = !1,
    focusItemOnOpen: f = "auto",
    focusItemOnHover: h = !0,
    openOnArrowKeyDown: p = !0,
    disabledIndices: g = void 0,
    orientation: m = "vertical",
    parentOrientation: y,
    cols: v = 1,
    id: w,
    resetOnPointerLeave: C = !0,
    externalTree: x
  } = t;
  process.env.NODE_ENV !== "production" && (a && (c || console.warn("`useListNavigation` looping must be enabled to allow escaping."), d || console.warn("`useListNavigation` must be virtual to allow escaping.")), m === "vertical" && v > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const E = "rootStore" in e ? e.rootStore : e, S = E.useState("open"), M = E.useState("floatingElement"), T = E.useState("domReferenceElement"), P = E.context.dataRef, k = Ad(M), I = Nd(T), O = Yt(k), A = Kr(), R = vo(x), N = b.useRef(f), $ = b.useRef(i ?? -1), F = b.useRef(null), V = b.useRef(!0), D = Se((fe) => {
    o($.current === -1 ? null : $.current, fe);
  }), H = b.useRef(D), j = b.useRef(!!M), U = b.useRef(S), K = b.useRef(!1), G = b.useRef(!1), B = b.useRef(null), z = Yt(g), W = Yt(S), X = Yt(i), J = Yt(C), Q = Ai(), Y = Ai(), ce = Se(() => {
    function fe(re) {
      d ? R == null || R.events.emit("virtualfocus", re) : B.current = uc(re, {
        sync: K.current,
        preventScroll: !0
      });
    }
    const q = n.current[$.current], te = G.current;
    q && fe(q), (K.current ? (re) => re() : (re) => Q.request(re))(() => {
      var xe;
      const re = n.current[$.current] || q;
      if (!re)
        return;
      q || fe(re), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      se && (te || !V.current) && ((xe = re.scrollIntoView) == null || xe.call(re, {
        block: "nearest",
        inline: "nearest"
      }));
    });
  });
  be(() => {
    P.current.orientation = m;
  }, [P, m]), be(() => {
    s && (S && M ? ($.current = i ?? -1, N.current && i != null && (G.current = !0, D())) : j.current && ($.current = -1, H.current()));
  }, [s, S, M, i, D]), be(() => {
    if (s) {
      if (!S) {
        K.current = !1;
        return;
      }
      if (M)
        if (r == null) {
          if (K.current = !1, X.current != null)
            return;
          if (j.current && ($.current = -1, ce()), (!U.current || !j.current) && N.current && (F.current != null || N.current === !0 && F.current == null)) {
            let fe = 0;
            const q = () => {
              n.current[0] == null ? (fe < 2 && (fe ? (oe) => Y.request(oe) : queueMicrotask)(q), fe += 1) : ($.current = F.current == null || Lu(F.current, m, u) || l ? lc(n) : Vd(n), F.current = null, D());
            };
            q();
          }
        } else
          $i(n.current, r) || ($.current = r, ce(), G.current = !1);
    }
  }, [s, S, M, r, X, l, n, m, u, D, ce, Y]), be(() => {
    var re, ve;
    if (!s || M || !R || d || !j.current)
      return;
    const fe = R.nodesRef.current, q = (ve = (re = fe.find((xe) => xe.id === A)) == null ? void 0 : re.context) == null ? void 0 : ve.elements.floating, te = Xt(Ye(M)), oe = fe.some((xe) => xe.context && Re(xe.context.elements.floating, te));
    q && !oe && V.current && q.focus({
      preventScroll: !0
    });
  }, [s, M, R, A, d]), be(() => {
    H.current = D, U.current = S, j.current = !!M;
  }), be(() => {
    S || (F.current = null, N.current = f);
  }, [S, f]);
  const ee = r != null, ne = Se((fe) => {
    if (!W.current)
      return;
    const q = n.current.indexOf(fe.currentTarget);
    q !== -1 && ($.current !== q || r !== q) && ($.current = q, D(fe));
  }), de = Se(() => {
    var fe, q, te;
    return y ?? ((te = (q = (fe = R == null ? void 0 : R.nodesRef.current.find((oe) => oe.id === A)) == null ? void 0 : fe.context) == null ? void 0 : q.dataRef) == null ? void 0 : te.current.orientation);
  }), pe = Se(() => lc(n, z.current)), Ee = Se((fe) => {
    if (V.current = !1, K.current = !0, fe.which === 229 || !W.current && fe.currentTarget === O.current)
      return;
    if (l && mT(fe.key, m, u, v)) {
      Ma(fe.key, de()) || kn(fe), E.setOpen(!1, Ve($d, fe.nativeEvent)), vt(T) && (d ? R == null || R.events.emit("virtualfocus", T) : T.focus());
      return;
    }
    const q = $.current, te = lc(n, g), oe = Vd(n, g);
    if (I || (fe.key === "Home" && (kn(fe), $.current = te, D(fe)), fe.key === "End" && (kn(fe), $.current = oe, D(fe))), v > 1) {
      const re = Array.from({
        length: n.current.length
      }, () => ({
        width: 1,
        height: 1
      })), ve = $0(re, v, !1), xe = ve.findIndex((Ze) => Ze != null && !Fr(n.current, Ze, g)), Me = ve.reduce((Ze, nt, Kt) => nt != null && !Fr(n.current, nt, g) ? Kt : Ze, -1), qe = ve[A0(ve.map((Ze) => Ze != null ? n.current[Ze] : null), {
        event: fe,
        orientation: m,
        loopFocus: c,
        rtl: u,
        cols: v,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: L0([...(typeof g != "function" ? g : null) || n.current.map((Ze, nt) => Fr(n.current, nt, g) ? nt : void 0), void 0], ve),
        minIndex: xe,
        maxIndex: Me,
        prevIndex: F0(
          $.current > oe ? te : $.current,
          re,
          ve,
          v,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          fe.key === Qi ? "bl" : fe.key === (u ? co : lo) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (qe != null && ($.current = qe, D(fe)), m === "both")
        return;
    }
    if (Ma(fe.key, m)) {
      if (kn(fe), S && !d && Xt(fe.currentTarget.ownerDocument) === fe.currentTarget) {
        $.current = Lu(fe.key, m, u) ? te : oe, D(fe);
        return;
      }
      Lu(fe.key, m, u) ? c ? q >= oe ? a && q !== n.current.length ? $.current = -1 : (K.current = !1, $.current = te) : $.current = sn(n.current, {
        startingIndex: q,
        disabledIndices: g
      }) : $.current = Math.min(oe, sn(n.current, {
        startingIndex: q,
        disabledIndices: g
      })) : c ? q <= te ? a && q !== -1 ? $.current = n.current.length : (K.current = !1, $.current = oe) : $.current = sn(n.current, {
        startingIndex: q,
        decrement: !0,
        disabledIndices: g
      }) : $.current = Math.max(te, sn(n.current, {
        startingIndex: q,
        decrement: !0,
        disabledIndices: g
      })), $i(n.current, $.current) && ($.current = -1), D(fe);
    }
  }), se = b.useMemo(() => ({
    onFocus(q) {
      K.current = !0, ne(q);
    },
    onClick: ({
      currentTarget: q
    }) => q.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(q) {
      K.current = !0, G.current = !1, h && ne(q);
    },
    onPointerLeave(q) {
      var oe;
      if (!W.current || !V.current || q.pointerType === "touch")
        return;
      K.current = !0;
      const te = q.relatedTarget;
      if (!(!h || n.current.includes(te)) && J.current && ((oe = B.current) == null || oe.call(B), B.current = null, $.current = -1, D(q), !d)) {
        const re = O.current, ve = Xt(Ye(re));
        re && Re(re, ve) && re.focus({
          preventScroll: !0
        });
      }
    }
  }), [ne, W, O, h, n, D, J, d]), ke = b.useMemo(() => d && S && ee && {
    "aria-activedescendant": `${w}-${r}`
  }, [d, S, ee, w, r]), we = b.useMemo(() => ({
    "aria-orientation": m === "both" ? void 0 : m,
    ...I ? {} : ke,
    onKeyDown(fe) {
      if (fe.key === "Tab" && fe.shiftKey && S && !d) {
        const q = Dt(fe.nativeEvent);
        if (q && !Re(O.current, q))
          return;
        kn(fe), E.setOpen(!1, Ve(Ho, fe.nativeEvent)), vt(T) && T.focus();
        return;
      }
      Ee(fe);
    },
    onPointerMove() {
      V.current = !0;
    }
  }), [ke, Ee, O, m, I, E, S, d, T]), Oe = b.useMemo(() => {
    function fe(oe) {
      E.setOpen(!0, Ve($d, oe.nativeEvent, oe.currentTarget));
    }
    function q(oe) {
      f === "auto" && O0(oe.nativeEvent) && (N.current = !d);
    }
    function te(oe) {
      N.current = f, f === "auto" && M0(oe.nativeEvent) && (N.current = !0);
    }
    return {
      onKeyDown(oe) {
        const re = E.select("open");
        V.current = !1;
        const ve = oe.key.startsWith("Arrow"), xe = gT(oe.key, de(), u), Me = Ma(oe.key, m), qe = (l ? xe : Me) || oe.key === "Enter" || oe.key.trim() === "";
        if (d && re)
          return Ee(oe);
        if (!(!re && !p && ve)) {
          if (qe) {
            const Ze = Ma(oe.key, de());
            F.current = l && Ze ? null : oe.key;
          }
          if (l) {
            xe && (kn(oe), re ? ($.current = pe(), D(oe)) : fe(oe));
            return;
          }
          Me && (X.current != null && ($.current = X.current), kn(oe), !re && p ? fe(oe) : Ee(oe), re && D(oe));
        }
      },
      onFocus(oe) {
        E.select("open") && !d && ($.current = -1, D(oe));
      },
      onPointerDown: te,
      onPointerEnter: te,
      onMouseDown: q,
      onClick: q
    };
  }, [Ee, f, pe, l, D, E, p, m, de, u, X, d]), Ie = b.useMemo(() => ({
    ...ke,
    ...Oe
  }), [ke, Oe]);
  return b.useMemo(() => s ? {
    reference: Ie,
    floating: we,
    item: se,
    trigger: Oe
  } : {}, [s, Ie, we, Oe, se]);
}
function vT(e, t) {
  const {
    listRef: n,
    elementsRef: r,
    activeIndex: o,
    onMatch: s,
    onTyping: i,
    enabled: a = !0,
    resetMs: c = 750,
    selectedIndex: l = null
  } = t, u = "rootStore" in e ? e.rootStore : e, d = u.useState("open"), f = ln(), h = b.useRef(""), p = b.useRef(l ?? o ?? -1), g = b.useRef(null), m = Se((w) => {
    function C(I) {
      const O = r == null ? void 0 : r.current[I];
      return !O || kl(O);
    }
    function x(I, O, A = 0) {
      if (I.length === 0)
        return -1;
      const R = (A % I.length + I.length) % I.length, N = O.toLocaleLowerCase();
      for (let $ = 0; $ < I.length; $ += 1) {
        const F = (R + $) % I.length, V = I[F];
        if (!(!(V != null && V.toLocaleLowerCase().startsWith(N)) || !C(F)))
          return F;
      }
      return -1;
    }
    const E = n.current;
    if (h.current.length > 0 && w.key === " " && (kn(w), i == null || i(!0)), h.current.length > 0 && h.current[0] !== " " && x(E, h.current) === -1 && w.key !== " " && (i == null || i(!1)), E == null || // Character key.
    w.key.length !== 1 || // Modifier key.
    w.ctrlKey || w.metaKey || w.altKey)
      return;
    d && w.key !== " " && (kn(w), i == null || i(!0));
    const S = h.current === "";
    S && (p.current = l ?? o ?? -1), E.every((I) => {
      var O, A;
      return I ? ((O = I[0]) == null ? void 0 : O.toLocaleLowerCase()) !== ((A = I[1]) == null ? void 0 : A.toLocaleLowerCase()) : !0;
    }) && h.current === w.key && (h.current = "", p.current = g.current), h.current += w.key, f.start(c, () => {
      h.current = "", p.current = g.current, i == null || i(!1);
    });
    const P = ((S ? l ?? o ?? -1 : p.current) ?? 0) + 1, k = x(E, h.current, P);
    k !== -1 ? (s == null || s(k), g.current = k) : w.key !== " " && (h.current = "", i == null || i(!1));
  }), y = Se((w) => {
    const C = w.relatedTarget, x = u.select("domReferenceElement"), E = u.select("floatingElement");
    Re(x, C) || Re(E, C) || (f.clear(), h.current = "", p.current = g.current, i == null || i(!1));
  });
  be(() => {
    !d && l !== null || (f.clear(), g.current = null, h.current !== "" && (h.current = ""));
  }, [d, l, f]), be(() => {
    d && h.current === "" && (p.current = l ?? o ?? -1);
  }, [d, l, o]);
  const v = b.useMemo(() => ({
    onKeyDown: m,
    onBlur: y
  }), [m, y]);
  return b.useMemo(() => a ? {
    reference: v,
    floating: v
  } : {}, [a, v]);
}
const Ug = 0.1, yT = Ug * Ug, xt = 0.5;
function Ta(e, t, n, r, o, s) {
  return r >= t != s >= t && e <= (o - n) * (t - r) / (s - r) + n;
}
function ka(e, t, n, r, o, s, i, a, c, l) {
  let u = !1;
  return Ta(e, t, n, r, o, s) && (u = !u), Ta(e, t, o, s, i, a) && (u = !u), Ta(e, t, i, a, c, l) && (u = !u), Ta(e, t, c, l, n, r) && (u = !u), u;
}
function wT(e, t, n) {
  return e >= n.x && e <= n.x + n.width && t >= n.y && t <= n.y + n.height;
}
function Pa(e, t, n, r, o, s) {
  const i = Math.min(n, o), a = Math.max(n, o), c = Math.min(r, s), l = Math.max(r, s);
  return e >= i && e <= a && t >= c && t <= l;
}
function jl(e = {}) {
  const {
    blockPointerEvents: t = !1
  } = e, n = new xn(), r = ({
    x: o,
    y: s,
    placement: i,
    elements: a,
    onClose: c,
    nodeId: l,
    tree: u
  }) => {
    const d = i == null ? void 0 : i.split("-")[0];
    let f = !1, h = null, p = null, g = typeof performance < "u" ? performance.now() : 0;
    function m(v, w) {
      const C = performance.now(), x = C - g;
      if (h === null || p === null || x === 0)
        return h = v, p = w, g = C, !1;
      const E = v - h, S = w - p, M = E * E + S * S, T = x * x * yT;
      return h = v, p = w, g = C, M < T;
    }
    function y() {
      n.clear(), c();
    }
    return function(w) {
      n.clear();
      const C = a.domReference, x = a.floating;
      if (!C || !x || d == null || o == null || s == null)
        return;
      const {
        clientX: E,
        clientY: S
      } = w, M = Dt(w), T = w.type === "mouseleave", P = Re(x, M), k = Re(C, M);
      if (P && (f = !0, !T))
        return;
      if (k && (f = !1, !T)) {
        f = !0;
        return;
      }
      if (T && Ge(w.relatedTarget) && Re(x, w.relatedTarget))
        return;
      function I() {
        return !!(u && fo(u.nodesRef.current, l).length > 0);
      }
      function O() {
        I() || y();
      }
      if (I())
        return;
      const A = C.getBoundingClientRect(), R = x.getBoundingClientRect(), N = o > R.right - R.width / 2, $ = s > R.bottom - R.height / 2, F = R.width > A.width, V = R.height > A.height, D = (F ? A : R).left, H = (F ? A : R).right, j = (V ? A : R).top, U = (V ? A : R).bottom;
      if (d === "top" && s >= A.bottom - 1 || d === "bottom" && s <= A.top + 1 || d === "left" && o >= A.right - 1 || d === "right" && o <= A.left + 1) {
        O();
        return;
      }
      let K = !1;
      switch (d) {
        case "top":
          K = Pa(E, S, D, A.top + 1, H, R.bottom - 1);
          break;
        case "bottom":
          K = Pa(E, S, D, R.top + 1, H, A.bottom - 1);
          break;
        case "left":
          K = Pa(E, S, R.right - 1, U, A.left + 1, j);
          break;
        case "right":
          K = Pa(E, S, A.right - 1, U, R.left + 1, j);
          break;
      }
      if (K)
        return;
      if (f && !wT(E, S, A)) {
        O();
        return;
      }
      if (!T && m(E, S)) {
        O();
        return;
      }
      let G = !1;
      switch (d) {
        case "top": {
          const B = F ? xt / 2 : xt * 4, z = F || N ? o + B : o - B, W = F ? o - B : N ? o + B : o - B, X = s + xt + 1, J = N || F ? R.bottom - xt : R.top, Q = N ? F ? R.bottom - xt : R.top : R.bottom - xt;
          G = ka(E, S, z, X, W, X, R.left, J, R.right, Q);
          break;
        }
        case "bottom": {
          const B = F ? xt / 2 : xt * 4, z = F || N ? o + B : o - B, W = F ? o - B : N ? o + B : o - B, X = s - xt, J = N || F ? R.top + xt : R.bottom, Q = N ? F ? R.top + xt : R.bottom : R.top + xt;
          G = ka(E, S, z, X, W, X, R.left, J, R.right, Q);
          break;
        }
        case "left": {
          const B = V ? xt / 2 : xt * 4, z = V || $ ? s + B : s - B, W = V ? s - B : $ ? s + B : s - B, X = o + xt + 1, J = $ || V ? R.right - xt : R.left, Q = $ ? V ? R.right - xt : R.left : R.right - xt;
          G = ka(E, S, J, R.top, Q, R.bottom, X, z, X, W);
          break;
        }
        case "right": {
          const B = V ? xt / 2 : xt * 4, z = V || $ ? s + B : s - B, W = V ? s - B : $ ? s + B : s - B, X = o - xt, J = $ || V ? R.left + xt : R.right, Q = $ ? V ? R.left + xt : R.right : R.left + xt;
          G = ka(E, S, X, z, X, W, J, R.top, Q, R.bottom);
          break;
        }
      }
      G ? f || n.start(40, O) : O();
    };
  };
  return r.__options = {
    ...e,
    blockPointerEvents: t
  }, r;
}
const xT = {
  ...Hl,
  disabled: ge((e) => e.disabled),
  instantType: ge((e) => e.instantType),
  isInstantPhase: ge((e) => e.isInstantPhase),
  trackCursorAxis: ge((e) => e.trackCursorAxis),
  disableHoverablePopup: ge((e) => e.disableHoverablePopup),
  lastOpenChangeReason: ge((e) => e.openChangeReason),
  closeOnClick: ge((e) => e.closeOnClick),
  closeDelay: ge((e) => e.closeDelay),
  hasViewport: ge((e) => e.hasViewport)
};
class ah extends Ns {
  constructor(n, r, o = !1) {
    const s = new $s(), i = {
      ...CT(),
      ...n
    };
    i.floatingRootContext = nh(s, r, o);
    super(i, {
      popupRef: /* @__PURE__ */ b.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: s
    }, xT);
    ae(this, "setOpen", (n, r) => {
      var l, u;
      const o = r.reason, s = o === Pt, i = n && o === hs, a = !n && (o === br || o === Ji);
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, (u = (l = this.context).onOpenChange) == null || u.call(l, n, r), r.isCanceled)
        return;
      this.state.floatingRootContext.dispatchOpenChange(n, r);
      const c = () => {
        const d = {
          open: n,
          openChangeReason: o
        };
        i ? d.instantType = "focus" : a ? d.instantType = "dismiss" : o === Pt && (d.instantType = void 0), th(d, n, r.trigger), this.update(d);
      };
      s ? Yn.flushSync(c) : c();
    });
  }
  // Used by trigger clicks to clear a delayed hover open without reporting a public open-state change.
  cancelPendingOpen(n) {
    this.state.floatingRootContext.dispatchOpenChange(!1, Ve(br, n));
  }
  static useStore(n, r) {
    return eh(n, (s, i) => new ah(r, s, i)).store;
  }
}
function CT() {
  return {
    ...Bl(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const by = If(function(t) {
  const {
    disabled: n = !1,
    defaultOpen: r = !1,
    open: o,
    disableHoverablePopup: s = !1,
    trackCursorAxis: i = "none",
    actionsRef: a,
    onOpenChange: c,
    onOpenChangeComplete: l,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: h
  } = t, p = ah.useStore(u == null ? void 0 : u.store, {
    open: r,
    openProp: o,
    activeTriggerId: f,
    triggerIdProp: d
  });
  yl(() => {
    o === void 0 && p.state.open === !1 && r === !0 && p.update({
      open: !0,
      activeTriggerId: f
    });
  }), p.useControlledProp("openProp", o), p.useControlledProp("triggerIdProp", d), p.useContextCallback("onOpenChange", c), p.useContextCallback("onOpenChangeComplete", l);
  const g = p.useState("open"), m = !n && g, y = p.useState("activeTriggerId"), v = p.useState("mounted"), w = p.useState("payload");
  p.useSyncedValues({
    trackCursorAxis: i,
    disableHoverablePopup: s
  }), p.useSyncedValue("disabled", n), Ll(p);
  const {
    forceUnmount: C,
    transitionStatus: x
  } = Vl(m, p), E = p.useState("isInstantPhase"), S = p.useState("instantType"), M = p.useState("lastOpenChangeReason"), T = b.useRef(null);
  be(() => {
    g && n && p.setOpen(!1, Ve(I0));
  }, [g, n, p]), be(() => {
    x === "ending" && M === xs || x !== "ending" && E ? (S !== "delay" && (T.current = S), p.set("instantType", "delay")) : T.current !== null && (p.set("instantType", T.current), T.current = null);
  }, [x, E, M, S, p]), be(() => {
    m && y == null && p.set("payload", void 0);
  }, [p, y, m]);
  const P = b.useCallback(() => {
    p.setOpen(!1, Ve(Ml));
  }, [p]);
  b.useImperativeHandle(a, () => ({
    unmount: C,
    close: P
  }), [C, P]);
  const k = m || v || !n && i !== "none";
  return /* @__PURE__ */ Z(Df.Provider, {
    value: p,
    children: [k && /* @__PURE__ */ _(ET, {
      store: p,
      disabled: n,
      trackCursorAxis: i
    }), typeof h == "function" ? h({
      payload: w
    }) : h]
  });
});
process.env.NODE_ENV !== "production" && (by.displayName = "TooltipRoot");
function ET({
  store: e,
  disabled: t,
  trackCursorAxis: n
}) {
  const r = e.useState("floatingRootContext"), o = Il(r, {
    enabled: !t,
    referencePress: () => e.select("closeOnClick")
  }), s = oM(r, {
    enabled: !t && n !== "none",
    axis: n === "none" ? void 0 : n
  }), i = b.useMemo(() => Zt(s.reference, o.reference), [s.reference, o.reference]), a = b.useMemo(() => Zt(s.trigger, o.trigger), [s.trigger, o.trigger]), c = b.useMemo(() => Zt(As, s.floating, o.floating), [s.floating, o.floating]);
  return Wl(e, {
    activeTriggerProps: i,
    inactiveTriggerProps: a,
    popupProps: c
  }), null;
}
let Qn = function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = Hr.startingStyle] = "startingStyle", e[e.endingStyle = Hr.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e.side = "data-side", e.align = "data-align", e;
}({}), Lc = /* @__PURE__ */ function(e) {
  return e.popupOpen = "data-popup-open", e.pressed = "data-pressed", e;
}({});
const _T = {
  [Lc.popupOpen]: ""
}, ST = {
  [Lc.popupOpen]: "",
  [Lc.pressed]: ""
}, OT = {
  [Qn.open]: ""
}, MT = {
  [Qn.closed]: ""
}, TT = {
  [Qn.anchorHidden]: ""
}, Ul = {
  open(e) {
    return e ? _T : null;
  }
}, zd = {
  open(e) {
    return e ? ST : null;
  }
}, qr = {
  open(e) {
    return e ? OT : MT;
  },
  anchorHidden(e) {
    return e ? TT : null;
  }
};
function nn(e) {
  return Br(e, "base-ui");
}
const ch = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (ch.displayName = "TooltipProviderContext");
function kT() {
  return b.useContext(ch);
}
let PT = function(e) {
  return e[e.popupOpen = Lc.popupOpen] = "popupOpen", e.triggerDisabled = "data-trigger-disabled", e;
}({});
const RT = 600, vy = "data-base-ui-tooltip-trigger";
function Gg(e) {
  if ("composedPath" in e) {
    const n = e.composedPath();
    for (let r = 0; r < n.length; r += 1) {
      const o = n[r];
      if (Ge(o))
        return o;
    }
  }
  const t = e.target;
  return Ge(t) ? t : null;
}
function IT(e) {
  let t = e;
  for (; t; ) {
    if (t.hasAttribute(vy))
      return t;
    const n = t.parentElement;
    if (n) {
      t = n;
      continue;
    }
    const r = t.getRootNode();
    t = "host" in r && Ge(r.host) ? r.host : null;
  }
  return null;
}
const yy = v0(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    handle: i,
    payload: a,
    disabled: c,
    delay: l,
    closeOnClick: u = !0,
    closeDelay: d,
    id: f,
    ...h
  } = t, p = Zi(!0), g = (i == null ? void 0 : i.store) ?? p;
  if (!g)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : rt(82));
  const m = nn(f), y = g.useState("isTriggerActive", m), v = g.useState("isOpenedByTrigger", m), w = g.useState("floatingRootContext"), C = b.useRef(null), x = l ?? RT, E = d ?? 0, {
    registerTrigger: S,
    isMountedByThisTrigger: M
  } = Fl(m, C, g, {
    payload: a,
    closeOnClick: u,
    closeDelay: E
  }), T = kT(), {
    delayRef: P,
    isInstantPhase: k,
    hasProvider: I
  } = bO(w, {
    open: v
  }), O = sh(w);
  g.useSyncedValue("isInstantPhase", k);
  const A = g.useState("disabled"), R = c ?? A, N = Yt(R), $ = g.useState("trackCursorAxis"), F = g.useState("disableHoverablePopup"), V = b.useRef(!1), D = ln(), H = b.useRef(void 0);
  function j() {
    const Y = T == null ? void 0 : T.delay, ce = typeof P.current == "object" ? P.current.open : void 0;
    let ee = x;
    return I && (ce !== 0 ? ee = l ?? Y ?? x : ee = 0), ee;
  }
  function U(Y) {
    const ce = C.current;
    if (!ce || !Y)
      return !1;
    const ee = IT(Y);
    return ee !== null && ee !== ce && Re(ce, ee);
  }
  function K(Y) {
    const ce = U(Y);
    return V.current = ce, ce && (O.openChangeTimeout.clear(), O.restTimeout.clear(), O.restTimeoutPending = !1, D.clear()), ce;
  }
  const G = Yl(w, {
    enabled: !R,
    mouseOnly: !0,
    move: !1,
    handleClose: !F && $ !== "both" ? jl() : null,
    restMs: j,
    delay() {
      const Y = typeof P.current == "object" ? P.current.close : void 0;
      let ce = E;
      return d == null && I && (ce = Y), {
        close: ce
      };
    },
    triggerElementRef: C,
    isActiveTrigger: y,
    isClosing: () => g.select("transitionStatus") === "ending",
    shouldOpen() {
      return !V.current;
    }
  }), B = gy(w, {
    enabled: !R
  }).reference, z = (Y) => {
    const ce = V.current, ee = Gg(Y), ne = K(ee), de = C.current, pe = de && ee && Re(de, ee);
    if (ne && g.select("open") && g.select("lastOpenChangeReason") === Pt) {
      g.setOpen(!1, Ve(Pt, Y));
      return;
    }
    if (ce && !ne && pe && !N.current && !g.select("open") && de && // Match the hover hook's non-strict mouse fallback for mouse-only event sequences.
    Bo(H.current)) {
      const Ee = () => {
        !V.current && !N.current && !g.select("open") && g.setOpen(!0, Ve(Pt, Y, de));
      }, se = j();
      se === 0 ? (D.clear(), Ee()) : D.start(se, Ee);
    }
  }, W = g.useState("triggerProps", M);
  return $e("button", t, {
    state: {
      open: v
    },
    ref: [n, S, C],
    props: [G, B, M || $ !== "none" ? W : void 0, {
      onMouseOver(Y) {
        z(Y.nativeEvent);
      },
      onFocus(Y) {
        U(Gg(Y.nativeEvent)) && Y.preventBaseUIHandler();
      },
      onMouseLeave() {
        V.current = !1, D.clear(), H.current = void 0;
      },
      onPointerEnter(Y) {
        H.current = Y.pointerType;
      },
      onPointerDown(Y) {
        H.current = Y.pointerType, g.set("closeOnClick", u), u && !g.select("open") && g.cancelPendingOpen(Y.nativeEvent);
      },
      onClick(Y) {
        u && !g.select("open") && g.cancelPendingOpen(Y.nativeEvent);
      },
      id: m,
      [PT.triggerDisabled]: R ? "" : void 0,
      [vy]: R ? void 0 : ""
    }, h],
    stateAttributesMapping: Ul
  });
});
process.env.NODE_ENV !== "production" && (yy.displayName = "TooltipTrigger");
const lh = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (lh.displayName = "TooltipPortalContext");
function DT() {
  const e = b.useContext(lh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : rt(70));
  return e;
}
const uh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    className: s,
    render: i,
    style: a,
    ...c
  } = t, {
    portalNode: l,
    portalSubtree: u
  } = Q0({
    container: o,
    ref: n,
    componentProps: t,
    elementProps: c
  });
  return !u && !l ? null : /* @__PURE__ */ Z(b.Fragment, {
    children: [u, l && /* @__PURE__ */ Yn.createPortal(r, l)]
  });
});
process.env.NODE_ENV !== "production" && (uh.displayName = "FloatingPortalLite");
const wy = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t;
  return Zi().useState("mounted") || r ? /* @__PURE__ */ _(lh.Provider, {
    value: r,
    children: /* @__PURE__ */ _(uh, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (wy.displayName = "TooltipPortal");
const dh = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (dh.displayName = "TooltipPositionerContext");
function xy() {
  const e = b.useContext(dh);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : rt(71));
  return e;
}
const Cy = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cy.displayName = "DirectionContext");
function fh() {
  const e = b.useContext(Cy);
  return (e == null ? void 0 : e.direction) ?? "ltr";
}
const NT = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    var V, D;
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0,
      offsetParent: d = "real"
    } = Wr(e, t) || {};
    if (l == null)
      return {};
    const f = N0(u), h = {
      x: n,
      y: r
    }, p = Bf(o), g = Wf(p), m = await i.getDimensions(l), y = p === "y", v = y ? "top" : "left", w = y ? "bottom" : "right", C = y ? "clientHeight" : "clientWidth", x = s.reference[g] + s.reference[p] - h[p] - s.floating[g], E = h[p] - s.reference[p], S = d === "real" ? await ((V = i.getOffsetParent) == null ? void 0 : V.call(i, l)) : a.floating;
    let M = a.floating[C] || s.floating[g];
    (!M || !await ((D = i.isElement) == null ? void 0 : D.call(i, S))) && (M = a.floating[C] || s.floating[g]);
    const T = x / 2 - E / 2, P = M / 2 - m[g] / 2 - 1, k = Math.min(f[v], P), I = Math.min(f[w], P), O = k, A = M - m[g] - I, R = M / 2 - m[g] / 2 + T, N = Fd(O, R, A), $ = !c.arrow && bo(o) != null && R !== N && s.reference[g] / 2 - (R < O ? k : I) - m[g] / 2 < 0, F = $ ? R < O ? R - O : R - A : 0;
    return {
      [p]: h[p] + F,
      data: {
        [p]: N,
        centerOffset: R - N - F,
        ...$ && {
          alignmentOffset: F
        }
      },
      reset: $
    };
  }
}), AT = (e, t) => ({
  ...NT(e),
  options: [e, t]
}), $T = {
  name: "hide",
  async fn(e) {
    var a;
    const {
      width: t,
      height: n,
      x: r,
      y: o
    } = e.rects.reference, s = t === 0 && n === 0 && r === 0 && o === 0;
    return {
      data: {
        referenceHidden: ((a = (await KM().fn(e)).data) == null ? void 0 : a.referenceHidden) || s
      }
    };
  }
}, fc = {
  sideX: "left",
  sideY: "top"
}, hh = {
  name: "adaptiveOrigin",
  async fn(e) {
    var v, w;
    const {
      x: t,
      y: n,
      rects: {
        floating: r
      },
      elements: {
        floating: o
      },
      platform: s,
      strategy: i,
      placement: a
    } = e, c = Ot(o), l = c.getComputedStyle(o);
    if (!(l.transitionDuration !== "0s" && l.transitionDuration !== ""))
      return {
        x: t,
        y: n,
        data: fc
      };
    const d = await ((v = s.getOffsetParent) == null ? void 0 : v.call(s, o));
    let f = {
      width: 0,
      height: 0
    };
    if (i === "fixed" && (c != null && c.visualViewport))
      f = {
        width: c.visualViewport.width,
        height: c.visualViewport.height
      };
    else if (d === c) {
      const C = Ye(o);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else
      await ((w = s.isElement) == null ? void 0 : w.call(s, d)) && (f = await s.getDimensions(d));
    const h = wn(a);
    let p = t, g = n;
    h === "left" && (p = f.width - (t + r.width)), h === "top" && (g = f.height - (n + r.height));
    const m = h === "left" ? "right" : fc.sideX, y = h === "top" ? "bottom" : fc.sideY;
    return {
      x: p,
      y: g,
      data: {
        sideX: m,
        sideY: y
      }
    };
  }
};
function Ey(e, t, n) {
  const r = e === "inline-start" || e === "inline-end";
  return {
    top: "top",
    right: r ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: r ? n ? "inline-end" : "inline-start" : "left"
  }[t];
}
function Kg(e, t, n) {
  const {
    rects: r,
    placement: o
  } = e;
  return {
    side: Ey(t, wn(o), n),
    align: bo(o) || "center",
    anchor: {
      width: r.reference.width,
      height: r.reference.height
    },
    positioner: {
      width: r.floating.width,
      height: r.floating.height
    }
  };
}
function ph(e) {
  var fn, $n;
  const {
    // Public parameters
    anchor: t,
    positionMethod: n = "absolute",
    side: r = "bottom",
    sideOffset: o = 0,
    align: s = "center",
    alignOffset: i = 0,
    collisionBoundary: a,
    collisionPadding: c = 5,
    sticky: l = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    inline: f,
    // Private parameters
    keepMounted: h = !1,
    floatingRootContext: p,
    mounted: g,
    collisionAvoidance: m,
    shiftCrossAxis: y = !1,
    nodeId: v,
    adaptiveOrigin: w,
    lazyFlip: C = !1,
    externalTree: x
  } = e, [E, S] = b.useState(null);
  !g && E !== null && S(null);
  const M = m.side || "flip", T = m.align || "flip", P = m.fallbackAxisSide || "end", k = typeof t == "function" ? t : void 0, I = Se(k), O = k ? I : t, A = Yt(t), R = Yt(g), $ = fh() === "rtl", F = E || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": $ ? "left" : "right",
    "inline-start": $ ? "right" : "left"
  }[r], V = s === "center" ? F : `${F}-${s}`;
  let D = c;
  const H = 1, j = r === "bottom" ? H : 0, U = r === "top" ? H : 0, K = r === "right" ? H : 0, G = r === "left" ? H : 0;
  typeof D == "number" ? D = {
    top: D + j,
    right: D + G,
    bottom: D + U,
    left: D + K
  } : D && (D = {
    top: (D.top || 0) + j,
    right: (D.right || 0) + G,
    bottom: (D.bottom || 0) + U,
    left: (D.left || 0) + K
  });
  const B = {
    boundary: a === "clipping-ancestors" ? "clippingAncestors" : a,
    padding: D
  }, z = b.useRef(null), W = Yt(o), X = Yt(i), J = typeof o != "function" ? o : 0, Q = typeof i != "function" ? i : 0, Y = [];
  f && Y.push(f), Y.push(YM((me) => {
    const De = Kg(me, r, $), Ne = typeof W.current == "function" ? W.current(De) : W.current, Qe = typeof X.current == "function" ? X.current(De) : X.current;
    return {
      mainAxis: Ne,
      crossAxis: Qe,
      alignmentAxis: Qe
    };
  }, [J, Q, $, r]));
  const ce = T === "none" && M !== "shift", ee = !ce && (l || y || M === "shift"), ne = M === "none" ? null : UM({
    ...B,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: D.top + H,
      right: D.right + H,
      bottom: D.bottom + H,
      left: D.left + H
    },
    mainAxis: !y && M === "flip",
    crossAxis: T === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: P
  }), de = ce ? null : zM((me) => {
    const De = Ye(me.elements.floating).documentElement;
    return {
      ...B,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: y ? {
        x: 0,
        y: 0,
        width: De.clientWidth,
        height: De.clientHeight
      } : void 0,
      mainAxis: T !== "none",
      crossAxis: ee,
      limiter: l || y ? void 0 : jM((Ne) => {
        if (!z.current)
          return {};
        const {
          width: Qe,
          height: Be
        } = z.current.getBoundingClientRect(), Mt = Bn(wn(Ne.placement)), ze = Mt === "y" ? Qe : Be, Kn = Mt === "y" ? D.left + D.right : D.top + D.bottom;
        return {
          offset: ze / 2 + Kn / 2
        };
      })
    };
  }, [B, l, y, D, T]);
  M === "shift" || T === "shift" || s === "center" ? Y.push(de, ne) : Y.push(ne, de), Y.push(GM({
    ...B,
    apply({
      elements: {
        floating: me
      },
      availableWidth: De,
      availableHeight: Ne,
      rects: Qe
    }) {
      if (!R.current)
        return;
      const Be = me.style;
      Be.setProperty("--available-width", `${De}px`), Be.setProperty("--available-height", `${Ne}px`);
      const Mt = Ot(me).devicePixelRatio || 1, {
        x: ze,
        y: Kn,
        width: Sn,
        height: Eo
      } = Qe.reference, Sr = (Math.round((ze + Sn) * Mt) - Math.round(ze * Mt)) / Mt, tr = (Math.round((Kn + Eo) * Mt) - Math.round(Kn * Mt)) / Mt;
      Be.setProperty("--anchor-width", `${Sr}px`), Be.setProperty("--anchor-height", `${tr}px`);
    }
  }), AT((me) => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: z.current || Ye(me.elements.floating).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(me) {
      var ft, Je, Xe;
      const {
        elements: De,
        middlewareData: Ne,
        placement: Qe,
        rects: Be,
        y: Mt
      } = me, ze = wn(Qe), Kn = Bn(ze), Sn = z.current, Eo = ((ft = Ne.arrow) == null ? void 0 : ft.x) || 0, Sr = ((Je = Ne.arrow) == null ? void 0 : Je.y) || 0, tr = (Sn == null ? void 0 : Sn.clientWidth) || 0, wu = (Sn == null ? void 0 : Sn.clientHeight) || 0, Bs = Eo + tr / 2, xa = Sr + wu / 2, xu = Math.abs(((Xe = Ne.shift) == null ? void 0 : Xe.y) || 0), L = Be.reference.height / 2, ue = typeof o == "function" ? o(Kg(me, r, $)) : o, ye = xu > ue, Fe = {
        top: `${Bs}px calc(100% + ${ue}px)`,
        bottom: `${Bs}px ${-ue}px`,
        left: `calc(100% + ${ue}px) ${xa}px`,
        right: `${-ue}px ${xa}px`
      }[ze], it = `${Bs}px ${Be.reference.y + L - Mt}px`;
      return De.floating.style.setProperty("--transform-origin", ee && Kn === "y" && ye ? it : Fe), {};
    }
  }, $T, w), be(() => {
    !g && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [g, p]);
  const pe = b.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: Ee,
    elements: se,
    x: ke,
    y: we,
    middlewareData: Oe,
    update: Ie,
    placement: fe,
    context: q,
    isPositioned: te,
    floatingStyles: oe
  } = fT({
    rootContext: p,
    open: h ? g : void 0,
    placement: V,
    middleware: Y,
    strategy: n,
    whileElementsMounted: h ? void 0 : (...me) => Vg(...me, pe),
    nodeId: v,
    externalTree: x
  }), {
    sideX: re,
    sideY: ve
  } = Oe.adaptiveOrigin || fc, xe = te ? n : "fixed", Me = b.useMemo(() => {
    const me = w ? {
      position: xe,
      [re]: ke,
      [ve]: we
    } : {
      position: xe,
      ...oe
    };
    return te || (me.opacity = 0), me;
  }, [w, xe, re, ke, ve, we, oe, te]), qe = b.useRef(null);
  be(() => {
    if (!g)
      return;
    const me = A.current, De = typeof me == "function" ? me() : me, Qe = (qg(De) ? De.current : De) || null || null;
    Qe !== qe.current && (Ee.setPositionReference(Qe), qe.current = Qe);
  }, [g, Ee, O, A]), b.useEffect(() => {
    if (!g)
      return;
    const me = A.current;
    typeof me != "function" && qg(me) && me.current !== qe.current && (Ee.setPositionReference(me.current), qe.current = me.current);
  }, [g, Ee, O, A]), b.useEffect(() => {
    if (h && g && se.domReference && se.floating)
      return Vg(se.domReference, se.floating, Ie, pe);
  }, [h, g, se, Ie, pe]);
  const Ze = wn(fe), nt = Ey(r, Ze, $), Kt = bo(fe) || "center", dn = !!((fn = Oe.hide) != null && fn.referenceHidden);
  be(() => {
    C && g && te && S(Ze);
  }, [C, g, te, Ze]);
  const rn = b.useMemo(() => {
    var me, De;
    return {
      position: "absolute",
      top: (me = Oe.arrow) == null ? void 0 : me.y,
      left: (De = Oe.arrow) == null ? void 0 : De.x
    };
  }, [Oe.arrow]), _n = (($n = Oe.arrow) == null ? void 0 : $n.centerOffset) !== 0;
  return b.useMemo(() => ({
    positionerStyles: Me,
    arrowStyles: rn,
    arrowRef: z,
    arrowUncentered: _n,
    side: nt,
    align: Kt,
    physicalSide: Ze,
    anchorHidden: dn,
    refs: Ee,
    context: q,
    isPositioned: te,
    update: Ie
  }), [Me, rn, z, _n, nt, Kt, Ze, dn, Ee, q, te, Ie]);
}
function qg(e) {
  return e != null && "current" in e;
}
function Gl(e) {
  return e === "starting" ? UO : wt;
}
function gh(e, t, {
  styles: n,
  transitionStatus: r,
  props: o,
  refs: s,
  hidden: i,
  inert: a = !1
}) {
  const c = {
    ...n
  };
  return a && (c.pointerEvents = "none"), $e("div", e, {
    state: t,
    ref: s,
    props: [{
      role: "presentation",
      hidden: i,
      style: c
    }, Gl(r), o],
    stateAttributesMapping: qr
  });
}
const _y = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    anchor: s,
    positionMethod: i = "absolute",
    side: a = "top",
    align: c = "center",
    sideOffset: l = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: m = jf,
    style: y,
    ...v
  } = t, w = Zi(), C = DT(), x = w.useState("open"), E = w.useState("mounted"), S = w.useState("trackCursorAxis"), M = w.useState("disableHoverablePopup"), T = w.useState("floatingRootContext"), P = w.useState("instantType"), k = w.useState("transitionStatus"), I = w.useState("hasViewport"), O = ph({
    anchor: s,
    positionMethod: i,
    floatingRootContext: T,
    mounted: E,
    side: a,
    sideOffset: l,
    align: c,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    arrowPadding: h,
    disableAnchorTracking: g,
    keepMounted: C,
    collisionAvoidance: m,
    adaptiveOrigin: I ? hh : void 0
  }), A = b.useMemo(() => ({
    open: x,
    side: O.side,
    align: O.align,
    anchorHidden: O.anchorHidden,
    instant: S !== "none" ? "tracking-cursor" : P
  }), [x, O.side, O.align, O.anchorHidden, S, P]), R = gh(t, A, {
    styles: O.positionerStyles,
    transitionStatus: k,
    props: v,
    refs: [n, w.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !x || S === "both" || M
  });
  return /* @__PURE__ */ _(dh.Provider, {
    value: O,
    children: R
  });
});
process.env.NODE_ENV !== "production" && (_y.displayName = "TooltipPositioner");
const FT = {
  ...qr,
  ...Un
}, Sy = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = Zi(), {
    side: c,
    align: l
  } = xy(), u = a.useState("open"), d = a.useState("instantType"), f = a.useState("transitionStatus"), h = a.useState("popupProps"), p = a.useState("floatingRootContext"), g = a.useState("disabled"), m = a.useState("closeDelay");
  xr({
    open: u,
    ref: a.context.popupRef,
    onComplete() {
      var C, x;
      u && ((x = (C = a.context).onOpenChangeComplete) == null || x.call(C, !0));
    }
  }), ih(p, {
    enabled: !g,
    closeDelay: m
  });
  const y = a.useStateSetter("popupElement");
  return $e("div", t, {
    state: {
      open: u,
      side: c,
      align: l,
      instant: d,
      transitionStatus: f
    },
    ref: [n, a.context.popupRef, y],
    props: [h, Gl(f), i],
    stateAttributesMapping: FT
  });
});
process.env.NODE_ENV !== "production" && (Sy.displayName = "TooltipPopup");
const Oy = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = Zi(), {
    arrowRef: c,
    side: l,
    align: u,
    arrowUncentered: d,
    arrowStyles: f
  } = xy(), h = a.useState("open"), p = a.useState("instantType");
  return $e("div", t, {
    state: {
      open: h,
      side: l,
      align: u,
      uncentered: d,
      instant: p
    },
    ref: [n, c],
    props: [{
      style: f,
      "aria-hidden": !0
    }, i],
    stateAttributesMapping: qr
  });
});
process.env.NODE_ENV !== "production" && (Oy.displayName = "TooltipArrow");
const My = function(t) {
  const {
    delay: n,
    closeDelay: r,
    timeout: o = 400
  } = t, s = b.useMemo(() => ({
    delay: n,
    closeDelay: r
  }), [n, r]), i = b.useMemo(() => ({
    open: n,
    close: r
  }), [n, r]);
  return /* @__PURE__ */ _(ch.Provider, {
    value: s,
    children: /* @__PURE__ */ _(mO, {
      delay: i,
      timeoutMs: o,
      children: t.children
    })
  });
};
process.env.NODE_ENV !== "production" && (My.displayName = "TooltipProvider");
function na(e) {
  return Mf(19) ? e : e ? "true" : void 0;
}
const LT = En(
  "max-w-lg origin-[--transform-origin] rounded-lg bg-clip-padding outline outline-1 -outline-offset-1 outline-[theme(borderColor.foundations-subtle)] transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 data-[instant]:duration-0",
  {
    variants: {
      variant: {
        dark: "bg-foundations-inverse text-foundations-inverse outline-transparent [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-inverse)]",
        light: "bg-foundations-default text-foundations-boldest [&_[data-slot=arrow-bg]]:fill-[theme(backgroundColor.foundations-default)] [&_[data-slot=arrow-border]]:fill-[theme(borderColor.foundations-subtle)]"
      },
      size: {
        default: "p-2 text-sm lg:p-3 lg:[&_.tooltip-arrow]:h-4 lg:[&_.tooltip-arrow]:w-8",
        sm: "px-2.5 py-1.5 text-xs"
      }
    },
    defaultVariants: {
      variant: "dark",
      size: "default"
    }
  }
), Xg = (e) => /* @__PURE__ */ _(My, { delay: 350, ...e }), VT = by, WT = b.forwardRef((e, t) => /* @__PURE__ */ _(yy, { "data-slot": "tooltip-trigger", ...e })), BT = b.forwardRef(
  ({
    side: e = "top",
    sideOffset: t = 10,
    collisionPadding: n = 4,
    collisionBoundary: r,
    align: o,
    alignOffset: s = 0,
    className: i,
    hideArrow: a = !1,
    variant: c,
    size: l,
    children: u
  }, d) => /* @__PURE__ */ _(wy, { children: /* @__PURE__ */ _(
    _y,
    {
      "data-slot": "tooltip-positioner",
      side: e,
      sideOffset: t,
      collisionPadding: n,
      align: o,
      alignOffset: s,
      collisionBoundary: r,
      className: "z-50",
      children: /* @__PURE__ */ Z(
        Sy,
        {
          "data-slot": "tooltip-content",
          ref: d,
          className: le(
            "break-words",
            LT({ variant: c, size: l }),
            i
          ),
          children: [
            u,
            !a && /* @__PURE__ */ _(
              Oy,
              {
                "data-slot": "tooltip-arrow",
                className: "z-50 data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=right]:left-[-13px] data-[side=top]:bottom-[-8px] data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180",
                children: /* @__PURE__ */ _(HT, {})
              }
            )
          ]
        }
      )
    }
  ) })
), Rt = Object.assign(VT, {
  Trigger: WT,
  Popup: BT
});
function HT(e) {
  return /* @__PURE__ */ Z("svg", { width: "20", height: "10", viewBox: "0 0 20 10", fill: "none", ...e, children: [
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-bg",
        d: "M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
      }
    ),
    /* @__PURE__ */ _(
      "path",
      {
        "data-slot": "arrow-border",
        d: "M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
      }
    )
  ] });
}
const Ty = ({
  children: e,
  render: t,
  content: n,
  hoverable: r,
  size: o,
  variant: s,
  disabled: i,
  ...a
}) => {
  const [c, l] = b.useState(null), [u, d] = b.useState(!1);
  b.useEffect(() => {
    if (!c)
      return;
    const p = () => {
      d(c.scrollWidth > c.clientWidth);
    }, g = new ResizeObserver((m) => {
      requestAnimationFrame(() => {
        for (const y of m)
          y.contentBoxSize && p();
      });
    });
    return g.observe(c), () => g.unobserve(c);
  }, [c]);
  const h = Is({
    defaultTagName: "p",
    render: t,
    ref: l,
    props: Zt({
      className: "truncate",
      "data-slot": "overflow-text"
    }, a)
  });
  return /* @__PURE__ */ Z(
    Rt,
    {
      disabled: i || !u,
      disableHoverablePopup: !r,
      children: [
        /* @__PURE__ */ _(Rt.Trigger, { render: h, children: e }),
        /* @__PURE__ */ _(Rt.Popup, { size: o, variant: s, children: n ?? (c == null ? void 0 : c.textContent) })
      ]
    }
  );
}, YT = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: le(
      "h-4 animate-pulse rounded bg-foundations-subtlest",
      e
    ),
    ...t
  }
));
YT.displayName = "Skeleton";
const mh = /* @__PURE__ */ b.createContext(!1);
process.env.NODE_ENV !== "production" && (mh.displayName = "IsDrawerContext");
const bh = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (bh.displayName = "DialogRootContext");
function Xr(e) {
  const t = b.useContext(bh);
  if (e === !1 && t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : rt(27));
  return t;
}
const zT = {
  ...qr,
  ...Un
}, vh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    forceRender: i = !1,
    ...a
  } = t, {
    store: c
  } = Xr(), l = c.useState("open"), u = c.useState("nested"), d = c.useState("mounted"), f = c.useState("transitionStatus");
  return $e("div", t, {
    state: {
      open: l,
      transitionStatus: f
    },
    ref: [c.context.backdropRef, n],
    stateAttributesMapping: zT,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, a],
    enabled: i || !u
  });
});
process.env.NODE_ENV !== "production" && (vh.displayName = "DialogBackdrop");
let jd;
process.env.NODE_ENV !== "production" && (jd = /* @__PURE__ */ new Set());
function Vc(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    jd.has(t) || (jd.add(t), console.error(`Base UI: ${t}`));
  }
}
const yh = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (yh.displayName = "CompositeRootContext");
function wh(e = !1) {
  const t = b.useContext(yh);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : rt(16));
  return t;
}
function jT(e) {
  const {
    focusableWhenDisabled: t,
    disabled: n,
    composite: r = !1,
    tabIndex: o = 0,
    isNativeButton: s
  } = e, i = r && t !== !1, a = r && t === !1;
  return {
    props: b.useMemo(() => {
      const l = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && t && u.key !== "Tab" && u.preventDefault();
        }
      };
      return r || (l.tabIndex = o, !s && n && (l.tabIndex = t ? o : -1)), (s && (t || i) || !s && n) && (l["aria-disabled"] = n), s && (!t || a) && (l.disabled = n), l;
    }, [r, n, t, i, a, s, o])
  };
}
function Cr(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: n,
    tabIndex: r = 0,
    native: o = !0,
    composite: s
  } = e, i = b.useRef(null), a = wh(!0), c = s ?? a !== void 0, {
    props: l
  } = jT({
    focusableWhenDisabled: n,
    disabled: t,
    composite: c,
    tabIndex: r,
    isNativeButton: o
  });
  process.env.NODE_ENV !== "production" && b.useEffect(() => {
    var p, g;
    if (!i.current)
      return;
    const h = Ra(i.current);
    if (o) {
      if (!h) {
        const m = ((p = Wn.captureOwnerStack) == null ? void 0 : p.call(Wn)) || "";
        Vc(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${m}`);
      }
    } else if (h) {
      const m = ((g = Wn.captureOwnerStack) == null ? void 0 : g.call(Wn)) || "";
      Vc(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${m}`);
    }
  }, [o]);
  const u = b.useCallback(() => {
    const h = i.current;
    Ra(h) && c && t && l.disabled === void 0 && h.disabled && (h.disabled = !1);
  }, [t, l.disabled, c]);
  be(u, [u]);
  const d = b.useCallback((h = {}) => {
    const {
      onClick: p,
      onMouseDown: g,
      onKeyUp: m,
      onKeyDown: y,
      onPointerDown: v,
      ...w
    } = h;
    return Zt({
      onClick(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        p == null || p(C);
      },
      onMouseDown(C) {
        t || g == null || g(C);
      },
      onKeyDown(C) {
        if (t || (Mc(C), y == null || y(C), C.baseUIHandlerPrevented))
          return;
        const x = C.target === C.currentTarget, E = C.currentTarget, S = Ra(E), M = !o && UT(E), T = x && (o ? S : !M), P = C.key === "Enter", k = C.key === " ", I = E.getAttribute("role"), O = (I == null ? void 0 : I.startsWith("menuitem")) || I === "option" || I === "gridcell";
        if (x && c && k) {
          if (C.defaultPrevented && O)
            return;
          C.preventDefault(), M || o && S ? (E.click(), C.preventBaseUIHandler()) : T && (p == null || p(C), C.preventBaseUIHandler());
          return;
        }
        T && (!o && (k || P) && C.preventDefault(), !o && P && (p == null || p(C)));
      },
      onKeyUp(C) {
        if (!t) {
          if (Mc(C), m == null || m(C), C.target === C.currentTarget && o && c && Ra(C.currentTarget) && C.key === " ") {
            C.preventDefault();
            return;
          }
          C.baseUIHandlerPrevented || C.target === C.currentTarget && !o && !c && C.key === " " && (p == null || p(C));
        }
      },
      onPointerDown(C) {
        if (t) {
          C.preventDefault();
          return;
        }
        v == null || v(C);
      }
    }, o ? {
      type: "button"
    } : {
      role: "button"
    }, l, w);
  }, [t, l, c, o]), f = Se((h) => {
    i.current = h, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function Ra(e) {
  return vt(e) && e.tagName === "BUTTON";
}
function UT(e) {
  return !!((e == null ? void 0 : e.tagName) === "A" && (e != null && e.href));
}
const Kl = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    ...c
  } = t, {
    store: l
  } = Xr(), u = l.useState("open"), {
    getButtonProps: d,
    buttonRef: f
  } = Cr({
    disabled: i,
    native: a
  }), h = {
    disabled: i
  };
  function p(g) {
    u && l.setOpen(!1, Ve(R0, g.nativeEvent));
  }
  return $e("button", t, {
    state: h,
    ref: [n, f],
    props: [{
      onClick: p
    }, c, d]
  });
});
process.env.NODE_ENV !== "production" && (Kl.displayName = "DialogClose");
const xh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, {
    store: c
  } = Xr(), l = nn(i);
  return c.useSyncedValueWithCleanup("descriptionElementId", l), $e("p", t, {
    ref: n,
    props: [{
      id: l
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (xh.displayName = "DialogDescription");
let GT = /* @__PURE__ */ function(e) {
  return e.nestedDialogs = "--nested-dialogs", e;
}({}), KT = function(e) {
  return e[e.open = Qn.open] = "open", e[e.closed = Qn.closed] = "closed", e[e.startingStyle = Qn.startingStyle] = "startingStyle", e[e.endingStyle = Qn.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({});
const Ch = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ch.displayName = "DialogPortalContext");
function ky() {
  const e = b.useContext(Ch);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : rt(26));
  return e;
}
const Ci = "ArrowUp", ls = "ArrowDown", Wc = "ArrowLeft", Ei = "ArrowRight", ql = "Home", Xl = "End", Py = /* @__PURE__ */ new Set([Wc, Ei]), qT = /* @__PURE__ */ new Set([Wc, Ei, ql, Xl]), Ry = /* @__PURE__ */ new Set([Ci, ls]), XT = /* @__PURE__ */ new Set([Ci, ls, ql, Xl]), Iy = /* @__PURE__ */ new Set([...Py, ...Ry]), Zl = /* @__PURE__ */ new Set([...Iy, ql, Xl]), ZT = "Shift", QT = "Control", JT = "Alt", ek = "Meta", tk = /* @__PURE__ */ new Set([ZT, QT, JT, ek]);
function nk(e) {
  return vt(e) && e.tagName === "INPUT";
}
function Zg(e) {
  return !!(nk(e) && e.selectionStart != null || vt(e) && e.tagName === "TEXTAREA");
}
function Qg(e, t, n, r) {
  if (!e || !t || !t.scrollTo)
    return;
  let o = e.scrollLeft, s = e.scrollTop;
  const i = e.clientWidth < e.scrollWidth, a = e.clientHeight < e.scrollHeight;
  if (i && r !== "vertical") {
    const c = Jg(e, t, "left"), l = Ia(e), u = Ia(t);
    n === "ltr" && (c + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - l.scrollPaddingRight ? o = c + t.offsetWidth + u.scrollMarginRight - e.clientWidth + l.scrollPaddingRight : c - u.scrollMarginLeft < e.scrollLeft + l.scrollPaddingLeft && (o = c - u.scrollMarginLeft - l.scrollPaddingLeft)), n === "rtl" && (c - u.scrollMarginRight < e.scrollLeft + l.scrollPaddingLeft ? o = c - u.scrollMarginLeft - l.scrollPaddingLeft : c + t.offsetWidth + u.scrollMarginRight > e.scrollLeft + e.clientWidth - l.scrollPaddingRight && (o = c + t.offsetWidth + u.scrollMarginRight - e.clientWidth + l.scrollPaddingRight));
  }
  if (a && r !== "horizontal") {
    const c = Jg(e, t, "top"), l = Ia(e), u = Ia(t);
    c - u.scrollMarginTop < e.scrollTop + l.scrollPaddingTop ? s = c - u.scrollMarginTop - l.scrollPaddingTop : c + t.offsetHeight + u.scrollMarginBottom > e.scrollTop + e.clientHeight - l.scrollPaddingBottom && (s = c + t.offsetHeight + u.scrollMarginBottom - e.clientHeight + l.scrollPaddingBottom);
  }
  e.scrollTo({
    left: o,
    top: s,
    behavior: "auto"
  });
}
function Jg(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let o = 0;
  for (; t.offsetParent && (o += t[r], t.offsetParent !== e); )
    t = t.offsetParent;
  return o;
}
function Ia(e) {
  const t = getComputedStyle(e);
  return {
    scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
  };
}
const rk = {
  ...qr,
  ...Un,
  nestedDialogOpen(e) {
    return e ? {
      [KT.nestedDialogOpen]: ""
    } : null;
  }
}, Eh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    finalFocus: i,
    initialFocus: a,
    ...c
  } = t, {
    store: l
  } = Xr(), u = l.useState("descriptionElementId"), d = l.useState("disablePointerDismissal"), f = l.useState("floatingRootContext"), h = l.useState("popupProps"), p = l.useState("modal"), g = l.useState("mounted"), m = l.useState("nested"), y = l.useState("nestedOpenDialogCount"), v = l.useState("open"), w = l.useState("openMethod"), C = l.useState("titleElementId"), x = l.useState("transitionStatus"), E = l.useState("role"), S = f.useState("floatingId"), M = c.id ?? S;
  ky(), xr({
    open: v,
    ref: l.context.popupRef,
    onComplete() {
      var R, N;
      v && ((N = (R = l.context).onOpenChangeComplete) == null || N.call(R, !0));
    }
  });
  function T(R) {
    return R === "touch" ? l.context.popupRef.current : !0;
  }
  const P = a === void 0 ? T : a, k = y > 0, I = l.useStateSetter("popupElement"), A = $e("div", t, {
    state: {
      open: v,
      nested: m,
      transitionStatus: x,
      nestedDialogOpen: k
    },
    props: [h, {
      id: M,
      "aria-labelledby": C ?? void 0,
      "aria-describedby": u ?? void 0,
      role: E,
      ...As,
      hidden: !g,
      onKeyDown(R) {
        Zl.has(R.key) && R.stopPropagation();
      },
      style: {
        [GT.nestedDialogs]: y
      }
    }, c],
    ref: [n, l.context.popupRef, I],
    stateAttributesMapping: rk
  });
  return /* @__PURE__ */ _(Qf, {
    context: f,
    openInteractionType: w,
    disabled: !g,
    closeOnFocusOut: !d,
    initialFocus: P,
    returnFocus: i,
    modal: p !== !1,
    restoreFocus: "popup",
    children: A
  });
});
process.env.NODE_ENV !== "production" && (Eh.displayName = "DialogPopup");
const Ql = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    cutout: r,
    ...o
  } = t;
  let s;
  if (r) {
    const i = r.getBoundingClientRect();
    s = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${i.left}px ${i.top}px,${i.left}px ${i.bottom}px,${i.right}px ${i.bottom}px,${i.right}px ${i.top}px,${i.left}px ${i.top}px)`;
  }
  return /* @__PURE__ */ _("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...o,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: s
    }
  });
});
process.env.NODE_ENV !== "production" && (Ql.displayName = "InternalBackdrop");
const _h = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: s
  } = Xr(), i = s.useState("mounted"), a = s.useState("modal"), c = s.useState("open");
  return i || r ? /* @__PURE__ */ _(Ch.Provider, {
    value: r,
    children: /* @__PURE__ */ Z(Pl, {
      ref: n,
      ...o,
      children: [i && a === !0 && /* @__PURE__ */ _(Ql, {
        ref: s.context.internalBackdropRef,
        inert: na(!c)
      }), t.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (_h.displayName = "DialogPortal");
let em = {}, tm = {}, nm = "";
function ok(e) {
  if (typeof document > "u")
    return !1;
  const t = Ye(e);
  return Ot(t).innerWidth - t.documentElement.clientWidth > 0;
}
function sk(e) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = Ye(e), r = n.documentElement, o = n.body, s = mo(r) ? r : o, i = s.style.overflowY, a = r.style.scrollbarGutter;
  r.style.scrollbarGutter = "stable", s.style.overflowY = "scroll";
  const c = s.offsetWidth;
  s.style.overflowY = "hidden";
  const l = s.offsetWidth;
  return s.style.overflowY = i, r.style.scrollbarGutter = a, c === l;
}
function ik(e) {
  const t = Ye(e), n = t.documentElement, r = t.body, o = mo(n) ? n : r, s = {
    overflowY: o.style.overflowY,
    overflowX: o.style.overflowX
  };
  return Object.assign(o.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(o.style, s);
  };
}
function ak(e) {
  var h;
  const t = Ye(e), n = t.documentElement, r = t.body, o = Ot(n);
  let s = 0, i = 0, a = !1;
  const c = bn.create();
  if (x0 && (((h = o.visualViewport) == null ? void 0 : h.scale) ?? 1) !== 1)
    return () => {
    };
  function l() {
    const p = o.getComputedStyle(n), g = o.getComputedStyle(r), v = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    s = n.scrollTop, i = n.scrollLeft, em = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, nm = n.style.scrollBehavior, tm = {
      position: r.style.position,
      height: r.style.height,
      width: r.style.width,
      boxSizing: r.style.boxSizing,
      overflowY: r.style.overflowY,
      overflowX: r.style.overflowX,
      scrollBehavior: r.style.scrollBehavior
    };
    const w = n.scrollHeight > n.clientHeight, C = n.scrollWidth > n.clientWidth, x = p.overflowY === "scroll" || g.overflowY === "scroll", E = p.overflowX === "scroll" || g.overflowX === "scroll", S = Math.max(0, o.innerWidth - r.clientWidth), M = Math.max(0, o.innerHeight - r.clientHeight), T = parseFloat(g.marginTop) + parseFloat(g.marginBottom), P = parseFloat(g.marginLeft) + parseFloat(g.marginRight), k = mo(n) ? n : r;
    if (a = sk(e), a) {
      n.style.scrollbarGutter = v, k.style.overflowY = "hidden", k.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: v,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (w || x) && (n.style.overflowY = "scroll"), (C || E) && (n.style.overflowX = "scroll"), Object.assign(r.style, {
      position: "relative",
      height: T || M ? `calc(100dvh - ${T + M}px)` : "100dvh",
      width: P || S ? `calc(100vw - ${P + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), r.scrollTop = s, r.scrollLeft = i, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, em), Object.assign(r.style, tm), a || (n.scrollTop = s, n.scrollLeft = i, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = nm);
  }
  function d() {
    u(), c.request(l);
  }
  l();
  const f = We(o, "resize", d);
  return () => {
    c.cancel(), u(), typeof o.removeEventListener == "function" && f();
  };
}
class ck {
  constructor() {
    ae(this, "lockCount", 0);
    ae(this, "restore", null);
    ae(this, "timeoutLock", xn.create());
    ae(this, "timeoutUnlock", xn.create());
    ae(this, "release", () => {
      this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
    });
    ae(this, "unlock", () => {
      var t;
      this.lockCount === 0 && this.restore && ((t = this.restore) == null || t.call(this), this.restore = null);
    });
  }
  acquire(t) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(t)), this.release;
  }
  lock(t) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const r = Ye(t).documentElement, o = Ot(r).getComputedStyle(r).overflowY;
    if (o === "hidden" || o === "clip") {
      this.restore = an;
      return;
    }
    const s = C0 || !ok(t);
    this.restore = s ? ik(t) : ak(t);
  }
}
const lk = new ck();
function Dy(e = !0, t = null) {
  be(() => {
    if (e)
      return lk.acquire(t);
  }, [e, t]);
}
function uk(e) {
  const {
    store: t,
    parentContext: n,
    actionsRef: r,
    isDrawer: o
  } = e, s = t.useState("open");
  hy(t, s), Ll(t);
  const {
    forceUnmount: i
  } = Vl(s, t), a = b.useCallback(() => {
    t.setOpen(!1, Ve(Ml));
  }, [t]);
  return b.useImperativeHandle(r, () => ({
    unmount: i,
    close: a
  }), [i, a]), {
    parentContext: n,
    isDrawer: o
  };
}
function dk({
  store: e,
  dialogRoot: t
}) {
  const {
    parentContext: n,
    isDrawer: r
  } = t, o = e.useState("open"), s = e.useState("disablePointerDismissal"), i = e.useState("modal"), a = e.useState("popupElement"), c = e.useState("floatingRootContext"), [l, u] = b.useState(0), [d, f] = b.useState(0), h = l === 0, p = Il(c, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: i === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(v) {
      if (!e.context.outsidePressEnabledRef.current || "button" in v && v.button !== 0 || "touches" in v && v.touches.length !== 1)
        return !1;
      const w = Dt(v);
      if (h && !s) {
        const C = w;
        return i && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === C || e.context.backdropRef.current === C || Re(C, a) && !(C != null && C.hasAttribute("data-base-ui-portal")) : !0;
      }
      return !1;
    },
    escapeKey: h
  });
  Dy(o && i === !0, a), e.useContextCallback("onNestedDialogOpen", (v, w) => {
    u(v), f(w);
  }), e.useContextCallback("onNestedDialogClose", () => {
    u(0), f(0);
  }), b.useEffect(() => (n != null && n.onNestedDialogOpen && o && n.onNestedDialogOpen(l + 1, d + (r ? 1 : 0)), n != null && n.onNestedDialogClose && !o && n.onNestedDialogClose(), () => {
    n != null && n.onNestedDialogClose && o && n.onNestedDialogClose();
  }), [r, o, l, d, n]);
  const g = p.reference ?? wt, m = p.trigger ?? wt, y = b.useMemo(() => Zt(As, p.floating), [p.floating]);
  return Wl(e, {
    activeTriggerProps: g,
    inactiveTriggerProps: m,
    popupProps: y,
    nestedOpenDialogCount: l,
    nestedOpenDrawerCount: d
  }), null;
}
const fk = {
  ...Hl,
  modal: ge((e) => e.modal),
  nested: ge((e) => e.nested),
  nestedOpenDialogCount: ge((e) => e.nestedOpenDialogCount),
  nestedOpenDrawerCount: ge((e) => e.nestedOpenDrawerCount),
  disablePointerDismissal: ge((e) => e.disablePointerDismissal),
  openMethod: ge((e) => e.openMethod),
  descriptionElementId: ge((e) => e.descriptionElementId),
  titleElementId: ge((e) => e.titleElementId),
  viewportElement: ge((e) => e.viewportElement),
  role: ge((e) => e.role)
};
class Sh extends Ns {
  constructor(n, r, o = !1) {
    const s = new $s(), i = hk(n);
    i.floatingRootContext = nh(s, r, o);
    super(i, {
      popupRef: /* @__PURE__ */ b.createRef(),
      backdropRef: /* @__PURE__ */ b.createRef(),
      internalBackdropRef: /* @__PURE__ */ b.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: s,
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, fk);
    ae(this, "setOpen", (n, r) => {
      var s, i;
      if (r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      }, !n && r.trigger == null && this.state.activeTriggerId != null && (r.trigger = this.state.activeTriggerElement ?? void 0), (i = (s = this.context).onOpenChange) == null || i.call(s, n, r), r.isCanceled)
        return;
      this.state.floatingRootContext.dispatchOpenChange(n, r);
      const o = {
        open: n
      };
      th(o, n, r.trigger), this.update(o);
    });
  }
  static useStore(n, r) {
    return eh(n, (s, i) => new Sh(r, s, i), !0).store;
  }
}
function hk(e = {}) {
  return {
    ...Bl(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...e
  };
}
function pk(e, t = "dialog") {
  const {
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: s,
    onOpenChangeComplete: i,
    disablePointerDismissal: a = !1,
    modal: c = !0,
    actionsRef: l,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null
  } = e, h = t === "drawer", p = t === "alert-dialog", g = p ? !0 : c, m = p || a, y = p ? "alertdialog" : "dialog", v = Xr(!0), C = {
    modal: g,
    disablePointerDismissal: m,
    nested: !!v,
    role: y
  }, x = Sh.useStore(u == null ? void 0 : u.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d,
    ...C
  });
  yl(() => {
    const I = r === void 0 && x.state.open === !1 && o === !0 ? {
      open: !0,
      activeTriggerId: f
    } : null;
    p ? x.update(I ? {
      ...C,
      ...I
    } : C) : I && x.update(I);
  }), x.useControlledProp("openProp", r), x.useControlledProp("triggerIdProp", d), x.useSyncedValues(C), x.useContextCallback("onOpenChange", s), x.useContextCallback("onOpenChangeComplete", i);
  const E = x.useState("open"), S = x.useState("mounted"), M = x.useState("payload"), T = uk({
    store: x,
    actionsRef: l,
    parentContext: v == null ? void 0 : v.store.context,
    isDrawer: h
  }), P = E || S, k = b.useMemo(() => ({
    store: x
  }), [x]);
  return /* @__PURE__ */ _(mh.Provider, {
    value: !1,
    children: /* @__PURE__ */ Z(bh.Provider, {
      value: k,
      children: [P && /* @__PURE__ */ _(dk, {
        store: x,
        dialogRoot: T
      }), typeof n == "function" ? n({
        payload: M
      }) : n]
    })
  });
}
function Ny(e) {
  const t = b.useContext(mh) ? "drawer" : "dialog";
  return pk(e, t);
}
let rm = function(e) {
  return e[e.open = Qn.open] = "open", e[e.closed = Qn.closed] = "closed", e[e.startingStyle = Qn.startingStyle] = "startingStyle", e[e.endingStyle = Qn.endingStyle] = "endingStyle", e.nested = "data-nested", e.nestedDialogOpen = "data-nested-dialog-open", e;
}({});
const gk = {
  ...qr,
  ...Un,
  nested(e) {
    return e ? {
      [rm.nested]: ""
    } : null;
  },
  nestedDialogOpen(e) {
    return e ? {
      [rm.nestedDialogOpen]: ""
    } : null;
  }
}, Oh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    ...a
  } = t, c = ky(), {
    store: l
  } = Xr(), u = l.useState("open"), d = l.useState("nested"), f = l.useState("transitionStatus"), h = l.useState("nestedOpenDialogCount"), p = l.useState("mounted"), g = l.useStateSetter("viewportElement"), m = h > 0;
  return $e("div", t, {
    enabled: c || p,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: m
    },
    ref: [n, g],
    stateAttributesMapping: gk,
    props: [{
      role: "presentation",
      hidden: !p,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Oh.displayName = "DialogViewport");
const Mh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, {
    store: c
  } = Xr(), l = nn(i);
  return c.useSyncedValueWithCleanup("titleElementId", l), $e("h2", t, {
    ref: n,
    props: [{
      id: l
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (Mh.displayName = "DialogTitle");
function mk(e) {
  const t = b.useRef(""), n = b.useCallback((o) => {
    o.defaultPrevented || (t.current = o.pointerType, e(o, o.pointerType));
  }, [e]);
  return {
    onClick: b.useCallback((o) => {
      if (o.detail === 0) {
        e(o, "keyboard");
        return;
      }
      "pointerType" in o ? e(o, o.pointerType) : e(o, t.current), t.current = "";
    }, [e]),
    onPointerDown: n
  };
}
function Ay(e, t) {
  const n = b.useRef(e), r = Se(t);
  be(() => {
    n.current !== e && r(n.current);
  }, [e, r]), be(() => {
    n.current = e;
  }, [e]);
}
function Th(e, t) {
  const n = Se((s, i) => {
    (typeof e == "function" ? e() : e) || t(i || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (C0 ? "touch" : ""));
  }), {
    onClick: r,
    onPointerDown: o
  } = mk(n);
  return b.useMemo(() => ({
    onClick: r,
    onPointerDown: o
  }), [r, o]);
}
function bk(e) {
  const [t, n] = b.useState(null), r = Th(e, n);
  return Ay(e, (o) => {
    o && !e && n(null);
  }), b.useMemo(() => ({
    openMethod: t,
    triggerProps: r
  }), [t, r]);
}
const kh = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    id: c,
    payload: l,
    handle: u,
    ...d
  } = t, f = Xr(!0), h = (u == null ? void 0 : u.store) ?? (f == null ? void 0 : f.store);
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : rt(79));
  const p = nn(c), g = h.useState("floatingRootContext"), m = h.useState("isOpenedByTrigger", p), y = h.useState("triggerPopupId", p), v = b.useRef(null), {
    registerTrigger: w,
    isMountedByThisTrigger: C
  } = Fl(p, v, h, {
    payload: l
  }), {
    getButtonProps: x,
    buttonRef: E
  } = Cr({
    disabled: i,
    native: a
  }), S = Rl(g, {
    enabled: g != null
  }), M = Th(() => h.select("open"), (k) => {
    h.set("openMethod", k);
  }), T = {
    disabled: i,
    open: m
  }, P = h.useState("triggerProps", C);
  return $e("button", t, {
    state: T,
    ref: [E, n, w, v],
    props: [S.reference, P, M, {
      [zf]: "",
      id: p,
      "aria-haspopup": "dialog",
      "aria-expanded": m,
      "aria-controls": y
    }, d, x],
    stateAttributesMapping: Ul
  });
});
process.env.NODE_ENV !== "production" && (kh.displayName = "DialogTrigger");
const vk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Calendar/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
})), yk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "CheckCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 12 2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), yo = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Check/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5 13 4 4L19 7"
})), $y = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDown/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 9-7 7-7-7"
})), wk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronLeft/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 19-7-7 7-7"
})), Ph = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronRight/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 5 7 7-7 7"
})), Fy = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Copy/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6.667 13.333H5c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667h6.667c.92 0 1.666.746 1.666 1.667v1.667m-5 10H15c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.747-1.666-1.667-1.666H8.333c-.92 0-1.666.746-1.666 1.666V15c0 .92.746 1.667 1.666 1.667Z"
})), xk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "DotsHorizontal/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
})), Vu = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExclamationCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Ck = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Exclamation/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3Z"
})), Ek = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})), _k = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "EyeOff/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3 3 3.59 3.59M21 21l-3.589-3.589m-3.536 1.414A10.05 10.05 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 0 1 1.563-3.029m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532L6.59 6.59m7.532 7.532 3.29 3.29M6.59 6.59A9.953 9.953 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 0 1-4.132 5.411"
})), Sk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Eye/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.458 12C3.733 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.275 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.543-7Z"
})), om = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "FolderDownload/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 10v6m0 0-3-3m3 3 3-3M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
})), Rh = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "InformationCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Ok = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "QuestionMarkCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Mk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Refresh/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15"
})), Tk = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Search/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
})), Ih = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "XCircle/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), Jl = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "X/outline"
}, e), /* @__PURE__ */ b.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18 18 6M6 6l12 12"
}));
function kk(e) {
  return /* @__PURE__ */ _(Ny, { ...e });
}
function Ly(e) {
  return /* @__PURE__ */ _(_h, { ...e });
}
function Pk(e) {
  return /* @__PURE__ */ _(kh, { "data-slot": "dialog-trigger", ...e });
}
function Rk({ className: e, ...t }) {
  return /* @__PURE__ */ Z(
    Kl,
    {
      "data-slot": "dialog-close",
      className: le("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(Jl, { className: "h-5 w-5 text-foundations-subtler" }),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function Vy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    vh,
    {
      className: le(
        "fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        e
      ),
      "data-slot": "dialog-backdrop",
      ...t
    }
  );
}
function Wy({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    Oh,
    {
      className: le(
        "fixed inset-0 z-50 grid grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        e
      ),
      "data-slot": "dialog-viewport",
      ...t
    }
  );
}
function Ik({
  className: e,
  children: t,
  backdropClassName: n,
  showCloseButton: r = !1,
  ...o
}) {
  return /* @__PURE__ */ Z(Ly, { children: [
    /* @__PURE__ */ _(Vy, { className: n }),
    /* @__PURE__ */ _(Wy, { children: /* @__PURE__ */ Z(
      Eh,
      {
        className: le(
          "relative row-start-2 flex max-h-full min-h-0 w-full min-w-0 flex-col rounded-lg border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "opacity-[calc(1-0.1*var(--nested-dialogs))] data-[nested-dialog-open]:origin-top",
          "before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-lg)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
          "max-sm:opacity-[calc(1-min(var(--nested-dialogs),1))] max-sm:before:hidden max-sm:data-[ending-style]:translate-y-4 max-sm:data-[starting-style]:translate-y-4",
          "sm:my-8 sm:w-full sm:max-w-lg sm:-translate-y-[calc(1.25rem*var(--nested-dialogs))] sm:scale-[calc(1-0.1*var(--nested-dialogs))] sm:data-[nested]:data-[ending-style]:translate-y-8 sm:data-[nested]:data-[starting-style]:translate-y-8",
          "sm:data-[ending-style]:scale-95 sm:data-[starting-style]:scale-95",
          e
        ),
        "data-slot": "dialog-popup",
        ...o,
        children: [
          t,
          r && /* @__PURE__ */ Z(Kl, { className: "opacity-72 pointer-coarse:after:absolute pointer-coarse:after:size-full pointer-coarse:after:min-h-11 pointer-coarse:after:min-w-11 focus-visible:ring-ring focus-visible:ring-offset-background absolute end-2 top-2 inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md border border-transparent outline-none transition-[color,background-color,box-shadow,opacity] size-7 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-1 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0", children: [
            /* @__PURE__ */ _(Jl, {}),
            /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    ) })
  ] });
}
function Dk({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: le(
        "in-[[data-slot=dialog-popup]:has([data-slot=dialog-panel])]:pb-3 flex items-center justify-between gap-2 p-6 pb-4 max-sm:pb-4",
        e
      ),
      "data-slot": "dialog-header",
      ...t
    }
  );
}
function Nk({
  className: e,
  variant: t = "default",
  ...n
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: le(
        "flex flex-col gap-2 sm:flex-row-reverse",
        t === "default" && "border-t border-t-foundations-subtle px-12 py-4",
        t === "bare" && "border-t-0 p-0",
        e
      ),
      "data-slot": "dialog-footer",
      ...n
    }
  );
}
function Ak({
  className: e,
  render: t,
  ref: n,
  ...r
}) {
  return /* @__PURE__ */ _(
    Mh,
    {
      ref: n,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: le(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "dialog-title",
      ...r
    }
  );
}
function $k({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    xh,
    {
      ref: t,
      className: le("text-sm text-foundations-subtle", e),
      "data-slot": "dialog-description",
      ...n
    }
  );
}
function Fk({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: le("px-6 py-4", e),
      "data-slot": "dialog-panel",
      ...t
    }
  );
}
const fW = Object.assign(kk, {
  Trigger: Pk,
  Portal: Ly,
  Close: Rk,
  Backdrop: Vy,
  Popup: Ik,
  Header: Dk,
  Footer: Nk,
  Title: Ak,
  Description: $k,
  Panel: Fk,
  Viewport: Wy
});
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function ra(e) {
  return e + 0.5 | 0;
}
const so = (e, t, n) => Math.max(Math.min(e, n), t);
function di(e) {
  return so(ra(e * 2.55), 0, 255);
}
function uo(e) {
  return so(ra(e * 255), 0, 255);
}
function Rr(e) {
  return so(ra(e / 2.55) / 100, 0, 1);
}
function sm(e) {
  return so(ra(e * 100), 0, 100);
}
const Ln = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Ud = [..."0123456789ABCDEF"], Lk = (e) => Ud[e & 15], Vk = (e) => Ud[(e & 240) >> 4] + Ud[e & 15], Da = (e) => (e & 240) >> 4 === (e & 15), Wk = (e) => Da(e.r) && Da(e.g) && Da(e.b) && Da(e.a);
function Bk(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & Ln[e[1]] * 17,
    g: 255 & Ln[e[2]] * 17,
    b: 255 & Ln[e[3]] * 17,
    a: t === 5 ? Ln[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: Ln[e[1]] << 4 | Ln[e[2]],
    g: Ln[e[3]] << 4 | Ln[e[4]],
    b: Ln[e[5]] << 4 | Ln[e[6]],
    a: t === 9 ? Ln[e[7]] << 4 | Ln[e[8]] : 255
  })), n;
}
const Hk = (e, t) => e < 255 ? t(e) : "";
function Yk(e) {
  var t = Wk(e) ? Lk : Vk;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + Hk(e.a, t) : void 0;
}
const zk = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function By(e, t, n) {
  const r = t * Math.min(n, 1 - n), o = (s, i = (s + e / 30) % 12) => n - r * Math.max(Math.min(i - 3, 9 - i, 1), -1);
  return [o(0), o(8), o(4)];
}
function jk(e, t, n) {
  const r = (o, s = (o + e / 60) % 6) => n - n * t * Math.max(Math.min(s, 4 - s, 1), 0);
  return [r(5), r(3), r(1)];
}
function Uk(e, t, n) {
  const r = By(e, 1, 0.5);
  let o;
  for (t + n > 1 && (o = 1 / (t + n), t *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - t - n, r[o] += t;
  return r;
}
function Gk(e, t, n, r, o) {
  return e === o ? (t - n) / r + (t < n ? 6 : 0) : t === o ? (n - e) / r + 2 : (e - t) / r + 4;
}
function Dh(e) {
  const n = e.r / 255, r = e.g / 255, o = e.b / 255, s = Math.max(n, r, o), i = Math.min(n, r, o), a = (s + i) / 2;
  let c, l, u;
  return s !== i && (u = s - i, l = a > 0.5 ? u / (2 - s - i) : u / (s + i), c = Gk(n, r, o, u, s), c = c * 60 + 0.5), [c | 0, l || 0, a];
}
function Nh(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(uo);
}
function Ah(e, t, n) {
  return Nh(By, e, t, n);
}
function Kk(e, t, n) {
  return Nh(Uk, e, t, n);
}
function qk(e, t, n) {
  return Nh(jk, e, t, n);
}
function Hy(e) {
  return (e % 360 + 360) % 360;
}
function Xk(e) {
  const t = zk.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? di(+t[5]) : uo(+t[5]));
  const o = Hy(+t[2]), s = +t[3] / 100, i = +t[4] / 100;
  return t[1] === "hwb" ? r = Kk(o, s, i) : t[1] === "hsv" ? r = qk(o, s, i) : r = Ah(o, s, i), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function Zk(e, t) {
  var n = Dh(e);
  n[0] = Hy(n[0] + t), n = Ah(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function Qk(e) {
  if (!e)
    return;
  const t = Dh(e), n = t[0], r = sm(t[1]), o = sm(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${Rr(e.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const im = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, am = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Jk() {
  const e = {}, t = Object.keys(am), n = Object.keys(im);
  let r, o, s, i, a;
  for (r = 0; r < t.length; r++) {
    for (i = a = t[r], o = 0; o < n.length; o++)
      s = n[o], a = a.replace(s, im[s]);
    s = parseInt(am[i], 16), e[a] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return e;
}
let Na;
function e2(e) {
  Na || (Na = Jk(), Na.transparent = [0, 0, 0, 0]);
  const t = Na[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const t2 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function n2(e) {
  const t = t2.exec(e);
  let n = 255, r, o, s;
  if (t) {
    if (t[7] !== r) {
      const i = +t[7];
      n = t[8] ? di(i) : so(i * 255, 0, 255);
    }
    return r = +t[1], o = +t[3], s = +t[5], r = 255 & (t[2] ? di(r) : so(r, 0, 255)), o = 255 & (t[4] ? di(o) : so(o, 0, 255)), s = 255 & (t[6] ? di(s) : so(s, 0, 255)), {
      r,
      g: o,
      b: s,
      a: n
    };
  }
}
function r2(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${Rr(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Wu = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Qo = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function o2(e, t, n) {
  const r = Qo(Rr(e.r)), o = Qo(Rr(e.g)), s = Qo(Rr(e.b));
  return {
    r: uo(Wu(r + n * (Qo(Rr(t.r)) - r))),
    g: uo(Wu(o + n * (Qo(Rr(t.g)) - o))),
    b: uo(Wu(s + n * (Qo(Rr(t.b)) - s))),
    a: e.a + n * (t.a - e.a)
  };
}
function Aa(e, t, n) {
  if (e) {
    let r = Dh(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = Ah(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function Yy(e, t) {
  return e && Object.assign(t || {}, e);
}
function cm(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = uo(e[3]))) : (t = Yy(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = uo(t.a)), t;
}
function s2(e) {
  return e.charAt(0) === "r" ? n2(e) : Xk(e);
}
class Li {
  constructor(t) {
    if (t instanceof Li)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = cm(t) : n === "string" && (r = Bk(t) || e2(t) || s2(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Yy(this._rgb);
    return t && (t.a = Rr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = cm(t);
  }
  rgbString() {
    return this._valid ? r2(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Yk(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Qk(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, o = t.rgb;
      let s;
      const i = n === s ? 0.5 : n, a = 2 * i - 1, c = r.a - o.a, l = ((a * c === -1 ? a : (a + c) / (1 + a * c)) + 1) / 2;
      s = 1 - l, r.r = 255 & l * r.r + s * o.r + 0.5, r.g = 255 & l * r.g + s * o.g + 0.5, r.b = 255 & l * r.b + s * o.b + 0.5, r.a = i * r.a + (1 - i) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = o2(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Li(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = uo(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = ra(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Aa(this._rgb, 2, t), this;
  }
  darken(t) {
    return Aa(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Aa(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Aa(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Zk(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function Mr() {
}
const i2 = (() => {
  let e = 0;
  return () => e++;
})();
function yt(e) {
  return e === null || typeof e > "u";
}
function Ft(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function at(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function tn(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function On(e, t) {
  return tn(e) ? e : t;
}
function ut(e, t) {
  return typeof e > "u" ? t : e;
}
const a2 = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, zy = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Vt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function bt(e, t, n, r) {
  let o, s, i;
  if (Ft(e))
    if (s = e.length, r)
      for (o = s - 1; o >= 0; o--)
        t.call(n, e[o], o);
    else
      for (o = 0; o < s; o++)
        t.call(n, e[o], o);
  else if (at(e))
    for (i = Object.keys(e), s = i.length, o = 0; o < s; o++)
      t.call(n, e[i[o]], i[o]);
}
function Bc(e, t) {
  let n, r, o, s;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (o = e[n], s = t[n], o.datasetIndex !== s.datasetIndex || o.index !== s.index)
      return !1;
  return !0;
}
function Hc(e) {
  if (Ft(e))
    return e.map(Hc);
  if (at(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      t[n[o]] = Hc(e[n[o]]);
    return t;
  }
  return e;
}
function jy(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function c2(e, t, n, r) {
  if (!jy(e))
    return;
  const o = t[e], s = n[e];
  at(o) && at(s) ? Vi(o, s, r) : t[e] = Hc(s);
}
function Vi(e, t, n) {
  const r = Ft(t) ? t : [
    t
  ], o = r.length;
  if (!at(e))
    return e;
  n = n || {};
  const s = n.merger || c2;
  let i;
  for (let a = 0; a < o; ++a) {
    if (i = r[a], !at(i))
      continue;
    const c = Object.keys(i);
    for (let l = 0, u = c.length; l < u; ++l)
      s(c[l], e, i, n);
  }
  return e;
}
function _i(e, t) {
  return Vi(e, t, {
    merger: l2
  });
}
function l2(e, t, n) {
  if (!jy(e))
    return;
  const r = t[e], o = n[e];
  at(r) && at(o) ? _i(r, o) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Hc(o));
}
const lm = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function u2(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const o of t)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function d2(e) {
  const t = u2(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function zo(e, t) {
  return (lm[t] || (lm[t] = d2(t)))(e);
}
function $h(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Wi = (e) => typeof e < "u", ho = (e) => typeof e == "function", um = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function f2(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Gt = Math.PI, Nt = 2 * Gt, h2 = Nt + Gt, Yc = Number.POSITIVE_INFINITY, p2 = Gt / 180, Wt = Gt / 2, So = Gt / 4, dm = Gt * 2 / 3, io = Math.log10, gr = Math.sign;
function Si(e, t, n) {
  return Math.abs(e - t) < n;
}
function fm(e) {
  const t = Math.round(e);
  e = Si(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(io(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function g2(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((o, s) => o - s).pop(), t;
}
function Bi(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function m2(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function Uy(e, t, n) {
  let r, o, s;
  for (r = 0, o = e.length; r < o; r++)
    s = e[r][n], isNaN(s) || (t.min = Math.min(t.min, s), t.max = Math.max(t.max, s));
}
function lr(e) {
  return e * (Gt / 180);
}
function Fh(e) {
  return e * (180 / Gt);
}
function hm(e) {
  if (!tn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function Gy(e, t) {
  const n = t.x - e.x, r = t.y - e.y, o = Math.sqrt(n * n + r * r);
  let s = Math.atan2(r, n);
  return s < -0.5 * Gt && (s += Nt), {
    angle: s,
    distance: o
  };
}
function Gd(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function b2(e, t) {
  return (e - t + h2) % Nt - Gt;
}
function Zn(e) {
  return (e % Nt + Nt) % Nt;
}
function Hi(e, t, n, r) {
  const o = Zn(e), s = Zn(t), i = Zn(n), a = Zn(s - o), c = Zn(i - o), l = Zn(o - s), u = Zn(o - i);
  return o === s || o === i || r && s === i || a > c && l < u;
}
function cn(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function v2(e) {
  return cn(e, -32768, 32767);
}
function zc(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Lh(e, t, n) {
  n = n || ((i) => e[i] < t);
  let r = e.length - 1, o = 0, s;
  for (; r - o > 1; )
    s = o + r >> 1, n(s) ? o = s : r = s;
  return {
    lo: o,
    hi: r
  };
}
const Fo = (e, t, n, r) => Lh(e, n, r ? (o) => {
  const s = e[o][t];
  return s < n || s === n && e[o + 1][t] === n;
} : (o) => e[o][t] < n), y2 = (e, t, n) => Lh(e, n, (r) => e[r][t] >= n);
function w2(e, t, n) {
  let r = 0, o = e.length;
  for (; r < o && e[r] < t; )
    r++;
  for (; o > r && e[o - 1] > n; )
    o--;
  return r > 0 || o < e.length ? e.slice(r, o) : e;
}
const Ky = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function x2(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Ky.forEach((n) => {
    const r = "_onData" + $h(n), o = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const i = o.apply(this, s);
        return e._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...s);
        }), i;
      }
    });
  });
}
function pm(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(t);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (Ky.forEach((s) => {
    delete e[s];
  }), delete e._chartjs);
}
function qy(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const Xy = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Zy(e, t) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, Xy.call(window, () => {
      r = !1, e.apply(t, n);
    }));
  };
}
function C2(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const E2 = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", gm = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2;
function _2(e, t, n) {
  const r = t.length;
  let o = 0, s = r;
  if (e._sorted) {
    const { iScale: i, _parsed: a } = e, c = i.axis, { min: l, max: u, minDefined: d, maxDefined: f } = i.getUserBounds();
    d && (o = cn(Math.min(
      // @ts-expect-error Need to type _parsed
      Fo(a, c, l).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : Fo(t, c, i.getPixelForValue(l)).lo
    ), 0, r - 1)), f ? s = cn(Math.max(
      // @ts-expect-error Need to type _parsed
      Fo(a, i.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : Fo(t, c, i.getPixelForValue(u), !0).hi + 1
    ), o, r) - o : s = r - o;
  }
  return {
    start: o,
    count: s
  };
}
function S2(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, o = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = o, !0;
  const s = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), s;
}
const $a = (e) => e === 0 || e === 1, mm = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * Nt / n)), bm = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * Nt / n) + 1, Oi = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Wt) + 1,
  easeOutSine: (e) => Math.sin(e * Wt),
  easeInOutSine: (e) => -0.5 * (Math.cos(Gt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => $a(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => $a(e) ? e : mm(e, 0.075, 0.3),
  easeOutElastic: (e) => $a(e) ? e : bm(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return $a(e) ? e : e < 0.5 ? 0.5 * mm(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * bm(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Oi.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Oi.easeInBounce(e * 2) * 0.5 : Oi.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Vh(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function vm(e) {
  return Vh(e) ? e : new Li(e);
}
function Bu(e) {
  return Vh(e) ? e : new Li(e).saturate(0.5).darken(0.1).hexString();
}
const O2 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], M2 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function T2(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: M2
    },
    numbers: {
      type: "number",
      properties: O2
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function k2(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const ym = /* @__PURE__ */ new Map();
function P2(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = ym.get(n);
  return r || (r = new Intl.NumberFormat(e, t), ym.set(n, r)), r;
}
function eu(e, t, n) {
  return P2(t, n).format(e);
}
const Qy = {
  values(e) {
    return Ft(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, s = e;
    if (n.length > 1) {
      const l = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (l < 1e-4 || l > 1e15) && (o = "scientific"), s = R2(e, n);
    }
    const i = io(Math.abs(s)), a = isNaN(i) ? 1 : Math.max(Math.min(-1 * Math.floor(i), 20), 0), c = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(c, this.options.ticks.format), eu(e, r, c);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = n[t].significand || e / Math.pow(10, Math.floor(io(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * n.length ? Qy.numeric.call(this, e, t, n) : "";
  }
};
function R2(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var tu = {
  formatters: Qy
};
function I2(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: tu.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const jo = /* @__PURE__ */ Object.create(null), Kd = /* @__PURE__ */ Object.create(null);
function Mi(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const s = n[r];
    e = e[s] || (e[s] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Hu(e, t, n) {
  return typeof t == "string" ? Vi(Mi(e, t), n) : Vi(Mi(e, ""), t);
}
class D2 {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Bu(o.backgroundColor), this.hoverBorderColor = (r, o) => Bu(o.borderColor), this.hoverColor = (r, o) => Bu(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Hu(this, t, n);
  }
  get(t) {
    return Mi(this, t);
  }
  describe(t, n) {
    return Hu(Kd, t, n);
  }
  override(t, n) {
    return Hu(jo, t, n);
  }
  route(t, n, r, o) {
    const s = Mi(this, t), i = Mi(this, r), a = "_" + n;
    Object.defineProperties(s, {
      [a]: {
        value: s[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const c = this[a], l = i[o];
          return at(c) ? Object.assign({}, l, c) : ut(c, l);
        },
        set(c) {
          this[a] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var zt = /* @__PURE__ */ new D2({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  T2,
  k2,
  I2
]);
function N2(e) {
  return !e || yt(e.size) || yt(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function jc(e, t, n, r, o) {
  let s = t[o];
  return s || (s = t[o] = e.measureText(o).width, n.push(o)), s > r && (r = s), r;
}
function A2(e, t, n, r) {
  r = r || {};
  let o = r.data = r.data || {}, s = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (o = r.data = {}, s = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let i = 0;
  const a = n.length;
  let c, l, u, d, f;
  for (c = 0; c < a; c++)
    if (d = n[c], d != null && !Ft(d))
      i = jc(e, o, s, i, d);
    else if (Ft(d))
      for (l = 0, u = d.length; l < u; l++)
        f = d[l], f != null && !Ft(f) && (i = jc(e, o, s, i, f));
  e.restore();
  const h = s.length / 2;
  if (h > n.length) {
    for (c = 0; c < h; c++)
      delete o[s[c]];
    s.splice(0, h);
  }
  return i;
}
function Oo(e, t, n) {
  const r = e.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - o) * r) / r + o;
}
function wm(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function qd(e, t, n, r) {
  $2(e, t, n, r, null);
}
function $2(e, t, n, r, o) {
  let s, i, a, c, l, u, d, f;
  const h = t.pointStyle, p = t.rotation, g = t.radius;
  let m = (p || 0) * p2;
  if (h && typeof h == "object" && (s = h.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(m), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), h) {
      default:
        o ? e.ellipse(n, r, o / 2, g, 0, 0, Nt) : e.arc(n, r, g, 0, Nt), e.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : g, e.moveTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += dm, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += dm, e.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), e.closePath();
        break;
      case "rectRounded":
        l = g * 0.516, c = g - l, i = Math.cos(m + So) * c, d = Math.cos(m + So) * (o ? o / 2 - l : c), a = Math.sin(m + So) * c, f = Math.sin(m + So) * (o ? o / 2 - l : c), e.arc(n - d, r - a, l, m - Gt, m - Wt), e.arc(n + f, r - i, l, m - Wt, m), e.arc(n + d, r + a, l, m, m + Wt), e.arc(n - f, r + i, l, m + Wt, m + Gt), e.closePath();
        break;
      case "rect":
        if (!p) {
          c = Math.SQRT1_2 * g, u = o ? o / 2 : c, e.rect(n - u, r - c, 2 * u, 2 * c);
          break;
        }
        m += So;
      case "rectRot":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + f, r - i), e.lineTo(n + d, r + a), e.lineTo(n - f, r + i), e.closePath();
        break;
      case "crossRot":
        m += So;
      case "cross":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i);
        break;
      case "star":
        d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i), m += So, d = Math.cos(m) * (o ? o / 2 : g), i = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), e.moveTo(n - d, r - a), e.lineTo(n + d, r + a), e.moveTo(n + f, r - i), e.lineTo(n - f, r + i);
        break;
      case "line":
        i = o ? o / 2 : Math.cos(m) * g, a = Math.sin(m) * g, e.moveTo(n - i, r - a), e.lineTo(n + i, r + a);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(m) * (o ? o / 2 : g), r + Math.sin(m) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function Dr(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function Jy(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function e1(e) {
  e.restore();
}
function F2(e, t, n, r, o) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (o === "middle") {
    const s = (t.x + n.x) / 2;
    e.lineTo(s, t.y), e.lineTo(s, n.y);
  } else
    o === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function L2(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function V2(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), yt(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function W2(e, t, n, r, o) {
  if (o.strikethrough || o.underline) {
    const s = e.measureText(r), i = t - s.actualBoundingBoxLeft, a = t + s.actualBoundingBoxRight, c = n - s.actualBoundingBoxAscent, l = n + s.actualBoundingBoxDescent, u = o.strikethrough ? (c + l) / 2 : l;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = o.decorationWidth || 2, e.moveTo(i, u), e.lineTo(a, u), e.stroke();
  }
}
function B2(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function Uc(e, t, n, r, o, s = {}) {
  const i = Ft(t) ? t : [
    t
  ], a = s.strokeWidth > 0 && s.strokeColor !== "";
  let c, l;
  for (e.save(), e.font = o.string, V2(e, s), c = 0; c < i.length; ++c)
    l = i[c], s.backdrop && B2(e, s.backdrop), a && (s.strokeColor && (e.strokeStyle = s.strokeColor), yt(s.strokeWidth) || (e.lineWidth = s.strokeWidth), e.strokeText(l, n, r, s.maxWidth)), e.fillText(l, n, r, s.maxWidth), W2(e, n, r, l, s), r += Number(o.lineHeight);
  e.restore();
}
function Gc(e, t) {
  const { x: n, y: r, w: o, h: s, radius: i } = t;
  e.arc(n + i.topLeft, r + i.topLeft, i.topLeft, -Wt, Gt, !0), e.lineTo(n, r + s - i.bottomLeft), e.arc(n + i.bottomLeft, r + s - i.bottomLeft, i.bottomLeft, Gt, Wt, !0), e.lineTo(n + o - i.bottomRight, r + s), e.arc(n + o - i.bottomRight, r + s - i.bottomRight, i.bottomRight, Wt, 0, !0), e.lineTo(n + o, r + i.topRight), e.arc(n + o - i.topRight, r + i.topRight, i.topRight, 0, -Wt, !0), e.lineTo(n + i.topLeft, r);
}
const H2 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Y2 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function z2(e, t) {
  const n = ("" + e).match(H2);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const j2 = (e) => +e || 0;
function Wh(e, t) {
  const n = {}, r = at(t), o = r ? Object.keys(t) : t, s = at(e) ? r ? (i) => ut(e[i], e[t[i]]) : (i) => e[i] : () => e;
  for (const i of o)
    n[i] = j2(s(i));
  return n;
}
function t1(e) {
  return Wh(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function ms(e) {
  return Wh(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function zn(e) {
  const t = t1(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function In(e, t) {
  e = e || {}, t = t || zt.font;
  let n = ut(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = ut(e.style, t.style);
  r && !("" + r).match(Y2) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: ut(e.family, t.family),
    lineHeight: z2(ut(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: ut(e.weight, t.weight),
    string: ""
  };
  return o.string = N2(o), o;
}
function Fa(e, t, n, r) {
  let o = !0, s, i, a;
  for (s = 0, i = e.length; s < i; ++s)
    if (a = e[s], a !== void 0 && (t !== void 0 && typeof a == "function" && (a = a(t), o = !1), n !== void 0 && Ft(a) && (a = a[n % a.length], o = !1), a !== void 0))
      return r && !o && (r.cacheable = !1), a;
}
function U2(e, t, n) {
  const { min: r, max: o } = e, s = zy(t, (o - r) / 2), i = (a, c) => n && a === 0 ? 0 : a + c;
  return {
    min: i(r, -Math.abs(s)),
    max: i(o, s)
  };
}
function wo(e, t) {
  return Object.assign(Object.create(e), t);
}
function Bh(e, t = [
  ""
], n, r, o = () => e[0]) {
  const s = n || e;
  typeof r > "u" && (r = s1("_fallback", e));
  const i = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: s,
    _fallback: r,
    _getTarget: o,
    override: (a) => Bh([
      a,
      ...e
    ], t, s, r)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, c) {
      return delete a[c], delete a._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, c) {
      return r1(a, c, () => eP(c, t, e, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, c) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, c) {
      return Cm(a).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Cm(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, c, l) {
      const u = a._storage || (a._storage = o());
      return a[c] = u[c] = l, delete a._keys, !0;
    }
  });
}
function Es(e, t, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: n1(e, r),
    setContext: (s) => Es(e, s, n, r),
    override: (s) => Es(e.override(s), t, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, i) {
      return delete s[i], delete e[i], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, i, a) {
      return r1(s, i, () => K2(s, i, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, i) {
      return s._descriptors.allKeys ? Reflect.has(e, i) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, i);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(s, i) {
      return Reflect.has(e, i);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(s, i, a) {
      return e[i] = a, delete s[i], !0;
    }
  });
}
function n1(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: o = t.allKeys } = e;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: ho(n) ? n : () => n,
    isIndexable: ho(r) ? r : () => r
  };
}
const G2 = (e, t) => e ? e + $h(t) : t, Hh = (e, t) => at(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function r1(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function K2(e, t, n) {
  const { _proxy: r, _context: o, _subProxy: s, _descriptors: i } = e;
  let a = r[t];
  return ho(a) && i.isScriptable(t) && (a = q2(t, a, e, n)), Ft(a) && a.length && (a = X2(t, a, e, i.isIndexable)), Hh(t, a) && (a = Es(a, o, s && s[t], i)), a;
}
function q2(e, t, n, r) {
  const { _proxy: o, _context: s, _subProxy: i, _stack: a } = n;
  if (a.has(e))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + e);
  a.add(e);
  let c = t(s, i || r);
  return a.delete(e), Hh(e, c) && (c = Yh(o._scopes, o, e, c)), c;
}
function X2(e, t, n, r) {
  const { _proxy: o, _context: s, _subProxy: i, _descriptors: a } = n;
  if (typeof s.index < "u" && r(e))
    return t[s.index % t.length];
  if (at(t[0])) {
    const c = t, l = o._scopes.filter((u) => u !== c);
    t = [];
    for (const u of c) {
      const d = Yh(l, o, e, u);
      t.push(Es(d, s, i && i[e], a));
    }
  }
  return t;
}
function o1(e, t, n) {
  return ho(e) ? e(t, n) : e;
}
const Z2 = (e, t) => e === !0 ? t : typeof e == "string" ? zo(t, e) : void 0;
function Q2(e, t, n, r, o) {
  for (const s of t) {
    const i = Z2(n, s);
    if (i) {
      e.add(i);
      const a = o1(i._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (i === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function Yh(e, t, n, r) {
  const o = t._rootScopes, s = o1(t._fallback, n, r), i = [
    ...e,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let c = xm(a, i, n, s || n, r);
  return c === null || typeof s < "u" && s !== n && (c = xm(a, i, s, c, r), c === null) ? !1 : Bh(Array.from(a), [
    ""
  ], o, s, () => J2(t, n, r));
}
function xm(e, t, n, r, o) {
  for (; n; )
    n = Q2(e, t, n, r, o);
  return n;
}
function J2(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const o = r[t];
  return Ft(o) && at(n) ? n : o || {};
}
function eP(e, t, n, r) {
  let o;
  for (const s of t)
    if (o = s1(G2(s, e), n), typeof o < "u")
      return Hh(e, o) ? Yh(n, r, e, o) : o;
}
function s1(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (typeof r < "u")
      return r;
  }
}
function Cm(e) {
  let t = e._keys;
  return t || (t = e._keys = tP(e._scopes)), t;
}
function tP(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
const nP = Number.EPSILON || 1e-14, _s = (e, t) => t < e.length && !e[t].skip && e[t], i1 = (e) => e === "x" ? "y" : "x";
function rP(e, t, n, r) {
  const o = e.skip ? t : e, s = t, i = n.skip ? t : n, a = Gd(s, o), c = Gd(i, s);
  let l = a / (a + c), u = c / (a + c);
  l = isNaN(l) ? 0 : l, u = isNaN(u) ? 0 : u;
  const d = r * l, f = r * u;
  return {
    previous: {
      x: s.x - d * (i.x - o.x),
      y: s.y - d * (i.y - o.y)
    },
    next: {
      x: s.x + f * (i.x - o.x),
      y: s.y + f * (i.y - o.y)
    }
  };
}
function oP(e, t, n) {
  const r = e.length;
  let o, s, i, a, c, l = _s(e, 0);
  for (let u = 0; u < r - 1; ++u)
    if (c = l, l = _s(e, u + 1), !(!c || !l)) {
      if (Si(t[u], 0, nP)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / t[u], s = n[u + 1] / t[u], a = Math.pow(o, 2) + Math.pow(s, 2), !(a <= 9) && (i = 3 / Math.sqrt(a), n[u] = o * i * t[u], n[u + 1] = s * i * t[u]);
    }
}
function sP(e, t, n = "x") {
  const r = i1(n), o = e.length;
  let s, i, a, c = _s(e, 0);
  for (let l = 0; l < o; ++l) {
    if (i = a, a = c, c = _s(e, l + 1), !a)
      continue;
    const u = a[n], d = a[r];
    i && (s = (u - i[n]) / 3, a[`cp1${n}`] = u - s, a[`cp1${r}`] = d - s * t[l]), c && (s = (c[n] - u) / 3, a[`cp2${n}`] = u + s, a[`cp2${r}`] = d + s * t[l]);
  }
}
function iP(e, t = "x") {
  const n = i1(t), r = e.length, o = Array(r).fill(0), s = Array(r);
  let i, a, c, l = _s(e, 0);
  for (i = 0; i < r; ++i)
    if (a = c, c = l, l = _s(e, i + 1), !!c) {
      if (l) {
        const u = l[t] - c[t];
        o[i] = u !== 0 ? (l[n] - c[n]) / u : 0;
      }
      s[i] = a ? l ? gr(o[i - 1]) !== gr(o[i]) ? 0 : (o[i - 1] + o[i]) / 2 : o[i - 1] : o[i];
    }
  oP(e, o, s), sP(e, s, t);
}
function La(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function aP(e, t) {
  let n, r, o, s, i, a = Dr(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    i = s, s = a, a = n < r - 1 && Dr(e[n + 1], t), s && (o = e[n], i && (o.cp1x = La(o.cp1x, t.left, t.right), o.cp1y = La(o.cp1y, t.top, t.bottom)), a && (o.cp2x = La(o.cp2x, t.left, t.right), o.cp2y = La(o.cp2y, t.top, t.bottom)));
}
function cP(e, t, n, r, o) {
  let s, i, a, c;
  if (t.spanGaps && (e = e.filter((l) => !l.skip)), t.cubicInterpolationMode === "monotone")
    iP(e, o);
  else {
    let l = r ? e[e.length - 1] : e[0];
    for (s = 0, i = e.length; s < i; ++s)
      a = e[s], c = rP(l, a, e[Math.min(s + 1, i - (r ? 0 : 1)) % i], t.tension), a.cp1x = c.previous.x, a.cp1y = c.previous.y, a.cp2x = c.next.x, a.cp2y = c.next.y, l = a;
  }
  t.capBezierPoints && aP(e, n);
}
function a1() {
  return typeof window < "u" && typeof document < "u";
}
function zh(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Kc(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const nu = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function lP(e, t) {
  return nu(e).getPropertyValue(t);
}
const uP = [
  "top",
  "right",
  "bottom",
  "left"
];
function Vo(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const s = uP[o];
    r[s] = parseFloat(e[t + "-" + s + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const dP = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function fP(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: o, offsetY: s } = r;
  let i = !1, a, c;
  if (dP(o, s, e.target))
    a = o, c = s;
  else {
    const l = t.getBoundingClientRect();
    a = r.clientX - l.left, c = r.clientY - l.top, i = !0;
  }
  return {
    x: a,
    y: c,
    box: i
  };
}
function Po(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, o = nu(n), s = o.boxSizing === "border-box", i = Vo(o, "padding"), a = Vo(o, "border", "width"), { x: c, y: l, box: u } = fP(e, n), d = i.left + (u && a.left), f = i.top + (u && a.top);
  let { width: h, height: p } = t;
  return s && (h -= i.width + a.width, p -= i.height + a.height), {
    x: Math.round((c - d) / h * n.width / r),
    y: Math.round((l - f) / p * n.height / r)
  };
}
function hP(e, t, n) {
  let r, o;
  if (t === void 0 || n === void 0) {
    const s = zh(e);
    if (!s)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const i = s.getBoundingClientRect(), a = nu(s), c = Vo(a, "border", "width"), l = Vo(a, "padding");
      t = i.width - l.width - c.width, n = i.height - l.height - c.height, r = Kc(a.maxWidth, s, "clientWidth"), o = Kc(a.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || Yc,
    maxHeight: o || Yc
  };
}
const Va = (e) => Math.round(e * 10) / 10;
function pP(e, t, n, r) {
  const o = nu(e), s = Vo(o, "margin"), i = Kc(o.maxWidth, e, "clientWidth") || Yc, a = Kc(o.maxHeight, e, "clientHeight") || Yc, c = hP(e, t, n);
  let { width: l, height: u } = c;
  if (o.boxSizing === "content-box") {
    const f = Vo(o, "border", "width"), h = Vo(o, "padding");
    l -= h.width + f.width, u -= h.height + f.height;
  }
  return l = Math.max(0, l - s.width), u = Math.max(0, r ? l / r : u - s.height), l = Va(Math.min(l, i, c.maxWidth)), u = Va(Math.min(u, a, c.maxHeight)), l && !u && (u = Va(l / 2)), (t !== void 0 || n !== void 0) && r && c.height && u > c.height && (u = c.height, l = Va(Math.floor(u * r))), {
    width: l,
    height: u
  };
}
function Em(e, t, n) {
  const r = t || 1, o = Math.floor(e.height * r), s = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const i = e.canvas;
  return i.style && (n || !i.style.height && !i.style.width) && (i.style.height = `${e.height}px`, i.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || i.height !== o || i.width !== s ? (e.currentDevicePixelRatio = r, i.height = o, i.width = s, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const gP = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function _m(e, t) {
  const n = lP(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function Ro(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function mP(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function bP(e, t, n, r) {
  const o = {
    x: e.cp2x,
    y: e.cp2y
  }, s = {
    x: t.cp1x,
    y: t.cp1y
  }, i = Ro(e, o, n), a = Ro(o, s, n), c = Ro(s, t, n), l = Ro(i, a, n), u = Ro(a, c, n);
  return Ro(l, u, n);
}
const vP = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, yP = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Yu(e, t, n) {
  return e ? vP(t, n) : yP();
}
function wP(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function xP(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function c1(e) {
  return e === "angle" ? {
    between: Hi,
    compare: b2,
    normalize: Zn
  } : {
    between: zc,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Sm({ start: e, end: t, count: n, loop: r, style: o }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: o
  };
}
function CP(e, t, n) {
  const { property: r, start: o, end: s } = n, { between: i, normalize: a } = c1(r), c = t.length;
  let { start: l, end: u, loop: d } = e, f, h;
  if (d) {
    for (l += c, u += c, f = 0, h = c; f < h && i(a(t[l % c][r]), o, s); ++f)
      l--, u--;
    l %= c, u %= c;
  }
  return u < l && (u += c), {
    start: l,
    end: u,
    loop: d,
    style: e.style
  };
}
function EP(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: r, start: o, end: s } = n, i = t.length, { compare: a, between: c, normalize: l } = c1(r), { start: u, end: d, loop: f, style: h } = CP(e, t, n), p = [];
  let g = !1, m = null, y, v, w;
  const C = () => c(o, w, y) && a(o, w) !== 0, x = () => a(s, y) === 0 || c(s, w, y), E = () => g || C(), S = () => !g || x();
  for (let M = u, T = u; M <= d; ++M)
    v = t[M % i], !v.skip && (y = l(v[r]), y !== w && (g = c(y, o, s), m === null && E() && (m = a(y, o) === 0 ? M : T), m !== null && S() && (p.push(Sm({
      start: m,
      end: M,
      loop: f,
      count: i,
      style: h
    })), m = null), T = M, w = y));
  return m !== null && p.push(Sm({
    start: m,
    end: d,
    loop: f,
    count: i,
    style: h
  })), p;
}
function _P(e, t) {
  const n = [], r = e.segments;
  for (let o = 0; o < r.length; o++) {
    const s = EP(r[o], e.points, t);
    s.length && n.push(...s);
  }
  return n;
}
function SP(e, t, n, r) {
  let o = 0, s = t - 1;
  if (n && !r)
    for (; o < t && !e[o].skip; )
      o++;
  for (; o < t && e[o].skip; )
    o++;
  for (o %= t, n && (s += o); s > o && e[s % t].skip; )
    s--;
  return s %= t, {
    start: o,
    end: s
  };
}
function OP(e, t, n, r) {
  const o = e.length, s = [];
  let i = t, a = e[t], c;
  for (c = t + 1; c <= n; ++c) {
    const l = e[c % o];
    l.skip || l.stop ? a.skip || (r = !1, s.push({
      start: t % o,
      end: (c - 1) % o,
      loop: r
    }), t = i = l.stop ? c : null) : (i = c, a.skip && (t = c)), a = l;
  }
  return i !== null && s.push({
    start: t % o,
    end: i % o,
    loop: r
  }), s;
}
function MP(e, t) {
  const n = e.points, r = e.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const s = !!e._loop, { start: i, end: a } = SP(n, o, s, r);
  if (r === !0)
    return Om(e, [
      {
        start: i,
        end: a,
        loop: s
      }
    ], n, t);
  const c = a < i ? a + o : a, l = !!e._fullLoop && i === 0 && a === o - 1;
  return Om(e, OP(n, i, c, l), n, t);
}
function Om(e, t, n, r) {
  return !r || !r.setContext || !n ? t : TP(e, t, n, r);
}
function TP(e, t, n, r) {
  const o = e._chart.getContext(), s = Mm(e.options), { _datasetIndex: i, options: { spanGaps: a } } = e, c = n.length, l = [];
  let u = s, d = t[0].start, f = d;
  function h(p, g, m, y) {
    const v = a ? -1 : 1;
    if (p !== g) {
      for (p += c; n[p % c].skip; )
        p -= v;
      for (; n[g % c].skip; )
        g += v;
      p % c !== g % c && (l.push({
        start: p % c,
        end: g % c,
        loop: m,
        style: y
      }), u = y, d = g % c);
    }
  }
  for (const p of t) {
    d = a ? d : p.start;
    let g = n[d % c], m;
    for (f = d + 1; f <= p.end; f++) {
      const y = n[f % c];
      m = Mm(r.setContext(wo(o, {
        type: "segment",
        p0: g,
        p1: y,
        p0DataIndex: (f - 1) % c,
        p1DataIndex: f % c,
        datasetIndex: i
      }))), kP(m, u) && h(d, f - 1, p.loop, u), g = y, u = m;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return l;
}
function Mm(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function kP(e, t) {
  if (!t)
    return !1;
  const n = [], r = function(o, s) {
    return Vh(s) ? (n.includes(s) || n.push(s), n.indexOf(s)) : s;
  };
  return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class PP {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, o) {
    const s = n.listeners[o], i = n.duration;
    s.forEach((a) => a({
      chart: t,
      initial: n.initial,
      numSteps: i,
      currentStep: Math.min(r - n.start, i)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Xy.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const s = r.items;
      let i = s.length - 1, a = !1, c;
      for (; i >= 0; --i)
        c = s[i], c._active ? (c._total > r.duration && (r.duration = c._total), c.tick(t), a = !0) : (s[i] = s[s.length - 1], s.pop());
      a && (o.draw(), this._notify(o, r, t, "progress")), s.length || (r.running = !1, this._notify(o, r, t, "complete"), r.initial = !1), n += s.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var kr = /* @__PURE__ */ new PP();
const Tm = "transparent", RP = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = vm(e || Tm), o = r.valid && vm(t || Tm);
    return o && o.valid ? o.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
let IP = class {
  constructor(t, n, r, o) {
    const s = n[r];
    o = Fa([
      t.to,
      o,
      s,
      t.from
    ]);
    const i = Fa([
      t.from,
      s,
      o
    ]);
    this._active = !0, this._fn = t.fn || RP[t.type || typeof i], this._easing = Oi[t.easing] || Oi.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = i, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], s = r - this._start, i = this._duration - s;
      this._start = r, this._duration = Math.floor(Math.max(i, t.duration)), this._total += s, this._loop = !!t.loop, this._to = Fa([
        t.to,
        n,
        o,
        t.from
      ]), this._from = Fa([
        t.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, o = this._prop, s = this._from, i = this._loop, a = this._to;
    let c;
    if (this._active = s !== a && (i || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = s;
      return;
    }
    c = n / r % 2, c = i && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[o] = this._fn(s, a, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
};
class l1 {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!at(t))
      return;
    const n = Object.keys(zt.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((o) => {
      const s = t[o];
      if (!at(s))
        return;
      const i = {};
      for (const a of n)
        i[a] = s[a];
      (Ft(s.properties) && s.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, i);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, o = NP(t, r);
    if (!o)
      return [];
    const s = this._createAnimations(o, r);
    return r.$shared && DP(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), s;
  }
  _createAnimations(t, n) {
    const r = this._properties, o = [], s = t.$animations || (t.$animations = {}), i = Object.keys(n), a = Date.now();
    let c;
    for (c = i.length - 1; c >= 0; --c) {
      const l = i[c];
      if (l.charAt(0) === "$")
        continue;
      if (l === "options") {
        o.push(...this._animateOptions(t, n));
        continue;
      }
      const u = n[l];
      let d = s[l];
      const f = r.get(l);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        t[l] = u;
        continue;
      }
      s[l] = d = new IP(f, t, l, u), o.push(d);
    }
    return o;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return kr.add(this._chart, r), !0;
  }
}
function DP(e, t) {
  const n = [], r = Object.keys(t);
  for (let o = 0; o < r.length; o++) {
    const s = e[r[o]];
    s && s.active() && n.push(s.wait());
  }
  return Promise.all(n);
}
function NP(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function km(e, t) {
  const n = e && e.options || {}, r = n.reverse, o = n.min === void 0 ? t : 0, s = n.max === void 0 ? t : 0;
  return {
    start: r ? s : o,
    end: r ? o : s
  };
}
function AP(e, t, n) {
  if (n === !1)
    return !1;
  const r = km(e, n), o = km(t, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function $P(e) {
  let t, n, r, o;
  return at(e) ? (t = e.top, n = e.right, r = e.bottom, o = e.left) : t = n = r = o = e, {
    top: t,
    right: n,
    bottom: r,
    left: o,
    disabled: e === !1
  };
}
function u1(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let o, s;
  for (o = 0, s = r.length; o < s; ++o)
    n.push(r[o].index);
  return n;
}
function Pm(e, t, n, r = {}) {
  const o = e.keys, s = r.mode === "single";
  let i, a, c, l;
  if (t !== null) {
    for (i = 0, a = o.length; i < a; ++i) {
      if (c = +o[i], c === n) {
        if (r.all)
          continue;
        break;
      }
      l = e.values[c], tn(l) && (s || t === 0 || gr(t) === gr(l)) && (t += l);
    }
    return t;
  }
}
function FP(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let r, o, s;
  for (r = 0, o = t.length; r < o; ++r)
    s = t[r], n[r] = {
      x: s,
      y: e[s]
    };
  return n;
}
function Rm(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function LP(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function VP(e) {
  const { min: t, max: n, minDefined: r, maxDefined: o } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function WP(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function Im(e, t, n, r) {
  for (const o of t.getMatchingVisibleMetas(r).reverse()) {
    const s = e[o.index];
    if (n && s > 0 || !n && s < 0)
      return o.index;
  }
  return null;
}
function Dm(e, t) {
  const { chart: n, _cachedMeta: r } = e, o = n._stacks || (n._stacks = {}), { iScale: s, vScale: i, index: a } = r, c = s.axis, l = i.axis, u = LP(s, i, r), d = t.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = t[h], { [c]: g, [l]: m } = p, y = p._stacks || (p._stacks = {});
    f = y[l] = WP(o, u, g), f[a] = m, f._top = Im(f, i, !0, r.type), f._bottom = Im(f, i, !1, r.type);
    const v = f._visualValues || (f._visualValues = {});
    v[a] = m;
  }
}
function zu(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function BP(e, t) {
  return wo(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function HP(e, t, n) {
  return wo(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function Ks(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const o of t) {
      const s = o._stacks;
      if (!s || s[r] === void 0 || s[r][n] === void 0)
        return;
      delete s[r][n], s[r]._visualValues !== void 0 && s[r]._visualValues[n] !== void 0 && delete s[r]._visualValues[n];
    }
  }
}
const ju = (e) => e === "reset" || e === "none", Nm = (e, t) => t ? e : Object.assign({}, e), YP = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: u1(n, !0),
  values: null
};
class Wo {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = Rm(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && Ks(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, s = n.xAxisID = ut(r.xAxisID, zu(t, "x")), i = n.yAxisID = ut(r.yAxisID, zu(t, "y")), a = n.rAxisID = ut(r.rAxisID, zu(t, "r")), c = n.indexAxis, l = n.iAxisID = o(c, s, i, a), u = n.vAxisID = o(c, i, s, a);
    n.xScale = this.getScaleForId(s), n.yScale = this.getScaleForId(i), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(l), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && pm(this._data, this), t._stacked && Ks(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (at(n))
      this._data = FP(n);
    else if (r !== n) {
      if (r) {
        pm(r, this);
        const o = this._cachedMeta;
        Ks(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && x2(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const s = n._stacked;
    n._stacked = Rm(n.vScale, n), n.stack !== r.stack && (o = !0, Ks(n), n.stack = r.stack), this._resyncElements(t), (o || s !== n._stacked) && Dm(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: s, _stacked: i } = r, a = s.axis;
    let c = t === 0 && n === o.length ? !0 : r._sorted, l = t > 0 && r._parsed[t - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Ft(o[t]) ? f = this.parseArrayData(r, o, t, n) : at(o[t]) ? f = this.parseObjectData(r, o, t, n) : f = this.parsePrimitiveData(r, o, t, n);
      const h = () => d[a] === null || l && d[a] < l[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + t] = d = f[u], c && (h() && (c = !1), l = d);
      r._sorted = c;
    }
    i && Dm(this, f);
  }
  parsePrimitiveData(t, n, r, o) {
    const { iScale: s, vScale: i } = t, a = s.axis, c = i.axis, l = s.getLabels(), u = s === i, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || s.parse(l[p], p),
        [c]: i.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(t, n, r, o) {
    const { xScale: s, yScale: i } = t, a = new Array(o);
    let c, l, u, d;
    for (c = 0, l = o; c < l; ++c)
      u = c + r, d = n[u], a[c] = {
        x: s.parse(d[0], u),
        y: i.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(t, n, r, o) {
    const { xScale: s, yScale: i } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, l = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], l[u] = {
        x: s.parse(zo(h, a), f),
        y: i.parse(zo(h, c), f)
      };
    return l;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const o = this.chart, s = this._cachedMeta, i = n[t.axis], a = {
      keys: u1(o, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return Pm(a, i, s.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, n, r, o) {
    const s = r[n.axis];
    let i = s === null ? NaN : s;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, i = Pm(o, s, this._cachedMeta.index)), t.min = Math.min(t.min, i), t.max = Math.max(t.max, i);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, o = r._parsed, s = r._sorted && t === r.iScale, i = o.length, a = this._getOtherScale(t), c = YP(n, r, this.chart), l = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = VP(a);
    let f, h;
    function p() {
      h = o[f];
      const g = h[a.axis];
      return !tn(h[t.axis]) || u > g || d < g;
    }
    for (f = 0; f < i && !(!p() && (this.updateRangeFromParsed(l, t, h, c), s)); ++f)
      ;
    if (s) {
      for (f = i - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(l, t, h, c);
          break;
        }
    }
    return l;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let o, s, i;
    for (o = 0, s = n.length; o < s; ++o)
      i = n[o][t.axis], tn(i) && r.push(i);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, s = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(s[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(s[o.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = $P(ut(this.options.clip, AP(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], s = n.chartArea, i = [], a = this._drawStart || 0, c = this._drawCount || o.length - a, l = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(t, s, a, c), u = a; u < a + c; ++u) {
      const d = o[u];
      d.hidden || (d.active && l ? i.push(d) : d.draw(t, s));
    }
    for (u = 0; u < i.length; ++u)
      i[u].draw(t, s);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const o = this.getDataset();
    let s;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const i = this._cachedMeta.data[t];
      s = i.$context || (i.$context = HP(this.getContext(), t, i)), s.parsed = this.getParsed(t), s.raw = o.data[t], s.index = s.dataIndex = t;
    } else
      s = this.$context || (this.$context = BP(this.chart.getContext(), this.index)), s.dataset = o, s.index = s.datasetIndex = this.index;
    return s.active = !!n, s.mode = r, s;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const o = n === "active", s = this._cachedDataOpts, i = t + "-" + n, a = s[i], c = this.enableOptionSharing && Wi(r);
    if (a)
      return Nm(a, c);
    const l = this.chart.config, u = l.datasetElementScopeKeys(this._type, t), d = o ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = l.getOptionScopes(this.getDataset(), u), h = Object.keys(zt.elements[t]), p = () => this.getContext(r, o, n), g = l.resolveNamedOptions(f, h, p, d);
    return g.$shared && (g.$shared = c, s[i] = Object.freeze(Nm(g, c))), g;
  }
  _resolveAnimations(t, n, r) {
    const o = this.chart, s = this._cachedDataOpts, i = `animation-${n}`, a = s[i];
    if (a)
      return a;
    let c;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      c = u.createResolver(f, this.getContext(t, r, n));
    }
    const l = new l1(o, c && c.animations);
    return c && c._cacheable && (s[i] = Object.freeze(l)), l;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || ju(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), o = this._sharedOptions, s = this.getSharedOptions(r), i = this.includeOptions(n, s) || s !== o;
    return this.updateSharedOptions(s, n, r), {
      sharedOptions: s,
      includeOptions: i
    };
  }
  updateElement(t, n, r, o) {
    ju(o) ? Object.assign(t, r) : this._resolveAnimations(n, o).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !ju(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, o) {
    t.active = o;
    const s = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(t, {
      options: !o && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, c, l] of this._syncList)
      this[a](c, l);
    this._syncList = [];
    const o = r.length, s = n.length, i = Math.min(s, o);
    i && this.parse(0, i), s > o ? this._insertElements(o, s - o, t) : s < o && this._removeElements(s, o - s);
  }
  _insertElements(t, n, r = !0) {
    const o = this._cachedMeta, s = o.data, i = t + n;
    let a;
    const c = (l) => {
      for (l.length += n, a = l.length - 1; a >= i; a--)
        l[a] = l[a - n];
    };
    for (c(s), a = t; a < i; ++a)
      s[a] = new this.dataElementType();
    this._parsing && c(o._parsed), this.parse(t, n), r && this.updateElements(s, t, n, "reset");
  }
  updateElements(t, n, r, o) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(t, n);
      r._stacked && Ks(r, o);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, o] = t;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ae(Wo, "defaults", {}), ae(Wo, "datasetElementType", null), ae(Wo, "dataElementType", null);
function zP(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let o = 0, s = n.length; o < s; o++)
      r = r.concat(n[o].controller.getAllParsedValues(e));
    e._cache.$bar = qy(r.sort((o, s) => o - s));
  }
  return e._cache.$bar;
}
function jP(e) {
  const t = e.iScale, n = zP(t, e.type);
  let r = t._length, o, s, i, a;
  const c = () => {
    i === 32767 || i === -32768 || (Wi(a) && (r = Math.min(r, Math.abs(i - a) || r)), a = i);
  };
  for (o = 0, s = n.length; o < s; ++o)
    i = t.getPixelForValue(n[o]), c();
  for (a = void 0, o = 0, s = t.ticks.length; o < s; ++o)
    i = t.getPixelForTick(o), c();
  return r;
}
function UP(e, t, n, r) {
  const o = n.barThickness;
  let s, i;
  return yt(o) ? (s = t.min * n.categoryPercentage, i = n.barPercentage) : (s = o * r, i = 1), {
    chunk: s / r,
    ratio: i,
    start: t.pixels[e] - s / 2
  };
}
function GP(e, t, n, r) {
  const o = t.pixels, s = o[e];
  let i = e > 0 ? o[e - 1] : null, a = e < o.length - 1 ? o[e + 1] : null;
  const c = n.categoryPercentage;
  i === null && (i = s - (a === null ? t.end - t.start : a - s)), a === null && (a = s + s - i);
  const l = s - (s - Math.min(i, a)) / 2 * c;
  return {
    chunk: Math.abs(a - i) / 2 * c / r,
    ratio: n.barPercentage,
    start: l
  };
}
function KP(e, t, n, r) {
  const o = n.parse(e[0], r), s = n.parse(e[1], r), i = Math.min(o, s), a = Math.max(o, s);
  let c = i, l = a;
  Math.abs(i) > Math.abs(a) && (c = a, l = i), t[n.axis] = l, t._custom = {
    barStart: c,
    barEnd: l,
    start: o,
    end: s,
    min: i,
    max: a
  };
}
function d1(e, t, n, r) {
  return Ft(e) ? KP(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function Am(e, t, n, r) {
  const o = e.iScale, s = e.vScale, i = o.getLabels(), a = o === s, c = [];
  let l, u, d, f;
  for (l = n, u = n + r; l < u; ++l)
    f = t[l], d = {}, d[o.axis] = a || o.parse(i[l], l), c.push(d1(f, d, s, l));
  return c;
}
function Uu(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function qP(e, t, n) {
  return e !== 0 ? gr(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function XP(e) {
  let t, n, r, o, s;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (o = "end", s = "start") : (o = "start", s = "end"), {
    start: n,
    end: r,
    reverse: t,
    top: o,
    bottom: s
  };
}
function ZP(e, t, n, r) {
  let o = t.borderSkipped;
  const s = {};
  if (!o) {
    e.borderSkipped = s;
    return;
  }
  if (o === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: i, end: a, reverse: c, top: l, bottom: u } = XP(e);
  o === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? o = l : (n._bottom || 0) === r ? o = u : (s[$m(u, i, a, c)] = !0, o = l)), s[$m(o, i, a, c)] = !0, e.borderSkipped = s;
}
function $m(e, t, n, r) {
  return r ? (e = QP(e, t, n), e = Fm(e, n, t)) : e = Fm(e, t, n), e;
}
function QP(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function Fm(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function JP(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class hc extends Wo {
  parsePrimitiveData(t, n, r, o) {
    return Am(t, n, r, o);
  }
  parseArrayData(t, n, r, o) {
    return Am(t, n, r, o);
  }
  parseObjectData(t, n, r, o) {
    const { iScale: s, vScale: i } = t, { xAxisKey: a = "x", yAxisKey: c = "y" } = this._parsing, l = s.axis === "x" ? a : c, u = i.axis === "x" ? a : c, d = [];
    let f, h, p, g;
    for (f = r, h = r + o; f < h; ++f)
      g = n[f], p = {}, p[s.axis] = s.parse(zo(g, l), f), d.push(d1(zo(g, u), p, i, f));
    return d;
  }
  updateRangeFromParsed(t, n, r, o) {
    super.updateRangeFromParsed(t, n, r, o);
    const s = r._custom;
    s && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, s.min), t.max = Math.max(t.max, s.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, s = this.getParsed(t), i = s._custom, a = Uu(i) ? "[" + i.start + ", " + i.end + "]" : "" + o.getLabelForValue(s[o.axis]);
    return {
      label: "" + r.getLabelForValue(s[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", { index: i, _cachedMeta: { vScale: a } } = this, c = a.getBasePixel(), l = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), g = s || yt(p[a.axis]) ? {
        base: c,
        head: c
      } : this._calculateBarValuePixels(h), m = this._calculateBarIndexPixels(h, u), y = (p._stacks || {})[a.axis], v = {
        horizontal: l,
        base: g.base,
        enableBorderRadius: !y || Uu(p._custom) || i === y._top || i === y._bottom,
        x: l ? g.head : m.center,
        y: l ? m.center : g.head,
        height: l ? m.size : Math.abs(g.size),
        width: l ? Math.abs(g.size) : m.size
      };
      f && (v.options = d || this.resolveDataElementOptions(h, t[h].active ? "active" : o));
      const w = v.options || t[h].options;
      ZP(v, w, y, i), JP(v, w, u.ratio), this.updateElement(t[h], h, v, o);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((c) => c.controller.options.grouped), s = r.options.stacked, i = [], a = (c) => {
      const l = c.controller.getParsed(n), u = l && l[c.vScale.axis];
      if (yt(u) || isNaN(u))
        return !0;
    };
    for (const c of o)
      if (!(n !== void 0 && a(c)) && ((s === !1 || i.indexOf(c.stack) === -1 || s === void 0 && c.stack === void 0) && i.push(c.stack), c.index === t))
        break;
    return i.length || i.push(void 0), i;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const o = this._getStacks(t, r), s = n !== void 0 ? o.indexOf(n) : -1;
    return s === -1 ? o.length - 1 : s;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let s, i;
    for (s = 0, i = n.data.length; s < i; ++s)
      o.push(r.getPixelForValue(this.getParsed(s)[r.axis], s));
    const a = t.barThickness;
    return {
      min: a || jP(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: a ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: s, minBarLength: i } } = this, a = s || 0, c = this.getParsed(t), l = c._custom, u = Uu(l);
    let d = c[n.axis], f = 0, h = r ? this.applyStack(n, c, r) : d, p, g;
    h !== d && (f = h - d, h = d), u && (d = l.barStart, h = l.barEnd - l.barStart, d !== 0 && gr(d) !== gr(l.barEnd) && (f = 0), f += d);
    const m = !yt(s) && !u ? s : f;
    let y = n.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? p = n.getPixelForValue(f + h) : p = y, g = p - y, Math.abs(g) < i) {
      g = qP(g, n, a) * i, d === a && (y -= g / 2);
      const v = n.getPixelForDecimal(0), w = n.getPixelForDecimal(1), C = Math.min(v, w), x = Math.max(v, w);
      y = Math.max(Math.min(y, x), C), p = y + g, r && !u && (c._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(y));
    }
    if (y === n.getPixelForValue(a)) {
      const v = gr(g) * n.getLineWidthForValue(a) / 2;
      y += v, g -= v;
    }
    return {
      size: g,
      base: y,
      head: p,
      center: p + g / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, o = this.options, s = o.skipNull, i = ut(o.maxBarThickness, 1 / 0);
    let a, c;
    if (n.grouped) {
      const l = s ? this._getStackCount(t) : n.stackCount, u = o.barThickness === "flex" ? GP(t, n, o, l) : UP(t, n, o, l), d = this._getStackIndex(this.index, this._cachedMeta.stack, s ? t : void 0);
      a = u.start + u.chunk * d + u.chunk / 2, c = Math.min(i, u.chunk * u.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(t)[r.axis], t), c = Math.min(i, n.min * n.ratio);
    return {
      base: a - c / 2,
      head: a + c / 2,
      center: a,
      size: c
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, o = r.length;
    let s = 0;
    for (; s < o; ++s)
      this.getParsed(s)[n.axis] !== null && r[s].draw(this._ctx);
  }
}
ae(hc, "id", "bar"), ae(hc, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ae(hc, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function eR(e, t, n) {
  let r = 1, o = 1, s = 0, i = 0;
  if (t < Nt) {
    const a = e, c = a + t, l = Math.cos(a), u = Math.sin(a), d = Math.cos(c), f = Math.sin(c), h = (w, C, x) => Hi(w, a, c, !0) ? 1 : Math.max(C, C * n, x, x * n), p = (w, C, x) => Hi(w, a, c, !0) ? -1 : Math.min(C, C * n, x, x * n), g = h(0, l, d), m = h(Wt, u, f), y = p(Gt, l, d), v = p(Gt + Wt, u, f);
    r = (g - y) / 2, o = (m - v) / 2, s = -(g + y) / 2, i = -(m + v) / 2;
  }
  return {
    ratioX: r,
    ratioY: o,
    offsetX: s,
    offsetY: i
  };
}
class fi extends Wo {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, o = this._cachedMeta;
    if (this._parsing === !1)
      o._parsed = r;
    else {
      let s = (c) => +r[c];
      if (at(r[t])) {
        const { key: c = "value" } = this._parsing;
        s = (l) => +zo(r[l], c);
      }
      let i, a;
      for (i = t, a = t + n; i < a; ++i)
        o._parsed[i] = s(i);
    }
  }
  _getRotation() {
    return lr(this.options.rotation - 90);
  }
  _getCircumference() {
    return lr(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Nt, n = -Nt;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const o = this.chart.getDatasetMeta(r).controller, s = o._getRotation(), i = o._getCircumference();
        t = Math.min(t, s), n = Math.max(n, s + i);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, o = this._cachedMeta, s = o.data, i = this.getMaxBorderWidth() + this.getMaxOffset(s) + this.options.spacing, a = Math.max((Math.min(r.width, r.height) - i) / 2, 0), c = Math.min(a2(this.options.cutout, a), 1), l = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: g } = eR(d, u, c), m = (r.width - i) / f, y = (r.height - i) / h, v = Math.max(Math.min(m, y) / 2, 0), w = zy(this.options.radius, v), C = Math.max(w * c, 0), x = (w - C) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * w, this.offsetY = g * w, o.total = this.calculateTotal(), this.outerRadius = w - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * l, 0), this.updateElements(s, 0, s.length, t);
  }
  _circumference(t, n) {
    const r = this.options, o = this._cachedMeta, s = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || o._parsed[t] === null || o.data[t].hidden ? 0 : this.calculateCircumference(o._parsed[t] * s / Nt);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", i = this.chart, a = i.chartArea, l = i.options.animation, u = (a.left + a.right) / 2, d = (a.top + a.bottom) / 2, f = s && l.animateScale, h = f ? 0 : this.innerRadius, p = f ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: m } = this._getSharedOptions(n, o);
    let y = this._getRotation(), v;
    for (v = 0; v < n; ++v)
      y += this._circumference(v, s);
    for (v = n; v < n + r; ++v) {
      const w = this._circumference(v, s), C = t[v], x = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: y,
        endAngle: y + w,
        circumference: w,
        outerRadius: p,
        innerRadius: h
      };
      m && (x.options = g || this.resolveDataElementOptions(v, C.active ? "active" : o)), y += w, this.updateElement(C, v, x, o);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, o;
    for (o = 0; o < n.length; o++) {
      const s = t._parsed[o];
      s !== null && !isNaN(s) && this.chart.getDataVisibility(o) && !n[o].hidden && (r += Math.abs(s));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? Nt * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, o = r.data.labels || [], s = eu(n._parsed[t], r.options.locale);
    return {
      label: o[t] || "",
      value: s
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let o, s, i, a, c;
    if (!t) {
      for (o = 0, s = r.data.datasets.length; o < s; ++o)
        if (r.isDatasetVisible(o)) {
          i = r.getDatasetMeta(o), t = i.data, a = i.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (o = 0, s = t.length; o < s; ++o)
      c = a.resolveDataElementOptions(o), c.borderAlign !== "inner" && (n = Math.max(n, c.borderWidth || 0, c.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, o = t.length; r < o; ++r) {
      const s = this.resolveDataElementOptions(r);
      n = Math.max(n, s.offset || 0, s.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(ut(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ae(fi, "id", "doughnut"), ae(fi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ae(fi, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), ae(fi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: r, color: o } } = t.legend.options;
            return n.labels.map((s, i) => {
              const c = t.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: s,
                fillStyle: c.backgroundColor,
                strokeStyle: c.borderColor,
                fontColor: o,
                lineWidth: c.borderWidth,
                pointStyle: r,
                hidden: !t.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, r) {
        r.chart.toggleDataVisibility(n.index), r.chart.update();
      }
    }
  }
});
class pc extends Wo {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: s } = n, i = this.chart._animationsDisabled;
    let { start: a, count: c } = _2(n, o, i);
    this._drawStart = a, this._drawCount = c, S2(n) && (a = 0, c = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!s._decimated, r.points = o;
    const l = this.resolveDatasetElementOptions(t);
    this.options.showLine || (l.borderWidth = 0), l.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !i,
      options: l
    }, t), this.updateElements(o, a, c, t);
  }
  updateElements(t, n, r, o) {
    const s = o === "reset", { iScale: i, vScale: a, _stacked: c, _dataset: l } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = i.axis, h = a.axis, { spanGaps: p, segment: g } = this.options, m = Bi(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || s || o === "none", v = n + r, w = t.length;
    let C = n > 0 && this.getParsed(n - 1);
    for (let x = 0; x < w; ++x) {
      const E = t[x], S = y ? E : {};
      if (x < n || x >= v) {
        S.skip = !0;
        continue;
      }
      const M = this.getParsed(x), T = yt(M[h]), P = S[f] = i.getPixelForValue(M[f], x), k = S[h] = s || T ? a.getBasePixel() : a.getPixelForValue(c ? this.applyStack(a, M, c) : M[h], x);
      S.skip = isNaN(P) || isNaN(k) || T, S.stop = x > 0 && Math.abs(M[f] - C[f]) > m, g && (S.parsed = M, S.raw = l.data[x]), d && (S.options = u || this.resolveDataElementOptions(x, E.active ? "active" : o)), y || this.updateElement(E, x, S, o), C = M;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, o = t.data || [];
    if (!o.length)
      return r;
    const s = o[0].size(this.resolveDataElementOptions(0)), i = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, s, i) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
ae(pc, "id", "line"), ae(pc, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ae(pc, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function Mo() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class jh {
  constructor(t) {
    ae(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(jh.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Mo();
  }
  parse() {
    return Mo();
  }
  format() {
    return Mo();
  }
  add() {
    return Mo();
  }
  diff() {
    return Mo();
  }
  startOf() {
    return Mo();
  }
  endOf() {
    return Mo();
  }
}
var f1 = {
  _date: jh
};
function tR(e, t, n, r) {
  const { controller: o, data: s, _sorted: i } = e, a = o._cachedMeta.iScale;
  if (a && t === a.axis && t !== "r" && i && s.length) {
    const c = a._reversePixels ? y2 : Fo;
    if (r) {
      if (o._sharedOptions) {
        const l = s[0], u = typeof l.getRange == "function" && l.getRange(t);
        if (u) {
          const d = c(s, t, n - u), f = c(s, t, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else
      return c(s, t, n);
  }
  return {
    lo: 0,
    hi: s.length - 1
  };
}
function oa(e, t, n, r, o) {
  const s = e.getSortedVisibleDatasetMetas(), i = n[t];
  for (let a = 0, c = s.length; a < c; ++a) {
    const { index: l, data: u } = s[a], { lo: d, hi: f } = tR(s[a], t, i, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, l, h);
    }
  }
}
function nR(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, o) {
    const s = t ? Math.abs(r.x - o.x) : 0, i = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(i, 2));
  };
}
function Gu(e, t, n, r, o) {
  const s = [];
  return !o && !e.isPointInArea(t) || oa(e, n, t, function(a, c, l) {
    !o && !Dr(a, e.chartArea, 0) || a.inRange(t.x, t.y, r) && s.push({
      element: a,
      datasetIndex: c,
      index: l
    });
  }, !0), s;
}
function rR(e, t, n, r) {
  let o = [];
  function s(i, a, c) {
    const { startAngle: l, endAngle: u } = i.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = Gy(i, {
      x: t.x,
      y: t.y
    });
    Hi(d, l, u) && o.push({
      element: i,
      datasetIndex: a,
      index: c
    });
  }
  return oa(e, n, t, s), o;
}
function oR(e, t, n, r, o, s) {
  let i = [];
  const a = nR(n);
  let c = Number.POSITIVE_INFINITY;
  function l(u, d, f) {
    const h = u.inRange(t.x, t.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(!!s || e.isPointInArea(p)) && !h)
      return;
    const m = a(t, p);
    m < c ? (i = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], c = m) : m === c && i.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return oa(e, n, t, l), i;
}
function Ku(e, t, n, r, o, s) {
  return !s && !e.isPointInArea(t) ? [] : n === "r" && !r ? rR(e, t, n, o) : oR(e, t, n, r, o, s);
}
function Lm(e, t, n, r, o) {
  const s = [], i = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return oa(e, n, t, (c, l, u) => {
    c[i](t[n], o) && (s.push({
      element: c,
      datasetIndex: l,
      index: u
    }), a = a || c.inRange(t.x, t.y, o));
  }), r && !a ? [] : s;
}
var sR = {
  evaluateInteractionItems: oa,
  modes: {
    index(e, t, n, r) {
      const o = Po(t, e), s = n.axis || "x", i = n.includeInvisible || !1, a = n.intersect ? Gu(e, o, s, r, i) : Ku(e, o, s, !1, r, i), c = [];
      return a.length ? (e.getSortedVisibleDatasetMetas().forEach((l) => {
        const u = a[0].index, d = l.data[u];
        d && !d.skip && c.push({
          element: d,
          datasetIndex: l.index,
          index: u
        });
      }), c) : [];
    },
    dataset(e, t, n, r) {
      const o = Po(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      let a = n.intersect ? Gu(e, o, s, r, i) : Ku(e, o, s, !1, r, i);
      if (a.length > 0) {
        const c = a[0].datasetIndex, l = e.getDatasetMeta(c).data;
        a = [];
        for (let u = 0; u < l.length; ++u)
          a.push({
            element: l[u],
            datasetIndex: c,
            index: u
          });
      }
      return a;
    },
    point(e, t, n, r) {
      const o = Po(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      return Gu(e, o, s, r, i);
    },
    nearest(e, t, n, r) {
      const o = Po(t, e), s = n.axis || "xy", i = n.includeInvisible || !1;
      return Ku(e, o, s, n.intersect, r, i);
    },
    x(e, t, n, r) {
      const o = Po(t, e);
      return Lm(e, o, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const o = Po(t, e);
      return Lm(e, o, "y", n.intersect, r);
    }
  }
};
const h1 = [
  "left",
  "top",
  "right",
  "bottom"
];
function qs(e, t) {
  return e.filter((n) => n.pos === t);
}
function Vm(e, t) {
  return e.filter((n) => h1.indexOf(n.pos) === -1 && n.box.axis === t);
}
function Xs(e, t) {
  return e.sort((n, r) => {
    const o = t ? r : n, s = t ? n : r;
    return o.weight === s.weight ? o.index - s.index : o.weight - s.weight;
  });
}
function iR(e) {
  const t = [];
  let n, r, o, s, i, a;
  for (n = 0, r = (e || []).length; n < r; ++n)
    o = e[n], { position: s, options: { stack: i, stackWeight: a = 1 } } = o, t.push({
      index: n,
      box: o,
      pos: s,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: i && s + i,
      stackWeight: a
    });
  return t;
}
function aR(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: o, stackWeight: s } = n;
    if (!r || !h1.includes(o))
      continue;
    const i = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    i.count++, i.weight += s;
  }
  return t;
}
function cR(e, t) {
  const n = aR(e), { vBoxMaxWidth: r, hBoxMaxHeight: o } = t;
  let s, i, a;
  for (s = 0, i = e.length; s < i; ++s) {
    a = e[s];
    const { fullSize: c } = a.box, l = n[a.stack], u = l && a.stackWeight / l.weight;
    a.horizontal ? (a.width = u ? u * r : c && t.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : c && t.availableHeight);
  }
  return n;
}
function lR(e) {
  const t = iR(e), n = Xs(t.filter((l) => l.box.fullSize), !0), r = Xs(qs(t, "left"), !0), o = Xs(qs(t, "right")), s = Xs(qs(t, "top"), !0), i = Xs(qs(t, "bottom")), a = Vm(t, "x"), c = Vm(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(s),
    rightAndBottom: o.concat(c).concat(i).concat(a),
    chartArea: qs(t, "chartArea"),
    vertical: r.concat(o).concat(c),
    horizontal: s.concat(i).concat(a)
  };
}
function Wm(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function p1(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function uR(e, t, n, r) {
  const { pos: o, box: s } = n, i = e.maxPadding;
  if (!at(o)) {
    n.size && (e[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? s.height : s.width), n.size = d.size / d.count, e[o] += n.size;
  }
  s.getPadding && p1(i, s.getPadding());
  const a = Math.max(0, t.outerWidth - Wm(i, e, "left", "right")), c = Math.max(0, t.outerHeight - Wm(i, e, "top", "bottom")), l = a !== e.w, u = c !== e.h;
  return e.w = a, e.h = c, n.horizontal ? {
    same: l,
    other: u
  } : {
    same: u,
    other: l
  };
}
function dR(e) {
  const t = e.maxPadding;
  function n(r) {
    const o = Math.max(t[r] - e[r], 0);
    return e[r] += o, o;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function fR(e, t) {
  const n = t.maxPadding;
  function r(o) {
    const s = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((i) => {
      s[i] = Math.max(t[i], n[i]);
    }), s;
  }
  return r(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function hi(e, t, n, r) {
  const o = [];
  let s, i, a, c, l, u;
  for (s = 0, i = e.length, l = 0; s < i; ++s) {
    a = e[s], c = a.box, c.update(a.width || t.w, a.height || t.h, fR(a.horizontal, t));
    const { same: d, other: f } = uR(t, n, a, r);
    l |= d && o.length, u = u || f, c.fullSize || o.push(a);
  }
  return l && hi(o, t, n, r) || u;
}
function Wa(e, t, n, r, o) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + o, e.width = r, e.height = o;
}
function Bm(e, t, n, r) {
  const o = n.padding;
  let { x: s, y: i } = t;
  for (const a of e) {
    const c = a.box, l = r[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / l.weight || 1;
    if (a.horizontal) {
      const d = t.w * u, f = l.size || c.height;
      Wi(l.start) && (i = l.start), c.fullSize ? Wa(c, o.left, i, n.outerWidth - o.right - o.left, f) : Wa(c, t.left + l.placed, i, d, f), l.start = i, l.placed += d, i = c.bottom;
    } else {
      const d = t.h * u, f = l.size || c.width;
      Wi(l.start) && (s = l.start), c.fullSize ? Wa(c, s, o.top, f, n.outerHeight - o.bottom - o.top) : Wa(c, s, t.top + l.placed, f, d), l.start = s, l.placed += d, s = c.right;
    }
  }
  t.x = s, t.y = i;
}
var Ba = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const o = zn(e.options.layout.padding), s = Math.max(t - o.width, 0), i = Math.max(n - o.height, 0), a = lR(e.boxes), c = a.vertical, l = a.horizontal;
    bt(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = c.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: o,
      availableWidth: s,
      availableHeight: i,
      vBoxMaxWidth: s / 2 / u,
      hBoxMaxHeight: i / 2
    }), f = Object.assign({}, o);
    p1(f, zn(r));
    const h = Object.assign({
      maxPadding: f,
      w: s,
      h: i,
      x: o.left,
      y: o.top
    }, o), p = cR(c.concat(l), d);
    hi(a.fullSize, h, d, p), hi(c, h, d, p), hi(l, h, d, p) && hi(c, h, d, p), dR(h), Bm(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, Bm(a.rightAndBottom, h, d, p), e.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, bt(a.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, e.chartArea), m.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class g1 {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, o) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class hR extends g1 {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const gc = "$chartjs", pR = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Hm = (e) => e === null || e === "";
function gR(e, t) {
  const n = e.style, r = e.getAttribute("height"), o = e.getAttribute("width");
  if (e[gc] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Hm(o)) {
    const s = _m(e, "width");
    s !== void 0 && (e.width = s);
  }
  if (Hm(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const s = _m(e, "height");
      s !== void 0 && (e.height = s);
    }
  return e;
}
const m1 = gP ? {
  passive: !0
} : !1;
function mR(e, t, n) {
  e.addEventListener(t, n, m1);
}
function bR(e, t, n) {
  e.canvas.removeEventListener(t, n, m1);
}
function vR(e, t) {
  const n = pR[e.type] || e.type, { x: r, y: o } = Po(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function qc(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function yR(e, t, n) {
  const r = e.canvas, o = new MutationObserver((s) => {
    let i = !1;
    for (const a of s)
      i = i || qc(a.addedNodes, r), i = i && !qc(a.removedNodes, r);
    i && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function wR(e, t, n) {
  const r = e.canvas, o = new MutationObserver((s) => {
    let i = !1;
    for (const a of s)
      i = i || qc(a.removedNodes, r), i = i && !qc(a.addedNodes, r);
    i && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const Yi = /* @__PURE__ */ new Map();
let Ym = 0;
function b1() {
  const e = window.devicePixelRatio;
  e !== Ym && (Ym = e, Yi.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function xR(e, t) {
  Yi.size || window.addEventListener("resize", b1), Yi.set(e, t);
}
function CR(e) {
  Yi.delete(e), Yi.size || window.removeEventListener("resize", b1);
}
function ER(e, t, n) {
  const r = e.canvas, o = r && zh(r);
  if (!o)
    return;
  const s = Zy((a, c) => {
    const l = o.clientWidth;
    n(a, c), l < o.clientWidth && n();
  }, window), i = new ResizeObserver((a) => {
    const c = a[0], l = c.contentRect.width, u = c.contentRect.height;
    l === 0 && u === 0 || s(l, u);
  });
  return i.observe(o), xR(e, s), i;
}
function qu(e, t, n) {
  n && n.disconnect(), t === "resize" && CR(e);
}
function _R(e, t, n) {
  const r = e.canvas, o = Zy((s) => {
    e.ctx !== null && n(vR(s, e));
  }, e);
  return mR(r, t, o), o;
}
class SR extends g1 {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (gR(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[gc])
      return !1;
    const r = n[gc].initial;
    [
      "height",
      "width"
    ].forEach((s) => {
      const i = r[s];
      yt(i) ? n.removeAttribute(s) : n.setAttribute(s, i);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((s) => {
      n.style[s] = o[s];
    }), n.width = n.width, delete n[gc], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const o = t.$proxies || (t.$proxies = {}), i = {
      attach: yR,
      detach: wR,
      resize: ER
    }[n] || _R;
    o[n] = i(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), o = r[n];
    if (!o)
      return;
    ({
      attach: qu,
      detach: qu,
      resize: qu
    }[n] || bR)(t, n, o), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, o) {
    return pP(t, n, r, o);
  }
  isAttached(t) {
    const n = zh(t);
    return !!(n && n.isConnected);
  }
}
function OR(e) {
  return !a1() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? hR : SR;
}
var cc;
let qo = (cc = class {
  constructor() {
    ae(this, "x");
    ae(this, "y");
    ae(this, "active", !1);
    ae(this, "options");
    ae(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return Bi(this.x) && Bi(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const o = {};
    return t.forEach((s) => {
      o[s] = r[s] && r[s].active() ? r[s]._to : this[s];
    }), o;
  }
}, ae(cc, "defaults", {}), ae(cc, "defaultRoutes"), cc);
function MR(e, t) {
  const n = e.options.ticks, r = TR(e), o = Math.min(n.maxTicksLimit || r, r), s = n.major.enabled ? PR(t) : [], i = s.length, a = s[0], c = s[i - 1], l = [];
  if (i > o)
    return RR(t, l, s, i / o), l;
  const u = kR(s, t, o);
  if (i > 0) {
    let d, f;
    const h = i > 1 ? Math.round((c - a) / (i - 1)) : null;
    for (Ha(t, l, u, yt(h) ? 0 : a - h, a), d = 0, f = i - 1; d < f; d++)
      Ha(t, l, u, s[d], s[d + 1]);
    return Ha(t, l, u, c, yt(h) ? t.length : c + h), l;
  }
  return Ha(t, l, u), l;
}
function TR(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), o = e._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function kR(e, t, n) {
  const r = IR(e), o = t.length / n;
  if (!r)
    return Math.max(o, 1);
  const s = g2(r);
  for (let i = 0, a = s.length - 1; i < a; i++) {
    const c = s[i];
    if (c > o)
      return c;
  }
  return Math.max(o, 1);
}
function PR(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function RR(e, t, n, r) {
  let o = 0, s = n[0], i;
  for (r = Math.ceil(r), i = 0; i < e.length; i++)
    i === s && (t.push(e[i]), o++, s = n[o * r]);
}
function Ha(e, t, n, r, o) {
  const s = ut(r, 0), i = Math.min(ut(o, e.length), e.length);
  let a = 0, c, l, u;
  for (n = Math.ceil(n), o && (c = o - r, n = c / Math.floor(c / n)), u = s; u < 0; )
    a++, u = Math.round(s + a * n);
  for (l = Math.max(s, 0); l < i; l++)
    l === u && (t.push(e[l]), a++, u = Math.round(s + a * n));
}
function IR(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const DR = (e) => e === "left" ? "right" : e === "right" ? "left" : e, zm = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, jm = (e, t) => Math.min(t || e, e);
function Um(e, t) {
  const n = [], r = e.length / t, o = e.length;
  let s = 0;
  for (; s < o; s += r)
    n.push(e[Math.floor(s)]);
  return n;
}
function NR(e, t, n) {
  const r = e.ticks.length, o = Math.min(t, r - 1), s = e._startPixel, i = e._endPixel, a = 1e-6;
  let c = e.getPixelForTick(o), l;
  if (!(n && (r === 1 ? l = Math.max(c - s, i - c) : t === 0 ? l = (e.getPixelForTick(1) - c) / 2 : l = (c - e.getPixelForTick(o - 1)) / 2, c += o < t ? l : -l, c < s - a || c > i + a)))
    return c;
}
function AR(e, t) {
  bt(e, (n) => {
    const r = n.gc, o = r.length / 2;
    let s;
    if (o > t) {
      for (s = 0; s < o; ++s)
        delete n.data[r[s]];
      r.splice(0, o);
    }
  });
}
function Zs(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function Gm(e, t) {
  if (!e.display)
    return 0;
  const n = In(e.font, t), r = zn(e.padding);
  return (Ft(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function $R(e, t) {
  return wo(e, {
    scale: t,
    type: "scale"
  });
}
function FR(e, t, n) {
  return wo(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function LR(e, t, n) {
  let r = E2(e);
  return (n && t !== "right" || !n && t === "right") && (r = DR(r)), r;
}
function VR(e, t, n, r) {
  const { top: o, left: s, bottom: i, right: a, chart: c } = e, { chartArea: l, scales: u } = c;
  let d = 0, f, h, p;
  const g = i - o, m = a - s;
  if (e.isHorizontal()) {
    if (h = gm(r, s, a), at(n)) {
      const y = Object.keys(n)[0], v = n[y];
      p = u[y].getPixelForValue(v) + g - t;
    } else
      n === "center" ? p = (l.bottom + l.top) / 2 + g - t : p = zm(e, n, t);
    f = a - s;
  } else {
    if (at(n)) {
      const y = Object.keys(n)[0], v = n[y];
      h = u[y].getPixelForValue(v) - m + t;
    } else
      n === "center" ? h = (l.left + l.right) / 2 - m + t : h = zm(e, n, t);
    p = gm(r, i, o), d = n === "left" ? -Wt : Wt;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class Xo extends qo {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return t = On(t, Number.POSITIVE_INFINITY), n = On(n, Number.NEGATIVE_INFINITY), r = On(r, Number.POSITIVE_INFINITY), o = On(o, Number.NEGATIVE_INFINITY), {
      min: On(t, r),
      max: On(n, o),
      minDefined: tn(t),
      maxDefined: tn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: o, maxDefined: s } = this.getUserBounds(), i;
    if (o && s)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let c = 0, l = a.length; c < l; ++c)
      i = a[c].controller.getMinMax(this, t), o || (n = Math.min(n, i.min)), s || (r = Math.max(r, i.max));
    return n = s && n > r ? r : n, r = o && n > r ? n : r, {
      min: On(n, On(r, n)),
      max: On(r, On(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Vt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, r) {
    const { beginAtZero: o, grace: s, ticks: i } = this.options, a = i.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = U2(this, s, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = a < this.ticks.length;
    this._convertTicksToLabels(c ? Um(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), i.display && (i.autoSkip || i.source === "auto") && (this.ticks = MR(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Vt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Vt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Vt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Vt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Vt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, o, s;
    for (r = 0, o = t.length; r < o; r++)
      s = t[r], s.label = Vt(n.callback, [
        s.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Vt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Vt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = jm(this.ticks.length, t.ticks.maxTicksLimit), o = n.minRotation || 0, s = n.maxRotation;
    let i = o, a, c, l;
    if (!this._isVisible() || !n.display || o >= s || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = cn(this.chart.width - d, 0, this.maxWidth);
    a = t.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (t.offset ? 0.5 : 1)), c = this.maxHeight - Zs(t.grid) - n.padding - Gm(t.title, this.chart.options.font), l = Math.sqrt(d * d + f * f), i = Fh(Math.min(Math.asin(cn((u.highest.height + 6) / a, -1, 1)), Math.asin(cn(c / l, -1, 1)) - Math.asin(cn(f / l, -1, 1)))), i = Math.max(o, Math.min(s, i))), this.labelRotation = i;
  }
  afterCalculateLabelRotation() {
    Vt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Vt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: s } } = this, i = this._isVisible(), a = this.isHorizontal();
    if (i) {
      const c = Gm(o, n.options.font);
      if (a ? (t.width = this.maxWidth, t.height = Zs(s) + c) : (t.height = this.maxHeight, t.width = Zs(s) + c), r.display && this.ticks.length) {
        const { first: l, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = lr(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (a) {
          const y = r.mirror ? 0 : m * d.width + g * f.height;
          t.height = Math.min(this.maxHeight, t.height + y + h);
        } else {
          const y = r.mirror ? 0 : g * d.width + m * f.height;
          t.width = Math.min(this.maxWidth, t.width + y + h);
        }
        this._calculatePadding(l, u, m, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, o) {
    const { ticks: { align: s, padding: i }, position: a } = this.options, c = this.labelRotation !== 0, l = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      c ? l ? (f = o * t.width, h = r * n.height) : (f = r * t.height, h = o * n.width) : s === "start" ? h = n.width : s === "end" ? f = t.width : s !== "inner" && (f = t.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + i) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + i) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = t.height / 2;
      s === "start" ? (u = 0, d = t.height) : s === "end" && (u = n.height, d = 0), this.paddingTop = u + i, this.paddingBottom = d + i;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Vt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      yt(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = Um(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, r) {
    const { ctx: o, _longestTextCache: s } = this, i = [], a = [], c = Math.floor(n / jm(n, r));
    let l = 0, u = 0, d, f, h, p, g, m, y, v, w, C, x;
    for (d = 0; d < n; d += c) {
      if (p = t[d].label, g = this._resolveTickFontOptions(d), o.font = m = g.string, y = s[m] = s[m] || {
        data: {},
        gc: []
      }, v = g.lineHeight, w = C = 0, !yt(p) && !Ft(p))
        w = jc(o, y.data, y.gc, w, p), C = v;
      else if (Ft(p))
        for (f = 0, h = p.length; f < h; ++f)
          x = p[f], !yt(x) && !Ft(x) && (w = jc(o, y.data, y.gc, w, x), C += v);
      i.push(w), a.push(C), l = Math.max(w, l), u = Math.max(C, u);
    }
    AR(s, n);
    const E = i.indexOf(l), S = a.indexOf(u), M = (T) => ({
      width: i[T] || 0,
      height: a[T] || 0
    });
    return {
      first: M(0),
      last: M(n - 1),
      widest: M(E),
      highest: M(S),
      widths: i,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return v2(this._alignToPixels ? Oo(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = FR(this.getContext(), t, r));
    }
    return this.$context || (this.$context = $R(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = lr(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), s = this._getLabelSizes(), i = t.autoSkipPadding || 0, a = s ? s.widest.width + i : 0, c = s ? s.highest.height + i : 0;
    return this.isHorizontal() ? c * r > a * o ? a / r : c / o : c * o < a * r ? c / r : a / o;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, o = this.options, { grid: s, position: i, border: a } = o, c = s.offset, l = this.isHorizontal(), d = this.ticks.length + (c ? 1 : 0), f = Zs(s), h = [], p = a.setContext(this.getContext()), g = p.display ? p.width : 0, m = g / 2, y = function(N) {
      return Oo(r, N, g);
    };
    let v, w, C, x, E, S, M, T, P, k, I, O;
    if (i === "top")
      v = y(this.bottom), S = this.bottom - f, T = v - m, k = y(t.top) + m, O = t.bottom;
    else if (i === "bottom")
      v = y(this.top), k = t.top, O = y(t.bottom) - m, S = v + m, T = this.top + f;
    else if (i === "left")
      v = y(this.right), E = this.right - f, M = v - m, P = y(t.left) + m, I = t.right;
    else if (i === "right")
      v = y(this.left), P = t.left, I = y(t.right) - m, E = v + m, M = this.left + f;
    else if (n === "x") {
      if (i === "center")
        v = y((t.top + t.bottom) / 2 + 0.5);
      else if (at(i)) {
        const N = Object.keys(i)[0], $ = i[N];
        v = y(this.chart.scales[N].getPixelForValue($));
      }
      k = t.top, O = t.bottom, S = v + m, T = S + f;
    } else if (n === "y") {
      if (i === "center")
        v = y((t.left + t.right) / 2);
      else if (at(i)) {
        const N = Object.keys(i)[0], $ = i[N];
        v = y(this.chart.scales[N].getPixelForValue($));
      }
      E = v - m, M = E - f, P = t.left, I = t.right;
    }
    const A = ut(o.ticks.maxTicksLimit, d), R = Math.max(1, Math.ceil(d / A));
    for (w = 0; w < d; w += R) {
      const N = this.getContext(w), $ = s.setContext(N), F = a.setContext(N), V = $.lineWidth, D = $.color, H = F.dash || [], j = F.dashOffset, U = $.tickWidth, K = $.tickColor, G = $.tickBorderDash || [], B = $.tickBorderDashOffset;
      C = NR(this, w, c), C !== void 0 && (x = Oo(r, C, V), l ? E = M = P = I = x : S = T = k = O = x, h.push({
        tx1: E,
        ty1: S,
        tx2: M,
        ty2: T,
        x1: P,
        y1: k,
        x2: I,
        y2: O,
        width: V,
        color: D,
        borderDash: H,
        borderDashOffset: j,
        tickWidth: U,
        tickColor: K,
        tickBorderDash: G,
        tickBorderDashOffset: B
      }));
    }
    return this._ticksLength = d, this._borderValue = v, h;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: o, ticks: s } = r, i = this.isHorizontal(), a = this.ticks, { align: c, crossAlign: l, padding: u, mirror: d } = s, f = Zs(r.grid), h = f + u, p = d ? -u : h, g = -lr(this.labelRotation), m = [];
    let y, v, w, C, x, E, S, M, T, P, k, I, O = "middle";
    if (o === "top")
      E = this.bottom - p, S = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      E = this.top + p, S = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const R = this._getYAxisLabelAlignment(f);
      S = R.textAlign, x = R.x;
    } else if (o === "right") {
      const R = this._getYAxisLabelAlignment(f);
      S = R.textAlign, x = R.x;
    } else if (n === "x") {
      if (o === "center")
        E = (t.top + t.bottom) / 2 + h;
      else if (at(o)) {
        const R = Object.keys(o)[0], N = o[R];
        E = this.chart.scales[R].getPixelForValue(N) + h;
      }
      S = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        x = (t.left + t.right) / 2 - h;
      else if (at(o)) {
        const R = Object.keys(o)[0], N = o[R];
        x = this.chart.scales[R].getPixelForValue(N);
      }
      S = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (c === "start" ? O = "top" : c === "end" && (O = "bottom"));
    const A = this._getLabelSizes();
    for (y = 0, v = a.length; y < v; ++y) {
      w = a[y], C = w.label;
      const R = s.setContext(this.getContext(y));
      M = this.getPixelForTick(y) + s.labelOffset, T = this._resolveTickFontOptions(y), P = T.lineHeight, k = Ft(C) ? C.length : 1;
      const N = k / 2, $ = R.color, F = R.textStrokeColor, V = R.textStrokeWidth;
      let D = S;
      i ? (x = M, S === "inner" && (y === v - 1 ? D = this.options.reverse ? "left" : "right" : y === 0 ? D = this.options.reverse ? "right" : "left" : D = "center"), o === "top" ? l === "near" || g !== 0 ? I = -k * P + P / 2 : l === "center" ? I = -A.highest.height / 2 - N * P + P : I = -A.highest.height + P / 2 : l === "near" || g !== 0 ? I = P / 2 : l === "center" ? I = A.highest.height / 2 - N * P : I = A.highest.height - k * P, d && (I *= -1), g !== 0 && !R.showLabelBackdrop && (x += P / 2 * Math.sin(g))) : (E = M, I = (1 - k) * P / 2);
      let H;
      if (R.showLabelBackdrop) {
        const j = zn(R.backdropPadding), U = A.heights[y], K = A.widths[y];
        let G = I - j.top, B = 0 - j.left;
        switch (O) {
          case "middle":
            G -= U / 2;
            break;
          case "bottom":
            G -= U;
            break;
        }
        switch (S) {
          case "center":
            B -= K / 2;
            break;
          case "right":
            B -= K;
            break;
        }
        H = {
          left: B,
          top: G,
          width: K + j.width,
          height: U + j.height,
          color: R.backdropColor
        };
      }
      m.push({
        label: C,
        font: T,
        textOffset: I,
        options: {
          rotation: g,
          color: $,
          strokeColor: F,
          strokeWidth: V,
          textAlign: D,
          textBaseline: O,
          translation: [
            x,
            E
          ],
          backdrop: H
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-lr(this.labelRotation))
      return t === "top" ? "left" : "right";
    let o = "center";
    return n.align === "start" ? o = "left" : n.align === "end" ? o = "right" : n.align === "inner" && (o = "inner"), o;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: s } } = this.options, i = this._getLabelSizes(), a = t + s, c = i.widest.width;
    let l, u;
    return n === "left" ? o ? (u = this.right + s, r === "near" ? l = "left" : r === "center" ? (l = "center", u += c / 2) : (l = "right", u += c)) : (u = this.right - a, r === "near" ? l = "right" : r === "center" ? (l = "center", u -= c / 2) : (l = "left", u = this.left)) : n === "right" ? o ? (u = this.left + s, r === "near" ? l = "right" : r === "center" ? (l = "center", u -= c / 2) : (l = "left", u -= c)) : (u = this.left + a, r === "near" ? l = "left" : r === "center" ? (l = "center", u += c / 2) : (l = "right", u = this.right)) : l = "right", {
      textAlign: l,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: o, width: s, height: i } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, o, s, i), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const o = this.ticks.findIndex((s) => s.value === t);
    return o >= 0 ? n.setContext(this.getContext(o)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let s, i;
    const a = (c, l, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(c.x, c.y), r.lineTo(l.x, l.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (s = 0, i = o.length; s < i; ++s) {
        const c = o[s];
        n.drawOnChartArea && a({
          x: c.x1,
          y: c.y1
        }, {
          x: c.x2,
          y: c.y2
        }, c), n.drawTicks && a({
          x: c.tx1,
          y: c.ty1
        }, {
          x: c.tx2,
          y: c.ty2
        }, {
          color: c.tickColor,
          width: c.tickWidth,
          borderDash: c.tickBorderDash,
          borderDashOffset: c.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: r, grid: o } } = this, s = r.setContext(this.getContext()), i = r.display ? s.width : 0;
    if (!i)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, c = this._borderValue;
    let l, u, d, f;
    this.isHorizontal() ? (l = Oo(t, this.left, i) - i / 2, u = Oo(t, this.right, a) + a / 2, d = f = c) : (d = Oo(t, this.top, i) - i / 2, f = Oo(t, this.bottom, a) + a / 2, l = u = c), n.save(), n.lineWidth = s.width, n.strokeStyle = s.color, n.beginPath(), n.moveTo(l, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, o = this._computeLabelArea();
    o && Jy(r, o);
    const s = this.getLabelItems(t);
    for (const i of s) {
      const a = i.options, c = i.font, l = i.label, u = i.textOffset;
      Uc(r, l, 0, u, c, a);
    }
    o && e1(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const s = In(r.font), i = zn(r.padding), a = r.align;
    let c = s.lineHeight / 2;
    n === "bottom" || n === "center" || at(n) ? (c += i.bottom, Ft(r.text) && (c += s.lineHeight * (r.text.length - 1))) : c += i.top;
    const { titleX: l, titleY: u, maxWidth: d, rotation: f } = VR(this, c, n, a);
    Uc(t, r.text, 0, 0, s, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: LR(a, n, o),
      textBaseline: "middle",
      translation: [
        l,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = ut(t.grid && t.grid.z, -1), o = ut(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Xo.prototype.draw ? [
      {
        z: n,
        draw: (s) => {
          this.draw(s);
        }
      }
    ] : [
      {
        z: r,
        draw: (s) => {
          this.drawBackground(), this.drawGrid(s), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (s) => {
          this.drawLabels(s);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let s, i;
    for (s = 0, i = n.length; s < i; ++s) {
      const a = n[s];
      a[r] === this.id && (!t || a.type === t) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return In(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Ya {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    HR(n) && (r = this.register(n));
    const o = this.items, s = t.id, i = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + t);
    return s in o || (o[s] = t, WR(t, i, r), this.override && zt.override(t.id, t.overrides)), i;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, o = this.scope;
    r in n && delete n[r], o && r in zt[o] && (delete zt[o][r], this.override && delete jo[r]);
  }
}
function WR(e, t, n) {
  const r = Vi(/* @__PURE__ */ Object.create(null), [
    n ? zt.get(n) : {},
    zt.get(t),
    e.defaults
  ]);
  zt.set(t, r), e.defaultRoutes && BR(t, e.defaultRoutes), e.descriptors && zt.describe(t, e.descriptors);
}
function BR(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), o = r.pop(), s = [
      e
    ].concat(r).join("."), i = t[n].split("."), a = i.pop(), c = i.join(".");
    zt.route(s, o, c, a);
  });
}
function HR(e) {
  return "id" in e && "defaults" in e;
}
class YR {
  constructor() {
    this.controllers = new Ya(Wo, "datasets", !0), this.elements = new Ya(qo, "elements"), this.plugins = new Ya(Object, "plugins"), this.scales = new Ya(Xo, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [
      ...n
    ].forEach((o) => {
      const s = r || this._getRegistryForType(o);
      r || s.isForType(o) || s === this.plugins && o.id ? this._exec(t, s, o) : bt(o, (i) => {
        const a = r || this._getRegistryForType(i);
        this._exec(t, a, i);
      });
    });
  }
  _exec(t, n, r) {
    const o = $h(t);
    Vt(r["before" + o], [], r), n[t](r), Vt(r["after" + o], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const o = n.get(t);
    if (o === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return o;
  }
}
var or = /* @__PURE__ */ new YR();
class zR {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const s = o ? this._descriptors(t).filter(o) : this._descriptors(t), i = this._notify(s, t, n, r);
    return n === "afterDestroy" && (this._notify(s, t, "stop"), this._notify(this._init, t, "uninstall")), i;
  }
  _notify(t, n, r, o) {
    o = o || {};
    for (const s of t) {
      const i = s.plugin, a = i[r], c = [
        n,
        o,
        s.options
      ];
      if (Vt(a, c, i) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    yt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, o = ut(r.options && r.options.plugins, {}), s = jR(r);
    return o === !1 && !n ? [] : GR(t, s, o, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, o = (s, i) => s.filter((a) => !i.some((c) => a.plugin.id === c.plugin.id));
    this._notify(o(n, r), t, "stop"), this._notify(o(r, n), t, "start");
  }
}
function jR(e) {
  const t = {}, n = [], r = Object.keys(or.plugins.items);
  for (let s = 0; s < r.length; s++)
    n.push(or.getPlugin(r[s]));
  const o = e.plugins || [];
  for (let s = 0; s < o.length; s++) {
    const i = o[s];
    n.indexOf(i) === -1 && (n.push(i), t[i.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function UR(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function GR(e, { plugins: t, localIds: n }, r, o) {
  const s = [], i = e.getContext();
  for (const a of t) {
    const c = a.id, l = UR(r[c], o);
    l !== null && s.push({
      plugin: a,
      options: KR(e.config, {
        plugin: a,
        local: n[c]
      }, l, i)
    });
  }
  return s;
}
function KR(e, { plugin: t, local: n }, r, o) {
  const s = e.pluginScopeKeys(t), i = e.getOptionScopes(r, s);
  return n && t.defaults && i.push(t.defaults), e.createResolver(i, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Xd(e, t) {
  const n = zt.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function qR(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function XR(e, t) {
  return e === t ? "_index_" : "_value_";
}
function Km(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function ZR(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Zd(e, ...t) {
  if (Km(e))
    return e;
  for (const n of t) {
    const r = n.axis || ZR(n.position) || e.length > 1 && Km(e[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function qm(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function QR(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((r) => r.xAxisID === e || r.yAxisID === e);
    if (n.length)
      return qm(e, "x", n[0]) || qm(e, "y", n[0]);
  }
  return {};
}
function JR(e, t) {
  const n = jo[e.type] || {
    scales: {}
  }, r = t.scales || {}, o = Xd(e.type, t), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((i) => {
    const a = r[i];
    if (!at(a))
      return console.error(`Invalid scale configuration for scale: ${i}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${i}`);
    const c = Zd(i, a, QR(i, e), zt.scales[a.type]), l = XR(c, o), u = n.scales || {};
    s[i] = _i(/* @__PURE__ */ Object.create(null), [
      {
        axis: c
      },
      a,
      u[c],
      u[l]
    ]);
  }), e.data.datasets.forEach((i) => {
    const a = i.type || e.type, c = i.indexAxis || Xd(a, t), u = (jo[a] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = qR(d, c), h = i[f + "AxisID"] || f;
      s[h] = s[h] || /* @__PURE__ */ Object.create(null), _i(s[h], [
        {
          axis: f
        },
        r[h],
        u[d]
      ]);
    });
  }), Object.keys(s).forEach((i) => {
    const a = s[i];
    _i(a, [
      zt.scales[a.type],
      zt.scale
    ]);
  }), s;
}
function v1(e) {
  const t = e.options || (e.options = {});
  t.plugins = ut(t.plugins, {}), t.scales = JR(e, t);
}
function y1(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function eI(e) {
  return e = e || {}, e.data = y1(e.data), v1(e), e;
}
const Xm = /* @__PURE__ */ new Map(), w1 = /* @__PURE__ */ new Set();
function za(e, t) {
  let n = Xm.get(e);
  return n || (n = t(), Xm.set(e, n), w1.add(n)), n;
}
const Qs = (e, t, n) => {
  const r = zo(t, n);
  r !== void 0 && e.add(r);
};
class tI {
  constructor(t) {
    this._config = eI(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = y1(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), v1(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return za(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return za(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return za(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return za(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let o = r.get(t);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(t, o)), o;
  }
  getOptionScopes(t, n, r) {
    const { options: o, type: s } = this, i = this._cachedScopes(t, r), a = i.get(n);
    if (a)
      return a;
    const c = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      t && (c.add(t), u.forEach((d) => Qs(c, t, d))), u.forEach((d) => Qs(c, o, d)), u.forEach((d) => Qs(c, jo[s] || {}, d)), u.forEach((d) => Qs(c, zt, d)), u.forEach((d) => Qs(c, Kd, d));
    });
    const l = Array.from(c);
    return l.length === 0 && l.push(/* @__PURE__ */ Object.create(null)), w1.has(n) && i.set(n, l), l;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      jo[n] || {},
      zt.datasets[n] || {},
      {
        type: n
      },
      zt,
      Kd
    ];
  }
  resolveNamedOptions(t, n, r, o = [
    ""
  ]) {
    const s = {
      $shared: !0
    }, { resolver: i, subPrefixes: a } = Zm(this._resolverCache, t, o);
    let c = i;
    if (rI(i, n)) {
      s.$shared = !1, r = ho(r) ? r() : r;
      const l = this.createResolver(t, r, a);
      c = Es(i, r, l);
    }
    for (const l of n)
      s[l] = c[l];
    return s;
  }
  createResolver(t, n, r = [
    ""
  ], o) {
    const { resolver: s } = Zm(this._resolverCache, t, r);
    return at(n) ? Es(s, n, void 0, o) : s;
  }
}
function Zm(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const o = n.join();
  let s = r.get(o);
  return s || (s = {
    resolver: Bh(t, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(o, s)), s;
}
const nI = (e) => at(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || ho(e[n]), !1);
function rI(e, t) {
  const { isScriptable: n, isIndexable: r } = n1(e);
  for (const o of t) {
    const s = n(o), i = r(o), a = (i || s) && e[o];
    if (s && (ho(a) || nI(a)) || i && Ft(a))
      return !0;
  }
  return !1;
}
var oI = "4.3.3";
const sI = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Qm(e, t) {
  return e === "top" || e === "bottom" || sI.indexOf(e) === -1 && t === "x";
}
function Jm(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function eb(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Vt(n && n.onComplete, [
    e
  ], t);
}
function iI(e) {
  const t = e.chart, n = t.options.animation;
  Vt(n && n.onProgress, [
    e
  ], t);
}
function x1(e) {
  return a1() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const mc = {}, tb = (e) => {
  const t = x1(e);
  return Object.values(mc).filter((n) => n.canvas === t).pop();
};
function aI(e, t, n) {
  const r = Object.keys(e);
  for (const o of r) {
    const s = +o;
    if (s >= t) {
      const i = e[o];
      delete e[o], (n > 0 || s > t) && (e[s + n] = i);
    }
  }
}
function cI(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
function lI(e) {
  const { xScale: t, yScale: n } = e;
  if (t && n)
    return {
      left: t.left,
      right: t.right,
      top: n.top,
      bottom: n.bottom
    };
}
var no;
let Uh = (no = class {
  static register(...t) {
    or.add(...t), nb();
  }
  static unregister(...t) {
    or.remove(...t), nb();
  }
  constructor(t, n) {
    const r = this.config = new tI(n), o = x1(t), s = tb(o);
    if (s)
      throw new Error("Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused.");
    const i = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || OR(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, i.aspectRatio), c = a && a.canvas, l = c && c.height, u = c && c.width;
    if (this.id = i2(), this.ctx = a, this.canvas = c, this.width = u, this.height = l, this._options = i, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new zR(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = C2((d) => this.update(d), i.resizeDelay || 0), this._dataChanges = [], mc[this.id] = this, !a || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    kr.listen(this, "complete", eb), kr.listen(this, "progress", iI), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: s } = this;
    return yt(t) ? n && s ? s : o ? r / o : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return or;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Em(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return wm(this.canvas, this.ctx), this;
  }
  stop() {
    return kr.stop(this), this;
  }
  resize(t, n) {
    kr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, o = this.canvas, s = r.maintainAspectRatio && this.aspectRatio, i = this.platform.getMaximumSize(o, t, n, s), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = i.width, this.height = i.height, this._aspectRatio = this.aspectRatio, Em(this, a, !0) && (this.notifyPlugins("resize", {
      size: i
    }), Vt(r.onResize, [
      this,
      i
    ], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    bt(n, (r, o) => {
      r.id = o;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, o = Object.keys(r).reduce((i, a) => (i[a] = !1, i), {});
    let s = [];
    n && (s = s.concat(Object.keys(n).map((i) => {
      const a = n[i], c = Zd(i, a), l = c === "r", u = c === "x";
      return {
        options: a,
        dposition: l ? "chartArea" : u ? "bottom" : "left",
        dtype: l ? "radialLinear" : u ? "category" : "linear"
      };
    }))), bt(s, (i) => {
      const a = i.options, c = a.id, l = Zd(c, a), u = ut(a.type, i.dtype);
      (a.position === void 0 || Qm(a.position, l) !== Qm(i.dposition)) && (a.position = i.dposition), o[c] = !0;
      let d = null;
      if (c in r && r[c].type === u)
        d = r[c];
      else {
        const f = or.getScale(u);
        d = new f({
          id: c,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, t);
    }), bt(o, (i, a) => {
      i || delete r[a];
    }), bt(r, (i) => {
      Ba.configure(this, i, i.options), Ba.addBox(this, i);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((o, s) => o.index - s.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(Jm("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, o) => {
      n.filter((s) => s === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const s = n[r];
      let i = this.getDatasetMeta(r);
      const a = s.type || this.config.type;
      if (i.type && i.type !== a && (this._destroyDatasetMeta(r), i = this.getDatasetMeta(r)), i.type = a, i.indexAxis = s.indexAxis || Xd(a, this.options), i.order = s.order || 0, i.index = r, i.label = "" + s.label, i.visible = this.isDatasetVisible(r), i.controller)
        i.controller.updateIndex(r), i.controller.linkScales();
      else {
        const c = or.getController(a), { datasetElementType: l, dataElementType: u } = zt.datasets[a];
        Object.assign(c, {
          dataElementType: or.getElement(u),
          datasetElementType: l && or.getElement(l)
        }), i.controller = new c(this, r), t.push(i.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    bt(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let i = 0;
    for (let l = 0, u = this.data.datasets.length; l < u; l++) {
      const { controller: d } = this.getDatasetMeta(l), f = !o && s.indexOf(d) === -1;
      d.buildOrUpdateElements(f), i = Math.max(+d.getMaxOverflow(), i);
    }
    i = this._minPadding = r.layout.autoPadding ? i : 0, this._updateLayout(i), o || bt(s, (l) => {
      l.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Jm("z", "_idx"));
    const { _active: a, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    bt(this.scales, (t) => {
      Ba.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!um(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: s } of n) {
      const i = r === "_removeElements" ? -s : s;
      aI(t, o, i);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (s) => new Set(t.filter((i) => i[0] === s).map((i, a) => a + "," + i.splice(1).join(","))), o = r(0);
    for (let s = 1; s < n; s++)
      if (!um(o, r(s)))
        return;
    return Array.from(o).map((s) => s.split(",")).map((s) => ({
      method: s[1],
      start: +s[2],
      count: +s[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Ba.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], bt(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, s) => {
      o._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, ho(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), o = {
      meta: r,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (kr.has(this) ? this.attached && !kr.running(this) && kr.start(this) : (this.draw(), eb({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resize(r, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let o, s;
    for (o = 0, s = n.length; o < s; ++o) {
      const i = n[o];
      (!t || i.visible) && r.push(i);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, o = !r.disabled, s = lI(t) || this.chartArea, i = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (o && Jy(n, {
      left: r.left === !1 ? 0 : s.left - r.left,
      right: r.right === !1 ? this.width : s.right + r.right,
      top: r.top === !1 ? 0 : s.top - r.top,
      bottom: r.bottom === !1 ? this.height : s.bottom + r.bottom
    }), t.controller.draw(), o && e1(n), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return Dr(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, o) {
    const s = sR.modes[n];
    return typeof s == "function" ? s(this, t, r, o) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let o = r.filter((s) => s && s._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = wo(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const o = r ? "show" : "hide", s = this.getDatasetMeta(t), i = s.controller._resolveAnimations(void 0, o);
    Wi(n) ? (s.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), i.update(s, {
      visible: r
    }), this.update((a) => a.datasetIndex === t ? o : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), kr.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), wm(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete mc[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (s, i) => {
      n.addEventListener(this, s, i), t[s] = i;
    }, o = (s, i, a) => {
      s.offsetX = i, s.offsetY = a, this._eventHandler(s);
    };
    bt(this.options.events, (s) => r(s, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (c, l) => {
      n.addEventListener(this, c, l), t[c] = l;
    }, o = (c, l) => {
      t[c] && (n.removeEventListener(this, c, l), delete t[c]);
    }, s = (c, l) => {
      this.canvas && this.resize(c, l);
    };
    let i;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", s), r("detach", i);
    };
    i = () => {
      this.attached = !1, o("resize", s), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : i();
  }
  unbindEvents() {
    bt(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, bt(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const o = r ? "set" : "remove";
    let s, i, a, c;
    for (n === "dataset" && (s = this.getDatasetMeta(t[0].datasetIndex), s.controller["_" + o + "DatasetHoverStyle"]()), a = 0, c = t.length; a < c; ++a) {
      i = t[a];
      const l = i && this.getDatasetMeta(i.datasetIndex).controller;
      l && l[o + "HoverStyle"](i.element, i.datasetIndex, i.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: s, index: i }) => {
      const a = this.getDatasetMeta(s);
      if (!a)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: a.data[i],
        index: i
      };
    });
    !Bc(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, r) {
    const o = this.options.hover, s = (c, l) => c.filter((u) => !l.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), i = s(n, t), a = r ? t : s(t, n);
    i.length && this.updateHoverStyle(i, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, o = (i) => (i.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const s = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (s || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: o = [], options: s } = this, i = n, a = this._getActiveElements(t, o, r, i), c = f2(t), l = cI(t, this._lastEvent, r, c);
    r && (this._lastEvent = null, Vt(s.onHover, [
      t,
      a,
      this
    ], this), c && Vt(s.onClick, [
      t,
      a,
      this
    ], this));
    const u = !Bc(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = l, u;
  }
  _getActiveElements(t, n, r, o) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(t, s.mode, s, o);
  }
}, ae(no, "defaults", zt), ae(no, "instances", mc), ae(no, "overrides", jo), ae(no, "registry", or), ae(no, "version", oI), ae(no, "getChart", tb), no);
function nb() {
  return bt(Uh.instances, (e) => e._plugins.invalidate());
}
function uI(e, t, n) {
  const { startAngle: r, pixelMargin: o, x: s, y: i, outerRadius: a, innerRadius: c } = t;
  let l = o / a;
  e.beginPath(), e.arc(s, i, a, r - l, n + l), c > o ? (l = o / c, e.arc(s, i, c, n + l, r - l, !0)) : e.arc(s, i, o, n + Wt, r - Wt), e.closePath(), e.clip();
}
function dI(e) {
  return Wh(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function fI(e, t, n, r) {
  const o = dI(e.options.borderRadius), s = (n - t) / 2, i = Math.min(s, r * t / 2), a = (c) => {
    const l = (n - Math.min(s, c)) * r / 2;
    return cn(c, 0, Math.min(s, l));
  };
  return {
    outerStart: a(o.outerStart),
    outerEnd: a(o.outerEnd),
    innerStart: cn(o.innerStart, 0, i),
    innerEnd: cn(o.innerEnd, 0, i)
  };
}
function Jo(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Xc(e, t, n, r, o, s) {
  const { x: i, y: a, startAngle: c, pixelMargin: l, innerRadius: u } = t, d = Math.max(t.outerRadius + r + n - l, 0), f = u > 0 ? u + r + n + l : 0;
  let h = 0;
  const p = o - c;
  if (r) {
    const R = u > 0 ? u - r : 0, N = d > 0 ? d - r : 0, $ = (R + N) / 2, F = $ !== 0 ? p * $ / ($ + r) : p;
    h = (p - F) / 2;
  }
  const g = Math.max(1e-3, p * d - n / Gt) / d, m = (p - g) / 2, y = c + m + h, v = o - m - h, { outerStart: w, outerEnd: C, innerStart: x, innerEnd: E } = fI(t, f, d, v - y), S = d - w, M = d - C, T = y + w / S, P = v - C / M, k = f + x, I = f + E, O = y + x / k, A = v - E / I;
  if (e.beginPath(), s) {
    const R = (T + P) / 2;
    if (e.arc(i, a, d, T, R), e.arc(i, a, d, R, P), C > 0) {
      const V = Jo(M, P, i, a);
      e.arc(V.x, V.y, C, P, v + Wt);
    }
    const N = Jo(I, v, i, a);
    if (e.lineTo(N.x, N.y), E > 0) {
      const V = Jo(I, A, i, a);
      e.arc(V.x, V.y, E, v + Wt, A + Math.PI);
    }
    const $ = (v - E / f + (y + x / f)) / 2;
    if (e.arc(i, a, f, v - E / f, $, !0), e.arc(i, a, f, $, y + x / f, !0), x > 0) {
      const V = Jo(k, O, i, a);
      e.arc(V.x, V.y, x, O + Math.PI, y - Wt);
    }
    const F = Jo(S, y, i, a);
    if (e.lineTo(F.x, F.y), w > 0) {
      const V = Jo(S, T, i, a);
      e.arc(V.x, V.y, w, y - Wt, T);
    }
  } else {
    e.moveTo(i, a);
    const R = Math.cos(T) * d + i, N = Math.sin(T) * d + a;
    e.lineTo(R, N);
    const $ = Math.cos(P) * d + i, F = Math.sin(P) * d + a;
    e.lineTo($, F);
  }
  e.closePath();
}
function hI(e, t, n, r, o) {
  const { fullCircles: s, startAngle: i, circumference: a } = t;
  let c = t.endAngle;
  if (s) {
    Xc(e, t, n, r, c, o);
    for (let l = 0; l < s; ++l)
      e.fill();
    isNaN(a) || (c = i + (a % Nt || Nt));
  }
  return Xc(e, t, n, r, c, o), e.fill(), c;
}
function pI(e, t, n, r, o) {
  const { fullCircles: s, startAngle: i, circumference: a, options: c } = t, { borderWidth: l, borderJoinStyle: u, borderDash: d, borderDashOffset: f } = c, h = c.borderAlign === "inner";
  if (!l)
    return;
  e.setLineDash(d || []), e.lineDashOffset = f, h ? (e.lineWidth = l * 2, e.lineJoin = u || "round") : (e.lineWidth = l, e.lineJoin = u || "bevel");
  let p = t.endAngle;
  if (s) {
    Xc(e, t, n, r, p, o);
    for (let g = 0; g < s; ++g)
      e.stroke();
    isNaN(a) || (p = i + (a % Nt || Nt));
  }
  h && uI(e, t, p), s || (Xc(e, t, n, r, p, o), e.stroke());
}
class pi extends qo {
  constructor(n) {
    super();
    ae(this, "circumference");
    ae(this, "endAngle");
    ae(this, "fullCircles");
    ae(this, "innerRadius");
    ae(this, "outerRadius");
    ae(this, "pixelMargin");
    ae(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const s = this.getProps([
      "x",
      "y"
    ], o), { angle: i, distance: a } = Gy(s, {
      x: n,
      y: r
    }), { startAngle: c, endAngle: l, innerRadius: u, outerRadius: d, circumference: f } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], o), h = (this.options.spacing + this.options.borderWidth) / 2, g = ut(f, l - c) >= Nt || Hi(i, c, l), m = zc(a, u + h, d + h);
    return g && m;
  }
  getCenterPoint(n) {
    const { x: r, y: o, startAngle: s, endAngle: i, innerRadius: a, outerRadius: c } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: l, spacing: u } = this.options, d = (s + i) / 2, f = (a + c + u + l) / 2;
    return {
      x: r + Math.cos(d) * f,
      y: o + Math.sin(d) * f
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: r, circumference: o } = this, s = (r.offset || 0) / 4, i = (r.spacing || 0) / 2, a = r.circular;
    if (this.pixelMargin = r.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = o > Nt ? Math.floor(o / Nt) : 0, o === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const c = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(c) * s, Math.sin(c) * s);
    const l = 1 - Math.sin(Math.min(Gt, o || 0)), u = s * l;
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, hI(n, this, u, i, a), pI(n, this, u, i, a), n.restore();
  }
}
ae(pi, "id", "arc"), ae(pi, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ae(pi, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ae(pi, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function C1(e, t, n = t) {
  e.lineCap = ut(n.borderCapStyle, t.borderCapStyle), e.setLineDash(ut(n.borderDash, t.borderDash)), e.lineDashOffset = ut(n.borderDashOffset, t.borderDashOffset), e.lineJoin = ut(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = ut(n.borderWidth, t.borderWidth), e.strokeStyle = ut(n.borderColor, t.borderColor);
}
function gI(e, t, n) {
  e.lineTo(n.x, n.y);
}
function mI(e) {
  return e.stepped ? F2 : e.tension || e.cubicInterpolationMode === "monotone" ? L2 : gI;
}
function E1(e, t, n = {}) {
  const r = e.length, { start: o = 0, end: s = r - 1 } = n, { start: i, end: a } = t, c = Math.max(o, i), l = Math.min(s, a), u = o < i && s < i || o > a && s > a;
  return {
    count: r,
    start: c,
    loop: t.loop,
    ilen: l < c && !u ? r + l - c : l - c
  };
}
function bI(e, t, n, r) {
  const { points: o, options: s } = t, { count: i, start: a, loop: c, ilen: l } = E1(o, n, r), u = mI(s);
  let { move: d = !0, reverse: f } = r || {}, h, p, g;
  for (h = 0; h <= l; ++h)
    p = o[(a + (f ? l - h : h)) % i], !p.skip && (d ? (e.moveTo(p.x, p.y), d = !1) : u(e, g, p, f, s.stepped), g = p);
  return c && (p = o[(a + (f ? l : 0)) % i], u(e, g, p, f, s.stepped)), !!c;
}
function vI(e, t, n, r) {
  const o = t.points, { count: s, start: i, ilen: a } = E1(o, n, r), { move: c = !0, reverse: l } = r || {};
  let u = 0, d = 0, f, h, p, g, m, y;
  const v = (C) => (i + (l ? a - C : C)) % s, w = () => {
    g !== m && (e.lineTo(u, m), e.lineTo(u, g), e.lineTo(u, y));
  };
  for (c && (h = o[v(0)], e.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[v(f)], h.skip)
      continue;
    const C = h.x, x = h.y, E = C | 0;
    E === p ? (x < g ? g = x : x > m && (m = x), u = (d * u + C) / ++d) : (w(), e.lineTo(C, x), p = E, d = 0, g = m = x), y = x;
  }
  w();
}
function Qd(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? vI : bI;
}
function yI(e) {
  return e.stepped ? mP : e.tension || e.cubicInterpolationMode === "monotone" ? bP : Ro;
}
function wI(e, t, n, r) {
  let o = t._path;
  o || (o = t._path = new Path2D(), t.path(o, n, r) && o.closePath()), C1(e, t.options), e.stroke(o);
}
function xI(e, t, n, r) {
  const { segments: o, options: s } = t, i = Qd(t);
  for (const a of o)
    C1(e, s, a.style), e.beginPath(), i(e, t, a, {
      start: n,
      end: n + r - 1
    }) && e.closePath(), e.stroke();
}
const CI = typeof Path2D == "function";
function EI(e, t, n, r) {
  CI && !t.options.segment ? wI(e, t, n, r) : xI(e, t, n, r);
}
class gi extends qo {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      cP(this._points, r, t, o, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = MP(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, o = t[n], s = this.points, i = _P(this, {
      property: n,
      start: o,
      end: o
    });
    if (!i.length)
      return;
    const a = [], c = yI(r);
    let l, u;
    for (l = 0, u = i.length; l < u; ++l) {
      const { start: d, end: f } = i[l], h = s[d], p = s[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const g = Math.abs((o - h[n]) / (p[n] - h[n])), m = c(h, p, g, r.stepped);
      m[n] = t[n], a.push(m);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(t, n, r) {
    return Qd(this)(t, this, n, r);
  }
  path(t, n, r) {
    const o = this.segments, s = Qd(this);
    let i = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      i &= s(t, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!i;
  }
  draw(t, n, r, o) {
    const s = this.options || {};
    (this.points || []).length && s.borderWidth && (t.save(), EI(t, this, r, o), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ae(gi, "id", "line"), ae(gi, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ae(gi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ae(gi, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function rb(e, t, n, r) {
  const o = e.options, { [n]: s } = e.getProps([
    n
  ], r);
  return Math.abs(t - s) < o.radius + o.hitRadius;
}
class bc extends qo {
  constructor(n) {
    super();
    ae(this, "parsed");
    ae(this, "skip");
    ae(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const s = this.options, { x: i, y: a } = this.getProps([
      "x",
      "y"
    ], o);
    return Math.pow(n - i, 2) + Math.pow(r - a, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(n, r) {
    return rb(this, n, "x", r);
  }
  inYRange(n, r) {
    return rb(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: o
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const o = r && n.borderWidth || 0;
    return (r + o) * 2;
  }
  draw(n, r) {
    const o = this.options;
    this.skip || o.radius < 0.1 || !Dr(this, r, this.size(o) / 2) || (n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.fillStyle = o.backgroundColor, qd(n, o, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
ae(bc, "id", "point"), /**
* @type {any}
*/
ae(bc, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ae(bc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function _1(e, t) {
  const { x: n, y: r, base: o, width: s, height: i } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let a, c, l, u, d;
  return e.horizontal ? (d = i / 2, a = Math.min(n, o), c = Math.max(n, o), l = r - d, u = r + d) : (d = s / 2, a = n - d, c = n + d, l = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: l,
    right: c,
    bottom: u
  };
}
function ao(e, t, n, r) {
  return e ? 0 : cn(t, n, r);
}
function _I(e, t, n) {
  const r = e.options.borderWidth, o = e.borderSkipped, s = t1(r);
  return {
    t: ao(o.top, s.top, 0, n),
    r: ao(o.right, s.right, 0, t),
    b: ao(o.bottom, s.bottom, 0, n),
    l: ao(o.left, s.left, 0, t)
  };
}
function SI(e, t, n) {
  const { enableBorderRadius: r } = e.getProps([
    "enableBorderRadius"
  ]), o = e.options.borderRadius, s = ms(o), i = Math.min(t, n), a = e.borderSkipped, c = r || at(o);
  return {
    topLeft: ao(!c || a.top || a.left, s.topLeft, 0, i),
    topRight: ao(!c || a.top || a.right, s.topRight, 0, i),
    bottomLeft: ao(!c || a.bottom || a.left, s.bottomLeft, 0, i),
    bottomRight: ao(!c || a.bottom || a.right, s.bottomRight, 0, i)
  };
}
function OI(e) {
  const t = _1(e), n = t.right - t.left, r = t.bottom - t.top, o = _I(e, n / 2, r / 2), s = SI(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: s
    },
    inner: {
      x: t.left + o.l,
      y: t.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, s.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, s.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, s.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, s.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function Xu(e, t, n, r) {
  const o = t === null, s = n === null, a = e && !(o && s) && _1(e, r);
  return a && (o || zc(t, a.left, a.right)) && (s || zc(n, a.top, a.bottom));
}
function MI(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function TI(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function Zu(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, o = e.y !== n.y ? -t : 0, s = (e.x + e.w !== n.x + n.w ? t : 0) - r, i = (e.y + e.h !== n.y + n.h ? t : 0) - o;
  return {
    x: e.x + r,
    y: e.y + o,
    w: e.w + s,
    h: e.h + i,
    radius: e.radius
  };
}
class vc extends qo {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: s, outer: i } = OI(this), a = MI(i.radius) ? Gc : TI;
    t.save(), (i.w !== s.w || i.h !== s.h) && (t.beginPath(), a(t, Zu(i, n, s)), t.clip(), a(t, Zu(s, -n, i)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), a(t, Zu(s, n)), t.fillStyle = o, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return Xu(this, t, n, r);
  }
  inXRange(t, n) {
    return Xu(this, t, null, n);
  }
  inYRange(t, n) {
    return Xu(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: o, horizontal: s } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: s ? (n + o) / 2 : n,
      y: s ? r : (r + o) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
ae(vc, "id", "bar"), ae(vc, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ae(vc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const mi = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = 0, o = 0, s = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const i = e[t].element;
      if (i && i.hasValue()) {
        const a = i.tooltipPosition();
        r += a.x, o += a.y, ++s;
      }
    }
    return {
      x: r / s,
      y: o / s
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, o = Number.POSITIVE_INFINITY, s, i, a;
    for (s = 0, i = e.length; s < i; ++s) {
      const c = e[s].element;
      if (c && c.hasValue()) {
        const l = c.getCenterPoint(), u = Gd(t, l);
        u < o && (o = u, a = c);
      }
    }
    if (a) {
      const c = a.tooltipPosition();
      n = c.x, r = c.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function rr(e, t) {
  return t && (Ft(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function Pr(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function kI(e, t) {
  const { element: n, datasetIndex: r, index: o } = t, s = e.getDatasetMeta(r).controller, { label: i, value: a } = s.getLabelAndValue(o);
  return {
    chart: e,
    label: i,
    parsed: s.getParsed(o),
    raw: e.data.datasets[r].data[o],
    formattedValue: a,
    dataset: s.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function ob(e, t) {
  const n = e.chart.ctx, { body: r, footer: o, title: s } = e, { boxWidth: i, boxHeight: a } = t, c = In(t.bodyFont), l = In(t.titleFont), u = In(t.footerFont), d = s.length, f = o.length, h = r.length, p = zn(t.padding);
  let g = p.height, m = 0, y = r.reduce((C, x) => C + x.before.length + x.lines.length + x.after.length, 0);
  if (y += e.beforeBody.length + e.afterBody.length, d && (g += d * l.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), y) {
    const C = t.displayColors ? Math.max(a, c.lineHeight) : c.lineHeight;
    g += h * C + (y - h) * c.lineHeight + (y - 1) * t.bodySpacing;
  }
  f && (g += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
  let v = 0;
  const w = function(C) {
    m = Math.max(m, n.measureText(C).width + v);
  };
  return n.save(), n.font = l.string, bt(e.title, w), n.font = c.string, bt(e.beforeBody.concat(e.afterBody), w), v = t.displayColors ? i + 2 + t.boxPadding : 0, bt(r, (C) => {
    bt(C.before, w), bt(C.lines, w), bt(C.after, w);
  }), v = 0, n.font = u.string, bt(e.footer, w), n.restore(), m += p.width, {
    width: m,
    height: g
  };
}
function PI(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function RI(e, t, n, r) {
  const { x: o, width: s } = r, i = n.caretSize + n.caretPadding;
  if (e === "left" && o + s + i > t.width || e === "right" && o - s - i < 0)
    return !0;
}
function II(e, t, n, r) {
  const { x: o, width: s } = n, { width: i, chartArea: { left: a, right: c } } = e;
  let l = "center";
  return r === "center" ? l = o <= (a + c) / 2 ? "left" : "right" : o <= s / 2 ? l = "left" : o >= i - s / 2 && (l = "right"), RI(l, e, t, n) && (l = "center"), l;
}
function sb(e, t, n) {
  const r = n.yAlign || t.yAlign || PI(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || II(e, t, n, r),
    yAlign: r
  };
}
function DI(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function NI(e, t, n) {
  let { y: r, height: o } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= o + n : r -= o / 2, r;
}
function ib(e, t, n, r) {
  const { caretSize: o, caretPadding: s, cornerRadius: i } = e, { xAlign: a, yAlign: c } = n, l = o + s, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = ms(i);
  let p = DI(t, a);
  const g = NI(t, c, l);
  return c === "center" ? a === "left" ? p += l : a === "right" && (p -= l) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: cn(p, 0, r.width - t.width),
    y: cn(g, 0, r.height - t.height)
  };
}
function ja(e, t, n) {
  const r = zn(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function ab(e) {
  return rr([], Pr(e));
}
function AI(e, t, n) {
  return wo(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function cb(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const S1 = {
  beforeTitle: Mr,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: Mr,
  beforeBody: Mr,
  beforeLabel: Mr,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return yt(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: Mr,
  afterBody: Mr,
  beforeFooter: Mr,
  footer: Mr,
  afterFooter: Mr
};
function mn(e, t, n, r) {
  const o = e[t].call(n, r);
  return typeof o > "u" ? S1[t].call(n, r) : o;
}
class Jd extends qo {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, s = new l1(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = AI(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, o = mn(r, "beforeTitle", this, t), s = mn(r, "title", this, t), i = mn(r, "afterTitle", this, t);
    let a = [];
    return a = rr(a, Pr(o)), a = rr(a, Pr(s)), a = rr(a, Pr(i)), a;
  }
  getBeforeBody(t, n) {
    return ab(mn(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: r } = n, o = [];
    return bt(t, (s) => {
      const i = {
        before: [],
        lines: [],
        after: []
      }, a = cb(r, s);
      rr(i.before, Pr(mn(a, "beforeLabel", this, s))), rr(i.lines, mn(a, "label", this, s)), rr(i.after, Pr(mn(a, "afterLabel", this, s))), o.push(i);
    }), o;
  }
  getAfterBody(t, n) {
    return ab(mn(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, o = mn(r, "beforeFooter", this, t), s = mn(r, "footer", this, t), i = mn(r, "afterFooter", this, t);
    let a = [];
    return a = rr(a, Pr(o)), a = rr(a, Pr(s)), a = rr(a, Pr(i)), a;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, o = [], s = [], i = [];
    let a = [], c, l;
    for (c = 0, l = n.length; c < l; ++c)
      a.push(kI(this.chart, n[c]));
    return t.filter && (a = a.filter((u, d, f) => t.filter(u, d, f, r))), t.itemSort && (a = a.sort((u, d) => t.itemSort(u, d, r))), bt(a, (u) => {
      const d = cb(t.callbacks, u);
      o.push(mn(d, "labelColor", this, u)), s.push(mn(d, "labelPointStyle", this, u)), i.push(mn(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = s, this.labelTextColors = i, this.dataPoints = a, a;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let s, i = [];
    if (!o.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const a = mi[r.position].call(this, o, this._eventPosition);
      i = this._createItems(r), this.title = this.getTitle(i, r), this.beforeBody = this.getBeforeBody(i, r), this.body = this.getBody(i, r), this.afterBody = this.getAfterBody(i, r), this.footer = this.getFooter(i, r);
      const c = this._size = ob(this, r), l = Object.assign({}, a, c), u = sb(this.chart, r, l), d = ib(r, l, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, s = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: c.width,
        height: c.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = i, this.$context = void 0, s && this._resolveAnimations().update(this, s), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, r, o) {
    const s = this.getCaretPosition(t, r, o);
    n.lineTo(s.x1, s.y1), n.lineTo(s.x2, s.y2), n.lineTo(s.x3, s.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: o, yAlign: s } = this, { caretSize: i, cornerRadius: a } = r, { topLeft: c, topRight: l, bottomLeft: u, bottomRight: d } = ms(a), { x: f, y: h } = t, { width: p, height: g } = n;
    let m, y, v, w, C, x;
    return s === "center" ? (C = h + g / 2, o === "left" ? (m = f, y = m - i, w = C + i, x = C - i) : (m = f + p, y = m + i, w = C - i, x = C + i), v = m) : (o === "left" ? y = f + Math.max(c, u) + i : o === "right" ? y = f + p - Math.max(l, d) - i : y = this.caretX, s === "top" ? (w = h, C = w - i, m = y - i, v = y + i) : (w = h + g, C = w + i, m = y + i, v = y - i), x = w), {
      x1: m,
      x2: y,
      x3: v,
      y1: w,
      y2: C,
      y3: x
    };
  }
  drawTitle(t, n, r) {
    const o = this.title, s = o.length;
    let i, a, c;
    if (s) {
      const l = Yu(r.rtl, this.x, this.width);
      for (t.x = ja(this, r.titleAlign, r), n.textAlign = l.textAlign(r.titleAlign), n.textBaseline = "middle", i = In(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = i.string, c = 0; c < s; ++c)
        n.fillText(o[c], l.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + a, c + 1 === s && (t.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(t, n, r, o, s) {
    const i = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: c, boxWidth: l } = s, u = In(s.bodyFont), d = ja(this, "left", s), f = o.x(d), h = c < u.lineHeight ? (u.lineHeight - c) / 2 : 0, p = n.y + h;
    if (s.usePointStyle) {
      const g = {
        radius: Math.min(l, c) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, m = o.leftForLtr(f, l) + l / 2, y = p + c / 2;
      t.strokeStyle = s.multiKeyBackground, t.fillStyle = s.multiKeyBackground, qd(t, g, m, y), t.strokeStyle = i.borderColor, t.fillStyle = i.backgroundColor, qd(t, g, m, y);
    } else {
      t.lineWidth = at(i.borderWidth) ? Math.max(...Object.values(i.borderWidth)) : i.borderWidth || 1, t.strokeStyle = i.borderColor, t.setLineDash(i.borderDash || []), t.lineDashOffset = i.borderDashOffset || 0;
      const g = o.leftForLtr(f, l), m = o.leftForLtr(o.xPlus(f, 1), l - 2), y = ms(i.borderRadius);
      Object.values(y).some((v) => v !== 0) ? (t.beginPath(), t.fillStyle = s.multiKeyBackground, Gc(t, {
        x: g,
        y: p,
        w: l,
        h: c,
        radius: y
      }), t.fill(), t.stroke(), t.fillStyle = i.backgroundColor, t.beginPath(), Gc(t, {
        x: m,
        y: p + 1,
        w: l - 2,
        h: c - 2,
        radius: y
      }), t.fill()) : (t.fillStyle = s.multiKeyBackground, t.fillRect(g, p, l, c), t.strokeRect(g, p, l, c), t.fillStyle = i.backgroundColor, t.fillRect(m, p + 1, l - 2, c - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: o } = this, { bodySpacing: s, bodyAlign: i, displayColors: a, boxHeight: c, boxWidth: l, boxPadding: u } = r, d = In(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = Yu(r.rtl, this.x, this.width), g = function(M) {
      n.fillText(M, p.x(t.x + h), t.y + f / 2), t.y += f + s;
    }, m = p.textAlign(i);
    let y, v, w, C, x, E, S;
    for (n.textAlign = i, n.textBaseline = "middle", n.font = d.string, t.x = ja(this, m, r), n.fillStyle = r.bodyColor, bt(this.beforeBody, g), h = a && m !== "right" ? i === "center" ? l / 2 + u : l + 2 + u : 0, C = 0, E = o.length; C < E; ++C) {
      for (y = o[C], v = this.labelTextColors[C], n.fillStyle = v, bt(y.before, g), w = y.lines, a && w.length && (this._drawColorBox(n, t, C, p, r), f = Math.max(d.lineHeight, c)), x = 0, S = w.length; x < S; ++x)
        g(w[x]), f = d.lineHeight;
      bt(y.after, g);
    }
    h = 0, f = d.lineHeight, bt(this.afterBody, g), t.y -= s;
  }
  drawFooter(t, n, r) {
    const o = this.footer, s = o.length;
    let i, a;
    if (s) {
      const c = Yu(r.rtl, this.x, this.width);
      for (t.x = ja(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = c.textAlign(r.footerAlign), n.textBaseline = "middle", i = In(r.footerFont), n.fillStyle = r.footerColor, n.font = i.string, a = 0; a < s; ++a)
        n.fillText(o[a], c.x(t.x), t.y + i.lineHeight / 2), t.y += i.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, o) {
    const { xAlign: s, yAlign: i } = this, { x: a, y: c } = t, { width: l, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = ms(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, c), i === "top" && this.drawCaret(t, n, r, o), n.lineTo(a + l - f, c), n.quadraticCurveTo(a + l, c, a + l, c + f), i === "center" && s === "right" && this.drawCaret(t, n, r, o), n.lineTo(a + l, c + u - p), n.quadraticCurveTo(a + l, c + u, a + l - p, c + u), i === "bottom" && this.drawCaret(t, n, r, o), n.lineTo(a + h, c + u), n.quadraticCurveTo(a, c + u, a, c + u - h), i === "center" && s === "left" && this.drawCaret(t, n, r, o), n.lineTo(a, c + d), n.quadraticCurveTo(a, c, a + d, c), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, o = r && r.x, s = r && r.y;
    if (o || s) {
      const i = mi[t.position].call(this, this._active, this._eventPosition);
      if (!i)
        return;
      const a = this._size = ob(this, t), c = Object.assign({}, i, this._size), l = sb(n, t, c), u = ib(t, c, l, n);
      (o._to !== u.x || s._to !== u.y) && (this.xAlign = l.xAlign, this.yAlign = l.yAlign, this.width = a.width, this.height = a.height, this.caretX = i.x, this.caretY = i.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const i = zn(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (t.save(), t.globalAlpha = r, this.drawBackground(s, t, o, n), wP(t, n.textDirection), s.y += i.top, this.drawTitle(s, t, n), this.drawBody(s, t, n), this.drawFooter(s, t, n), xP(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, o = t.map(({ datasetIndex: a, index: c }) => {
      const l = this.chart.getDatasetMeta(a);
      if (!l)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: l.data[c],
        index: c
      };
    }), s = !Bc(r, o), i = this._positionChanged(o, n);
    (s || i) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, s = this._active || [], i = this._getActiveElements(t, s, n, r), a = this._positionChanged(i, t), c = n || !Bc(i, s) || a;
    return c && (this._active = i, (o.enabled || o.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), c;
  }
  _getActiveElements(t, n, r, o) {
    const s = this.options;
    if (t.type === "mouseout")
      return [];
    if (!o)
      return n;
    const i = this.chart.getElementsAtEventForMode(t, s.mode, s, r);
    return s.reverse && i.reverse(), i;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: o, options: s } = this, i = mi[s.position].call(this, t, n);
    return i !== !1 && (r !== i.x || o !== i.y);
  }
}
ae(Jd, "positioners", mi);
var $I = {
  id: "tooltip",
  _element: Jd,
  positioners: mi,
  afterInit(e, t, n) {
    n && (e.tooltip = new Jd({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: S1
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const FI = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function LI(e, t, n, r) {
  const o = e.indexOf(t);
  if (o === -1)
    return FI(e, t, n, r);
  const s = e.lastIndexOf(t);
  return o !== s ? n : o;
}
const VI = (e, t) => e === null ? null : cn(Math.round(e), 0, t);
function lb(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class ef extends Xo {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: s } of n)
        r[o] === s && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (yt(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : LI(r, t, ut(n, t), this._addedLabels), VI(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, o = [];
    let s = this.getLabels();
    s = t === 0 && n === s.length - 1 ? s : s.slice(t, n + 1), this._valueRange = Math.max(s.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let i = t; i <= n; i++)
      o.push({
        value: i
      });
    return o;
  }
  getLabelForValue(t) {
    return lb.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ae(ef, "id", "category"), ae(ef, "defaults", {
  ticks: {
    callback: lb
  }
});
function WI(e, t) {
  const n = [], { bounds: o, step: s, min: i, max: a, precision: c, count: l, maxTicks: u, maxDigits: d, includeBounds: f } = e, h = s || 1, p = u - 1, { min: g, max: m } = t, y = !yt(i), v = !yt(a), w = !yt(l), C = (m - g) / (d + 1);
  let x = fm((m - g) / p / h) * h, E, S, M, T;
  if (x < 1e-14 && !y && !v)
    return [
      {
        value: g
      },
      {
        value: m
      }
    ];
  T = Math.ceil(m / x) - Math.floor(g / x), T > p && (x = fm(T * x / p / h) * h), yt(c) || (E = Math.pow(10, c), x = Math.ceil(x * E) / E), o === "ticks" ? (S = Math.floor(g / x) * x, M = Math.ceil(m / x) * x) : (S = g, M = m), y && v && s && m2((a - i) / s, x / 1e3) ? (T = Math.round(Math.min((a - i) / x, u)), x = (a - i) / T, S = i, M = a) : w ? (S = y ? i : S, M = v ? a : M, T = l - 1, x = (M - S) / T) : (T = (M - S) / x, Si(T, Math.round(T), x / 1e3) ? T = Math.round(T) : T = Math.ceil(T));
  const P = Math.max(hm(x), hm(S));
  E = Math.pow(10, yt(c) ? P : c), S = Math.round(S * E) / E, M = Math.round(M * E) / E;
  let k = 0;
  for (y && (f && S !== i ? (n.push({
    value: i
  }), S < i && k++, Si(Math.round((S + k * x) * E) / E, i, ub(i, C, e)) && k++) : S < i && k++); k < T; ++k) {
    const I = Math.round((S + k * x) * E) / E;
    if (v && I > a)
      break;
    n.push({
      value: I
    });
  }
  return v && f && M !== a ? n.length && Si(n[n.length - 1].value, a, ub(a, C, e)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!v || M === a) && n.push({
    value: M
  }), n;
}
function ub(e, t, { horizontal: n, minRotation: r }) {
  const o = lr(r), s = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, i = 0.75 * t * ("" + e).length;
  return Math.min(t / s, i);
}
class Zc extends Xo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return yt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: s } = this;
    const i = (c) => o = n ? o : c, a = (c) => s = r ? s : c;
    if (t) {
      const c = gr(o), l = gr(s);
      c < 0 && l < 0 ? a(0) : c > 0 && l > 0 && i(0);
    }
    if (o === s) {
      let c = s === 0 ? 1 : Math.abs(s * 0.05);
      a(s + c), t || i(o - c);
    }
    this.min = o, this.max = s;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, s = this._range || this, i = WI(o, s);
    return t.bounds === "ticks" && Uy(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const o = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return eu(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class tf extends Zc {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = tn(t) ? t : 0, this.max = tn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = lr(this.options.ticks.minRotation), o = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, s.lineHeight / o));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
ae(tf, "id", "linear"), ae(tf, "defaults", {
  ticks: {
    callback: tu.formatters.numeric
  }
});
const zi = (e) => Math.floor(io(e)), To = (e, t) => Math.pow(10, zi(e) + t);
function db(e) {
  return e / Math.pow(10, zi(e)) === 1;
}
function fb(e, t, n) {
  const r = Math.pow(10, n), o = Math.floor(e / r);
  return Math.ceil(t / r) - o;
}
function BI(e, t) {
  const n = t - e;
  let r = zi(n);
  for (; fb(e, t, r) > 10; )
    r++;
  for (; fb(e, t, r) < 10; )
    r--;
  return Math.min(r, zi(e));
}
function HI(e, { min: t, max: n }) {
  t = On(e.min, t);
  const r = [], o = zi(t);
  let s = BI(t, n), i = s < 0 ? Math.pow(10, Math.abs(s)) : 1;
  const a = Math.pow(10, s), c = o > s ? Math.pow(10, o) : 0, l = Math.round((t - c) * i) / i, u = Math.floor((t - c) / a / 10) * a * 10;
  let d = Math.floor((l - u) / Math.pow(10, s)), f = On(e.min, Math.round((c + u + d * Math.pow(10, s)) * i) / i);
  for (; f < n; )
    r.push({
      value: f,
      major: db(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (s++, d = 2, i = s >= 0 ? 1 : i), f = Math.round((c + u + d * Math.pow(10, s)) * i) / i;
  const h = On(e.max, f);
  return r.push({
    value: h,
    major: db(h),
    significand: d
  }), r;
}
class hb extends Xo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = Zc.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return tn(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = tn(t) ? Math.max(0, t) : null, this.max = tn(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !tn(this._userMin) && (this.min = t === To(this.min, 0) ? To(this.min, -1) : To(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, o = this.max;
    const s = (a) => r = t ? r : a, i = (a) => o = n ? o : a;
    r === o && (r <= 0 ? (s(1), i(10)) : (s(To(r, -1)), i(To(o, 1)))), r <= 0 && s(To(o, -1)), o <= 0 && i(To(r, 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = HI(n, this);
    return t.bounds === "ticks" && Uy(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : eu(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = io(t), this._valueRange = io(this.max) - io(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (io(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
ae(hb, "id", "logarithmic"), ae(hb, "defaults", {
  ticks: {
    callback: tu.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function nf(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = zn(t.backdropPadding);
    return ut(t.font && t.font.size, zt.font.size) + n.height;
  }
  return 0;
}
function YI(e, t, n) {
  return n = Ft(n) ? n : [
    n
  ], {
    w: A2(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function pb(e, t, n, r, o) {
  return e === r || e === o ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > o ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function zI(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], o = [], s = e._pointLabels.length, i = e.options.pointLabels, a = i.centerPointLabels ? Gt / s : 0;
  for (let c = 0; c < s; c++) {
    const l = i.setContext(e.getPointLabelContext(c));
    o[c] = l.padding;
    const u = e.getPointPosition(c, e.drawingArea + o[c], a), d = In(l.font), f = YI(e.ctx, d, e._pointLabels[c]);
    r[c] = f;
    const h = Zn(e.getIndexAngle(c) + a), p = Math.round(Fh(h)), g = pb(p, u.x, f.w, 0, 180), m = pb(p, u.y, f.h, 90, 270);
    jI(n, t, h, g, m);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = KI(e, r, o);
}
function jI(e, t, n, r, o) {
  const s = Math.abs(Math.sin(n)), i = Math.abs(Math.cos(n));
  let a = 0, c = 0;
  r.start < t.l ? (a = (t.l - r.start) / s, e.l = Math.min(e.l, t.l - a)) : r.end > t.r && (a = (r.end - t.r) / s, e.r = Math.max(e.r, t.r + a)), o.start < t.t ? (c = (t.t - o.start) / i, e.t = Math.min(e.t, t.t - c)) : o.end > t.b && (c = (o.end - t.b) / i, e.b = Math.max(e.b, t.b + c));
}
function UI(e, t, n) {
  const r = e.drawingArea, { extra: o, additionalAngle: s, padding: i, size: a } = n, c = e.getPointPosition(t, r + o + i, s), l = Math.round(Fh(Zn(c.angle + Wt))), u = ZI(c.y, a.h, l), d = qI(l), f = XI(c.x, a.w, d);
  return {
    visible: !0,
    x: c.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + a.w,
    bottom: u + a.h
  };
}
function GI(e, t) {
  if (!t)
    return !0;
  const { left: n, top: r, right: o, bottom: s } = e;
  return !(Dr({
    x: n,
    y: r
  }, t) || Dr({
    x: n,
    y: s
  }, t) || Dr({
    x: o,
    y: r
  }, t) || Dr({
    x: o,
    y: s
  }, t));
}
function KI(e, t, n) {
  const r = [], o = e._pointLabels.length, s = e.options, { centerPointLabels: i, display: a } = s.pointLabels, c = {
    extra: nf(s) / 2,
    additionalAngle: i ? Gt / o : 0
  };
  let l;
  for (let u = 0; u < o; u++) {
    c.padding = n[u], c.size = t[u];
    const d = UI(e, u, c);
    r.push(d), a === "auto" && (d.visible = GI(d, l), d.visible && (l = d));
  }
  return r;
}
function qI(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function XI(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function ZI(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function QI(e, t, n) {
  const { left: r, top: o, right: s, bottom: i } = n, { backdropColor: a } = t;
  if (!yt(a)) {
    const c = ms(t.borderRadius), l = zn(t.backdropPadding);
    e.fillStyle = a;
    const u = r - l.left, d = o - l.top, f = s - r + l.width, h = i - o + l.height;
    Object.values(c).some((p) => p !== 0) ? (e.beginPath(), Gc(e, {
      x: u,
      y: d,
      w: f,
      h,
      radius: c
    }), e.fill()) : e.fillRect(u, d, f, h);
  }
}
function JI(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let o = t - 1; o >= 0; o--) {
    const s = e._pointLabelItems[o];
    if (!s.visible)
      continue;
    const i = r.setContext(e.getPointLabelContext(o));
    QI(n, i, s);
    const a = In(i.font), { x: c, y: l, textAlign: u } = s;
    Uc(n, e._pointLabels[o], c, l + a.lineHeight / 2, a, {
      color: i.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function O1(e, t, n, r) {
  const { ctx: o } = e;
  if (n)
    o.arc(e.xCenter, e.yCenter, t, 0, Nt);
  else {
    let s = e.getPointPosition(0, t);
    o.moveTo(s.x, s.y);
    for (let i = 1; i < r; i++)
      s = e.getPointPosition(i, t), o.lineTo(s.x, s.y);
  }
}
function eD(e, t, n, r, o) {
  const s = e.ctx, i = t.circular, { color: a, lineWidth: c } = t;
  !i && !r || !a || !c || n < 0 || (s.save(), s.strokeStyle = a, s.lineWidth = c, s.setLineDash(o.dash), s.lineDashOffset = o.dashOffset, s.beginPath(), O1(e, n, i, r), s.closePath(), s.stroke(), s.restore());
}
function tD(e, t, n) {
  return wo(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Ua extends Zc {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = zn(nf(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = tn(t) && !isNaN(t) ? t : 0, this.max = tn(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / nf(this.options));
  }
  generateTickLabels(t) {
    Zc.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const o = Vt(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return o || o === 0 ? o : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? zI(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, o) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, o));
  }
  getIndexAngle(t) {
    const n = Nt / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return Zn(t * n + lr(r));
  }
  getDistanceFromCenterForValue(t) {
    if (yt(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (yt(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return tD(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const o = this.getIndexAngle(t) - Wt + r;
    return {
      x: Math.cos(o) * n + this.xCenter,
      y: Math.sin(o) * n + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: o, bottom: s } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: o,
      bottom: s
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), O1(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: o, border: s } = n, i = this._pointLabels.length;
    let a, c, l;
    if (n.pointLabels.display && JI(this, i), o.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        c = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), h = o.setContext(f), p = s.setContext(f);
        eD(this, h, c, i, p);
      }
    }), r.display) {
      for (t.save(), a = i - 1; a >= 0; a--) {
        const u = r.setContext(this.getPointLabelContext(a)), { color: d, lineWidth: f } = u;
        !f || !d || (t.lineWidth = f, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, c = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), l = this.getPointPosition(a, c), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(l.x, l.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const o = this.getIndexAngle(0);
    let s, i;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(o), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((a, c) => {
      if (c === 0 && !n.reverse)
        return;
      const l = r.setContext(this.getContext(c)), u = In(l.font);
      if (s = this.getDistanceFromCenterForValue(this.ticks[c].value), l.showLabelBackdrop) {
        t.font = u.string, i = t.measureText(a.label).width, t.fillStyle = l.backdropColor;
        const d = zn(l.backdropPadding);
        t.fillRect(-i / 2 - d.left, -s - u.size / 2 - d.top, i + d.width, u.size + d.height);
      }
      Uc(t, a.label, 0, -s, u, {
        color: l.color,
        strokeColor: l.textStrokeColor,
        strokeWidth: l.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
ae(Ua, "id", "radialLinear"), ae(Ua, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: tu.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ae(Ua, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ae(Ua, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const ru = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, vn = /* @__PURE__ */ Object.keys(ru);
function gb(e, t) {
  return e - t;
}
function mb(e, t) {
  if (yt(t))
    return null;
  const n = e._adapter, { parser: r, round: o, isoWeekday: s } = e._parseOpts;
  let i = t;
  return typeof r == "function" && (i = r(i)), tn(i) || (i = typeof r == "string" ? n.parse(i, r) : n.parse(i)), i === null ? null : (o && (i = o === "week" && (Bi(s) || s === !0) ? n.startOf(i, "isoWeek", s) : n.startOf(i, o)), +i);
}
function bb(e, t, n, r) {
  const o = vn.length;
  for (let s = vn.indexOf(e); s < o - 1; ++s) {
    const i = ru[vn[s]], a = i.steps ? i.steps : Number.MAX_SAFE_INTEGER;
    if (i.common && Math.ceil((n - t) / (a * i.size)) <= r)
      return vn[s];
  }
  return vn[o - 1];
}
function nD(e, t, n, r, o) {
  for (let s = vn.length - 1; s >= vn.indexOf(n); s--) {
    const i = vn[s];
    if (ru[i].common && e._adapter.diff(o, r, i) >= t - 1)
      return i;
  }
  return vn[n ? vn.indexOf(n) : 0];
}
function rD(e) {
  for (let t = vn.indexOf(e) + 1, n = vn.length; t < n; ++t)
    if (ru[vn[t]].common)
      return vn[t];
}
function vb(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = Lh(n, t), s = n[r] >= t ? n[r] : n[o];
    e[s] = !0;
  }
}
function oD(e, t, n, r) {
  const o = e._adapter, s = +o.startOf(t[0].value, r), i = t[t.length - 1].value;
  let a, c;
  for (a = s; a <= i; a = +o.add(a, 1, r))
    c = n[a], c >= 0 && (t[c].major = !0);
  return t;
}
function yb(e, t, n) {
  const r = [], o = {}, s = t.length;
  let i, a;
  for (i = 0; i < s; ++i)
    a = t[i], o[a] = i, r.push({
      value: a,
      major: !1
    });
  return s === 0 || !n ? r : oD(e, r, o, n);
}
class ji extends Xo {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const r = t.time || (t.time = {}), o = this._adapter = new f1._date(t.adapters.date);
    o.init(n), _i(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : mb(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: o, max: s, minDefined: i, maxDefined: a } = this.getUserBounds();
    function c(l) {
      !i && !isNaN(l.min) && (o = Math.min(o, l.min)), !a && !isNaN(l.max) && (s = Math.max(s, l.max));
    }
    (!i || !a) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), o = tn(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), s = tn(s) && !isNaN(s) ? s : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, s - 1), this.max = Math.max(o + 1, s);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const s = this.min, i = this.max, a = w2(o, s, i);
    return this._unit = n.unit || (r.autoSkip ? bb(n.minUnit, this.min, this.max, this._getLabelCapacity(s)) : nD(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : rD(this._unit), this.initOffsets(o), t.reverse && a.reverse(), yb(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, r = 0, o, s;
    this.options.offset && t.length && (o = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(t[1]) - o) / 2, s = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = s : r = (s - this.getDecimalForValue(t[t.length - 2])) / 2);
    const i = t.length < 3 ? 0.5 : 0.25;
    n = cn(n, 0, i), r = cn(r, 0, i), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, o = this.options, s = o.time, i = s.unit || bb(s.minUnit, n, r, this._getLabelCapacity(n)), a = ut(o.ticks.stepSize, 1), c = i === "week" ? s.isoWeekday : !1, l = Bi(c) || c === !0, u = {};
    let d = n, f, h;
    if (l && (d = +t.startOf(d, "isoWeek", c)), d = +t.startOf(d, l ? "day" : i), t.diff(r, n, i) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + i);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +t.add(f, a, i), h++)
      vb(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && vb(u, f, p), Object.keys(u).sort(gb).map((g) => +g);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  format(t, n) {
    const o = this.options.time.displayFormats, s = this._unit, i = n || o[s];
    return this._adapter.format(t, i);
  }
  _tickFormatFunction(t, n, r, o) {
    const s = this.options, i = s.ticks.callback;
    if (i)
      return Vt(i, [
        t,
        n,
        r
      ], this);
    const a = s.time.displayFormats, c = this._unit, l = this._majorUnit, u = c && a[c], d = l && a[l], f = r[n], h = l && d && f && f.major;
    return this._adapter.format(t, o || (h ? d : u));
  }
  generateTickLabels(t) {
    let n, r, o;
    for (n = 0, r = t.length; n < r; ++n)
      o = t[n], o.label = this._tickFormatFunction(o.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, o = lr(this.isHorizontal() ? n.maxRotation : n.minRotation), s = Math.cos(o), i = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * s + a * i,
      h: r * i + a * s
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, s = this._tickFormatFunction(t, 0, yb(this, [
      t
    ], this._majorUnit), o), i = this._getLabelSize(s), a = Math.floor(this.isHorizontal() ? this.width / i.w : this.height / i.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      t = t.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      t.push(mb(this, o[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return qy(t.sort(gb));
  }
}
ae(ji, "id", "time"), ae(ji, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Ga(e, t, n) {
  let r = 0, o = e.length - 1, s, i, a, c;
  n ? (t >= e[r].pos && t <= e[o].pos && ({ lo: r, hi: o } = Fo(e, "pos", t)), { pos: s, time: a } = e[r], { pos: i, time: c } = e[o]) : (t >= e[r].time && t <= e[o].time && ({ lo: r, hi: o } = Fo(e, "time", t)), { time: s, pos: a } = e[r], { time: i, pos: c } = e[o]);
  const l = i - s;
  return l ? a + (c - a) * (t - s) / l : a;
}
class wb extends ji {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Ga(n, this.min), this._tableRange = Ga(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, o = [], s = [];
    let i, a, c, l, u;
    for (i = 0, a = t.length; i < a; ++i)
      l = t[i], l >= n && l <= r && o.push(l);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (i = 0, a = o.length; i < a; ++i)
      u = o[i + 1], c = o[i - 1], l = o[i], Math.round((u + c) / 2) !== l && s.push({
        time: l,
        pos: i / (a - 1)
      });
    return s;
  }
  _generate() {
    const t = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, s) => o - s);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Ga(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return Ga(this._table, r * this._tableRange + this._minPos, !0);
  }
}
ae(wb, "id", "timeseries"), ae(wb, "defaults", ji.defaults);
function Yr(e) {
  "@babel/helpers - typeof";
  return Yr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yr(e);
}
function kt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Pe(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ae(e) {
  Pe(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Yr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function M1(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = kt(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Gh(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = kt(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), s = new Date(n.getTime());
  s.setMonth(n.getMonth() + r + 1, 0);
  var i = s.getDate();
  return o >= i ? s : (n.setFullYear(s.getFullYear(), s.getMonth(), o), n);
}
function sa(e, t) {
  Pe(2, arguments);
  var n = Ae(e).getTime(), r = kt(t);
  return new Date(n + r);
}
var sD = 36e5;
function iD(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  return sa(e, n * sD);
}
var aD = {};
function xo() {
  return aD;
}
function xb(e, t) {
  var n, r, o, s, i, a, c, l;
  Pe(1, arguments);
  var u = xo(), d = kt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ae(e), h = f.getDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function Qc(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function rf(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setHours(0, 0, 0, 0), t;
}
var cD = 864e5;
function of(e, t) {
  Pe(2, arguments);
  var n = rf(e), r = rf(t), o = n.getTime() - Qc(n), s = r.getTime() - Qc(r);
  return Math.round((o - s) / cD);
}
var lD = 6e4;
function uD(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  return sa(e, n * lD);
}
function dD(e, t) {
  Pe(2, arguments);
  var n = kt(t), r = n * 3;
  return Gh(e, r);
}
function fD(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  return sa(e, n * 1e3);
}
function hD(e, t) {
  Pe(2, arguments);
  var n = kt(t), r = n * 7;
  return M1(e, r);
}
function pD(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  return Gh(e, n * 12);
}
function Ti(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
var ou = 6e4, su = 36e5, gD = 1e3;
function mD(e) {
  return Pe(1, arguments), e instanceof Date || Yr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Kh(e) {
  if (Pe(1, arguments), !mD(e) && typeof e != "number")
    return !1;
  var t = Ae(e);
  return !isNaN(Number(t));
}
function bD(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t), o = n.getFullYear() - r.getFullYear(), s = n.getMonth() - r.getMonth();
  return o * 12 + s;
}
function vD(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t);
  return n.getFullYear() - r.getFullYear();
}
function Cb(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function T1(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t), o = Cb(n, r), s = Math.abs(of(n, r));
  n.setDate(n.getDate() - o * s);
  var i = +(Cb(n, r) === -o), a = o * (s - i);
  return a === 0 ? 0 : a;
}
function iu(e, t) {
  return Pe(2, arguments), Ae(e).getTime() - Ae(t).getTime();
}
var Eb = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, yD = "trunc";
function ia(e) {
  return e ? Eb[e] : Eb[yD];
}
function wD(e, t, n) {
  Pe(2, arguments);
  var r = iu(e, t) / su;
  return ia(n == null ? void 0 : n.roundingMethod)(r);
}
function xD(e, t, n) {
  Pe(2, arguments);
  var r = iu(e, t) / ou;
  return ia(n == null ? void 0 : n.roundingMethod)(r);
}
function k1(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setHours(23, 59, 59, 999), t;
}
function P1(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function CD(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return k1(t).getTime() === P1(t).getTime();
}
function R1(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t), o = Ti(n, r), s = Math.abs(bD(n, r)), i;
  if (s < 1)
    i = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * s);
    var a = Ti(n, r) === -o;
    CD(Ae(e)) && s === 1 && Ti(e, r) === 1 && (a = !1), i = o * (s - Number(a));
  }
  return i === 0 ? 0 : i;
}
function ED(e, t, n) {
  Pe(2, arguments);
  var r = R1(e, t) / 3;
  return ia(n == null ? void 0 : n.roundingMethod)(r);
}
function _D(e, t, n) {
  Pe(2, arguments);
  var r = iu(e, t) / 1e3;
  return ia(n == null ? void 0 : n.roundingMethod)(r);
}
function SD(e, t, n) {
  Pe(2, arguments);
  var r = T1(e, t) / 7;
  return ia(n == null ? void 0 : n.roundingMethod)(r);
}
function OD(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t), o = Ti(n, r), s = Math.abs(vD(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var i = Ti(n, r) === -o, a = o * (s - Number(i));
  return a === 0 ? 0 : a;
}
function MD(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setSeconds(0, 0), t;
}
function TD(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function yc(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function kD(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function PD(e) {
  Pe(1, arguments);
  var t = Ae(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function RD(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setMinutes(59, 59, 999), t;
}
function ID(e, t) {
  var n, r, o, s, i, a, c, l;
  Pe(1, arguments);
  var u = xo(), d = kt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ae(e), h = f.getDay(), p = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + p), f.setHours(23, 59, 59, 999), f;
}
function DD(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setSeconds(59, 999), t;
}
function ND(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getMonth(), r = n - n % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
function AD(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setMilliseconds(999), t;
}
function I1(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  return sa(e, -n);
}
var $D = 864e5;
function FD(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / $D) + 1;
}
function Ss(e) {
  Pe(1, arguments);
  var t = 1, n = Ae(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function D1(e) {
  Pe(1, arguments);
  var t = Ae(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Ss(r), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(n, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var i = Ss(s);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function LD(e) {
  Pe(1, arguments);
  var t = D1(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Ss(n);
  return r;
}
var VD = 6048e5;
function N1(e) {
  Pe(1, arguments);
  var t = Ae(e), n = Ss(t).getTime() - LD(t).getTime();
  return Math.round(n / VD) + 1;
}
function Uo(e, t) {
  var n, r, o, s, i, a, c, l;
  Pe(1, arguments);
  var u = xo(), d = kt((n = (r = (o = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Ae(e), h = f.getUTCDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - p), f.setUTCHours(0, 0, 0, 0), f;
}
function qh(e, t) {
  var n, r, o, s, i, a, c, l;
  Pe(1, arguments);
  var u = Ae(e), d = u.getUTCFullYear(), f = xo(), h = kt((n = (r = (o = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = f.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var g = Uo(p, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d, 0, h), m.setUTCHours(0, 0, 0, 0);
  var y = Uo(m, t);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= y.getTime() ? d : d - 1;
}
function WD(e, t) {
  var n, r, o, s, i, a, c, l;
  Pe(1, arguments);
  var u = xo(), d = kt((n = (r = (o = (s = t == null ? void 0 : t.firstWeekContainsDate) !== null && s !== void 0 ? s : t == null || (i = t.locale) === null || i === void 0 || (a = i.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = qh(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = Uo(h, t);
  return p;
}
var BD = 6048e5;
function A1(e, t) {
  Pe(1, arguments);
  var n = Ae(e), r = Uo(n, t).getTime() - WD(n, t).getTime();
  return Math.round(r / BD) + 1;
}
function gt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var HD = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return gt(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : gt(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return gt(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return gt(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return gt(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return gt(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return gt(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), s = Math.floor(o * Math.pow(10, r - 3));
    return gt(s, n.length);
  }
};
const Jr = HD;
var es = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, YD = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), s = o > 0 ? o : 1 - o;
      return r.ordinalNumber(s, {
        unit: "year"
      });
    }
    return Jr.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var s = qh(t, o), i = s > 0 ? s : 1 - s;
    if (n === "YY") {
      var a = i % 100;
      return gt(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : gt(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = D1(t);
    return gt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return gt(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return gt(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return gt(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Jr.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return gt(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var s = A1(t, o);
    return n === "wo" ? r.ordinalNumber(s, {
      unit: "week"
    }) : gt(s, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = N1(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : gt(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Jr.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = FD(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : gt(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var s = t.getUTCDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return gt(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var s = t.getUTCDay(), i = (s - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return gt(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), s = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(s);
      case "ii":
        return gt(s, n.length);
      case "io":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), s = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), s;
    switch (o === 12 ? s = es.noon : o === 0 ? s = es.midnight : s = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), s;
    switch (o >= 17 ? s = es.evening : o >= 12 ? s = es.afternoon : o >= 4 ? s = es.morning : s = es.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Jr.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Jr.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : gt(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : gt(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Jr.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Jr.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Jr.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return Sb(i);
      case "XXXX":
      case "XX":
        return Io(i);
      case "XXXXX":
      case "XXX":
      default:
        return Io(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "x":
        return Sb(i);
      case "xxxx":
      case "xx":
        return Io(i);
      case "xxxxx":
      case "xxx":
      default:
        return Io(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + _b(i, ":");
      case "OOOO":
      default:
        return "GMT" + Io(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + _b(i, ":");
      case "zzzz":
      default:
        return "GMT" + Io(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var s = o._originalDate || t, i = Math.floor(s.getTime() / 1e3);
    return gt(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var s = o._originalDate || t, i = s.getTime();
    return gt(i, n.length);
  }
};
function _b(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), s = r % 60;
  if (s === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + gt(s, 2);
}
function Sb(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + gt(Math.abs(e) / 60, 2);
  }
  return Io(e, t);
}
function Io(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), s = gt(Math.floor(o / 60), 2), i = gt(o % 60, 2);
  return r + s + n + i;
}
const zD = YD;
var Ob = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, $1 = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, jD = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], s = r[2];
  if (!s)
    return Ob(t, n);
  var i;
  switch (o) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Ob(o, n)).replace("{{time}}", $1(s, n));
}, UD = {
  p: $1,
  P: jD
};
const sf = UD;
var GD = ["D", "DD"], KD = ["YY", "YYYY"];
function F1(e) {
  return GD.indexOf(e) !== -1;
}
function L1(e) {
  return KD.indexOf(e) !== -1;
}
function Jc(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var qD = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, XD = function(t, n, r) {
  var o, s = qD[t];
  return typeof s == "string" ? o = s : n === 1 ? o = s.one : o = s.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const ZD = XD;
function Qu(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var QD = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, JD = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, eN = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, tN = {
  date: Qu({
    formats: QD,
    defaultWidth: "full"
  }),
  time: Qu({
    formats: JD,
    defaultWidth: "full"
  }),
  dateTime: Qu({
    formats: eN,
    defaultWidth: "full"
  })
};
const nN = tN;
var rN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, oN = function(t, n, r, o) {
  return rN[t];
};
const sN = oN;
function Js(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var s = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[i] || e.formattingValues[s];
    } else {
      var a = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[a];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
var iN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, aN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, lN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, uN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, dN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, fN = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, hN = {
  ordinalNumber: fN,
  era: Js({
    values: iN,
    defaultWidth: "wide"
  }),
  quarter: Js({
    values: aN,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Js({
    values: cN,
    defaultWidth: "wide"
  }),
  day: Js({
    values: lN,
    defaultWidth: "wide"
  }),
  dayPeriod: Js({
    values: uN,
    defaultWidth: "wide",
    formattingValues: dN,
    defaultFormattingWidth: "wide"
  })
};
const pN = hN;
function ei(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = t.match(o);
    if (!s)
      return null;
    var i = s[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(a) ? mN(a, function(d) {
      return d.test(i);
    }) : gN(a, function(d) {
      return d.test(i);
    }), l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var u = t.slice(i.length);
    return {
      value: l,
      rest: u
    };
  };
}
function gN(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function mN(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function bN(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], s = t.match(e.parsePattern);
    if (!s)
      return null;
    var i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var a = t.slice(o.length);
    return {
      value: i,
      rest: a
    };
  };
}
var vN = /^(\d+)(th|st|nd|rd)?/i, yN = /\d+/i, wN = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, xN = {
  any: [/^b/i, /^(a|c)/i]
}, CN = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, EN = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _N = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, SN = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, ON = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, MN = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, TN = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kN = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, PN = {
  ordinalNumber: bN({
    matchPattern: vN,
    parsePattern: yN,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ei({
    matchPatterns: wN,
    defaultMatchWidth: "wide",
    parsePatterns: xN,
    defaultParseWidth: "any"
  }),
  quarter: ei({
    matchPatterns: CN,
    defaultMatchWidth: "wide",
    parsePatterns: EN,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ei({
    matchPatterns: _N,
    defaultMatchWidth: "wide",
    parsePatterns: SN,
    defaultParseWidth: "any"
  }),
  day: ei({
    matchPatterns: ON,
    defaultMatchWidth: "wide",
    parsePatterns: MN,
    defaultParseWidth: "any"
  }),
  dayPeriod: ei({
    matchPatterns: TN,
    defaultMatchWidth: "any",
    parsePatterns: kN,
    defaultParseWidth: "any"
  })
};
const RN = PN;
var IN = {
  code: "en-US",
  formatDistance: ZD,
  formatLong: nN,
  formatRelative: sN,
  localize: pN,
  match: RN,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const V1 = IN;
var DN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, NN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, AN = /^'([^]*?)'?$/, $N = /''/g, FN = /[a-zA-Z]/;
function Lr(e, t, n) {
  var r, o, s, i, a, c, l, u, d, f, h, p, g, m, y, v, w, C;
  Pe(2, arguments);
  var x = String(t), E = xo(), S = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : E.locale) !== null && r !== void 0 ? r : V1, M = kt((s = (i = (a = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : E.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = E.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(M >= 1 && M <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = kt((h = (p = (g = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (y = n.locale) === null || y === void 0 || (v = y.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && g !== void 0 ? g : E.weekStartsOn) !== null && p !== void 0 ? p : (w = E.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!S.localize)
    throw new RangeError("locale must contain localize property");
  if (!S.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var P = Ae(e);
  if (!Kh(P))
    throw new RangeError("Invalid time value");
  var k = Qc(P), I = I1(P, k), O = {
    firstWeekContainsDate: M,
    weekStartsOn: T,
    locale: S,
    _originalDate: P
  }, A = x.match(NN).map(function(R) {
    var N = R[0];
    if (N === "p" || N === "P") {
      var $ = sf[N];
      return $(R, S.formatLong);
    }
    return R;
  }).join("").match(DN).map(function(R) {
    if (R === "''")
      return "'";
    var N = R[0];
    if (N === "'")
      return LN(R);
    var $ = zD[N];
    if ($)
      return !(n != null && n.useAdditionalWeekYearTokens) && L1(R) && Jc(R, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && F1(R) && Jc(R, t, String(e)), $(I, R, S.localize, O);
    if (N.match(FN))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + N + "`");
    return R;
  }).join("");
  return A;
}
function LN(e) {
  var t = e.match(AN);
  return t ? t[1].replace($N, "'") : e;
}
function VN(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function WN(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t);
  return n.getTime() > r.getTime();
}
function BN(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = Ae(t);
  return n.getTime() < r.getTime();
}
function Mb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function HN(e, t) {
  if (e) {
    if (typeof e == "string")
      return Mb(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Mb(e, t);
  }
}
function Tb(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = HN(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s = !0, i = !1, a;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return s = l.done, l;
    },
    e: function(l) {
      i = !0, a = l;
    },
    f: function() {
      try {
        !s && n.return != null && n.return();
      } finally {
        if (i)
          throw a;
      }
    }
  };
}
function Te(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function af(e, t) {
  return af = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, af(e, t);
}
function ct(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && af(e, t);
}
function el(e) {
  return el = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, el(e);
}
function YN() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zN(e, t) {
  if (t && (Yr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Te(e);
}
function lt(e) {
  var t = YN();
  return function() {
    var r = el(e), o;
    if (t) {
      var s = el(this).constructor;
      o = Reflect.construct(r, arguments, s);
    } else
      o = r.apply(this, arguments);
    return zN(this, o);
  };
}
function ot(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function jN(e, t) {
  if (Yr(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Yr(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function W1(e) {
  var t = jN(e, "string");
  return Yr(t) === "symbol" ? t : String(t);
}
function kb(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, W1(r.key), r);
  }
}
function st(e, t, n) {
  return t && kb(e.prototype, t), n && kb(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ce(e, t, n) {
  return t = W1(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var UN = 10, B1 = /* @__PURE__ */ function() {
  function e() {
    ot(this, e), Ce(this, "priority", void 0), Ce(this, "subPriority", 0);
  }
  return st(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
}(), GN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n(r, o, s, i, a) {
    var c;
    return ot(this, n), c = t.call(this), c.value = r, c.validateValue = o, c.setValue = s, c.priority = i, a && (c.subPriority = a), c;
  }
  return st(n, [{
    key: "validate",
    value: function(o, s) {
      return this.validateValue(o, this.value, s);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return this.setValue(o, s, this.value, i);
    }
  }]), n;
}(B1), KN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", UN), Ce(Te(r), "subPriority", -1), r;
  }
  return st(n, [{
    key: "set",
    value: function(o, s) {
      if (s.timestampIsSet)
        return o;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), i.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), i;
    }
  }]), n;
}(B1), dt = /* @__PURE__ */ function() {
  function e() {
    ot(this, e), Ce(this, "incompatibleTokens", void 0), Ce(this, "priority", void 0), Ce(this, "subPriority", void 0);
  }
  return st(e, [{
    key: "run",
    value: function(n, r, o, s) {
      var i = this.parse(n, r, o, s);
      return i ? {
        setter: new GN(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), e;
}(), qN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 140), Ce(Te(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(o, {
            width: "wide"
          }) || i.era(o, {
            width: "abbreviated"
          }) || i.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.era = i, o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), jt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ir = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ut(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Lt(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function ar(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, s = n[3] ? parseInt(n[3], 10) : 0, i = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * su + s * ou + i * gD),
    rest: t.slice(n[0].length)
  };
}
function H1(e) {
  return Lt(jt.anyDigitsSigned, e);
}
function Bt(e, t) {
  switch (e) {
    case 1:
      return Lt(jt.singleDigit, t);
    case 2:
      return Lt(jt.twoDigits, t);
    case 3:
      return Lt(jt.threeDigits, t);
    case 4:
      return Lt(jt.fourDigits, t);
    default:
      return Lt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function tl(e, t) {
  switch (e) {
    case 1:
      return Lt(jt.singleDigitSigned, t);
    case 2:
      return Lt(jt.twoDigitsSigned, t);
    case 3:
      return Lt(jt.threeDigitsSigned, t);
    case 4:
      return Lt(jt.fourDigitsSigned, t);
    default:
      return Lt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Xh(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Y1(e, t) {
  var n = t > 0, r = n ? t : 1 - t, o;
  if (r <= 50)
    o = e || 100;
  else {
    var s = r + 50, i = Math.floor(s / 100) * 100, a = e >= s % 100;
    o = e + i - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function z1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var XN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 130), Ce(Te(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(l) {
        return {
          year: l,
          isTwoDigitYear: s === "yy"
        };
      };
      switch (s) {
        case "y":
          return Ut(Bt(4, o), a);
        case "yo":
          return Ut(i.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Ut(Bt(s.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var c = Y1(i.year, a);
        return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var l = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), ZN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 130), Ce(Te(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(l) {
        return {
          year: l,
          isTwoDigitYear: s === "YY"
        };
      };
      switch (s) {
        case "Y":
          return Ut(Bt(4, o), a);
        case "Yo":
          return Ut(i.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Ut(Bt(s.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s.isTwoDigitYear || s.year > 0;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      var c = qh(o, a);
      if (i.isTwoDigitYear) {
        var l = Y1(i.year, c);
        return o.setUTCFullYear(l, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), Uo(o, a);
      }
      var u = !("era" in s) || s.era === 1 ? i.year : 1 - i.year;
      return o.setUTCFullYear(u, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), Uo(o, a);
    }
  }]), n;
}(dt), QN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 130), Ce(Te(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s) {
      return tl(s === "R" ? 4 : s.length, o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(i, 0, 4), a.setUTCHours(0, 0, 0, 0), Ss(a);
    }
  }]), n;
}(dt), JN = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 130), Ce(Te(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s) {
      return tl(s === "u" ? 4 : s.length, o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCFullYear(i, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), e5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 120), Ce(Te(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "Q":
        case "QQ":
          return Bt(s.length, o);
        case "Qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), t5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 120), Ce(Te(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "q":
        case "qq":
          return Bt(s.length, o);
        case "qo":
          return i.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 4;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth((i - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), n5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Ce(Te(r), "priority", 110), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(l) {
        return l - 1;
      };
      switch (s) {
        case "M":
          return Ut(Lt(jt.month, o), a);
        case "MM":
          return Ut(Bt(2, o), a);
        case "Mo":
          return Ut(i.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "MMM":
          return i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(o, {
            width: "wide",
            context: "formatting"
          }) || i.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), r5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 110), Ce(Te(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(l) {
        return l - 1;
      };
      switch (s) {
        case "L":
          return Ut(Lt(jt.month, o), a);
        case "LL":
          return Ut(Bt(2, o), a);
        case "Lo":
          return Ut(i.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "LLL":
          return i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(o, {
            width: "wide",
            context: "standalone"
          }) || i.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(i, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt);
function o5(e, t, n) {
  Pe(2, arguments);
  var r = Ae(e), o = kt(t), s = A1(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - s * 7), r;
}
var s5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 100), Ce(Te(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "w":
          return Lt(jt.week, o);
        case "wo":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return Uo(o5(o, i, a), a);
    }
  }]), n;
}(dt);
function i5(e, t) {
  Pe(2, arguments);
  var n = Ae(e), r = kt(t), o = N1(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var a5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 100), Ce(Te(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "I":
          return Lt(jt.week, o);
        case "Io":
          return i.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 53;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return Ss(i5(o, i));
    }
  }]), n;
}(dt), c5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], l5 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], u5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "subPriority", 1), Ce(Te(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "d":
          return Lt(jt.date, o);
        case "do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      var i = o.getUTCFullYear(), a = z1(i), c = o.getUTCMonth();
      return a ? s >= 1 && s <= l5[c] : s >= 1 && s <= c5[c];
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCDate(i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), d5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "subpriority", 1), Ce(Te(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "D":
        case "DD":
          return Lt(jt.dayOfYear, o);
        case "Do":
          return i.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      var i = o.getUTCFullYear(), a = z1(i);
      return a ? s >= 1 && s <= 366 : s >= 1 && s <= 365;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMonth(0, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt);
function Zh(e, t, n) {
  var r, o, s, i, a, c, l, u;
  Pe(2, arguments);
  var d = xo(), f = kt((r = (o = (s = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (a = n.locale) === null || a === void 0 || (c = a.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && o !== void 0 ? o : (l = d.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Ae(e), p = kt(t), g = h.getUTCDay(), m = p % 7, y = (m + 7) % 7, v = (y < f ? 7 : 0) + p - g;
  return h.setUTCDate(h.getUTCDate() + v), h;
}
var f5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Zh(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), h5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i, a) {
      var c = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "e":
        case "ee":
          return Ut(Bt(s.length, o), c);
        case "eo":
          return Ut(i.ordinalNumber(o, {
            unit: "day"
          }), c);
        case "eee":
          return i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Zh(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), p5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i, a) {
      var c = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (s) {
        case "c":
        case "cc":
          return Ut(Bt(s.length, o), c);
        case "co":
          return Ut(i.ordinalNumber(o, {
            unit: "day"
          }), c);
        case "ccc":
          return i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(o, {
            width: "wide",
            context: "standalone"
          }) || i.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(o, {
            width: "short",
            context: "standalone"
          }) || i.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 6;
    }
  }, {
    key: "set",
    value: function(o, s, i, a) {
      return o = Zh(o, i, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt);
function g5(e, t) {
  Pe(2, arguments);
  var n = kt(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = Ae(e), s = o.getUTCDay(), i = n % 7, a = (i + 7) % 7, c = (a < r ? 7 : 0) + n - s;
  return o.setUTCDate(o.getUTCDate() + c), o;
}
var m5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 90), Ce(Te(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      var a = function(l) {
        return l === 0 ? 7 : l;
      };
      switch (s) {
        case "i":
        case "ii":
          return Bt(s.length, o);
        case "io":
          return i.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return Ut(i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return Ut(i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return Ut(i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return Ut(i.day(o, {
            width: "wide",
            context: "formatting"
          }) || i.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(o, {
            width: "short",
            context: "formatting"
          }) || i.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 7;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o = g5(o, i), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(dt), b5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 80), Ce(Te(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(Xh(i), 0, 0, 0), o;
    }
  }]), n;
}(dt), v5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 80), Ce(Te(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(Xh(i), 0, 0, 0), o;
    }
  }]), n;
}(dt), y5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 80), Ce(Te(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(Xh(i), 0, 0, 0), o;
    }
  }]), n;
}(dt), w5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 70), Ce(Te(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "h":
          return Lt(jt.hour12h, o);
        case "ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 12;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCHours() >= 12;
      return a && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : !a && i === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(dt), x5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 70), Ce(Te(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "H":
          return Lt(jt.hour23h, o);
        case "Ho":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 23;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(dt), C5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 70), Ce(Te(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "K":
          return Lt(jt.hour11h, o);
        case "Ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 11;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = o.getUTCHours() >= 12;
      return a && i < 12 ? o.setUTCHours(i + 12, 0, 0, 0) : o.setUTCHours(i, 0, 0, 0), o;
    }
  }]), n;
}(dt), E5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 70), Ce(Te(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "k":
          return Lt(jt.hour24h, o);
        case "ko":
          return i.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 1 && s <= 24;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      var a = i <= 24 ? i % 24 : i;
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(dt), _5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 60), Ce(Te(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "m":
          return Lt(jt.minute, o);
        case "mo":
          return i.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMinutes(i, 0, 0), o;
    }
  }]), n;
}(dt), S5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 50), Ce(Te(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s, i) {
      switch (s) {
        case "s":
          return Lt(jt.second, o);
        case "so":
          return i.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return Bt(s.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, s) {
      return s >= 0 && s <= 59;
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCSeconds(i, 0), o;
    }
  }]), n;
}(dt), O5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 30), Ce(Te(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s) {
      var i = function(c) {
        return Math.floor(c * Math.pow(10, -s.length + 3));
      };
      return Ut(Bt(s.length, o), i);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return o.setUTCMilliseconds(i), o;
    }
  }]), n;
}(dt), M5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 10), Ce(Te(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s) {
      switch (s) {
        case "X":
          return ar(ir.basicOptionalMinutes, o);
        case "XX":
          return ar(ir.basic, o);
        case "XXXX":
          return ar(ir.basicOptionalSeconds, o);
        case "XXXXX":
          return ar(ir.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return ar(ir.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(dt), T5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 10), Ce(Te(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o, s) {
      switch (s) {
        case "x":
          return ar(ir.basicOptionalMinutes, o);
        case "xx":
          return ar(ir.basic, o);
        case "xxxx":
          return ar(ir.basicOptionalSeconds, o);
        case "xxxxx":
          return ar(ir.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return ar(ir.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return s.timestampIsSet ? o : new Date(o.getTime() - i);
    }
  }]), n;
}(dt), k5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 40), Ce(Te(r), "incompatibleTokens", "*"), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o) {
      return H1(o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(dt), P5 = /* @__PURE__ */ function(e) {
  ct(n, e);
  var t = lt(n);
  function n() {
    var r;
    ot(this, n);
    for (var o = arguments.length, s = new Array(o), i = 0; i < o; i++)
      s[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(s)), Ce(Te(r), "priority", 20), Ce(Te(r), "incompatibleTokens", "*"), r;
  }
  return st(n, [{
    key: "parse",
    value: function(o) {
      return H1(o);
    }
  }, {
    key: "set",
    value: function(o, s, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(dt), R5 = {
  G: new qN(),
  y: new XN(),
  Y: new ZN(),
  R: new QN(),
  u: new JN(),
  Q: new e5(),
  q: new t5(),
  M: new n5(),
  L: new r5(),
  w: new s5(),
  I: new a5(),
  d: new u5(),
  D: new d5(),
  E: new f5(),
  e: new h5(),
  c: new p5(),
  i: new m5(),
  a: new b5(),
  b: new v5(),
  B: new y5(),
  h: new w5(),
  H: new x5(),
  K: new C5(),
  k: new E5(),
  m: new _5(),
  s: new S5(),
  S: new O5(),
  X: new M5(),
  x: new T5(),
  t: new k5(),
  T: new P5()
}, I5 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, D5 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, N5 = /^'([^]*?)'?$/, A5 = /''/g, $5 = /\S/, F5 = /[a-zA-Z]/;
function us(e, t, n, r) {
  var o, s, i, a, c, l, u, d, f, h, p, g, m, y, v, w, C, x;
  Pe(3, arguments);
  var E = String(e), S = String(t), M = xo(), T = (o = (s = r == null ? void 0 : r.locale) !== null && s !== void 0 ? s : M.locale) !== null && o !== void 0 ? o : V1;
  if (!T.match)
    throw new RangeError("locale must contain match property");
  var P = kt((i = (a = (c = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && c !== void 0 ? c : M.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = M.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(P >= 1 && P <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var k = kt((p = (g = (m = (y = r == null ? void 0 : r.weekStartsOn) !== null && y !== void 0 ? y : r == null || (v = r.locale) === null || v === void 0 || (w = v.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && m !== void 0 ? m : M.weekStartsOn) !== null && g !== void 0 ? g : (C = M.locale) === null || C === void 0 || (x = C.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(k >= 0 && k <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (S === "")
    return E === "" ? Ae(n) : /* @__PURE__ */ new Date(NaN);
  var I = {
    firstWeekContainsDate: P,
    weekStartsOn: k,
    locale: T
  }, O = [new KN()], A = S.match(D5).map(function(W) {
    var X = W[0];
    if (X in sf) {
      var J = sf[X];
      return J(W, T.formatLong);
    }
    return W;
  }).join("").match(I5), R = [], N = Tb(A), $;
  try {
    var F = function() {
      var X = $.value;
      !(r != null && r.useAdditionalWeekYearTokens) && L1(X) && Jc(X, S, e), !(r != null && r.useAdditionalDayOfYearTokens) && F1(X) && Jc(X, S, e);
      var J = X[0], Q = R5[J];
      if (Q) {
        var Y = Q.incompatibleTokens;
        if (Array.isArray(Y)) {
          var ce = R.find(function(ne) {
            return Y.includes(ne.token) || ne.token === J;
          });
          if (ce)
            throw new RangeError("The format string mustn't contain `".concat(ce.fullToken, "` and `").concat(X, "` at the same time"));
        } else if (Q.incompatibleTokens === "*" && R.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(X, "` and any other token at the same time"));
        R.push({
          token: J,
          fullToken: X
        });
        var ee = Q.run(E, X, T.match, I);
        if (!ee)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        O.push(ee.setter), E = ee.rest;
      } else {
        if (J.match(F5))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + J + "`");
        if (X === "''" ? X = "'" : J === "'" && (X = L5(X)), E.indexOf(X) === 0)
          E = E.slice(X.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (N.s(); !($ = N.n()).done; ) {
      var V = F();
      if (Yr(V) === "object")
        return V.v;
    }
  } catch (W) {
    N.e(W);
  } finally {
    N.f();
  }
  if (E.length > 0 && $5.test(E))
    return /* @__PURE__ */ new Date(NaN);
  var D = O.map(function(W) {
    return W.priority;
  }).sort(function(W, X) {
    return X - W;
  }).filter(function(W, X, J) {
    return J.indexOf(W) === X;
  }).map(function(W) {
    return O.filter(function(X) {
      return X.priority === W;
    }).sort(function(X, J) {
      return J.subPriority - X.subPriority;
    });
  }).map(function(W) {
    return W[0];
  }), H = Ae(n);
  if (isNaN(H.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var j = I1(H, Qc(H)), U = {}, K = Tb(D), G;
  try {
    for (K.s(); !(G = K.n()).done; ) {
      var B = G.value;
      if (!B.validate(j, I))
        return /* @__PURE__ */ new Date(NaN);
      var z = B.set(j, U, I);
      Array.isArray(z) ? (j = z[0], VN(U, z[1])) : j = z;
    }
  } catch (W) {
    K.e(W);
  } finally {
    K.f();
  }
  return j;
}
function L5(e) {
  return e.match(N5)[1].replace(A5, "'");
}
function V5(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setMinutes(0, 0, 0), t;
}
function W5(e) {
  Pe(1, arguments);
  var t = Ae(e);
  return t.setMilliseconds(0), t;
}
function B5(e, t) {
  var n;
  Pe(1, arguments);
  var r = kt((n = t == null ? void 0 : t.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = j5(e), s;
  if (o.date) {
    var i = U5(o.date, r);
    s = G5(i.restDateString, i.year);
  }
  if (!s || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = s.getTime(), c = 0, l;
  if (o.time && (c = K5(o.time), isNaN(c)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (l = q5(o.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + c), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + c + l);
}
var Ka = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, H5 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Y5 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, z5 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function j5(e) {
  var t = {}, n = e.split(Ka.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Ka.timeZoneDelimiter.test(t.date) && (t.date = e.split(Ka.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var o = Ka.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function U5(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var o = r[1] ? parseInt(r[1]) : null, s = r[2] ? parseInt(r[2]) : null;
  return {
    year: s === null ? o : s * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function G5(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(H5);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = ti(n[1]), s = ti(n[2]) - 1, i = ti(n[3]), a = ti(n[4]), c = ti(n[5]) - 1;
  if (r)
    return e6(t, a, c) ? X5(t, a, c) : /* @__PURE__ */ new Date(NaN);
  var l = /* @__PURE__ */ new Date(0);
  return !Q5(t, s, i) || !J5(t, o) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(t, s, Math.max(o, i)), l);
}
function ti(e) {
  return e ? parseInt(e) : 1;
}
function K5(e) {
  var t = e.match(Y5);
  if (!t)
    return NaN;
  var n = Ju(t[1]), r = Ju(t[2]), o = Ju(t[3]);
  return t6(n, r, o) ? n * su + r * ou + o * 1e3 : NaN;
}
function Ju(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function q5(e) {
  if (e === "Z")
    return 0;
  var t = e.match(z5);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return n6(r, o) ? n * (r * su + o * ou) : NaN;
}
function X5(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var o = r.getUTCDay() || 7, s = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + s), r;
}
var Z5 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function j1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Q5(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Z5[t] || (j1(e) ? 29 : 28));
}
function J5(e, t) {
  return t >= 1 && t <= (j1(e) ? 366 : 365);
}
function e6(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function t6(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function n6(e, t) {
  return t >= 0 && t <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const r6 = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
f1._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return r6;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = Ae(e) : n === "string" && (typeof t == "string" ? e = us(e, t, /* @__PURE__ */ new Date(), this.options) : e = B5(e, this.options)), Kh(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return Lr(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return sa(e, t);
      case "second":
        return fD(e, t);
      case "minute":
        return uD(e, t);
      case "hour":
        return iD(e, t);
      case "day":
        return M1(e, t);
      case "week":
        return hD(e, t);
      case "month":
        return Gh(e, t);
      case "quarter":
        return dD(e, t);
      case "year":
        return pD(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return iu(e, t);
      case "second":
        return _D(e, t);
      case "minute":
        return xD(e, t);
      case "hour":
        return wD(e, t);
      case "day":
        return T1(e, t);
      case "week":
        return SD(e, t);
      case "month":
        return R1(e, t);
      case "quarter":
        return ED(e, t);
      case "year":
        return OD(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return W5(e);
      case "minute":
        return MD(e);
      case "hour":
        return V5(e);
      case "day":
        return rf(e);
      case "week":
        return xb(e);
      case "isoWeek":
        return xb(e, { weekStartsOn: +n });
      case "month":
        return yc(e);
      case "quarter":
        return TD(e);
      case "year":
        return PD(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return AD(e);
      case "minute":
        return DD(e);
      case "hour":
        return RD(e);
      case "day":
        return k1(e);
      case "week":
        return ID(e);
      case "month":
        return P1(e);
      case "quarter":
        return ND(e);
      case "year":
        return kD(e);
      default:
        return e;
    }
  }
});
function Nr(e, t) {
  const { format: n = "rgba" } = t || {}, r = `rgba(${getComputedStyle(
    document.documentElement
  ).getPropertyValue(e)})`;
  return n === "hex" ? o6(r) : r;
}
const o6 = (e) => {
  const t = e.replace(/^rgba?\(|\s+|\)$/g, "").split(","), n = parseInt(t[0], 10), r = parseInt(t[1], 10), o = parseInt(t[2], 10), s = Math.round(parseFloat(t[3]) * 255), i = (a) => a.toString(16).padStart(2, "0");
  return `#${i(n)}${i(r)}${i(o)}${Number.isNaN(s) ? "" : i(s)}`;
}, U1 = () => /* @__PURE__ */ Z("div", { className: "relative flex h-52 w-full flex-1 flex-col justify-between", children: [
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ _("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ Z("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2.5", children: [
    /* @__PURE__ */ _(G1, {}),
    /* @__PURE__ */ _("p", { className: "text-xs font-medium text-foundations-boldest", children: "No data in this period" })
  ] })
] }), G1 = ({ className: e }) => /* @__PURE__ */ Z(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "84",
    viewBox: "0 0 112 84",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M56.7368 84C79.9328 84 98.7368 65.196 98.7368 42C98.7368 18.804 79.9328 0 56.7368 0C33.5409 0 14.7368 18.804 14.7368 42C14.7368 65.196 33.5409 84 56.7368 84Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _("g", { filter: "url(#filter0_d_18659_25530)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M8.19249 29.5547H103.392C104.328 29.5547 105.224 29.9262 105.886 30.5874C106.547 31.2486 106.918 32.1455 106.918 33.0806V50.7102C106.918 51.6454 106.547 52.5422 105.886 53.2034C105.224 53.8647 104.328 54.2362 103.392 54.2362H8.19249C7.25736 54.2362 6.36052 53.8647 5.69928 53.2034C5.03805 52.5422 4.66656 51.6454 4.66656 50.7102V33.0806C4.66656 32.1455 5.03805 31.2486 5.69928 30.5874C6.36052 29.9262 7.25736 29.5547 8.19249 29.5547V29.5547Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M53.324 35.1953H34.9892C33.8208 35.1953 32.8736 36.1425 32.8736 37.3109C32.8736 38.4793 33.8208 39.4264 34.9892 39.4264H53.324C54.4924 39.4264 55.4395 38.4793 55.4395 37.3109C55.4395 36.1425 54.4924 35.1953 53.324 35.1953Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M66.0171 44.3633H34.989C33.8206 44.3633 32.8734 45.3104 32.8734 46.4788C32.8734 47.6472 33.8206 48.5944 34.989 48.5944H66.0171C67.1855 48.5944 68.1327 47.6472 68.1327 46.4788C68.1327 45.3104 67.1855 44.3633 66.0171 44.3633Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M27.2341 41.8951C27.2341 36.2479 22.6562 31.6699 17.0089 31.6699C11.3617 31.6699 6.78375 36.2479 6.78375 41.8951C6.78375 47.5423 11.3617 52.1203 17.0089 52.1203C22.6562 52.1203 27.2341 47.5423 27.2341 41.8951Z",
          className: "fill-[theme(backgroundColor.chart-neutral)]"
        }
      ),
      /* @__PURE__ */ Z("g", { clipPath: "url(#clip0_18659_25530)", children: [
        /* @__PURE__ */ _(
          "path",
          {
            d: "M12.1339 42.6223C12.1339 42.2787 12.4124 42.0001 12.7561 42.0001H14.0005C14.3442 42.0001 14.6227 42.2787 14.6227 42.6223V45.7334C14.6227 46.0771 14.3442 46.3556 14.0005 46.3556H12.7561C12.4124 46.3556 12.1339 46.0771 12.1339 45.7334V42.6223Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M15.8672 40.1334C15.8672 39.7898 16.1458 39.5112 16.4894 39.5112H17.7338C18.0775 39.5112 18.3561 39.7898 18.3561 40.1334V45.7334C18.3561 46.0771 18.0775 46.3556 17.7338 46.3556H16.4894C16.1458 46.3556 15.8672 46.0771 15.8672 45.7334V40.1334Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            d: "M19.6005 38.2668C19.6005 37.9231 19.8791 37.6445 20.2227 37.6445H21.4672C21.8108 37.6445 22.0894 37.9231 22.0894 38.2668V45.7334C22.0894 46.0771 21.8108 46.3556 21.4672 46.3556H20.2227C19.8791 46.3556 19.6005 46.0771 19.6005 45.7334V38.2668Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("defs", { children: [
        /* @__PURE__ */ Z(
          "filter",
          {
            id: "filter0_d_18659_25530",
            x: "0.435454",
            y: "27.4391",
            width: "110.714",
            height: "33.1439",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ _("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ _("feOffset", { dy: "2.11556" }),
              /* @__PURE__ */ _("feGaussianBlur", { stdDeviation: "2.11556" }),
              /* @__PURE__ */ _(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_18659_25530"
                }
              ),
              /* @__PURE__ */ _(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_18659_25530",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ _("clipPath", { id: "clip0_18659_25530", children: /* @__PURE__ */ _(
          "rect",
          {
            width: "12.4444",
            height: "12.4444",
            className: "fill-[theme(backgroundColor.foundations-default)]",
            transform: "translate(10.8894 35.7773)"
          }
        ) })
      ] })
    ]
  }
), K1 = b.createContext(null);
function aa() {
  const e = b.useContext(K1);
  if (!e)
    throw new Error(
      "Chart compound components must be used within a <Chart> component"
    );
  return e;
}
const s6 = ({
  children: e,
  type: t,
  labels: n,
  datasets: r
}) => {
  const [o, s] = b.useState(null), i = b.useRef(null), a = n.length > 50, c = b.useMemo(
    () => ({
      chart: o,
      setChart: s,
      type: t,
      labels: n,
      datasets: r,
      tooltipRef: i,
      isLargeDataSet: a
    }),
    [o, t, n, r, a]
  );
  return /* @__PURE__ */ _(K1.Provider, { value: c, children: e });
}, q1 = "label";
function Pb(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function i6(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function X1(e, t) {
  e.labels = t;
}
function Z1(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : q1;
  const r = [];
  e.datasets = t.map((o) => {
    const s = e.datasets.find((i) => i[n] === o[n]);
    return !s || !o.data || r.includes(s) ? {
      ...o
    } : (r.push(s), Object.assign(s, o), s);
  });
}
function a6(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : q1;
  const n = {
    labels: [],
    datasets: []
  };
  return X1(n, e.labels), Z1(n, e.datasets, t), n;
}
function c6(e, t) {
  const { height: n = 150, width: r = 300, redraw: o = !1, datasetIdKey: s, type: i, data: a, options: c, plugins: l = [], fallbackContent: u, updateMode: d, ...f } = e, h = Ue(null), p = Ue(), g = () => {
    h.current && (p.current = new Uh(h.current, {
      type: i,
      data: a6(a, s),
      options: c && {
        ...c
      },
      plugins: l
    }), Pb(t, p.current));
  }, m = () => {
    Pb(t, null), p.current && (p.current.destroy(), p.current = null);
  };
  return Ke(() => {
    !o && p.current && c && i6(p.current, c);
  }, [
    o,
    c
  ]), Ke(() => {
    !o && p.current && X1(p.current.config.data, a.labels);
  }, [
    o,
    a.labels
  ]), Ke(() => {
    !o && p.current && a.datasets && Z1(p.current.config.data, a.datasets, s);
  }, [
    o,
    a.datasets
  ]), Ke(() => {
    p.current && (o ? (m(), setTimeout(g)) : p.current.update(d));
  }, [
    o,
    c,
    a.labels,
    a.datasets,
    d
  ]), Ke(() => {
    p.current && (m(), setTimeout(g));
  }, [
    i
  ]), Ke(() => (g(), () => m()), []), /* @__PURE__ */ ie.createElement("canvas", Object.assign({
    ref: h,
    role: "img",
    height: n,
    width: r
  }, f), u);
}
const l6 = /* @__PURE__ */ At(c6), u6 = (e) => {
  let t = null;
  return {
    id: "hover-label",
    afterEvent(r, { inChartArea: o, event: s }) {
      var a, c;
      if (!o) {
        t = null;
        return;
      }
      const [i] = r.getElementsAtEventForMode(
        //@ts-expect-error
        s,
        "nearest",
        { intersect: !1, axis: (c = (a = r.config.options) == null ? void 0 : a.interaction) == null ? void 0 : c.axis },
        !0
      );
      t = (i == null ? void 0 : i.index) ?? null;
    },
    afterDatasetDraw(r) {
      var w;
      const o = r.config.type;
      if (o === "doughnut" || o === "pie")
        return;
      const {
        ctx: s,
        chartArea: { top: i, bottom: a },
        scales: { x: c }
      } = r;
      if (s.save(), t == null)
        return;
      const l = (w = r.data.labels) == null ? void 0 : w[t], d = r.getDatasetMeta(0).data[t], f = d ? d.x : c.getPixelForValue(new Date(l).getTime()), h = 1;
      s.beginPath(), s.setLineDash([3, 3]), s.strokeStyle = Nr("--border-foundations-bolder"), s.lineWidth = h;
      const p = f - h / 2;
      s.moveTo(p, i), s.lineTo(p, a), s.stroke();
      const g = 8, m = new Date(l).getTime(), y = Lr(m, e), v = s.measureText(`${y}`).width + g;
      s.fillStyle = Nr(
        "--background-foundations-subtlest"
      ), s.roundRect(f - v / 2, a + 12, v, 20, 4), s.fill(), s.font = "500 12px 'DM Sans', Arial", s.fillStyle = Nr("--text-foundations-boldest"), s.fillText(
        y,
        f - v / 2 + g / 2,
        a + 12 + 20 / 2 + 5
      ), s.restore();
    }
  };
}, d6 = {
  id: "fully-rendered",
  afterRender: function(e) {
    e.$rendered || (e.$rendered = !0);
  }
}, f6 = (e, t) => ({
  id: "center-text",
  afterDatasetDraw(n) {
    const { ctx: r, chartArea: o } = n, s = (o.left + o.right) / 2, i = (o.top + o.bottom) / 2;
    r.save(), r.textAlign = "center", r.textBaseline = "middle", r.font = `${(t == null ? void 0 : t.fontWeight) || "700"} ${(t == null ? void 0 : t.fontSize) || "32px"} 'DM Sans', Arial`, r.fillStyle = (t == null ? void 0 : t.color) || Nr("--text-foundations-boldest"), r.fillText(e, s, i), r.restore();
  }
}), Q1 = ({
  horizontal: e = !1,
  extraScales: t,
  scaleXWeekFormat: n = !1,
  disableAnimation: r = !1,
  maxYValue: o,
  formatXLabel: s,
  formatYLabel: i,
  crossHairTooltipFormat: a = "MMM d, yyy",
  className: c,
  centerText: l
} = {}) => {
  const { setChart: u, type: d, labels: f, datasets: h, tooltipRef: p } = aa();
  return /* @__PURE__ */ _("div", { className: le("h-full", c), children: /* @__PURE__ */ _(
    l6,
    {
      ref: u,
      width: "100%",
      type: d,
      data: {
        labels: f,
        datasets: h
      },
      options: {
        layout: d === "doughnut" || d === "pie" ? {
          padding: 0
        } : {
          padding: {
            right: 40
          }
        },
        animation: r ? !1 : d === "doughnut" || d === "pie" ? {
          animateRotate: !0,
          animateScale: !1
        } : !0,
        transitions: {
          active: {
            animation: {
              duration: 0
            }
          }
        },
        responsive: !0,
        maintainAspectRatio: !1,
        indexAxis: e ? "y" : "x",
        interaction: d === "doughnut" || d === "pie" ? {
          intersect: !0,
          mode: "point"
        } : {
          intersect: !1,
          axis: "x",
          mode: "nearest"
        },
        elements: {
          point: {
            radius: f.length === 1 ? 4 : 0,
            hitRadius: 4,
            pointStyle: "circle"
          },
          line: {
            borderWidth: 2,
            tension: 0.02
          }
        },
        cutout: "70%",
        plugins: {
          tooltip: d === "doughnut" || d === "pie" ? {
            mode: "point",
            intersect: !0,
            enabled: !1,
            external: (g) => {
              var w, C;
              if (!g.chart.$rendered)
                return;
              const m = g.tooltip;
              if (m.opacity === 0) {
                (w = p.current) == null || w.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const y = g.chart.canvas.getBoundingClientRect(), v = {
                opacity: 1,
                left: y.left + m.caretX + window.scrollX,
                top: y.top + m.caretY + window.scrollY,
                xAlign: m.xAlign,
                dataPoints: m.dataPoints.map(
                  (x) => {
                    var E;
                    return {
                      label: x.label,
                      dataset: x.dataset,
                      raw: x.raw,
                      rawLabel: (E = x.chart.data.labels) == null ? void 0 : E[x.dataIndex],
                      dataIndex: x.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(v);
            }
          } : {
            mode: "nearest",
            intersect: !1,
            enabled: !1,
            external: (g) => {
              var w, C;
              if (!g.chart.$rendered)
                return;
              const m = g.tooltip;
              if (m.opacity === 0) {
                (w = p.current) == null || w.updateTooltip({
                  opacity: 0,
                  top: void 0,
                  left: void 0,
                  xAlign: void 0
                });
                return;
              }
              const y = g.chart.canvas.getBoundingClientRect(), v = {
                opacity: 1,
                left: y.left + m.caretX + window.scrollX,
                top: y.top + m.caretY + window.scrollY,
                xAlign: m.xAlign,
                dataPoints: m.dataPoints.map(
                  (x) => {
                    var E;
                    return {
                      label: x.label,
                      dataset: x.dataset,
                      raw: x.raw,
                      rawLabel: (E = x.chart.data.labels) == null ? void 0 : E[x.dataIndex],
                      dataIndex: x.dataIndex
                    };
                  }
                )
              };
              (C = p.current) == null || C.updateTooltip(v);
            }
          }
        },
        ...d !== "doughnut" && d !== "pie" ? {
          scales: {
            y: {
              beginAtZero: !0,
              grace: "5%",
              grid: {
                display: !1
              },
              ticks: {
                padding: 8,
                color: Nr(
                  "--text-foundations-bold"
                ),
                count: 2,
                callback: i
              },
              border: {
                display: !1
              },
              max: o
            },
            x: {
              offset: !0,
              type: "time",
              time: {
                unit: "day",
                displayFormats: {
                  day: n ? "E" : "MMM d"
                },
                tooltipFormat: "MMM d, yyy"
              },
              grid: {
                color: "transparent",
                tickColor: Nr(
                  "--border-foundations-bold"
                ),
                offset: !1
              },
              ticks: {
                padding: 8,
                color: Nr(
                  "--text-foundations-bold"
                ),
                align: "center",
                autoSkip: !1,
                maxRotation: 0,
                minRotation: 0,
                source: "labels",
                callback(g, m) {
                  return m === 0 || m === f.length - 1 ? s ? s(g, m) : Lr(g, "MMM d, yyy") : void 0;
                }
              },
              border: {
                color: Nr(
                  "--border-foundations-bold"
                )
              }
            },
            ...t
          }
        } : {}
      },
      plugins: [
        b.useMemo(
          () => u6(a || "MMM d, yyy"),
          [a]
        ),
        d6,
        ...l && (d === "doughnut" || d === "pie") ? [
          b.useMemo(
            () => f6(l.text, {
              fontSize: l.fontSize,
              fontWeight: l.fontWeight,
              color: l.color
            }),
            [
              l.text,
              l.fontSize,
              l.fontWeight,
              l.color
            ]
          )
        ] : []
      ]
    }
  ) });
};
Q1.displayName = "Chart.Canvas";
function J1() {
  const [e, t] = b.useReducer((n) => !n, !1);
  return t;
}
const h6 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
}) => {
  const { chart: o, datasets: s } = aa(), [i, a] = b.useState(null), [c, l] = b.useState(/* @__PURE__ */ new Set()), u = J1();
  if (!o)
    return null;
  const d = b.useCallback(
    (f) => {
      c.has(f) ? (l((p) => {
        const g = new Set(p);
        return g.delete(f), g;
      }), o.setDatasetVisibility(f, !0)) : (l((p) => new Set(p).add(f)), o.setDatasetVisibility(f, !1)), o.update(), u();
    },
    [o, c, u, l]
  );
  return /* @__PURE__ */ _(
    "div",
    {
      className: le(
        "flex flex-wrap justify-center gap-2",
        e === "column" && "flex-col items-start",
        t
      ),
      children: s.map((f, h) => {
        var p;
        return /* @__PURE__ */ _(
          "button",
          {
            className: le(
              "flex items-center space-x-1 p-1 transition-opacity duration-300",
              i !== null && i !== h && "opacity-20",
              c.has(h) && "line-through opacity-50"
            ),
            onClick: () => d(h),
            onMouseEnter: () => {
              c.has(h) || (a(h), o.config.data.datasets.forEach((g, m) => {
                var y, v, w, C;
                if (!c.has(m)) {
                  if (h === m) {
                    o.config.data.datasets[h].backgroundColor = g.backgroundColor, o.config.data.datasets[h].borderColor = g.borderColor;
                    return;
                  }
                  g.backgroundColor = (v = (y = g.backgroundColor) == null ? void 0 : y.replace) == null ? void 0 : v.call(y, ")", ", 0.3)"), g.borderColor = (C = (w = g.borderColor) == null ? void 0 : w.replace) == null ? void 0 : C.call(
                    w,
                    ")",
                    ", 0.3)"
                  );
                }
              }), o.update(), u());
            },
            onMouseLeave: () => {
              a(null), o.config.data.datasets.forEach((g, m) => {
                c.has(m) || (g.backgroundColor = g.backgroundColor = s[m].backgroundColor, g.borderColor = g.borderColor = s[m].borderColor);
              }), o.update(), u();
            },
            children: /* @__PURE__ */ Z("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: le(
                      "h-2 w-2 shrink-0 rounded-full bg-foundations-subtle transition-opacity duration-300",
                      c.has(h) && "opacity-30"
                    ),
                    style: {
                      backgroundColor: ((p = f.backgroundColor) == null ? void 0 : p.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(f.label || "", h) : f.label })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(f.label || "", h) })
            ] })
          },
          f.label
        );
      })
    }
  );
}, p6 = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
}) => {
  const { chart: o, labels: s, datasets: i } = aa(), [a, c] = b.useState(null), [l, u] = b.useState(/* @__PURE__ */ new Set()), d = J1();
  if (!o)
    return null;
  const f = b.useCallback(
    (p) => {
      l.has(p) ? (u((m) => {
        const y = new Set(m);
        return y.delete(p), y;
      }), o.toggleDataVisibility(p)) : (u((m) => new Set(m).add(p)), o.toggleDataVisibility(p)), o.update(), d();
    },
    [o, l, d, u]
  ), h = (p) => {
    const m = i[0].backgroundColor;
    return Array.isArray(m) ? m[p] : m;
  };
  return /* @__PURE__ */ _(
    "div",
    {
      className: le(
        "flex flex-wrap justify-center gap-2 pb-4",
        e === "column" && "flex-col items-start",
        t
      ),
      children: s.map((p, g) => {
        const m = l.has(g), y = h(g);
        return /* @__PURE__ */ _(
          "button",
          {
            className: le(
              "flex p-1 transition-opacity duration-300",
              a !== null && a !== g && "opacity-20",
              m && "line-through opacity-50"
            ),
            onClick: () => f(g),
            onMouseEnter: () => {
              if (m)
                return;
              c(g);
              const v = o.config.data.datasets[0], w = v.backgroundColor, C = v.borderColor;
              Array.isArray(w) && (v.backgroundColor = w.map(
                (x, E) => E === g || l.has(E) ? x : x.replace(")", ", 0.3)")
              )), Array.isArray(C) && (v.borderColor = C.map(
                (x, E) => E === g || l.has(E) ? x : x.replace(")", ", 0.3)")
              )), o.update(), d();
            },
            onMouseLeave: () => {
              c(null);
              const v = o.config.data.datasets[0];
              v.backgroundColor = i[0].backgroundColor, v.borderColor = i[0].borderColor, o.update(), d();
            },
            children: /* @__PURE__ */ Z("div", { className: "flex flex-1 flex-col items-start gap-0.5", children: [
              /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: le(
                      "h-2 w-2 shrink-0 rounded-full transition-opacity duration-300",
                      m && "opacity-30"
                    ),
                    style: {
                      backgroundColor: (y == null ? void 0 : y.toString()) || void 0
                    }
                  }
                ),
                /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bolder", children: n ? n(p, g) : p })
              ] }),
              r && /* @__PURE__ */ _("span", { className: "text-xs font-medium text-foundations-bold", children: r(p, g) })
            ] })
          },
          `${p}-${g}`
        );
      })
    }
  );
}, ew = ({
  variant: e = "row",
  className: t,
  labelFormatter: n,
  descriptionFormatter: r
} = {}) => {
  const { type: o, chart: s, datasets: i } = aa();
  return s ? o === "doughnut" || o === "pie" ? /* @__PURE__ */ _(
    p6,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r
    }
  ) : i.length <= 1 ? null : /* @__PURE__ */ _(
    h6,
    {
      variant: e,
      className: t,
      labelFormatter: n,
      descriptionFormatter: r
    }
  ) : null;
};
ew.displayName = "Chart.Legend";
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, et.apply(this, arguments);
}
function g6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function tw(...e) {
  return (t) => e.forEach(
    (n) => g6(n, t)
  );
}
function vr(...e) {
  return je(tw(...e), e);
}
const Os = /* @__PURE__ */ At((e, t) => {
  const { children: n, ...r } = e, o = fs.toArray(n), s = o.find(b6);
  if (s) {
    const i = s.props.children, a = o.map((c) => c === s ? fs.count(i) > 1 ? fs.only(null) : /* @__PURE__ */ Sc(i) ? i.props.children : null : c);
    return /* @__PURE__ */ Le(cf, et({}, r, {
      ref: t
    }), /* @__PURE__ */ Sc(i) ? /* @__PURE__ */ ml(i, void 0, a) : null);
  }
  return /* @__PURE__ */ Le(cf, et({}, r, {
    ref: t
  }), n);
});
Os.displayName = "Slot";
const cf = /* @__PURE__ */ At((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Sc(n) ? /* @__PURE__ */ ml(n, {
    ...v6(r, n.props),
    ref: t ? tw(t, n.ref) : n.ref
  }) : fs.count(n) > 1 ? fs.only(null) : null;
});
cf.displayName = "SlotClone";
const m6 = ({ children: e }) => /* @__PURE__ */ Le(q_, null, e);
function b6(e) {
  return /* @__PURE__ */ Sc(e) && e.type === m6;
}
function v6(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      s(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...s
    } : r === "className" && (n[r] = [
      o,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const y6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Nn = y6.reduce((e, t) => {
  const n = /* @__PURE__ */ At((r, o) => {
    const { asChild: s, ...i } = r, a = s ? Os : t;
    return Ke(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ Le(a, et({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function w6(e, t) {
  e && Sf(
    () => e.dispatchEvent(t)
  );
}
const nw = /* @__PURE__ */ At((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ Z_.createPortal(/* @__PURE__ */ Le(Nn.div, et({}, o, {
    ref: t
  })), r) : null;
}), x6 = nw, rw = ({ children: e }) => /* @__PURE__ */ _(x6, { asChild: !0, children: e });
function lf(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(
    () => (...n) => {
      var r;
      return (r = t.current) == null ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const ow = b.memo(
  b.forwardRef(
    ({
      isLargeDataSet: e,
      tooltipLabelFormatter: t,
      tooltipValueFormatter: n,
      showLabel: r,
      tooltipVariant: o
    }, s) => {
      const [i, a] = b.useState({
        opacity: 0,
        top: 0,
        left: 0,
        xAlign: ""
      });
      b.useImperativeHandle(s, () => ({
        updateTooltip: (h) => {
          i.opacity === h.opacity && i.left === h.left && i.top === h.top || a((p) => ({
            opacity: h.opacity,
            top: h.top ?? p.top,
            left: h.left ?? p.left,
            xAlign: h.xAlign ?? p.xAlign,
            dataPoints: h.dataPoints ?? p.dataPoints
          }));
        }
      }));
      const { top: c, left: l, opacity: u, xAlign: d, dataPoints: f } = i;
      return /* @__PURE__ */ _(
        "div",
        {
          className: le(
            "pointer-events-none fixed z-50 -translate-y-[calc(100%-8px)] space-y-2 rounded-lg border border-foundations-subtle bg-foundations-default shadow-3 transition-all",
            d === "left" ? "translate-x-[calc(8px+6px)]" : "-translate-x-[calc(100%+8px+6px)]",
            o === "line" ? "px-3 py-2" : "p-4",
            e ? "duration-100" : "duration-200"
          ),
          style: {
            top: c,
            left: l,
            opacity: u
          },
          children: f == null ? void 0 : f.map((h) => {
            const p = h.dataset.backgroundColor, g = Array.isArray(p) ? p[h.dataIndex] : p;
            return /* @__PURE__ */ Z(
              "div",
              {
                className: le(
                  "flex gap-2 whitespace-nowrap",
                  o === "line" ? "items-stretch" : "items-center"
                ),
                children: [
                  /* @__PURE__ */ _(
                    "div",
                    {
                      className: le(
                        "rounded-full",
                        o === "line" ? "w-[3px]" : "size-2"
                      ),
                      style: {
                        backgroundColor: g
                      }
                    }
                  ),
                  /* @__PURE__ */ Z(
                    "div",
                    {
                      className: le(
                        "flex text-xs font-medium text-foundations-boldest",
                        o === "line" ? "flex-col gap-1" : "flex-row gap-4"
                      ),
                      children: [
                        r && /* @__PURE__ */ _("p", { children: h.dataset.label }),
                        /* @__PURE__ */ _(
                          "p",
                          {
                            className: le(
                              "text-[11px] uppercase",
                              o === "line" ? " text-[11px] text-foundations-subtle" : "text-current"
                            ),
                            children: t ? t(h.rawLabel, h.dataIndex) : h.label
                          }
                        ),
                        /* @__PURE__ */ _(
                          "p",
                          {
                            className: le(
                              o === "line" ? "text-current" : "text-foundations-subtle"
                            ),
                            children: n ? n(h.raw, h.dataIndex) : String(h.raw)
                          }
                        )
                      ]
                    }
                  )
                ]
              },
              h.dataset.label ?? h.label
            );
          })
        }
      );
    }
  )
);
ow.displayName = "TooltipInternal";
const sw = ({
  labelFormatter: e,
  valueFormatter: t,
  variant: n = "line"
} = {}) => {
  const { tooltipRef: r, isLargeDataSet: o, datasets: s } = aa();
  return /* @__PURE__ */ _(rw, { children: /* @__PURE__ */ _(
    ow,
    {
      ref: r,
      tooltipVariant: n,
      tooltipLabelFormatter: e && lf(e),
      tooltipValueFormatter: t && lf(t),
      isLargeDataSet: o,
      showLabel: s.length > 1
    }
  ) });
};
sw.displayName = "Chart.Tooltip";
Uh.register(
  ef,
  tf,
  ji,
  vc,
  gi,
  bc,
  pc,
  hc,
  pi,
  fi,
  $I
);
const iw = ({
  type: e,
  labels: t,
  datasets: n,
  children: r,
  className: o
}) => t.length === 0 ? /* @__PURE__ */ _(U1, {}) : /* @__PURE__ */ _(s6, { type: e, labels: t, datasets: n, children: /* @__PURE__ */ _("div", { className: le("relative flex flex-col", o), children: r }) });
iw.displayName = "Chart";
const mW = Object.assign(iw, {
  Canvas: Q1,
  Legend: ew,
  Tooltip: sw
});
function bW(e) {
  return {
    grace: "5%",
    grid: {
      drawOnChartArea: !1,
      drawTicks: !1
    },
    ticks: {
      padding: 8,
      color: Nr("--text-foundations-subtle")
    },
    border: {
      display: !1
    },
    ...e
  };
}
const C6 = (e) => /* @__PURE__ */ b.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowShortUp/solid"
}, e), /* @__PURE__ */ b.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.293 9.707a1 1 0 0 1 0-1.414l4.005-4a1.002 1.002 0 0 1 1.416 0l4.005 4a1 1 0 0 1-1.416 1.414l-2.296-2.293V15a1 1 0 0 1-1.001 1 1.002 1.002 0 0 1-1.001-1V7.414L6.709 9.707a1.002 1.002 0 0 1-1.416 0Z",
  clipRule: "evenodd"
})), Qh = (e) => Number(e.toFixed(2)), E6 = En(
  "transition-all duration-1000 stroke-neutral-300",
  {
    variants: {
      variant: {
        success: "stroke-[theme(backgroundColor.chart-categorical-2-subtle)]",
        danger: "stroke-[theme(backgroundColor.chart-categorical-3-subtle)]",
        primary: "stroke-[theme(backgroundColor.info-bold)]"
      }
    }
  }
), aw = b.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    strokeLinecap: s = "round"
  }, i) => {
    const c = n / 2 - r, l = 2 * Math.PI * c, u = l * ((100 - (t || 0)) / 100);
    return /* @__PURE__ */ Z("svg", { ref: i, width: n, height: n, children: [
      /* @__PURE__ */ _(
        "circle",
        {
          className: le("stroke-neutral-100", o),
          fill: "none",
          strokeWidth: r,
          r: c,
          cx: n / 2,
          cy: n / 2
        }
      ),
      /* @__PURE__ */ _(
        "circle",
        {
          className: le(
            "stroke-[theme(backgroundColor.chart-neutral)]",
            E6({ variant: e })
          ),
          fill: "none",
          strokeWidth: r,
          r: c,
          cx: n / 2,
          cy: n / 2,
          strokeDasharray: l,
          strokeDashoffset: u,
          strokeLinecap: s,
          transform: "rotate(-90)",
          "transform-origin": "center"
        }
      )
    ] });
  }
), _6 = b.forwardRef(
  ({
    variant: e,
    value: t,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    className: s,
    children: i
  }, a) => /* @__PURE__ */ Z("div", { ref: a, className: le("relative inline-flex", s), children: [
    /* @__PURE__ */ _(
      aw,
      {
        value: t,
        variant: e,
        size: n,
        strokeWidth: r,
        strokeClassName: o
      }
    ),
    /* @__PURE__ */ _("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-1.5", children: t === null ? /* @__PURE__ */ Z("div", { className: "flex scale-[0.8] flex-col items-center", children: [
      /* @__PURE__ */ _(G1, {}),
      /* @__PURE__ */ _("p", { className: "-mt-4 text-xs font-medium text-foundations-boldest", children: "No data in this period" })
    ] }) : /* @__PURE__ */ Z(It, { children: [
      /* @__PURE__ */ Z("p", { className: "text-xl font-bold text-foundations-boldest", children: [
        Qh(t),
        "%"
      ] }),
      i
    ] }) })
  ] })
);
_6.displayName = "CircleChart";
const S6 = En(
  "flex items-center justify-center rounded-md border border-foundations-bold bg-foundations-subtlest text-foundations-boldest py-0.5 px-1.5",
  {
    variants: {
      variant: {
        success: "bg-success-subtler border-success-subtle",
        danger: "bg-danger-subtler border-danger-subtle"
      }
    }
  }
), vW = b.forwardRef(({ diffPercentage: e, variant: t, className: n, ...r }, o) => /* @__PURE__ */ Z(
  "span",
  {
    ref: o,
    className: le(S6({ variant: t }), n),
    ...r,
    children: [
      !!e && /* @__PURE__ */ _(
        C6,
        {
          className: le("h-4 w-4", e < 0 && " rotate-180")
        }
      ),
      /* @__PURE__ */ Z("span", { className: "text-xs font-medium", children: [
        Qh(Math.abs(e)),
        "%"
      ] })
    ]
  }
)), O6 = ({
  items: e,
  formatValue: t,
  onBarHover: n
}) => {
  const r = b.useMemo(
    () => Math.max(...e.map((o) => o.value)),
    [e]
  );
  return e.length === 0 ? /* @__PURE__ */ _(U1, {}) : /* @__PURE__ */ _("div", { className: "space-y-4 text-xs font-medium", children: e.map((o) => {
    const s = (t == null ? void 0 : t(o)) || o.value;
    return /* @__PURE__ */ Z("div", { children: [
      /* @__PURE__ */ _("p", { className: "uppercase text-foundations-bold", children: o.label }),
      /* @__PURE__ */ Z(
        "div",
        {
          className: "mt-0.5 flex items-center space-x-2",
          style: {
            width: `${o.value ? o.value / r * 100 : 0}%`
          },
          children: [
            /* @__PURE__ */ Z(
              Rt,
              {
                onOpenChangeComplete: (i) => {
                  n == null || n(i, o);
                },
                disableHoverablePopup: !0,
                children: [
                  /* @__PURE__ */ _(
                    Rt.Trigger,
                    {
                      delay: 0,
                      render: /* @__PURE__ */ _(
                        "div",
                        {
                          className: "h-2 min-w-[2px] flex-1 bg-neutral-200",
                          style: {
                            backgroundColor: o.color
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ Z(
                    Rt.Popup,
                    {
                      variant: "light",
                      className: "flex items-center gap-2 whitespace-nowrap shadow-3",
                      hideArrow: !0,
                      children: [
                        /* @__PURE__ */ _(
                          "div",
                          {
                            className: "rounded-full size-2",
                            style: {
                              backgroundColor: o.color
                            }
                          }
                        ),
                        /* @__PURE__ */ Z("div", { className: "flex gap-4 text-xs font-medium text-foundations-boldest", children: [
                          /* @__PURE__ */ _("p", { className: "uppercase", children: o.label }),
                          /* @__PURE__ */ Z("p", { className: "text-foundations-subtle", children: [
                            s,
                            " ",
                            o.percentage && /* @__PURE__ */ Z("span", { children: [
                              "(",
                              Qh(o.percentage),
                              "%)"
                            ] })
                          ] })
                        ] })
                      ]
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ _("span", { className: "tabular-nums text-foundations-subtle", children: s })
          ]
        }
      )
    ] }, o.label);
  }) });
};
O6.displayName = "HorizontalBarsChart";
function ca({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = b.useRef(e !== void 0), [s, i] = b.useState(t), a = o ? e : s;
  if (process.env.NODE_ENV !== "production") {
    b.useEffect(() => {
      o !== (e !== void 0) && Vc([`A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: l
    } = b.useRef(t);
    b.useEffect(() => {
      !o && Rb(l) !== Rb(t) && Vc([`A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [t]);
  }
  const c = b.useCallback((l) => {
    o || i(l);
  }, []);
  return [a, c];
}
function Rb(e) {
  let t = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(e, function(s, i) {
      if (!(s === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof i == "bigint")
          return `__bigint__:${i}`;
        if (i !== null && typeof i == "object") {
          const a = n.get(i);
          if (a !== void 0)
            return `__object__:${a}`;
          n.set(i, t), t += 1;
        }
        return i;
      }
    }) ?? `__top__:${typeof e}`;
  } catch {
    return "__unserializable__";
  }
}
const Jh = /* @__PURE__ */ b.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Jh.displayName = "CompositeListContext");
function M6() {
  return b.useContext(Jh);
}
function ep(e) {
  const {
    children: t,
    elementsRef: n,
    labelsRef: r,
    onMapChange: o
  } = e, s = Se(o), i = b.useRef(0), a = gn(k6).current, c = gn(T6).current, [l, u] = b.useState(0), d = b.useRef(l), f = Se((y, v) => {
    c.set(y, v ?? null), d.current += 1, u(d.current);
  }), h = Se((y) => {
    c.delete(y), d.current += 1, u(d.current);
  }), p = b.useMemo(() => {
    const y = /* @__PURE__ */ new Map();
    return Array.from(c.keys()).filter((w) => w.isConnected).sort(P6).forEach((w, C) => {
      const x = c.get(w) ?? {};
      y.set(w, {
        ...x,
        index: C
      });
    }), y;
  }, [c, l]);
  be(() => {
    if (typeof MutationObserver != "function" || p.size === 0)
      return;
    const y = new MutationObserver((v) => {
      const w = /* @__PURE__ */ new Set(), C = (x) => w.has(x) ? w.delete(x) : w.add(x);
      v.forEach((x) => {
        x.removedNodes.forEach(C), x.addedNodes.forEach(C);
      }), w.size === 0 && (d.current += 1, u(d.current));
    });
    return p.forEach((v, w) => {
      w.parentElement && y.observe(w.parentElement, {
        childList: !0
      });
    }), () => {
      y.disconnect();
    };
  }, [p]), be(() => {
    d.current === l && (n.current.length !== p.size && (n.current.length = p.size), r && r.current.length !== p.size && (r.current.length = p.size), i.current = p.size), s(p);
  }, [s, p, n, r, l]), be(() => () => {
    n.current = [];
  }, [n]), be(() => () => {
    r && (r.current = []);
  }, [r]);
  const g = Se((y) => (a.add(y), () => {
    a.delete(y);
  }));
  be(() => {
    a.forEach((y) => y(p));
  }, [a, p]);
  const m = b.useMemo(() => ({
    register: f,
    unregister: h,
    subscribeMapChange: g,
    elementsRef: n,
    labelsRef: r,
    nextIndexRef: i
  }), [f, h, g, n, r, i]);
  return /* @__PURE__ */ _(Jh.Provider, {
    value: m,
    children: t
  });
}
function T6() {
  return /* @__PURE__ */ new Map();
}
function k6() {
  return /* @__PURE__ */ new Set();
}
function P6(e, t) {
  const n = e.compareDocumentPosition(t);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
function R6(e) {
  const {
    open: t,
    defaultOpen: n,
    onOpenChange: r,
    disabled: o
  } = e, [s, i] = ca({
    controlled: t,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: c,
    transitionStatus: l
  } = ta(s, !0, !0), u = nn(), [d, f] = b.useState(), h = d ?? u, p = Se((g) => {
    const m = !s, y = Ve(br, g.nativeEvent);
    r(m, y), !y.isCanceled && i(m);
  });
  return b.useMemo(() => ({
    disabled: o,
    handleTrigger: p,
    mounted: a,
    open: s,
    panelId: h,
    setMounted: c,
    setOpen: i,
    setPanelIdState: f,
    transitionStatus: l
  }), [o, p, a, s, h, c, i, f, l]);
}
const tp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (tp.displayName = "CollapsibleRootContext");
function cw() {
  const e = b.useContext(tp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : rt(15));
  return e;
}
let I6 = /* @__PURE__ */ function(e) {
  return e[e.None = 0] = "None", e[e.GuessFromOrder = 1] = "GuessFromOrder", e;
}({});
function Fs(e = {}) {
  const {
    label: t,
    metadata: n,
    textRef: r,
    indexGuessBehavior: o,
    index: s
  } = e, {
    register: i,
    unregister: a,
    subscribeMapChange: c,
    elementsRef: l,
    labelsRef: u,
    nextIndexRef: d
  } = M6(), f = b.useRef(-1), [h, p] = b.useState(s ?? (o === I6.GuessFromOrder ? () => {
    if (f.current === -1) {
      const y = d.current;
      d.current += 1, f.current = y;
    }
    return f.current;
  } : -1)), g = b.useRef(null), m = b.useCallback((y) => {
    var v;
    if (g.current = y, h !== -1 && y !== null && (l.current[h] = y, u)) {
      const w = t !== void 0;
      u.current[h] = w ? t : ((v = r == null ? void 0 : r.current) == null ? void 0 : v.textContent) ?? y.textContent;
    }
  }, [h, l, u, t, r]);
  return be(() => {
    if (s != null)
      return;
    const y = g.current;
    if (y)
      return i(y, n), () => {
        a(y);
      };
  }, [s, i, a, n]), be(() => {
    if (s == null)
      return c((y) => {
        var w;
        const v = g.current ? (w = y.get(g.current)) == null ? void 0 : w.index : null;
        v != null && p(v);
      });
  }, [s, c, p]), b.useMemo(() => ({
    ref: m,
    index: h
  }), [h, m]);
}
let np = function(e) {
  return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = Hr.startingStyle] = "startingStyle", e[e.endingStyle = Hr.endingStyle] = "endingStyle", e;
}({}), D6 = /* @__PURE__ */ function(e) {
  return e.panelOpen = "data-panel-open", e;
}({});
const N6 = {
  [np.open]: ""
}, A6 = {
  [np.closed]: ""
}, $6 = {
  open(e) {
    return e ? {
      [D6.panelOpen]: ""
    } : null;
  }
}, F6 = {
  open(e) {
    return e ? N6 : A6;
  }
};
function lw(e) {
  return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
const ni = {
  height: void 0,
  width: void 0
};
function L6(e) {
  const {
    externalRef: t,
    hiddenUntilFound: n,
    id: r,
    keepMounted: o,
    mounted: s,
    onOpenChange: i,
    open: a,
    setMounted: c,
    setOpen: l,
    transitionStatus: u
  } = e, d = b.useRef(null), f = b.useRef(null), [h, p] = b.useState(ni), g = b.useRef(ni), m = b.useRef(!1), y = b.useRef(a), v = b.useRef(!1), [w, C] = b.useState(!1), x = b.useRef(null), E = Vr(t, d), S = Yt({
    mounted: s,
    open: a
  }), M = $l(d, !1, !1), T = !a && !s, P = w ? "idle" : u, k = a && // These 2 refs are safe to read in render, they are only written from committed
  // layout/effect paths and gate one-shot motion suppression for the next open
  // lifecycle. They intentionally expose the last committed motion snapshot.
  (y.current || v.current), I = !a && s && // These 2 refs are also safe to read in render, both hold the last committed
  // animation mode and measurement. This fallback only restores a previously
  // measured pixel size after the live dimensions state has been reset back to `auto`.
  f.current === "css-animation" && h.height === void 0 && h.width === void 0 ? g.current : h, O = n && T && f.current !== "css-animation", A = Se((V, D = !0) => {
    D && (g.current = V), p(V);
  }), R = Se(() => {
    var V;
    (V = x.current) == null || V.call(x), x.current = null;
  }), N = Se((V) => {
    R(), x.current = () => {
      x.current = null, V();
    };
  }), $ = Se(() => {
    a && s && f.current === "css-animation" && (v.current = !0);
  });
  be(() => {
    !w || u === "starting" || C(!1);
  }, [w, u]), b.useEffect(() => () => {
    $(), R();
  }, [$, R]), be(() => {
    const V = d.current;
    if (!V)
      return;
    !a && x.current && R();
    const D = V6(V, k);
    if (f.current = D, a && u === "idle" && y.current && D === "css-animation") {
      g.current = ts(V);
      return;
    }
    if (a && u === "starting") {
      const U = m.current;
      if (m.current = !1, D === "none") {
        A(ts(V)), C(!0);
        return;
      }
      if (D === "css-transition") {
        const K = W6(V);
        if (A(ts(V)), !U)
          return K;
        const G = ri(V, "transition-duration", "0s");
        return N(G), C(!0), K;
      }
      if (D === "css-animation") {
        if (A(ts(V)), !U) {
          ri(V, "animation-name", "none")();
          return;
        }
        const K = ri(V, "animation-name", "none"), G = ri(V, "animation-duration", "0s");
        K(), N(G), C(!0);
        return;
      }
    }
    if (!a && s && (u === "idle" || u === "starting")) {
      if (D === "none") {
        A(ni, !1), c(!1);
        return;
      }
      D === "css-animation" && (y.current = !1, v.current = !1), A(ts(V));
      return;
    }
    if (u !== "ending")
      return;
    if (D === "none") {
      c(!1);
      return;
    }
    const H = ts(V);
    if (!((H.height ?? 0) > 0 || (H.width ?? 0) > 0)) {
      c(!1);
      return;
    }
    A(H), D === "css-animation" && ri(V, "animation-name", "none")();
  }, [s, a, R, A, c, N, k, u]), xr({
    enabled: a && s && P === "idle",
    open: !0,
    ref: d,
    onComplete() {
      a && A(ni, !1);
    }
  }), b.useEffect(() => {
    if (a || !s || P !== "ending" || !d.current)
      return;
    const D = new AbortController();
    let H = -1;
    function j() {
      S.current.open || (c(!1), A(ni, !1));
    }
    return H = bn.request(() => {
      D.signal.aborted || M(j, D.signal);
    }), () => {
      bn.cancel(H), D.abort();
    };
  }, [S, s, a, P, M, A, c]), be(() => {
    const V = d.current;
    !V || !n || !T || V.setAttribute("hidden", "until-found");
  }, [T, n]), b.useEffect(function() {
    const D = d.current;
    if (!D)
      return;
    function H(j) {
      m.current = !0, l(!0), i(!0, Ve(xs, j));
    }
    return We(D, "beforematch", H);
  }, [i, l]);
  const F = o || n || s || a;
  return {
    height: I.height,
    props: {
      ...O ? {
        [np.startingStyle]: ""
      } : void 0,
      hidden: T,
      id: r
    },
    ref: E,
    shouldPreventOpenAnimation: k,
    shouldRender: F,
    transitionStatus: P,
    width: I.width
  };
}
function ts(e) {
  return {
    height: e.scrollHeight,
    width: e.scrollWidth
  };
}
function V6(e, t = !1) {
  const n = Ot(e).getComputedStyle(e), r = (n.animationName.split(",").map((s) => s.trim()).some((s) => s !== "" && s !== "none") || t) && Ib(n.animationDuration), o = Ib(n.transitionDuration);
  return r && o ? (process.env.NODE_ENV !== "production" && vl("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used."), "css-transition") : o ? "css-transition" : r ? "css-animation" : "none";
}
function Ib(e) {
  return e.split(",").map((t) => t.trim()).some((t) => t !== "" && Number.parseFloat(t) > 0);
}
function ri(e, t, n) {
  const r = e.style.getPropertyValue(t), o = e.style.getPropertyPriority(t);
  return e.style.setProperty(t, n), () => {
    if (r === "") {
      e.style.removeProperty(t);
      return;
    }
    e.style.setProperty(t, r, o);
  };
}
function W6(e) {
  const t = {
    "justify-content": e.style.justifyContent,
    "align-items": e.style.alignItems,
    "align-content": e.style.alignContent,
    "justify-items": e.style.justifyItems
  };
  Object.keys(t).forEach((o) => {
    e.style.setProperty(o, "initial", "important");
  });
  function n() {
    Object.entries(t).forEach(([o, s]) => {
      if (s === "") {
        e.style.removeProperty(o);
        return;
      }
      e.style.setProperty(o, s);
    });
  }
  const r = bn.request(n);
  return () => {
    bn.cancel(r), n();
  };
}
let Db = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const B6 = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, bi = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, H6 = {
  disabled: !1,
  ...bi
}, Y6 = {
  valid(e) {
    return e === null ? null : e ? {
      [Db.valid]: ""
    } : {
      [Db.invalid]: ""
    };
  }
}, z6 = {
  invalid: void 0,
  name: void 0,
  validityData: {
    state: B6,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: an,
  disabled: void 0,
  touched: bi.touched,
  setTouched: an,
  dirty: bi.dirty,
  setDirty: an,
  filled: bi.filled,
  setFilled: an,
  focused: bi.focused,
  setFocused: an,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: H6,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: an,
  validation: {
    getValidationProps: (e = wt) => e,
    getInputValidationProps: (e = wt) => e,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
}, uw = /* @__PURE__ */ b.createContext(z6);
process.env.NODE_ENV !== "production" && (uw.displayName = "FieldRootContext");
function dw(e = !0) {
  const t = b.useContext(uw);
  if (t.setValidityData === an && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : rt(28));
  return t;
}
function j6(e, t, n, r, o = !0) {
  const {
    registerFieldControl: s
  } = dw(), i = b.useRef(null);
  i.current || (i.current = Symbol()), be(() => {
    const a = i.current;
    return !a || !o ? void 0 : (s(a, {
      controlRef: e,
      getValue: r,
      id: t,
      value: n
    }), () => {
      s(a, void 0);
    });
  }, [e, o, r, t, s, n]);
}
const fw = /* @__PURE__ */ b.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: an,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (fw.displayName = "FormContext");
function U6() {
  return b.useContext(fw);
}
const hw = /* @__PURE__ */ b.createContext({
  controlId: void 0,
  registerControlId: an,
  labelId: void 0,
  setLabelId: an,
  messageIds: [],
  setMessageIds: an,
  getDescriptionProps: (e) => e
});
process.env.NODE_ENV !== "production" && (hw.displayName = "LabelableContext");
function pw() {
  return b.useContext(hw);
}
function G6(e = {}) {
  const {
    id: t,
    implicit: n = !1,
    controlRef: r
  } = e, {
    controlId: o,
    registerControlId: s
  } = pw(), i = nn(t), a = n ? o : void 0, c = gn(() => Symbol("labelable-control")), l = b.useRef(!1), u = b.useRef(t != null), d = Se(() => {
    !l.current || s === an || (l.current = !1, s(c.current, void 0));
  });
  return be(() => {
    if (s === an)
      return;
    let f;
    if (n) {
      const h = r == null ? void 0 : r.current;
      Ge(h) && h.closest("label") != null ? f = t ?? null : f = a ?? i;
    } else if (t != null)
      u.current = !0, f = t;
    else if (u.current)
      f = i;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    l.current = !0, s(c.current, f);
  }, [t, r, a, s, n, i, c, d]), b.useEffect(() => d, [d]), o ?? i;
}
function K6(e) {
  const t = e.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return t;
  const n = Ot(e), r = n.getComputedStyle(e, "::before"), o = n.getComputedStyle(e, "::after");
  if (!(r.content !== "none" || o.content !== "none"))
    return t;
  const i = parseFloat(r.width) || 0, a = parseFloat(r.height) || 0, c = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, u = Math.max(t.width, i, c), d = Math.max(t.height, a, l), f = u - t.width, h = d - t.height;
  return {
    left: t.left - f / 2,
    right: t.right + f / 2,
    top: t.top - h / 2,
    bottom: t.bottom + h / 2
  };
}
const q6 = 20;
function gw(e, t, n, r) {
  const [o, s] = b.useState(!1);
  be(() => {
    if (!e || !t || n == null) {
      s(!1);
      return;
    }
    const i = Ye(n).documentElement.clientWidth, a = n.offsetWidth;
    s(i > 0 && a > 0 && a >= i - q6);
  }, [e, t, n]), Dy(e && (!t || o), r);
}
const mw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    orientation: s = "horizontal",
    style: i,
    ...a
  } = t;
  return $e("div", t, {
    state: {
      orientation: s
    },
    ref: n,
    props: [{
      role: "separator",
      "aria-orientation": s
    }, a]
  });
});
process.env.NODE_ENV !== "production" && (mw.displayName = "Separator");
function X6(e, t, n, r = !0, o) {
  const [s, i] = b.useState(), a = nn(o ? `${o}-label` : void 0), c = e ?? t ?? s;
  return be(() => {
    const l = e || t || !r ? void 0 : Z6(n.current, a);
    s !== l && i(l);
  }), c;
}
function Z6(e, t) {
  const n = Q6(e);
  if (n)
    return !n.id && t && (n.id = t), n.id || void 0;
}
function Q6(e) {
  if (!e)
    return;
  const t = e.parentElement;
  if (t && t.tagName === "LABEL")
    return t;
  const n = e.id;
  if (n) {
    const o = e.nextElementSibling;
    if (o && o.htmlFor === n)
      return o;
  }
  const r = e.labels;
  return r && r[0];
}
const bw = {
  ...F6,
  ...Un
}, vw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    defaultOpen: s = !1,
    disabled: i = !1,
    onOpenChange: a,
    open: c,
    style: l,
    ...u
  } = t, d = Se(a), f = R6({
    open: c,
    defaultOpen: s,
    onOpenChange: d,
    disabled: i
  }), h = b.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), p = b.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: h
  }), [f, d, h]), g = $e("div", t, {
    state: h,
    ref: n,
    props: u,
    stateAttributesMapping: bw
  });
  return /* @__PURE__ */ _(tp.Provider, {
    value: p,
    children: g
  });
});
process.env.NODE_ENV !== "production" && (vw.displayName = "CollapsibleRoot");
const J6 = {
  ...$6,
  ...Un
}, yw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    panelId: r,
    open: o,
    handleTrigger: s,
    state: i,
    disabled: a
  } = cw(), {
    className: c,
    disabled: l = a,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: h,
    ...p
  } = t, {
    getButtonProps: g,
    buttonRef: m
  } = Cr({
    disabled: l,
    focusableWhenDisabled: !0,
    native: f
  });
  return $e("button", t, {
    state: i,
    ref: [n, m],
    props: [{
      "aria-controls": o ? r : void 0,
      "aria-expanded": o,
      onClick: s
    }, p, g],
    stateAttributesMapping: J6
  });
});
process.env.NODE_ENV !== "production" && (yw.displayName = "CollapsibleTrigger");
let Nb = /* @__PURE__ */ function(e) {
  return e.collapsiblePanelHeight = "--collapsible-panel-height", e.collapsiblePanelWidth = "--collapsible-panel-width", e;
}({});
const ww = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    hiddenUntilFound: o,
    keepMounted: s,
    render: i,
    id: a,
    style: c,
    ...l
  } = t;
  process.env.NODE_ENV !== "production" && be(() => {
    o && s === !1 && vl("The `keepMounted={false}` prop on `Collapsible.Panel` is ignored when `hiddenUntilFound` is enabled, since the panel must remain mounted while closed.");
  }, [o, s]);
  const {
    mounted: u,
    onOpenChange: d,
    open: f,
    panelId: h,
    setMounted: p,
    setPanelIdState: g,
    setOpen: m,
    state: y,
    transitionStatus: v
  } = cw(), w = o ?? !1, C = s ?? !1;
  be(() => {
    if (a)
      return g(a), () => {
        g(void 0);
      };
  }, [a, g]);
  const {
    height: x,
    props: E,
    ref: S,
    shouldPreventOpenAnimation: M,
    shouldRender: T,
    transitionStatus: P,
    width: k
  } = L6({
    externalRef: n,
    hiddenUntilFound: w,
    id: h,
    keepMounted: C,
    mounted: u,
    onOpenChange: d,
    open: f,
    setMounted: p,
    setOpen: m,
    transitionStatus: v
  }), I = {
    ...y,
    transitionStatus: P
  }, O = i0(c, I), A = $e("div", {
    ...t,
    style: void 0
  }, {
    state: I,
    ref: S,
    props: [
      E,
      {
        style: {
          [Nb.collapsiblePanelHeight]: x === void 0 ? "auto" : `${x}px`,
          [Nb.collapsiblePanelWidth]: k === void 0 ? "auto" : `${k}px`
        }
      },
      l,
      O ? {
        style: O
      } : void 0,
      // Resolve the public `style` prop so temporary `animationName: 'none'`
      // can still win after user's inline styles have been merged.
      M ? {
        style: {
          animationName: "none"
        }
      } : void 0
    ],
    stateAttributesMapping: bw
  });
  return T ? A : null;
});
process.env.NODE_ENV !== "production" && (ww.displayName = "CollapsiblePanel");
function e3(e, t) {
  const n = nn(e);
  return be(() => (t(n), () => {
    t(void 0);
  }), [n, t]), n;
}
const xw = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (xw.displayName = "ContextMenuRootContext");
function la(e = !0) {
  const t = b.useContext(xw);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : rt(25));
  return t;
}
const rp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (rp.displayName = "MenuPositionerContext");
function ua(e) {
  const t = b.useContext(rp);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : rt(33));
  return t;
}
const op = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (op.displayName = "MenuRootContext");
function Gn(e) {
  const t = b.useContext(op);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : rt(36));
  return t;
}
const t3 = {
  ...qr,
  ...Un
}, Cw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    store: a
  } = Gn(), c = a.useState("open"), l = a.useState("mounted"), u = a.useState("transitionStatus"), d = a.useState("lastOpenChangeReason"), f = la(), h = {
    open: c,
    transitionStatus: u
  };
  return $e("div", t, {
    ref: f != null && f.backdropRef ? [n, f.backdropRef] : n,
    state: h,
    stateAttributesMapping: t3,
    props: [{
      role: "presentation",
      hidden: !l,
      style: {
        pointerEvents: d === Pt ? "none" : void 0,
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, i]
  });
});
process.env.NODE_ENV !== "production" && (Cw.displayName = "MenuBackdrop");
const sp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (sp.displayName = "MenuCheckboxItemContext");
function n3() {
  const e = b.useContext(sp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuCheckboxItemContext is missing. MenuCheckboxItem parts must be placed within <Menu.CheckboxItem>." : rt(30));
  return e;
}
function r3(e) {
  const {
    closeOnClick: t,
    highlighted: n,
    id: r,
    nodeId: o,
    store: s,
    typingRef: i,
    itemRef: a,
    itemMetadata: c
  } = e, {
    events: l
  } = s.useState("floatingTreeRoot"), u = la(!0), d = u !== void 0;
  return b.useMemo(() => ({
    id: r,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && (i != null && i.current) && f.preventDefault();
    },
    onMouseMove(f) {
      o && l.emit("itemhover", {
        nodeId: o,
        target: f.currentTarget
      });
    },
    onClick(f) {
      t && l.emit("close", {
        domEvent: f,
        reason: Ol
      });
    },
    onMouseUp(f) {
      if (u) {
        const h = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && h && Math.abs(f.clientX - h.x) <= 1 && Math.abs(f.clientY - h.y) <= 1 || d && !_0 && f.button === 2)
          return;
      }
      a.current && s.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!c || c.type === "regular-item") && a.current.click();
    }
  }), [t, n, r, l, o, s, i, a, u, d, c]);
}
const ip = {
  type: "regular-item"
};
function au(e) {
  const {
    closeOnClick: t,
    disabled: n = !1,
    highlighted: r,
    id: o,
    store: s,
    typingRef: i = s.context.typingRef,
    nativeButton: a,
    itemMetadata: c,
    nodeId: l
  } = e, u = b.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Cr({
    disabled: n,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  }), h = r3({
    closeOnClick: t,
    highlighted: r,
    id: o,
    nodeId: l,
    store: s,
    typingRef: i,
    itemRef: u,
    itemMetadata: c
  }), p = b.useCallback((m) => Zt(h, {
    onMouseEnter() {
      c.type === "submenu-trigger" && c.setActive();
    }
  }, m, d), [h, d, c]), g = Vr(u, f);
  return b.useMemo(() => ({
    getItemProps: p,
    itemRef: g
  }), [p, g]);
}
let Ab = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.highlighted = "data-highlighted", e;
}({});
const cu = {
  checked(e) {
    return e ? {
      [Ab.checked]: ""
    } : {
      [Ab.unchecked]: ""
    };
  },
  ...Un
}, Ew = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: c = !1,
    closeOnClick: l = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: h,
    ...p
  } = t, g = Fs({
    label: i
  }), m = ua(!0), y = nn(s), {
    store: v
  } = Gn(), w = v.useState("isActive", g.index), C = v.useState("itemProps"), [x, E] = ca({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: S,
    itemRef: M
  } = au({
    closeOnClick: l,
    disabled: c,
    highlighted: w,
    id: y,
    store: v,
    nativeButton: a,
    nodeId: m == null ? void 0 : m.context.nodeId,
    itemMetadata: ip
  }), T = b.useMemo(() => ({
    disabled: c,
    highlighted: w,
    checked: x
  }), [c, w, x]);
  function P(I) {
    const O = Ve(Ol, I.nativeEvent, void 0, {
      preventUnmountOnClose() {
      }
    });
    f == null || f(!x, O), !O.isCanceled && E((A) => !A);
  }
  const k = $e("div", t, {
    state: T,
    stateAttributesMapping: cu,
    props: [C, {
      role: "menuitemcheckbox",
      "aria-checked": x,
      onClick: P
    }, p, S],
    ref: [M, n, g.ref]
  });
  return /* @__PURE__ */ _(sp.Provider, {
    value: T,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (Ew.displayName = "MenuCheckboxItem");
const _w = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    keepMounted: i = !1,
    ...a
  } = t, c = n3(), l = b.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = ta(c.checked);
  xr({
    open: c.checked,
    ref: l,
    onComplete() {
      c.checked || d(!1);
    }
  });
  const f = {
    checked: c.checked,
    disabled: c.disabled,
    highlighted: c.highlighted,
    transitionStatus: u
  };
  return $e("span", t, {
    state: f,
    ref: [n, l],
    stateAttributesMapping: cu,
    props: {
      "aria-hidden": !0,
      ...a
    },
    enabled: i || c.checked
  });
});
process.env.NODE_ENV !== "production" && (_w.displayName = "MenuCheckboxItemIndicator");
const lu = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (lu.displayName = "MenuGroupContext");
function o3() {
  const e = b.useContext(lu);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuGroupContext is missing. Menu group parts must be used within <Menu.Group> or <Menu.RadioGroup>." : rt(31));
  return e;
}
const Sw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, [a, c] = b.useState(void 0), l = $e("div", t, {
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": a,
      ...i
    }
  });
  return /* @__PURE__ */ _(lu.Provider, {
    value: c,
    children: l
  });
});
process.env.NODE_ENV !== "production" && (Sw.displayName = "MenuGroup");
const Ow = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, c = nn(i), l = o3();
  return be(() => (l(c), () => {
    l(void 0);
  }), [l, c]), $e("div", t, {
    ref: n,
    props: {
      id: c,
      role: "presentation",
      ...a
    }
  });
});
process.env.NODE_ENV !== "production" && (Ow.displayName = "MenuGroupLabel");
const Mw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: c = !1,
    closeOnClick: l = !0,
    style: u,
    ...d
  } = t, f = Fs({
    label: i
  }), h = ua(!0), p = nn(s), {
    store: g
  } = Gn(), m = g.useState("isActive", f.index), y = g.useState("itemProps"), {
    getItemProps: v,
    itemRef: w
  } = au({
    closeOnClick: l,
    disabled: c,
    highlighted: m,
    id: p,
    store: g,
    nativeButton: a,
    nodeId: h == null ? void 0 : h.context.nodeId,
    itemMetadata: ip
  });
  return $e("div", t, {
    state: {
      disabled: c,
      highlighted: m
    },
    props: [y, d, v],
    ref: [w, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (Mw.displayName = "MenuItem");
const Tw = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Tw.displayName = "ToolbarRootContext");
function kw(e) {
  const t = b.useContext(Tw);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToolbarRootContext is missing. Toolbar parts must be placed within <Toolbar.Root>." : rt(69));
  return t;
}
const s3 = {
  ...qr,
  ...Un
}, Pw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    finalFocus: i,
    ...a
  } = t, {
    store: c
  } = Gn(), {
    side: l,
    align: u
  } = ua(), d = kw(!0) != null, f = c.useState("open"), h = c.useState("transitionStatus"), p = c.useState("popupProps"), g = c.useState("mounted"), m = c.useState("instantType"), y = c.useState("activeTriggerElement"), v = c.useState("parent"), w = c.useState("lastOpenChangeReason"), C = c.useState("rootId"), x = c.useState("floatingRootContext"), E = c.useState("floatingTreeRoot"), S = c.useState("closeDelay"), M = c.useState("activeTriggerElement"), T = c.useState("hoverEnabled"), P = c.useState("disabled"), k = v.type === "context-menu";
  xr({
    open: f,
    ref: c.context.popupRef,
    onComplete() {
      var N, $;
      f && (($ = (N = c.context).onOpenChangeComplete) == null || $.call(N, !0));
    }
  }), b.useEffect(() => {
    function N($) {
      c.setOpen(!1, Ve($.reason, $.domEvent));
    }
    return E.events.on("close", N), () => {
      E.events.off("close", N);
    };
  }, [E.events, c]), ih(x, {
    enabled: T && !P && !k && v.type !== "menubar",
    closeDelay: S
  });
  const I = b.useCallback((N) => {
    c.set("popupElement", N);
  }, [c]), O = {
    transitionStatus: h,
    side: l,
    align: u,
    open: f,
    nested: v.type === "menu",
    instant: m
  }, A = $e("div", t, {
    state: O,
    ref: [n, c.context.popupRef, I],
    stateAttributesMapping: s3,
    props: [p, {
      onKeyDown(N) {
        d && Zl.has(N.key) && N.stopPropagation();
      }
    }, Gl(h), a, {
      "data-rootownerid": C
    }]
  });
  let R = v.type === void 0 || k;
  return (y || v.type === "menubar" && w !== Ff) && (R = !0), /* @__PURE__ */ _(Qf, {
    context: x,
    modal: k,
    disabled: !g,
    returnFocus: i === void 0 ? R : i,
    initialFocus: v.type !== "menu",
    restoreFocus: !0,
    externalTree: v.type !== "menubar" ? E : void 0,
    previousFocusableElement: M,
    nextFocusableElement: v.type === void 0 ? c.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: v.type === void 0 ? c.context.beforeContentFocusGuardRef : void 0,
    children: A
  });
});
process.env.NODE_ENV !== "production" && (Pw.displayName = "MenuPopup");
const ap = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (ap.displayName = "MenuPortalContext");
function i3() {
  const e = b.useContext(ap);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : rt(32));
  return e;
}
const Rw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: s
  } = Gn();
  return s.useState("mounted") || r ? /* @__PURE__ */ _(ap.Provider, {
    value: r,
    children: /* @__PURE__ */ _(Pl, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Rw.displayName = "MenuPortal");
const Iw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var ke;
  const {
    anchor: r,
    positionMethod: o = "absolute",
    className: s,
    render: i,
    side: a,
    align: c,
    sideOffset: l = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: h = 5,
    sticky: p = !1,
    disableAnchorTracking: g = !1,
    collisionAvoidance: m = ZO,
    style: y,
    ...v
  } = t, {
    store: w
  } = Gn(), C = i3(), x = la(!0), E = w.useState("parent"), S = w.useState("floatingRootContext"), M = w.useState("floatingTreeRoot"), T = w.useState("mounted"), P = w.useState("open"), k = w.useState("modal"), I = w.useState("openMethod"), O = w.useState("activeTriggerElement"), A = w.useState("transitionStatus"), R = w.useState("positionerElement"), N = w.useState("instantType"), $ = w.useState("hasViewport"), F = w.useState("lastOpenChangeReason"), V = w.useState("floatingNodeId"), D = w.useState("floatingParentNodeId"), H = S.useState("domReferenceElement"), j = b.useRef(null), U = $l(R, !1, !1);
  let K = r, G = l, B = u, z = c, W = m;
  E.type === "context-menu" && (K = r ?? ((ke = E.context) == null ? void 0 : ke.anchor), z = z ?? "start", !a && z !== "center" && (B = t.alignOffset ?? 2, G = t.sideOffset ?? -5));
  let X = a, J = z;
  E.type === "menu" ? (X = X ?? "inline-end", J = J ?? "start", W = t.collisionAvoidance ?? jf) : E.type === "menubar" && (X = X ?? "bottom", J = J ?? "start");
  const Q = E.type === "context-menu", Y = ph({
    anchor: K,
    floatingRootContext: S,
    positionMethod: x ? "fixed" : o,
    mounted: T,
    side: X,
    sideOffset: G,
    align: J,
    alignOffset: B,
    arrowPadding: Q ? 0 : h,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: p,
    nodeId: V,
    keepMounted: C,
    disableAnchorTracking: g,
    collisionAvoidance: W,
    shiftCrossAxis: Q && !("side" in W && W.side === "flip"),
    externalTree: M,
    adaptiveOrigin: $ ? hh : void 0
  });
  b.useEffect(() => {
    function we(Oe) {
      Oe.open && (Oe.parentNodeId === V && w.set("hoverEnabled", !1), Oe.nodeId !== V && Oe.parentNodeId === w.select("floatingParentNodeId") && w.setOpen(!1, Ve(ui)));
    }
    return M.events.on("menuopenchange", we), () => {
      M.events.off("menuopenchange", we);
    };
  }, [w, M.events, V]), b.useEffect(() => {
    if (w.select("floatingParentNodeId") == null)
      return;
    function we(Oe) {
      if (Oe.open || Oe.nodeId !== w.select("floatingParentNodeId"))
        return;
      const Ie = Oe.reason ?? ui;
      w.setOpen(!1, Ve(Ie));
    }
    return M.events.on("menuopenchange", we), () => {
      M.events.off("menuopenchange", we);
    };
  }, [M.events, w]);
  const ce = ln();
  b.useEffect(() => {
    P || ce.clear();
  }, [P, ce]), b.useEffect(() => {
    function we(Oe) {
      if (!(!P || Oe.nodeId !== w.select("floatingParentNodeId")))
        if (Oe.target && O && O !== Oe.target) {
          const Ie = w.select("closeDelay");
          Ie > 0 ? ce.isStarted() || ce.start(Ie, () => {
            w.setOpen(!1, Ve(ui));
          }) : w.setOpen(!1, Ve(ui));
        } else
          ce.clear();
    }
    return M.events.on("itemhover", we), () => {
      M.events.off("itemhover", we);
    };
  }, [M.events, P, O, w, ce]), b.useEffect(() => {
    const we = {
      open: P,
      nodeId: V,
      parentNodeId: D,
      reason: w.select("lastOpenChangeReason")
    };
    M.events.emit("menuopenchange", we);
  }, [M.events, P, w, V, D]), be(() => {
    const we = H, Oe = j.current;
    if (we && (j.current = we), Oe && we && we !== Oe) {
      w.set("instantType", void 0);
      const Ie = new AbortController();
      return U(() => {
        w.set("instantType", "trigger-change");
      }, Ie.signal), () => {
        Ie.abort();
      };
    }
  }, [H, U, w]);
  const ee = {
    open: P,
    side: Y.side,
    align: Y.align,
    anchorHidden: Y.anchorHidden,
    nested: E.type === "menu",
    instant: N
  }, ne = E.type === "menubar" && E.context.modal;
  gw(P && (ne || k && F !== Pt), I === "touch", R, O);
  const pe = gh(t, ee, {
    styles: Y.positionerStyles,
    transitionStatus: A,
    props: v,
    refs: [n, w.useStateSetter("positionerElement")],
    hidden: !T,
    inert: !P
  }), Ee = T && E.type !== "menu" && (E.type !== "menubar" && k && F !== Pt || E.type === "menubar" && E.context.modal);
  let se = null;
  return E.type === "menubar" ? se = E.context.contentElement : E.type === void 0 && (se = O), /* @__PURE__ */ Z(rp.Provider, {
    value: Y,
    children: [Ee && /* @__PURE__ */ _(Ql, {
      ref: E.type === "context-menu" || E.type === "nested-context-menu" ? E.context.internalBackdropRef : null,
      inert: na(!P),
      cutout: se
    }), /* @__PURE__ */ _(ey, {
      id: V,
      children: /* @__PURE__ */ _(ep, {
        elementsRef: w.context.itemDomElements,
        labelsRef: w.context.itemLabels,
        children: pe
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Iw.displayName = "MenuPositioner");
const cp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (cp.displayName = "MenuRadioGroupContext");
function a3() {
  const e = b.useContext(cp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : rt(34));
  return e;
}
const Dw = /* @__PURE__ */ b.memo(/* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    value: s,
    defaultValue: i,
    onValueChange: a,
    disabled: c = !1,
    style: l,
    "aria-labelledby": u,
    ...d
  } = t, [f, h] = b.useState(void 0), [p, g] = ca({
    controlled: s,
    default: i,
    name: "MenuRadioGroup"
  }), m = Se((C, x) => {
    a == null || a(C, x), !x.isCanceled && g(C);
  }), v = $e("div", t, {
    state: {
      disabled: c
    },
    ref: n,
    props: {
      role: "group",
      "aria-labelledby": u ?? f,
      "aria-disabled": c || void 0,
      ...d
    }
  }), w = b.useMemo(() => ({
    value: p,
    setValue: m,
    disabled: c
  }), [p, m, c]);
  return /* @__PURE__ */ _(lu.Provider, {
    value: h,
    children: /* @__PURE__ */ _(cp.Provider, {
      value: w,
      children: v
    })
  });
}));
process.env.NODE_ENV !== "production" && (Dw.displayName = "MenuRadioGroup");
const lp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (lp.displayName = "MenuRadioItemContext");
function c3() {
  const e = b.useContext(lp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : rt(35));
  return e;
}
const Nw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    id: s,
    label: i,
    nativeButton: a = !1,
    disabled: c = !1,
    closeOnClick: l = !1,
    value: u,
    style: d,
    ...f
  } = t, h = Fs({
    label: i
  }), p = ua(!0), g = nn(s), {
    store: m
  } = Gn(), y = m.useState("isActive", h.index), v = m.useState("itemProps"), {
    value: w,
    setValue: C,
    disabled: x
  } = a3(), E = x || c, S = w === u, {
    getItemProps: M,
    itemRef: T
  } = au({
    closeOnClick: l,
    disabled: E,
    highlighted: y,
    id: g,
    store: m,
    nativeButton: a,
    nodeId: p == null ? void 0 : p.context.nodeId,
    itemMetadata: ip
  }), P = b.useMemo(() => ({
    disabled: E,
    highlighted: y,
    checked: S
  }), [E, y, S]);
  function k(O) {
    const A = Ve(Ol, O.nativeEvent, void 0, {
      preventUnmountOnClose() {
      }
    });
    C(u, A);
  }
  const I = $e("div", t, {
    state: P,
    stateAttributesMapping: cu,
    props: [v, {
      role: "menuitemradio",
      "aria-checked": S,
      onClick: k
    }, f, M],
    ref: [T, n, h.ref]
  });
  return /* @__PURE__ */ _(lp.Provider, {
    value: P,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (Nw.displayName = "MenuRadioItem");
const Aw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    keepMounted: i = !1,
    ...a
  } = t, c = c3(), l = b.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = ta(c.checked);
  xr({
    open: c.checked,
    ref: l,
    onComplete() {
      c.checked || d(!1);
    }
  });
  const f = {
    checked: c.checked,
    disabled: c.disabled,
    highlighted: c.highlighted,
    transitionStatus: u
  };
  return $e("span", t, {
    state: f,
    stateAttributesMapping: cu,
    ref: [n, l],
    props: {
      "aria-hidden": !0,
      ...a
    },
    enabled: i || c.checked
  });
});
process.env.NODE_ENV !== "production" && (Aw.displayName = "MenuRadioItemIndicator");
const $w = /* @__PURE__ */ b.createContext(null);
process.env.NODE_ENV !== "production" && ($w.displayName = "MenubarContext");
function Fw(e) {
  const t = b.useContext($w);
  if (t === null && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenubarContext is missing. Menubar parts must be placed within <Menubar>." : rt(5));
  return t;
}
const l3 = {
  ...Hl,
  disabled: ge((e) => e.parent.type === "menubar" && e.parent.context.disabled || e.disabled),
  modal: ge((e) => (e.parent.type === void 0 || e.parent.type === "context-menu") && (e.modal ?? !0)),
  openMethod: ge((e) => e.openMethod),
  allowMouseEnter: ge((e) => e.allowMouseEnter),
  stickIfOpen: ge((e) => e.stickIfOpen),
  parent: ge((e) => e.parent),
  rootId: ge((e) => e.parent.type === "menu" ? e.parent.store.select("rootId") : e.parent.type !== void 0 ? e.parent.context.rootId : e.rootId),
  activeIndex: ge((e) => e.activeIndex),
  isActive: ge((e, t) => e.activeIndex === t),
  hoverEnabled: ge((e) => e.hoverEnabled),
  instantType: ge((e) => e.instantType),
  lastOpenChangeReason: ge((e) => e.openChangeReason),
  floatingTreeRoot: ge((e) => e.parent.type === "menu" ? e.parent.store.select("floatingTreeRoot") : e.floatingTreeRoot),
  floatingNodeId: ge((e) => e.floatingNodeId),
  floatingParentNodeId: ge((e) => e.floatingParentNodeId),
  itemProps: ge((e) => e.itemProps),
  closeDelay: ge((e) => e.closeDelay),
  hasViewport: ge((e) => e.hasViewport),
  keyboardEventRelay: ge((e) => {
    if (e.keyboardEventRelay)
      return e.keyboardEventRelay;
    if (e.parent.type === "menu")
      return e.parent.store.select("keyboardEventRelay");
  })
};
class up extends Ns {
  constructor(n) {
    super({
      ...u3(),
      ...n
    }, {
      positionerRef: /* @__PURE__ */ b.createRef(),
      popupRef: /* @__PURE__ */ b.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ b.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ b.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new $s()
    }, l3);
    ae(this, "unsubscribeParentListener", null);
    this.unsubscribeParentListener = this.observe("parent", (r) => {
      var o;
      if ((o = this.unsubscribeParentListener) == null || o.call(this), r.type === "menu") {
        let s = r.store.select("rootId"), i = r.store.select("floatingTreeRoot"), a = r.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = r.store.subscribe(() => {
          const c = r.store.select("rootId"), l = r.store.select("floatingTreeRoot"), u = r.store.select("keyboardEventRelay");
          s === c && i === l && a === u || (s = c, i = l, a = u, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = r.store.context.allowMouseUpTriggerRef;
        return;
      }
      r.type !== void 0 && (this.context.allowMouseUpTriggerRef = r.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(n, r) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: n,
      eventDetails: r
    });
  }
  static useStore(n, r) {
    const o = gn(() => new up(r)).current;
    return n ?? o;
  }
}
function u3() {
  return {
    ...Bl(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new Gf(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: wt,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const dp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (dp.displayName = "MenuSubmenuRootContext");
function Lw() {
  return b.useContext(dp);
}
const fp = If(function(t) {
  const {
    children: n,
    open: r,
    onOpenChange: o,
    onOpenChangeComplete: s,
    defaultOpen: i = !1,
    disabled: a = !1,
    modal: c,
    loopFocus: l = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: h,
    triggerId: p,
    defaultTriggerId: g = null,
    highlightItemOnHover: m = !0
  } = t, y = la(!0), v = Gn(!0), w = Fw(!0), C = Lw(), x = b.useMemo(() => C && v ? {
    type: "menu",
    store: v.store
  } : w ? {
    type: "menubar",
    context: w
  } : y && !v ? {
    type: "context-menu",
    context: y
  } : {
    type: void 0
  }, [y, v, w, C]), E = up.useStore(h == null ? void 0 : h.store, {
    open: i,
    openProp: r,
    activeTriggerId: g,
    triggerIdProp: p,
    parent: x
  });
  yl(() => {
    r === void 0 && E.state.open === !1 && i === !0 && E.update({
      open: !0,
      activeTriggerId: g
    });
  }), E.useControlledProp("openProp", r), E.useControlledProp("triggerIdProp", p), E.useContextCallback("onOpenChangeComplete", s);
  const S = Br(), M = Br(), T = E.useState("floatingTreeRoot"), P = Xf(T), k = Kr(), I = E.useState("open"), O = E.useState("activeTriggerElement"), A = E.useState("positionerElement"), R = E.useState("hoverEnabled"), N = E.useState("disabled"), $ = E.useState("lastOpenChangeReason"), F = E.useState("parent"), V = E.useState("activeIndex"), D = E.useState("payload"), H = E.useState("floatingParentNodeId"), j = b.useRef(null), U = b.useRef(F.type !== "context-menu"), K = ln(), G = b.useRef(!0), B = ln(), z = H != null;
  process.env.NODE_ENV !== "production" && F.type !== void 0 && c !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: W,
    triggerProps: X
  } = bk(I);
  E.useSyncedValues({
    disabled: a,
    modal: F.type === void 0 ? c : void 0,
    openMethod: W,
    rootId: S
  }), Ll(E);
  const {
    forceUnmount: J
  } = Vl(I, E, () => {
    E.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  });
  be(() => {
    y && !v ? E.update({
      parent: {
        type: "context-menu",
        context: y
      },
      floatingNodeId: P,
      floatingParentNodeId: k
    }) : v && E.update({
      floatingNodeId: P,
      floatingParentNodeId: k
    });
  }, [y, v, P, k, E]), b.useEffect(() => {
    if (I || (j.current = null), F.type === "context-menu") {
      if (!I) {
        K.clear(), U.current = !1;
        return;
      }
      K.start(500, () => {
        U.current = !0;
      });
    }
  }, [K, I, F.type]), be(() => {
    !I && !R && E.set("hoverEnabled", !0);
  }, [I, R, E]);
  const Q = Se((re, ve) => {
    var dn;
    const xe = ve.reason;
    if (I === re && ve.trigger === O && $ === xe || (ve.preventUnmountOnClose = () => {
      E.set("preventUnmountingOnClose", !0);
    }, !re && ve.trigger == null && (ve.trigger = O ?? void 0), o == null || o(re, ve), ve.isCanceled))
      return;
    E.state.floatingRootContext.dispatchOpenChange(re, ve);
    const Me = ve.event;
    if (re === !1 && (Me == null ? void 0 : Me.type) === "click" && Me.pointerType === "touch" && !G.current)
      return;
    if (!re && V !== null) {
      const rn = E.context.itemDomElements.current[V];
      queueMicrotask(() => {
        rn == null || rn.setAttribute("tabindex", "-1");
      });
    }
    re && xe === hs ? (G.current = !1, B.start(300, () => {
      G.current = !0;
    })) : (G.current = !0, B.clear());
    const qe = (xe === br || xe === Ol) && Me.detail === 0 && (Me == null ? void 0 : Me.isTrusted), Ze = !re && (xe === Ji || xe == null), nt = {
      open: re,
      openChangeReason: xe
    };
    j.current = ve.event ?? null;
    const Kt = ((dn = ve.trigger) == null ? void 0 : dn.id) ?? null;
    (Kt || re) && (nt.activeTriggerId = Kt, nt.activeTriggerElement = ve.trigger ?? null), E.update(nt), F.type === "menubar" && (xe === hs || xe === Ho || xe === Pt || xe === $d || xe === ui) ? E.set("instantType", "group") : qe || Ze ? E.set("instantType", qe ? "click" : "dismiss") : E.set("instantType", void 0);
  }), Y = dy({
    popupStore: E,
    floatingId: M,
    nested: k != null,
    onOpenChange: Q
  }), ce = Y.context.events;
  b.useEffect(() => {
    const re = ({
      open: ve,
      eventDetails: xe
    }) => Q(ve, xe);
    return ce.on("setOpen", re), () => {
      ce == null || ce.off("setOpen", re);
    };
  }, [ce, Q]);
  const ee = b.useCallback(() => {
    E.setOpen(!1, Ve(Ml));
  }, [E]);
  b.useImperativeHandle(d, () => ({
    unmount: J,
    close: ee
  }), [J, ee]);
  let ne;
  F.type === "context-menu" && (ne = F.context), b.useImperativeHandle(ne == null ? void 0 : ne.positionerRef, () => A, [A]), b.useImperativeHandle(ne == null ? void 0 : ne.actionsRef, () => ({
    setOpen: Q
  }), [Q]);
  const de = Il(Y, {
    enabled: !N,
    bubbles: {
      escapeKey: f && F.type === "menu"
    },
    outsidePress() {
      var re;
      return F.type !== "context-menu" || ((re = j.current) == null ? void 0 : re.type) === "contextmenu" ? !0 : U.current;
    },
    externalTree: z ? T : void 0
  }), pe = fh(), Ee = b.useCallback((re) => {
    E.select("activeIndex") !== re && E.set("activeIndex", re);
  }, [E]), se = bT(Y, {
    enabled: !N,
    listRef: E.context.itemDomElements,
    activeIndex: V,
    nested: F.type !== void 0,
    loopFocus: l,
    orientation: u,
    parentOrientation: F.type === "menubar" ? F.context.orientation : void 0,
    rtl: pe === "rtl",
    disabledIndices: ys,
    onNavigate: Ee,
    openOnArrowKeyDown: F.type !== "context-menu",
    externalTree: z ? T : void 0,
    focusItemOnHover: m
  }), ke = b.useCallback((re) => {
    E.context.typingRef.current = re;
  }, [E]), we = vT(Y, {
    listRef: E.context.itemLabels,
    elementsRef: E.context.itemDomElements,
    activeIndex: V,
    resetMs: jO,
    onMatch: (re) => {
      I && re !== V && E.set("activeIndex", re);
    },
    onTyping: ke
  }), Oe = b.useMemo(() => {
    const re = Zt(we.reference, se.reference, de.reference, {
      onMouseMove() {
        E.set("allowMouseEnter", !0);
      }
    }, X);
    return re["aria-haspopup"] = "menu", re["aria-expanded"] = I, re;
  }, [E, we.reference, se.reference, de.reference, X, I]), Ie = b.useMemo(() => {
    const re = Zt(se.trigger, de.trigger, X);
    return re["aria-haspopup"] = "menu", re["aria-expanded"] = !1, re;
  }, [se.trigger, de.trigger, X]), fe = b.useMemo(() => Zt(As, {
    id: M,
    role: "menu",
    "aria-labelledby": O == null ? void 0 : O.id,
    onMouseMove() {
      E.set("allowMouseEnter", !0), F.type === "menu" && E.set("hoverEnabled", !1);
    },
    onClick() {
      E.select("hoverEnabled") && E.set("hoverEnabled", !1);
    },
    onKeyDown(re) {
      const ve = E.select("keyboardEventRelay");
      ve && !re.isPropagationStopped() && ve(re);
    }
  }, we.floating, se.floating, de.floating), [O, M, F.type, E, we.floating, se.floating, de.floating]), q = se.item ?? wt;
  Wl(E, {
    floatingRootContext: Y,
    activeTriggerProps: Oe,
    inactiveTriggerProps: Ie,
    popupProps: fe,
    itemProps: q
  });
  const te = b.useMemo(() => ({
    store: E,
    parent: x
  }), [E, x]), oe = /* @__PURE__ */ _(op.Provider, {
    value: te,
    children: typeof n == "function" ? n({
      payload: D
    }) : n
  });
  return F.type === void 0 || F.type === "context-menu" ? /* @__PURE__ */ _(ty, {
    externalTree: T,
    children: oe
  }) : oe;
});
process.env.NODE_ENV !== "production" && (fp.displayName = "MenuRoot");
function d3(e) {
  const t = Gn().store, n = b.useMemo(() => ({
    parentMenu: t
  }), [t]);
  return /* @__PURE__ */ _(dp.Provider, {
    value: n,
    children: /* @__PURE__ */ _(fp, {
      ...e
    })
  });
}
function Vw(e = {}) {
  const {
    highlightItemOnHover: t,
    highlightedIndex: n,
    onHighlightedIndexChange: r
  } = wh(), {
    ref: o,
    index: s
  } = Fs(e), i = n === s, a = b.useRef(null), c = Vr(o, a);
  return {
    compositeProps: b.useMemo(() => ({
      tabIndex: i ? 0 : -1,
      onFocus() {
        r(s);
      },
      onMouseMove() {
        const u = a.current;
        if (!t || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !i && !d && u.focus();
      }
    }), [i, r, s, t]),
    compositeRef: c,
    index: s
  };
}
function f3(e) {
  const {
    render: t,
    className: n,
    style: r,
    state: o = wt,
    props: s = ys,
    refs: i = ys,
    metadata: a,
    stateAttributesMapping: c,
    tag: l = "div",
    ...u
  } = e, {
    compositeProps: d,
    compositeRef: f
  } = Vw({
    metadata: a
  });
  return $e(l, e, {
    state: o,
    ref: [...i, f],
    props: [d, ...s, u],
    stateAttributesMapping: c
  });
}
function Ww(e) {
  if (vt(e) && e.hasAttribute("data-rootownerid"))
    return e.getAttribute("data-rootownerid") ?? void 0;
  if (!hr(e))
    return Ww(mr(e));
}
function Bw(e, t) {
  const n = b.useRef(null);
  function r(s) {
    Yn.flushSync(() => {
      e.setOpen(!1, Ve(Ho, s.nativeEvent, s.currentTarget));
    });
    const i = WO(n.current);
    i == null || i.focus();
  }
  function o(s) {
    var a;
    const i = e.select("positionerElement");
    if (i && ps(s, i))
      (a = e.context.beforeContentFocusGuardRef.current) == null || a.focus();
    else {
      Yn.flushSync(() => {
        e.setOpen(!1, Ve(Ho, s.nativeEvent, s.currentTarget));
      });
      let c = VO(e.context.triggerFocusTargetRef.current || t.current);
      for (; c !== null && Re(i, c); ) {
        const l = c;
        if (c = Yf(c), c === l)
          break;
      }
      c == null || c.focus();
    }
  }
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: r,
    handleFocusTargetFocus: o
  };
}
function h3(e) {
  const {
    enabled: t = !0,
    mouseDownAction: n,
    open: r
  } = e, o = b.useRef(!1);
  return b.useMemo(() => t ? {
    onMouseDown: (s) => {
      (n === "open" && !r || n === "close" && r) && (o.current = !0, Ye(s.currentTarget).addEventListener("click", () => {
        o.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (s) => {
      o.current && (o.current = !1, s.preventBaseUIHandler());
    }
  } : wt, [t, n, r]);
}
const qa = 2, Hw = v0(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    id: c,
    openOnHover: l,
    delay: u = 100,
    closeDelay: d = 0,
    handle: f,
    payload: h,
    ...p
  } = t, g = Gn(!0), m = (f == null ? void 0 : f.store) ?? (g == null ? void 0 : g.store);
  if (!m)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : rt(85));
  const y = nn(c), v = m.useState("isTriggerActive", y), w = m.useState("floatingRootContext"), C = m.useState("isOpenedByTrigger", y), x = m.useState("triggerPopupId", y), E = b.useRef(null), S = g3(), M = wh(!0), T = vo(), P = b.useMemo(() => T ?? new Gf(), [T]), k = Xf(P), I = Kr(), {
    registerTrigger: O,
    isMountedByThisTrigger: A
  } = Fl(y, E, m, {
    payload: h,
    closeDelay: d,
    parent: S,
    floatingTreeRoot: P,
    floatingNodeId: k,
    floatingParentNodeId: I,
    keyboardEventRelay: M == null ? void 0 : M.relayKeyboardEvent
  }), R = S.type === "menubar", N = m.useState("disabled"), $ = i || N || R && S.context.disabled, {
    getButtonProps: F,
    buttonRef: V
  } = Cr({
    disabled: $,
    native: a
  });
  b.useEffect(() => {
    !C && S.type === void 0 && (m.context.allowMouseUpTriggerRef.current = !1);
  }, [m, C, S.type]);
  const D = b.useRef(null), H = ln(), j = Se((se) => {
    if (!D.current)
      return;
    H.clear(), m.context.allowMouseUpTriggerRef.current = !1;
    const ke = se.target;
    if (Re(D.current, ke) || Re(m.select("positionerElement"), ke) || ke === D.current || ke != null && Ww(ke) === m.select("rootId"))
      return;
    const we = K6(D.current);
    se.clientX >= we.left - qa && se.clientX <= we.right + qa && se.clientY >= we.top - qa && se.clientY <= we.bottom + qa || P.events.emit("close", {
      domEvent: se,
      reason: gO
    });
  });
  b.useEffect(() => {
    C && m.select("lastOpenChangeReason") === Pt && Ye(D.current).addEventListener("mouseup", j, {
      once: !0
    });
  }, [C, j, m]);
  const U = R && S.context.hasSubmenuOpen, G = Yl(w, {
    enabled: (l ?? U) && !$ && S.type !== "context-menu" && (!R || U && !A),
    handleClose: jl({
      blockPointerEvents: !R
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? u : void 0,
    delay: {
      close: d
    },
    triggerElementRef: E,
    externalTree: P,
    isActiveTrigger: v,
    isClosing: () => m.select("transitionStatus") === "ending"
  }), B = p3(C, m.select("lastOpenChangeReason")), z = Rl(w, {
    enabled: !$ && S.type !== "context-menu",
    event: C && R ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? B : !1
  }), W = gy(w, {
    enabled: !$ && U
  }), X = h3({
    open: C,
    enabled: R,
    mouseDownAction: "open"
  }), J = b.useMemo(() => Zt(W.reference, z.reference), [W.reference, z.reference]), Q = m.useState("triggerProps", A), {
    preFocusGuardRef: Y,
    handlePreFocusGuardFocus: ce,
    handleFocusTargetFocus: ee
  } = Bw(m, E), ne = {
    disabled: $,
    open: C
  }, de = [D, n, V, O, E], pe = [J, G ?? wt, Q, {
    "aria-haspopup": "menu",
    "aria-controls": x,
    id: y,
    onMouseDown: (se) => {
      if (m.select("open"))
        return;
      H.start(200, () => {
        m.context.allowMouseUpTriggerRef.current = !0;
      }), Ye(se.currentTarget).addEventListener("mouseup", j, {
        once: !0
      });
    }
  }, R ? {
    role: "menuitem"
  } : {}, X, p, F], Ee = $e("button", t, {
    enabled: !R,
    stateAttributesMapping: zd,
    state: ne,
    ref: de,
    props: pe
  });
  return R ? /* @__PURE__ */ _(f3, {
    tag: "button",
    render: r,
    className: o,
    style: s,
    state: ne,
    refs: de,
    props: pe,
    stateAttributesMapping: zd
  }) : C ? /* @__PURE__ */ Z(b.Fragment, {
    children: [/* @__PURE__ */ _(Hn, {
      ref: Y,
      onFocus: ce
    }, `${y}-pre-focus-guard`), /* @__PURE__ */ _(b.Fragment, {
      children: Ee
    }, y), /* @__PURE__ */ _(Hn, {
      ref: m.context.triggerFocusTargetRef,
      onFocus: ee
    }, `${y}-post-focus-guard`)]
  }) : /* @__PURE__ */ _(b.Fragment, {
    children: Ee
  }, y);
});
process.env.NODE_ENV !== "production" && (Hw.displayName = "MenuTrigger");
function p3(e, t) {
  const n = ln(), [r, o] = b.useState(!1);
  return be(() => {
    e && t === "trigger-hover" ? (o(!0), n.start(X0, () => {
      o(!1);
    })) : e || (n.clear(), o(!1));
  }, [e, t, n]), r;
}
function g3() {
  const e = la(!0), t = Gn(!0), n = Fw(!0);
  return b.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : e && !t ? {
    type: "context-menu",
    context: e
  } : {
    type: void 0
  }, [e, t, n]);
}
const Yw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    label: i,
    id: a,
    nativeButton: c = !1,
    openOnHover: l = !0,
    delay: u = 100,
    closeDelay: d = 0,
    disabled: f = !1,
    ...h
  } = t, p = Fs(), g = ua(), {
    store: m
  } = Gn(), y = nn(a), v = m.useState("open"), w = m.useState("floatingRootContext"), C = m.useState("floatingTreeRoot"), x = m.useState("triggerPopupId", y), E = fy(y, m), S = b.useCallback((z) => {
    const W = E(z);
    return z !== null && m.select("open") && m.select("activeTriggerId") == null && m.update({
      activeTriggerId: y,
      activeTriggerElement: z,
      closeDelay: d
    }), W;
  }, [E, d, m, y]), M = b.useRef(null), T = b.useCallback((z) => {
    M.current = z, m.set("activeTriggerElement", z);
  }, [m]);
  process.env.NODE_ENV !== "production" && be(() => {
    var W;
    const z = M.current;
    if (z && lw(z) && !f) {
      const X = ((W = Wn.captureOwnerStack) == null ? void 0 : W.call(Wn)) || "";
      vl(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${X}`);
    }
  });
  const P = Lw();
  if (!(P != null && P.parentMenu))
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : rt(37));
  m.useSyncedValue("closeDelay", d);
  const k = P.parentMenu, I = k.useState("itemProps"), O = k.useState("isActive", p.index), A = b.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      k.set("activeIndex", p.index);
    }
  }), [k, p.index]), R = m.useState("disabled"), N = f || R, {
    getItemProps: $,
    itemRef: F
  } = au({
    closeOnClick: !1,
    disabled: N,
    highlighted: O,
    id: y,
    store: m,
    typingRef: k.context.typingRef,
    nativeButton: c,
    itemMetadata: A,
    nodeId: g == null ? void 0 : g.context.nodeId
  }), V = m.useState("hoverEnabled"), D = k.useState("allowMouseEnter"), H = Yl(w, {
    enabled: V && l && !N,
    handleClose: jl({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: u,
    delay: D ? {
      open: u,
      close: d
    } : 0,
    triggerElementRef: M,
    externalTree: C,
    isClosing: () => m.select("transitionStatus") === "ending"
  }), U = Rl(w, {
    enabled: !N,
    event: "mousedown",
    toggle: !l,
    ignoreMouse: l,
    stickIfOpen: !1
  }).reference ?? wt, K = m.useState("triggerProps", !0);
  return delete K.id, $e("div", t, {
    state: {
      disabled: N,
      highlighted: O,
      open: v
    },
    stateAttributesMapping: Ul,
    props: [U, H, K, I, {
      "aria-controls": x,
      tabIndex: v || O ? 0 : -1,
      onBlur() {
        O && k.set("activeIndex", null);
      }
    }, h, $],
    ref: [n, p.ref, F, S, T]
  });
});
process.env.NODE_ENV !== "production" && (Yw.displayName = "MenuSubmenuTrigger");
function $b(e, t, n) {
  switch (e) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -t;
    case "right":
      return t;
    default:
      return 0;
  }
}
function m3(e) {
  const n = Ot(e).getComputedStyle(e).transform;
  let r = 0, o = 0, s = 1;
  if (n && n !== "none") {
    const i = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (i) {
      const a = i[1].split(", ").map(parseFloat);
      a.length === 6 ? (r = a[4], o = a[5], s = Math.sqrt(a[0] * a[0] + a[1] * a[1])) : a.length === 16 && (r = a[12], o = a[13], s = a[0]);
    }
  }
  return {
    x: r,
    y: o,
    scale: s
  };
}
const zw = "data-composite-item-active", b3 = [];
function v3(e) {
  const {
    itemSizes: t,
    cols: n = 1,
    loopFocus: r = !0,
    onLoop: o,
    dense: s = !1,
    orientation: i = "both",
    direction: a,
    highlightedIndex: c,
    onHighlightedIndexChange: l,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: h,
    modifierKeys: p = b3
  } = e, [g, m] = b.useState(0), y = n > 1, v = b.useRef(null), w = Vr(v, u), C = b.useRef([]), x = b.useRef(!1), E = c ?? g, S = Se((k, I = !1) => {
    if ((l ?? m)(k), I) {
      const O = C.current[k];
      Qg(v.current, O, a, i);
    }
  }), M = Se((k) => {
    if (k.size === 0 || x.current)
      return;
    x.current = !0;
    const I = Array.from(k.keys()), O = I.find((R) => R == null ? void 0 : R.hasAttribute(zw)) ?? null, A = O ? I.indexOf(O) : -1;
    A !== -1 && S(A), Qg(v.current, O, a, i);
  }), T = Se((k, I, O) => o ? o == null ? void 0 : o(k, I, O, C) : O), P = b.useMemo(() => ({
    "aria-orientation": i === "both" ? void 0 : i,
    ref: w,
    onFocus(k) {
      const I = v.current, O = Dt(k.nativeEvent);
      !I || O == null || !Zg(O) || O.setSelectionRange(0, O.value.length ?? 0);
    },
    onKeyDown(k) {
      const I = d ? Zl : Iy;
      if (!I.has(k.key) || y3(k, p) || !v.current)
        return;
      const A = a === "rtl", R = A ? Wc : Ei, N = {
        horizontal: R,
        vertical: ls,
        both: R
      }[i], $ = A ? Ei : Wc, F = {
        horizontal: $,
        vertical: Ci,
        both: $
      }[i], V = Dt(k.nativeEvent);
      if (V != null && Zg(V) && !lw(V)) {
        const B = V.selectionStart, z = V.selectionEnd, W = V.value ?? "";
        if (B == null || k.shiftKey || B !== z || k.key !== F && B < W.length || k.key !== N && B > 0)
          return;
      }
      let D = E;
      const H = lc(C, h), j = Vd(C, h);
      if (y) {
        const B = t || Array.from({
          length: C.current.length
        }, () => ({
          width: 1,
          height: 1
        })), z = $0(B, n, s), W = z.findIndex((J) => J != null && !Fr(C.current, J, h)), X = z.reduce((J, Q, Y) => Q != null && !Fr(C.current, Q, h) ? Y : J, -1);
        D = z[A0(z.map((J) => J != null ? C.current[J] : null), {
          event: k,
          orientation: i,
          loopFocus: r,
          onLoop: T,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: L0([...h || C.current.map((J, Q) => Fr(C.current, Q) ? Q : void 0), void 0], z),
          minIndex: W,
          maxIndex: X,
          prevIndex: F0(
            E > j ? H : E,
            B,
            z,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            k.key === ls ? "bl" : k.key === Ei ? "tr" : "tl"
          ),
          rtl: A
        })];
      }
      const U = {
        horizontal: [R],
        vertical: [ls],
        both: [R, ls]
      }[i], K = {
        horizontal: [$],
        vertical: [Ci],
        both: [$, Ci]
      }[i], G = y ? I : {
        horizontal: d ? qT : Py,
        vertical: d ? XT : Ry,
        both: I
      }[i];
      d && (k.key === ql ? D = H : k.key === Xl && (D = j)), D === E && (U.includes(k.key) || K.includes(k.key)) && (r && D === j && U.includes(k.key) ? (D = H, o && (D = o(k, E, D, C))) : r && D === H && K.includes(k.key) ? (D = j, o && (D = o(k, E, D, C))) : D = sn(C.current, {
        startingIndex: D,
        decrement: K.includes(k.key),
        disabledIndices: h
      })), D !== E && !$i(C.current, D) && (f && k.stopPropagation(), G.has(k.key) && k.preventDefault(), S(D, !0), queueMicrotask(() => {
        var B;
        (B = C.current[D]) == null || B.focus();
      }));
    }
  }), [n, s, a, h, C, d, E, y, t, r, o, T, w, p, S, i, f]);
  return b.useMemo(() => ({
    props: P,
    highlightedIndex: E,
    onHighlightedIndexChange: S,
    elementsRef: C,
    disabledIndices: h,
    onMapChange: M,
    relayKeyboardEvent: P.onKeyDown
  }), [P, E, S, C, h, M]);
}
function y3(e, t) {
  for (const n of tk.values())
    if (!t.includes(n) && e.getModifierState(n))
      return !0;
  return !1;
}
function w3(e) {
  const {
    render: t,
    className: n,
    style: r,
    refs: o = ys,
    props: s = ys,
    state: i = wt,
    stateAttributesMapping: a,
    highlightedIndex: c,
    onHighlightedIndexChange: l,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: h,
    onLoop: p,
    cols: g,
    enableHomeAndEndKeys: m,
    onMapChange: y,
    stopEventPropagation: v = !0,
    rootRef: w,
    disabledIndices: C,
    modifierKeys: x,
    highlightItemOnHover: E = !1,
    tag: S = "div",
    ...M
  } = e, T = fh(), {
    props: P,
    highlightedIndex: k,
    onHighlightedIndexChange: I,
    elementsRef: O,
    onMapChange: A,
    relayKeyboardEvent: R
  } = v3({
    itemSizes: f,
    cols: g,
    loopFocus: h,
    onLoop: p,
    dense: d,
    orientation: u,
    highlightedIndex: c,
    onHighlightedIndexChange: l,
    rootRef: w,
    stopEventPropagation: v,
    enableHomeAndEndKeys: m,
    direction: T,
    disabledIndices: C,
    modifierKeys: x
  }), N = $e(S, e, {
    state: i,
    ref: o,
    props: [P, ...s, M],
    stateAttributesMapping: a
  }), $ = b.useMemo(() => ({
    highlightedIndex: k,
    onHighlightedIndexChange: I,
    highlightItemOnHover: E,
    relayKeyboardEvent: R
  }), [k, I, E, R]);
  return /* @__PURE__ */ _(yh.Provider, {
    value: $,
    children: /* @__PURE__ */ _(ep, {
      elementsRef: O,
      onMapChange: (F) => {
        y == null || y(F), A(F);
      },
      children: N
    })
  });
}
const Fb = /* @__PURE__ */ new Map();
function x3(e, t) {
  const n = JSON.stringify({
    locale: e,
    options: t
  }), r = Fb.get(n);
  if (r)
    return r;
  const o = new Intl.NumberFormat(e, t);
  return Fb.set(n, o), o;
}
function Lb(e, t, n) {
  return e == null ? "" : x3(t, n).format(e);
}
function C3(e, t, n) {
  return e == null ? "" : n ? Lb(e, t, n) : Lb(e / 100, t, {
    style: "percent"
  });
}
function E3(e, t, n) {
  return (e - t) * 100 / (n - t);
}
const hp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (hp.displayName = "PopoverRootContext");
function da(e) {
  const t = b.useContext(hp);
  if (t === void 0 && !e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : rt(47));
  return t;
}
function _3() {
  return {
    ...Bl(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const S3 = {
  ...Hl,
  disabled: ge((e) => e.disabled),
  instantType: ge((e) => e.instantType),
  openMethod: ge((e) => e.openMethod),
  openChangeReason: ge((e) => e.openChangeReason),
  modal: ge((e) => e.modal),
  focusManagerModal: ge((e) => e.focusManagerModal),
  stickIfOpen: ge((e) => e.stickIfOpen),
  titleElementId: ge((e) => e.titleElementId),
  descriptionElementId: ge((e) => e.descriptionElementId),
  openOnHover: ge((e) => e.openOnHover),
  closeDelay: ge((e) => e.closeDelay),
  hasViewport: ge((e) => e.hasViewport)
};
class pp extends Ns {
  constructor(n, r, o = !1) {
    const s = {
      ..._3(),
      ...n
    }, i = new $s();
    s.open && (n == null ? void 0 : n.mounted) === void 0 && (s.mounted = !0), s.floatingRootContext = nh(i, r, o);
    super(s, {
      popupRef: /* @__PURE__ */ b.createRef(),
      backdropRef: /* @__PURE__ */ b.createRef(),
      internalBackdropRef: /* @__PURE__ */ b.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ b.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ b.createRef(),
      stickIfOpenTimeout: new xn(),
      triggerElements: i
    }, S3);
    ae(this, "setOpen", (n, r) => {
      var l, u;
      const o = r.reason === Pt, s = r.reason === br && r.event.detail === 0, i = !n && (r.reason === Ji || r.reason == null);
      r.preventUnmountOnClose = () => {
        this.set("preventUnmountingOnClose", !0);
      };
      const a = this.select("activeTriggerId");
      if (!n && r.reason === R0 && r.trigger == null && a != null && (r.trigger = this.context.triggerElements.getById(a) ?? this.select("activeTriggerElement") ?? void 0), (u = (l = this.context).onOpenChange) == null || u.call(l, n, r), r.isCanceled)
        return;
      this.state.floatingRootContext.dispatchOpenChange(n, r);
      const c = () => {
        const d = {
          open: n,
          openChangeReason: r.reason
        };
        th(d, n, r.trigger), this.update(d);
      };
      o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(X0, () => {
        this.set("stickIfOpen", !1);
      }), Yn.flushSync(c)) : c(), s || i ? this.set("instantType", s ? "click" : "dismiss") : r.reason === Ho ? this.set("instantType", "focus") : this.set("instantType", void 0);
    });
    ae(this, "disposeEffect", () => this.context.stickIfOpenTimeout.disposeEffect());
  }
  static useStore(n, r) {
    const {
      store: o,
      internalStore: s
    } = eh(n, (i, a) => new pp(r, i, a));
    return b.useEffect(() => s == null ? void 0 : s.disposeEffect(), [s]), o;
  }
}
function Vb({
  props: e
}) {
  const {
    children: t,
    open: n,
    defaultOpen: r = !1,
    onOpenChange: o,
    onOpenChangeComplete: s,
    modal: i = !1,
    handle: a,
    triggerId: c,
    defaultTriggerId: l = null
  } = e, u = pp.useStore(a == null ? void 0 : a.store, {
    modal: i,
    open: r,
    openProp: n,
    activeTriggerId: l,
    triggerIdProp: c
  });
  yl(() => {
    n === void 0 && u.state.open === !1 && r === !0 && u.update({
      open: !0,
      activeTriggerId: l
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", c);
  const d = u.useState("open"), f = u.useState("mounted"), h = u.useState("payload"), p = Kr() != null;
  u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", s), hy(u, d), Ll(u);
  const {
    forceUnmount: g
  } = Vl(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  u.useSyncedValues({
    modal: i,
    nested: p
  }), b.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const m = b.useCallback(() => {
    u.setOpen(!1, Ve(Ml));
  }, [u]);
  b.useImperativeHandle(e.actionsRef, () => ({
    unmount: g,
    close: m
  }), [g, m]);
  const y = d || f, v = b.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ Z(hp.Provider, {
    value: v,
    children: [y && /* @__PURE__ */ _(M3, {
      store: u,
      modal: i
    }), typeof t == "function" ? t({
      payload: h
    }) : t]
  });
}
function O3(e) {
  return da(!0) ? /* @__PURE__ */ _(Vb, {
    props: e
  }) : /* @__PURE__ */ _(ty, {
    children: /* @__PURE__ */ _(Vb, {
      props: e
    })
  });
}
function M3({
  store: e,
  modal: t
}) {
  const n = e.useState("floatingRootContext"), r = Il(n, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: t === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), o = r.reference ?? wt, s = r.trigger ?? wt, i = b.useMemo(() => Zt(As, r.floating), [r.floating]);
  return Wl(e, {
    activeTriggerProps: o,
    inactiveTriggerProps: s,
    popupProps: i
  }), null;
}
const T3 = 300, jw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i = !1,
    nativeButton: a = !0,
    handle: c,
    payload: l,
    openOnHover: u = !1,
    delay: d = T3,
    closeDelay: f = 0,
    id: h,
    ...p
  } = t, g = da(!0), m = (c == null ? void 0 : c.store) ?? (g == null ? void 0 : g.store);
  if (!m)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : rt(74));
  const y = nn(h), v = m.useState("isTriggerActive", y), w = m.useState("floatingRootContext"), C = m.useState("isOpenedByTrigger", y), x = m.useState("triggerPopupId", y), E = b.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: M
  } = Fl(y, E, m, {
    payload: l,
    disabled: i,
    openOnHover: u,
    closeDelay: f
  }), T = m.useState("openChangeReason"), P = m.useState("stickIfOpen"), k = m.useState("openMethod"), I = m.useState("focusManagerModal"), O = Yl(w, {
    enabled: w != null && u && (k !== "touch" || T !== br),
    mouseOnly: !0,
    move: !1,
    handleClose: jl(),
    restMs: d,
    delay: {
      close: f
    },
    triggerElementRef: E,
    isActiveTrigger: v,
    isClosing: () => m.select("transitionStatus") === "ending"
  }), A = Rl(w, {
    enabled: w != null,
    stickIfOpen: P
  }), R = Th(() => m.select("open"), (G) => {
    m.set("openMethod", G);
  }), N = m.useState("triggerProps", M), {
    getButtonProps: $,
    buttonRef: F
  } = Cr({
    disabled: i,
    native: a
  }), V = {
    open(G) {
      return G && T === br ? zd.open(G) : Ul.open(G);
    }
  }, {
    preFocusGuardRef: D,
    handlePreFocusGuardFocus: H,
    handleFocusTargetFocus: j
  } = Bw(m, E), K = $e("button", t, {
    state: {
      disabled: i,
      open: C
    },
    ref: [F, n, S, E],
    props: [A.reference, O, N, R, {
      [zf]: "",
      id: y,
      "aria-haspopup": "dialog",
      "aria-expanded": C,
      "aria-controls": x
    }, p, $],
    stateAttributesMapping: V
  });
  return M && !I ? /* @__PURE__ */ Z(b.Fragment, {
    children: [/* @__PURE__ */ _(Hn, {
      ref: D,
      onFocus: H
    }), /* @__PURE__ */ _(b.Fragment, {
      children: K
    }, y), /* @__PURE__ */ _(Hn, {
      ref: m.context.triggerFocusTargetRef,
      onFocus: j
    })]
  }) : /* @__PURE__ */ _(b.Fragment, {
    children: K
  }, y);
});
process.env.NODE_ENV !== "production" && (jw.displayName = "PopoverTrigger");
const gp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (gp.displayName = "PopoverPortalContext");
function k3() {
  const e = b.useContext(gp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : rt(45));
  return e;
}
const Uw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    keepMounted: r = !1,
    ...o
  } = t, {
    store: s
  } = da();
  return s.useState("mounted") || r ? /* @__PURE__ */ _(gp.Provider, {
    value: r,
    children: /* @__PURE__ */ _(Pl, {
      ref: n,
      ...o
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Uw.displayName = "PopoverPortal");
const mp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (mp.displayName = "PopoverPositionerContext");
function P3() {
  const e = b.useContext(mp);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : rt(46));
  return e;
}
const Gw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    anchor: i,
    positionMethod: a = "absolute",
    side: c = "bottom",
    align: l = "center",
    sideOffset: u = 0,
    alignOffset: d = 0,
    collisionBoundary: f = "clipping-ancestors",
    collisionPadding: h = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: m = !1,
    collisionAvoidance: y = jf,
    ...v
  } = t, {
    store: w
  } = da(), C = k3(), x = Xf(), E = w.useState("floatingRootContext"), S = w.useState("mounted"), M = w.useState("open"), T = w.useState("openChangeReason"), P = w.useState("activeTriggerElement"), k = w.useState("modal"), I = w.useState("openMethod"), O = w.useState("positionerElement"), A = w.useState("instantType"), R = w.useState("transitionStatus"), N = w.useState("hasViewport"), $ = b.useRef(null), F = $l(O, !1, !1), V = ph({
    anchor: i,
    floatingRootContext: E,
    positionMethod: a,
    mounted: S,
    side: c,
    sideOffset: u,
    align: l,
    alignOffset: d,
    arrowPadding: p,
    collisionBoundary: f,
    collisionPadding: h,
    sticky: g,
    disableAnchorTracking: m,
    keepMounted: C,
    nodeId: x,
    collisionAvoidance: y,
    adaptiveOrigin: N ? hh : void 0
  }), D = E.useState("domReferenceElement");
  be(() => {
    const K = D, G = $.current;
    if (K && ($.current = K), G && K && K !== G) {
      w.set("instantType", void 0);
      const B = new AbortController();
      return F(() => {
        w.set("instantType", "trigger-change");
      }, B.signal), () => {
        B.abort();
      };
    }
  }, [D, F, w]), gw(M && k === !0 && T !== Pt, I === "touch", O, P);
  const H = b.useCallback((K) => {
    w.set("positionerElement", K);
  }, [w]), j = {
    open: M,
    side: V.side,
    align: V.align,
    anchorHidden: V.anchorHidden,
    instant: A
  }, U = gh(t, j, {
    styles: V.positionerStyles,
    transitionStatus: R,
    props: v,
    refs: [n, H],
    hidden: !S,
    inert: !M
  });
  return /* @__PURE__ */ Z(mp.Provider, {
    value: V,
    children: [S && k === !0 && T !== Pt && /* @__PURE__ */ _(Ql, {
      ref: w.context.internalBackdropRef,
      inert: na(!M),
      cutout: P
    }), /* @__PURE__ */ _(ey, {
      id: x,
      children: U
    })]
  });
});
process.env.NODE_ENV !== "production" && (Gw.displayName = "PopoverPositioner");
const Kw = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Kw.displayName = "ClosePartContext");
function R3() {
  const [e, t] = b.useState(0), n = Se(() => (t((o) => o + 1), () => {
    t((o) => Math.max(0, o - 1));
  }));
  return {
    context: b.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: e > 0
  };
}
function I3(e) {
  const {
    value: t,
    children: n
  } = e;
  return /* @__PURE__ */ _(Kw.Provider, {
    value: t,
    children: n
  });
}
const D3 = {
  ...qr,
  ...Un
}, qw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    initialFocus: i,
    finalFocus: a,
    ...c
  } = t, {
    store: l
  } = da(), u = P3(), d = kw(!0) != null, {
    context: f,
    hasClosePart: h
  } = R3(), p = l.useState("open"), g = l.useState("openMethod"), m = l.useState("instantType"), y = l.useState("transitionStatus"), v = l.useState("popupProps"), w = l.useState("titleElementId"), C = l.useState("descriptionElementId"), x = l.useState("modal"), E = l.useState("mounted"), S = l.useState("openChangeReason"), M = l.useState("activeTriggerElement"), T = l.useState("floatingRootContext"), P = T.useState("floatingId"), k = l.useState("disabled"), I = l.useState("openOnHover"), O = l.useState("closeDelay"), A = c.id ?? P;
  xr({
    open: p,
    ref: l.context.popupRef,
    onComplete() {
      var H, j;
      p && ((j = (H = l.context).onOpenChangeComplete) == null || j.call(H, !0));
    }
  }), ih(T, {
    enabled: I && !k,
    closeDelay: O
  });
  function R(H) {
    return H === "touch" ? l.context.popupRef.current : !0;
  }
  const N = i === void 0 ? R : i, $ = x !== !1 && h;
  l.useSyncedValue("focusManagerModal", $);
  const F = b.useCallback((H) => {
    l.set("popupElement", H);
  }, [l]), V = {
    open: p,
    side: u.side,
    align: u.align,
    instant: m,
    transitionStatus: y
  }, D = $e("div", t, {
    state: V,
    ref: [n, l.context.popupRef, F],
    props: [v, {
      id: A,
      role: "dialog",
      ...As,
      "aria-labelledby": w,
      "aria-describedby": C,
      onKeyDown(H) {
        d && Zl.has(H.key) && H.stopPropagation();
      }
    }, Gl(y), c],
    stateAttributesMapping: D3
  });
  return /* @__PURE__ */ _(Qf, {
    context: T,
    openInteractionType: g,
    modal: $,
    disabled: !E || S === Pt,
    initialFocus: N,
    returnFocus: a,
    restoreFocus: "popup",
    previousFocusableElement: vt(M) ? M : void 0,
    nextFocusableElement: l.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: l.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ _(I3, {
      value: f,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (qw.displayName = "PopoverPopup");
const bp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (bp.displayName = "ProgressRootContext");
function uu() {
  const e = b.useContext(bp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : rt(51));
  return e;
}
let ed = /* @__PURE__ */ function(e) {
  return e.complete = "data-complete", e.indeterminate = "data-indeterminate", e.progressing = "data-progressing", e;
}({});
const fa = {
  status(e) {
    return e === "progressing" ? {
      [ed.progressing]: ""
    } : e === "complete" ? {
      [ed.complete]: ""
    } : e === "indeterminate" ? {
      [ed.indeterminate]: ""
    } : null;
  }
};
function N3(e, t) {
  return t == null ? "indeterminate progress" : e || `${t}%`;
}
const Xw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    format: r,
    getAriaValueText: o = N3,
    locale: s,
    max: i = 100,
    min: a = 0,
    value: c,
    render: l,
    className: u,
    children: d,
    style: f,
    ...h
  } = t, [p, g] = b.useState(), m = Yt(r);
  let y = "indeterminate";
  Number.isFinite(c) && (y = c === i ? "complete" : "progressing");
  const v = C3(c, s, m.current), w = b.useMemo(() => ({
    status: y
  }), [y]), C = {
    "aria-labelledby": p,
    "aria-valuemax": i,
    "aria-valuemin": a,
    "aria-valuenow": c ?? void 0,
    "aria-valuetext": o(v, c),
    role: "progressbar",
    children: /* @__PURE__ */ Z(b.Fragment, {
      children: [d, /* @__PURE__ */ _("span", {
        role: "presentation",
        style: Tl,
        children: "x"
      })]
    })
  }, x = b.useMemo(() => ({
    formattedValue: v,
    max: i,
    min: a,
    setLabelId: g,
    state: w,
    status: y,
    value: c
  }), [v, i, a, g, w, y, c]), E = $e("div", t, {
    state: w,
    ref: n,
    props: [C, h],
    stateAttributesMapping: fa
  });
  return /* @__PURE__ */ _(bp.Provider, {
    value: x,
    children: E
  });
});
process.env.NODE_ENV !== "production" && (Xw.displayName = "ProgressRoot");
const Zw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    state: a
  } = uu();
  return $e("div", t, {
    state: a,
    ref: n,
    props: i,
    stateAttributesMapping: fa
  });
});
process.env.NODE_ENV !== "production" && (Zw.displayName = "ProgressTrack");
const Qw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    max: a,
    min: c,
    value: l,
    state: u
  } = uu(), d = Number.isFinite(l) && l !== null ? E3(l, c, a) : null, f = d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  };
  return $e("div", t, {
    state: u,
    ref: n,
    props: [{
      style: f
    }, i],
    stateAttributesMapping: fa
  });
});
process.env.NODE_ENV !== "production" && (Qw.displayName = "ProgressIndicator");
const Jw = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    render: o,
    children: s,
    style: i,
    ...a
  } = t, {
    value: c,
    formattedValue: l,
    state: u
  } = uu(), d = c == null ? "indeterminate" : l, f = c == null ? null : l;
  return $e("span", t, {
    state: u,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: typeof s == "function" ? s(d, c) : f
    }, a],
    stateAttributesMapping: fa
  });
});
process.env.NODE_ENV !== "production" && (Jw.displayName = "ProgressValue");
const ex = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    ...a
  } = t, {
    setLabelId: c,
    state: l
  } = uu(), u = e3(i, c);
  return $e("span", t, {
    state: l,
    ref: n,
    props: [{
      id: u,
      role: "presentation"
    }, a],
    stateAttributesMapping: fa
  });
});
process.env.NODE_ENV !== "production" && (ex.displayName = "ProgressLabel");
const vp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (vp.displayName = "SwitchRootContext");
function A3() {
  const e = b.useContext(vp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : rt(63));
  return e;
}
let Wb = /* @__PURE__ */ function(e) {
  return e.checked = "data-checked", e.unchecked = "data-unchecked", e.disabled = "data-disabled", e.readonly = "data-readonly", e.required = "data-required", e.valid = "data-valid", e.invalid = "data-invalid", e.touched = "data-touched", e.dirty = "data-dirty", e.filled = "data-filled", e.focused = "data-focused", e;
}({});
const tx = {
  ...Y6,
  checked(e) {
    return e ? {
      [Wb.checked]: ""
    } : {
      [Wb.unchecked]: ""
    };
  }
}, nx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    checked: r,
    className: o,
    defaultChecked: s,
    "aria-labelledby": i,
    form: a,
    id: c,
    inputRef: l,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: h = !1,
    required: p = !1,
    disabled: g = !1,
    render: m,
    uncheckedValue: y,
    value: v,
    style: w,
    ...C
  } = t, {
    clearErrors: x
  } = U6(), {
    state: E,
    setTouched: S,
    setDirty: M,
    validityData: T,
    setFilled: P,
    setFocused: k,
    shouldValidateOnChange: I,
    validationMode: O,
    disabled: A,
    name: R,
    validation: N
  } = dw(), {
    labelId: $
  } = pw(), F = A || g, V = R ?? u, D = b.useRef(null), H = Vr(D, l, N.inputRef), j = b.useRef(null), U = nn(), K = G6({
    id: c,
    implicit: !1,
    controlRef: j
  }), G = d ? void 0 : K, [B, z] = ca({
    controlled: r,
    default: !!s,
    name: "Switch",
    state: "checked"
  });
  j6(j, U, B), be(() => {
    D.current && P(D.current.checked);
  }, [D, P]), Ay(B, () => {
    x(V), M(B !== T.initialValue), P(B), I() ? N.commit(B) : N.commit(B, !0);
  });
  const {
    getButtonProps: W,
    buttonRef: X
  } = Cr({
    disabled: F,
    native: d
  }), J = X6(i, $, D, !d, G), Q = {
    id: d ? K : U,
    role: "switch",
    "aria-checked": B,
    "aria-readonly": h || void 0,
    "aria-required": p || void 0,
    "aria-labelledby": J,
    onFocus() {
      F || k(!0);
    },
    onBlur() {
      const ne = D.current;
      !ne || F || (S(!0), k(!1), O === "onBlur" && N.commit(ne.checked));
    },
    onClick(ne) {
      if (h || F)
        return;
      ne.preventDefault();
      const de = D.current;
      de && de.dispatchEvent(new (Ot(de)).PointerEvent("click", {
        bubbles: !0,
        shiftKey: ne.shiftKey,
        ctrlKey: ne.ctrlKey,
        altKey: ne.altKey,
        metaKey: ne.metaKey
      }));
    }
  }, Y = Zt(
    {
      checked: B,
      disabled: F,
      form: a,
      id: G,
      name: V,
      required: p,
      style: V ? EO : Tl,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: H,
      onChange(ne) {
        if (ne.nativeEvent.defaultPrevented)
          return;
        if (h) {
          ne.preventDefault();
          return;
        }
        const de = ne.currentTarget.checked, pe = Ve(xs, ne.nativeEvent);
        f == null || f(de, pe), !pe.isCanceled && z(de);
      },
      onFocus() {
        var ne;
        (ne = j.current) == null || ne.focus();
      }
    },
    N.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    v !== void 0 ? {
      value: v
    } : wt
  ), ce = b.useMemo(() => ({
    ...E,
    checked: B,
    disabled: F,
    readOnly: h,
    required: p
  }), [E, B, F, h, p]), ee = $e("span", t, {
    state: ce,
    ref: [n, j, X],
    props: [Q, N.getValidationProps, C, W],
    stateAttributesMapping: tx
  });
  return /* @__PURE__ */ Z(vp.Provider, {
    value: ce,
    children: [ee, !B && V && y !== void 0 && /* @__PURE__ */ _("input", {
      type: "hidden",
      form: a,
      name: V,
      value: y
    }), /* @__PURE__ */ _("input", {
      ...Y,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (nx.displayName = "SwitchRoot");
const rx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, a = A3();
  return $e("span", t, {
    state: a,
    ref: n,
    stateAttributesMapping: tx,
    props: i
  });
});
process.env.NODE_ENV !== "production" && (rx.displayName = "SwitchThumb");
const yp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (yp.displayName = "TabsRootContext");
function wp() {
  const e = b.useContext(yp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : rt(64));
  return e;
}
let $3 = /* @__PURE__ */ function(e) {
  return e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e;
}({});
const xp = {
  tabActivationDirection: (e) => ({
    [$3.activationDirection]: e
  })
}, ox = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    defaultValue: o = 0,
    onValueChange: s,
    orientation: i = "horizontal",
    render: a,
    value: c,
    style: l,
    ...u
  } = t, d = t.defaultValue !== void 0, f = b.useRef([]), [h, p] = b.useState(() => /* @__PURE__ */ new Map()), [g, m] = ca({
    controlled: c,
    default: o,
    name: "Tabs",
    state: "value"
  }), y = c !== void 0, [v, w] = b.useState(() => /* @__PURE__ */ new Map()), C = b.useCallback((z) => {
    if (z === void 0)
      return null;
    for (const [W, X] of v.entries())
      if (X != null && z === (X.value ?? X.index))
        return W;
    return null;
  }, [v]), [x, E] = b.useState(() => ({
    previousValue: g,
    tabActivationDirection: "none"
  })), {
    previousValue: S,
    tabActivationDirection: M
  } = x;
  let T = M, P = !1;
  S !== g && (T = Bb(S, g, i, v), P = S != null && g != null && C(g) == null);
  const k = P ? S : g, I = S !== k || M !== T;
  be(() => {
    I && E({
      previousValue: k,
      tabActivationDirection: T
    });
  }, [k, I, T]);
  const O = Se((z, W) => {
    const X = Bb(g, z, i, v);
    W.activationDirection = X, s == null || s(z, W), !W.isCanceled && m(z);
  }), A = Se((z, W) => {
    s == null || s(z, Ve(W, void 0, void 0, {
      activationDirection: "none"
    }));
  }), R = Se((z, W) => {
    p((X) => {
      if (X.get(z) === W)
        return X;
      const J = new Map(X);
      return J.set(z, W), J;
    });
  }), N = Se((z, W) => {
    p((X) => {
      if (!X.has(z) || X.get(z) !== W)
        return X;
      const J = new Map(X);
      return J.delete(z), J;
    });
  }), $ = b.useCallback((z) => h.get(z), [h]), F = b.useCallback((z) => {
    for (const W of v.values())
      if (z === (W == null ? void 0 : W.value))
        return W == null ? void 0 : W.id;
  }, [v]), V = b.useMemo(() => ({
    getTabElementBySelectedValue: C,
    getTabIdByPanelValue: F,
    getTabPanelIdByValue: $,
    onValueChange: O,
    orientation: i,
    registerMountedTabPanel: R,
    setTabMap: w,
    unregisterMountedTabPanel: N,
    tabActivationDirection: T,
    value: g
  }), [C, F, $, O, i, R, w, N, T, g]), D = b.useMemo(() => {
    for (const z of v.values())
      if (z != null && z.value === g)
        return z;
  }, [v, g]), H = b.useMemo(() => {
    for (const z of v.values())
      if (z != null && !z.disabled)
        return z.value;
  }, [v]), j = b.useRef(!d), U = b.useRef(d), K = b.useRef(!1);
  be(() => {
    if (y)
      return;
    function z(Q, Y) {
      m(Q), E((ce) => ce.previousValue === Q && ce.tabActivationDirection === "none" ? ce : {
        previousValue: Q,
        tabActivationDirection: "none"
      }), A(Q, Y), j.current = !1;
    }
    if (v.size === 0) {
      if (!K.current || g === null)
        return;
      z(null, bg);
      return;
    }
    K.current = !0;
    const W = D == null ? void 0 : D.disabled, X = D == null && g !== null;
    if (!W && g === o && (U.current = !1), U.current && W && g === o)
      return;
    const J = j.current;
    if (W || X) {
      const Q = H ?? null;
      if (g === Q) {
        j.current = !1;
        return;
      }
      let Y = bg;
      J ? Y = vg : W && (Y = I0), z(Q, Y);
      return;
    }
    J && D != null && (A(g, vg), j.current = !1);
  }, [o, H, y, A, D, m, v, g]);
  const B = $e("div", t, {
    state: {
      orientation: i,
      tabActivationDirection: T
    },
    ref: n,
    props: u,
    stateAttributesMapping: xp
  });
  return /* @__PURE__ */ _(yp.Provider, {
    value: V,
    children: /* @__PURE__ */ _(ep, {
      elementsRef: f,
      children: B
    })
  });
});
process.env.NODE_ENV !== "production" && (ox.displayName = "TabsRoot");
function Bb(e, t, n, r) {
  if (e == null || t == null)
    return "none";
  let o = null, s = null;
  for (const [c, l] of r.entries()) {
    if (l == null)
      continue;
    const u = l.value ?? l.index;
    if (e === u && (o = c), t === u && (s = c), o != null && s != null)
      break;
  }
  if (o == null || s == null)
    return o !== s && (typeof e == "number" || typeof e == "string") && typeof e == typeof t ? n === "horizontal" ? t > e ? "right" : "left" : t > e ? "down" : "up" : "none";
  const i = o.getBoundingClientRect(), a = s.getBoundingClientRect();
  if (n === "horizontal") {
    if (a.left < i.left)
      return "left";
    if (a.left > i.left)
      return "right";
  } else {
    if (a.top < i.top)
      return "up";
    if (a.top > i.top)
      return "down";
  }
  return "none";
}
const Cp = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cp.displayName = "TabsListContext");
function F3() {
  const e = b.useContext(Cp);
  if (e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : rt(65));
  return e;
}
const sx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o = !1,
    render: s,
    value: i,
    id: a,
    nativeButton: c = !0,
    style: l,
    ...u
  } = t, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: h
  } = wp(), {
    activateOnFocus: p,
    highlightedTabIndex: g,
    onTabActivation: m,
    registerTabResizeObserverElement: y,
    setHighlightedTabIndex: v,
    tabsListElement: w
  } = F3(), C = nn(a), x = b.useMemo(() => ({
    disabled: o,
    id: C,
    value: i
  }), [o, C, i]), {
    compositeProps: E,
    compositeRef: S,
    index: M
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = Vw({
    metadata: x
  }), T = i === d, P = b.useRef(!1), k = b.useRef(null);
  b.useEffect(() => {
    const j = k.current;
    if (j)
      return y(j);
  }, [y]), be(() => {
    if (P.current) {
      P.current = !1;
      return;
    }
    if (!(T && M > -1 && g !== M))
      return;
    const j = w;
    if (j != null) {
      const U = Xt(Ye(j));
      if (U && Re(j, U))
        return;
    }
    o || v(M);
  }, [T, M, g, v, o, w]);
  const {
    getButtonProps: I,
    buttonRef: O
  } = Cr({
    disabled: o,
    native: c,
    focusableWhenDisabled: !0
  }), A = f(i), R = b.useRef(!1), N = b.useRef(!1);
  function $(j) {
    T || o || m(i, Ve(xs, j.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function F(j) {
    T || (M > -1 && !o && v(M), !o && p && (!R.current || // keyboard or touch focus
    R.current && N.current) && m(i, Ve(xs, j.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function V(j) {
    if (T || o)
      return;
    R.current = !0;
    function U() {
      R.current = !1, N.current = !1;
    }
    (!j.button || j.button === 0) && (N.current = !0, Ye(j.currentTarget).addEventListener("pointerup", U, {
      once: !0
    }));
  }
  return $e("button", t, {
    state: {
      disabled: o,
      active: T,
      orientation: h
    },
    ref: [n, O, S, k],
    props: [E, {
      role: "tab",
      "aria-controls": A,
      "aria-selected": T,
      id: C,
      onClick: $,
      onFocus: F,
      onPointerDown: V,
      [zw]: T ? "" : void 0,
      onKeyDownCapture() {
        P.current = !0;
      }
    }, u, I]
  });
});
process.env.NODE_ENV !== "production" && (sx.displayName = "TabsTab");
let L3 = function(e) {
  return e.index = "data-index", e.activationDirection = "data-activation-direction", e.orientation = "data-orientation", e.hidden = "data-hidden", e[e.startingStyle = Hr.startingStyle] = "startingStyle", e[e.endingStyle = Hr.endingStyle] = "endingStyle", e;
}({});
const V3 = {
  ...xp,
  ...Un
}, ix = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    className: r,
    value: o,
    render: s,
    keepMounted: i = !1,
    style: a,
    ...c
  } = t, {
    value: l,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: h,
    unregisterMountedTabPanel: p
  } = wp(), g = nn(), m = b.useMemo(() => ({
    id: g,
    value: o
  }), [g, o]), {
    ref: y,
    index: v
  } = Fs({
    metadata: m
  }), w = o === l, {
    mounted: C,
    transitionStatus: x,
    setMounted: E
  } = ta(w), S = !C, M = u(o), T = {
    hidden: S,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: x
  }, P = b.useRef(null), k = $e("div", t, {
    state: T,
    ref: [n, y, P],
    props: [{
      "aria-labelledby": M,
      hidden: S,
      id: g,
      role: "tabpanel",
      tabIndex: w ? 0 : -1,
      inert: na(!w),
      [L3.index]: v
    }, c],
    stateAttributesMapping: V3
  });
  return xr({
    open: w,
    ref: P,
    onComplete() {
      w || E(!1);
    }
  }), be(() => {
    if (!(S && !i) && g != null)
      return h(o, g), () => {
        p(o, g);
      };
  }, [S, i, o, g, h, p]), i || C ? k : null;
});
process.env.NODE_ENV !== "production" && (ix.displayName = "TabsPanel");
const ax = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    activateOnFocus: r = !1,
    className: o,
    loopFocus: s = !0,
    render: i,
    style: a,
    ...c
  } = t, {
    onValueChange: l,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: h
  } = wp(), [p, g] = b.useState(0), [m, y] = b.useState(null), v = b.useRef(/* @__PURE__ */ new Set()), w = b.useRef(/* @__PURE__ */ new Set()), C = b.useRef(null);
  b.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const k = new ResizeObserver(() => {
      v.current.forEach((I) => {
        I();
      });
    });
    return C.current = k, m && k.observe(m), w.current.forEach((I) => {
      k.observe(I);
    }), () => {
      k.disconnect(), C.current = null;
    };
  }, [m]);
  const x = Se((k) => (v.current.add(k), () => {
    v.current.delete(k);
  })), E = Se((k) => {
    var I;
    return w.current.add(k), (I = C.current) == null || I.observe(k), () => {
      var O;
      w.current.delete(k), (O = C.current) == null || O.unobserve(k);
    };
  }), S = Se((k, I) => {
    k !== d && l(k, I);
  }), M = {
    orientation: u,
    tabActivationDirection: h
  }, T = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, P = b.useMemo(() => ({
    activateOnFocus: r,
    highlightedTabIndex: p,
    registerIndicatorUpdateListener: x,
    registerTabResizeObserverElement: E,
    onTabActivation: S,
    setHighlightedTabIndex: g,
    tabsListElement: m
  }), [r, p, x, E, S, g, m]);
  return /* @__PURE__ */ _(Cp.Provider, {
    value: P,
    children: /* @__PURE__ */ _(w3, {
      render: i,
      className: o,
      style: a,
      state: M,
      refs: [n, y],
      props: [T, c],
      stateAttributesMapping: xp,
      highlightedIndex: p,
      enableHomeAndEndKeys: !0,
      loopFocus: s,
      orientation: u,
      onHighlightedIndexChange: g,
      onMapChange: f,
      disabledIndices: ys
    })
  });
});
process.env.NODE_ENV !== "production" && (ax.displayName = "TabsList");
const du = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (du.displayName = "ToastContext");
function Ep() {
  const e = b.useContext(du);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : rt(73));
  return e;
}
let Hb = 0;
function cx(e) {
  return Hb += 1, `${e}-${Math.random().toString(36).slice(2, 6)}-${Hb}`;
}
function td(e, t) {
  if (typeof e == "string")
    return {
      description: e
    };
  if (typeof e == "function") {
    const n = e(t);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return e;
}
function nd(e) {
  const t = /* @__PURE__ */ new Map();
  let n = 0, r = 0;
  return e.forEach((o, s) => {
    const i = o.transitionStatus === "ending";
    t.set(o.id, {
      value: o,
      domIndex: s,
      visibleIndex: i ? -1 : n,
      offsetY: r
    }), r += o.height || 0, i || (n += 1);
  }), t;
}
const Xa = (e) => e.toastMetadata, nr = {
  toasts: ge((e) => e.toasts),
  isEmpty: ge((e) => e.toasts.length === 0),
  toast: ge(Xa, (e, t) => {
    var n;
    return (n = e.get(t)) == null ? void 0 : n.value;
  }),
  toastIndex: ge(Xa, (e, t) => {
    var n;
    return ((n = e.get(t)) == null ? void 0 : n.domIndex) ?? -1;
  }),
  toastOffsetY: ge(Xa, (e, t) => {
    var n;
    return ((n = e.get(t)) == null ? void 0 : n.offsetY) ?? 0;
  }),
  toastVisibleIndex: ge(Xa, (e, t) => {
    var n;
    return ((n = e.get(t)) == null ? void 0 : n.visibleIndex) ?? -1;
  }),
  hovering: ge((e) => e.hovering),
  focused: ge((e) => e.focused),
  expanded: ge((e) => e.hovering || e.focused),
  expandedOrOutOfFocus: ge((e) => e.hovering || e.focused || !e.isWindowFocused),
  prevFocusElement: ge((e) => e.prevFocusElement)
};
class W3 extends Ns {
  constructor(n) {
    super({
      ...n,
      toastMetadata: nd(n.toasts)
    }, {}, nr);
    ae(this, "timers", /* @__PURE__ */ new Map());
    ae(this, "areTimersPaused", !1);
    ae(this, "setViewport", (n) => {
      this.set("viewport", n);
    });
    ae(this, "disposeEffect", () => () => {
      this.timers.forEach((n) => {
        var r;
        (r = n.timeout) == null || r.clear();
      }), this.timers.clear();
    });
    ae(this, "addToast", (n) => {
      const {
        timeout: r,
        limit: o
      } = this.state, s = n.id || cx("toast");
      if (n.id) {
        const u = nr.toast(this.state, n.id);
        if (u)
          if (u.transitionStatus === "ending")
            this.removeToast(n.id, {
              skipOnRemove: !0
            });
          else {
            const {
              id: d,
              transitionStatus: f,
              ...h
            } = n;
            return this.updateToastInternal(n.id, h, {
              resetTimer: !0,
              markUpdated: !0
            }), n.id;
          }
      }
      const i = {
        ...n,
        id: s,
        updateKey: 0,
        transitionStatus: "starting"
      }, a = [i, ...this.state.toasts], c = a.filter((u) => u.transitionStatus !== "ending");
      if (c.length > o) {
        const u = c.length - o, d = c.slice(-u), f = new Set(d.map((h) => h.id));
        this.setToasts(a.map((h) => {
          const p = f.has(h.id);
          return h.limited !== p ? {
            ...h,
            limited: p
          } : h;
        }));
      } else
        this.setToasts(a.map((u) => u.limited ? {
          ...u,
          limited: !1
        } : u));
      const l = i.timeout ?? r;
      return i.type !== "loading" && l > 0 && this.scheduleTimer(s, l, () => this.closeToast(s)), nr.expandedOrOutOfFocus(this.state) && this.pauseTimers(), s;
    });
    ae(this, "updateToast", (n, r) => {
      this.updateToastInternal(n, r, {
        markUpdated: !0
      });
    });
    ae(this, "updateToastInternal", (n, r, o = {}) => {
      var m, y;
      const {
        timeout: s,
        toasts: i
      } = this.state, a = nr.toast(this.state, n) ?? null;
      if (!a || a.transitionStatus === "ending")
        return;
      const c = {
        ...a,
        ...r,
        ...o.markUpdated && {
          updateKey: (a.updateKey ?? 0) + 1
        }
      };
      this.setToasts(i.map((v) => v.id === n ? c : v));
      const l = c.timeout ?? s, u = (a == null ? void 0 : a.timeout) ?? s, d = Object.hasOwn(r, "timeout"), f = c.transitionStatus !== "ending" && c.type !== "loading" && l > 0, h = this.timers.has(n), p = u !== l, g = (a == null ? void 0 : a.type) === "loading";
      if (!f && h) {
        const v = this.timers.get(n);
        (m = v == null ? void 0 : v.timeout) == null || m.clear(), this.timers.delete(n);
        return;
      }
      if (f && (!h || p || d || g || o.resetTimer)) {
        const v = this.timers.get(n);
        v && ((y = v.timeout) == null || y.clear(), this.timers.delete(n)), this.scheduleTimer(n, l, () => this.closeToast(n)), nr.expandedOrOutOfFocus(this.state) && this.pauseTimers();
      }
    });
    ae(this, "closeToast", (n) => {
      const r = n === void 0, {
        limit: o,
        toasts: s
      } = this.state;
      let i;
      if (r)
        i = s, this.timers.forEach((u) => {
          var d;
          (d = u.timeout) == null || d.clear();
        }), this.timers.clear();
      else {
        const u = nr.toast(this.state, n);
        if (!u)
          return;
        i = [u];
        const d = this.timers.get(n);
        d != null && d.timeout && (d.timeout.clear(), this.timers.delete(n));
      }
      let a = 0;
      const c = s.map((u) => {
        if (r || u.id === n)
          return {
            ...u,
            transitionStatus: "ending",
            height: 0
          };
        if (u.transitionStatus === "ending")
          return u;
        const d = a >= o;
        return a += 1, u.limited !== d ? {
          ...u,
          limited: d
        } : u;
      }), l = {
        toasts: c,
        toastMetadata: nd(c)
      };
      (r || s.length === 1) && (l.hovering = !1, l.focused = !1), this.update(l), i.forEach((u) => {
        var d;
        u.transitionStatus !== "ending" && ((d = u.onClose) == null || d.call(u));
      }), this.handleFocusManagement(n);
    });
    ae(this, "promiseToast", (n, r) => {
      const o = td(r.loading), s = this.addToast({
        ...o,
        type: "loading"
      }), i = n.then((a) => {
        const c = td(r.success, a);
        return this.updateToast(s, {
          ...c,
          type: "success",
          timeout: c.timeout
        }), a;
      }).catch((a) => {
        const c = td(r.error, a);
        return this.updateToast(s, {
          ...c,
          type: "error",
          timeout: c.timeout
        }), Promise.reject(a);
      });
      return {}.hasOwnProperty.call(r, "setPromise") && r.setPromise(i), i;
    });
    ae(this, "handleDocumentPointerDown", (n) => {
      if (n.pointerType !== "touch")
        return;
      const r = Dt(n);
      Re(this.state.viewport, r) || (this.resumeTimers(), this.update({
        hovering: !1,
        focused: !1
      }));
    });
  }
  setFocused(n) {
    this.set("focused", n);
  }
  setHovering(n) {
    this.set("hovering", n);
  }
  setIsWindowFocused(n) {
    this.set("isWindowFocused", n);
  }
  setPrevFocusElement(n) {
    this.set("prevFocusElement", n);
  }
  removeToast(n, r = {}) {
    var a;
    const o = nr.toastIndex(this.state, n);
    if (o === -1)
      return;
    const s = this.state.toasts[o];
    r.skipOnRemove || (a = s == null ? void 0 : s.onRemove) == null || a.call(s);
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((n) => {
      if (n.timeout) {
        n.timeout.clear();
        const r = Date.now() - n.start, o = n.delay - r;
        n.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((n, r) => {
      n.remaining = n.remaining > 0 ? n.remaining : n.delay, n.timeout ?? (n.timeout = xn.create()), n.timeout.start(n.remaining, () => {
        this.timers.delete(r), n.callback();
      }), n.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    var n;
    (n = this.state.prevFocusElement) == null || n.focus({
      preventScroll: !0
    });
  }
  scheduleTimer(n, r, o) {
    const s = Date.now(), i = !nr.expandedOrOutOfFocus(this.state), a = i ? xn.create() : void 0;
    a == null || a.start(r, () => {
      this.timers.delete(n), o();
    }), this.timers.set(n, {
      timeout: a,
      start: i ? s : 0,
      delay: r,
      remaining: r,
      callback: o
    });
  }
  setToasts(n) {
    const r = {
      toasts: n,
      toastMetadata: nd(n)
    };
    n.length === 0 && (r.hovering = !1, r.focused = !1), this.update(r);
  }
  handleFocusManagement(n) {
    var c, l;
    const r = Xt(Ye(this.state.viewport));
    if (!this.state.viewport || !Re(this.state.viewport, r) || !Pc(r))
      return;
    if (n === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = nr.toasts(this.state), s = nr.toastIndex(this.state, n);
    let i = null, a = s + 1;
    for (; a < o.length; ) {
      if (o[a].transitionStatus !== "ending") {
        i = o[a];
        break;
      }
      a += 1;
    }
    if (!i)
      for (a = s - 1; a >= 0; ) {
        if (o[a].transitionStatus !== "ending") {
          i = o[a];
          break;
        }
        a -= 1;
      }
    i ? (l = (c = i.ref) == null ? void 0 : c.current) == null || l.focus() : this.restoreFocusToPrevElement();
  }
}
const lx = function(t) {
  const {
    children: n,
    timeout: r = 5e3,
    limit: o = 3,
    toastManager: s
  } = t, i = gn(() => new W3({
    timeout: r,
    limit: o,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return wl(i.disposeEffect), b.useEffect(function() {
    return s ? s[" subscribe"](({
      action: l,
      options: u
    }) => {
      const d = u.id;
      l === "promise" && u.promise ? i.promiseToast(u.promise, u) : l === "update" && d ? i.updateToast(d, u) : l === "close" ? i.closeToast(d) : i.addToast(u);
    }) : void 0;
  }, [i, s]), i.useSyncedValues({
    timeout: r,
    limit: o
  }), /* @__PURE__ */ _(du.Provider, {
    value: i,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (lx.displayName = "ToastProvider");
let B3 = /* @__PURE__ */ function(e) {
  return e.frontmostHeight = "--toast-frontmost-height", e;
}({});
const ux = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var $;
  const {
    render: r,
    className: o,
    style: s,
    children: i,
    ...a
  } = t, c = Ep(), l = ln(), u = b.useRef(!1), d = b.useRef(!1), f = b.useRef(!1), h = c.useState("isEmpty"), p = c.useState("toasts"), g = c.useState("focused"), m = c.useState("expanded"), y = c.useState("prevFocusElement"), v = (($ = p[0]) == null ? void 0 : $.height) ?? 0, w = b.useMemo(() => p.some((F) => F.transitionStatus === "ending"), [p]), C = b.useMemo(() => p.filter((F) => F.priority === "high"), [p]);
  b.useEffect(() => {
    const F = c.state.viewport;
    if (!F)
      return;
    function V(H) {
      h || H.key === "F6" && Dt(H) !== F && (H.preventDefault(), c.setPrevFocusElement(Xt(Ye(F))), F == null || F.focus({
        preventScroll: !0
      }), c.pauseTimers(), c.setFocused(!0));
    }
    const D = Ot(F);
    return We(D, "keydown", V);
  }, [c, h]), b.useEffect(() => {
    const F = c.state.viewport;
    if (!F || h)
      return;
    const V = Ot(F);
    function D(j) {
      Dt(j) === V && (c.setIsWindowFocused(!1), c.pauseTimers());
    }
    function H(j) {
      if (j.relatedTarget)
        return;
      const U = Dt(j), K = Xt(Ye(F));
      (U === V || !Re(F, U) || !Pc(K)) && c.resumeTimers(), l.start(0, () => c.setIsWindowFocused(!0));
    }
    return er(We(V, "blur", D, !0), We(V, "focus", H, !0));
  }, [
    c,
    l,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    h
  ]), b.useEffect(() => {
    const F = c.state.viewport;
    if (!F || h)
      return;
    const V = Ye(F);
    return We(V, "pointerdown", c.handleDocumentPointerDown, !0);
  }, [h, c]);
  function x(F) {
    var D, H, j;
    const V = c.state.viewport;
    V && (u.current = !0, F.relatedTarget === V ? (j = (H = (D = p[0]) == null ? void 0 : D.ref) == null ? void 0 : H.current) == null || j.focus() : c.restoreFocusToPrevElement());
  }
  function E(F) {
    F.key === "Tab" && F.shiftKey && Dt(F.nativeEvent) === c.state.viewport && (F.preventDefault(), c.restoreFocusToPrevElement(), c.resumeTimers());
  }
  function S() {
    const F = c.state.toasts.some((V) => V.transitionStatus === "ending");
    !c.state.isWindowFocused || F || f.current || !d.current || (c.resumeTimers(), c.setHovering(!1), d.current = !1);
  }
  b.useEffect(S, [w, c]);
  function M() {
    c.pauseTimers(), c.setHovering(!0), d.current = !1;
  }
  function T() {
    w || f.current ? d.current = !0 : (c.resumeTimers(), c.setHovering(!1));
  }
  function P(F) {
    F.pointerType === "touch" && (f.current = !0);
  }
  function k(F) {
    F.pointerType === "touch" && (f.current = !1, S());
  }
  function I() {
    if (u.current) {
      u.current = !1;
      return;
    }
    g || Pc(Xt(Ye(c.state.viewport))) && (c.setFocused(!0), c.pauseTimers());
  }
  function O(F) {
    !g || Re(c.state.viewport, F.relatedTarget) || (c.setFocused(!1), c.resumeTimers());
  }
  const A = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: M,
    onMouseMove: M,
    onMouseLeave: T,
    onFocus: I,
    onBlur: O,
    onKeyDown: E,
    onClick: I,
    onPointerDown: P,
    onPointerUp: k,
    onPointerCancel: k
  }, R = {
    expanded: m
  }, N = $e("div", t, {
    ref: [n, c.setViewport],
    state: R,
    props: [A, {
      style: {
        [B3.frontmostHeight]: v ? `${v}px` : void 0
      }
    }, a, {
      children: /* @__PURE__ */ Z(b.Fragment, {
        children: [!h && y && /* @__PURE__ */ _(Hn, {
          onFocus: x
        }), i, !h && y && /* @__PURE__ */ _(Hn, {
          onFocus: x
        })]
      })
    }]
  });
  return /* @__PURE__ */ Z(b.Fragment, {
    children: [!h && y && /* @__PURE__ */ _(Hn, {
      onFocus: x
    }), N, !g && C.length > 0 && /* @__PURE__ */ _("div", {
      style: Tl,
      children: C.map((F) => /* @__PURE__ */ Z("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ _("div", {
          children: F.title
        }), /* @__PURE__ */ _("div", {
          children: F.description
        })]
      }, F.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (ux.displayName = "ToastViewport");
const _p = /* @__PURE__ */ b.createContext(void 0);
process.env.NODE_ENV !== "production" && (_p.displayName = "ToastRootContext");
function ha() {
  const e = b.useContext(_p);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : rt(66));
  return e;
}
let ko = /* @__PURE__ */ function(e) {
  return e.index = "--toast-index", e.offsetY = "--toast-offset-y", e.height = "--toast-height", e.swipeMovementX = "--toast-swipe-movement-x", e.swipeMovementY = "--toast-swipe-movement-y", e;
}({});
const H3 = {
  ...Un,
  swipeDirection(e) {
    return e ? {
      "data-swipe-direction": e
    } : null;
  }
}, oi = 40, Y3 = 10, eo = 0.5, z3 = 1, j3 = `${qO},${XO}`, dx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var fe;
  const {
    toast: r,
    render: o,
    className: s,
    swipeDirection: i = ["down", "right"],
    style: a,
    ...c
  } = t, l = ((fe = r.positionerProps) == null ? void 0 : fe.anchor) !== void 0;
  let u = [];
  l || (u = Array.isArray(i) ? i : [i]);
  const d = u.length > 0, f = Ep(), [h, p] = b.useState(void 0), [g, m] = b.useState(!1), [y, v] = b.useState(!1), [w, C] = b.useState(!1), [x, E] = b.useState({
    x: 0,
    y: 0
  }), [S, M] = b.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [T, P] = b.useState(), [k, I] = b.useState(), [O, A] = b.useState(null), R = b.useRef(null), N = b.useRef({
    x: 0,
    y: 0
  }), $ = b.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), F = b.useRef(void 0), V = b.useRef(0), D = b.useRef(!1), H = b.useRef({
    x: 0,
    y: 0
  }), j = b.useRef(!1), U = b.useRef({
    x: 0,
    y: 0
  }), K = b.useRef(null), G = b.useRef(null), B = f.useState("toastIndex", r.id), z = f.useState("toastVisibleIndex", r.id), W = f.useState("toastOffsetY", r.id), X = f.useState("focused"), J = f.useState("expanded");
  xr({
    open: r.transitionStatus !== "ending",
    ref: R,
    onComplete() {
      r.transitionStatus === "ending" && f.removeToast(r.id);
    }
  });
  const Q = Se((q = !1) => {
    const te = R.current;
    if (!te)
      return;
    const oe = te.style.height;
    te.style.height = "auto";
    const re = te.offsetHeight;
    te.style.height = oe;
    function ve() {
      f.updateToastInternal(r.id, {
        ref: R,
        height: re,
        ...r.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    q ? Yn.flushSync(ve) : ve();
  });
  be(Q, [Q]);
  function Y(q) {
    U.current = q, E(q);
  }
  be(() => () => {
    var q;
    (q = G.current) == null || q.abort();
  }, []);
  function ce(q, te) {
    let oe = q, re = te;
    return !u.includes("left") && !u.includes("right") ? oe = q > 0 ? q ** eo : -(Math.abs(q) ** eo) : (!u.includes("right") && q > 0 && (oe = q ** eo), !u.includes("left") && q < 0 && (oe = -(Math.abs(q) ** eo))), !u.includes("up") && !u.includes("down") ? re = te > 0 ? te ** eo : -(Math.abs(te) ** eo) : (!u.includes("down") && te > 0 && (re = te ** eo), !u.includes("up") && te < 0 && (re = -(Math.abs(te) ** eo))), {
      x: oe,
      y: re
    };
  }
  const ee = Se((q) => {
    var qe;
    if (q.pointerId !== K.current)
      return;
    K.current = null, (qe = G.current) == null || qe.abort(), G.current = null, m(!1), v(!1), A(null);
    const te = $.current;
    if (q.type === "pointercancel" || D.current) {
      Y({
        x: te.x,
        y: te.y
      }), p(void 0);
      return;
    }
    let oe = !1;
    const re = U.current, ve = re.x - te.x, xe = re.y - te.y;
    let Me;
    for (const Ze of u) {
      switch (Ze) {
        case "right":
          ve > oi && (oe = !0, Me = "right");
          break;
        case "left":
          ve < -oi && (oe = !0, Me = "left");
          break;
        case "down":
          xe > oi && (oe = !0, Me = "down");
          break;
        case "up":
          xe < -oi && (oe = !0, Me = "up");
          break;
      }
      if (oe)
        break;
    }
    oe ? (p(Me), C(!0), f.closeToast(r.id)) : (Y({
      x: te.x,
      y: te.y
    }), p(void 0));
  });
  function ne(q) {
    var ve, xe;
    if (q.button !== 0)
      return;
    q.pointerType === "touch" && f.pauseTimers();
    const te = Dt(q.nativeEvent);
    if (te ? te.closest(`button,a,input,textarea,[role="button"],${j3}`) : !1)
      return;
    if (D.current = !1, F.current = void 0, V.current = 0, K.current = q.pointerId, N.current = {
      x: q.clientX,
      y: q.clientY
    }, H.current = N.current, R.current) {
      const Me = m3(R.current);
      $.current = Me, M(Me), Y({
        x: Me.x,
        y: Me.y
      });
    }
    f.setHovering(!0), m(!0), v(!1), A(null), j.current = !0;
    const re = R.current;
    if (re) {
      (ve = G.current) == null || ve.abort();
      const Me = new AbortController();
      G.current = Me;
      const qe = Ye(re);
      qe.addEventListener("pointerup", ee, {
        signal: Me.signal
      }), qe.addEventListener("pointercancel", ee, {
        signal: Me.signal
      }), (xe = re.setPointerCapture) == null || xe.call(re, q.pointerId);
    }
  }
  function de(q) {
    if (q.pointerId !== K.current)
      return;
    q.preventDefault(), j.current && (N.current = {
      x: q.clientX,
      y: q.clientY
    }, j.current = !1);
    const {
      clientY: te,
      clientX: oe,
      movementX: re,
      movementY: ve
    } = q;
    (ve < 0 && te > H.current.y || ve > 0 && te < H.current.y) && (H.current = {
      x: H.current.x,
      y: te
    }), (re < 0 && oe > H.current.x || re > 0 && oe < H.current.x) && (H.current = {
      x: oe,
      y: H.current.y
    });
    const xe = oe - N.current.x, Me = te - N.current.y, qe = te - H.current.y, Ze = oe - H.current.x;
    if (!y && Math.sqrt(xe * xe + Me * Me) >= z3 && (v(!0), O === null)) {
      const fn = u.includes("left") || u.includes("right"), $n = u.includes("up") || u.includes("down");
      if (fn && $n) {
        const me = Math.abs(xe), De = Math.abs(Me);
        A(me > De ? "horizontal" : "vertical");
      }
    }
    let nt;
    if (!F.current)
      O === "vertical" ? Me > 0 ? nt = "down" : Me < 0 && (nt = "up") : O === "horizontal" ? xe > 0 ? nt = "right" : xe < 0 && (nt = "left") : Math.abs(xe) >= Math.abs(Me) ? nt = xe > 0 ? "right" : "left" : nt = Me > 0 ? "down" : "up", nt && u.includes(nt) && (F.current = nt, V.current = $b(nt, xe, Me), p(nt));
    else {
      const _n = F.current, fn = $b(_n, Ze, qe);
      fn > oi ? (D.current = !1, p(_n)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && V.current - fn >= Y3 && (D.current = !0);
    }
    const Kt = ce(xe, Me);
    let dn = $.current.x, rn = $.current.y;
    O === "horizontal" ? (u.includes("left") || u.includes("right")) && (dn += Kt.x) : (O === "vertical" || (u.includes("left") || u.includes("right")) && (dn += Kt.x), (u.includes("up") || u.includes("down")) && (rn += Kt.y)), Y({
      x: dn,
      y: rn
    });
  }
  function pe(q) {
    if (q.key === "Escape") {
      if (!R.current || !Re(R.current, Xt(Ye(R.current))))
        return;
      f.closeToast(r.id);
    }
  }
  b.useEffect(() => {
    if (!d)
      return;
    const q = R.current;
    if (!q)
      return;
    function te(oe) {
      Re(q, Dt(oe)) && oe.preventDefault();
    }
    return We(q, "touchmove", te, {
      passive: !1
    });
  }, [d]);
  function Ee() {
    if (!g && x.x === S.x && x.y === S.y && !w)
      return {
        [ko.swipeMovementX]: "0px",
        [ko.swipeMovementY]: "0px"
      };
    const q = x.x - S.x, te = x.y - S.y;
    return {
      transition: g ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: g ? `translateX(${x.x}px) translateY(${x.y}px) scale(${S.scale})` : void 0,
      [ko.swipeMovementX]: `${q}px`,
      [ko.swipeMovementY]: `${te}px`
    };
  }
  const se = r.priority === "high", ke = {
    role: se ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": T,
    "aria-describedby": k,
    "aria-hidden": se && !X ? !0 : void 0,
    onPointerDown: d ? ne : void 0,
    onPointerMove: d ? de : void 0,
    onPointerUp: d ? ee : void 0,
    onPointerCancel: d ? ee : void 0,
    onKeyDown: pe,
    inert: na(r.limited),
    style: {
      ...Ee(),
      [ko.index]: r.transitionStatus === "ending" ? B : z,
      [ko.offsetY]: `${W}px`,
      [ko.height]: r.height ? `${r.height}px` : void 0
    }
  }, we = b.useMemo(() => ({
    rootRef: R,
    toast: r,
    titleId: T,
    setTitleId: P,
    descriptionId: k,
    setDescriptionId: I,
    swiping: g,
    swipeDirection: h,
    recalculateHeight: Q,
    index: B,
    visibleIndex: z,
    expanded: J
  }), [r, T, k, g, h, Q, B, z, J]), Oe = {
    transitionStatus: r.transitionStatus,
    expanded: J,
    limited: r.limited || !1,
    type: r.type,
    swiping: we.swiping,
    swipeDirection: we.swipeDirection
  }, Ie = $e("div", t, {
    ref: [n, we.rootRef],
    state: Oe,
    stateAttributesMapping: H3,
    props: [ke, c]
  });
  return /* @__PURE__ */ _(_p.Provider, {
    value: we,
    children: Ie
  });
});
process.env.NODE_ENV !== "production" && (dx.displayName = "ToastRoot");
const fx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    ...i
  } = t, {
    visibleIndex: a,
    expanded: c,
    recalculateHeight: l
  } = ha(), u = b.useRef(null);
  be(() => {
    const p = u.current;
    if (!p || (l(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const g = new ResizeObserver(() => l(!0)), m = new MutationObserver(() => l(!0));
    return g.observe(p), m.observe(p, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      g.disconnect(), m.disconnect();
    };
  }, [l]);
  const d = a > 0;
  return $e("div", t, {
    ref: [n, u],
    state: {
      expanded: c,
      behind: d
    },
    props: i
  });
});
process.env.NODE_ENV !== "production" && (fx.displayName = "ToastContent");
const hx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    children: a,
    ...c
  } = t, {
    toast: l,
    setDescriptionId: u
  } = ha(), d = a ?? l.description, f = !!d, h = Br(i);
  be(() => {
    if (f)
      return u(h), () => {
        u(void 0);
      };
  }, [f, h, u]);
  const p = {
    type: l.type
  }, g = $e("p", t, {
    ref: n,
    state: p,
    props: {
      ...c,
      id: h,
      children: d
    }
  });
  return f ? g : null;
});
process.env.NODE_ENV !== "production" && (hx.displayName = "ToastDescription");
const px = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    id: i,
    children: a,
    ...c
  } = t, {
    toast: l,
    setTitleId: u
  } = ha(), d = a ?? l.title, f = !!d, h = Br(i);
  be(() => {
    if (f)
      return u(h), () => {
        u(void 0);
      };
  }, [f, h, u]);
  const p = {
    type: l.type
  }, g = $e("h2", t, {
    ref: n,
    state: p,
    props: {
      ...c,
      id: h,
      children: d
    }
  });
  return f ? g : null;
});
process.env.NODE_ENV !== "production" && (px.displayName = "ToastTitle");
const gx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  const {
    render: r,
    className: o,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...c
  } = t, l = Ep(), {
    toast: u
  } = ha(), d = l.useState("expanded"), [f, h] = b.useState(!1), {
    getButtonProps: p,
    buttonRef: g
  } = Cr({
    disabled: i,
    native: a
  }), m = {
    type: u.type
  };
  return $e("button", t, {
    ref: [n, g],
    state: m,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        l.closeToast(u.id);
      },
      onFocus() {
        h(!0);
      },
      onBlur() {
        h(!1);
      }
    }, c, p]
  });
});
process.env.NODE_ENV !== "production" && (gx.displayName = "ToastClose");
const mx = /* @__PURE__ */ b.forwardRef(function(t, n) {
  var m;
  const {
    render: r,
    className: o,
    style: s,
    disabled: i,
    nativeButton: a = !0,
    ...c
  } = t, {
    toast: l
  } = ha(), u = ((m = l.actionProps) == null ? void 0 : m.children) ?? c.children, d = !!u, {
    getButtonProps: f,
    buttonRef: h
  } = Cr({
    disabled: i,
    native: a
  }), p = {
    type: l.type
  }, g = $e("button", t, {
    ref: [n, h],
    state: p,
    props: [c, l.actionProps, f, {
      children: u
    }]
  });
  return d ? g : null;
});
process.env.NODE_ENV !== "production" && (mx.displayName = "ToastAction");
const U3 = uh;
function G3() {
  const e = b.useContext(du);
  if (!e)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : rt(73));
  const t = e.useState("toasts");
  return b.useMemo(() => ({
    toasts: t,
    add: e.addToast,
    close: e.closeToast,
    update: e.updateToast,
    promise: e.promiseToast
  }), [t, e]);
}
function K3() {
  const e = /* @__PURE__ */ new Set();
  function t(n) {
    e.forEach((r) => r(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(r) {
      return e.add(r), () => {
        e.delete(r);
      };
    },
    add(n) {
      const r = n.id || cx("toast"), o = {
        ...n,
        id: r,
        transitionStatus: "starting"
      };
      return t({
        action: "add",
        options: o
      }), r;
    },
    close(n) {
      t({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, r) {
      t({
        action: "update",
        options: {
          ...r,
          id: n
        }
      });
    },
    promise(n, r) {
      let o = n;
      return t({
        action: "promise",
        options: {
          ...r,
          promise: n,
          setPromise(s) {
            o = s;
          }
        }
      }), o;
    }
  };
}
const q3 = En(
  "inline-flex flex-shrink-0 items-center py-0.5 text-xs font-medium text-foundations-bolder",
  {
    variants: {
      variant: {
        primary: "border border-info-subtle bg-info-subtler",
        secondary: "bg-gold-400 text-white",
        warning: "border border-warning-subtle bg-warning-subtler",
        dimmed: "bg-foundations-bolder text-white",
        default: "border border-foundations-subtle bg-foundations-subtlest text-foundations-subtle",
        success: "border border-success-subtle bg-success-subtler",
        danger: "border border-danger-subtle bg-danger-subtler",
        pending: "bg-warning-subtler text-gold-400"
      },
      size: {
        sm: "px-2",
        md: "px-2.5"
      },
      shape: {
        pill: "rounded-full",
        square: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md",
      shape: "pill",
      variant: "default"
    }
  }
), X3 = ie.forwardRef(
  ({ variant: e, size: t, shape: n, className: r, render: o, ...s }, i) => {
    const a = {
      className: le(q3({ variant: e, size: t, shape: n, className: r })),
      "data-slot": "badge"
    };
    return Is({
      defaultTagName: "div",
      render: o,
      ref: i,
      props: Zt(a, s)
    });
  }
);
X3.displayName = "Badge";
const Z3 = En(
  "relative flex w-full flex-shrink-0 items-center overflow-hidden rounded-md p-4",
  {
    variants: {
      state: {
        success: "",
        danger: "",
        informative: "",
        warning: "",
        neutral: ""
      },
      contrast: {
        low: "border text-foundations-boldest [&_.close-btn]:text-foundations-subtle [&_.icon]:h-5 [&_.icon]:w-5 [&_.icon_svg]:h-4 [&_.icon_svg]:w-4",
        medium: "text-foundations-inverse shadow-2 [&_.icon]:h-8 [&_.icon]:w-8 [&_.icon_svg]:h-6 [&_.icon_svg]:w-6"
      },
      fullWidth: {
        true: "",
        false: "max-w-[25rem]"
      }
    },
    defaultVariants: {
      state: "informative",
      contrast: "low",
      fullWidth: !1
    },
    compoundVariants: [
      {
        state: "success",
        contrast: "low",
        className: "border-success-subtle bg-success-subtler [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "low",
        className: "border-danger-subtle bg-danger-subtler [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "low",
        className: "border-info-subtle bg-info-subtler [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "low",
        className: "border-warning-subtle bg-warning-subtler [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "neutral",
        contrast: "low",
        className: "border-foundations-subtle bg-foundations-subtelst-02 text-foundations-subtle [&_.icon]:bg-transparent [&_.icon]:text-foundations-subtle"
      },
      {
        state: "success",
        contrast: "medium",
        className: "bg-success-subtle text-foundations-boldest [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "medium",
        className: "bg-danger-subtle text-foundations-boldest [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "medium",
        className: "bg-info-subtle text-foundations-boldest [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "medium",
        className: "bg-warning-subtle text-foundations-boldest [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      }
    ]
  }
), Q3 = b.forwardRef(
  ({
    title: e,
    state: t = "neutral",
    contrast: n,
    fullWidth: r,
    className: o,
    onClose: s,
    actions: i,
    content: a,
    Icon: c,
    ...l
  }, u) => /* @__PURE__ */ Z(
    "div",
    {
      ref: u,
      className: le(Z3({ state: t, contrast: n, fullWidth: r }), o),
      ...l,
      children: [
        /* @__PURE__ */ _(bx, { state: t, CustomIcon: c }),
        /* @__PURE__ */ Z("div", { className: "ml-4 flex-1", children: [
          /* @__PURE__ */ _("div", { className: "text-sm font-medium", children: e }),
          a && /* @__PURE__ */ _("div", { className: "mt-2", children: a })
        ] }),
        i && /* @__PURE__ */ _("div", { className: "ml-4 space-x-2", children: i }),
        s && /* @__PURE__ */ _(
          "button",
          {
            onClick: s,
            className: "close-btn ml-2 flex-shrink-0 rounded-sm hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            children: /* @__PURE__ */ _(Jl, { className: "h-4 w-4 " })
          }
        )
      ]
    }
  )
);
Q3.displayName = "Alert";
const J3 = {
  success: yo,
  danger: Vu,
  informative: Rh,
  warning: Vu,
  neutral: Vu
}, bx = ({
  state: e,
  CustomIcon: t
}) => {
  const n = J3[e];
  return /* @__PURE__ */ _("div", { className: "icon flex flex-shrink-0 items-center justify-center rounded-full", children: t ? /* @__PURE__ */ _(t, {}) : /* @__PURE__ */ _(n, {}) });
};
bx.displayName = "AlertIcon";
const e4 = b.forwardRef(
  ({ className: e, disableHover: t, render: n, ...r }, o) => {
    const s = {
      className: le(
        "block rounded-lg border border-foundations-subtle bg-foundations-default p-6 transition-colors focus:border-info-bold focus:outline-none focus:ring-1 focus:ring-info-bold [&:has(.link-overlay:focus)]:border-info-bold [&:has(.link-overlay:focus)]:ring-1 [&:has(.link-overlay:focus)]:ring-info-bold",
        !t && "hover:border-foundations-bold hover:shadow-3",
        e
      ),
      "data-slot": "card"
    };
    return Is({
      defaultTagName: "div",
      render: n,
      ref: o,
      props: Zt(s, r)
    });
  }
);
e4.displayName = "Card";
const t4 = b.forwardRef(
  ({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ _(
    e ? Os : "div",
    {
      ref: r,
      className: le(
        "relative [&_button]:relative [&_button]:z-[1] [&_a:not(.link-overlay)]:relative [&_a:not(.link-overlay)]:z-[1]",
        t
      ),
      ...n
    }
  )
);
t4.displayName = "LinkBox";
const n4 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "a",
  {
    ref: n,
    className: le(
      "link-overlay before:absolute before:inset-0 focus:outline-none",
      e
    ),
    ...t
  }
));
n4.displayName = "LinkOverlay";
const r4 = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 66,
    viewBox: "0 0 184 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/08", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Mask Group 3", children: [
        /* @__PURE__ */ Z("g", { id: "Group 26805", children: [
          /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Path 25918",
              d: "M39.5 30.6754C38.3371 30.9512 37.2627 31.5449 36.4038 32.4038C35.1848 33.6228 34.5 35.2761 34.5 37V62C34.5 63.7239 35.1848 65.3772 36.4038 66.5962C37.6228 67.8152 39.2761 68.5 41 68.5H176C177.724 68.5 179.377 67.8152 180.596 66.5962C181.815 65.3772 182.5 63.7239 182.5 62V37C182.5 35.2761 181.815 33.6228 180.596 32.4038C179.377 31.1848 177.724 30.5 176 30.5H41H39.5V30.6754Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617",
                d: "M105 40H79C77.3431 40 76 41.3431 76 43C76 44.6569 77.3431 46 79 46H105C106.657 46 108 44.6569 108 43C108 41.3431 106.657 40 105 40Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618",
                d: "M123 53H79C77.3431 53 76 54.3431 76 56C76 57.6569 77.3431 59 79 59H123C124.657 59 126 57.6569 126 56C126 54.3431 124.657 53 123 53Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26804", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624",
                d: "M68 49.5C68 41.4919 61.5081 35 53.5 35C45.4919 35 39 41.4919 39 49.5C39 57.5081 45.4919 64 53.5 64C61.5081 64 68 57.5081 68 49.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920",
                d: "M52.6007 54.194C53.842 54.1939 55.0477 53.7785 56.0257 53.014L59.1007 56.089L60.0897 55.1L57.0137 52.024C57.7865 51.0248 58.1981 49.7934 58.1815 48.5303C58.1648 47.2672 57.7208 46.047 56.9219 45.0686C56.123 44.0901 55.0162 43.4111 53.782 43.1422C52.5478 42.8733 51.2588 43.0303 50.1253 43.5877C48.9917 44.1451 48.0804 45.07 47.5398 46.2117C46.9992 47.3533 46.8612 48.6444 47.1483 49.8746C47.4354 51.1047 48.1306 52.2013 49.1208 52.9857C50.1109 53.7701 51.3375 54.196 52.6007 54.194ZM52.6007 44.4C53.4314 44.4 54.2434 44.6464 54.9341 45.1079C55.6248 45.5694 56.1631 46.2253 56.481 46.9928C56.7989 47.7602 56.8821 48.6047 56.72 49.4194C56.5579 50.2341 56.1579 50.9825 55.5705 51.5699C54.9832 52.1573 54.2348 52.5573 53.4201 52.7193C52.6054 52.8814 51.7609 52.7982 50.9934 52.4803C50.226 52.1624 49.57 51.6241 49.1085 50.9334C48.647 50.2427 48.4007 49.4307 48.4007 48.6C48.4007 47.4861 48.8432 46.4178 49.6308 45.6302C50.4185 44.8425 51.4868 44.4 52.6007 44.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26784", children: [
          /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5623",
              d: "M161 81.5H26C22.4101 81.5 19.5 84.4101 19.5 88V113C19.5 116.59 22.4101 119.5 26 119.5H161C164.59 119.5 167.5 116.59 167.5 113V88C167.5 84.4102 164.59 81.5 161 81.5Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5617_2",
                d: "M90 91H64C62.3431 91 61 92.3431 61 94C61 95.6569 62.3431 97 64 97H90C91.6569 97 93 95.6569 93 94C93 92.3431 91.6569 91 90 91Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5618_2",
                d: "M108 104H64C62.3431 104 61 105.343 61 107C61 108.657 62.3431 110 64 110H108C109.657 110 111 108.657 111 107C111 105.343 109.657 104 108 104Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ Z("g", { id: "Group 26807", children: [
            /* @__PURE__ */ _(
              "path",
              {
                id: "Rectangle 5624_2",
                d: "M53 100.5C53 92.4919 46.5081 86 38.5 86C30.4919 86 24 92.4919 24 100.5C24 108.508 30.4919 115 38.5 115C46.5081 115 53 108.508 53 100.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ _("g", { id: "bx-search_2", children: /* @__PURE__ */ _(
              "path",
              {
                id: "Path 25920_2",
                d: "M37.6007 105.194C38.842 105.194 40.0477 104.778 41.0257 104.014L44.1007 107.089L45.0897 106.1L42.0137 103.024C42.7865 102.025 43.1981 100.793 43.1815 99.5303C43.1648 98.2672 42.7208 97.047 41.9219 96.0686C41.123 95.0901 40.0162 94.4111 38.782 94.1422C37.5478 93.8733 36.2588 94.0303 35.1253 94.5877C33.9917 95.1451 33.0804 96.07 32.5398 97.2117C31.9992 98.3533 31.8612 99.6444 32.1483 100.875C32.4354 102.105 33.1306 103.201 34.1208 103.986C35.1109 104.77 36.3375 105.196 37.6007 105.194ZM37.6007 95.4C38.4314 95.4 39.2434 95.6464 39.9341 96.1079C40.6248 96.5694 41.1631 97.2253 41.481 97.9928C41.7989 98.7602 41.8821 99.6047 41.72 100.419C41.5579 101.234 41.1579 101.983 40.5705 102.57C39.9832 103.157 39.2348 103.557 38.4201 103.719C37.6054 103.881 36.7609 103.798 35.9934 103.48C35.226 103.162 34.57 102.624 34.1085 101.933C33.647 101.243 33.4007 100.431 33.4007 99.6C33.4007 98.4861 33.8432 97.4178 34.6308 96.6302C35.4185 95.8425 36.4868 95.4 37.6007 95.4Z",
                fill: "white"
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  }
), vx = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 150 153",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/07", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Subtraction 1",
          d: "M109.755 47.2509L109.748 47.2439C108.398 45.9026 107.328 44.3068 106.599 42.549C106.102 41.3514 105.77 40.0949 105.61 38.8138C105.395 37.0834 103.972 35.5 101.996 35.5H47.9978C46.0262 35.5 44.6038 37.0766 44.3853 38.8043C43.9832 41.9829 42.5372 44.9584 40.2478 47.2478C37.9584 49.5372 34.9829 50.9832 31.8043 51.3853C30.0766 51.6038 28.5 53.0262 28.5 54.9978V148C28.5 149.933 30.067 151.5 32 151.5H118C119.933 151.5 121.5 149.933 121.5 148V55.0044C121.5 53.0279 119.916 51.6052 118.186 51.3897C116.905 51.2301 115.648 50.8984 114.45 50.4015C112.692 49.6721 111.097 48.6013 109.755 47.2509Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 665",
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "ic_add_48px", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Path 25936",
          d: "M84.8995 87.8997C84.1184 88.6807 82.8521 88.6807 82.0711 87.8997L76.4142 82.2428C75.6332 81.4618 74.3668 81.4618 73.5858 82.2428L67.9289 87.8997C67.1479 88.6807 65.8816 88.6807 65.1005 87.8997C64.3195 87.1186 64.3195 85.8523 65.1005 85.0712L70.7574 79.4144C71.5384 78.6333 71.5384 77.367 70.7574 76.5859L65.1005 70.9291C64.3195 70.148 64.3195 68.8817 65.1005 68.1007C65.8816 67.3196 67.1479 67.3196 67.9289 68.1007L73.5858 73.7575C74.3668 74.5386 75.6332 74.5386 76.4142 73.7575L82.0711 68.1007C82.8521 67.3196 84.1184 67.3196 84.8995 68.1007C85.6805 68.8817 85.6805 70.148 84.8995 70.9291L79.2426 76.5859C78.4616 77.367 78.4616 78.6333 79.2426 79.4144L84.8995 85.0712C85.6805 85.8523 85.6805 87.1186 84.8995 87.8997Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5618",
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      )
    ] })
  }
), yW = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/10", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 1489", children: [
        /* @__PURE__ */ Z("g", { id: "Group 3", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1",
              x: 34,
              y: 46,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1",
              cx: 68,
              cy: 65,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 1", children: [
          /* @__PURE__ */ _(
            "rect",
            {
              id: "Rectangle 1_2",
              x: 49,
              y: 65,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "circle",
            {
              id: "Ellipse 1_2",
              cx: 83,
              cy: 84,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-default)]"
            }
          )
        ] })
      ] })
    ] })
  }
), wW = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 168,
    viewBox: "0 0 194 168",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/01", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5625",
          d: "M159 0H39C33.4772 0 29 5.37258 29 12V156C29 162.627 33.4772 168 39 168H159C164.523 168 169 162.627 169 156V12C169 5.37258 164.523 0 159 0Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26800", children: [
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25918",
            d: "M49.5 64.6754C48.3371 64.9512 47.2627 65.5449 46.4038 66.4038C45.1848 67.6228 44.5 69.2761 44.5 71V96C44.5 97.7239 45.1848 99.3772 46.4038 100.596C47.6228 101.815 49.2761 102.5 51 102.5H186C187.724 102.5 189.377 101.815 190.596 100.596C191.815 99.3772 192.5 97.7239 192.5 96V71C192.5 69.2761 191.815 67.6228 190.596 66.4038C189.377 65.1848 187.724 64.5 186 64.5H51H49.5V64.6754Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M125 74H99C97.3431 74 96 75.3431 96 77C96 78.6569 97.3431 80 99 80H125C126.657 80 128 78.6569 128 77C128 75.3431 126.657 74 125 74Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M143 87H99C97.3431 87 96 88.3431 96 90C96 91.6569 97.3431 93 99 93H143C144.657 93 146 91.6569 146 90C146 88.3431 144.657 87 143 87Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26799", children: /* @__PURE__ */ _("g", { id: "Group 26756", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647",
            d: "M76.5 93C81.7467 93 86 88.7467 86 83.5C86 78.2533 81.7467 74 76.5 74C71.2533 74 67 78.2533 67 83.5C67 88.7467 71.2533 93 76.5 93Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26798", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25919",
            d: "M6.5 112.675C5.33714 112.951 4.26267 113.545 3.40381 114.404C2.18482 115.623 1.5 117.276 1.5 119V144C1.5 145.724 2.18482 147.377 3.40381 148.596C4.62279 149.815 6.27609 150.5 8 150.5H143C144.724 150.5 146.377 149.815 147.596 148.596C148.815 147.377 149.5 145.724 149.5 144V119C149.5 117.276 148.815 115.623 147.596 114.404C146.377 113.185 144.724 112.5 143 112.5H8H6.5V112.675Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_2", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M68 122H42C40.3431 122 39 123.343 39 125C39 126.657 40.3431 128 42 128H68C69.6569 128 71 126.657 71 125C71 123.343 69.6569 122 68 122Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M86 135H42C40.3431 135 39 136.343 39 138C39 139.657 40.3431 141 42 141H86C87.6569 141 89 139.657 89 138C89 136.343 87.6569 135 86 135Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26796", children: /* @__PURE__ */ _("g", { id: "Group 26757", children: /* @__PURE__ */ _("g", { id: "Ellipse 648", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Vector",
            d: "M20.5 141C25.7467 141 30 136.747 30 131.5C30 126.253 25.7467 122 20.5 122C15.2533 122 11 126.253 11 131.5C11 136.747 15.2533 141 20.5 141Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26802", children: [
        /* @__PURE__ */ _("g", { id: "Group_3", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5623",
            d: "M143 16.5H8C4.41015 16.5 1.5 19.4101 1.5 23V48C1.5 51.5899 4.41015 54.5 8 54.5H143C146.59 54.5 149.5 51.5899 149.5 48V23C149.5 19.4102 146.59 16.5 143 16.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775_3", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M80 26H54C52.3431 26 51 27.3431 51 29C51 30.6569 52.3431 32 54 32H80C81.6569 32 83 30.6569 83 29C83 27.3431 81.6569 26 80 26Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M98 39H54C52.3431 39 51 40.3431 51 42C51 43.6569 52.3431 45 54 45H98C99.6569 45 101 43.6569 101 42C101 40.3431 99.6569 39 98 39Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ _("g", { id: "Group 26801", children: /* @__PURE__ */ _("g", { id: "Group 26756_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 647_2",
            d: "M33.5 45C38.7467 45 43 40.7467 43 35.5C43 30.2533 38.7467 26 33.5 26C28.2533 26 24 30.2533 24 35.5C24 40.7467 28.2533 45 33.5 45Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] })
    ] })
  }
), xW = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 169,
    viewBox: "0 0 150 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/02", children: [
      /* @__PURE__ */ Z("g", { id: "Mask Group 1", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 652",
            d: "M75 158C116.421 158 150 124.421 150 83C150 41.5786 116.421 8 75 8C33.5786 8 0 41.5786 0 83C0 124.421 33.5786 158 75 158Z",
            className: "fill-[theme(backgroundColor.foundations-subtler)]"
          }
        ),
        /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5615",
            d: "M118 49.5H32C28.4101 49.5 25.5 52.4101 25.5 56V161C25.5 164.59 28.4101 167.5 32 167.5H118C121.59 167.5 124.5 164.59 124.5 161V56C124.5 52.4101 121.59 49.5 118 49.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26776", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617",
              d: "M65 66H39C37.3431 66 36 67.3431 36 69C36 70.6569 37.3431 72 39 72H65C66.6569 72 68 70.6569 68 69C68 67.3431 66.6569 66 65 66Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618",
              d: "M83 79H39C37.3431 79 36 80.3431 36 82C36 83.6569 37.3431 85 39 85H83C84.6569 85 86 83.6569 86 82C86 80.3431 84.6569 79 83 79Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26777", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M65 93H39C37.3431 93 36 94.3431 36 96C36 97.6569 37.3431 99 39 99H65C66.6569 99 68 97.6569 68 96C68 94.3431 66.6569 93 65 93Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M83 106H39C37.3431 106 36 107.343 36 109C36 110.657 37.3431 112 39 112H83C84.6569 112 86 110.657 86 109C86 107.343 84.6569 106 83 106Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ Z("g", { id: "Group 26778", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M65 120H39C37.3431 120 36 121.343 36 123C36 124.657 37.3431 126 39 126H65C66.6569 126 68 124.657 68 123C68 121.343 66.6569 120 65 120Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M83 133H39C37.3431 133 36 134.343 36 136C36 137.657 37.3431 139 39 139H83C84.6569 139 86 137.657 86 136C86 134.343 84.6569 133 83 133Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26779", children: [
        /* @__PURE__ */ _("g", { id: "Group_2", children: /* @__PURE__ */ _(
          "path",
          {
            id: "Rectangle 5616",
            d: "M118 0H32C29.2386 0 27 2.23858 27 5V35C27 37.7614 29.2386 40 32 40H118C120.761 40 123 37.7614 123 35V5C123 2.23858 120.761 0 118 0Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ Z("g", { id: "Group 26775", children: [
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5617_4",
              d: "M65 11H39C37.3431 11 36 12.3431 36 14C36 15.6569 37.3431 17 39 17H65C66.6569 17 68 15.6569 68 14C68 12.3431 66.6569 11 65 11Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ _(
            "path",
            {
              id: "Rectangle 5618_4",
              d: "M83 24H39C37.3431 24 36 25.3431 36 27C36 28.6569 37.3431 30 39 30H83C84.6569 30 86 28.6569 86 27C86 25.3431 84.6569 24 83 24Z",
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] })
      ] })
    ] })
  }
), CW = (e) => /* @__PURE__ */ _(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 169,
    viewBox: "0 0 158 169",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ Z("g", { id: "Illustrations/Empty States/03", children: [
      /* @__PURE__ */ _(
        "path",
        {
          id: "Ellipse 652",
          d: "M79 158C122.63 158 158 122.63 158 79C158 35.3695 122.63 0 79 0C35.3695 0 0 35.3695 0 79C0 122.63 35.3695 158 79 158Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Group", children: /* @__PURE__ */ _("g", { id: "Mask Group", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5615",
          d: "M122 49.5H36C32.4101 49.5 29.5 52.4101 29.5 56V161C29.5 164.59 32.4101 167.5 36 167.5H122C125.59 167.5 128.5 164.59 128.5 161V56C128.5 52.4101 125.59 49.5 122 49.5Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ) }) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5617",
          d: "M70 61H44C42.3431 61 41 62.3431 41 64C41 65.6569 42.3431 67 44 67H70C71.6569 67 73 65.6569 73 64C73 62.3431 71.6569 61 70 61Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5620",
          d: "M70 103H44C42.3431 103 41 104.343 41 106C41 107.657 42.3431 109 44 109H70C71.6569 109 73 107.657 73 106C73 104.343 71.6569 103 70 103Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ _("g", { id: "Rectangle 5618", children: /* @__PURE__ */ _(
        "path",
        {
          id: "Vector",
          d: "M112 76H46C43.7909 76 42 77.7909 42 80V90C42 92.2091 43.7909 94 46 94H112C114.209 94 116 92.2091 116 90V80C116 77.7909 114.209 76 112 76Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          id: "Rectangle 5619",
          d: "M112 117H46C43.2386 117 41 119.239 41 122V130C41 132.761 43.2386 135 46 135H112C114.761 135 117 132.761 117 130V122C117 119.239 114.761 117 112 117Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ Z("g", { id: "Group 26781", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 654",
            d: "M57 40C59.2091 40 61 38.2091 61 36C61 33.7909 59.2091 32 57 32C54.7909 32 53 33.7909 53 36C53 38.2091 54.7909 40 57 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 655",
            d: "M79 40C81.2091 40 83 38.2091 83 36C83 33.7909 81.2091 32 79 32C76.7909 32 75 33.7909 75 36C75 38.2091 76.7909 40 79 40Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 656",
            d: "M101 40C103.209 40 105 38.2091 105 36C105 33.7909 103.209 32 101 32C98.7909 32 97 33.7909 97 36C97 38.2091 98.7909 40 101 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        )
      ] }),
      /* @__PURE__ */ Z("g", { id: "Group 26782", children: [
        /* @__PURE__ */ _(
          "path",
          {
            id: "Ellipse 658",
            d: "M90 96C92.7614 96 95 93.7614 95 91C95 88.2386 92.7614 86 90 86C87.2386 86 85 88.2386 85 91C85 93.7614 87.2386 96 90 96Z",
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)]"
          }
        ),
        /* @__PURE__ */ _(
          "path",
          {
            id: "Path 25916",
            d: "M93.9071 112.37C93.1071 112.37 92.3601 112.37 91.6801 112.327C90.8425 112.27 90.0367 111.984 89.3515 111.499C88.6662 111.014 88.128 110.349 87.7961 109.578L83.5771 101.24C83.2676 100.88 83.1131 100.412 83.1472 99.938C83.1813 99.4643 83.4012 99.0233 83.7591 98.711C84.0522 98.4754 84.418 98.3485 84.7941 98.352C85.071 98.3601 85.3428 98.4281 85.5909 98.5513C85.839 98.6746 86.0574 98.8502 86.2311 99.066L88.1471 101.681L88.1761 101.715V91.78C88.1761 91.2871 88.3719 90.8144 88.7204 90.4659C89.069 90.1173 89.5417 89.9215 90.0346 89.9215C90.5275 89.9215 91.0002 90.1173 91.3487 90.4659C91.6973 90.8144 91.8931 91.2871 91.8931 91.78V98.28C91.8715 98.0408 91.9 97.7998 91.9767 97.5722C92.0534 97.3446 92.1767 97.1355 92.3387 96.9582C92.5007 96.781 92.6979 96.6394 92.9176 96.5425C93.1374 96.4456 93.3749 96.3956 93.6151 96.3956C93.8552 96.3956 94.0928 96.4456 94.3125 96.5425C94.5323 96.6394 94.7294 96.781 94.8914 96.9582C95.0534 97.1355 95.1767 97.3446 95.2535 97.5722C95.3302 97.7998 95.3587 98.0408 95.3371 98.28V99.635C95.3155 99.3958 95.344 99.1548 95.4207 98.9272C95.4974 98.6996 95.6207 98.4905 95.7827 98.3132C95.9447 98.136 96.1419 97.9944 96.3616 97.8975C96.5814 97.8006 96.8189 97.7506 97.0591 97.7506C97.2992 97.7506 97.5368 97.8006 97.7565 97.8975C97.9763 97.9944 98.1734 98.136 98.3354 98.3132C98.4974 98.4905 98.6207 98.6996 98.6975 98.9272C98.7742 99.1548 98.8027 99.3958 98.7811 99.635V100.679C98.7595 100.44 98.788 100.199 98.8647 99.9712C98.9414 99.7436 99.0647 99.5345 99.2267 99.3572C99.3887 99.18 99.5859 99.0384 99.8056 98.9415C100.025 98.8446 100.263 98.7946 100.503 98.7946C100.743 98.7946 100.981 98.8446 101.201 98.9415C101.42 99.0384 101.617 99.18 101.779 99.3572C101.941 99.5345 102.065 99.7436 102.141 99.9712C102.218 100.199 102.247 100.44 102.225 100.679V107.016C102.191 108.965 101.31 112.251 98.2111 112.251C97.9861 112.261 96.0801 112.371 93.9111 112.371L93.9071 112.37Z",
            className: "fill-[theme(backgroundColor.foundations-bold)] stroke-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] })
    ] })
  }
), EW = (e) => /* @__PURE__ */ Z(
  "svg",
  {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ _("g", { clipPath: "url(#clip0_22879_245463)", children: /* @__PURE__ */ _(
        "path",
        {
          d: "M73.4 66.7992C73.4 65.9156 74.1163 65.1992 75 65.1992C75.8837 65.1992 76.6 65.9156 76.6 66.7992V75.5992C76.6 76.041 76.9582 76.3992 77.4 76.3992C77.8418 76.3992 78.2 76.041 78.2 75.5992V68.3992C78.2 67.5156 78.9163 66.7992 79.8 66.7992C80.6837 66.7992 81.4 67.5156 81.4 68.3992V75.5992C81.4 76.041 81.7582 76.3992 82.2 76.3992C82.6418 76.3992 83 76.041 83 75.5992V71.5992C83 70.7156 83.7163 69.9992 84.6 69.9992C85.4837 69.9992 86.2 70.7156 86.2 71.5992V79.5992C86.2 85.7848 81.1856 90.7992 75 90.7992C68.8144 90.7992 63.8 85.7848 63.8 79.5992V76.3992C63.8 75.5156 64.5163 74.7992 65.4 74.7992C66.2837 74.7992 67 75.5156 67 76.3992V80.3992C67 80.841 67.3582 81.1992 67.8 81.1992C68.2418 81.1992 68.6 80.841 68.6 80.3992V68.3992C68.6 67.5156 69.3163 66.7992 70.2 66.7992C71.0837 66.7992 71.8 67.5156 71.8 68.3992V75.5992C71.8 76.041 72.1582 76.3992 72.6 76.3992C73.0418 76.3992 73.4 76.041 73.4 75.5992V66.7992Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _(
        "path",
        {
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", { id: "clip0_22879_245463", children: /* @__PURE__ */ _(
        "rect",
        {
          width: "32",
          height: "32",
          className: "fill-[theme(backgroundColor.foundations-default)]",
          transform: "translate(59 62)"
        }
      ) }) })
    ]
  }
), o4 = (e, t = 5, n = "*") => {
  const r = String(e), o = n.repeat(
    Math.max(r.length - t, 3)
  );
  return r.slice(0, t) + o;
};
function s4(e, t) {
  return /* @__PURE__ */ b.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ b.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }));
}
const i4 = b.forwardRef(s4), a4 = i4, yx = () => {
  const [e, t] = _t(null), [n, r] = _t(!1);
  return Ke(() => {
    if (!n)
      return;
    const s = setTimeout(() => {
      r(!1);
    }, 1500);
    return () => clearTimeout(s);
  }, [n]), { copiedText: e, copy: async (s) => {
    try {
      return await navigator.clipboard.writeText(s), t(s), r(!0), !0;
    } catch (i) {
      return console.warn("Copy failed", i), t(null), !1;
    }
  }, isCopied: n };
}, c4 = ({
  text: e,
  className: t,
  size: n,
  iconClassName: r
}) => {
  const [o, s] = b.useState(!1), { copy: i, isCopied: a } = yx();
  return /* @__PURE__ */ Z(Rt, { open: o, children: [
    /* @__PURE__ */ _(
      Rt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          Di,
          {
            size: n,
            className: le("inline-flex shrink-0 px-1 py-0.5", t),
            onMouseEnter: () => s(!0),
            onMouseLeave: () => s(!1),
            onFocus: () => s(!0),
            onBlur: () => s(!1),
            variant: "tertiary",
            onClick: (c) => {
              c.stopPropagation(), a || i(e);
            }
          }
        ),
        children: a ? /* @__PURE__ */ _(a4, { className: le("text-success", r) }) : /* @__PURE__ */ _(Fy, { className: r })
      }
    ),
    /* @__PURE__ */ _(Rt.Popup, { size: "sm", children: a ? "Copied!" : "Copy" })
  ] });
}, wx = At(
  ({
    type: e = "text",
    value: t,
    defaultValue: n,
    name: r,
    label: o,
    helpText: s,
    onChange: i,
    onFocus: a,
    onBlur: c,
    icon: l,
    className: u,
    containerClassName: d,
    readOnly: f,
    copyable: h,
    encrypted: p,
    nativeChangeEvent: g,
    ...m
  }, y) => {
    const [v, w] = _t(
      !(t || n)
    ), [C, x] = _t(!1), [E, S] = _t(!1), M = p && !v, T = fr(
      () => M ? o4(t || "") : t,
      [M, t]
    );
    return /* @__PURE__ */ Z("div", { className: d, children: [
      o && /* @__PURE__ */ _(
        "label",
        {
          htmlFor: r,
          className: "mb-4 block text-sm font-medium text-foundations-bold",
          children: o
        }
      ),
      /* @__PURE__ */ Z("div", { className: "relative block", children: [
        /* @__PURE__ */ _(
          "input",
          {
            type: M ? "text" : e,
            name: r,
            id: r,
            ref: y,
            defaultValue: n,
            value: T,
            placeholder: "Type your method...",
            onChange: (k) => {
              g ? i(k) : i(k.currentTarget.value, k);
            },
            className: le(
              "peer block w-full min-w-0 flex-1 rounded-md border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
              l ? "pl-8" : "",
              h && p ? "pr-[68px] truncate" : h || p ? "pr-9 truncate" : "",
              u
            ),
            readOnly: f || M,
            onFocus: (k) => {
              a == null || a(k), S(!0), v || x(!0);
            },
            onBlur: (k) => {
              c == null || c(k), S(!1);
            },
            ...m
          }
        ),
        /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-2 flex transform items-center text-foundations-subtler peer-focus:text-blue-500", children: l }),
        (h || p) && /* @__PURE__ */ Z("div", { className: "absolute inset-y-0 right-2 flex items-center justify-center gap-2 text-foundations-subtler peer-focus:text-blue-500", children: [
          p && /* @__PURE__ */ Z(
            Rt,
            {
              open: C,
              onOpenChange: (k) => x(k),
              children: [
                /* @__PURE__ */ _(
                  Rt.Trigger,
                  {
                    onClick: () => {
                      x(!1), w((k) => !k);
                    },
                    "data-testid": "reveal-input",
                    children: v ? /* @__PURE__ */ _(_k, { className: "h-5 w-5" }) : /* @__PURE__ */ _(Sk, { className: "h-5 w-5" })
                  }
                ),
                /* @__PURE__ */ _(Rt.Popup, { size: "sm", children: E && !v ? "Reveal first to be able to edit" : v ? "Hide" : "Reveal" })
              ]
            }
          ),
          h && /* @__PURE__ */ _(c4, { text: t ?? "", iconClassName: "h-5 w-5" })
        ] })
      ] }),
      s && /* @__PURE__ */ _(
        "p",
        {
          className: "mt-2 text-sm text-foundations-subtler",
          id: "email-description",
          children: s
        }
      )
    ] });
  }
);
wx.displayName = "Input";
var l4 = Object.defineProperty, u4 = Object.defineProperties, d4 = Object.getOwnPropertyDescriptors, nl = Object.getOwnPropertySymbols, xx = Object.prototype.hasOwnProperty, Cx = Object.prototype.propertyIsEnumerable, Yb = (e, t, n) => t in e ? l4(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, f4 = (e, t) => {
  for (var n in t || (t = {}))
    xx.call(t, n) && Yb(e, n, t[n]);
  if (nl)
    for (var n of nl(t))
      Cx.call(t, n) && Yb(e, n, t[n]);
  return e;
}, h4 = (e, t) => u4(e, d4(t)), p4 = (e, t) => {
  var n = {};
  for (var r in e)
    xx.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && nl)
    for (var r of nl(e))
      t.indexOf(r) < 0 && Cx.call(e, r) && (n[r] = e[r]);
  return n;
};
function g4(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), r = setTimeout(e, 50);
  return [t, n, r];
}
function m4(e) {
  let t = b.useRef();
  return b.useEffect(() => {
    t.current = e;
  }), t.current;
}
var b4 = 18, Ex = 40, v4 = `${Ex}px`, y4 = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function w4({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: r }) {
  let [o, s] = b.useState(!1), [i, a] = b.useState(!1), [c, l] = b.useState(!1), u = b.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && o && i, [o, i, n]), d = b.useCallback(() => {
    let f = e.current, h = t.current;
    if (!f || !h || c || n === "none")
      return;
    let p = f, g = p.getBoundingClientRect().left + p.offsetWidth, m = p.getBoundingClientRect().top + p.offsetHeight / 2, y = g - b4, v = m;
    document.querySelectorAll(y4).length === 0 && document.elementFromPoint(y, v) === f || (s(!0), l(!0));
  }, [e, t, c, n]);
  return b.useEffect(() => {
    let f = e.current;
    if (!f || n === "none")
      return;
    function h() {
      let g = window.innerWidth - f.getBoundingClientRect().right;
      a(g >= Ex);
    }
    h();
    let p = setInterval(h, 1e3);
    return () => {
      clearInterval(p);
    };
  }, [e, n]), b.useEffect(() => {
    let f = r || document.activeElement === t.current;
    if (n === "none" || !f)
      return;
    let h = setTimeout(d, 0), p = setTimeout(d, 2e3), g = setTimeout(d, 5e3), m = setTimeout(() => {
      l(!0);
    }, 6e3);
    return () => {
      clearTimeout(h), clearTimeout(p), clearTimeout(g), clearTimeout(m);
    };
  }, [t, r, n, d]), { hasPWMBadge: o, willPushPWMBadge: u, PWM_BADGE_SPACE_WIDTH: v4 };
}
var x4 = b.createContext({}), _x = b.forwardRef((e, t) => {
  var n = e, { value: r, onChange: o, maxLength: s, textAlign: i = "left", pattern: a, placeholder: c, inputMode: l = "numeric", onComplete: u, pushPasswordManagerStrategy: d = "increase-width", pasteTransformer: f, containerClassName: h, noScriptCSSFallback: p = C4, render: g, children: m } = n, y = p4(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), v, w, C, x, E;
  let [S, M] = b.useState(typeof y.defaultValue == "string" ? y.defaultValue : ""), T = r ?? S, P = m4(T), k = b.useCallback((ee) => {
    o == null || o(ee), M(ee);
  }, [o]), I = b.useMemo(() => a ? typeof a == "string" ? new RegExp(a) : a : null, [a]), O = b.useRef(null), A = b.useRef(null), R = b.useRef({ value: T, onChange: k, isIOS: typeof window < "u" && ((w = (v = window == null ? void 0 : window.CSS) == null ? void 0 : v.supports) == null ? void 0 : w.call(v, "-webkit-touch-callout", "none")) }), N = b.useRef({ prev: [(C = O.current) == null ? void 0 : C.selectionStart, (x = O.current) == null ? void 0 : x.selectionEnd, (E = O.current) == null ? void 0 : E.selectionDirection] });
  b.useImperativeHandle(t, () => O.current, []), b.useEffect(() => {
    let ee = O.current, ne = A.current;
    if (!ee || !ne)
      return;
    R.current.value !== ee.value && R.current.onChange(ee.value), N.current.prev = [ee.selectionStart, ee.selectionEnd, ee.selectionDirection];
    function de() {
      if (document.activeElement !== ee) {
        j(null), K(null);
        return;
      }
      let se = ee.selectionStart, ke = ee.selectionEnd, we = ee.selectionDirection, Oe = ee.maxLength, Ie = ee.value, fe = N.current.prev, q = -1, te = -1, oe;
      if (Ie.length !== 0 && se !== null && ke !== null) {
        let Me = se === ke, qe = se === Ie.length && Ie.length < Oe;
        if (Me && !qe) {
          let Ze = se;
          if (Ze === 0)
            q = 0, te = 1, oe = "forward";
          else if (Ze === Oe)
            q = Ze - 1, te = Ze, oe = "backward";
          else if (Oe > 1 && Ie.length > 1) {
            let nt = 0;
            if (fe[0] !== null && fe[1] !== null) {
              oe = Ze < fe[1] ? "backward" : "forward";
              let Kt = fe[0] === fe[1] && fe[0] < Oe;
              oe === "backward" && !Kt && (nt = -1);
            }
            q = nt + Ze, te = nt + Ze + 1;
          }
        }
        q !== -1 && te !== -1 && q !== te && O.current.setSelectionRange(q, te, oe);
      }
      let re = q !== -1 ? q : se, ve = te !== -1 ? te : ke, xe = oe ?? we;
      j(re), K(ve), N.current.prev = [re, ve, xe];
    }
    if (document.addEventListener("selectionchange", de, { capture: !0 }), de(), document.activeElement === ee && D(!0), !document.getElementById("input-otp-style")) {
      let se = document.createElement("style");
      if (se.id = "input-otp-style", document.head.appendChild(se), se.sheet) {
        let ke = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        si(se.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), si(se.sheet, `[data-input-otp]:autofill { ${ke} }`), si(se.sheet, `[data-input-otp]:-webkit-autofill { ${ke} }`), si(se.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), si(se.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let pe = () => {
      ne && ne.style.setProperty("--root-height", `${ee.clientHeight}px`);
    };
    pe();
    let Ee = new ResizeObserver(pe);
    return Ee.observe(ee), () => {
      document.removeEventListener("selectionchange", de, { capture: !0 }), Ee.disconnect();
    };
  }, []);
  let [$, F] = b.useState(!1), [V, D] = b.useState(!1), [H, j] = b.useState(null), [U, K] = b.useState(null);
  b.useEffect(() => {
    g4(() => {
      var ee, ne, de, pe;
      (ee = O.current) == null || ee.dispatchEvent(new Event("input"));
      let Ee = (ne = O.current) == null ? void 0 : ne.selectionStart, se = (de = O.current) == null ? void 0 : de.selectionEnd, ke = (pe = O.current) == null ? void 0 : pe.selectionDirection;
      Ee !== null && se !== null && (j(Ee), K(se), N.current.prev = [Ee, se, ke]);
    });
  }, [T, V]), b.useEffect(() => {
    P !== void 0 && T !== P && P.length < s && T.length === s && (u == null || u(T));
  }, [s, u, P, T]);
  let G = w4({ containerRef: A, inputRef: O, pushPasswordManagerStrategy: d, isFocused: V }), B = b.useCallback((ee) => {
    let ne = ee.currentTarget.value.slice(0, s);
    if (ne.length > 0 && I && !I.test(ne)) {
      ee.preventDefault();
      return;
    }
    typeof P == "string" && ne.length < P.length && document.dispatchEvent(new Event("selectionchange")), k(ne);
  }, [s, k, P, I]), z = b.useCallback(() => {
    var ee;
    if (O.current) {
      let ne = Math.min(O.current.value.length, s - 1), de = O.current.value.length;
      (ee = O.current) == null || ee.setSelectionRange(ne, de), j(ne), K(de);
    }
    D(!0);
  }, [s]), W = b.useCallback((ee) => {
    var ne, de;
    let pe = O.current;
    if (!f && (!R.current.isIOS || !ee.clipboardData || !pe))
      return;
    let Ee = ee.clipboardData.getData("text/plain"), se = f ? f(Ee) : Ee;
    ee.preventDefault();
    let ke = (ne = O.current) == null ? void 0 : ne.selectionStart, we = (de = O.current) == null ? void 0 : de.selectionEnd, Oe = (ke !== we ? T.slice(0, ke) + se + T.slice(we) : T.slice(0, ke) + se + T.slice(ke)).slice(0, s);
    if (Oe.length > 0 && I && !I.test(Oe))
      return;
    pe.value = Oe, k(Oe);
    let Ie = Math.min(Oe.length, s - 1), fe = Oe.length;
    pe.setSelectionRange(Ie, fe), j(Ie), K(fe);
  }, [s, k, I, T]), X = b.useMemo(() => ({ position: "relative", cursor: y.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [y.disabled]), J = b.useMemo(() => ({ position: "absolute", inset: 0, width: G.willPushPWMBadge ? `calc(100% + ${G.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: G.willPushPWMBadge ? `inset(0 ${G.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: i, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [G.PWM_BADGE_SPACE_WIDTH, G.willPushPWMBadge, i]), Q = b.useMemo(() => b.createElement("input", h4(f4({ autoComplete: y.autoComplete || "one-time-code" }, y), { "data-input-otp": !0, "data-input-otp-placeholder-shown": T.length === 0 || void 0, "data-input-otp-mss": H, "data-input-otp-mse": U, inputMode: l, pattern: I == null ? void 0 : I.source, "aria-placeholder": c, style: J, maxLength: s, value: T, ref: O, onPaste: (ee) => {
    var ne;
    W(ee), (ne = y.onPaste) == null || ne.call(y, ee);
  }, onChange: B, onMouseOver: (ee) => {
    var ne;
    F(!0), (ne = y.onMouseOver) == null || ne.call(y, ee);
  }, onMouseLeave: (ee) => {
    var ne;
    F(!1), (ne = y.onMouseLeave) == null || ne.call(y, ee);
  }, onFocus: (ee) => {
    var ne;
    z(), (ne = y.onFocus) == null || ne.call(y, ee);
  }, onBlur: (ee) => {
    var ne;
    D(!1), (ne = y.onBlur) == null || ne.call(y, ee);
  } })), [B, z, W, l, J, s, U, H, y, I == null ? void 0 : I.source, T]), Y = b.useMemo(() => ({ slots: Array.from({ length: s }).map((ee, ne) => {
    var de;
    let pe = V && H !== null && U !== null && (H === U && ne === H || ne >= H && ne < U), Ee = T[ne] !== void 0 ? T[ne] : null, se = T[0] !== void 0 ? null : (de = c == null ? void 0 : c[ne]) != null ? de : null;
    return { char: Ee, placeholderChar: se, isActive: pe, hasFakeCaret: pe && Ee === null };
  }), isFocused: V, isHovering: !y.disabled && $ }), [V, $, s, U, H, y.disabled, T]), ce = b.useMemo(() => g ? g(Y) : b.createElement(x4.Provider, { value: Y }, m), [m, Y, g]);
  return b.createElement(b.Fragment, null, p !== null && b.createElement("noscript", null, b.createElement("style", null, p)), b.createElement("div", { ref: A, "data-input-otp-container": !0, style: X, className: h }, ce, b.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, Q)));
});
_x.displayName = "Input";
function si(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var C4 = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`, E4 = "^\\d+$";
const _4 = b.forwardRef(
  ({
    maxLength: e = 6,
    pattern: t = E4,
    value: n,
    onChange: r,
    id: o = b.useId(),
    name: s,
    disabled: i,
    inputMode: a,
    className: c,
    slotClassName: l,
    autoFocus: u = !1,
    onBlur: d,
    onFocus: f
  }, h) => /* @__PURE__ */ _(
    _x,
    {
      "data-slot": "input-otp",
      ref: h,
      id: o,
      name: s,
      maxLength: e,
      pattern: t,
      value: n,
      onChange: r,
      disabled: i,
      inputMode: a,
      autoFocus: u,
      containerClassName: le("flex items-center gap-2", c),
      className: "disabled:cursor-not-allowed",
      render: ({ slots: p }) => p.map((g, m) => /* @__PURE__ */ _(S4, { ...g, className: l }, m)),
      onFocus: f,
      onBlur: d
    }
  )
);
_4.displayName = "InputOTP";
function S4({
  char: e,
  hasFakeCaret: t,
  isActive: n,
  placeholderChar: r,
  className: o
}) {
  return /* @__PURE__ */ Z(
    "div",
    {
      "data-slot": "input-otp-slot",
      "data-active": n,
      className: le(
        "border-input relative flex h-9 w-9 items-center justify-center rounded-md border border-foundations-bold bg-foundations-default text-foundations-boldest outline-none transition-all data-[active=true]:border-info-bold data-[active=true]:ring-1 data-[active=true]:ring-info-bold",
        o
      ),
      children: [
        e || r,
        t && /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ _("div", { className: "h-4 w-px animate-caret-blink bg-foundations-bolder duration-1000" }) })
      ]
    }
  );
}
function Sx(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const O4 = En(
  "cursor-pointer rounded focus:ring-2 focus:ring-offset-0",
  {
    variants: {
      variant: {
        primary: "checked:bg-info-bold indeterminate:bg-info-bold hover:checked:bg-info-bold hover:indeterminate:bg-info-bold focus:checked:bg-info-bold focus:indeterminate:bg-info-bold",
        dark: "checked:bg-foundations-boldest indeterminate:bg-foundations-boldest hover:checked:bg-foundations-boldest hover:indeterminate:bg-foundations-boldest focus:checked:bg-foundations-boldest focus:indeterminate:bg-foundations-boldest"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), Ox = b.forwardRef(
  ({
    disabled: e,
    readOnly: t,
    className: n,
    containerClassName: r,
    label: o,
    description: s,
    isIndeterminate: i = !1,
    variant: a,
    ...c
  }, l) => {
    const u = b.useRef(null);
    return b.useEffect(() => {
      u.current && (u.current.indeterminate = i);
    }, [i]), /* @__PURE__ */ Z(
      "label",
      {
        className: le("flex space-x-2", r),
        "aria-disabled": e,
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              ref: Sx([u, l]),
              className: le(
                O4({ variant: a }),
                o && "mt-0.5",
                e && "cursor-not-allowed border-foundations-subtle checked:bg-foundations-subtle indeterminate:bg-foundations-subtle hover:checked:bg-foundations-subtle hover:indeterminate:bg-foundations-subtle focus:checked:bg-foundations-subtle focus:indeterminate:bg-foundations-subtle",
                n
              ),
              type: "checkbox",
              disabled: e || t,
              readOnly: t,
              ...c
            }
          ),
          (o || s) && /* @__PURE__ */ Z(
            "div",
            {
              className: le(
                "flex flex-col text-sm",
                e && "cursor-not-allowed opacity-50"
              ),
              children: [
                o && /* @__PURE__ */ _(It, { children: typeof o == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-boldest", children: o }) : o }),
                s && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: s })
              ]
            }
          )
        ]
      }
    );
  }
);
Ox.displayName = "Checkbox";
const M4 = En(
  "group/switch relative inline-flex rounded-full border-2 border-transparent bg-foundations-bold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-info-bold focus:ring-offset-2 focus:ring-offset-[theme(backgroundColor.foundations-default)] aria-[disabled=true]:cursor-not-allowed aria-[disabled=true]:bg-foundations-subtlest data-[checked]:bg-info-bold",
  {
    variants: {
      size: {
        default: "h-6 w-11",
        sm: "h-4 w-[30px]"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), T4 = En(
  "block translate-x-0 rounded-full bg-white transition-transform duration-200 will-change-transform",
  {
    variants: {
      size: {
        default: "h-5 w-5",
        sm: "h-3 w-3"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), _W = b.forwardRef(({ className: e, children: t, size: n = "default", ...r }, o) => {
  const s = !!t;
  return /* @__PURE__ */ Z(
    nx,
    {
      "data-slot": "switch",
      ref: o,
      className: le(
        M4({ size: n }),
        s && (n === "sm" ? "w-[38px]" : "w-14"),
        e
      ),
      ...r,
      children: [
        t && /* @__PURE__ */ _(
          "span",
          {
            className: le(
              "absolute inset-y-0 left-auto z-0 inline-flex items-center font-medium tracking-wider text-foundations-subtle group-data-[checked]/switch:left-1 group-data-[checked]/switch:right-auto group-data-[checked]/switch:text-neutral-white",
              n === "sm" ? "right-0.5 text-[10px]" : "right-1 text-xs"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ _(
          rx,
          {
            "data-slot": "switch-thumb",
            className: le(
              T4({ size: n }),
              s ? n === "sm" ? "data-[checked]:translate-x-[22px]" : "data-[checked]:translate-x-8" : n === "sm" ? "data-[checked]:translate-x-[14px]" : "data-[checked]:translate-x-5"
            )
          }
        )
      ]
    }
  );
}), k4 = b.forwardRef(
  ({ className: e, label: t, description: n, ...r }, o) => /* @__PURE__ */ Z("label", { className: "flex space-x-2", children: [
    /* @__PURE__ */ _(
      "input",
      {
        ref: o,
        className: le(
          "cursor-pointer border-foundations-subtle checked:border-info-bold checked:bg-info-bold hover:border-foundations-bold hover:checked:bg-info-bolder focus:ring-offset-[theme(backgroundColor.foundations-default)]",
          t && "mt-0.5",
          e
        ),
        type: "radio",
        ...r
      }
    ),
    /* @__PURE__ */ Z("div", { className: "flex flex-col text-sm", children: [
      t && /* @__PURE__ */ _(It, { children: typeof t == "string" ? /* @__PURE__ */ _("span", { className: "font-medium text-foundations-bolder", children: t }) : t }),
      n && /* @__PURE__ */ _("span", { className: "text-foundations-subtle", children: n })
    ] })
  ] })
);
k4.displayName = "Radio";
const P4 = En(
  "group/link inline-flex items-center space-x-1 font-medium transition-colors focus:text-info",
  {
    variants: {
      variant: {
        inline: "text-info underline hover:text-link-hovered",
        standalone: "text-info hover:text-link-hovered hover:underline focus:underline"
      },
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md",
      variant: "standalone"
    }
  }
), Sp = b.forwardRef(
  ({
    className: e,
    children: t,
    size: n,
    variant: r = "standalone",
    showExternalIcon: o = !0,
    truncate: s = !1,
    render: i,
    ...a
  }, c) => {
    const l = {
      className: le(P4({ variant: r, size: n }), e, {
        "max-w-full overflow-hidden": s
      }),
      children: /* @__PURE__ */ Z(It, { children: [
        /* @__PURE__ */ _(Ty, { size: "sm", render: /* @__PURE__ */ _("span", {}), children: t }),
        o && /* @__PURE__ */ _(Ek, { className: "h-4 w-4 flex-shrink-0" })
      ] }),
      "data-slot": "link"
    };
    return Is({
      defaultTagName: "a",
      ref: c,
      render: i,
      props: Zt(l, a)
    });
  }
);
Sp.displayName = "Link";
function pa(e, t = []) {
  let n = [];
  function r(s, i) {
    const a = /* @__PURE__ */ Ii(i), c = n.length;
    n = [
      ...n,
      i
    ];
    function l(d) {
      const { scope: f, children: h, ...p } = d, g = (f == null ? void 0 : f[e][c]) || a, m = fr(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ Le(g.Provider, {
        value: m
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[e][c]) || a, p = bl(h);
      if (p)
        return p;
      if (i !== void 0)
        return i;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return l.displayName = s + "Provider", [
      l,
      u
    ];
  }
  const o = () => {
    const s = n.map((i) => /* @__PURE__ */ Ii(i));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || s;
      return fr(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: c
          }
        }),
        [
          a,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    R4(o, ...t)
  ];
}
function R4(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(s) {
      const i = r.reduce((a, { useScope: c, scopeName: l }) => {
        const d = c(s)[`__scope${l}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return fr(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function pn(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function I4(e) {
  const t = e + "CollectionProvider", [n, r] = pa(t), [o, s] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), i = (h) => {
    const { scope: p, children: g } = h, m = ie.useRef(null), y = ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ ie.createElement(o, {
      scope: p,
      itemMap: y,
      collectionRef: m
    }, g);
  }, a = e + "CollectionSlot", c = /* @__PURE__ */ ie.forwardRef((h, p) => {
    const { scope: g, children: m } = h, y = s(a, g), v = vr(p, y.collectionRef);
    return /* @__PURE__ */ ie.createElement(Os, {
      ref: v
    }, m);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ ie.forwardRef((h, p) => {
    const { scope: g, children: m, ...y } = h, v = ie.useRef(null), w = vr(p, v), C = s(l, g);
    return ie.useEffect(() => (C.itemMap.set(v, {
      ref: v,
      ...y
    }), () => void C.itemMap.delete(v))), /* @__PURE__ */ ie.createElement(Os, {
      [u]: "",
      ref: w
    }, m);
  });
  function f(h) {
    const p = s(e + "CollectionConsumer", h);
    return ie.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m)
        return [];
      const y = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (C, x) => y.indexOf(C.ref.current) - y.indexOf(x.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: i,
      Slot: c,
      ItemSlot: d
    },
    f,
    r
  ];
}
const Ms = globalThis != null && globalThis.document ? Rs : () => {
}, D4 = b["useId".toString()] || (() => {
});
let N4 = 0;
function Mx(e) {
  const [t, n] = b.useState(D4());
  return Ms(() => {
    e || n(
      (r) => r ?? String(N4++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function zr(e) {
  const t = Ue(e);
  return Ke(() => {
    t.current = e;
  }), fr(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function ga({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = A4({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, i = s ? e : r, a = zr(n), c = je((l) => {
    if (s) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && a(d);
    } else
      o(l);
  }, [
    s,
    e,
    o,
    a
  ]);
  return [
    i,
    c
  ];
}
function A4({ defaultProp: e, onChange: t }) {
  const n = _t(e), [r] = n, o = Ue(r), s = zr(t);
  return Ke(() => {
    o.current !== r && (s(r), o.current = r);
  }, [
    r,
    o,
    s
  ]), n;
}
const $4 = /* @__PURE__ */ Ii(void 0);
function Tx(e) {
  const t = bl($4);
  return e || t || "ltr";
}
const rd = "rovingFocusGroup.onEntryFocus", F4 = {
  bubbles: !1,
  cancelable: !0
}, Op = "RovingFocusGroup", [uf, kx, L4] = I4(Op), [V4, Px] = pa(Op, [
  L4
]), [W4, B4] = V4(Op), H4 = /* @__PURE__ */ At((e, t) => /* @__PURE__ */ Le(uf.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Le(uf.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ Le(Y4, et({}, e, {
  ref: t
}))))), Y4 = /* @__PURE__ */ At((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: s, currentTabStopId: i, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: c, onEntryFocus: l, ...u } = e, d = Ue(null), f = vr(t, d), h = Tx(s), [p = null, g] = ga({
    prop: i,
    defaultProp: a,
    onChange: c
  }), [m, y] = _t(!1), v = zr(l), w = kx(n), C = Ue(!1), [x, E] = _t(0);
  return Ke(() => {
    const S = d.current;
    if (S)
      return S.addEventListener(rd, v), () => S.removeEventListener(rd, v);
  }, [
    v
  ]), /* @__PURE__ */ Le(W4, {
    scope: n,
    orientation: r,
    dir: h,
    loop: o,
    currentTabStopId: p,
    onItemFocus: je(
      (S) => g(S),
      [
        g
      ]
    ),
    onItemShiftTab: je(
      () => y(!0),
      []
    ),
    onFocusableItemAdd: je(
      () => E(
        (S) => S + 1
      ),
      []
    ),
    onFocusableItemRemove: je(
      () => E(
        (S) => S - 1
      ),
      []
    )
  }, /* @__PURE__ */ Le(Nn.div, et({
    tabIndex: m || x === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: pn(e.onMouseDown, () => {
      C.current = !0;
    }),
    onFocus: pn(e.onFocus, (S) => {
      const M = !C.current;
      if (S.target === S.currentTarget && M && !m) {
        const T = new CustomEvent(rd, F4);
        if (S.currentTarget.dispatchEvent(T), !T.defaultPrevented) {
          const P = w().filter(
            (R) => R.focusable
          ), k = P.find(
            (R) => R.active
          ), I = P.find(
            (R) => R.id === p
          ), A = [
            k,
            I,
            ...P
          ].filter(Boolean).map(
            (R) => R.ref.current
          );
          Rx(A);
        }
      }
      C.current = !1;
    }),
    onBlur: pn(
      e.onBlur,
      () => y(!1)
    )
  })));
}), z4 = "RovingFocusGroupItem", j4 = /* @__PURE__ */ At((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: s, ...i } = e, a = Mx(), c = s || a, l = B4(z4, n), u = l.currentTabStopId === c, d = kx(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = l;
  return Ke(() => {
    if (r)
      return f(), () => h();
  }, [
    r,
    f,
    h
  ]), /* @__PURE__ */ Le(uf.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: o
  }, /* @__PURE__ */ Le(Nn.span, et({
    tabIndex: u ? 0 : -1,
    "data-orientation": l.orientation
  }, i, {
    ref: t,
    onMouseDown: pn(e.onMouseDown, (p) => {
      r ? l.onItemFocus(c) : p.preventDefault();
    }),
    onFocus: pn(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: pn(e.onKeyDown, (p) => {
      if (p.key === "Tab" && p.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (p.target !== p.currentTarget)
        return;
      const g = K4(p, l.orientation, l.dir);
      if (g !== void 0) {
        p.preventDefault();
        let y = d().filter(
          (v) => v.focusable
        ).map(
          (v) => v.ref.current
        );
        if (g === "last")
          y.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && y.reverse();
          const v = y.indexOf(p.currentTarget);
          y = l.loop ? q4(y, v + 1) : y.slice(v + 1);
        }
        setTimeout(
          () => Rx(y)
        );
      }
    })
  })));
}), U4 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function G4(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function K4(e, t, n) {
  const r = G4(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return U4[r];
}
function Rx(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function q4(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const X4 = H4, Z4 = j4, Q4 = /* @__PURE__ */ At((e, t) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...s } = e, [i = !1, a] = ga({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ Le(Nn.button, et({
    type: "button",
    "aria-pressed": i,
    "data-state": i ? "on" : "off",
    "data-disabled": e.disabled ? "" : void 0
  }, s, {
    ref: t,
    onClick: pn(e.onClick, () => {
      e.disabled || a(!i);
    })
  }));
}), fu = "ToggleGroup", [Ix, SW] = pa(fu, [
  Px
]), Dx = Px(), J4 = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ ie.createElement(e9, et({}, o, {
      ref: t
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ ie.createElement(t9, et({}, o, {
      ref: t
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${fu}\``);
}), [Nx, Ax] = Ix(fu), e9 = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...s } = e, [i, a] = ga({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ ie.createElement(Nx, {
    scope: e.__scopeToggleGroup,
    type: "single",
    value: i ? [
      i
    ] : [],
    onItemActivate: a,
    onItemDeactivate: ie.useCallback(
      () => a(""),
      [
        a
      ]
    )
  }, /* @__PURE__ */ ie.createElement($x, et({}, s, {
    ref: t
  })));
}), t9 = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...s } = e, [i = [], a] = ga({
    prop: n,
    defaultProp: r,
    onChange: o
  }), c = ie.useCallback(
    (u) => a(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      a
    ]
  ), l = ie.useCallback(
    (u) => a(
      (d = []) => d.filter(
        (f) => f !== u
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ ie.createElement(Nx, {
    scope: e.__scopeToggleGroup,
    type: "multiple",
    value: i,
    onItemActivate: c,
    onItemDeactivate: l
  }, /* @__PURE__ */ ie.createElement($x, et({}, s, {
    ref: t
  })));
}), [n9, r9] = Ix(fu), $x = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: s, dir: i, loop: a = !0, ...c } = e, l = Dx(n), u = Tx(i), d = {
    role: "group",
    dir: u,
    ...c
  };
  return /* @__PURE__ */ ie.createElement(n9, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ ie.createElement(X4, et({
    asChild: !0
  }, l, {
    orientation: s,
    dir: u,
    loop: a
  }), /* @__PURE__ */ ie.createElement(Nn.div, et({}, d, {
    ref: t
  }))) : /* @__PURE__ */ ie.createElement(Nn.div, et({}, d, {
    ref: t
  })));
}), df = "ToggleGroupItem", o9 = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const n = Ax(df, e.__scopeToggleGroup), r = r9(df, e.__scopeToggleGroup), o = Dx(e.__scopeToggleGroup), s = n.value.includes(e.value), i = r.disabled || e.disabled, a = {
    ...e,
    pressed: s,
    disabled: i
  }, c = ie.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ ie.createElement(Z4, et({
    asChild: !0
  }, o, {
    focusable: !i,
    active: s,
    ref: c
  }), /* @__PURE__ */ ie.createElement(zb, et({}, a, {
    ref: t
  }))) : /* @__PURE__ */ ie.createElement(zb, et({}, a, {
    ref: t
  }));
}), zb = /* @__PURE__ */ ie.forwardRef((e, t) => {
  const { __scopeToggleGroup: n, value: r, ...o } = e, s = Ax(df, n), i = {
    role: "radio",
    "aria-checked": e.pressed,
    "aria-pressed": void 0
  }, a = s.type === "single" ? i : void 0;
  return /* @__PURE__ */ ie.createElement(Q4, et({}, a, o, {
    ref: t,
    onPressedChange: (c) => {
      c ? s.onItemActivate(r) : s.onItemDeactivate(r);
    }
  }));
}), s9 = J4, i9 = o9, a9 = b.forwardRef(({ onValueChange: e, className: t, canReset: n = !1, error: r, ...o }, s) => /* @__PURE__ */ _(
  s9,
  {
    ref: s,
    className: le(
      "inline-flex flex-shrink-0 space-x-2 rounded-md border border-foundations-subtle p-1",
      r && "border-red-500 focus:border-red-500 focus:ring-red-500",
      t
    ),
    type: "single",
    onValueChange: (i) => {
      (i || n) && e(i);
    },
    ...o
  }
));
a9.displayName = "OptionsGroup";
const c9 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  i9,
  {
    ref: n,
    type: "button",
    className: le(
      "rounded px-2 py-1.5 text-sm font-medium text-foundations-subtle hover:bg-neutral-200 focus:bg-neutral-200 focus:outline-none aria-checked:bg-info-bold aria-checked:text-foundations-inverse aria-checked:focus:bg-info-bolder",
      e
    ),
    ...t
  }
));
c9.displayName = "Option";
function l9(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const od = {}, vi = {};
function Ir(e, t) {
  try {
    const r = (od[e] || (od[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1];
    return r in vi ? vi[r] : jb(r, r.split(":"));
  } catch {
    if (e in vi)
      return vi[e];
    const n = e == null ? void 0 : e.match(u9);
    return n ? jb(e, n.slice(1)) : NaN;
  }
}
const u9 = /([+-]\d\d):?(\d\d)?/;
function jb(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return vi[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class ur extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Ir(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Fx(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new ur(...n, t) : new ur(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new ur(+this, t);
  }
  getTimezoneOffset() {
    const t = -Ir(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), rl(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new ur(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ub = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Ub.test(e))
    return;
  const t = e.replace(Ub, "$1UTC");
  ur.prototype[t] && (e.startsWith("get") ? ur.prototype[e] = function() {
    return this.internal[t]();
  } : (ur.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), d9(this), +this;
  }, ur.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), rl(this), +this;
  }));
});
function rl(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-Ir(e.timeZone, e) * 60));
}
function d9(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Fx(e);
}
function Fx(e, t) {
  const n = Array.isArray(t) ? f9(t) : +e.internal, r = Ir(e.timeZone, e), o = r > 0 ? Math.floor(r) : Math.ceil(r), s = /* @__PURE__ */ new Date(+e);
  s.setUTCHours(s.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+s)).getTimezoneOffset(), c = i - a;
  let l = i;
  if (c && i !== o) {
    const T = Date.prototype.getHours.apply(e), P = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (T !== P) {
      const k = /* @__PURE__ */ new Date(+e), I = i - o;
      I && k.setUTCMinutes(k.getUTCMinutes() + I);
      const O = Ir(e.timeZone, k);
      (O > 0 ? Math.floor(O) : Math.ceil(O)) === o && (l = a);
    }
  }
  const u = l - o;
  u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
  const d = /* @__PURE__ */ new Date(+e);
  d.setUTCSeconds(0);
  const f = i > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, h = Math.round(-(Ir(e.timeZone, e) * 60)) % 60;
  (h || f) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + h + f);
  const p = Ir(e.timeZone, e), g = p > 0 ? Math.floor(p) : Math.ceil(p), y = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - g, v = g !== o, w = y - u, C = g - o, x = n - g * 60 * 1e3, E = C > 0 && Gb(e) - n === C * 60 * 1e3 && Gb(e, x) !== n;
  if (v && w && !E) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + w);
    const T = Ir(e.timeZone, e), P = T > 0 ? Math.floor(T) : Math.ceil(T), k = g - P;
    k && w < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + k);
  }
  rl(e);
  const M = (t ? n : n + h * 1e3) - +e.internal;
  M && Math.abs(M) < 30 * 60 * 1e3 && (Date.prototype.setTime.call(e, +e + M), rl(e));
}
function f9(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function Gb(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-Ir(e.timeZone, n) * 60)), +n;
}
class on extends ur {
  //#region static
  static tz(t, ...n) {
    return n.length ? new on(...n, t) : new on(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${l9(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new on(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new on(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Lx = 6048e5, h9 = 864e5, Kb = Symbol.for("constructDateFrom");
function Qt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Kb in e ? e[Kb](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function St(e, t) {
  return Qt(t || e, e);
}
function Vx(e, t, n) {
  const r = St(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Qt((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Wx(e, t, n) {
  const r = St(e, n == null ? void 0 : n.in);
  if (isNaN(t))
    return Qt((n == null ? void 0 : n.in) || e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), s = Qt((n == null ? void 0 : n.in) || e, r.getTime());
  s.setMonth(r.getMonth() + t + 1, 0);
  const i = s.getDate();
  return o >= i ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    o
  ), r);
}
let p9 = {};
function ma() {
  return p9;
}
function Ts(e, t) {
  var a, c, l, u;
  const n = ma(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = St(e, t == null ? void 0 : t.in), s = o.getDay(), i = (s < r ? 7 : 0) + s - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function Ui(e, t) {
  return Ts(e, { ...t, weekStartsOn: 1 });
}
function Bx(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = Qt(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const s = Ui(o), i = Qt(n, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Ui(i);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= a.getTime() ? r : r - 1;
}
function qb(e) {
  const t = St(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Ls(e, ...t) {
  const n = Qt.bind(
    null,
    e || t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Gi(e, t) {
  const n = St(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Mp(e, t, n) {
  const [r, o] = Ls(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = Gi(r), i = Gi(o), a = +s - qb(s), c = +i - qb(i);
  return Math.round((a - c) / h9);
}
function g9(e, t) {
  const n = Bx(e, t), r = Qt((t == null ? void 0 : t.in) || e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Ui(r);
}
function m9(e, t, n) {
  return Vx(e, t * 7, n);
}
function b9(e, t, n) {
  return Wx(e, t * 12, n);
}
function v9(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Qt.bind(null, o));
    const s = St(o, r);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), Qt(r, n || NaN);
}
function y9(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Qt.bind(null, o));
    const s = St(o, r);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), Qt(r, n || NaN);
}
function w9(e, t, n) {
  const [r, o] = Ls(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Gi(r) == +Gi(o);
}
function Hx(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function x9(e) {
  return !(!Hx(e) && typeof e != "number" || isNaN(+St(e)));
}
function Yx(e, t, n) {
  const [r, o] = Ls(
    n == null ? void 0 : n.in,
    e,
    t
  ), s = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return s * 12 + i;
}
function C9(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function zx(e, t) {
  const [n, r] = Ls(e, t.start, t.end);
  return { start: n, end: r };
}
function E9(e, t) {
  const { start: n, end: r } = zx(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setDate(1);
  let a = (t == null ? void 0 : t.step) ?? 1;
  if (!a)
    return [];
  a < 0 && (a = -a, o = !o);
  const c = [];
  for (; +i <= s; )
    c.push(Qt(n, i)), i.setMonth(i.getMonth() + a);
  return o ? c.reverse() : c;
}
function _9(e, t) {
  const n = St(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function S9(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function jx(e, t) {
  const n = St(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function O9(e, t) {
  const { start: n, end: r } = zx(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, i = o ? r : n;
  i.setHours(0, 0, 0, 0), i.setMonth(0, 1);
  let a = (t == null ? void 0 : t.step) ?? 1;
  if (!a)
    return [];
  a < 0 && (a = -a, o = !o);
  const c = [];
  for (; +i <= s; )
    c.push(Qt(n, i)), i.setFullYear(i.getFullYear() + a);
  return o ? c.reverse() : c;
}
function Ux(e, t) {
  var a, c, l, u;
  const n = ma(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = St(e, t == null ? void 0 : t.in), s = o.getDay(), i = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function M9(e, t) {
  return Ux(e, { ...t, weekStartsOn: 1 });
}
const T9 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, k9 = (e, t, n) => {
  let r;
  const o = T9[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function sd(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const P9 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, R9 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, I9 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, D9 = {
  date: sd({
    formats: P9,
    defaultWidth: "full"
  }),
  time: sd({
    formats: R9,
    defaultWidth: "full"
  }),
  dateTime: sd({
    formats: I9,
    defaultWidth: "full"
  })
}, N9 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, A9 = (e, t, n, r) => N9[e];
function ii(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[a] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[i];
    }
    const s = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[s];
  };
}
const $9 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, F9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, L9 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, V9 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, W9 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, B9 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, H9 = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Y9 = {
  ordinalNumber: H9,
  era: ii({
    values: $9,
    defaultWidth: "wide"
  }),
  quarter: ii({
    values: F9,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ii({
    values: L9,
    defaultWidth: "wide"
  }),
  day: ii({
    values: V9,
    defaultWidth: "wide"
  }),
  dayPeriod: ii({
    values: W9,
    defaultWidth: "wide",
    formattingValues: B9,
    defaultFormattingWidth: "wide"
  })
};
function ai(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = t.match(o);
    if (!s)
      return null;
    const i = s[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(a) ? j9(a, (d) => d.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      z9(a, (d) => d.test(i))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(l)
    ) : l;
    const u = t.slice(i.length);
    return { value: l, rest: u };
  };
}
function z9(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function j9(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function U9(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], s = t.match(e.parsePattern);
    if (!s)
      return null;
    let i = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const a = t.slice(o.length);
    return { value: i, rest: a };
  };
}
const G9 = /^(\d+)(th|st|nd|rd)?/i, K9 = /\d+/i, q9 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, X9 = {
  any: [/^b/i, /^(a|c)/i]
}, Z9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Q9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, J9 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, eA = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, tA = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, nA = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, rA = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, oA = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, sA = {
  ordinalNumber: U9({
    matchPattern: G9,
    parsePattern: K9,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ai({
    matchPatterns: q9,
    defaultMatchWidth: "wide",
    parsePatterns: X9,
    defaultParseWidth: "any"
  }),
  quarter: ai({
    matchPatterns: Z9,
    defaultMatchWidth: "wide",
    parsePatterns: Q9,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ai({
    matchPatterns: J9,
    defaultMatchWidth: "wide",
    parsePatterns: eA,
    defaultParseWidth: "any"
  }),
  day: ai({
    matchPatterns: tA,
    defaultMatchWidth: "wide",
    parsePatterns: nA,
    defaultParseWidth: "any"
  }),
  dayPeriod: ai({
    matchPatterns: rA,
    defaultMatchWidth: "any",
    parsePatterns: oA,
    defaultParseWidth: "any"
  })
}, cs = {
  code: "en-US",
  formatDistance: k9,
  formatLong: D9,
  formatRelative: A9,
  localize: Y9,
  match: sA,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function iA(e, t) {
  const n = St(e, t == null ? void 0 : t.in);
  return Mp(n, jx(n)) + 1;
}
function Tp(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = +Ui(n) - +g9(n);
  return Math.round(r / Lx) + 1;
}
function Gx(e, t) {
  var u, d, f, h;
  const n = St(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = ma(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Qt((t == null ? void 0 : t.in) || e, 0);
  i.setFullYear(r + 1, 0, s), i.setHours(0, 0, 0, 0);
  const a = Ts(i, t), c = Qt((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(r, 0, s), c.setHours(0, 0, 0, 0);
  const l = Ts(c, t);
  return +n >= +a ? r + 1 : +n >= +l ? r : r - 1;
}
function aA(e, t) {
  var a, c, l, u;
  const n = ma(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Gx(e, t), s = Qt((t == null ? void 0 : t.in) || e, 0);
  return s.setFullYear(o, 0, r), s.setHours(0, 0, 0, 0), Ts(s, t);
}
function kp(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = +Ts(n, t) - +aA(n, t);
  return Math.round(r / Lx) + 1;
}
function mt(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const to = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return mt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : mt(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return mt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return mt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return mt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return mt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return mt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return mt(o, t.length);
  }
}, ns = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Xb = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return to.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Gx(e, r), s = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = s % 100;
      return mt(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : mt(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Bx(e);
    return mt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return mt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return mt(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return mt(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return to.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return mt(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = kp(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : mt(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Tp(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : mt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : to.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = iA(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : mt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(s);
      case "ee":
        return mt(s, 2);
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(s);
      case "cc":
        return mt(s, t.length);
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return mt(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = ns.noon : r === 0 ? o = ns.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = ns.evening : r >= 12 ? o = ns.afternoon : r >= 4 ? o = ns.morning : o = ns.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return to.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : to.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : mt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : mt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : to.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : to.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return to.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Qb(r);
      case "XXXX":
      case "XX":
        return Do(r);
      case "XXXXX":
      case "XXX":
      default:
        return Do(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Qb(r);
      case "xxxx":
      case "xx":
        return Do(r);
      case "xxxxx":
      case "xxx":
      default:
        return Do(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Zb(r, ":");
      case "OOOO":
      default:
        return "GMT" + Do(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Zb(r, ":");
      case "zzzz":
      default:
        return "GMT" + Do(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return mt(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return mt(+e, t.length);
  }
};
function Zb(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? n + String(o) : n + String(o) + t + mt(s, 2);
}
function Qb(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + mt(Math.abs(e) / 60, 2) : Do(e, t);
}
function Do(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = mt(Math.trunc(r / 60), 2), s = mt(r % 60, 2);
  return n + o + t + s;
}
const Jb = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Kx = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, cA = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Jb(e, t);
  let s;
  switch (r) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", Jb(r, t)).replace("{{time}}", Kx(o, t));
}, lA = {
  p: Kx,
  P: cA
}, uA = /^D+$/, dA = /^Y+$/, fA = ["D", "DD", "YY", "YYYY"];
function hA(e) {
  return uA.test(e);
}
function pA(e) {
  return dA.test(e);
}
function gA(e, t, n) {
  const r = mA(e, t, n);
  if (console.warn(r), fA.includes(e))
    throw new RangeError(r);
}
function mA(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const bA = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, vA = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yA = /^'([^]*?)'?$/, wA = /''/g, xA = /[a-zA-Z]/;
function yi(e, t, n) {
  var u, d, f, h, p, g, m, y;
  const r = ma(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? cs, s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((y = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : y.weekStartsOn) ?? 0, a = St(e, n == null ? void 0 : n.in);
  if (!x9(a))
    throw new RangeError("Invalid time value");
  let c = t.match(vA).map((v) => {
    const w = v[0];
    if (w === "p" || w === "P") {
      const C = lA[w];
      return C(v, o.formatLong);
    }
    return v;
  }).join("").match(bA).map((v) => {
    if (v === "''")
      return { isToken: !1, value: "'" };
    const w = v[0];
    if (w === "'")
      return { isToken: !1, value: CA(v) };
    if (Xb[w])
      return { isToken: !0, value: v };
    if (w.match(xA))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: v };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(a, c));
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  };
  return c.map((v) => {
    if (!v.isToken)
      return v.value;
    const w = v.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && pA(w) || !(n != null && n.useAdditionalDayOfYearTokens) && hA(w)) && gA(w, t, String(e));
    const C = Xb[w[0]];
    return C(a, w, o.localize, l);
  }).join("");
}
function CA(e) {
  const t = e.match(yA);
  return t ? t[1].replace(wA, "'") : e;
}
function EA(e, t) {
  const n = St(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), s = Qt(n, 0);
  return s.setFullYear(r, o + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function _A(e, t) {
  return St(e, t == null ? void 0 : t.in).getMonth();
}
function SA(e, t) {
  return St(e, t == null ? void 0 : t.in).getFullYear();
}
function OA(e, t) {
  return +St(e) > +St(t);
}
function MA(e, t) {
  return +St(e) < +St(t);
}
function TA(e, t, n) {
  const [r, o] = Ls(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function kA(e, t, n) {
  const [r, o] = Ls(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function PA(e, t, n) {
  const r = St(e, n == null ? void 0 : n.in), o = r.getFullYear(), s = r.getDate(), i = Qt((n == null ? void 0 : n.in) || e, 0);
  i.setFullYear(o, t, 15), i.setHours(0, 0, 0, 0);
  const a = EA(i);
  return r.setMonth(t, Math.min(s, a)), r;
}
function RA(e, t, n) {
  const r = St(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? Qt((n == null ? void 0 : n.in) || e, NaN) : (r.setFullYear(t), r);
}
const ev = 5, IA = 4;
function DA(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), s = t.addDays(o, ev * 7 - 1);
  return t.getMonth(e) === t.getMonth(s) ? ev : IA;
}
function qx(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function NA(e, t) {
  const n = qx(e, t), r = DA(e, t);
  return t.addDays(n, r * 7 - 1);
}
const Xx = {
  ...cs,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (i, a) => yi(i, a, { locale: cs, ...n });
      let s = o(e, "PPPP");
      return t.today && (s = `Today, ${s}`), t.selected && (s = `${s}, selected`), s;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => yi(o, s, { locale: cs, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (i, a) => yi(i, a, { locale: cs, ...n });
      let s = o(e, "PPPP");
      return t != null && t.today && (s = `Today, ${s}`), s;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => yi(o, s, { locale: cs, ...t }), r(e, "cccc");
    }
  }
};
class An {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.today = () => {
      var o;
      if ((o = this.overrides) != null && o.today)
        return this.overrides.today();
      if (this.options.timeZone)
        return on.tz(this.options.timeZone);
      const r = this.options.Date ?? Date;
      return new r();
    }, this.newDate = (r, o, s) => {
      var i;
      return (i = this.overrides) != null && i.newDate ? this.overrides.newDate(r, o, s) : this.options.timeZone ? new on(r, o, s, this.options.timeZone) : new Date(r, o, s);
    }, this.addDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addDays ? this.overrides.addDays(r, o) : Vx(r, o);
    }, this.addMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addMonths ? this.overrides.addMonths(r, o) : Wx(r, o);
    }, this.addWeeks = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addWeeks ? this.overrides.addWeeks(r, o) : m9(r, o);
    }, this.addYears = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.addYears ? this.overrides.addYears(r, o) : b9(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Mp(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : Yx(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : E9(r);
    }, this.eachYearOfInterval = (r) => {
      var a;
      const o = (a = this.overrides) != null && a.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : O9(r), s = new Set(o.map((c) => this.getYear(c)));
      if (s.size === o.length)
        return o;
      const i = [];
      return s.forEach((c) => {
        i.push(new Date(c, 0, 1));
      }), i;
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : NA(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : M9(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : C9(r);
    }, this.endOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.endOfWeek ? this.overrides.endOfWeek(r, o) : Ux(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : S9(r);
    }, this.format = (r, o, s) => {
      var a;
      const i = (a = this.overrides) != null && a.format ? this.overrides.format(r, o, this.options) : yi(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(i) : i;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : Tp(r);
    }, this.getMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getMonth ? this.overrides.getMonth(r, this.options) : _A(r, this.options);
    }, this.getYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getYear ? this.overrides.getYear(r, this.options) : SA(r, this.options);
    }, this.getWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.getWeek ? this.overrides.getWeek(r, this.options) : kp(r, this.options);
    }, this.isAfter = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isAfter ? this.overrides.isAfter(r, o) : OA(r, o);
    }, this.isBefore = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isBefore ? this.overrides.isBefore(r, o) : MA(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Hx(r);
    }, this.isSameDay = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameDay ? this.overrides.isSameDay(r, o) : w9(r, o);
    }, this.isSameMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameMonth ? this.overrides.isSameMonth(r, o) : TA(r, o);
    }, this.isSameYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.isSameYear ? this.overrides.isSameYear(r, o) : kA(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : v9(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : y9(r);
    }, this.setMonth = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setMonth ? this.overrides.setMonth(r, o) : PA(r, o);
    }, this.setYear = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.setYear ? this.overrides.setYear(r, o) : RA(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : qx(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Gi(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Ui(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : _9(r);
    }, this.startOfWeek = (r, o) => {
      var s;
      return (s = this.overrides) != null && s.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Ts(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : jx(r);
    }, this.options = { locale: Xx, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    var n;
    const t = (n = this.options.locale) == null ? void 0 : n.code;
    return t && An.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, s = n == null ? void 0 : n.code;
    if (s && An.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const i = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, i);
  }
}
An.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Er = new An();
class Zx {
  constructor(t, n, r = Er) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class AA {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class $A {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function FA(e) {
  return ie.createElement("span", { ...e });
}
function LA(e) {
  const { size: t = 24, orientation: n = "left", className: r, style: o } = e;
  return ie.createElement(
    "svg",
    { className: r, style: o, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && ie.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && ie.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && ie.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && ie.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function VA(e) {
  const { day: t, modifiers: n, ...r } = e;
  return ie.createElement("td", { ...r });
}
function WA(e) {
  const { day: t, modifiers: n, ...r } = e, o = ie.useRef(null);
  return ie.useEffect(() => {
    var s;
    n.focused && ((s = o.current) == null || s.focus());
  }, [n.focused]), ie.createElement("button", { ref: o, ...r });
}
var _e;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(_e || (_e = {}));
var $t;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})($t || ($t = {}));
var Jn;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Jn || (Jn = {}));
var Tn;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Tn || (Tn = {}));
const Qx = Ii(void 0);
function ba() {
  const e = bl(Qx);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function BA(e) {
  const { options: t, className: n, ...r } = e, { classNames: o, components: s, styles: i } = ba(), a = [o[_e.Dropdown], n].join(" "), c = t == null ? void 0 : t.find(({ value: l }) => l === r.value);
  return ie.createElement(
    "span",
    { "data-disabled": r.disabled, className: o[_e.DropdownRoot], style: i == null ? void 0 : i[_e.DropdownRoot] },
    ie.createElement(s.Select, { className: a, ...r }, t == null ? void 0 : t.map(({ value: l, label: u, disabled: d }) => ie.createElement(s.Option, { key: l, value: l, disabled: d }, u))),
    ie.createElement(
      "span",
      { className: o[_e.CaptionLabel], style: i == null ? void 0 : i[_e.CaptionLabel], "aria-hidden": !0 },
      c == null ? void 0 : c.label,
      ie.createElement(s.Chevron, { orientation: "down", size: 18, className: o[_e.Chevron], style: i == null ? void 0 : i[_e.Chevron] })
    )
  );
}
function HA(e) {
  return ie.createElement("div", { ...e });
}
function YA(e) {
  return ie.createElement("div", { ...e });
}
function zA(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return ie.createElement("div", { ...r }, e.children);
}
function jA(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return ie.createElement("div", { ...r });
}
function UA(e) {
  return ie.createElement("table", { ...e });
}
function GA(e) {
  return ie.createElement("div", { ...e });
}
function KA(e) {
  const { components: t } = ba();
  return ie.createElement(t.Dropdown, { ...e });
}
function qA(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...s } = e, { components: i, classNames: a, styles: c, labels: { labelPrevious: l, labelNext: u } } = ba(), d = je((h) => {
    o && (n == null || n(h));
  }, [o, n]), f = je((h) => {
    r && (t == null || t(h));
  }, [r, t]);
  return ie.createElement(
    "nav",
    { ...s },
    ie.createElement(
      i.PreviousMonthButton,
      { type: "button", className: a[_e.PreviousMonthButton], style: c == null ? void 0 : c[_e.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: f },
      ie.createElement(i.Chevron, { disabled: r ? void 0 : !0, className: a[_e.Chevron], style: c == null ? void 0 : c[_e.Chevron], orientation: "left" })
    ),
    ie.createElement(
      i.NextMonthButton,
      { type: "button", className: a[_e.NextMonthButton], style: c == null ? void 0 : c[_e.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": u(o), onClick: d },
      ie.createElement(i.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: a[_e.Chevron], style: c == null ? void 0 : c[_e.Chevron] })
    )
  );
}
function XA(e) {
  return ie.createElement("button", { ...e });
}
function ZA(e) {
  return ie.createElement("option", { ...e });
}
function QA(e) {
  return ie.createElement("button", { ...e });
}
function JA(e) {
  const { rootRef: t, ...n } = e;
  return ie.createElement("div", { ...n, ref: t });
}
function e7(e) {
  return ie.createElement("select", { ...e });
}
function t7(e) {
  const { week: t, ...n } = e;
  return ie.createElement("tr", { ...n });
}
function n7(e) {
  return ie.createElement("th", { ...e });
}
function r7(e) {
  return ie.createElement(
    "thead",
    { "aria-hidden": !0 },
    ie.createElement("tr", { ...e })
  );
}
function o7(e) {
  const { week: t, ...n } = e;
  return ie.createElement("th", { ...n });
}
function s7(e) {
  return ie.createElement("th", { ...e });
}
function i7(e) {
  return ie.createElement("tbody", { ...e });
}
function a7(e) {
  const { components: t } = ba();
  return ie.createElement(t.Dropdown, { ...e });
}
const c7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionLabel: FA,
  Chevron: LA,
  Day: VA,
  DayButton: WA,
  Dropdown: BA,
  DropdownNav: HA,
  Footer: YA,
  Month: zA,
  MonthCaption: jA,
  MonthGrid: UA,
  Months: GA,
  MonthsDropdown: KA,
  Nav: qA,
  NextMonthButton: XA,
  Option: ZA,
  PreviousMonthButton: QA,
  Root: JA,
  Select: e7,
  Week: t7,
  WeekNumber: o7,
  WeekNumberHeader: s7,
  Weekday: n7,
  Weekdays: r7,
  Weeks: i7,
  YearsDropdown: a7
}, Symbol.toStringTag, { value: "Module" }));
function Ar(e, t, n = !1, r = Er) {
  let { from: o, to: s } = e;
  const { differenceInCalendarDays: i, isSameDay: a } = r;
  return o && s ? (i(s, o) < 0 && ([o, s] = [s, o]), i(t, o) >= (n ? 1 : 0) && i(s, t) >= (n ? 1 : 0)) : !n && s ? a(s, t) : !n && o ? a(o, t) : !1;
}
function Pp(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function hu(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function Rp(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Ip(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Jx(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function eC(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function $r(e, t, n = Er) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: s, isAfter: i } = n;
  return r.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (n.isDate(a))
      return o(e, a);
    if (eC(a, n))
      return a.some((c) => o(e, c));
    if (hu(a))
      return Ar(a, e, !1, n);
    if (Jx(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(e.getDay()) : a.dayOfWeek === e.getDay();
    if (Pp(a)) {
      const c = s(a.before, e), l = s(a.after, e), u = c > 0, d = l < 0;
      return i(a.before, a.after) ? d && u : u || d;
    }
    return Rp(a) ? s(e, a.after) > 0 : Ip(a) ? s(a.before, e) > 0 : typeof a == "function" ? a(e) : !1;
  });
}
function l7(e, t, n, r, o) {
  const { disabled: s, hidden: i, modifiers: a, showOutsideDays: c, broadcastCalendar: l, today: u = o.today() } = t, { isSameDay: d, isSameMonth: f, startOfMonth: h, isBefore: p, endOfMonth: g, isAfter: m } = o, y = n && h(n), v = r && g(r), w = {
    [$t.focused]: [],
    [$t.outside]: [],
    [$t.disabled]: [],
    [$t.hidden]: [],
    [$t.today]: []
  }, C = {};
  for (const x of e) {
    const { date: E, displayMonth: S } = x, M = !!(S && !f(E, S)), T = !!(y && p(E, y)), P = !!(v && m(E, v)), k = !!(s && $r(E, s, o)), I = !!(i && $r(E, i, o)) || T || P || // Broadcast calendar will show outside days as default
    !l && !c && M || l && c === !1 && M, O = d(E, u);
    M && w.outside.push(x), k && w.disabled.push(x), I && w.hidden.push(x), O && w.today.push(x), a && Object.keys(a).forEach((A) => {
      const R = a == null ? void 0 : a[A];
      R && $r(E, R, o) && (C[A] ? C[A].push(x) : C[A] = [x]);
    });
  }
  return (x) => {
    const E = {
      [$t.focused]: !1,
      [$t.disabled]: !1,
      [$t.hidden]: !1,
      [$t.outside]: !1,
      [$t.today]: !1
    }, S = {};
    for (const M in w) {
      const T = w[M];
      E[M] = T.some((P) => P === x);
    }
    for (const M in C)
      S[M] = C[M].some((T) => T === x);
    return {
      ...E,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function u7(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [s]) => (n[s] ? o.push(n[s]) : t[$t[s]] ? o.push(t[$t[s]]) : t[Jn[s]] && o.push(t[Jn[s]]), o), [t[_e.Day]]);
}
function d7(e) {
  return {
    ...c7,
    ...e
  };
}
function f7(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function h7() {
  const e = {};
  for (const t in _e)
    e[_e[t]] = `rdp-${_e[t]}`;
  for (const t in $t)
    e[$t[t]] = `rdp-${$t[t]}`;
  for (const t in Jn)
    e[Jn[t]] = `rdp-${Jn[t]}`;
  for (const t in Tn)
    e[Tn[t]] = `rdp-${Tn[t]}`;
  return e;
}
function p7(e, t, n) {
  return (n ?? new An(t)).formatMonthYear(e);
}
function g7(e, t, n) {
  return (n ?? new An(t)).format(e, "d");
}
function m7(e, t = Er) {
  return t.format(e, "LLLL");
}
function b7(e, t, n) {
  return (n ?? new An(t)).format(e, "cccccc");
}
function v7(e, t = Er) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function y7() {
  return "";
}
function w7(e, t = Er) {
  return t.format(e, "yyyy");
}
const x7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: p7,
  formatDay: g7,
  formatMonthDropdown: m7,
  formatWeekNumber: v7,
  formatWeekNumberHeader: y7,
  formatWeekdayName: b7,
  formatYearDropdown: w7
}, Symbol.toStringTag, { value: "Module" }));
function C7(e) {
  return {
    ...x7,
    ...e
  };
}
function tC(e, t, n, r) {
  let o = (r ?? new An(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
function nC(e, t, n) {
  return (n ?? new An(t)).formatMonthYear(e);
}
function rC(e, t, n, r) {
  let o = (r ?? new An(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function oC(e) {
  return "Choose the Month";
}
function sC() {
  return "";
}
const E7 = "Go to the Next Month";
function iC(e, t) {
  return E7;
}
function aC(e) {
  return "Go to the Previous Month";
}
function cC(e, t, n) {
  return (n ?? new An(t)).format(e, "cccc");
}
function lC(e, t) {
  return `Week ${e}`;
}
function uC(e) {
  return "Week Number";
}
function dC(e) {
  return "Choose the Year";
}
const _7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelDayButton: tC,
  labelGrid: nC,
  labelGridcell: rC,
  labelMonthDropdown: oC,
  labelNav: sC,
  labelNext: iC,
  labelPrevious: aC,
  labelWeekNumber: lC,
  labelWeekNumberHeader: uC,
  labelWeekday: cC,
  labelYearDropdown: dC
}, Symbol.toStringTag, { value: "Module" })), Xn = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function S7(e, t) {
  var r;
  const n = ((r = t.locale) == null ? void 0 : r.labels) ?? {};
  return {
    ..._7,
    ...e ?? {},
    labelDayButton: Xn(tC, e == null ? void 0 : e.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Xn(oC, e == null ? void 0 : e.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Xn(iC, e == null ? void 0 : e.labelNext, n.labelNext),
    labelPrevious: Xn(aC, e == null ? void 0 : e.labelPrevious, n.labelPrevious),
    labelWeekNumber: Xn(lC, e == null ? void 0 : e.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Xn(dC, e == null ? void 0 : e.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Xn(nC, e == null ? void 0 : e.labelGrid, n.labelGrid),
    labelGridcell: Xn(rC, e == null ? void 0 : e.labelGridcell, n.labelGridcell),
    labelNav: Xn(sC, e == null ? void 0 : e.labelNav, n.labelNav),
    labelWeekNumberHeader: Xn(uC, e == null ? void 0 : e.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Xn(cC, e == null ? void 0 : e.labelWeekday, n.labelWeekday)
  };
}
function O7(e, t, n, r, o) {
  const { startOfMonth: s, startOfYear: i, endOfYear: a, eachMonthOfInterval: c, getMonth: l } = o;
  return c({
    start: i(e),
    end: a(e)
  }).map((f) => {
    const h = r.formatMonthDropdown(f, o), p = l(f), g = t && f < s(t) || n && f > s(n) || !1;
    return { value: p, label: h, disabled: g };
  });
}
function M7(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[_e.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function T7(e, t, n, r) {
  const o = r ?? e.today(), s = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), i = [];
  for (let a = 0; a < 7; a++) {
    const c = e.addDays(s, a);
    i.push(c);
  }
  return i;
}
function k7(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: s, endOfYear: i, eachYearOfInterval: a, getYear: c } = r, l = s(e), u = i(t), d = a({ start: l, end: u });
  return o && d.reverse(), d.map((f) => {
    const h = n.formatYearDropdown(f, r);
    return {
      value: c(f),
      label: h,
      disabled: !1
    };
  });
}
function P7(e, t = {}) {
  var a;
  const { weekStartsOn: n, locale: r } = t, o = n ?? ((a = r == null ? void 0 : r.options) == null ? void 0 : a.weekStartsOn) ?? 0, s = (c) => {
    const l = typeof c == "number" || typeof c == "string" ? new Date(c) : c;
    return new on(l.getFullYear(), l.getMonth(), l.getDate(), 12, 0, 0, e);
  }, i = (c) => {
    const l = s(c);
    return new Date(l.getFullYear(), l.getMonth(), l.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => s(on.tz(e)),
    newDate: (c, l, u) => new on(c, l, u, 12, 0, 0, e),
    startOfDay: (c) => s(c),
    startOfWeek: (c, l) => {
      const u = s(c), d = (l == null ? void 0 : l.weekStartsOn) ?? o, f = (u.getDay() - d + 7) % 7;
      return u.setDate(u.getDate() - f), u;
    },
    startOfISOWeek: (c) => {
      const l = s(c), u = (l.getDay() - 1 + 7) % 7;
      return l.setDate(l.getDate() - u), l;
    },
    startOfMonth: (c) => {
      const l = s(c);
      return l.setDate(1), l;
    },
    startOfYear: (c) => {
      const l = s(c);
      return l.setMonth(0, 1), l;
    },
    endOfWeek: (c, l) => {
      const u = s(c), h = ((((l == null ? void 0 : l.weekStartsOn) ?? o) + 6) % 7 - u.getDay() + 7) % 7;
      return u.setDate(u.getDate() + h), u;
    },
    endOfISOWeek: (c) => {
      const l = s(c), u = (7 - l.getDay()) % 7;
      return l.setDate(l.getDate() + u), l;
    },
    endOfMonth: (c) => {
      const l = s(c);
      return l.setMonth(l.getMonth() + 1, 0), l;
    },
    endOfYear: (c) => {
      const l = s(c);
      return l.setMonth(11, 31), l;
    },
    eachMonthOfInterval: (c) => {
      const l = s(c.start), u = s(c.end), d = [], f = new on(l.getFullYear(), l.getMonth(), 1, 12, 0, 0, e), h = u.getFullYear() * 12 + u.getMonth();
      for (; f.getFullYear() * 12 + f.getMonth() <= h; )
        d.push(new on(f, e)), f.setMonth(f.getMonth() + 1, 1);
      return d;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (c, l) => {
      const u = s(c);
      return u.setDate(u.getDate() + l), u;
    },
    addWeeks: (c, l) => {
      const u = s(c);
      return u.setDate(u.getDate() + l * 7), u;
    },
    addMonths: (c, l) => {
      const u = s(c);
      return u.setMonth(u.getMonth() + l), u;
    },
    addYears: (c, l) => {
      const u = s(c);
      return u.setFullYear(u.getFullYear() + l), u;
    },
    eachYearOfInterval: (c) => {
      const l = s(c.start), u = s(c.end), d = [], f = new on(l.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; f.getFullYear() <= u.getFullYear(); )
        d.push(new on(f, e)), f.setFullYear(f.getFullYear() + 1, 0, 1);
      return d;
    },
    getWeek: (c, l) => {
      var d;
      const u = i(c);
      return kp(u, {
        weekStartsOn: (l == null ? void 0 : l.weekStartsOn) ?? o,
        firstWeekContainsDate: (l == null ? void 0 : l.firstWeekContainsDate) ?? ((d = r == null ? void 0 : r.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1
      });
    },
    getISOWeek: (c) => {
      const l = i(c);
      return Tp(l);
    },
    differenceInCalendarDays: (c, l) => {
      const u = i(c), d = i(l);
      return Mp(u, d);
    },
    differenceInCalendarMonths: (c, l) => {
      const u = i(c), d = i(l);
      return Yx(u, d);
    }
  };
}
const va = (e) => e instanceof HTMLElement ? e : null, id = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], R7 = (e) => va(e.querySelector("[data-animated-month]")), ad = (e) => va(e.querySelector("[data-animated-caption]")), cd = (e) => va(e.querySelector("[data-animated-weeks]")), I7 = (e) => va(e.querySelector("[data-animated-nav]")), D7 = (e) => va(e.querySelector("[data-animated-weekdays]"));
function N7(e, t, { classNames: n, months: r, focused: o, dateLib: s }) {
  const i = Ue(null), a = Ue(r), c = Ue(!1);
  Rs(() => {
    const l = a.current;
    if (a.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || l.length === 0 || r.length !== l.length)
      return;
    const u = s.isSameMonth(r[0].date, l[0].date), d = s.isAfter(r[0].date, l[0].date), f = d ? n[Tn.caption_after_enter] : n[Tn.caption_before_enter], h = d ? n[Tn.weeks_after_enter] : n[Tn.weeks_before_enter], p = i.current, g = e.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (id(g).forEach((w) => {
      if (!(w instanceof HTMLElement))
        return;
      const C = R7(w);
      C && w.contains(C) && w.removeChild(C);
      const x = ad(w);
      x && x.classList.remove(f);
      const E = cd(w);
      E && E.classList.remove(h);
    }), i.current = g) : i.current = null, c.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const m = p instanceof HTMLElement ? id(p) : [], y = id(e.current);
    if (y != null && y.every((v) => v instanceof HTMLElement) && (m != null && m.every((v) => v instanceof HTMLElement))) {
      c.current = !0, e.current.style.isolation = "isolate";
      const v = I7(e.current);
      v && (v.style.zIndex = "1"), y.forEach((w, C) => {
        const x = m[C];
        if (!x)
          return;
        w.style.position = "relative", w.style.overflow = "hidden";
        const E = ad(w);
        E && E.classList.add(f);
        const S = cd(w);
        S && S.classList.add(h);
        const M = () => {
          c.current = !1, e.current && (e.current.style.isolation = ""), v && (v.style.zIndex = ""), E && E.classList.remove(f), S && S.classList.remove(h), w.style.position = "", w.style.overflow = "", w.contains(x) && w.removeChild(x);
        };
        x.style.pointerEvents = "none", x.style.position = "absolute", x.style.overflow = "hidden", x.setAttribute("aria-hidden", "true");
        const T = D7(x);
        T && (T.style.opacity = "0");
        const P = ad(x);
        P && (P.classList.add(d ? n[Tn.caption_before_exit] : n[Tn.caption_after_exit]), P.addEventListener("animationend", M));
        const k = cd(x);
        k && k.classList.add(d ? n[Tn.weeks_before_exit] : n[Tn.weeks_after_exit]), w.insertBefore(x, w.firstChild);
      });
    }
  });
}
function A7(e, t, n, r) {
  const o = e[0], s = e[e.length - 1], { ISOWeek: i, fixedWeeks: a, broadcastCalendar: c } = n ?? {}, { addDays: l, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: h, endOfMonth: p, endOfWeek: g, isAfter: m, startOfBroadcastWeek: y, startOfISOWeek: v, startOfWeek: w } = r, C = c ? y(o, r) : i ? v(o) : w(o), x = c ? f(s) : i ? h(p(s)) : g(p(s)), E = t && (c ? f(t) : i ? h(t) : g(t)), S = E && m(x, E) ? E : x, M = u(S, C), T = d(s, o) + 1, P = [];
  for (let O = 0; O <= M; O++) {
    const A = l(C, O);
    P.push(A);
  }
  const I = (c ? 35 : 42) * T;
  if (a && P.length < I) {
    const O = I - P.length;
    for (let A = 0; A < O; A++) {
      const R = l(P[P.length - 1], 1);
      P.push(R);
    }
  }
  return P;
}
function $7(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((s, i) => s.concat(i.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function F7(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, s = [];
  for (let i = 0; i < o; i++) {
    const a = r.addMonths(e, i);
    if (t && a > t)
      break;
    s.push(a);
  }
  return s;
}
function tv(e, t, n, r) {
  const { month: o, defaultMonth: s, today: i = r.today(), numberOfMonths: a = 1 } = e;
  let c = o || s || i;
  const { differenceInCalendarMonths: l, addMonths: u, startOfMonth: d } = r;
  if (n && l(n, c) < a - 1) {
    const f = -1 * (a - 1);
    c = u(n, f);
  }
  return t && l(c, t) < 0 && (c = t), d(c);
}
function L7(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: s, endOfISOWeek: i, endOfMonth: a, endOfWeek: c, getISOWeek: l, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: h } = r, p = e.reduce((g, m) => {
    const y = n.broadcastCalendar ? d(m, r) : n.ISOWeek ? f(m) : h(m), v = n.broadcastCalendar ? s(m) : n.ISOWeek ? i(a(m)) : c(a(m)), w = t.filter((S) => S >= y && S <= v), C = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && w.length < C) {
      const S = t.filter((M) => {
        const T = C - w.length;
        return M > v && M <= o(v, T);
      });
      w.push(...S);
    }
    const x = w.reduce((S, M) => {
      const T = n.ISOWeek ? l(M) : u(M), P = S.find((I) => I.weekNumber === T), k = new Zx(M, m, r);
      return P ? P.days.push(k) : S.push(new $A(T, [k])), S;
    }, []), E = new AA(m, x);
    return g.push(E), g;
  }, []);
  return n.reverseMonths ? p.reverse() : p;
}
function V7(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: s, startOfMonth: i, endOfMonth: a, addYears: c, endOfYear: l, today: u } = t, d = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = i(n) : !n && d && (n = o(c(e.today ?? u(), -100))), r ? r = a(r) : !r && d && (r = l(e.today ?? u())), [
    n && s(n),
    r && s(r)
  ];
}
function W7(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s = 1 } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: c } = r, l = o ? s : 1, u = i(e);
  if (!t)
    return a(u, l);
  if (!(c(t, e) < s))
    return a(u, l);
}
function B7(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s } = n, { startOfMonth: i, addMonths: a, differenceInCalendarMonths: c } = r, l = o ? s ?? 1 : 1, u = i(e);
  if (!t)
    return a(u, -l);
  if (!(c(u, t) <= 0))
    return a(u, -l);
}
function H7(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function pu(e, t) {
  const [n, r] = _t(e);
  return [t === void 0 ? n : t, r];
}
function Y7(e, t) {
  var C;
  const [n, r] = V7(e, t), { startOfMonth: o, endOfMonth: s } = t, i = tv(e, n, r, t), [a, c] = pu(
    i,
    // initialMonth is always computed from props.month if provided
    e.month ? i : void 0
  );
  Ke(() => {
    const x = tv(e, n, r, t);
    c(x);
  }, [e.timeZone]);
  const { months: l, weeks: u, days: d, previousMonth: f, nextMonth: h } = fr(() => {
    const x = F7(a, r, { numberOfMonths: e.numberOfMonths }, t), E = A7(x, e.endMonth ? s(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), S = L7(x, E, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), M = H7(S), T = $7(S), P = B7(a, n, e, t), k = W7(a, r, e, t);
    return {
      months: S,
      weeks: M,
      days: T,
      previousMonth: P,
      nextMonth: k
    };
  }, [
    t,
    a.getTime(),
    r == null ? void 0 : r.getTime(),
    n == null ? void 0 : n.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    (C = e.endMonth) == null ? void 0 : C.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: p, onMonthChange: g } = e, m = (x) => u.some((E) => E.days.some((S) => S.isEqualTo(x))), y = (x) => {
    if (p)
      return;
    let E = o(x);
    n && E < o(n) && (E = o(n)), r && E > o(r) && (E = o(r)), c(E), g == null || g(E);
  };
  return {
    months: l,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: r,
    previousMonth: f,
    nextMonth: h,
    goToMonth: y,
    goToDay: (x) => {
      m(x) || y(x.date);
    }
  };
}
var sr;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(sr || (sr = {}));
function nv(e) {
  return !e[$t.disabled] && !e[$t.hidden] && !e[$t.outside];
}
function z7(e, t, n, r) {
  let o, s = -1;
  for (const i of e) {
    const a = t(i);
    nv(a) && (a[$t.focused] && s < sr.FocusedModifier ? (o = i, s = sr.FocusedModifier) : r != null && r.isEqualTo(i) && s < sr.LastFocused ? (o = i, s = sr.LastFocused) : n(i.date) && s < sr.Selected ? (o = i, s = sr.Selected) : a[$t.today] && s < sr.Today && (o = i, s = sr.Today));
  }
  return o || (o = e.find((i) => nv(t(i)))), o;
}
function j7(e, t, n, r, o, s, i) {
  const { ISOWeek: a, broadcastCalendar: c } = s, { addDays: l, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: h, endOfISOWeek: p, endOfWeek: g, max: m, min: y, startOfBroadcastWeek: v, startOfISOWeek: w, startOfWeek: C } = i;
  let E = {
    day: l,
    week: d,
    month: u,
    year: f,
    startOfWeek: (S) => c ? v(S, i) : a ? w(S) : C(S),
    endOfWeek: (S) => c ? h(S) : a ? p(S) : g(S)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? E = m([r, E]) : t === "after" && o && (E = y([o, E])), E;
}
function fC(e, t, n, r, o, s, i, a = 0) {
  if (a > 365)
    return;
  const c = j7(e, t, n.date, r, o, s, i), l = !!(s.disabled && $r(c, s.disabled, i)), u = !!(s.hidden && $r(c, s.hidden, i)), d = c, f = new Zx(c, d, i);
  return !l && !u ? f : fC(e, t, f, r, o, s, i, a + 1);
}
function U7(e, t, n, r, o) {
  const { autoFocus: s } = e, [i, a] = _t(), c = z7(t.days, n, r || (() => !1), i), [l, u] = _t(s ? c : void 0);
  return {
    isFocusTarget: (g) => !!(c != null && c.isEqualTo(g)),
    setFocused: u,
    focused: l,
    blur: () => {
      a(l), u(void 0);
    },
    moveFocus: (g, m) => {
      if (!l)
        return;
      const y = fC(g, m, l, t.navStart, t.navEnd, e, o);
      y && (e.disableNavigation && !t.days.some((w) => w.isEqualTo(y)) || (t.goToDay(y), u(y)));
    }
  };
}
function G7(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = pu(n, o ? n : void 0), a = o ? n : s, { isSameDay: c } = t, l = (h) => (a == null ? void 0 : a.some((p) => c(p, h))) ?? !1, { min: u, max: d } = e;
  return {
    selected: a,
    select: (h, p, g) => {
      let m = [...a ?? []];
      if (l(h)) {
        if ((a == null ? void 0 : a.length) === u || r && (a == null ? void 0 : a.length) === 1)
          return;
        m = a == null ? void 0 : a.filter((y) => !c(y, h));
      } else
        (a == null ? void 0 : a.length) === d ? m = [h] : m = [...m, h];
      return o || i(m), o == null || o(m, h, p, g), m;
    },
    isSelected: l
  };
}
function K7(e, t, n = 0, r = 0, o = !1, s = Er) {
  const { from: i, to: a } = t || {}, { isSameDay: c, isAfter: l, isBefore: u } = s;
  let d;
  if (!i && !a)
    d = { from: e, to: n > 0 ? void 0 : e };
  else if (i && !a)
    c(i, e) ? n === 0 ? d = { from: i, to: e } : o ? d = { from: i, to: void 0 } : d = void 0 : u(e, i) ? d = { from: e, to: i } : d = { from: i, to: e };
  else if (i && a)
    if (c(i, e) && c(a, e))
      o ? d = { from: i, to: a } : d = void 0;
    else if (c(i, e))
      d = { from: i, to: n > 0 ? void 0 : e };
    else if (c(a, e))
      d = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, i))
      d = { from: e, to: a };
    else if (l(e, i))
      d = { from: i, to: e };
    else if (l(e, a))
      d = { from: i, to: e };
    else
      throw new Error("Invalid range");
  if (d != null && d.from && (d != null && d.to)) {
    const f = s.differenceInCalendarDays(d.to, d.from);
    r > 0 && f > r ? d = { from: e, to: void 0 } : n > 1 && f < n && (d = { from: e, to: void 0 });
  }
  return d;
}
function q7(e, t, n = Er) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const s = n.differenceInCalendarDays(e.to, e.from), i = Math.min(s, 6);
  for (let a = 0; a <= i; a++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function rv(e, t, n = Er) {
  return Ar(e, t.from, !1, n) || Ar(e, t.to, !1, n) || Ar(t, e.from, !1, n) || Ar(t, e.to, !1, n);
}
function X7(e, t, n = Er) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : n.isDate(a) ? Ar(e, a, !1, n) : eC(a, n) ? a.some((c) => Ar(e, c, !1, n)) : hu(a) ? a.from && a.to ? rv(e, { from: a.from, to: a.to }, n) : !1 : Jx(a) ? q7(e, a.dayOfWeek, n) : Pp(a) ? n.isAfter(a.before, a.after) ? rv(e, {
    from: n.addDays(a.after, 1),
    to: n.addDays(a.before, -1)
  }, n) : $r(e.from, a, n) || $r(e.to, a, n) : Rp(a) || Ip(a) ? $r(e.from, a, n) || $r(e.to, a, n) : !1))
    return !0;
  const i = r.filter((a) => typeof a == "function");
  if (i.length) {
    let a = e.from;
    const c = n.differenceInCalendarDays(e.to, e.from);
    for (let l = 0; l <= c; l++) {
      if (i.some((u) => u(a)))
        return !0;
      a = n.addDays(a, 1);
    }
  }
  return !1;
}
function Z7(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: s, required: i, onSelect: a } = e, [c, l] = pu(s, a ? s : void 0), u = a ? s : c;
  return {
    selected: u,
    select: (h, p, g) => {
      const { min: m, max: y } = e;
      let v;
      if (h) {
        const w = u == null ? void 0 : u.from, C = u == null ? void 0 : u.to, x = !!w && !!C, E = !!w && !!C && t.isSameDay(w, C) && t.isSameDay(h, w);
        o && (x || !(u != null && u.from)) ? !i && E ? v = void 0 : v = { from: h, to: void 0 } : v = K7(h, u, m, y, i, t);
      }
      return r && n && (v != null && v.from) && v.to && X7({ from: v.from, to: v.to }, n, t) && (v.from = h, v.to = void 0), a || l(v), a == null || a(v, h, p, g), v;
    },
    isSelected: (h) => u && Ar(u, h, !1, t)
  };
}
function Q7(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, i] = pu(n, o ? n : void 0), a = o ? n : s, { isSameDay: c } = t;
  return {
    selected: a,
    select: (d, f, h) => {
      let p = d;
      return !r && a && a && c(d, a) && (p = void 0), o || i(p), o == null || o(p, d, f, h), p;
    },
    isSelected: (d) => a ? c(a, d) : !1
  };
}
function J7(e, t) {
  const n = Q7(e, t), r = G7(e, t), o = Z7(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function Mn(e, t) {
  return e instanceof on && e.timeZone === t ? e : new on(e, t);
}
function rs(e, t, n) {
  if (!n)
    return Mn(e, t);
  const r = Mn(e, t), o = new on(r.getFullYear(), r.getMonth(), r.getDate(), 12, 0, 0, t);
  return new Date(o.getTime());
}
function ov(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? rs(e, t, n) : Array.isArray(e) ? e.map((r) => r instanceof Date ? rs(r, t, n) : r) : hu(e) ? {
    ...e,
    from: e.from ? Mn(e.from, t) : e.from,
    to: e.to ? Mn(e.to, t) : e.to
  } : Pp(e) ? {
    before: rs(e.before, t, n),
    after: rs(e.after, t, n)
  } : Rp(e) ? {
    after: rs(e.after, t, n)
  } : Ip(e) ? {
    before: rs(e.before, t, n)
  } : e;
}
function ld(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => ov(r, t, n)) : ov(e, t, n));
}
function e8(e) {
  var $n;
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = Mn(t.today, n)), t.month && (t.month = Mn(t.month, n)), t.defaultMonth && (t.defaultMonth = Mn(t.defaultMonth, n)), t.startMonth && (t.startMonth = Mn(t.startMonth, n)), t.endMonth && (t.endMonth = Mn(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = Mn(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = ($n = t.selected) == null ? void 0 : $n.map((me) => Mn(me, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? Mn(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? Mn(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = ld(t.disabled, n)), t.hidden !== void 0 && (t.hidden = ld(t.hidden, n)), t.modifiers)) {
    const me = {};
    Object.keys(t.modifiers).forEach((De) => {
      var Ne;
      me[De] = ld((Ne = t.modifiers) == null ? void 0 : Ne[De], n);
    }), t.modifiers = me;
  }
  const { components: r, formatters: o, labels: s, dateLib: i, locale: a, classNames: c } = fr(() => {
    const me = { ...Xx, ...t.locale }, De = t.broadcastCalendar ? 1 : t.weekStartsOn, Ne = t.noonSafe && t.timeZone ? P7(t.timeZone, {
      weekStartsOn: De,
      locale: me
    }) : void 0, Qe = t.dateLib && Ne ? { ...Ne, ...t.dateLib } : t.dateLib ?? Ne, Be = new An({
      locale: me,
      weekStartsOn: De,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, Qe);
    return {
      dateLib: Be,
      components: d7(t.components),
      formatters: C7(t.formatters),
      labels: S7(t.labels, Be.options),
      locale: me,
      classNames: { ...h7(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: i.today() });
  const { captionLayout: l, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: h, onDayClick: p, onDayFocus: g, onDayKeyDown: m, onDayMouseEnter: y, onDayMouseLeave: v, onNextClick: w, onPrevClick: C, showWeekNumber: x, styles: E } = t, { formatCaption: S, formatDay: M, formatMonthDropdown: T, formatWeekNumber: P, formatWeekNumberHeader: k, formatWeekdayName: I, formatYearDropdown: O } = o, A = Y7(t, i), { days: R, months: N, navStart: $, navEnd: F, previousMonth: V, nextMonth: D, goToMonth: H } = A, j = l7(R, t, $, F, i), { isSelected: U, select: K, selected: G } = J7(t, i) ?? {}, { blur: B, focused: z, isFocusTarget: W, moveFocus: X, setFocused: J } = U7(t, A, j, U ?? (() => !1), i), { labelDayButton: Q, labelGridcell: Y, labelGrid: ce, labelMonthDropdown: ee, labelNav: ne, labelPrevious: de, labelNext: pe, labelWeekday: Ee, labelWeekNumber: se, labelWeekNumberHeader: ke, labelYearDropdown: we } = s, Oe = fr(() => T7(i, t.ISOWeek, t.broadcastCalendar, t.today), [i, t.ISOWeek, t.broadcastCalendar, t.today]), Ie = u !== void 0 || p !== void 0, fe = je(() => {
    V && (H(V), C == null || C(V));
  }, [V, H, C]), q = je(() => {
    D && (H(D), w == null || w(D));
  }, [H, D, w]), te = je((me, De) => (Ne) => {
    Ne.preventDefault(), Ne.stopPropagation(), J(me), !De.disabled && (K == null || K(me.date, De, Ne), p == null || p(me.date, De, Ne));
  }, [K, p, J]), oe = je((me, De) => (Ne) => {
    J(me), g == null || g(me.date, De, Ne);
  }, [g, J]), re = je((me, De) => (Ne) => {
    B(), h == null || h(me.date, De, Ne);
  }, [B, h]), ve = je((me, De) => (Ne) => {
    const Qe = {
      ArrowLeft: [
        Ne.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Ne.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Ne.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Ne.shiftKey ? "year" : "week", "before"],
      PageUp: [Ne.shiftKey ? "year" : "month", "before"],
      PageDown: [Ne.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Qe[Ne.key]) {
      Ne.preventDefault(), Ne.stopPropagation();
      const [Be, Mt] = Qe[Ne.key];
      X(Be, Mt);
    }
    m == null || m(me.date, De, Ne);
  }, [X, m, t.dir]), xe = je((me, De) => (Ne) => {
    y == null || y(me.date, De, Ne);
  }, [y]), Me = je((me, De) => (Ne) => {
    v == null || v(me.date, De, Ne);
  }, [v]), qe = je((me, De) => (Ne) => {
    const Qe = Number(Ne.target.value), Be = i.setMonth(i.startOfMonth(me), Qe);
    H(i.addMonths(Be, -De));
  }, [i, H]), Ze = je((me, De) => (Ne) => {
    const Qe = Number(Ne.target.value), Be = i.setYear(i.startOfMonth(me), Qe);
    H(i.addMonths(Be, -De));
  }, [i, H]), { className: nt, style: Kt } = fr(() => ({
    className: [c[_e.Root], t.className].filter(Boolean).join(" "),
    style: { ...E == null ? void 0 : E[_e.Root], ...t.style }
  }), [c, t.className, t.style, E]), dn = f7(t), rn = (me) => {
    const De = E == null ? void 0 : E[_e.Dropdown], Ne = E == null ? void 0 : E[me];
    if (!(!De && !Ne))
      return {
        ...De,
        ...Ne
      };
  }, _n = Ue(null);
  N7(_n, !!t.animate, {
    classNames: c,
    months: N,
    focused: z,
    dateLib: i
  });
  const fn = {
    dayPickerProps: t,
    selected: G,
    select: K,
    isSelected: U,
    months: N,
    nextMonth: D,
    previousMonth: V,
    goToMonth: H,
    getModifiers: j,
    components: r,
    classNames: c,
    styles: E,
    labels: s,
    formatters: o
  };
  return ie.createElement(
    Qx.Provider,
    { value: fn },
    ie.createElement(
      r.Root,
      { rootRef: t.animate ? _n : void 0, className: nt, style: Kt, dir: t.dir, id: t.id, lang: t.lang ?? a.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...dn },
      ie.createElement(
        r.Months,
        { className: c[_e.Months], style: E == null ? void 0 : E[_e.Months] },
        !t.hideNavigation && !d && ie.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[_e.Nav], style: E == null ? void 0 : E[_e.Nav], "aria-label": ne(), onPreviousClick: fe, onNextClick: q, previousMonth: V, nextMonth: D }),
        N.map((me, De) => {
          const Ne = t.reverseMonths ? N.length - 1 - De : De;
          return ie.createElement(
            r.Month,
            {
              "data-animated-month": t.animate ? "true" : void 0,
              className: c[_e.Month],
              style: E == null ? void 0 : E[_e.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: De,
              displayIndex: De,
              calendarMonth: me
            },
            d === "around" && !t.hideNavigation && De === 0 && ie.createElement(
              r.PreviousMonthButton,
              { type: "button", className: c[_e.PreviousMonthButton], style: E == null ? void 0 : E[_e.PreviousMonthButton], tabIndex: V ? void 0 : -1, "aria-disabled": V ? void 0 : !0, "aria-label": de(V), onClick: fe, "data-animated-button": t.animate ? "true" : void 0 },
              ie.createElement(r.Chevron, { disabled: V ? void 0 : !0, className: c[_e.Chevron], style: E == null ? void 0 : E[_e.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            ie.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: c[_e.MonthCaption], style: E == null ? void 0 : E[_e.MonthCaption], calendarMonth: me, displayIndex: De }, l != null && l.startsWith("dropdown") ? ie.createElement(
              r.DropdownNav,
              { className: c[_e.Dropdowns], style: E == null ? void 0 : E[_e.Dropdowns] },
              (() => {
                const Qe = l === "dropdown" || l === "dropdown-months" ? ie.createElement(r.MonthsDropdown, { key: "month", className: c[_e.MonthsDropdown], "aria-label": ee(), disabled: !!t.disableNavigation, onChange: qe(me.date, Ne), options: O7(me.date, $, F, o, i), style: rn(_e.MonthsDropdown), value: i.getMonth(me.date) }) : ie.createElement("span", { key: "month" }, T(me.date, i)), Be = l === "dropdown" || l === "dropdown-years" ? ie.createElement(r.YearsDropdown, { key: "year", className: c[_e.YearsDropdown], "aria-label": we(i.options), disabled: !!t.disableNavigation, onChange: Ze(me.date, Ne), options: k7($, F, o, i, !!t.reverseYears), style: rn(_e.YearsDropdown), value: i.getYear(me.date) }) : ie.createElement("span", { key: "year" }, O(me.date, i));
                return i.getMonthYearOrder() === "year-first" ? [Be, Qe] : [Qe, Be];
              })(),
              ie.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, S(me.date, i.options, i))
            ) : ie.createElement(r.CaptionLabel, { className: c[_e.CaptionLabel], style: E == null ? void 0 : E[_e.CaptionLabel], role: "status", "aria-live": "polite" }, S(me.date, i.options, i))),
            d === "around" && !t.hideNavigation && De === f - 1 && ie.createElement(
              r.NextMonthButton,
              { type: "button", className: c[_e.NextMonthButton], style: E == null ? void 0 : E[_e.NextMonthButton], tabIndex: D ? void 0 : -1, "aria-disabled": D ? void 0 : !0, "aria-label": pe(D), onClick: q, "data-animated-button": t.animate ? "true" : void 0 },
              ie.createElement(r.Chevron, { disabled: D ? void 0 : !0, className: c[_e.Chevron], style: E == null ? void 0 : E[_e.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            De === f - 1 && d === "after" && !t.hideNavigation && ie.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[_e.Nav], style: E == null ? void 0 : E[_e.Nav], "aria-label": ne(), onPreviousClick: fe, onNextClick: q, previousMonth: V, nextMonth: D }),
            ie.createElement(
              r.MonthGrid,
              { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": ce(me.date, i.options, i) || void 0, className: c[_e.MonthGrid], style: E == null ? void 0 : E[_e.MonthGrid] },
              !t.hideWeekdays && ie.createElement(
                r.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: c[_e.Weekdays], style: E == null ? void 0 : E[_e.Weekdays] },
                x && ie.createElement(r.WeekNumberHeader, { "aria-label": ke(i.options), className: c[_e.WeekNumberHeader], style: E == null ? void 0 : E[_e.WeekNumberHeader], scope: "col" }, k()),
                Oe.map((Qe) => ie.createElement(r.Weekday, { "aria-label": Ee(Qe, i.options, i), className: c[_e.Weekday], key: String(Qe), style: E == null ? void 0 : E[_e.Weekday], scope: "col" }, I(Qe, i.options, i)))
              ),
              ie.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: c[_e.Weeks], style: E == null ? void 0 : E[_e.Weeks] }, me.weeks.map((Qe) => ie.createElement(
                r.Week,
                { className: c[_e.Week], key: Qe.weekNumber, style: E == null ? void 0 : E[_e.Week], week: Qe },
                x && ie.createElement(r.WeekNumber, { week: Qe, style: E == null ? void 0 : E[_e.WeekNumber], "aria-label": se(Qe.weekNumber, {
                  locale: a
                }), className: c[_e.WeekNumber], scope: "row", role: "rowheader" }, P(Qe.weekNumber, i)),
                Qe.days.map((Be) => {
                  const { date: Mt } = Be, ze = j(Be);
                  if (ze[$t.focused] = !ze.hidden && !!(z != null && z.isEqualTo(Be)), ze[Jn.selected] = (U == null ? void 0 : U(Mt)) || ze.selected, hu(G)) {
                    const { from: Sr, to: tr } = G;
                    ze[Jn.range_start] = !!(Sr && tr && i.isSameDay(Mt, Sr)), ze[Jn.range_end] = !!(Sr && tr && i.isSameDay(Mt, tr)), ze[Jn.range_middle] = Ar(G, Mt, !0, i);
                  }
                  const Kn = M7(ze, E, t.modifiersStyles), Sn = u7(ze, c, t.modifiersClassNames), Eo = !Ie && !ze.hidden ? Y(Mt, ze, i.options, i) : void 0;
                  return ie.createElement(r.Day, { key: `${Be.isoDate}_${Be.displayMonthId}`, day: Be, modifiers: ze, className: Sn.join(" "), style: Kn, role: "gridcell", "aria-selected": ze.selected || void 0, "aria-label": Eo, "data-day": Be.isoDate, "data-month": Be.outside ? Be.dateMonthId : void 0, "data-selected": ze.selected || void 0, "data-disabled": ze.disabled || void 0, "data-hidden": ze.hidden || void 0, "data-outside": Be.outside || void 0, "data-focused": ze.focused || void 0, "data-today": ze.today || void 0 }, !ze.hidden && Ie ? ie.createElement(r.DayButton, { className: c[_e.DayButton], style: E == null ? void 0 : E[_e.DayButton], type: "button", day: Be, modifiers: ze, disabled: !ze.focused && ze.disabled || void 0, "aria-disabled": ze.focused && ze.disabled || void 0, tabIndex: W(Be) ? 0 : -1, "aria-label": Q(Mt, ze, i.options, i), onClick: te(Be, ze), onBlur: re(Be, ze), onFocus: oe(Be, ze), onKeyDown: ve(Be, ze), onMouseEnter: xe(Be, ze), onMouseLeave: Me(Be, ze) }, M(Mt, i.options, i)) : !ze.hidden && M(Be.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && ie.createElement(r.Footer, { className: c[_e.Footer], style: E == null ? void 0 : E[_e.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const hC = b.createContext({}), pC = ({
  className: e,
  fromDate: t,
  toDate: n,
  initialFocus: r,
  CustomFooter: o,
  ...s
}) => {
  const i = [
    ...t ? [{ before: t }] : [],
    ...n ? [{ after: n }] : []
  ];
  return /* @__PURE__ */ _(hC.Provider, { value: { fromDate: t, toDate: n }, children: /* @__PURE__ */ _(
    e8,
    {
      showOutsideDays: !0,
      fixedWeeks: !0,
      weekStartsOn: 1,
      autoFocus: r,
      hideNavigation: !0,
      ...s.mode === "range" ? { resetOnSelect: !0 } : {},
      disabled: i,
      footer: o,
      className: le(
        "flex rounded-lg bg-foundations-default px-6 py-3",
        e
      ),
      formatters: {
        formatWeekdayName: (a) => Lr(a, "E")
      },
      classNames: {
        month_grid: "w-full border-collapse space-y-4",
        weekdays: "flex",
        weekday: "w-9 text-xs text-foundations-subtle font-normal uppercase",
        week: "flex w-full mt-2",
        day: "p-0 flex justify-center",
        day_button: "h-9 w-9 p-0 font-normal text-foundations-boldest text-sm rounded-full hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-info-bold focus:z-10",
        selected: "[&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:hover:!bg-info-bolder [&>button]:focus:!bg-info-bolder",
        today: "[&>button]:bg-neutral-100 [&>button]:rounded-full",
        range_start: "start [&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-l-full [&:not(:last-child)>button]:!rounded-r-none [&:last-child>button]:!rounded-r-full",
        range_middle: "[&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-none [&:first-child>button]:!rounded-l-full [&:last-child>button]:!rounded-r-full",
        range_end: "end [&>button]:!bg-info-bold [&>button]:!text-neutral-white [&>button]:!rounded-r-full [&:not(:first-child)>button]:!rounded-l-none [&:first-child>button]:!rounded-l-full [&.start.end>button]:!rounded-full",
        outside: "[&>button:not(:disabled)]:text-foundations-subtle",
        disabled: "[&>button]:!text-neutral-300 [&>button]:cursor-not-allowed",
        hidden: "invisible"
      },
      components: {
        MonthCaption: t8
      },
      ...s
    }
  ) });
};
pC.displayName = "Calendar";
const t8 = (e) => {
  const { goToMonth: t, nextMonth: n, previousMonth: r } = ba(), { fromDate: o, toDate: s } = b.useContext(hC), i = yc(e.calendarMonth.date), a = !r || !!o && !WN(i, yc(o)), c = !n || !!s && !BN(i, yc(s));
  return /* @__PURE__ */ Z("div", { className: "mb-4 flex items-center justify-between", children: [
    /* @__PURE__ */ _(
      Di,
      {
        variant: "tertiary",
        size: "xs",
        disabled: a,
        onClick: () => r && t(r),
        "aria-label": "Go to previous month",
        children: /* @__PURE__ */ _(wk, {})
      }
    ),
    /* @__PURE__ */ _(
      "div",
      {
        id: e.id,
        "aria-live": "polite",
        role: "presentation",
        className: "text-sm font-medium text-foundations-boldest",
        children: Lr(e.calendarMonth.date, "MMMM yyyy")
      }
    ),
    /* @__PURE__ */ _(
      Di,
      {
        variant: "tertiary",
        size: "xs",
        disabled: c,
        onClick: () => n && t(n),
        "aria-label": "Go to next month",
        children: /* @__PURE__ */ _(Ph, {})
      }
    )
  ] });
}, n8 = (e) => e.querySelector("input,textarea") || e, gu = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class r8 {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, s) => o !== t.selection[s]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, {
      inputType: n,
      data: null
    });
  }
}
function o8(e, ...t) {
  return t.every(({
    value: n
  }) => n === e.value);
}
function s8(e, ...t) {
  return t.every(({
    value: n,
    selection: r
  }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function i8({
  value: e,
  selection: t
}, n, r) {
  const [o, s] = t, i = typeof r == "function" ? r({
    value: e,
    selection: t
  }) : r;
  return {
    value: e,
    selection: i === "replace" ? [o, o + n.length] : [o, s]
  };
}
function mu(e) {
  return typeof e == "string";
}
function sv(e, t, n, r) {
  let o = "";
  for (let s = t.length; s < e.length; s++) {
    const i = e[s], a = (r == null ? void 0 : r.value[s]) === i;
    if (!mu(i) || i === n && !a)
      return o;
    o += i;
  }
  return o;
}
function gC(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return mu(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function a8(e, t, n) {
  let r = null, o = null;
  const s = Array.from(e.value).reduce((a, c, l) => {
    const u = sv(t, a, c, n), d = a + u, f = t[d.length];
    return mu(f) ? d + f : c.match(f) ? (r === null && l >= e.selection[0] && (r = d.length), o === null && l >= e.selection[1] && (o = d.length), d + c) : d;
  }, ""), i = sv(t, s, "", n);
  return {
    value: gC(s + i, t) ? s + i : s,
    selection: [r ?? s.length, o ?? s.length]
  };
}
function c8({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  let s = r, i = o;
  return {
    value: Array.from(e).reduce((c, l, u) => {
      const d = c + l;
      return r === u && (s = c.length), o === u && (i = c.length), d.match(n) ? d : c;
    }, ""),
    selection: [s, i]
  };
}
function Za(e, t, n = null) {
  if (gC(e.value, t))
    return e;
  const {
    value: r,
    selection: o
  } = Array.isArray(t) ? a8(e, t, n) : c8(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function iv(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], s = Array.from(e.value).reduce((i, a, c) => {
    const l = t[c];
    return c === n && o.push(i.length), c === r && o.push(i.length), mu(l) && l === a ? i : i + a;
  }, "");
  return o.length < 2 && o.push(...Array(2 - o.length).fill(s.length)), {
    value: s,
    selection: [o[0], o[1]]
  };
}
class ff {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const {
      value: r,
      selection: o
    } = Za(t, this.getMaskExpression(t));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const {
      value: o
    } = this, s = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), i = {
      value: o,
      selection: [t, n]
    }, a = iv(i, s), [c, l] = i8(a, r, this.maskOptions.overwriteMode).selection, u = a.value.slice(0, c) + r, d = u.length, f = Za({
      value: u + a.value.slice(l),
      selection: [d, d]
    }, s, i);
    if (o.slice(0, c) === Za({
      value: u,
      selection: [d, d]
    }, s, i).value || s8(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const {
      value: r
    } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), s = {
      value: r,
      selection: [t, n]
    }, i = iv(s, o), [a, c] = i.selection, l = i.value.slice(0, a) + i.value.slice(c), u = Za({
      value: l,
      selection: [a, a]
    }, o, s);
    this.value = u.value, this.selection = u.selection;
  }
  getMaskExpression(t) {
    const {
      mask: n
    } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class l8 {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
function ki(e, t, n) {
  return e.ctrlKey === !!(t & 1) && e.altKey === !!(t & 2) && e.shiftKey === !!(t & 4) && e.metaKey === !!(t & 8) && e.keyCode === n;
}
function u8(e) {
  return ki(
    e,
    1,
    89
    /* Y */
  ) || // Windows
  ki(
    e,
    5,
    90
    /* Z */
  ) || // Windows & Android
  ki(
    e,
    12,
    90
    /* Z */
  );
}
function d8(e) {
  return ki(
    e,
    1,
    90
    /* Z */
  ) || // Windows & Android
  ki(
    e,
    8,
    90
    /* Z */
  );
}
function f8(e) {
  return "onbeforeinput" in e;
}
function h8({
  key: e,
  ctrlKey: t,
  metaKey: n,
  altKey: r
}) {
  const o = t || n || r, s = /^.$/u.test(e);
  return !o && e !== "Backspace" && s;
}
function p8({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const s = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : s, n ? s : o];
}
function av({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((i) => Math.min(Math.max(i, 0), e.length));
}
const cv = /\s+$/g, lv = /^\s+/g, uv = /\s/;
function g8({
  value: e,
  selection: t
}, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const c = e.slice(r), [l] = c.match(lv) || [""], u = c.replace(lv, "").search(uv);
    return [r, u !== -1 ? r + l.length + u : e.length];
  }
  const s = e.slice(0, o), [i] = s.match(cv) || [""], a = s.replace(cv, "").split("").reverse().findIndex((c) => c.match(uv));
  return [a !== -1 ? o - i.length - a : 0, o];
}
function ol(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function m8(e, t) {
  const n = Object.assign(Object.assign({}, gu), t), r = ol(n.preprocessors), o = ol(n.postprocessors), s = typeof e == "string" ? {
    value: e,
    selection: [0, 0]
  } : e, {
    elementState: i
  } = r({
    elementState: s,
    data: ""
  }, "validation"), a = new ff(i, n), {
    value: c,
    selection: l
  } = o(a, s);
  return typeof e == "string" ? c : {
    value: c,
    selection: l
  };
}
class b8 extends r8 {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new l8(this.element), this.options = Object.assign(Object.assign({}, gu), this.maskitoOptions), this.preprocessor = ol(this.options.preprocessors), this.postprocessor = ol(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.ensureValueFitsMask(), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (u8(r))
        return r.preventDefault(), this.redo();
      if (d8(r))
        return r.preventDefault(), this.undo();
    }), f8(t) ? this.eventListener.listen("beforeinput", (r) => {
      const o = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: av(this.elementState, o)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: g8(this.elementState, o),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: p8(this.elementState, o),
            force: !0
          });
        case "insertLineBreak":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || "");
      }
    }) : (this.eventListener.listen("keydown", (r) => this.handleKeydown(r)), this.eventListener.listen("paste", (r) => {
      var o;
      return this.handleInsert(r, ((o = r.clipboardData) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
    })), this.eventListener.listen("input", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const {
      value: t,
      selectionStart: n,
      selectionEnd: r
    } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const {
      maxLength: t
    } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({
    value: t,
    selection: n
  }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r, o;
    (this.element.selectionStart !== t || this.element.selectionEnd !== n) && ((o = (r = this.element).setSelectionRange) === null || o === void 0 || o.call(r, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(m8(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    const n = typeof window < "u" ? window : globalThis;
    n != null && n.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), {
      bubbles: !0,
      cancelable: !1
    })));
  }
  handleKeydown(t) {
    const n = t.key, r = n === "Delete";
    switch (n) {
      case "Backspace":
      case "Delete":
        return this.handleDelete({
          event: t,
          isForward: r,
          selection: av(this.elementState, r)
        });
      case "Enter":
        return this.handleEnter(t);
    }
    h8(t) && this.handleInsert(t, n);
  }
  handleDelete({
    event: t,
    selection: n,
    isForward: r,
    force: o = !1
  }) {
    const s = {
      value: this.elementState.value,
      selection: n
    }, [i, a] = s.selection, {
      elementState: c
    } = this.preprocessor({
      elementState: s,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), l = new ff(c, this.options), [u, d] = c.selection;
    l.deleteCharacters([u, d]);
    const f = this.postprocessor(l, s);
    if (s.value.slice(0, i) + s.value.slice(a) === f.value && !o)
      return;
    if (t.preventDefault(), o8(s, c, l, f))
      return this.updateSelectionRange(r ? [d, d] : [u, u]);
    const p = r ? "deleteContentForward" : "deleteContentBackward";
    this.updateElementState(f, {
      inputType: "inputType" in t ? t.inputType : p,
      data: null
    }), this.updateHistory(f);
  }
  handleInsert(t, n) {
    const r = this.elementState, {
      elementState: o,
      data: s = n
    } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), i = new ff(o, this.options);
    try {
      i.addCharacters(o.selection, s);
    } catch {
      return t.preventDefault();
    }
    const [a, c] = o.selection, l = o.value.slice(0, a) + n + o.value.slice(c), u = this.postprocessor(i, r);
    if (u.value.length > this.maxLength)
      return t.preventDefault();
    l !== u.value && (t.preventDefault(), this.updateElementState(u, {
      data: n,
      inputType: "inputType" in t ? t.inputType : "insertText"
    }), this.updateHistory(u));
  }
  handleEnter(t) {
    this.isTextArea && this.handleInsert(t, `
`);
  }
}
const v8 = /* @__PURE__ */ new Date("0001-01-01"), y8 = /* @__PURE__ */ new Date("9999-12-31"), w8 = "–", x8 = "—", C8 = "-", E8 = "−", _8 = [C8, w8, x8, E8], S8 = [":", "."];
function hf(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const mC = (e) => {
  var t, n, r;
  return {
    day: ((t = e.match(/d/g)) === null || t === void 0 ? void 0 : t.length) || 0,
    month: ((n = e.match(/m/g)) === null || n === void 0 ? void 0 : n.length) || 0,
    year: ((r = e.match(/y/g)) === null || r === void 0 ? void 0 : r.length) || 0
  };
};
function O8(e) {
  return {
    day: String(e.getDate()).padStart(2, "0"),
    month: String(e.getMonth() + 1).padStart(2, "0"),
    year: String(e.getFullYear()).padStart(4, "0"),
    hours: String(e.getHours()).padStart(2, "0"),
    minutes: String(e.getMinutes()).padStart(2, "0"),
    seconds: String(e.getSeconds()).padStart(2, "0"),
    milliseconds: String(e.getMilliseconds()).padStart(3, "0")
  };
}
function M8(e, t) {
  return e.length < t.length ? !1 : e.split(/\D/).every((n) => !n.match(/^0+$/));
}
function bC(e, t, n) {
  const r = t.replace(/\W/g, "").length;
  return e.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function vC(e) {
  return e.reduce((t, [n, r]) => Object.assign(Object.assign({}, t), {
    [n]: r
  }), {});
}
function yC(e, t) {
  const n = t.replace(/[^dmy]/g, ""), r = e.replace(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return vC(Object.entries(o).filter(([s, i]) => !!i).sort(([s], [i]) => t.toLowerCase().indexOf(s[0]) > t.toLowerCase().indexOf(i[0]) ? 1 : -1));
}
function T8(e, t) {
  var n, r, o, s, i, a, c;
  const l = ((n = e.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${e.year}` : e.year, u = new Date(Number(l ?? "0"), Number((r = e.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = e.day) !== null && o !== void 0 ? o : "1"), Number((s = t == null ? void 0 : t.hours) !== null && s !== void 0 ? s : "0"), Number((i = t == null ? void 0 : t.minutes) !== null && i !== void 0 ? i : "0"), Number((a = t == null ? void 0 : t.seconds) !== null && a !== void 0 ? a : "0"), Number((c = t == null ? void 0 : t.milliseconds) !== null && c !== void 0 ? c : "0"));
  return u.setFullYear(Number(l ?? "0")), u;
}
const k8 = ", ";
function sl({
  day: e,
  month: t,
  year: n,
  hours: r,
  minutes: o,
  seconds: s,
  milliseconds: i
}, a, c) {
  var l;
  const u = ((l = a.match(/y/g)) === null || l === void 0 ? void 0 : l.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (c ? k8 + c : "")).replace(/d+/g, e ?? "").replace(/m+/g, t ?? "").replace(/y+/g, u ?? "").replace(/H+/g, r ?? "").replace(/MSS/g, i ?? "").replace(/M+/g, o ?? "").replace(/S+/g, s ?? "").replace(/^\D+/g, "").replace(/\D+$/g, "");
}
function pf(e, t, n = 0) {
  return Number(e.padEnd(t.length, "0")) <= Number(t) ? {
    validatedSegmentValue: e,
    prefixedZeroesCount: n
  } : e.endsWith("0") ? pf(`0${e.slice(0, t.length - 1)}`, t, n + 1) : pf(`${e.slice(0, t.length - 1)}0`, t, n);
}
const P8 = {
  day: 31,
  month: 12,
  year: 9999
};
function R8({
  dateString: e,
  dateModeTemplate: t,
  offset: n,
  selection: [r, o]
}) {
  const s = yC(e, t), i = Object.entries(s), a = {};
  let c = 0;
  for (const [d, f] of i) {
    const h = sl(a, t), p = P8[d], g = h.length && 1, m = n + h.length + g + mC(t)[d], y = m >= r && m === o;
    if (y && Number(f) > Number(p))
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    if (y && Number(f) < 1)
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    const {
      validatedSegmentValue: v,
      prefixedZeroesCount: w
    } = pf(f, `${p}`);
    c += w, a[d] = v;
  }
  const l = sl(a, t), u = l.length - e.length;
  return {
    validatedDateString: l,
    updatedSelection: [r + c + u, o + c + u]
  };
}
const wC = /[\\^$.*+?()[\]{}|]/g, I8 = RegExp(wC.source);
function xC(e) {
  return e && I8.test(e) ? e.replace(wC, "\\$&") : e;
}
function D8({
  activeElement: e
}) {
  if (!(e != null && e.shadowRoot))
    return e;
  let t = e.shadowRoot.activeElement;
  for (; t != null && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function N8(e, t) {
  const n = mC(t);
  return vC(Object.entries(e).map(([r, o]) => {
    const s = n[r];
    return [r, o.length === s && o.match(/^0+$/) ? "1".padStart(s, "0") : o];
  }));
}
function A8({
  dateModeTemplate: e,
  min: t = v8,
  max: n = y8,
  rangeSeparator: r = "",
  dateSegmentSeparator: o = "."
}) {
  return ({
    value: s,
    selection: i
  }) => {
    const a = r && s.endsWith(r), c = bC(s, e, r);
    let l = "";
    for (const u of c) {
      l += l ? r : "";
      const d = yC(u, e);
      if (!M8(u, e)) {
        const p = N8(d, e), g = sl(p, e), m = u.endsWith(o) ? o : "";
        l += g + m;
        continue;
      }
      const f = T8(d), h = hf(f, t, n);
      l += sl(O8(h), e);
    }
    return {
      selection: i,
      value: l + (a ? r : "")
    };
  };
}
function $8({
  dateModeTemplate: e,
  dateSegmentsSeparator: t,
  rangeSeparator: n = ""
}) {
  return ({
    elementState: r,
    data: o
  }) => {
    const {
      value: s,
      selection: i
    } = r;
    if (o === t)
      return {
        elementState: r,
        data: i[0] === s.length ? o : ""
      };
    if (_8.includes(o))
      return {
        elementState: r,
        data: n
      };
    const a = o.replace(new RegExp(`[^\\d${xC(t)}${n}]`, "g"), "");
    if (!a)
      return {
        elementState: r,
        data: ""
      };
    const [c, l] = i;
    let u = l + o.length;
    const d = s.slice(0, c) + a + s.slice(u), f = bC(d, e, n);
    let h = "";
    const p = !!n && d.includes(n);
    for (const m of f) {
      const {
        validatedDateString: y,
        updatedSelection: v
      } = R8({
        dateString: m,
        dateModeTemplate: e,
        offset: h ? h.length + n.length : 0,
        selection: [c, u]
      });
      if (m && !y)
        return {
          elementState: r,
          data: ""
        };
      u = v[1], h += p && h ? n + y : y;
    }
    const g = h.slice(c, u);
    return {
      elementState: {
        selection: i,
        value: h.slice(0, c) + g.split(t).map((m) => "0".repeat(m.length)).join(t) + h.slice(u)
      },
      data: g
    };
  };
}
function F8(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, s = () => r--, i = () => {
      if (D8(n) !== t)
        return;
      if (r)
        return n.addEventListener("mouseup", i, {
          once: !0,
          passive: !0
        });
      const a = t.selectionStart || 0, c = t.selectionEnd || 0, [l, u] = e(t.value, [a, c]);
      (l > a || u < c) && t.setSelectionRange(hf(a, l, u), hf(c, l, u));
    };
    return n.addEventListener("selectionchange", i, {
      passive: !0
    }), n.addEventListener("mousedown", o, {
      passive: !0
    }), n.addEventListener("mouseup", s, {
      passive: !0
    }), () => {
      n.removeEventListener("selectionchange", i), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", s);
    };
  };
}
function dv(e, t, n) {
  return (r, o) => {
    const s = () => t(r, o);
    return r.addEventListener(e, s, n), () => r.removeEventListener(e, s, n);
  };
}
function L8(e, t = !1) {
  const n = (s) => {
    for (let i = s.length - 1; i >= 0; i--)
      if (s[i] !== e[i])
        return s.slice(0, i + 1);
    return "";
  }, r = [F8((s) => [0, n(s).length])];
  let o = !1;
  if (t) {
    const s = dv("focus", (a) => {
      o = !0, a.value += e.slice(a.value.length), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    }), i = dv("blur", (a) => {
      o = !1, a.value = n(a.value), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    });
    r.push(s, i);
  }
  return {
    plugins: r,
    removePlaceholder: n,
    preprocessors: [({
      elementState: s,
      data: i
    }) => {
      const {
        value: a,
        selection: c
      } = s;
      return {
        elementState: {
          selection: c,
          value: n(a)
        },
        data: i
      };
    }],
    postprocessors: [({
      value: s,
      selection: i
    }, a) => a.value && (o || !t) ? {
      value: s + e.slice(s.length),
      selection: i
    } : {
      value: s,
      selection: i
    }]
  };
}
function V8() {
  return ({
    elementState: e
  }, t) => {
    const {
      value: n,
      selection: r
    } = e;
    if (!n || W8(n, r))
      return {
        elementState: e
      };
    const [o, s] = r, i = n.slice(o, s).replace(/\d/g, "0"), a = n.slice(0, o) + i + n.slice(s);
    return t === "validation" || t === "insert" && o === s ? {
      elementState: {
        selection: r,
        value: a
      }
    } : {
      elementState: {
        selection: t === "deleteBackward" || t === "insert" ? [o, o] : [s, s],
        value: a
      }
    };
  };
}
function W8(e, [t, n]) {
  return n === e.length;
}
function B8({
  mode: e,
  separator: t = ".",
  max: n,
  min: r
}) {
  const o = e.split("/").join(t);
  return Object.assign(Object.assign({}, gu), {
    mask: Array.from(o).map((s) => s === t ? s : /\d/),
    overwriteMode: "replace",
    preprocessors: [V8(), $8({
      dateModeTemplate: o,
      dateSegmentsSeparator: t
    })],
    postprocessors: [A8({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: t
    })]
  });
}
new RegExp(`[${S8.map(xC).join("")}]$`);
const H8 = typeof window < "u" ? Rs : Ke, Y8 = ({
  options: e = gu,
  elementPredicate: t = n8
} = {}) => {
  const [n, r] = _t(null), o = je((s) => {
    r(s);
  }, []);
  return H8(() => {
    if (!n)
      return;
    const s = new b8(t(n), e);
    return () => {
      s.destroy();
    };
  }, [e, n, t]), o;
};
function z8(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = zr(e);
  Ke(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const gf = "dismissableLayer.update", j8 = "dismissableLayer.pointerDownOutside", U8 = "dismissableLayer.focusOutside";
let fv;
const G8 = /* @__PURE__ */ Ii({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), K8 = /* @__PURE__ */ At((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: i, onInteractOutside: a, onDismiss: c, ...l } = e, u = bl(G8), [d, f] = _t(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = _t({}), g = vr(
    t,
    (M) => f(M)
  ), m = Array.from(u.layers), [y] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = m.indexOf(y), w = d ? m.indexOf(d) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, x = w >= v, E = q8((M) => {
    const T = M.target, P = [
      ...u.branches
    ].some(
      (k) => k.contains(T)
    );
    !x || P || (s == null || s(M), a == null || a(M), M.defaultPrevented || c == null || c());
  }, h), S = X8((M) => {
    const T = M.target;
    [
      ...u.branches
    ].some(
      (k) => k.contains(T)
    ) || (i == null || i(M), a == null || a(M), M.defaultPrevented || c == null || c());
  }, h);
  return z8((M) => {
    w === u.layers.size - 1 && (o == null || o(M), !M.defaultPrevented && c && (M.preventDefault(), c()));
  }, h), Ke(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (fv = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), hv(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = fv);
      };
  }, [
    d,
    h,
    r,
    u
  ]), Ke(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), hv());
  }, [
    d,
    u
  ]), Ke(() => {
    const M = () => p({});
    return document.addEventListener(gf, M), () => document.removeEventListener(gf, M);
  }, []), /* @__PURE__ */ Le(Nn.div, et({}, l, {
    ref: g,
    style: {
      pointerEvents: C ? x ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: pn(e.onFocusCapture, S.onFocusCapture),
    onBlurCapture: pn(e.onBlurCapture, S.onBlurCapture),
    onPointerDownCapture: pn(e.onPointerDownCapture, E.onPointerDownCapture)
  }));
});
function q8(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = zr(e), r = Ue(!1), o = Ue(() => {
  });
  return Ke(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          CC(j8, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      }
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function X8(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = zr(e), r = Ue(!1);
  return Ke(() => {
    const o = (s) => {
      s.target && !r.current && CC(U8, n, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function hv() {
  const e = new CustomEvent(gf);
  document.dispatchEvent(e);
}
function CC(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? w6(o, s) : o.dispatchEvent(s);
}
let ud = 0;
function Z8() {
  Ke(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : pv()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : pv()), ud++, () => {
      ud === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), ud--;
    };
  }, []);
}
function pv() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const dd = "focusScope.autoFocusOnMount", fd = "focusScope.autoFocusOnUnmount", gv = {
  bubbles: !1,
  cancelable: !0
}, Q8 = /* @__PURE__ */ At((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: s, ...i } = e, [a, c] = _t(null), l = zr(o), u = zr(s), d = Ue(null), f = vr(
    t,
    (g) => c(g)
  ), h = Ue({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ke(() => {
    if (r) {
      let g = function(w) {
        if (h.paused || !a)
          return;
        const C = w.target;
        a.contains(C) ? d.current = C : ro(d.current, {
          select: !0
        });
      }, m = function(w) {
        if (h.paused || !a)
          return;
        const C = w.relatedTarget;
        C !== null && (a.contains(C) || ro(d.current, {
          select: !0
        }));
      }, y = function(w) {
        const C = document.activeElement;
        for (const x of w)
          x.removedNodes.length > 0 && (a != null && a.contains(C) || ro(a));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const v = new MutationObserver(y);
      return a && v.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), v.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), Ke(() => {
    if (a) {
      bv.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(dd, gv);
        a.addEventListener(dd, l), a.dispatchEvent(y), y.defaultPrevented || (J8(o$(EC(a)), {
          select: !0
        }), document.activeElement === g && ro(a));
      }
      return () => {
        a.removeEventListener(dd, l), setTimeout(() => {
          const y = new CustomEvent(fd, gv);
          a.addEventListener(fd, u), a.dispatchEvent(y), y.defaultPrevented || ro(g ?? document.body, {
            select: !0
          }), a.removeEventListener(fd, u), bv.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    l,
    u,
    h
  ]);
  const p = je((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
    if (m && y) {
      const v = g.currentTarget, [w, C] = e$(v);
      w && C ? !g.shiftKey && y === C ? (g.preventDefault(), n && ro(w, {
        select: !0
      })) : g.shiftKey && y === w && (g.preventDefault(), n && ro(C, {
        select: !0
      })) : y === v && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ Le(Nn.div, et({
    tabIndex: -1
  }, i, {
    ref: f,
    onKeyDown: p
  }));
});
function J8(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ro(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function e$(e) {
  const t = EC(e), n = mv(t, e), r = mv(t.reverse(), e);
  return [
    n,
    r
  ];
}
function EC(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function mv(e, t) {
  for (const n of e)
    if (!t$(n, {
      upTo: t
    }))
      return n;
}
function t$(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function n$(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ro(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && n$(e) && t && e.select();
  }
}
const bv = r$();
function r$() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = vv(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = vv(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function vv(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function o$(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const s$ = ["top", "right", "bottom", "left"], Ki = Math.min, No = Math.max, i$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, a$ = {
  start: "end",
  end: "start"
};
function mf(e, t, n) {
  return No(e, Ki(t, n));
}
function jr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ur(e) {
  return e.split("-")[0];
}
function Vs(e) {
  return e.split("-")[1];
}
function Dp(e) {
  return e === "x" ? "y" : "x";
}
function Np(e) {
  return e === "y" ? "height" : "width";
}
function Ws(e) {
  return ["top", "bottom"].includes(Ur(e)) ? "y" : "x";
}
function Ap(e) {
  return Dp(Ws(e));
}
function c$(e, t, n) {
  n === void 0 && (n = !1);
  const r = Vs(e), o = Ap(e), s = Np(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (i = il(i)), [i, il(i)];
}
function l$(e) {
  const t = il(e);
  return [bf(e), t, bf(t)];
}
function bf(e) {
  return e.replace(/start|end/g, (t) => a$[t]);
}
function u$(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? s : i;
    default:
      return [];
  }
}
function d$(e, t, n, r) {
  const o = Vs(e);
  let s = u$(Ur(e), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), t && (s = s.concat(s.map(bf)))), s;
}
function il(e) {
  return e.replace(/left|right|bottom|top/g, (t) => i$[t]);
}
function f$(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function _C(e) {
  return typeof e != "number" ? f$(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function al(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function yv(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = Ws(t), i = Ap(t), a = Np(i), c = Ur(t), l = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Vs(t)) {
    case "start":
      h[i] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && l ? -1 : 1);
      break;
  }
  return h;
}
const h$ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = s.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = yv(l, r, c), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: m,
      fn: y
    } = a[g], {
      x: v,
      y: w,
      data: C,
      reset: x
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = v ?? u, d = w ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...C
      }
    }, x && p <= 50) {
      p++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (l = x.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : x.rects), {
        x: u,
        y: d
      } = yv(l, f, c)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function qi(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: a,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = jr(t, e), p = _C(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], y = al(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(m))) == null || n ? m : m.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), v = d === "floating" ? {
    ...i.floating,
    x: r,
    y: o
  } : i.reference, w = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), C = await (s.isElement == null ? void 0 : s.isElement(w)) ? await (s.getScale == null ? void 0 : s.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = al(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: v,
    offsetParent: w,
    strategy: c
  }) : v);
  return {
    top: (y.top - x.top + p.top) / C.y,
    bottom: (x.bottom - y.bottom + p.bottom) / C.y,
    left: (y.left - x.left + p.left) / C.x,
    right: (x.right - y.right + p.right) / C.x
  };
}
const wv = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: i,
      elements: a
    } = t, {
      element: c,
      padding: l = 0
    } = jr(e, t) || {};
    if (c == null)
      return {};
    const u = _C(l), d = {
      x: n,
      y: r
    }, f = Ap(o), h = Np(f), p = await i.getDimensions(c), g = f === "y", m = g ? "top" : "left", y = g ? "bottom" : "right", v = g ? "clientHeight" : "clientWidth", w = s.reference[h] + s.reference[f] - d[f] - s.floating[h], C = d[f] - s.reference[f], x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = x ? x[v] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(x))) && (E = a.floating[v] || s.floating[h]);
    const S = w / 2 - C / 2, M = E / 2 - p[h] / 2 - 1, T = Ki(u[m], M), P = Ki(u[y], M), k = T, I = E - p[h] - P, O = E / 2 - p[h] / 2 + S, A = mf(k, O, I), N = Vs(o) != null && O != A && s.reference[h] / 2 - (O < k ? T : P) - p[h] / 2 < 0 ? O < k ? k - O : I - O : 0;
    return {
      [f]: d[f] - N,
      data: {
        [f]: A,
        centerOffset: O - A + N
      }
    };
  }
}), SC = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: a,
        elements: c
      } = t, {
        mainAxis: l = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...g
      } = jr(e, t), m = Ur(r), y = Ur(i) === i, v = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), w = d || (y || !p ? [il(i)] : l$(i));
      !d && h !== "none" && w.push(...d$(i, p, h, v));
      const C = [i, ...w], x = await qi(t, g), E = [];
      let S = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (l && E.push(x[m]), u) {
        const k = c$(r, s, v);
        E.push(x[k[0]], x[k[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: E
      }], !E.every((k) => k <= 0)) {
        var M, T;
        const k = (((M = o.flip) == null ? void 0 : M.index) || 0) + 1, I = C[k];
        if (I)
          return {
            data: {
              index: k,
              overflows: S
            },
            reset: {
              placement: I
            }
          };
        let O = (T = S.filter((A) => A.overflows[0] <= 0).sort((A, R) => A.overflows[1] - R.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!O)
          switch (f) {
            case "bestFit": {
              var P;
              const A = (P = S.map((R) => [R.placement, R.overflows.filter((N) => N > 0).reduce((N, $) => N + $, 0)]).sort((R, N) => R[1] - N[1])[0]) == null ? void 0 : P[0];
              A && (O = A);
              break;
            }
            case "initialPlacement":
              O = i;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function xv(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Cv(e) {
  return s$.some((t) => e[t] >= 0);
}
const p$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = jr(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = await qi(t, {
            ...o,
            elementContext: "reference"
          }), i = xv(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Cv(i)
            }
          };
        }
        case "escaped": {
          const s = await qi(t, {
            ...o,
            altBoundary: !0
          }), i = xv(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Cv(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function g$(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Ur(n), a = Vs(n), c = Ws(n) === "y", l = ["left", "top"].includes(i) ? -1 : 1, u = s && c ? -1 : 1, d = jr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), c ? {
    x: h * u,
    y: f * l
  } : {
    x: f * l,
    y: h * u
  };
}
const OC = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await g$(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, MC = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: y,
              y: v
            } = m;
            return {
              x: y,
              y: v
            };
          }
        },
        ...c
      } = jr(e, t), l = {
        x: n,
        y: r
      }, u = await qi(t, c), d = Ws(Ur(o)), f = Dp(d);
      let h = l[f], p = l[d];
      if (s) {
        const m = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", v = h + u[m], w = h - u[y];
        h = mf(v, h, w);
      }
      if (i) {
        const m = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", v = p + u[m], w = p - u[y];
        p = mf(v, p, w);
      }
      const g = a.fn({
        ...t,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, m$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: i
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = jr(e, t), u = {
        x: n,
        y: r
      }, d = Ws(o), f = Dp(d);
      let h = u[f], p = u[d];
      const g = jr(a, t), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const w = f === "y" ? "height" : "width", C = s.reference[f] - s.floating[w] + m.mainAxis, x = s.reference[f] + s.reference[w] - m.mainAxis;
        h < C ? h = C : h > x && (h = x);
      }
      if (l) {
        var y, v;
        const w = f === "y" ? "width" : "height", C = ["top", "left"].includes(Ur(o)), x = s.reference[d] - s.floating[w] + (C && ((y = i.offset) == null ? void 0 : y[d]) || 0) + (C ? 0 : m.crossAxis), E = s.reference[d] + s.reference[w] + (C ? 0 : ((v = i.offset) == null ? void 0 : v[d]) || 0) - (C ? m.crossAxis : 0);
        p < x ? p = x : p > E && (p = E);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, TC = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: s
      } = t, {
        apply: i = () => {
        },
        ...a
      } = jr(e, t), c = await qi(t, a), l = Ur(n), u = Vs(n), d = Ws(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      l === "top" || l === "bottom" ? (p = l, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = l, p = u === "end" ? "top" : "bottom");
      const m = h - c[p], y = f - c[g], v = !t.middlewareData.shift;
      let w = m, C = y;
      if (d) {
        const E = f - c.left - c.right;
        C = u || v ? Ki(y, E) : E;
      } else {
        const E = h - c.top - c.bottom;
        w = u || v ? Ki(m, E) : E;
      }
      if (v && !u) {
        const E = No(c.left, 0), S = No(c.right, 0), M = No(c.top, 0), T = No(c.bottom, 0);
        d ? C = f - 2 * (E !== 0 || S !== 0 ? E + S : No(c.left, c.right)) : w = h - 2 * (M !== 0 || T !== 0 ? M + T : No(c.top, c.bottom));
      }
      await i({
        ...t,
        availableWidth: C,
        availableHeight: w
      });
      const x = await o.getDimensions(s.floating);
      return f !== x.width || h !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
}, vf = Math.min, bs = Math.max, cl = Math.round, Qa = Math.floor, po = (e) => ({
  x: e,
  y: e
});
function go(e) {
  return kC(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Dn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Zr(e) {
  var t;
  return (t = (kC(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function kC(e) {
  return e instanceof Node || e instanceof Dn(e).Node;
}
function Gr(e) {
  return e instanceof Element || e instanceof Dn(e).Element;
}
function yr(e) {
  return e instanceof HTMLElement || e instanceof Dn(e).HTMLElement;
}
function Ev(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Dn(e).ShadowRoot;
}
function ya(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = jn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function b$(e) {
  return ["table", "td", "th"].includes(go(e));
}
function $p(e) {
  const t = Fp(), n = jn(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function v$(e) {
  let t = ks(e);
  for (; yr(t) && !bu(t); ) {
    if ($p(t))
      return t;
    t = ks(t);
  }
  return null;
}
function Fp() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function bu(e) {
  return ["html", "body", "#document"].includes(go(e));
}
function jn(e) {
  return Dn(e).getComputedStyle(e);
}
function vu(e) {
  return Gr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ks(e) {
  if (go(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ev(e) && e.host || // Fallback.
    Zr(e)
  );
  return Ev(t) ? t.host : t;
}
function PC(e) {
  const t = ks(e);
  return bu(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : yr(t) && ya(t) ? t : PC(t);
}
function ll(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = PC(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), s = Dn(r);
  return o ? t.concat(s, s.visualViewport || [], ya(r) ? r : []) : t.concat(r, ll(r));
}
function RC(e) {
  const t = jn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = yr(e), s = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, a = cl(n) !== s || cl(r) !== i;
  return a && (n = s, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function Lp(e) {
  return Gr(e) ? e : e.contextElement;
}
function vs(e) {
  const t = Lp(e);
  if (!yr(t))
    return po(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = RC(t);
  let i = (s ? cl(n.width) : n.width) / r, a = (s ? cl(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const y$ = /* @__PURE__ */ po(0);
function IC(e) {
  const t = Dn(e);
  return !Fp() || !t.visualViewport ? y$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function w$(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Dn(e) ? !1 : t;
}
function Go(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = Lp(e);
  let i = po(1);
  t && (r ? Gr(r) && (i = vs(r)) : i = vs(e));
  const a = w$(s, n, r) ? IC(s) : po(0);
  let c = (o.left + a.x) / i.x, l = (o.top + a.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s) {
    const f = Dn(s), h = r && Gr(r) ? Dn(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const g = vs(p), m = p.getBoundingClientRect(), y = jn(p), v = m.left + (p.clientLeft + parseFloat(y.paddingLeft)) * g.x, w = m.top + (p.clientTop + parseFloat(y.paddingTop)) * g.y;
      c *= g.x, l *= g.y, u *= g.x, d *= g.y, c += v, l += w, p = Dn(p).frameElement;
    }
  }
  return al({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function x$(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = yr(n), s = Zr(n);
  if (n === s)
    return t;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = po(1);
  const c = po(0);
  if ((o || !o && r !== "fixed") && ((go(n) !== "body" || ya(s)) && (i = vu(n)), yr(n))) {
    const l = Go(n);
    a = vs(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - i.scrollLeft * a.x + c.x,
    y: t.y * a.y - i.scrollTop * a.y + c.y
  };
}
function C$(e) {
  return Array.from(e.getClientRects());
}
function DC(e) {
  return Go(Zr(e)).left + vu(e).scrollLeft;
}
function E$(e) {
  const t = Zr(e), n = vu(e), r = e.ownerDocument.body, o = bs(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = bs(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + DC(e);
  const a = -n.scrollTop;
  return jn(r).direction === "rtl" && (i += bs(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: i,
    y: a
  };
}
function _$(e, t) {
  const n = Dn(e), r = Zr(e), o = n.visualViewport;
  let s = r.clientWidth, i = r.clientHeight, a = 0, c = 0;
  if (o) {
    s = o.width, i = o.height;
    const l = Fp();
    (!l || l && t === "fixed") && (a = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: a,
    y: c
  };
}
function S$(e, t) {
  const n = Go(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = yr(e) ? vs(e) : po(1), i = e.clientWidth * s.x, a = e.clientHeight * s.y, c = o * s.x, l = r * s.y;
  return {
    width: i,
    height: a,
    x: c,
    y: l
  };
}
function _v(e, t, n) {
  let r;
  if (t === "viewport")
    r = _$(e, n);
  else if (t === "document")
    r = E$(Zr(e));
  else if (Gr(t))
    r = S$(t, n);
  else {
    const o = IC(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return al(r);
}
function NC(e, t) {
  const n = ks(e);
  return n === t || !Gr(n) || bu(n) ? !1 : jn(n).position === "fixed" || NC(n, t);
}
function O$(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ll(e).filter((a) => Gr(a) && go(a) !== "body"), o = null;
  const s = jn(e).position === "fixed";
  let i = s ? ks(e) : e;
  for (; Gr(i) && !bu(i); ) {
    const a = jn(i), c = $p(i);
    !c && a.position === "fixed" && (o = null), (s ? !c && !o : !c && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ya(i) && !c && NC(e, i)) ? r = r.filter((u) => u !== i) : o = a, i = ks(i);
  }
  return t.set(e, r), r;
}
function M$(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? O$(t, this._c) : [].concat(n), r], a = i[0], c = i.reduce((l, u) => {
    const d = _v(t, u, o);
    return l.top = bs(d.top, l.top), l.right = vf(d.right, l.right), l.bottom = vf(d.bottom, l.bottom), l.left = bs(d.left, l.left), l;
  }, _v(t, a, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function T$(e) {
  return RC(e);
}
function k$(e, t, n) {
  const r = yr(t), o = Zr(t), s = n === "fixed", i = Go(e, !0, s, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = po(0);
  if (r || !r && !s)
    if ((go(t) !== "body" || ya(o)) && (a = vu(t)), r) {
      const l = Go(t, !0, s, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else
      o && (c.x = DC(o));
  return {
    x: i.left + a.scrollLeft - c.x,
    y: i.top + a.scrollTop - c.y,
    width: i.width,
    height: i.height
  };
}
function Sv(e, t) {
  return !yr(e) || jn(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function AC(e, t) {
  const n = Dn(e);
  if (!yr(e))
    return n;
  let r = Sv(e, t);
  for (; r && b$(r) && jn(r).position === "static"; )
    r = Sv(r, t);
  return r && (go(r) === "html" || go(r) === "body" && jn(r).position === "static" && !$p(r)) ? n : r || v$(e) || n;
}
const P$ = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || AC, s = this.getDimensions;
  return {
    reference: k$(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await s(n)
    }
  };
};
function R$(e) {
  return jn(e).direction === "rtl";
}
const I$ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: x$,
  getDocumentElement: Zr,
  getClippingRect: M$,
  getOffsetParent: AC,
  getElementRects: P$,
  getClientRects: C$,
  getDimensions: T$,
  getScale: vs,
  isElement: Gr,
  isRTL: R$
};
function D$(e, t) {
  let n = null, r;
  const o = Zr(e);
  function s() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function i(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), s();
    const {
      left: l,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const h = Qa(u), p = Qa(o.clientWidth - (l + d)), g = Qa(o.clientHeight - (u + f)), m = Qa(l), v = {
      rootMargin: -h + "px " + -p + "px " + -g + "px " + -m + "px",
      threshold: bs(0, vf(1, c)) || 1
    };
    let w = !0;
    function C(x) {
      const E = x[0].intersectionRatio;
      if (E !== c) {
        if (!w)
          return i();
        E ? i(!1, E) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, v);
    }
    n.observe(e);
  }
  return i(!0), s;
}
function $C(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Lp(e), u = o || s ? [...l ? ll(l) : [], ...ll(t)] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), s && y.addEventListener("resize", n);
  });
  const d = l && a ? D$(l, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((y) => {
    let [v] = y;
    v && v.target === l && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(t);
    })), n();
  }), l && !c && h.observe(l), h.observe(t));
  let p, g = c ? Go(e) : null;
  c && m();
  function m() {
    const y = Go(e);
    g && (y.x !== g.x || y.y !== g.y || y.width !== g.width || y.height !== g.height) && n(), g = y, p = requestAnimationFrame(m);
  }
  return n(), () => {
    u.forEach((y) => {
      o && y.removeEventListener("scroll", n), s && y.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, c && cancelAnimationFrame(p);
  };
}
const N$ = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: I$,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return h$(e, t, {
    ...o,
    platform: s
  });
}, A$ = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? wv({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? wv({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var wc = typeof document < "u" ? Rs : Ke;
function ul(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!ul(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !ul(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function FC(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ov(e, t) {
  const n = FC(e);
  return Math.round(t * n) / n;
}
function Mv(e) {
  const t = b.useRef(e);
  return wc(() => {
    t.current = e;
  }), t;
}
function LC(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = b.useState(r);
  ul(f, r) || h(r);
  const [p, g] = b.useState(null), [m, y] = b.useState(null), v = b.useCallback((N) => {
    N != E.current && (E.current = N, g(N));
  }, [g]), w = b.useCallback((N) => {
    N !== S.current && (S.current = N, y(N));
  }, [y]), C = s || p, x = i || m, E = b.useRef(null), S = b.useRef(null), M = b.useRef(u), T = Mv(c), P = Mv(o), k = b.useCallback(() => {
    if (!E.current || !S.current)
      return;
    const N = {
      placement: t,
      strategy: n,
      middleware: f
    };
    P.current && (N.platform = P.current), N$(E.current, S.current, N).then(($) => {
      const F = {
        ...$,
        isPositioned: !0
      };
      I.current && !ul(M.current, F) && (M.current = F, Yn.flushSync(() => {
        d(F);
      }));
    });
  }, [f, t, n, P]);
  wc(() => {
    l === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [l]);
  const I = b.useRef(!1);
  wc(() => (I.current = !0, () => {
    I.current = !1;
  }), []), wc(() => {
    if (C && (E.current = C), x && (S.current = x), C && x) {
      if (T.current)
        return T.current(C, x, k);
      k();
    }
  }, [C, x, k, T]);
  const O = b.useMemo(() => ({
    reference: E,
    floating: S,
    setReference: v,
    setFloating: w
  }), [v, w]), A = b.useMemo(() => ({
    reference: C,
    floating: x
  }), [C, x]), R = b.useMemo(() => {
    const N = {
      position: n,
      left: 0,
      top: 0
    };
    if (!A.floating)
      return N;
    const $ = Ov(A.floating, u.x), F = Ov(A.floating, u.y);
    return a ? {
      ...N,
      transform: "translate(" + $ + "px, " + F + "px)",
      ...FC(A.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: F
    };
  }, [n, a, A.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: k,
    refs: O,
    elements: A,
    floatingStyles: R
  }), [u, k, O, A, R]);
}
const $$ = /* @__PURE__ */ At((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...s } = e;
  return /* @__PURE__ */ Le(Nn.svg, et({}, s, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ Le("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), F$ = $$;
function L$(e) {
  const [t, n] = _t(void 0);
  return Ms(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let i, a;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, a = l.blockSize;
        } else
          i = e.offsetWidth, a = e.offsetHeight;
        n({
          width: i,
          height: a
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const VC = "Popper", [WC, BC] = pa(VC), [V$, HC] = WC(VC), W$ = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = _t(null);
  return /* @__PURE__ */ Le(V$, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, B$ = "PopperAnchor", H$ = /* @__PURE__ */ At((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, s = HC(B$, n), i = Ue(null), a = vr(t, i);
  return Ke(() => {
    s.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ Le(Nn.div, et({}, o, {
    ref: a
  }));
}), YC = "PopperContent", [Y$, z$] = WC(YC), j$ = /* @__PURE__ */ At((e, t) => {
  var n, r, o, s, i, a, c, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, collisionBoundary: m = [], collisionPadding: y = 0, sticky: v = "partial", hideWhenDetached: w = !1, avoidCollisions: C = !0, onPlaced: x, ...E } = e, S = HC(YC, u), [M, T] = _t(null), P = vr(
    t,
    (ee) => T(ee)
  ), [k, I] = _t(null), O = L$(k), A = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, R = (r = O == null ? void 0 : O.height) !== null && r !== void 0 ? r : 0, N = d + (h !== "center" ? "-" + h : ""), $ = typeof y == "number" ? y : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...y
  }, F = Array.isArray(m) ? m : [
    m
  ], V = F.length > 0, D = {
    padding: $,
    boundary: F.filter(q$),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: V
  }, { refs: H, floatingStyles: j, placement: U, isPositioned: K, middlewareData: G } = LC({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: N,
    whileElementsMounted: $C,
    elements: {
      reference: S.anchor
    },
    middleware: [
      OC({
        mainAxis: f + R,
        alignmentAxis: p
      }),
      C && MC({
        mainAxis: !0,
        crossAxis: !1,
        limiter: v === "partial" ? m$() : void 0,
        ...D
      }),
      C && SC({
        ...D
      }),
      TC({
        ...D,
        apply: ({ elements: ee, rects: ne, availableWidth: de, availableHeight: pe }) => {
          const { width: Ee, height: se } = ne.reference, ke = ee.floating.style;
          ke.setProperty("--radix-popper-available-width", `${de}px`), ke.setProperty("--radix-popper-available-height", `${pe}px`), ke.setProperty("--radix-popper-anchor-width", `${Ee}px`), ke.setProperty("--radix-popper-anchor-height", `${se}px`);
        }
      }),
      k && A$({
        element: k,
        padding: g
      }),
      X$({
        arrowWidth: A,
        arrowHeight: R
      }),
      w && p$({
        strategy: "referenceHidden"
      })
    ]
  }), [B, z] = zC(U), W = zr(x);
  Ms(() => {
    K && (W == null || W());
  }, [
    K,
    W
  ]);
  const X = (o = G.arrow) === null || o === void 0 ? void 0 : o.x, J = (s = G.arrow) === null || s === void 0 ? void 0 : s.y, Q = ((i = G.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [Y, ce] = _t();
  return Ms(() => {
    M && ce(window.getComputedStyle(M).zIndex);
  }, [
    M
  ]), /* @__PURE__ */ Le("div", {
    ref: H.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...j,
      transform: K ? j.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Y,
      "--radix-popper-transform-origin": [
        (a = G.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (c = G.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ Le(Y$, {
    scope: u,
    placedSide: B,
    onArrowChange: I,
    arrowX: X,
    arrowY: J,
    shouldHideArrow: Q
  }, /* @__PURE__ */ Le(Nn.div, et({
    "data-side": B,
    "data-align": z
  }, E, {
    ref: P,
    style: {
      ...E.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: K ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = G.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), U$ = "PopperArrow", G$ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, K$ = /* @__PURE__ */ At(function(t, n) {
  const { __scopePopper: r, ...o } = t, s = z$(U$, r), i = G$[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ Le("span", {
      ref: s.onArrowChange,
      style: {
        position: "absolute",
        left: s.arrowX,
        top: s.arrowY,
        [i]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[s.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[s.placedSide],
        visibility: s.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ Le(F$, et({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function q$(e) {
  return e !== null;
}
const X$ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, s, i;
    const { placement: a, rects: c, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : e.arrowWidth, h = d ? 0 : e.arrowHeight, [p, g] = zC(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], y = ((r = (o = l.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, v = ((s = (i = l.arrow) === null || i === void 0 ? void 0 : i.y) !== null && s !== void 0 ? s : 0) + h / 2;
    let w = "", C = "";
    return p === "bottom" ? (w = d ? m : `${y}px`, C = `${-h}px`) : p === "top" ? (w = d ? m : `${y}px`, C = `${c.floating.height + h}px`) : p === "right" ? (w = `${-h}px`, C = d ? m : `${v}px`) : p === "left" && (w = `${c.floating.width + h}px`, C = d ? m : `${v}px`), {
      data: {
        x: w,
        y: C
      }
    };
  }
});
function zC(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Z$ = W$, jC = H$, Q$ = j$, J$ = K$;
function eF(e, t) {
  return t0((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Vp = (e) => {
  const { present: t, children: n } = e, r = tF(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : fs.only(n), s = vr(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ ml(o, {
    ref: s
  }) : null;
};
Vp.displayName = "Presence";
function tF(e) {
  const [t, n] = _t(), r = Ue({}), o = Ue(e), s = Ue("none"), i = e ? "mounted" : "unmounted", [a, c] = eF(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ke(() => {
    const l = Ja(r.current);
    s.current = a === "mounted" ? l : "none";
  }, [
    a
  ]), Ms(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const f = s.current, h = Ja(l);
      e ? c("MOUNT") : h === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), Ms(() => {
    if (t) {
      const l = (d) => {
        const h = Ja(r.current).includes(d.animationName);
        d.target === t && h && Sf(
          () => c("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (s.current = Ja(r.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: je((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Ja(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
var nF = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, os = /* @__PURE__ */ new WeakMap(), ec = /* @__PURE__ */ new WeakMap(), tc = {}, hd = 0, UC = function(e) {
  return e && (e.host || UC(e.parentNode));
}, rF = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = UC(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, oF = function(e, t, n, r) {
  var o = rF(t, Array.isArray(e) ? e : [e]);
  tc[n] || (tc[n] = /* @__PURE__ */ new WeakMap());
  var s = tc[n], i = [], a = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || a.has(d) || (a.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", g = (os.get(f) || 0) + 1, m = (s.get(f) || 0) + 1;
        os.set(f, g), s.set(f, m), i.push(f), g === 1 && p && ec.set(f, !0), m === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return u(t), a.clear(), hd++, function() {
    i.forEach(function(d) {
      var f = os.get(d) - 1, h = s.get(d) - 1;
      os.set(d, f), s.set(d, h), f || (ec.has(d) || d.removeAttribute(r), ec.delete(d)), h || d.removeAttribute(n);
    }), hd--, hd || (os = /* @__PURE__ */ new WeakMap(), os = /* @__PURE__ */ new WeakMap(), ec = /* @__PURE__ */ new WeakMap(), tc = {});
  };
}, sF = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || nF(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), oF(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, yn = function() {
  return yn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, yn.apply(this, arguments);
};
function GC(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function iF(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, s; r < o; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var xc = "right-scroll-bar-position", Cc = "width-before-scroll-bar", aF = "with-scroll-bars-hidden", cF = "--removed-body-scroll-bar-size";
function lF(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function uF(e, t) {
  var n = _t(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function dF(e, t) {
  return uF(t || null, function(n) {
    return e.forEach(function(r) {
      return lF(r, n);
    });
  });
}
function fF(e) {
  return e;
}
function hF(e, t) {
  t === void 0 && (t = fF);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var i = t(s, r);
      return n.push(i), function() {
        n = n.filter(function(a) {
          return a !== i;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var i = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), i = n;
      }
      var c = function() {
        var u = i;
        i = [], u.forEach(s);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          i.push(u), l();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return o;
}
function pF(e) {
  e === void 0 && (e = {});
  var t = hF(null);
  return t.options = yn({ async: !0, ssr: !1 }, e), t;
}
var KC = function(e) {
  var t = e.sideCar, n = GC(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, yn({}, n));
};
KC.isSideCarExport = !0;
function gF(e, t) {
  return e.useMedium(t), KC;
}
var qC = pF(), pd = function() {
}, yu = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: pd,
    onWheelCapture: pd,
    onTouchMoveCapture: pd
  }), o = r[0], s = r[1], i = e.forwardProps, a = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, p = e.inert, g = e.allowPinchZoom, m = e.as, y = m === void 0 ? "div" : m, v = GC(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), w = f, C = dF([n, t]), x = yn(yn({}, v), o);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(w, { sideCar: qC, removeScrollBar: l, shards: d, noIsolation: h, inert: p, setCallbacks: s, allowPinchZoom: !!g, lockRef: n }),
    i ? b.cloneElement(b.Children.only(a), yn(yn({}, x), { ref: C })) : b.createElement(y, yn({}, x, { className: c, ref: C }), a)
  );
});
yu.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
yu.classNames = {
  fullWidth: Cc,
  zeroRight: xc
};
var Tv, mF = function() {
  if (Tv)
    return Tv;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function bF() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = mF();
  return t && e.setAttribute("nonce", t), e;
}
function vF(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function yF(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var wF = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = bF()) && (vF(t, n), yF(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, xF = function() {
  var e = wF();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, XC = function() {
  var e = xF(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, CF = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, gd = function(e) {
  return parseInt(e || "", 10) || 0;
}, EF = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [gd(n), gd(r), gd(o)];
}, _F = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return CF;
  var t = EF(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, SF = XC(), OF = function(e, t, n, r) {
  var o = e.left, s = e.top, i = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(aF, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(xc, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Cc, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(xc, " .").concat(xc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Cc, " .").concat(Cc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(cF, ": ").concat(a, `px;
  }
`);
}, MF = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r, s = b.useMemo(function() {
    return _F(o);
  }, [o]);
  return b.createElement(SF, { styles: OF(s, !t, o, n ? "" : "!important") });
}, yf = !1;
if (typeof window < "u")
  try {
    var nc = Object.defineProperty({}, "passive", {
      get: function() {
        return yf = !0, !0;
      }
    });
    window.addEventListener("test", nc, nc), window.removeEventListener("test", nc, nc);
  } catch {
    yf = !1;
  }
var ss = yf ? { passive: !1 } : !1, TF = function(e) {
  return e.tagName === "TEXTAREA";
}, ZC = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !TF(e) && n[t] === "visible")
  );
}, kF = function(e) {
  return ZC(e, "overflowY");
}, PF = function(e) {
  return ZC(e, "overflowX");
}, kv = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = QC(e, n);
    if (r) {
      var o = JC(e, n), s = o[1], i = o[2];
      if (s > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, RF = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, IF = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, QC = function(e, t) {
  return e === "v" ? kF(t) : PF(t);
}, JC = function(e, t) {
  return e === "v" ? RF(t) : IF(t);
}, DF = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, NF = function(e, t, n, r, o) {
  var s = DF(e, window.getComputedStyle(t).direction), i = s * r, a = n.target, c = t.contains(a), l = !1, u = i > 0, d = 0, f = 0;
  do {
    var h = JC(e, a), p = h[0], g = h[1], m = h[2], y = g - m - s * p;
    (p || y) && QC(e, a) && (d += y, f += p), a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (u && (o && d === 0 || !o && i > d) || !u && (o && f === 0 || !o && -i > f)) && (l = !0), l;
}, rc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Pv = function(e) {
  return [e.deltaX, e.deltaY];
}, Rv = function(e) {
  return e && "current" in e ? e.current : e;
}, AF = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, $F = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, FF = 0, is = [];
function LF(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), o = b.useState(FF++)[0], s = b.useState(function() {
    return XC();
  })[0], i = b.useRef(e);
  b.useEffect(function() {
    i.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = iF([e.lockRef.current], (e.shards || []).map(Rv), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = b.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !i.current.allowPinchZoom;
    var y = rc(g), v = n.current, w = "deltaX" in g ? g.deltaX : v[0] - y[0], C = "deltaY" in g ? g.deltaY : v[1] - y[1], x, E = g.target, S = Math.abs(w) > Math.abs(C) ? "h" : "v";
    if ("touches" in g && S === "h" && E.type === "range")
      return !1;
    var M = kv(S, E);
    if (!M)
      return !0;
    if (M ? x = S : (x = S === "v" ? "h" : "v", M = kv(S, E)), !M)
      return !1;
    if (!r.current && "changedTouches" in g && (w || C) && (r.current = x), !x)
      return !0;
    var T = r.current || x;
    return NF(T, m, g, T === "h" ? w : C, !0);
  }, []), c = b.useCallback(function(g) {
    var m = g;
    if (!(!is.length || is[is.length - 1] !== s)) {
      var y = "deltaY" in m ? Pv(m) : rc(m), v = t.current.filter(function(x) {
        return x.name === m.type && x.target === m.target && AF(x.delta, y);
      })[0];
      if (v && v.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!v) {
        var w = (i.current.shards || []).map(Rv).filter(Boolean).filter(function(x) {
          return x.contains(m.target);
        }), C = w.length > 0 ? a(m, w[0]) : !i.current.noIsolation;
        C && m.cancelable && m.preventDefault();
      }
    }
  }, []), l = b.useCallback(function(g, m, y, v) {
    var w = { name: g, delta: m, target: y, should: v };
    t.current.push(w), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== w;
      });
    }, 1);
  }, []), u = b.useCallback(function(g) {
    n.current = rc(g), r.current = void 0;
  }, []), d = b.useCallback(function(g) {
    l(g.type, Pv(g), g.target, a(g, e.lockRef.current));
  }, []), f = b.useCallback(function(g) {
    l(g.type, rc(g), g.target, a(g, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return is.push(s), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, ss), document.addEventListener("touchmove", c, ss), document.addEventListener("touchstart", u, ss), function() {
      is = is.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", c, ss), document.removeEventListener("touchmove", c, ss), document.removeEventListener("touchstart", u, ss);
    };
  }, []);
  var h = e.removeScrollBar, p = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    p ? b.createElement(s, { styles: $F(o) }) : null,
    h ? b.createElement(MF, { gapMode: "margin" }) : null
  );
}
const VF = gF(qC, LF);
var eE = b.forwardRef(function(e, t) {
  return b.createElement(yu, yn({}, e, { ref: t, sideCar: VF }));
});
eE.classNames = yu.classNames;
const WF = eE, tE = "Popover", [nE, OW] = pa(tE, [
  BC
]), wa = BC(), [BF, Co] = nE(tE), HF = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: s, modal: i = !1 } = e, a = wa(t), c = Ue(null), [l, u] = _t(!1), [d = !1, f] = ga({
    prop: r,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ Le(Z$, a, /* @__PURE__ */ Le(BF, {
    scope: t,
    contentId: Mx(),
    triggerRef: c,
    open: d,
    onOpenChange: f,
    onOpenToggle: je(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: je(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: je(
      () => u(!1),
      []
    ),
    modal: i
  }, n));
}, YF = "PopoverAnchor", zF = /* @__PURE__ */ At((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Co(YF, n), s = wa(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: a } = o;
  return Ke(() => (i(), () => a()), [
    i,
    a
  ]), /* @__PURE__ */ Le(jC, et({}, s, r, {
    ref: t
  }));
}), jF = "PopoverTrigger", UF = /* @__PURE__ */ At((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Co(jF, n), s = wa(n), i = vr(t, o.triggerRef), a = /* @__PURE__ */ Le(Nn.button, et({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": sE(o.open)
  }, r, {
    ref: i,
    onClick: pn(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? a : /* @__PURE__ */ Le(jC, et({
    asChild: !0
  }, s), a);
}), rE = "PopoverPortal", [GF, KF] = nE(rE, {
  forceMount: void 0
}), qF = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, s = Co(rE, t);
  return /* @__PURE__ */ Le(GF, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ Le(Vp, {
    present: n || s.open
  }, /* @__PURE__ */ Le(nw, {
    asChild: !0,
    container: o
  }, r)));
}, Xi = "PopoverContent", XF = /* @__PURE__ */ At((e, t) => {
  const n = KF(Xi, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, s = Co(Xi, e.__scopePopover);
  return /* @__PURE__ */ Le(Vp, {
    present: r || s.open
  }, s.modal ? /* @__PURE__ */ Le(ZF, et({}, o, {
    ref: t
  })) : /* @__PURE__ */ Le(QF, et({}, o, {
    ref: t
  })));
}), ZF = /* @__PURE__ */ At((e, t) => {
  const n = Co(Xi, e.__scopePopover), r = Ue(null), o = vr(t, r), s = Ue(!1);
  return Ke(() => {
    const i = r.current;
    if (i)
      return sF(i);
  }, []), /* @__PURE__ */ Le(WF, {
    as: Os,
    allowPinchZoom: !0
  }, /* @__PURE__ */ Le(oE, et({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: pn(e.onCloseAutoFocus, (i) => {
      var a;
      i.preventDefault(), s.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: pn(e.onPointerDownOutside, (i) => {
      const a = i.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0, l = a.button === 2 || c;
      s.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: pn(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), QF = /* @__PURE__ */ At((e, t) => {
  const n = Co(Xi, e.__scopePopover), r = Ue(!1), o = Ue(!1);
  return /* @__PURE__ */ Le(oE, et({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (s) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, s), !s.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), s.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (s) => {
      var i, a;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = s.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(c)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
    }
  }));
}), oE = /* @__PURE__ */ At((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, disableOutsidePointerEvents: i, onEscapeKeyDown: a, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: u, ...d } = e, f = Co(Xi, n), h = wa(n);
  return Z8(), /* @__PURE__ */ Le(Q8, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ Le(K8, {
    asChild: !0,
    disableOutsidePointerEvents: i,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ Le(Q$, et({
    "data-state": sE(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), JF = "PopoverClose", eL = /* @__PURE__ */ At((e, t) => {
  const { __scopePopover: n, ...r } = e, o = Co(JF, n);
  return /* @__PURE__ */ Le(Nn.button, et({
    type: "button"
  }, r, {
    ref: t,
    onClick: pn(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), tL = /* @__PURE__ */ At((e, t) => {
  const { __scopePopover: n, ...r } = e, o = wa(n);
  return /* @__PURE__ */ Le(J$, et({}, o, r, {
    ref: t
  }));
});
function sE(e) {
  return e ? "open" : "closed";
}
const iE = HF, nL = zF, aE = UF, cE = qF, lE = XF, rL = eL, oL = tL, sL = ({
  name: e,
  id: t,
  className: n,
  selected: r,
  onSelect: o,
  disablePortal: s = !1,
  fromDate: i,
  toDate: a
}) => {
  const [c, l] = b.useState(!1), { inputRef: u, inputProps: d, setInputValue: f, month: h, setMonth: p } = Pn(
    {
      onSelect: o,
      selected: r,
      fromDate: i,
      toDate: a
    }
  ), g = (y) => {
    y ? (o(Lr(y, Pn.valueFormatString)), l(!1)) : (o(""), f(""));
  }, m = s ? b.Fragment : cE;
  return /* @__PURE__ */ Z(iE, { open: c, onOpenChange: l, children: [
    /* @__PURE__ */ _(nL, { asChild: !0, children: /* @__PURE__ */ _(
      cL,
      {
        ref: u,
        icon: /* @__PURE__ */ _(aE, { className: "pointer-events-auto -m-1 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", children: /* @__PURE__ */ _(vk, { className: "h-5 w-5" }) }),
        className: n,
        id: t,
        name: e,
        ...d
      }
    ) }),
    /* @__PURE__ */ _(m, { children: /* @__PURE__ */ _(
      lE,
      {
        className: "z-10",
        side: "bottom",
        sideOffset: 4,
        collisionPadding: 4,
        children: /* @__PURE__ */ _(
          pC,
          {
            mode: "single",
            className: "shadow-3",
            initialFocus: !0,
            onSelect: g,
            selected: r ? us(r, Pn.valueFormatString, /* @__PURE__ */ new Date()) : void 0,
            month: h,
            onMonthChange: p,
            fromDate: i,
            toDate: a
          }
        )
      }
    ) })
  ] });
};
sL.displayName = "DatePicker";
const oc = B8({
  mode: "dd/mm/yyyy",
  separator: "-"
}), { plugins: iL, ...Iv } = L8(
  "dd-mm-yyyy",
  !0
), aL = {
  ...oc,
  plugins: iL.concat(oc.plugins || []),
  preprocessors: [
    // Always put it BEFORE all other preprocessors
    ...Iv.preprocessors,
    ...oc.preprocessors
  ],
  postprocessors: [
    ...oc.postprocessors,
    // Always put it AFTER all other postprocessors
    ...Iv.postprocessors
  ]
}, Pn = ({
  selected: e,
  onSelect: t,
  fromDate: n,
  toDate: r
}) => {
  const [o, s] = b.useState(""), [i, a] = b.useState(), c = Y8({ options: aL });
  return b.useEffect(() => {
    e && (a(us(e, Pn.valueFormatString, /* @__PURE__ */ new Date())), s(
      Lr(
        us(e, Pn.valueFormatString, /* @__PURE__ */ new Date()),
        Pn.inputFormatString
      )
    ));
  }, [e]), {
    inputRef: c,
    setInputValue: s,
    month: i,
    setMonth: a,
    inputProps: {
      value: o,
      onBlur: (l) => {
        if (!l.target.value) {
          t == null || t(""), a(/* @__PURE__ */ new Date());
          return;
        }
        const u = us(
          l.target.value,
          Pn.inputFormatString,
          /* @__PURE__ */ new Date()
        ), d = n && of(n, u) > 0, f = r && of(u, r) > 0;
        if (!Kh(u) || d || f) {
          s(
            e ? Lr(
              us(e, Pn.valueFormatString, /* @__PURE__ */ new Date()),
              Pn.inputFormatString
            ) : ""
          );
          return;
        }
        t == null || t(Lr(u, Pn.valueFormatString)), a(u);
      },
      onChange: () => {
      },
      onInput: (l) => s(l.currentTarget.value)
    }
  };
};
Pn.valueFormatString = "yyyy-MM-dd";
Pn.inputFormatString = "dd-MM-yyyy";
Pn.monthValueFormatString = "yyyy-MM";
const cL = b.forwardRef(({ className: e, icon: t, ...n }, r) => /* @__PURE__ */ _(
  wx,
  {
    ref: r,
    containerClassName: e,
    icon: t,
    type: "text",
    placeholder: "dd-mm-yyyy",
    ...n
  }
)), lL = iE, uL = aE, dL = rL, MW = oL, fL = ie.forwardRef(({ children: e, ...t }, n) => /* @__PURE__ */ _(cE, { children: /* @__PURE__ */ _(lE, { ...t, ref: n, children: e }) })), hL = Xw, uE = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Jw,
  {
    ref: n,
    className: le("text-sm font-medium text-foundations-boldest", e),
    "data-slot": "progress-value",
    ...t
  }
));
uE.displayName = "ProgressValue";
const dE = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Zw,
  {
    ref: n,
    className: le("h-2 rounded-sm bg-foundations-subtlest", e),
    "data-slot": "progress-track",
    ...t
  }
));
dE.displayName = "ProgressTrack";
const fE = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Qw,
  {
    ref: n,
    className: le("rounded-sm bg-info-bold", e),
    "data-slot": "progress-indicator",
    ...t
  }
));
fE.displayName = "ProgressIndicator";
const TW = Object.assign(hL, {
  Label: ex,
  Track: dE,
  Indicator: fE,
  Value: uE
}), pL = O3, gL = jw, hE = ie.forwardRef(
  ({
    children: e,
    sideOffset: t = 4,
    align: n = "end",
    alignOffset: r = 0,
    side: o = "bottom",
    ...s
  }, i) => /* @__PURE__ */ _(Uw, { children: /* @__PURE__ */ _(
    Gw,
    {
      align: n,
      alignOffset: r,
      "data-slot": "popover-positioner",
      side: o,
      sideOffset: t,
      children: /* @__PURE__ */ _(qw, { ...s, ref: i, children: e })
    }
  ) })
);
hE.displayName = "PopoverPopup";
const kW = Object.assign(pL, {
  Trigger: gL,
  Popup: hE
});
function mL(e, t, n = []) {
  b.useEffect(() => {
    const r = setTimeout(() => {
      e();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t, ...n]);
}
const pE = b.createContext(null), _r = () => {
  const e = b.useContext(pE);
  if (!e)
    throw new Error(
      "useDropdownSearchContext must be used within <DropdownSearch />"
    );
  return e;
};
function cr(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, s;
  for (s = 0; s < r.length; s++)
    o = r[s], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(this, arguments);
}
function Dv(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wf(e, t) {
  return wf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, wf(e, t);
}
function bL(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, wf(e, t);
}
var xf = { exports: {} }, sc = { exports: {} }, ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nv;
function vL() {
  if (Nv)
    return ht;
  Nv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(x) {
    if (typeof x == "object" && x !== null) {
      var E = x.$$typeof;
      switch (E) {
        case t:
          switch (x = x.type, x) {
            case c:
            case l:
            case r:
            case s:
            case o:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case u:
                case p:
                case h:
                case i:
                  return x;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function C(x) {
    return w(x) === l;
  }
  return ht.AsyncMode = c, ht.ConcurrentMode = l, ht.ContextConsumer = a, ht.ContextProvider = i, ht.Element = t, ht.ForwardRef = u, ht.Fragment = r, ht.Lazy = p, ht.Memo = h, ht.Portal = n, ht.Profiler = s, ht.StrictMode = o, ht.Suspense = d, ht.isAsyncMode = function(x) {
    return C(x) || w(x) === c;
  }, ht.isConcurrentMode = C, ht.isContextConsumer = function(x) {
    return w(x) === a;
  }, ht.isContextProvider = function(x) {
    return w(x) === i;
  }, ht.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ht.isForwardRef = function(x) {
    return w(x) === u;
  }, ht.isFragment = function(x) {
    return w(x) === r;
  }, ht.isLazy = function(x) {
    return w(x) === p;
  }, ht.isMemo = function(x) {
    return w(x) === h;
  }, ht.isPortal = function(x) {
    return w(x) === n;
  }, ht.isProfiler = function(x) {
    return w(x) === s;
  }, ht.isStrictMode = function(x) {
    return w(x) === o;
  }, ht.isSuspense = function(x) {
    return w(x) === d;
  }, ht.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === l || x === s || x === o || x === d || x === f || typeof x == "object" && x !== null && (x.$$typeof === p || x.$$typeof === h || x.$$typeof === i || x.$$typeof === a || x.$$typeof === u || x.$$typeof === m || x.$$typeof === y || x.$$typeof === v || x.$$typeof === g);
  }, ht.typeOf = w, ht;
}
var pt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Av;
function yL() {
  return Av || (Av = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === l || Y === s || Y === o || Y === d || Y === f || typeof Y == "object" && Y !== null && (Y.$$typeof === p || Y.$$typeof === h || Y.$$typeof === i || Y.$$typeof === a || Y.$$typeof === u || Y.$$typeof === m || Y.$$typeof === y || Y.$$typeof === v || Y.$$typeof === g);
    }
    function C(Y) {
      if (typeof Y == "object" && Y !== null) {
        var ce = Y.$$typeof;
        switch (ce) {
          case t:
            var ee = Y.type;
            switch (ee) {
              case c:
              case l:
              case r:
              case s:
              case o:
              case d:
                return ee;
              default:
                var ne = ee && ee.$$typeof;
                switch (ne) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case i:
                    return ne;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var x = c, E = l, S = a, M = i, T = t, P = u, k = r, I = p, O = h, A = n, R = s, N = o, $ = d, F = !1;
    function V(Y) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(Y) || C(Y) === c;
    }
    function D(Y) {
      return C(Y) === l;
    }
    function H(Y) {
      return C(Y) === a;
    }
    function j(Y) {
      return C(Y) === i;
    }
    function U(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function K(Y) {
      return C(Y) === u;
    }
    function G(Y) {
      return C(Y) === r;
    }
    function B(Y) {
      return C(Y) === p;
    }
    function z(Y) {
      return C(Y) === h;
    }
    function W(Y) {
      return C(Y) === n;
    }
    function X(Y) {
      return C(Y) === s;
    }
    function J(Y) {
      return C(Y) === o;
    }
    function Q(Y) {
      return C(Y) === d;
    }
    pt.AsyncMode = x, pt.ConcurrentMode = E, pt.ContextConsumer = S, pt.ContextProvider = M, pt.Element = T, pt.ForwardRef = P, pt.Fragment = k, pt.Lazy = I, pt.Memo = O, pt.Portal = A, pt.Profiler = R, pt.StrictMode = N, pt.Suspense = $, pt.isAsyncMode = V, pt.isConcurrentMode = D, pt.isContextConsumer = H, pt.isContextProvider = j, pt.isElement = U, pt.isForwardRef = K, pt.isFragment = G, pt.isLazy = B, pt.isMemo = z, pt.isPortal = W, pt.isProfiler = X, pt.isStrictMode = J, pt.isSuspense = Q, pt.isValidElementType = w, pt.typeOf = C;
  }()), pt;
}
var $v;
function gE() {
  return $v || ($v = 1, process.env.NODE_ENV === "production" ? sc.exports = vL() : sc.exports = yL()), sc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var md, Fv;
function wL() {
  if (Fv)
    return md;
  Fv = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return md = o() ? Object.assign : function(s, i) {
    for (var a, c = r(s), l, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        t.call(a, d) && (c[d] = a[d]);
      if (e) {
        l = e(a);
        for (var f = 0; f < l.length; f++)
          n.call(a, l[f]) && (c[l[f]] = a[l[f]]);
      }
    }
    return c;
  }, md;
}
var bd, Lv;
function Wp() {
  if (Lv)
    return bd;
  Lv = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return bd = e, bd;
}
var vd, Vv;
function mE() {
  return Vv || (Vv = 1, vd = Function.call.bind(Object.prototype.hasOwnProperty)), vd;
}
var yd, Wv;
function xL() {
  if (Wv)
    return yd;
  Wv = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Wp(), n = {}, r = mE();
    e = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(s, i, a, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = s[u](i, u, c, a, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, yd = o, yd;
}
var wd, Bv;
function CL() {
  if (Bv)
    return wd;
  Bv = 1;
  var e = gE(), t = wL(), n = Wp(), r = mE(), o = xL(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return wd = function(a, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(D) {
      var H = D && (l && D[l] || D[u]);
      if (typeof H == "function")
        return H;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: v(),
      arrayOf: w,
      element: C(),
      elementType: x(),
      instanceOf: E,
      node: P(),
      objectOf: M,
      oneOf: S,
      oneOfType: T,
      shape: I,
      exact: O
    };
    function p(D, H) {
      return D === H ? D !== 0 || 1 / D === 1 / H : D !== D && H !== H;
    }
    function g(D, H) {
      this.message = D, this.data = H && typeof H == "object" ? H : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(D) {
      if (process.env.NODE_ENV !== "production")
        var H = {}, j = 0;
      function U(G, B, z, W, X, J, Q) {
        if (W = W || f, J = J || z, Q !== n) {
          if (c) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = W + ":" + z;
            !H[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), H[ce] = !0, j++);
          }
        }
        return B[z] == null ? G ? B[z] === null ? new g("The " + X + " `" + J + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new g("The " + X + " `" + J + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : D(B, z, W, X, J);
      }
      var K = U.bind(null, !1);
      return K.isRequired = U.bind(null, !0), K;
    }
    function y(D) {
      function H(j, U, K, G, B, z) {
        var W = j[U], X = N(W);
        if (X !== D) {
          var J = $(W);
          return new g(
            "Invalid " + G + " `" + B + "` of type " + ("`" + J + "` supplied to `" + K + "`, expected ") + ("`" + D + "`."),
            { expectedType: D }
          );
        }
        return null;
      }
      return m(H);
    }
    function v() {
      return m(i);
    }
    function w(D) {
      function H(j, U, K, G, B) {
        if (typeof D != "function")
          return new g("Property `" + B + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var z = j[U];
        if (!Array.isArray(z)) {
          var W = N(z);
          return new g("Invalid " + G + " `" + B + "` of type " + ("`" + W + "` supplied to `" + K + "`, expected an array."));
        }
        for (var X = 0; X < z.length; X++) {
          var J = D(z, X, K, G, B + "[" + X + "]", n);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return m(H);
    }
    function C() {
      function D(H, j, U, K, G) {
        var B = H[j];
        if (!a(B)) {
          var z = N(B);
          return new g("Invalid " + K + " `" + G + "` of type " + ("`" + z + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(D);
    }
    function x() {
      function D(H, j, U, K, G) {
        var B = H[j];
        if (!e.isValidElementType(B)) {
          var z = N(B);
          return new g("Invalid " + K + " `" + G + "` of type " + ("`" + z + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(D);
    }
    function E(D) {
      function H(j, U, K, G, B) {
        if (!(j[U] instanceof D)) {
          var z = D.name || f, W = V(j[U]);
          return new g("Invalid " + G + " `" + B + "` of type " + ("`" + W + "` supplied to `" + K + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return m(H);
    }
    function S(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function H(j, U, K, G, B) {
        for (var z = j[U], W = 0; W < D.length; W++)
          if (p(z, D[W]))
            return null;
        var X = JSON.stringify(D, function(Q, Y) {
          var ce = $(Y);
          return ce === "symbol" ? String(Y) : Y;
        });
        return new g("Invalid " + G + " `" + B + "` of value `" + String(z) + "` " + ("supplied to `" + K + "`, expected one of " + X + "."));
      }
      return m(H);
    }
    function M(D) {
      function H(j, U, K, G, B) {
        if (typeof D != "function")
          return new g("Property `" + B + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var z = j[U], W = N(z);
        if (W !== "object")
          return new g("Invalid " + G + " `" + B + "` of type " + ("`" + W + "` supplied to `" + K + "`, expected an object."));
        for (var X in z)
          if (r(z, X)) {
            var J = D(z, X, K, G, B + "." + X, n);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return m(H);
    }
    function T(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var H = 0; H < D.length; H++) {
        var j = D[H];
        if (typeof j != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(j) + " at index " + H + "."
          ), i;
      }
      function U(K, G, B, z, W) {
        for (var X = [], J = 0; J < D.length; J++) {
          var Q = D[J], Y = Q(K, G, B, z, W, n);
          if (Y == null)
            return null;
          Y.data && r(Y.data, "expectedType") && X.push(Y.data.expectedType);
        }
        var ce = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new g("Invalid " + z + " `" + W + "` supplied to " + ("`" + B + "`" + ce + "."));
      }
      return m(U);
    }
    function P() {
      function D(H, j, U, K, G) {
        return A(H[j]) ? null : new g("Invalid " + K + " `" + G + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return m(D);
    }
    function k(D, H, j, U, K) {
      return new g(
        (D || "React class") + ": " + H + " type `" + j + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function I(D) {
      function H(j, U, K, G, B) {
        var z = j[U], W = N(z);
        if (W !== "object")
          return new g("Invalid " + G + " `" + B + "` of type `" + W + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var X in D) {
          var J = D[X];
          if (typeof J != "function")
            return k(K, G, B, X, $(J));
          var Q = J(z, X, K, G, B + "." + X, n);
          if (Q)
            return Q;
        }
        return null;
      }
      return m(H);
    }
    function O(D) {
      function H(j, U, K, G, B) {
        var z = j[U], W = N(z);
        if (W !== "object")
          return new g("Invalid " + G + " `" + B + "` of type `" + W + "` " + ("supplied to `" + K + "`, expected `object`."));
        var X = t({}, j[U], D);
        for (var J in X) {
          var Q = D[J];
          if (r(D, J) && typeof Q != "function")
            return k(K, G, B, J, $(Q));
          if (!Q)
            return new g(
              "Invalid " + G + " `" + B + "` key `" + J + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(j[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
            );
          var Y = Q(z, J, K, G, B + "." + J, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return m(H);
    }
    function A(D) {
      switch (typeof D) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !D;
        case "object":
          if (Array.isArray(D))
            return D.every(A);
          if (D === null || a(D))
            return !0;
          var H = d(D);
          if (H) {
            var j = H.call(D), U;
            if (H !== D.entries) {
              for (; !(U = j.next()).done; )
                if (!A(U.value))
                  return !1;
            } else
              for (; !(U = j.next()).done; ) {
                var K = U.value;
                if (K && !A(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function R(D, H) {
      return D === "symbol" ? !0 : H ? H["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && H instanceof Symbol : !1;
    }
    function N(D) {
      var H = typeof D;
      return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : R(H, D) ? "symbol" : H;
    }
    function $(D) {
      if (typeof D > "u" || D === null)
        return "" + D;
      var H = N(D);
      if (H === "object") {
        if (D instanceof Date)
          return "date";
        if (D instanceof RegExp)
          return "regexp";
      }
      return H;
    }
    function F(D) {
      var H = $(D);
      switch (H) {
        case "array":
        case "object":
          return "an " + H;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + H;
        default:
          return H;
      }
    }
    function V(D) {
      return !D.constructor || !D.constructor.name ? f : D.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, wd;
}
var xd, Hv;
function EL() {
  if (Hv)
    return xd;
  Hv = 1;
  var e = Wp();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, xd = function() {
    function r(i, a, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, xd;
}
if (process.env.NODE_ENV !== "production") {
  var _L = gE(), SL = !0;
  xf.exports = CL()(_L.isElement, SL);
} else
  xf.exports = EL()();
var OL = xf.exports;
const he = /* @__PURE__ */ Q_(OL);
var Cf = { exports: {} }, Ct = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yv;
function ML() {
  if (Yv)
    return Ct;
  Yv = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, s = 60109, i = 60110, a = 60112, c = 60113, l = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var y = Symbol.for;
    e = y("react.element"), t = y("react.portal"), n = y("react.fragment"), r = y("react.strict_mode"), o = y("react.profiler"), s = y("react.provider"), i = y("react.context"), a = y("react.forward_ref"), c = y("react.suspense"), l = y("react.suspense_list"), u = y("react.memo"), d = y("react.lazy"), f = y("react.block"), h = y("react.server.block"), p = y("react.fundamental"), g = y("react.debug_trace_mode"), m = y("react.legacy_hidden");
  }
  function v(O) {
    if (typeof O == "object" && O !== null) {
      var A = O.$$typeof;
      switch (A) {
        case e:
          switch (O = O.type, O) {
            case n:
            case o:
            case r:
            case c:
            case l:
              return O;
            default:
              switch (O = O && O.$$typeof, O) {
                case i:
                case a:
                case d:
                case u:
                case s:
                  return O;
                default:
                  return A;
              }
          }
        case t:
          return A;
      }
    }
  }
  var w = s, C = e, x = a, E = n, S = d, M = u, T = t, P = o, k = r, I = c;
  return Ct.ContextConsumer = i, Ct.ContextProvider = w, Ct.Element = C, Ct.ForwardRef = x, Ct.Fragment = E, Ct.Lazy = S, Ct.Memo = M, Ct.Portal = T, Ct.Profiler = P, Ct.StrictMode = k, Ct.Suspense = I, Ct.isAsyncMode = function() {
    return !1;
  }, Ct.isConcurrentMode = function() {
    return !1;
  }, Ct.isContextConsumer = function(O) {
    return v(O) === i;
  }, Ct.isContextProvider = function(O) {
    return v(O) === s;
  }, Ct.isElement = function(O) {
    return typeof O == "object" && O !== null && O.$$typeof === e;
  }, Ct.isForwardRef = function(O) {
    return v(O) === a;
  }, Ct.isFragment = function(O) {
    return v(O) === n;
  }, Ct.isLazy = function(O) {
    return v(O) === d;
  }, Ct.isMemo = function(O) {
    return v(O) === u;
  }, Ct.isPortal = function(O) {
    return v(O) === t;
  }, Ct.isProfiler = function(O) {
    return v(O) === o;
  }, Ct.isStrictMode = function(O) {
    return v(O) === r;
  }, Ct.isSuspense = function(O) {
    return v(O) === c;
  }, Ct.isValidElementType = function(O) {
    return typeof O == "string" || typeof O == "function" || O === n || O === o || O === g || O === r || O === c || O === l || O === m || typeof O == "object" && O !== null && (O.$$typeof === d || O.$$typeof === u || O.$$typeof === s || O.$$typeof === i || O.$$typeof === a || O.$$typeof === p || O.$$typeof === f || O[0] === h);
  }, Ct.typeOf = v, Ct;
}
var Et = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zv;
function TL() {
  return zv || (zv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, s = 60109, i = 60110, a = 60112, c = 60113, l = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var y = Symbol.for;
      e = y("react.element"), t = y("react.portal"), n = y("react.fragment"), r = y("react.strict_mode"), o = y("react.profiler"), s = y("react.provider"), i = y("react.context"), a = y("react.forward_ref"), c = y("react.suspense"), l = y("react.suspense_list"), u = y("react.memo"), d = y("react.lazy"), f = y("react.block"), h = y("react.server.block"), p = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), g = y("react.debug_trace_mode"), y("react.offscreen"), m = y("react.legacy_hidden");
    }
    var v = !1;
    function w(Q) {
      return !!(typeof Q == "string" || typeof Q == "function" || Q === n || Q === o || Q === g || Q === r || Q === c || Q === l || Q === m || v || typeof Q == "object" && Q !== null && (Q.$$typeof === d || Q.$$typeof === u || Q.$$typeof === s || Q.$$typeof === i || Q.$$typeof === a || Q.$$typeof === p || Q.$$typeof === f || Q[0] === h));
    }
    function C(Q) {
      if (typeof Q == "object" && Q !== null) {
        var Y = Q.$$typeof;
        switch (Y) {
          case e:
            var ce = Q.type;
            switch (ce) {
              case n:
              case o:
              case r:
              case c:
              case l:
                return ce;
              default:
                var ee = ce && ce.$$typeof;
                switch (ee) {
                  case i:
                  case a:
                  case d:
                  case u:
                  case s:
                    return ee;
                  default:
                    return Y;
                }
            }
          case t:
            return Y;
        }
      }
    }
    var x = i, E = s, S = e, M = a, T = n, P = d, k = u, I = t, O = o, A = r, R = c, N = !1, $ = !1;
    function F(Q) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(Q) {
      return $ || ($ = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(Q) {
      return C(Q) === i;
    }
    function H(Q) {
      return C(Q) === s;
    }
    function j(Q) {
      return typeof Q == "object" && Q !== null && Q.$$typeof === e;
    }
    function U(Q) {
      return C(Q) === a;
    }
    function K(Q) {
      return C(Q) === n;
    }
    function G(Q) {
      return C(Q) === d;
    }
    function B(Q) {
      return C(Q) === u;
    }
    function z(Q) {
      return C(Q) === t;
    }
    function W(Q) {
      return C(Q) === o;
    }
    function X(Q) {
      return C(Q) === r;
    }
    function J(Q) {
      return C(Q) === c;
    }
    Et.ContextConsumer = x, Et.ContextProvider = E, Et.Element = S, Et.ForwardRef = M, Et.Fragment = T, Et.Lazy = P, Et.Memo = k, Et.Portal = I, Et.Profiler = O, Et.StrictMode = A, Et.Suspense = R, Et.isAsyncMode = F, Et.isConcurrentMode = V, Et.isContextConsumer = D, Et.isContextProvider = H, Et.isElement = j, Et.isForwardRef = U, Et.isFragment = K, Et.isLazy = G, Et.isMemo = B, Et.isPortal = z, Et.isProfiler = W, Et.isStrictMode = X, Et.isSuspense = J, Et.isValidElementType = w, Et.typeOf = C;
  }()), Et;
}
process.env.NODE_ENV === "production" ? Cf.exports = ML() : Cf.exports = TL();
var jv = Cf.exports;
let Uv = (e) => typeof e == "object" && e != null && e.nodeType === 1, Gv = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", Cd = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    let n = getComputedStyle(e, null);
    return Gv(n.overflowY, t) || Gv(n.overflowX, t) || ((r) => {
      let o = ((s) => {
        if (!s.ownerDocument || !s.ownerDocument.defaultView)
          return null;
        try {
          return s.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, ic = (e, t, n, r, o, s, i, a) => s < e && i > t || s > e && i < t ? 0 : s <= e && a <= n || i >= t && a >= n ? s - e - r : i > t && a < n || s < e && a > n ? i - t + o : 0, kL = (e) => {
  let t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
};
var PL = (e, t) => {
  var n, r, o, s, i, a;
  if (typeof document > "u")
    return [];
  let { scrollMode: c, block: l, inline: u, boundary: d, skipOverflowHiddenElements: f } = t, h = typeof d == "function" ? d : (A) => A !== d;
  if (!Uv(e))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, g = [], m = e;
  for (; Uv(m) && h(m); ) {
    if (m = kL(m), m === p) {
      g.push(m);
      break;
    }
    m != null && m === document.body && Cd(m) && !Cd(document.documentElement) || m != null && Cd(m, f) && g.push(m);
  }
  let y = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, v = (s = (o = window.visualViewport) == null ? void 0 : o.height) != null ? s : innerHeight, w = (i = window.scrollX) != null ? i : pageXOffset, C = (a = window.scrollY) != null ? a : pageYOffset, { height: x, width: E, top: S, right: M, bottom: T, left: P } = e.getBoundingClientRect(), k = l === "start" || l === "nearest" ? S : l === "end" ? T : S + x / 2, I = u === "center" ? P + E / 2 : u === "end" ? M : P, O = [];
  for (let A = 0; A < g.length; A++) {
    let R = g[A], { height: N, width: $, top: F, right: V, bottom: D, left: H } = R.getBoundingClientRect();
    if (c === "if-needed" && S >= 0 && P >= 0 && T <= v && M <= y && S >= F && T <= D && P >= H && M <= V)
      return O;
    let j = getComputedStyle(R), U = parseInt(j.borderLeftWidth, 10), K = parseInt(j.borderTopWidth, 10), G = parseInt(j.borderRightWidth, 10), B = parseInt(j.borderBottomWidth, 10), z = 0, W = 0, X = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - U - G : 0, J = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - K - B : 0, Q = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : $ / R.offsetWidth : 0, Y = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : N / R.offsetHeight : 0;
    if (p === R)
      z = l === "start" ? k : l === "end" ? k - v : l === "nearest" ? ic(C, C + v, v, K, B, C + k, C + k + x, x) : k - v / 2, W = u === "start" ? I : u === "center" ? I - y / 2 : u === "end" ? I - y : ic(w, w + y, y, U, G, w + I, w + I + E, E), z = Math.max(0, z + C), W = Math.max(0, W + w);
    else {
      z = l === "start" ? k - F - K : l === "end" ? k - D + B + J : l === "nearest" ? ic(F, D, N, K, B + J, k, k + x, x) : k - (F + N / 2) + J / 2, W = u === "start" ? I - H - U : u === "center" ? I - (H + $ / 2) + X / 2 : u === "end" ? I - V + G + X : ic(H, V, $, U, G + X, I, I + E, E);
      let { scrollLeft: ce, scrollTop: ee } = R;
      z = Math.max(0, Math.min(ee + z / Y, R.scrollHeight - N / Y + J)), W = Math.max(0, Math.min(ce + W / Q, R.scrollWidth - $ / Q + X)), k += ee - z, I += ce - W;
    }
    O.push({ el: R, top: z, left: W });
  }
  return O;
}, RL = 0;
function Kv(e) {
  return typeof e == "function" ? e : Vn;
}
function Vn() {
}
function bE(e, t) {
  if (e) {
    var n = PL(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var o = r.el, s = r.top, i = r.left;
      o.scrollTop = s, o.scrollLeft = i;
    });
  }
}
function qv(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Bp(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var s = arguments.length, i = new Array(s), a = 0; a < s; a++)
      i[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, i);
    }, t);
  }
  return o.cancel = r, o;
}
function Jt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      s[i - 1] = arguments[i];
    return t.some(function(a) {
      return a && a.apply(void 0, [r].concat(s)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function ds() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function vE() {
  return String(RL++);
}
function yE(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Xv(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function wE(e) {
  return typeof e.type == "string";
}
function xE(e) {
  return e.props;
}
function IL(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var DL = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function ac(e) {
  e === void 0 && (e = {});
  var t = {};
  return DL.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function dl(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = fl(t, r) ? t[r] : e[r], n;
  }, {});
}
function fl(e, t) {
  return e[t] !== void 0;
}
function Ef(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function NL(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Lo(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (s === 0)
    return -1;
  var i = s - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var a = e + t;
  a < 0 ? a = o ? i : 0 : a > i && (a = o ? 0 : i);
  var c = Ps(a, t < 0, n, r, o);
  return c === -1 ? e >= s ? -1 : e : c;
}
function Ps(e, t, n, r, o) {
  o === void 0 && (o = !1);
  var s = n.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!r(n[i], i))
        return i;
  } else
    for (var a = e; a < s; a++)
      if (!r(n[a], a))
        return a;
  return o ? Ps(t ? s - 1 : 0, t, n, r) : -1;
}
function hl(e, t, n, r) {
  return r === void 0 && (r = !0), t.some(function(o) {
    return o && (qv(o, e, n) || r && qv(o, n.document.activeElement, n));
  });
}
var Hp = Vn;
process.env.NODE_ENV !== "production" && (Hp = function(t, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(s) {
    n[s] !== void 0 && r[s] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + s + '" to be uncontrolled. ' + o) : n[s] === void 0 && r[s] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + s + '" to be controlled. ' + o);
  });
});
var AL = Bp(function(e) {
  EE(e).textContent = "";
}, 500);
function CE(e, t) {
  var n = EE(t);
  e && (n.textContent = e, AL(t));
}
function EE(e) {
  e === void 0 && (e = document);
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
var _E = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, SE = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, OE = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Ec = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, _c = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, ME = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, TE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, kE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, PE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, RE = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, IE = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, DE = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, NE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, _f = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, AE = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, $E = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, FE = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, $L = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: _E,
  mouseUp: SE,
  itemMouseEnter: OE,
  keyDownArrowUp: Ec,
  keyDownArrowDown: _c,
  keyDownEscape: ME,
  keyDownEnter: TE,
  keyDownHome: kE,
  keyDownEnd: PE,
  clickItem: RE,
  blurInput: IE,
  changeInput: DE,
  keyDownSpaceButton: NE,
  clickButton: _f,
  blurButton: AE,
  controlledPropUpdatedSelectedItem: $E,
  touchEnd: FE
}), FL = ["refKey", "ref"], LL = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], VL = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], WL = ["refKey", "ref"], BL = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], HL = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    bL(n, t);
    function n(o) {
      var s;
      s = t.call(this, o) || this, s.id = s.props.id || "downshift-" + vE(), s.menuId = s.props.menuId || s.id + "-menu", s.labelId = s.props.labelId || s.id + "-label", s.inputId = s.props.inputId || s.id + "-input", s.getItemId = s.props.getItemId || function(v) {
        return s.id + "-item-" + v;
      }, s.input = null, s.items = [], s.itemCount = null, s.previousResultCount = 0, s.timeoutIds = [], s.internalSetTimeout = function(v, w) {
        var C = setTimeout(function() {
          s.timeoutIds = s.timeoutIds.filter(function(x) {
            return x !== C;
          }), v();
        }, w);
        s.timeoutIds.push(C);
      }, s.setItemCount = function(v) {
        s.itemCount = v;
      }, s.unsetItemCount = function() {
        s.itemCount = null;
      }, s.isItemDisabled = function(v, w) {
        var C = s.getItemNodeFromIndex(w);
        return C && C.hasAttribute("disabled");
      }, s.setHighlightedIndex = function(v, w) {
        v === void 0 && (v = s.props.defaultHighlightedIndex), w === void 0 && (w = {}), w = ac(w), s.internalSetState(He({
          highlightedIndex: v
        }, w));
      }, s.clearSelection = function(v) {
        s.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: s.props.defaultHighlightedIndex,
          isOpen: s.props.defaultIsOpen
        }, v);
      }, s.selectItem = function(v, w, C) {
        w = ac(w), s.internalSetState(He({
          isOpen: s.props.defaultIsOpen,
          highlightedIndex: s.props.defaultHighlightedIndex,
          selectedItem: v,
          inputValue: s.props.itemToString(v)
        }, w), C);
      }, s.selectItemAtIndex = function(v, w, C) {
        var x = s.items[v];
        x != null && s.selectItem(x, w, C);
      }, s.selectHighlightedItem = function(v, w) {
        return s.selectItemAtIndex(s.getState().highlightedIndex, v, w);
      }, s.internalSetState = function(v, w) {
        var C, x, E = {}, S = typeof v == "function";
        return !S && v.hasOwnProperty("inputValue") && s.props.onInputValueChange(v.inputValue, He({}, s.getStateAndHelpers(), v)), s.setState(function(M) {
          M = s.getState(M);
          var T = S ? v(M) : v;
          T = s.props.stateReducer(M, T), C = T.hasOwnProperty("selectedItem");
          var P = {};
          return C && T.selectedItem !== M.selectedItem && (x = T.selectedItem), T.type = T.type || _E, Object.keys(T).forEach(function(k) {
            M[k] !== T[k] && (E[k] = T[k]), k !== "type" && (T[k], fl(s.props, k) || (P[k] = T[k]));
          }), S && T.hasOwnProperty("inputValue") && s.props.onInputValueChange(T.inputValue, He({}, s.getStateAndHelpers(), T)), P;
        }, function() {
          Kv(w)();
          var M = Object.keys(E).length > 1;
          M && s.props.onStateChange(E, s.getStateAndHelpers()), C && s.props.onSelect(v.selectedItem, s.getStateAndHelpers()), x !== void 0 && s.props.onChange(x, s.getStateAndHelpers()), s.props.onUserAction(E, s.getStateAndHelpers());
        });
      }, s.rootRef = function(v) {
        return s._rootNode = v;
      }, s.getRootProps = function(v, w) {
        var C, x = v === void 0 ? {} : v, E = x.refKey, S = E === void 0 ? "ref" : E, M = x.ref, T = cr(x, FL), P = w === void 0 ? {} : w, k = P.suppressRefError, I = k === void 0 ? !1 : k;
        s.getRootProps.called = !0, s.getRootProps.refKey = S, s.getRootProps.suppressRefError = I;
        var O = s.getState(), A = O.isOpen;
        return He((C = {}, C[S] = ds(M, s.rootRef), C.role = "combobox", C["aria-expanded"] = A, C["aria-haspopup"] = "listbox", C["aria-owns"] = A ? s.menuId : void 0, C["aria-labelledby"] = s.labelId, C), T);
      }, s.keyDownHandlers = {
        ArrowDown: function(w) {
          var C = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var x = w.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(x, {
              type: _c
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: _c
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), M = S.highlightedIndex, T = Lo(M, 1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(T, {
                  type: _c
                });
              }
            });
        },
        ArrowUp: function(w) {
          var C = this;
          if (w.preventDefault(), this.getState().isOpen) {
            var x = w.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(x, {
              type: Ec
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ec
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var S = C.getState(), M = S.highlightedIndex, T = Lo(M, -1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(T, {
                  type: Ec
                });
              }
            });
        },
        Enter: function(w) {
          if (w.which !== 229) {
            var C = this.getState(), x = C.isOpen, E = C.highlightedIndex;
            if (x && E != null) {
              w.preventDefault();
              var S = this.items[E], M = this.getItemNodeFromIndex(E);
              if (S == null || M && M.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: TE
              });
            }
          }
        },
        Escape: function(w) {
          w.preventDefault(), this.reset(He({
            type: ME
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, s.buttonKeyDownHandlers = He({}, s.keyDownHandlers, {
        " ": function(w) {
          w.preventDefault(), this.toggleMenu({
            type: NE
          });
        }
      }), s.inputKeyDownHandlers = He({}, s.keyDownHandlers, {
        Home: function(w) {
          var C = this.getState(), x = C.isOpen;
          if (x) {
            w.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !x)) {
              var S = Ps(0, !1, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: kE
              });
            }
          }
        },
        End: function(w) {
          var C = this.getState(), x = C.isOpen;
          if (x) {
            w.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !x)) {
              var S = Ps(E - 1, !0, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: PE
              });
            }
          }
        }
      }), s.getToggleButtonProps = function(v) {
        var w = v === void 0 ? {} : v, C = w.onClick;
        w.onPress;
        var x = w.onKeyDown, E = w.onKeyUp, S = w.onBlur, M = cr(w, LL), T = s.getState(), P = T.isOpen, k = {
          onClick: Jt(C, s.buttonHandleClick),
          onKeyDown: Jt(x, s.buttonHandleKeyDown),
          onKeyUp: Jt(E, s.buttonHandleKeyUp),
          onBlur: Jt(S, s.buttonHandleBlur)
        }, I = M.disabled ? {} : k;
        return He({
          type: "button",
          role: "button",
          "aria-label": P ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, I, M);
      }, s.buttonHandleKeyUp = function(v) {
        v.preventDefault();
      }, s.buttonHandleKeyDown = function(v) {
        var w = Ef(v);
        s.buttonKeyDownHandlers[w] && s.buttonKeyDownHandlers[w].call(Dv(s), v);
      }, s.buttonHandleClick = function(v) {
        v.preventDefault(), s.props.environment.document.activeElement === s.props.environment.document.body && v.target.focus(), process.env.NODE_ENV === "test" ? s.toggleMenu({
          type: _f
        }) : s.internalSetTimeout(function() {
          return s.toggleMenu({
            type: _f
          });
        });
      }, s.buttonHandleBlur = function(v) {
        var w = v.target;
        s.internalSetTimeout(function() {
          !s.isMouseDown && (s.props.environment.document.activeElement == null || s.props.environment.document.activeElement.id !== s.inputId) && s.props.environment.document.activeElement !== w && s.reset({
            type: AE
          });
        });
      }, s.getLabelProps = function(v) {
        return He({
          htmlFor: s.inputId,
          id: s.labelId
        }, v);
      }, s.getInputProps = function(v) {
        var w = v === void 0 ? {} : v, C = w.onKeyDown, x = w.onBlur, E = w.onChange, S = w.onInput;
        w.onChangeText;
        var M = cr(w, VL), T, P = {};
        T = "onChange";
        var k = s.getState(), I = k.inputValue, O = k.isOpen, A = k.highlightedIndex;
        if (!M.disabled) {
          var R;
          P = (R = {}, R[T] = Jt(E, S, s.inputHandleChange), R.onKeyDown = Jt(C, s.inputHandleKeyDown), R.onBlur = Jt(x, s.inputHandleBlur), R);
        }
        return He({
          "aria-autocomplete": "list",
          "aria-activedescendant": O && typeof A == "number" && A >= 0 ? s.getItemId(A) : void 0,
          "aria-controls": O ? s.menuId : void 0,
          "aria-labelledby": M && M["aria-label"] ? void 0 : s.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: I,
          id: s.inputId
        }, P, M);
      }, s.inputHandleKeyDown = function(v) {
        var w = Ef(v);
        w && s.inputKeyDownHandlers[w] && s.inputKeyDownHandlers[w].call(Dv(s), v);
      }, s.inputHandleChange = function(v) {
        s.internalSetState({
          type: DE,
          isOpen: !0,
          inputValue: v.target.value,
          highlightedIndex: s.props.defaultHighlightedIndex
        });
      }, s.inputHandleBlur = function() {
        s.internalSetTimeout(function() {
          var v = s.props.environment.document && !!s.props.environment.document.activeElement && !!s.props.environment.document.activeElement.dataset && s.props.environment.document.activeElement.dataset.toggle && s._rootNode && s._rootNode.contains(s.props.environment.document.activeElement);
          !s.isMouseDown && !v && s.reset({
            type: IE
          });
        });
      }, s.menuRef = function(v) {
        s._menuNode = v;
      }, s.getMenuProps = function(v, w) {
        var C, x = v === void 0 ? {} : v, E = x.refKey, S = E === void 0 ? "ref" : E, M = x.ref, T = cr(x, WL), P = w === void 0 ? {} : w, k = P.suppressRefError, I = k === void 0 ? !1 : k;
        return s.getMenuProps.called = !0, s.getMenuProps.refKey = S, s.getMenuProps.suppressRefError = I, He((C = {}, C[S] = ds(M, s.menuRef), C.role = "listbox", C["aria-labelledby"] = T && T["aria-label"] ? void 0 : s.labelId, C.id = s.menuId, C), T);
      }, s.getItemProps = function(v) {
        var w, C = v === void 0 ? {} : v, x = C.onMouseMove, E = C.onMouseDown, S = C.onClick;
        C.onPress;
        var M = C.index, T = C.item, P = T === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : IL("getItemProps", "item") : T, k = cr(C, BL);
        M === void 0 ? (s.items.push(P), M = s.items.indexOf(P)) : s.items[M] = P;
        var I = "onClick", O = S, A = (w = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Jt(x, function() {
            M !== s.getState().highlightedIndex && (s.setHighlightedIndex(M, {
              type: OE
            }), s.avoidScrolling = !0, s.internalSetTimeout(function() {
              return s.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Jt(E, function(N) {
            N.preventDefault();
          })
        }, w[I] = Jt(O, function() {
          s.selectItemAtIndex(M, {
            type: RE
          });
        }), w), R = k.disabled ? {
          onMouseDown: A.onMouseDown
        } : A;
        return He({
          id: s.getItemId(M),
          role: "option",
          "aria-selected": s.getState().highlightedIndex === M
        }, R, k);
      }, s.clearItems = function() {
        s.items = [];
      }, s.reset = function(v, w) {
        v === void 0 && (v = {}), v = ac(v), s.internalSetState(function(C) {
          var x = C.selectedItem;
          return He({
            isOpen: s.props.defaultIsOpen,
            highlightedIndex: s.props.defaultHighlightedIndex,
            inputValue: s.props.itemToString(x)
          }, v);
        }, w);
      }, s.toggleMenu = function(v, w) {
        v === void 0 && (v = {}), v = ac(v), s.internalSetState(function(C) {
          var x = C.isOpen;
          return He({
            isOpen: !x
          }, x && {
            highlightedIndex: s.props.defaultHighlightedIndex
          }, v);
        }, function() {
          var C = s.getState(), x = C.isOpen, E = C.highlightedIndex;
          x && s.getItemCount() > 0 && typeof E == "number" && s.setHighlightedIndex(E, v), Kv(w)();
        });
      }, s.openMenu = function(v) {
        s.internalSetState({
          isOpen: !0
        }, v);
      }, s.closeMenu = function(v) {
        s.internalSetState({
          isOpen: !1
        }, v);
      }, s.updateStatus = Bp(function() {
        var v = s.getState(), w = s.items[v.highlightedIndex], C = s.getItemCount(), x = s.props.getA11yStatusMessage(He({
          itemToString: s.props.itemToString,
          previousResultCount: s.previousResultCount,
          resultCount: C,
          highlightedItem: w
        }, v));
        s.previousResultCount = C, CE(x, s.props.environment.document);
      }, 200);
      var i = s.props, a = i.defaultHighlightedIndex, c = i.initialHighlightedIndex, l = c === void 0 ? a : c, u = i.defaultIsOpen, d = i.initialIsOpen, f = d === void 0 ? u : d, h = i.initialInputValue, p = h === void 0 ? "" : h, g = i.initialSelectedItem, m = g === void 0 ? null : g, y = s.getState({
        highlightedIndex: l,
        isOpen: f,
        inputValue: p,
        selectedItem: m
      });
      return y.selectedItem != null && s.props.initialInputValue === void 0 && (y.inputValue = s.props.itemToString(y.selectedItem)), s.state = y, s;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(s) {
        clearTimeout(s);
      }), this.timeoutIds = [];
    }, r.getState = function(s) {
      return s === void 0 && (s = this.state), dl(s, this.props);
    }, r.getItemCount = function() {
      var s = this.items.length;
      return this.itemCount != null ? s = this.itemCount : this.props.itemCount !== void 0 && (s = this.props.itemCount), s;
    }, r.getItemNodeFromIndex = function(s) {
      return this.props.environment.document.getElementById(this.getItemId(s));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var s = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(s, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(s, i) {
      var a = this.getItemCount(), c = this.getState(), l = c.highlightedIndex;
      if (a > 0) {
        var u = Lo(l, s, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, i);
      }
    }, r.getStateAndHelpers = function() {
      var s = this.getState(), i = s.highlightedIndex, a = s.inputValue, c = s.selectedItem, l = s.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, m = this.getInputProps, y = this.getItemProps, v = this.openMenu, w = this.closeMenu, C = this.toggleMenu, x = this.selectItem, E = this.selectItemAtIndex, S = this.selectHighlightedItem, M = this.setHighlightedIndex, T = this.clearSelection, P = this.clearItems, k = this.reset, I = this.setItemCount, O = this.unsetItemCount, A = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: g,
        getInputProps: m,
        getItemProps: y,
        // actions
        reset: k,
        openMenu: v,
        closeMenu: w,
        toggleMenu: C,
        selectItem: x,
        selectItemAtIndex: E,
        selectHighlightedItem: S,
        setHighlightedIndex: M,
        clearSelection: T,
        clearItems: P,
        setItemCount: I,
        unsetItemCount: O,
        setState: A,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: i,
        inputValue: a,
        isOpen: l,
        selectedItem: c
      };
    }, r.componentDidMount = function() {
      var s = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Zv(this._menuNode, this.getMenuProps);
      {
        var i = function() {
          s.isMouseDown = !0;
        }, a = function(h) {
          s.isMouseDown = !1;
          var p = hl(h.target, [s._rootNode, s._menuNode], s.props.environment);
          !p && s.getState().isOpen && s.reset({
            type: SE
          }, function() {
            return s.props.onOuterClick(s.getStateAndHelpers());
          });
        }, c = function() {
          s.isTouchMove = !1;
        }, l = function() {
          s.isTouchMove = !0;
        }, u = function(h) {
          var p = hl(h.target, [s._rootNode, s._menuNode], s.props.environment, !1);
          !s.isTouchMove && !p && s.getState().isOpen && s.reset({
            type: FE
          }, function() {
            return s.props.onOuterClick(s.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", i), d.addEventListener("mouseup", a), d.addEventListener("touchstart", c), d.addEventListener("touchmove", l), d.addEventListener("touchend", u), this.cleanup = function() {
          s.internalClearTimeouts(), s.updateStatus.cancel(), d.removeEventListener("mousedown", i), d.removeEventListener("mouseup", a), d.removeEventListener("touchstart", c), d.removeEventListener("touchmove", l), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(s, i) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = a.highlightedIndex, l = i.highlightedIndex === void 0 ? s : i, u = l.highlightedIndex, d = c && this.getState().isOpen && !s.isOpen, f = c !== u;
      return d || f;
    }, r.componentDidUpdate = function(s, i) {
      process.env.NODE_ENV !== "production" && (Hp(this.state, s, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Zv(this._menuNode, this.getMenuProps)), fl(this.props, "selectedItem") && this.props.selectedItemChanged(s.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: $E,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(i, s) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var s = Xv(this.props.children, Vn);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = Xv(s(this.getStateAndHelpers()));
      if (!i)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && YL(i, this.getRootProps), i;
      if (wE(i))
        return /* @__PURE__ */ ml(i, this.getRootProps(xE(i)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(X_);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: yE,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && NL(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Vn,
    onInputValueChange: Vn,
    onUserAction: Vn,
    onChange: Vn,
    onSelect: Vn,
    onOuterClick: Vn,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: bE
  }, e.stateChangeTypes = $L, e;
}();
process.env.NODE_ENV !== "production" && (HL.propTypes = {
  children: he.func,
  defaultHighlightedIndex: he.number,
  defaultIsOpen: he.bool,
  initialHighlightedIndex: he.number,
  initialSelectedItem: he.any,
  initialInputValue: he.string,
  initialIsOpen: he.bool,
  getA11yStatusMessage: he.func,
  itemToString: he.func,
  onChange: he.func,
  onSelect: he.func,
  onStateChange: he.func,
  onInputValueChange: he.func,
  onUserAction: he.func,
  onOuterClick: he.func,
  selectedItemChanged: he.func,
  stateReducer: he.func,
  itemCount: he.number,
  id: he.string,
  environment: he.shape({
    addEventListener: he.func.isRequired,
    removeEventListener: he.func.isRequired,
    document: he.shape({
      createElement: he.func.isRequired,
      getElementById: he.func.isRequired,
      activeElement: he.any.isRequired,
      body: he.any.isRequired
    }).isRequired,
    Node: he.func.isRequired
  }),
  suppressRefError: he.bool,
  scrollIntoView: he.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: he.any,
  isOpen: he.bool,
  inputValue: he.string,
  highlightedIndex: he.number,
  labelId: he.string,
  inputId: he.string,
  menuId: he.string,
  getItemId: he.func
  /* eslint-enable react/no-unused-prop-types */
});
function Zv(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function YL(e, t) {
  var n = t.refKey, r = n !== "ref", o = !wE(e);
  o && !r && !jv.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !jv.isForwardRef(e) && !xE(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var zL = ["isInitialMount", "highlightedIndex", "items", "environment"], LE = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function jL(e, t, n) {
  var r = e.props, o = e.type, s = {};
  Object.keys(t).forEach(function(i) {
    UL(i, e, t, n), n[i] !== t[i] && (s[i] = n[i]);
  }), r.onStateChange && Object.keys(s).length && r.onStateChange(He({
    type: o
  }, s));
}
function UL(e, t, n, r) {
  var o = t.props, s = t.type, i = "on" + Yp(e) + "Change";
  o[i] && r[e] !== void 0 && r[e] !== n[e] && o[i](He({
    type: s
  }, r));
}
function GL(e, t) {
  return t.changes;
}
function KL(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var qL = Bp(function(e, t) {
  CE(e(), t);
}, 200), XL = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Rs : Ke, ZL = "useId" in ie ? function(t) {
  var n = t.id, r = t.labelId, o = t.menuId, s = t.getItemId, i = t.toggleButtonId, a = t.inputId, c = "downshift-" + ie.useId();
  n || (n = c);
  var l = Ue({
    labelId: r || n + "-label",
    menuId: o || n + "-menu",
    getItemId: s || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: i || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return l.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + vE() : n, o = t.labelId, s = t.menuId, i = t.getItemId, a = t.toggleButtonId, c = t.inputId, l = Ue({
    labelId: o || r + "-label",
    menuId: s || r + "-menu",
    getItemId: i || function(u) {
      return r + "-item-" + u;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: c || r + "-input"
  });
  return l.current;
};
function QL(e, t, n, r) {
  var o, s;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    o = n[t], s = t;
  } else
    s = t === void 0 ? n.indexOf(e) : t, o = e;
  return [o, s];
}
function JL(e) {
  return e ? String(e) : "";
}
function Yp(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function VE(e) {
  var t = Ue(e);
  return t.current = e, t;
}
function eV(e, t, n) {
  var r = Ue(), o = Ue(), s = je(function(f, h) {
    o.current = h, f = dl(f, h.props);
    var p = e(f, h), g = h.props.stateReducer(f, He({}, h, {
      changes: p
    }));
    return g;
  }, [e]), i = t0(s, t), a = i[0], c = i[1], l = VE(n), u = je(function(f) {
    return c(He({
      props: l.current
    }, f));
  }, [l]), d = o.current;
  return Ke(function() {
    d && r.current && r.current !== a && jL(d, dl(r.current, d.props), a), r.current = a;
  }, [a, n, d]), [a, u];
}
var Pi = {
  itemToString: JL,
  stateReducer: GL,
  getA11ySelectionMessage: KL,
  scrollIntoView: bE,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function dr(e, t, n) {
  n === void 0 && (n = LE);
  var r = e["default" + Yp(t)];
  return r !== void 0 ? r : n[t];
}
function wi(e, t, n) {
  n === void 0 && (n = LE);
  var r = e[t];
  if (r !== void 0)
    return r;
  var o = e["initial" + Yp(t)];
  return o !== void 0 ? o : dr(e, t, n);
}
function tV(e) {
  var t = wi(e, "selectedItem"), n = wi(e, "isOpen"), r = wi(e, "highlightedIndex"), o = wi(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: o
  };
}
function Ri(e, t, n) {
  var r = e.items, o = e.initialHighlightedIndex, s = e.defaultHighlightedIndex, i = t.selectedItem, a = t.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && a === o ? o : s !== void 0 ? s : i ? r.indexOf(i) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function nV(e, t, n, r) {
  var o = Ue({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return Ke(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var s = function() {
        o.current.isMouseDown = !0;
      }, i = function(d) {
        o.current.isMouseDown = !1, e && !hl(d.target, t.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        o.current.isTouchMove = !1;
      }, c = function() {
        o.current.isTouchMove = !0;
      }, l = function(d) {
        e && !o.current.isTouchMove && !hl(d.target, t.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", s), n.addEventListener("mouseup", i), n.addEventListener("touchstart", a), n.addEventListener("touchmove", c), n.addEventListener("touchend", l), function() {
        n.removeEventListener("mousedown", s), n.removeEventListener("mouseup", i), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", c), n.removeEventListener("touchend", l);
      };
    }
  }, [e, n]), o;
}
var WE = function() {
  return Vn;
};
process.env.NODE_ENV !== "production" && (WE = function() {
  for (var t = Ue(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var s = Ue(r.reduce(function(a, c) {
    return a[c] = {}, a;
  }, {}));
  Ke(function() {
    Object.keys(s.current).forEach(function(a) {
      var c = s.current[a];
      if (t.current && !Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var l = c.suppressRefError, u = c.refKey, d = c.elementRef;
      (!d || !d.current) && !l && console.error('downshift: The ref prop "' + u + '" from ' + a + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var i = je(function(a, c, l, u) {
    s.current[a] = {
      suppressRefError: c,
      refKey: l,
      elementRef: u
    };
  }, []);
  return i;
});
function Qv(e, t, n) {
  var r = n.isInitialMount, o = n.highlightedIndex, s = n.items, i = n.environment, a = cr(n, zL);
  Ke(function() {
    r || qL(function() {
      return e(He({
        highlightedIndex: o,
        highlightedItem: s[o],
        resultCount: s.length
      }, a));
    }, i.document);
  }, t);
}
function rV(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, o = e.getItemNodeFromIndex, s = e.menuElement, i = e.scrollIntoView, a = Ue(!0);
  return XL(function() {
    t < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : i(o(t), s));
  }, [t]), a;
}
var BE = Vn;
process.env.NODE_ENV !== "production" && (BE = function(t) {
  var n = t.isInitialMount, r = t.props, o = t.state, s = Ue(r);
  Ke(function() {
    n || (Hp(o, s.current, r), s.current = r);
  }, [o, r, n]);
});
function Jv(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return He({
    isOpen: !1,
    highlightedIndex: -1
  }, o && He({
    selectedItem: e.items[t],
    isOpen: dr(e, "isOpen"),
    highlightedIndex: dr(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
var HE = {
  environment: he.shape({
    addEventListener: he.func.isRequired,
    removeEventListener: he.func.isRequired,
    document: he.shape({
      createElement: he.func.isRequired,
      getElementById: he.func.isRequired,
      activeElement: he.any.isRequired,
      body: he.any.isRequired
    }).isRequired,
    Node: he.func.isRequired
  }),
  itemToString: he.func,
  stateReducer: he.func
}, YE = He({}, HE, {
  getA11yStatusMessage: he.func,
  highlightedIndex: he.number,
  defaultHighlightedIndex: he.number,
  initialHighlightedIndex: he.number,
  isOpen: he.bool,
  defaultIsOpen: he.bool,
  initialIsOpen: he.bool,
  selectedItem: he.any,
  initialSelectedItem: he.any,
  defaultSelectedItem: he.any,
  id: he.string,
  labelId: he.string,
  menuId: he.string,
  getItemId: he.func,
  toggleButtonId: he.string,
  onSelectedItemChange: he.func,
  onHighlightedIndexChange: he.func,
  onStateChange: he.func,
  onIsOpenChange: he.func,
  scrollIntoView: he.func
});
function oV(e, t, n) {
  var r = t.type, o = t.props, s;
  switch (r) {
    case n.ItemMouseMove:
      s = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      s = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Ri(o, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      s = {
        isOpen: !0,
        highlightedIndex: Ri(o, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      s = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      s = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      s = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      s = {
        highlightedIndex: dr(o, "highlightedIndex"),
        isOpen: dr(o, "isOpen"),
        selectedItem: dr(o, "selectedItem"),
        inputValue: dr(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return He({}, e, s);
}
yn(yn({}, YE), { items: he.array.isRequired, isItemDisabled: he.func, getA11ySelectionMessage: he.func });
function sV(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
yn(yn({}, Pi), { getA11yStatusMessage: sV, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var zp = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, jp = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Up = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Gp = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Kp = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, qp = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Xp = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Zp = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Qp = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, pl = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Jp = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, zE = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, jE = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, eg = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, UE = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, GE = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, KE = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, qE = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, XE = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, tg = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, ZE = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, QE = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ng = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, JE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: zp,
  InputKeyDownArrowUp: jp,
  InputKeyDownEscape: Up,
  InputKeyDownHome: Gp,
  InputKeyDownEnd: Kp,
  InputKeyDownPageUp: qp,
  InputKeyDownPageDown: Xp,
  InputKeyDownEnter: Zp,
  InputChange: Qp,
  InputBlur: pl,
  InputClick: Jp,
  MenuMouseLeave: zE,
  ItemMouseMove: jE,
  ItemClick: eg,
  ToggleButtonClick: UE,
  FunctionToggleMenu: GE,
  FunctionOpenMenu: KE,
  FunctionCloseMenu: qE,
  FunctionSetHighlightedIndex: XE,
  FunctionSelectItem: tg,
  FunctionSetInputValue: ZE,
  FunctionReset: QE,
  ControlledPropUpdatedSelectedItem: ng
});
function iV(e) {
  var t = tV(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), He({}, t, {
    inputValue: r
  });
}
var aV = He({}, YE, {
  items: he.array.isRequired,
  isItemDisabled: he.func,
  selectedItemChanged: he.func,
  getA11ySelectionMessage: he.func,
  inputValue: he.string,
  defaultInputValue: he.string,
  initialInputValue: he.string,
  inputId: he.string,
  onInputValueChange: he.func
});
function cV(e, t, n) {
  var r = Ue(), o = eV(e, t, n), s = o[0], i = o[1];
  return Ke(function() {
    fl(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && i({
      type: ng,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = s.selectedItem === r.current ? n.selectedItem : s.selectedItem);
  }, [s.selectedItem, n.selectedItem]), [dl(s, n), i];
}
var e_ = Vn;
process.env.NODE_ENV !== "production" && (e_ = function(t, n) {
  he.checkPropTypes(aV, t, "prop", n.name);
});
var lV = He({}, Pi, {
  selectedItemChanged: function(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: yE,
  isItemDisabled: function() {
    return !1;
  }
});
function uV(e, t) {
  var n, r = t.type, o = t.props, s = t.altKey, i;
  switch (r) {
    case eg:
      i = {
        isOpen: dr(o, "isOpen"),
        highlightedIndex: dr(o, "highlightedIndex"),
        selectedItem: o.items[t.index],
        inputValue: o.itemToString(o.items[t.index])
      };
      break;
    case zp:
      e.isOpen ? i = {
        highlightedIndex: Lo(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: s && e.selectedItem == null ? -1 : Ri(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case jp:
      e.isOpen ? s ? i = Jv(o, e.highlightedIndex) : i = {
        highlightedIndex: Lo(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: Ri(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case Zp:
      i = Jv(o, e.highlightedIndex);
      break;
    case Up:
      i = He({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case qp:
      i = {
        highlightedIndex: Lo(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Xp:
      i = {
        highlightedIndex: Lo(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Gp:
      i = {
        highlightedIndex: Ps(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case Kp:
      i = {
        highlightedIndex: Ps(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case pl:
      i = He({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case Qp:
      i = {
        isOpen: !0,
        highlightedIndex: dr(o, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case Jp:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Ri(o, e, 0)
      };
      break;
    case tg:
      i = {
        selectedItem: t.selectedItem,
        inputValue: o.itemToString(t.selectedItem)
      };
      break;
    case ng:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return oV(e, t, JE);
  }
  return He({}, e, i);
}
var dV = ["onMouseLeave", "refKey", "ref"], fV = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], hV = ["onClick", "onPress", "refKey", "ref"], pV = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
en.stateChangeTypes = JE;
function en(e) {
  e === void 0 && (e = {}), e_(e, en);
  var t = He({}, lV, e), n = t.items, r = t.scrollIntoView, o = t.environment, s = t.getA11yStatusMessage, i = t.getA11ySelectionMessage, a = t.itemToString, c = iV(t), l = cV(uV, c, t), u = l[0], d = l[1], f = u.isOpen, h = u.highlightedIndex, p = u.selectedItem, g = u.inputValue, m = Ue(null), y = Ue({}), v = Ue(null), w = Ue(null), C = Ue(!0), x = ZL(t), E = Ue(), S = VE({
    state: u,
    props: t
  }), M = je(function(G) {
    return y.current[x.getItemId(G)];
  }, [x]);
  Qv(s, [f, h, g, n], He({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u)), Qv(i, [p], He({
    isInitialMount: C.current,
    previousResultCount: E.current,
    items: n,
    environment: o,
    itemToString: a
  }, u));
  var T = rV({
    menuElement: m.current,
    highlightedIndex: h,
    isOpen: f,
    itemRefs: y,
    scrollIntoView: r,
    getItemNodeFromIndex: M
  });
  BE({
    isInitialMount: C.current,
    props: t,
    state: u
  }), Ke(function() {
    var G = wi(t, "isOpen");
    G && v.current && v.current.focus();
  }, []), Ke(function() {
    C.current || (E.current = n.length);
  });
  var P = nV(f, [v, m, w], o, function() {
    d({
      type: pl,
      selectItem: !1
    });
  }), k = WE("getInputProps", "getMenuProps");
  Ke(function() {
    return C.current = !1, function() {
      C.current = !0;
    };
  }, []), Ke(function() {
    var G;
    if (!f)
      y.current = {};
    else if (((G = o.document) == null ? void 0 : G.activeElement) !== v.current) {
      var B;
      v == null || (B = v.current) == null || B.focus();
    }
  }, [f, o]);
  var I = fr(function() {
    return {
      ArrowDown: function(B) {
        B.preventDefault(), d({
          type: zp,
          altKey: B.altKey
        });
      },
      ArrowUp: function(B) {
        B.preventDefault(), d({
          type: jp,
          altKey: B.altKey
        });
      },
      Home: function(B) {
        S.current.state.isOpen && (B.preventDefault(), d({
          type: Gp
        }));
      },
      End: function(B) {
        S.current.state.isOpen && (B.preventDefault(), d({
          type: Kp
        }));
      },
      Escape: function(B) {
        var z = S.current.state;
        (z.isOpen || z.inputValue || z.selectedItem || z.highlightedIndex > -1) && (B.preventDefault(), d({
          type: Up
        }));
      },
      Enter: function(B) {
        var z = S.current.state;
        !z.isOpen || B.which === 229 || (B.preventDefault(), d({
          type: Zp
        }));
      },
      PageUp: function(B) {
        S.current.state.isOpen && (B.preventDefault(), d({
          type: qp
        }));
      },
      PageDown: function(B) {
        S.current.state.isOpen && (B.preventDefault(), d({
          type: Xp
        }));
      }
    };
  }, [d, S]), O = je(function(G) {
    return He({
      id: x.labelId,
      htmlFor: x.inputId
    }, G);
  }, [x]), A = je(function(G, B) {
    var z, W = G === void 0 ? {} : G, X = W.onMouseLeave, J = W.refKey, Q = J === void 0 ? "ref" : J, Y = W.ref, ce = cr(W, dV), ee = B === void 0 ? {} : B, ne = ee.suppressRefError, de = ne === void 0 ? !1 : ne;
    return k("getMenuProps", de, Q, m), He((z = {}, z[Q] = ds(Y, function(pe) {
      m.current = pe;
    }), z.id = x.menuId, z.role = "listbox", z["aria-labelledby"] = ce && ce["aria-label"] ? void 0 : "" + x.labelId, z.onMouseLeave = Jt(X, function() {
      d({
        type: zE
      });
    }), z), ce);
  }, [d, k, x]), R = je(function(G) {
    var B, z, W = G === void 0 ? {} : G, X = W.item, J = W.index, Q = W.refKey, Y = Q === void 0 ? "ref" : Q, ce = W.ref, ee = W.onMouseMove, ne = W.onMouseDown, de = W.onClick;
    W.onPress;
    var pe = W.disabled, Ee = cr(W, fV);
    pe !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var se = S.current, ke = se.props, we = se.state, Oe = QL(X, J, ke.items, "Pass either item or index to getItemProps!"), Ie = Oe[0], fe = Oe[1], q = ke.isItemDisabled(Ie, fe), te = "onClick", oe = de, re = function() {
      fe !== we.highlightedIndex && (T.current = !1, d({
        type: jE,
        index: fe,
        disabled: q
      }));
    }, ve = function() {
      d({
        type: eg,
        index: fe
      });
    }, xe = function(qe) {
      return qe.preventDefault();
    };
    return He((B = {}, B[Y] = ds(ce, function(Me) {
      Me && (y.current[x.getItemId(fe)] = Me);
    }), B["aria-disabled"] = q, B["aria-selected"] = "" + (fe === we.highlightedIndex), B.id = x.getItemId(fe), B.role = "option", B), !q && (z = {}, z[te] = Jt(oe, ve), z), {
      onMouseMove: Jt(ee, re),
      onMouseDown: Jt(ne, xe)
    }, Ee);
  }, [d, S, T, x]), N = je(function(G) {
    var B, z = G === void 0 ? {} : G, W = z.onClick;
    z.onPress;
    var X = z.refKey, J = X === void 0 ? "ref" : X, Q = z.ref, Y = cr(z, hV), ce = S.current.state, ee = function() {
      d({
        type: UE
      });
    };
    return He((B = {}, B[J] = ds(Q, function(ne) {
      w.current = ne;
    }), B["aria-controls"] = x.menuId, B["aria-expanded"] = ce.isOpen, B.id = x.toggleButtonId, B.tabIndex = -1, B), !Y.disabled && He({}, {
      onClick: Jt(W, ee)
    }), Y);
  }, [d, S, x]), $ = je(function(G, B) {
    var z, W = G === void 0 ? {} : G, X = W.onKeyDown, J = W.onChange, Q = W.onInput, Y = W.onBlur;
    W.onChangeText;
    var ce = W.onClick, ee = W.refKey, ne = ee === void 0 ? "ref" : ee, de = W.ref, pe = cr(W, pV), Ee = B === void 0 ? {} : B, se = Ee.suppressRefError, ke = se === void 0 ? !1 : se;
    k("getInputProps", ke, ne, v);
    var we = S.current.state, Oe = function(xe) {
      var Me = Ef(xe);
      Me && I[Me] && I[Me](xe);
    }, Ie = function(xe) {
      d({
        type: Qp,
        inputValue: xe.target.value
      });
    }, fe = function(xe) {
      if (we.isOpen && !P.current.isMouseDown) {
        var Me = xe.relatedTarget === null && o.document.activeElement !== o.document.body;
        d({
          type: pl,
          selectItem: !Me
        });
      }
    }, q = function() {
      d({
        type: Jp
      });
    }, te = "onChange", oe = {};
    if (!pe.disabled) {
      var re;
      oe = (re = {}, re[te] = Jt(J, Q, Ie), re.onKeyDown = Jt(X, Oe), re.onBlur = Jt(Y, fe), re.onClick = Jt(ce, q), re);
    }
    return He((z = {}, z[ne] = ds(de, function(ve) {
      v.current = ve;
    }), z["aria-activedescendant"] = we.isOpen && we.highlightedIndex > -1 ? x.getItemId(we.highlightedIndex) : "", z["aria-autocomplete"] = "list", z["aria-controls"] = x.menuId, z["aria-expanded"] = we.isOpen, z["aria-labelledby"] = pe && pe["aria-label"] ? void 0 : x.labelId, z.autoComplete = "off", z.id = x.inputId, z.role = "combobox", z.value = we.inputValue, z), oe, pe);
  }, [k, S, x, I, d, P, o]), F = je(function() {
    d({
      type: GE
    });
  }, [d]), V = je(function() {
    d({
      type: qE
    });
  }, [d]), D = je(function() {
    d({
      type: KE
    });
  }, [d]), H = je(function(G) {
    d({
      type: XE,
      highlightedIndex: G
    });
  }, [d]), j = je(function(G) {
    d({
      type: tg,
      selectedItem: G
    });
  }, [d]), U = je(function(G) {
    d({
      type: ZE,
      inputValue: G
    });
  }, [d]), K = je(function() {
    d({
      type: QE
    });
  }, [d]);
  return {
    // prop getters.
    getItemProps: R,
    getLabelProps: O,
    getMenuProps: A,
    getInputProps: $,
    getToggleButtonProps: N,
    // actions.
    toggleMenu: F,
    openMenu: D,
    closeMenu: V,
    setHighlightedIndex: H,
    setInputValue: U,
    selectItem: j,
    reset: K,
    // state.
    highlightedIndex: h,
    isOpen: f,
    selectedItem: p,
    inputValue: g
  };
}
function gV(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
He({}, HE, {
  selectedItems: he.array,
  initialSelectedItems: he.array,
  defaultSelectedItems: he.array,
  getA11yRemovalMessage: he.func,
  activeIndex: he.number,
  initialActiveIndex: he.number,
  defaultActiveIndex: he.number,
  onActiveIndexChange: he.func,
  onSelectedItemsChange: he.func,
  keyNavigationNext: he.string,
  keyNavigationPrevious: he.string
});
Pi.itemToString, Pi.stateReducer, Pi.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function ci(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var s, i, a, c;
    let l;
    n.key && ((s = n.debug) != null && s.call(n)) && (l = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((h, p) => r[p] !== h)))
      return o;
    r = u;
    let f;
    if (n.key && ((i = n.debug) != null && i.call(n)) && (f = Date.now()), o = t(...u), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - l) * 100) / 100, p = Math.round((Date.now() - f) * 100) / 100, g = p / 16, m = (y, v) => {
        for (y = String(y); y.length < v; )
          y = " " + y;
        return y;
      };
      console.info(
        `%c⏱ ${m(p, 5)} /${m(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, o), o;
  };
}
function Ed(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const mV = (e, t) => Math.abs(e - t) < 1, bV = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, vV = (e) => e, yV = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, wV = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (i) => {
    const { width: a, height: c } = i;
    t({ width: Math.round(a), height: Math.round(c) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const s = new r.ResizeObserver((i) => {
    const a = i[0];
    if (a != null && a.borderBoxSize) {
      const c = a.borderBoxSize[0];
      if (c) {
        o({ width: c.inlineSize, height: c.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return s.observe(n, { box: "border-box" }), () => {
    s.unobserve(n);
  };
}, e0 = {
  passive: !0
}, xV = typeof window > "u" ? !0 : "onscrollend" in window, CV = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const s = xV ? () => {
  } : bV(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), i = (l) => () => {
    o = n[e.options.horizontal ? "scrollLeft" : "scrollTop"], s(), t(o, l);
  }, a = i(!0), c = i(!1);
  return c(), n.addEventListener("scroll", a, e0), n.addEventListener("scrollend", c, e0), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", c);
  };
}, EV = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, _V = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, s;
  const i = e + t;
  (s = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || s.call(o, {
    [r.options.horizontal ? "left" : "top"]: i,
    behavior: n
  });
};
class SV {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((s) => {
          this._measureElement(s.target, s);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var s;
          return (s = r()) == null ? void 0 : s.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: vV,
        rangeExtractor: yV,
        onChange: () => {
        },
        measureElement: EV,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        ...n
      };
    }, this.notify = (n, r) => {
      var o, s;
      const { startIndex: i, endIndex: a } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, c = this.calculateRange();
      (n || i !== (c == null ? void 0 : c.startIndex) || a !== (c == null ? void 0 : c.endIndex)) && ((s = (o = this.options).onChange) == null || s.call(o, this, r));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, s) => {
            this.scrollAdjustments = 0, this.scrollDirection = s ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o;
            const i = this.isScrolling;
            this.isScrolling = s, this.notify(i !== s, s);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
      for (let i = r - 1; i >= 0; i--) {
        const a = n[i];
        if (o.has(a.lane))
          continue;
        const c = s.get(
          a.lane
        );
        if (c == null || a.end > c.end ? s.set(a.lane, a) : a.end < c.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return s.size === this.options.lanes ? Array.from(s.values()).sort((i, a) => i.end === a.end ? i.index - a.index : i.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = ci(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, s, i) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: s,
        enabled: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = ci(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: s, enabled: i }, a) => {
        var c;
        if (!i)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, l);
        for (let d = l; d < n; d++) {
          let f = (c = this.measurementsCache[d]) == null ? void 0 : c.measureElement;
          f || (f = (C) => {
            const x = s(d), E = this.elementsCache.get(x);
            if (!C) {
              E && (this.observer.unobserve(E), this.elementsCache.delete(x));
              return;
            }
            E !== C && (E && this.observer.unobserve(E), this.observer.observe(C), this.elementsCache.set(x, C)), C.isConnected && this.resizeItem(
              d,
              this.options.measureElement(C, void 0, this)
            );
          });
          const h = s(d), p = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), g = p ? p.end + this.options.gap : r + o, m = a.get(h), y = typeof m == "number" ? m : this.options.estimateSize(d), v = g + y, w = p ? p.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: g,
            size: y,
            end: v,
            key: h,
            lane: w,
            measureElement: f
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = ci(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? OV({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = ci(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, s) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), s = this.getMeasurements()[o];
      if (!s || !n.isConnected) {
        this.elementsCache.forEach((a, c) => {
          a === n && (this.observer.unobserve(n), this.elementsCache.delete(c));
        });
        return;
      }
      const i = this.elementsCache.get(s.key);
      i !== n && (i && this.observer.unobserve(i), this.observer.observe(n), this.elementsCache.set(s.key, n)), this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const s = this.itemSizeCache.get(o.key) ?? o.size, i = r - s;
      i !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, i, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", i), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += i,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!0, !1));
    }, this.measureElement = (n) => {
      n && this._measureElement(n, void 0);
    }, this.getVirtualItems = ci(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let s = 0, i = n.length; s < i; s++) {
          const a = n[s], c = r[a];
          o.push(c);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Ed(
          r[t_(
            0,
            r.length - 1,
            (o) => Ed(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), s = this.getScrollOffset();
      r === "auto" && (n <= s ? r = "start" : n >= s + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const i = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[i] : this.scrollElement[i] : 0) - o;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const s = this.getSize(), i = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= i + s - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= i + this.options.scrollPaddingStart)
          r = "start";
        else
          return [i, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const s = this.getOffsetForIndex(n, r);
      if (!s)
        return;
      const [i, a] = s;
      this._scrollToOffset(i, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [l] = Ed(
            this.getOffsetForIndex(n, a)
          );
          mV(l, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((s) => s.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      var n, r;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (r = (n = this.options).onChange) == null || r.call(n, this, !1);
    }, this.setOptions(t);
  }
}
const t_ = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, s = n(o);
    if (s < r)
      e = o + 1;
    else if (s > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function OV({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, s = t_(0, r, (a) => e[a].start, n);
  let i = s;
  for (; i < r && e[i].end < n + t; )
    i++;
  return { startIndex: s, endIndex: i };
}
const MV = typeof document < "u" ? b.useLayoutEffect : b.useEffect;
function TV(e) {
  const t = b.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, s) => {
      var i;
      s ? Sf(t) : t(), (i = e.onChange) == null || i.call(e, o, s);
    }
  }, [r] = b.useState(
    () => new SV(n)
  );
  return r.setOptions(n), b.useEffect(() => r._didMount(), []), MV(() => r._willUpdate()), r;
}
function n_(e) {
  return TV({
    observeElementRect: wV,
    observeElementOffset: CV,
    scrollToFn: _V,
    ...e
  });
}
function r_({
  items: e,
  inputValue: t,
  onInputValueChange: n,
  isItemDisabled: r
}) {
  const {
    isOpen: o,
    selected: s,
    onSelect: i,
    displayedValueKey: a,
    multiple: c,
    withConfirmation: l,
    setIsOpen: u,
    resettable: d = !0,
    options: f
  } = _r(), [h, p] = b.useState(s), g = l ? h : s, m = RV({
    items: e,
    selectedItem: g
  }), y = b.useRef(null), v = n_({
    count: m.length,
    getScrollElement: () => y.current,
    estimateSize: b.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: b.useCallback(
      (x) => {
        var E;
        return (E = m[x]) == null ? void 0 : E[0];
      },
      [m]
    ),
    enabled: o
  }), w = b.useMemo(() => {
    if (r)
      return (x, E) => r(x, E, g);
  }, [r, g]);
  return {
    ...en({
      isOpen: !0,
      inputValue: t,
      onInputValueChange: ({ inputValue: x }) => n(x ?? ""),
      onIsOpenChange: ({ isOpen: x, type: E }) => {
        E !== en.stateChangeTypes.InputBlur && u(!!x);
      },
      items: m,
      itemToString: (x) => x != null && x[1] ? a ? x[1][a] : x[1] : "",
      selectedItem: g,
      onSelectedItemChange: ({ selectedItem: x }) => {
        if ((x == null ? void 0 : x[0]) === "__SELECT_ALL__" && f) {
          if (!c)
            return;
          const T = (g || []).length === f.length && f.length > 0;
          let P;
          T ? P = [] : P = f, (l ? p : i)(P);
          return;
        }
        if (!c) {
          l ? p(x) : i(x);
          return;
        }
        const E = g.findIndex(
          ([M]) => M === (x == null ? void 0 : x[0])
        ), S = l ? p : i;
        E > 0 ? S([
          ...g.slice(0, E),
          ...g.slice(E + 1)
        ]) : S(E === 0 ? [...g.slice(1)] : [...g, x]);
      },
      ...w ? { isItemDisabled: w } : void 0,
      stateReducer: b.useMemo(
        () => c || l ? PV : kV({ resettable: d }),
        [c, l, d]
      ),
      scrollIntoView() {
      },
      onHighlightedIndexChange: ({ highlightedIndex: x, type: E }) => {
        E !== en.stateChangeTypes.MenuMouseLeave && x !== void 0 && v.scrollToIndex(x);
      }
    }),
    selectedItem: g,
    resetSelectionBuffer: () => p([]),
    setSelectionBuffer: p,
    virtualizer: v,
    listRef: y,
    sortedItems: m
  };
}
const kV = ({ resettable: e }) => (t, n) => {
  var s;
  const { changes: r, type: o } = n;
  switch (o) {
    case en.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...r,
        inputValue: ""
        // reset input value on popover opening
      };
    case en.stateChangeTypes.InputKeyDownEnter:
    case en.stateChangeTypes.ItemClick:
      return e ? {
        ...r,
        selectedItem: ((s = t.selectedItem) == null ? void 0 : s[0]) === r.selectedItem[0] ? [] : r.selectedItem
      } : r;
    case en.stateChangeTypes.InputBlur:
      return {
        ...r,
        selectedItem: t.selectedItem,
        // don't select on blur
        highlightedIndex: t.highlightedIndex,
        inputValue: t.inputValue
      };
    case en.stateChangeTypes.InputClick:
      return {
        ...r,
        isOpen: !0
      };
    default:
      return r;
  }
}, PV = (e, t) => {
  const { changes: n, type: r } = t;
  switch (r) {
    case en.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...n,
        inputValue: e.inputValue || ""
      };
    case en.stateChangeTypes.InputKeyDownEnter:
    case en.stateChangeTypes.ItemClick:
      return {
        ...n,
        isOpen: !0,
        // keep dropdown open after selection
        highlightedIndex: e.highlightedIndex,
        // keep highlighted index position
        inputValue: e.inputValue
        // keep search query
      };
    case en.stateChangeTypes.InputBlur:
      return {
        ...n,
        selectedItem: e.selectedItem,
        // don't select on blur
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      };
    case en.stateChangeTypes.InputClick:
      return {
        ...n,
        isOpen: !0
      };
    default:
      return n;
  }
};
function RV({
  items: e,
  selectedItem: t
}) {
  const { isOpen: n, multiple: r, getOptions: o } = _r(), s = !!o, i = b.useRef(null);
  return b.useEffect(() => {
    s || (n && !i.current && r ? i.current = new Set(
      (t || []).map(([c]) => c)
    ) : n || (i.current = null));
  }, [s, n, r, t]), b.useMemo(() => {
    var f;
    if (s || !r || !i.current)
      return e;
    const c = i.current, l = ((f = e[0]) == null ? void 0 : f[0]) === "__SELECT_ALL__" ? e[0] : null, d = [...l ? e.slice(1) : e].sort((h, p) => {
      const g = c.has(h[0]), m = c.has(p[0]);
      return g && !m ? -1 : !g && m ? 1 : 0;
    });
    return l ? [l, ...d] : d;
  }, [r, s, e, i.current]);
}
function IV({
  value: e,
  defaultValue: t,
  finalValue: n,
  onChange: r = () => {
  }
}) {
  const [o, s] = _t(
    t !== void 0 ? t : n
  ), i = (a, ...c) => {
    s(a), r == null || r(a, ...c);
  };
  return e !== void 0 ? [e, r, !0] : [o, i, !1];
}
const o_ = "__SELECT_ALL__", PW = (e) => {
  var r;
  const [t, n] = IV({
    value: e.isOpen,
    defaultValue: !1,
    onChange: e.onOpenChange
  });
  return /* @__PURE__ */ _(
    pE.Provider,
    {
      value: {
        ...e,
        withConfirmation: e.withConfirmation,
        setIsOpen: n,
        isOpen: t
      },
      children: /* @__PURE__ */ Z(lL, { open: t, onOpenChange: n, children: [
        /* @__PURE__ */ _(DV, { ref: e.triggerRef }),
        /* @__PURE__ */ Z(
          fL,
          {
            sideOffset: 6,
            collisionPadding: 10,
            ...e.contentProps,
            className: le(
              `line
            z-50
            flex max-h-[min(var(--radix-popover-content-available-height),26rem)]
             w-[var(--radix-popover-content-available-width)]
           max-w-[max(var(--radix-popover-trigger-width),_16rem)] flex-col overflow-hidden
          rounded-md
          bg-foundations-default py-1 shadow-2`,
              (r = e.contentProps) == null ? void 0 : r.className
            ),
            children: [
              e.options && /* @__PURE__ */ _(FV, {}),
              e.getOptions && /* @__PURE__ */ _(LV, {})
            ]
          }
        )
      ] })
    }
  );
}, DV = b.forwardRef(
  (e, t) => {
    const {
      selected: n,
      prefixText: r,
      prefixIcon: o,
      disabled: s,
      className: i,
      multiple: a,
      error: c,
      onBlur: l,
      displayedValue: u,
      CustomTrigger: d
    } = _r();
    return /* @__PURE__ */ Z(
      uL,
      {
        ref: t,
        type: "button",
        role: "combobox",
        "aria-haspopup": "listbox",
        className: le(
          "flex w-full select-none items-center rounded-md border border-foundations-bold bg-foundations-default py-2 pl-3 pr-2 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-info focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed aria-expanded:border-info-bold aria-expanded:text-info aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          !s && "group/drop-down hover:shadow-3",
          c && "border-danger-bold focus:border-danger-bold focus:ring-danger-bold [&:focus>svg]:!text-danger [&>svg]:text-danger",
          i
        ),
        disabled: s,
        onBlur: l,
        children: [
          d || /* @__PURE__ */ Z(It, { children: [
            r && /* @__PURE__ */ _("span", { className: "-my-2 mr-3 flex-shrink-0 border-r border-r-foundations-subtle py-2 pr-3 text-sm text-foundations-subtle", children: r }),
            o && /* @__PURE__ */ _(o, { className: "-ml-1 mr-3 h-5 w-5" }),
            /* @__PURE__ */ _(
              "span",
              {
                className: le(
                  "value min-w-0 flex-1 truncate text-sm text-foundations-subtle",
                  {
                    "text-foundations-bolder": a ? n.length : n == null ? void 0 : n[1]
                  }
                ),
                children: u ? u(n) : a ? /* @__PURE__ */ _(NV, {}) : /* @__PURE__ */ _(AV, {})
              }
            )
          ] }),
          /* @__PURE__ */ _($y, { className: "ml-2 h-5 w-5 shrink-0 transition-transform group-aria-expanded/drop-down:rotate-180" })
        ]
      }
    );
  }
), NV = () => {
  const { label: e, selected: t, displayedValueKey: n } = _r();
  return t != null && t.length ? /* @__PURE__ */ _(It, { children: t.map(
    ([r, o]) => n ? o[n] : o
  ).join(", ") }) : /* @__PURE__ */ _(It, { children: e });
}, AV = () => {
  const { label: e, selected: t, displayedValueKey: n } = _r();
  return t != null && t[1] ? /* @__PURE__ */ _(It, { children: n ? t[1][n] : t[1] }) : /* @__PURE__ */ _(It, { children: e });
}, s_ = ({ errorMsg: e }) => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4", children: [
  /* @__PURE__ */ _(vx, {}),
  /* @__PURE__ */ _("p", { className: "text-center text-sm text-foundations-subtle", children: e || "No matching data available" })
] }), $V = () => /* @__PURE__ */ _("div", { className: "my-4 flex flex-col items-center", children: /* @__PURE__ */ _(r4, {}) }), FV = () => {
  const {
    options: e = [],
    filterBy: t,
    displayedValueKey: n,
    onSelect: r,
    setIsOpen: o,
    ExtraBodyContent: s,
    searchTerm: i,
    onSearch: a,
    isItemDisabled: c,
    multiple: l,
    disableSelectAll: u
  } = _r(), [d, f] = b.useState(""), h = lf(t), p = !!t, g = i ?? d, m = a ?? f, y = b.useMemo(
    () => e.filter(([R, N]) => {
      var $;
      return p ? h(d, N) : n ? ($ = N[n]) == null ? void 0 : $.toLowerCase().includes(d == null ? void 0 : d.toLowerCase()) : N == null ? void 0 : N.toLowerCase().includes(d == null ? void 0 : d.toLowerCase());
    }),
    [e, d, p, h, n]
  ), v = b.useMemo(
    () => [[o_, "Select All"], ...e],
    [e]
  ), w = b.useMemo(() => !l || u || y.length === 0 || g.trim() !== "" ? y : v, [l, u, y, g]), {
    getLabelProps: C,
    getMenuProps: x,
    getInputProps: E,
    getItemProps: S,
    highlightedIndex: M,
    selectedItem: T,
    resetSelectionBuffer: P,
    listRef: k,
    virtualizer: I,
    sortedItems: O
  } = r_({
    items: w,
    inputValue: g,
    onInputValueChange: m,
    isItemDisabled: c
  }), A = I.getVirtualItems();
  return /* @__PURE__ */ Z(It, { children: [
    /* @__PURE__ */ _(i_, { getLabelProps: C, getInputProps: E }),
    s,
    /* @__PURE__ */ Z(
      "ul",
      {
        className: "relative my-1 w-full  overflow-y-auto",
        ...x({
          ref: k,
          style: { maxHeight: 350 }
        }),
        children: [
          /* @__PURE__ */ _("li", { style: { height: I.getTotalSize() } }, "total-size"),
          A.length ? A.map((R) => /* @__PURE__ */ _(
            a_,
            {
              ref: I.measureElement,
              "data-index": R.index,
              "data-highlighted": M === R.index,
              option: O[R.index],
              getItemProps: S,
              index: R.index,
              selectedItem: T,
              style: {
                position: "absolute",
                top: 0,
                left: "0.5rem",
                width: "calc(100% - 1rem)",
                transform: `translateY(${R.start}px)`
              }
            },
            R.key
          )) : /* @__PURE__ */ _(s_, {})
        ]
      }
    ),
    /* @__PURE__ */ _(
      c_,
      {
        onReset: P,
        onApply: () => {
          r(T), o(!1);
        }
      }
    )
  ] });
}, LV = () => {
  const {
    getOptions: e,
    dependencies: t = [],
    onSelect: n,
    setIsOpen: r,
    ExtraBodyContent: o,
    parseGetOptionsError: s,
    isItemDisabled: i,
    selected: a,
    multiple: c,
    disableEmptySearch: l
  } = _r(), [u, d] = b.useState(""), [f, h] = b.useState(!0), [p, g] = b.useState(null), [m, y] = b.useState([]), v = b.useMemo(() => [
    ...c && a ? a.filter(
      (P) => {
        var k;
        return (k = P[1]) == null ? void 0 : k.toLowerCase().includes(u == null ? void 0 : u.toLowerCase());
      }
    ) : [],
    ...a ? m.filter(
      (P) => !a.some(
        (k) => k[0] === P[0]
      )
    ) : m
  ], [m]), {
    getLabelProps: w,
    getMenuProps: C,
    getInputProps: x,
    getItemProps: E,
    highlightedIndex: S,
    selectedItem: M,
    resetSelectionBuffer: T
  } = r_({
    items: v,
    inputValue: u,
    onInputValueChange: d,
    isItemDisabled: i
  });
  return mL(
    () => {
      if (l && u === "") {
        y([]), h(!1), g(null);
        return;
      }
      h(!0), e(u).then(y).catch((P) => {
        const k = s != null && s(P) || typeof P == "string" ? P : null;
        g(k || null);
      }).finally(() => h(!1));
    },
    500,
    [u, ...t]
  ), /* @__PURE__ */ Z(It, { children: [
    /* @__PURE__ */ _(i_, { getLabelProps: w, getInputProps: x }),
    o,
    /* @__PURE__ */ _(
      "ul",
      {
        className: "my-1 flex-1 space-y-1 overflow-y-auto px-2",
        ...C(),
        children: f ? /* @__PURE__ */ _($V, {}) : v.length ? v.map((P, k) => /* @__PURE__ */ _(
          a_,
          {
            "data-highlighted": S === k,
            option: P,
            getItemProps: E,
            index: k,
            selectedItem: M
          },
          P[0]
        )) : /* @__PURE__ */ _(s_, { errorMsg: p })
      }
    ),
    /* @__PURE__ */ _(
      c_,
      {
        onReset: T,
        onApply: () => {
          n(M), r(!1);
        }
      }
    )
  ] });
}, i_ = ({
  getLabelProps: e,
  getInputProps: t
}) => {
  const {
    label: n,
    name: r,
    placeholder: o = "Search",
    disableSearch: s
  } = _r();
  return /* @__PURE__ */ Z("div", { className: "border-b border-foundations-subtle p-4 pt-3", children: [
    /* @__PURE__ */ Z("div", { className: "flex items-center justify-between space-x-2", children: [
      /* @__PURE__ */ _(
        "label",
        {
          title: n,
          className: "select-none truncate font-medium text-foundations-bolder",
          ...e(),
          children: n
        }
      ),
      /* @__PURE__ */ _(dL, { className: "shrink-0 text-foundations-subtler hover:text-info focus:text-info focus:outline-none ", children: /* @__PURE__ */ _(Ih, { className: "h-5 w-5" }) })
    ] }),
    /* @__PURE__ */ Z(
      "div",
      {
        className: le("relative mt-3", s && "invisible mt-0 h-0"),
        children: [
          /* @__PURE__ */ _(
            "input",
            {
              className: "w-full rounded-md border border-foundations-bold bg-foundations-default py-1.5 pl-10 pr-2 text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:ring-1 focus:ring-info-bold",
              placeholder: o,
              ...t({ name: r })
            }
          ),
          /* @__PURE__ */ _("div", { className: "pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2", children: /* @__PURE__ */ _(Tk, { className: "h-5 w-5 text-foundations-subtler " }) })
        ]
      }
    )
  ] });
}, VV = En(
  "group flex items-center justify-between gap-1 rounded p-2 text-sm text-foundations-bolder",
  {
    variants: {
      multiple: {
        true: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-foundations-subtlest",
        false: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), a_ = b.forwardRef(({ selectedItem: e, option: t, getItemProps: n, index: r, ...o }, s) => {
  const { multiple: i, renderOption: a, options: c } = _r(), [l, u] = t, d = l === o_, f = b.useMemo(() => {
    if (!d || !c)
      return null;
    const p = e == null ? void 0 : e.length, g = p === c.length && c.length > 0;
    return { allSelected: g, isIndeterminate: !g && !(p === 0) };
  }, [d, c, e]), h = i && !d ? e == null ? void 0 : e.some(([p]) => p === l) : l === (e == null ? void 0 : e[0]);
  return /* @__PURE__ */ Z(
    "li",
    {
      "data-selected": h,
      className: le(
        VV({ multiple: i }),
        d && "text-xs text-foundations-subtle"
      ),
      ...n({ item: t, index: r, ref: s }),
      ...o,
      children: [
        /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between overflow-hidden", children: d ? /* @__PURE__ */ Z("span", { className: "font-medium", children: [
          u,
          " ",
          c != null && c.length ? `(${c == null ? void 0 : c.length})` : null
        ] }) : a ? a(u) : /* @__PURE__ */ Z(It, { children: [
          /* @__PURE__ */ _("span", { children: u }),
          !i && /* @__PURE__ */ _(yo, { className: "invisible h-5 w-5 flex-shrink-0 group-data-[selected=true]:visible" })
        ] }) }),
        i && /* @__PURE__ */ _(
          Ox,
          {
            tabIndex: -1,
            checked: d ? f == null ? void 0 : f.allSelected : h,
            isIndeterminate: d ? f == null ? void 0 : f.isIndeterminate : !1,
            readOnly: !0,
            className: "pointer-events-none flex-shrink-0 select-none"
          }
        )
      ]
    }
  );
}), c_ = ({
  onReset: e,
  onApply: t
}) => {
  const { withConfirmation: n, ExtraFooterAction: r, resettable: o } = _r();
  return n ? /* @__PURE__ */ Z("div", { className: "border-t border-t-neutral-200 px-6 py-4", children: [
    r,
    /* @__PURE__ */ Z("div", { className: "flex space-x-4", children: [
      /* @__PURE__ */ _(
        Tc,
        {
          variant: "secondary",
          onClick: () => {
            o && e();
          },
          className: "flex-1",
          children: "Reset"
        }
      ),
      /* @__PURE__ */ _(Tc, { onClick: t, className: "flex-1", children: "Apply" })
    ] })
  ] }) : null;
}, l_ = b.createContext(null), u_ = () => {
  const e = b.useContext(l_);
  if (!e)
    throw new Error("useSelectContext must be used within <Select />");
  return e;
}, WV = (e) => {
  const [t, n] = b.useState(!1), [r, o] = b.useState(""), {
    selected: s,
    onSelect: i,
    options: a,
    placement: c = "bottom",
    className: l,
    contentClassName: u,
    displayedValueKey: d,
    filterBy: f
  } = e, h = b.useRef(!1), p = b.useMemo(() => h.current ? a.filter(([T, P]) => {
    if (typeof P == "string")
      return P.toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
    if (f)
      return f(r, P);
    if (d)
      return P[d].toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
  }) : a, [t, a, r, d]), g = b.useCallback(
    (T, P) => {
      var O;
      const { changes: k, type: I } = P;
      switch (I) {
        case en.stateChangeTypes.InputKeyDownEscape:
        case en.stateChangeTypes.InputBlur:
          return {
            ...k,
            selectedItem: T.selectedItem,
            inputValue: (O = T.selectedItem) != null && O[1] ? d ? T.selectedItem[1][d] : T.selectedItem[1] : ""
          };
        default:
          return k;
      }
    },
    [d]
  ), m = b.useRef(null), y = n_({
    count: p.length,
    getScrollElement: () => m.current,
    estimateSize: b.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: b.useCallback(
      (T) => {
        var P;
        return (P = p == null ? void 0 : p[T]) == null ? void 0 : P[0];
      },
      [p]
    ),
    enabled: t
  }), {
    getInputProps: v,
    getMenuProps: w,
    getItemProps: C,
    highlightedIndex: x,
    getToggleButtonProps: E
  } = en({
    isOpen: t,
    onIsOpenChange: ({ isOpen: T, ...P }) => {
      h.current = !1, n(!!T);
    },
    onInputValueChange: ({ inputValue: T }) => {
      h.current = !0, o(T ?? "");
    },
    items: p,
    itemToString: (T) => T != null && T[1] ? d ? T[1][d] : T[1] : "",
    selectedItem: s,
    onSelectedItemChange: ({ selectedItem: T }) => {
      i(T);
    },
    stateReducer: g,
    scrollIntoView() {
    },
    onHighlightedIndexChange: ({ highlightedIndex: T, type: P }) => {
      P !== en.stateChangeTypes.MenuMouseLeave && T !== void 0 && y.scrollToIndex(T);
    }
  }), { refs: S, floatingStyles: M } = LC({
    open: t,
    placement: c,
    middleware: [
      OC(6),
      SC(),
      MC(),
      TC({
        apply: ({ elements: T, rects: P, availableWidth: k, availableHeight: I }) => {
          const { width: O, height: A } = P.reference, R = T.floating.style;
          R.setProperty("--available-width", `${k}px`), R.setProperty(
            "--available-height",
            `${I}px`
          ), R.setProperty("--trigger-width", `${O}px`), R.setProperty("--trigger-height", `${A}px`);
        },
        padding: 10
      })
    ],
    whileElementsMounted: $C
  });
  return /* @__PURE__ */ _(l_.Provider, { value: e, children: /* @__PURE__ */ Z("div", { ref: S.setReference, className: l, children: [
    /* @__PURE__ */ _(
      d_,
      {
        getInputProps: v,
        getToggleButtonProps: E
      }
    ),
    /* @__PURE__ */ _(rw, { children: /* @__PURE__ */ _(
      "ul",
      {
        className: le(
          "z-50 max-h-[min(var(--available-height),_12.5rem)] w-[var(--available-width)] max-w-[max(var(--trigger-width),_18rem)] overflow-y-auto rounded-md bg-foundations-default shadow-2",
          !t && "hidden",
          u
        ),
        ...w({
          ref: Sx([S.setFloating, m]),
          style: M
        }),
        children: e.options && /* @__PURE__ */ Z(It, { children: [
          /* @__PURE__ */ _(
            "li",
            {
              style: { height: y.getTotalSize() }
            },
            "total-size"
          ),
          /* @__PURE__ */ _(
            h_,
            {
              virtualizer: y,
              getItemProps: C,
              highlightedIndex: x,
              filteredOptions: p
            }
          )
        ] })
      }
    ) })
  ] }) });
};
WV.displayName = "Select";
const d_ = ({
  getInputProps: e,
  getToggleButtonProps: t
}) => {
  const {
    selected: n,
    id: r,
    name: o,
    disabled: s,
    prefixText: i,
    prefixIcon: a,
    placeholder: c,
    inputClassName: l,
    onBlur: u,
    error: d,
    inputRef: f
  } = u_();
  return /* @__PURE__ */ Z("div", { className: "relative", children: [
    /* @__PURE__ */ _(
      "input",
      {
        className: le(
          "peer w-full overflow-ellipsis rounded-md border border-foundations-bold bg-foundations-default p-2 pr-8 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-foundations-boldest focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed  disabled:border-foundations-subtle disabled:bg-foundations-subtelst-02 disabled:text-foundations-subtler aria-expanded:border-info-bold aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          {
            "hover:shadow-3": !s,
            "text-foundations-boldest": n == null ? void 0 : n[1],
            "pl-9": a,
            "pl-16": i,
            "border-danger-bold focus:border-danger-bold focus:ring-danger-bold": d
          },
          l
        ),
        ...e({
          onBlur: u,
          disabled: s,
          placeholder: c,
          name: o,
          id: r,
          ref: f
        })
      }
    ),
    i && /* @__PURE__ */ _("span", { className: "pointer-events-none absolute inset-y-0 left-0 top-0 flex flex-shrink-0 items-center justify-center border-r border-r-foundations-bold px-3 text-sm text-foundations-subtle", children: i }),
    a && /* @__PURE__ */ _(a, { className: "pointer-events-none absolute left-2 top-1/2 h-5 w-5 -translate-y-1/2 text-foundations-subtler peer-focus:text-info peer-aria-expanded:text-info" }),
    /* @__PURE__ */ _(
      "button",
      {
        ...t({ disabled: s, type: "button" }),
        className: "absolute inset-y-0 right-2 flex flex-shrink-0 items-center justify-center text-foundations-subtler transition-transform disabled:cursor-not-allowed peer-focus:text-info peer-aria-expanded:rotate-180 peer-aria-expanded:text-info",
        children: /* @__PURE__ */ _($y, { className: " h-5 w-5 " })
      }
    )
  ] });
};
d_.displayName = "SelectInput";
const f_ = () => /* @__PURE__ */ Z("div", { className: "my-4 flex flex-col items-center space-y-4 text-center", children: [
  /* @__PURE__ */ _(vx, {}),
  /* @__PURE__ */ _("p", { className: "text-sm text-foundations-subtle", children: "No matching data available" })
] });
f_.displayName = "EmptyOptions";
const h_ = ({
  highlightedIndex: e,
  getItemProps: t,
  filteredOptions: n,
  virtualizer: r
}) => {
  const o = r.getVirtualItems();
  return /* @__PURE__ */ _(It, { children: o.length ? o.map((s) => /* @__PURE__ */ _(
    p_,
    {
      ref: r.measureElement,
      "data-index": s.index,
      "data-highlighted": e === s.index,
      option: n[s.index],
      getItemProps: t,
      index: s.index,
      style: {
        position: "absolute",
        top: 0,
        left: "0.5rem",
        width: "calc(100% - 1rem)",
        transform: `translateY(${s.start}px)`
      }
    },
    s.key
  )) : /* @__PURE__ */ _(f_, {}) });
};
h_.displayName = "SelectOptions";
const BV = En(
  "group flex items-center justify-between rounded p-2 text-sm text-foundations-subtle",
  {
    variants: {
      multiple: {
        true: "data-[highlighted=true]:bg-foundations-subtlest",
        false: "data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), p_ = b.forwardRef(({ option: e, getItemProps: t, index: n, ...r }, o) => {
  const { renderOption: s, selected: i } = u_(), [a, c] = e, l = a === (i == null ? void 0 : i[0]);
  return /* @__PURE__ */ _(
    "li",
    {
      "data-selected": l,
      className: BV(),
      ...t({
        item: e,
        index: n,
        ref: o
      }),
      ...r,
      children: /* @__PURE__ */ _("div", { className: "flex flex-1 items-center justify-between", children: s ? s(c, l) : /* @__PURE__ */ Z(It, { children: [
        /* @__PURE__ */ _("span", { children: c }),
        /* @__PURE__ */ _(yo, { className: "invisible h-5 w-5 group-data-[selected=true]:visible" })
      ] }) })
    }
  );
});
p_.displayName = "Option";
const HV = b.forwardRef(
  ({
    savedFileName: e = null,
    multiple: t = !1,
    accept: n,
    showAcceptedFilesHint: r = !0,
    label: o = "",
    hint: s = "",
    uploadingProgress: i = 0,
    uploadedFiles: a = [],
    onFilesChange: c,
    withUploadConfirmation: l = !1,
    onUploadConfirmed: u,
    isUploadButtonDisabled: d = !1,
    isUploadButtonLoading: f = !1,
    isUploadButtonTooltipDisabled: h = !1,
    uploadButtonTooltipText: p = ""
  }, g) => {
    var T;
    const m = i > 0 && i < 100, y = b.useMemo(
      () => `UploadFiles${o.split(" ").join("")}`,
      [o]
    ), [v, w] = b.useState(!1), C = b.useRef(null), x = a.length > 0 || !!e, E = b.useCallback(
      (P) => {
        var k;
        if (w(!1), (k = P.target.files) != null && k.length) {
          if (m)
            return;
          c([...P.target.files]);
        }
      },
      [c]
    ), S = b.useCallback(
      (P) => {
        P.preventDefault(), w(!0);
      },
      []
    ), M = b.useCallback(
      (P) => {
        P.preventDefault(), w(!1);
      },
      []
    );
    return /* @__PURE__ */ Z(It, { children: [
      o && /* @__PURE__ */ Z(
        "label",
        {
          htmlFor: y,
          className: "mb-2 inline-flex items-center gap-2",
          children: [
            /* @__PURE__ */ _("span", { className: "block text-sm font-medium text-foundations-bold", children: o }),
            s && /* @__PURE__ */ _(Xg, { delay: 0, children: /* @__PURE__ */ Z(Rt, { children: [
              /* @__PURE__ */ _(
                Rt.Trigger,
                {
                  render: /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100" }),
                  children: /* @__PURE__ */ _(
                    Ok,
                    {
                      width: 16,
                      height: 16,
                      className: " text-foundations-subtler"
                    }
                  )
                }
              ),
              /* @__PURE__ */ _(
                Rt.Popup,
                {
                  variant: "dark",
                  side: "top",
                  size: "sm",
                  collisionPadding: 4,
                  children: s
                }
              )
            ] }) })
          ]
        }
      ),
      /* @__PURE__ */ Z("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ Z(
          "div",
          {
            ref: g,
            className: le(
              "relative flex w-full items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-neutral-300 p-4 text-foundations-subtle transition-all duration-200",
              {
                "border-blue-500 bg-neutral-50 text-blue-500": v,
                "pointer-events-none border-solid border-blue-200": m,
                "pointer-events-none border-solid border-green-200": x,
                "p-2": l
              }
            ),
            children: [
              m ? /* @__PURE__ */ Z(It, { children: [
                /* @__PURE__ */ _(
                  aw,
                  {
                    variant: "primary",
                    value: i,
                    size: 26,
                    strokeWidth: 4,
                    strokeClassName: "stroke-neutral-800",
                    strokeLinecap: "square"
                  }
                ),
                /* @__PURE__ */ Z("p", { className: "p-1 text-xs font-medium", children: [
                  "Uploading (",
                  i,
                  "%)"
                ] }),
                /* @__PURE__ */ _(
                  "div",
                  {
                    className: "absolute bottom-0 left-0 h-[5px] bg-blue-500",
                    style: { width: `${i}%` }
                  }
                )
              ] }) : /* @__PURE__ */ _(It, { children: x ? /* @__PURE__ */ Z(It, { children: [
                /* @__PURE__ */ _("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-green-100", children: /* @__PURE__ */ _(
                  yo,
                  {
                    width: 16,
                    height: 16,
                    className: "text-green-500"
                  }
                ) }),
                /* @__PURE__ */ _("p", { className: "p-1 text-xs font-medium", children: ((T = a[0]) == null ? void 0 : T.name) || e })
              ] }) : /* @__PURE__ */ Z(It, { children: [
                /* @__PURE__ */ _(
                  om,
                  {
                    width: 20,
                    height: 20,
                    className: "pointer-events-none text-foundations-subtle"
                  }
                ),
                /* @__PURE__ */ Z("p", { className: "pointer-events-none p-1 text-xs font-medium", children: [
                  "Drop file or click here to",
                  " ",
                  l ? "browse" : "upload"
                ] })
              ] }) }),
              /* @__PURE__ */ _(
                "input",
                {
                  id: y,
                  className: "absolute inset-0 cursor-pointer opacity-0",
                  ref: C,
                  type: "file",
                  accept: n,
                  multiple: t,
                  onChange: E,
                  onDragEnter: S,
                  onDragLeave: M
                }
              )
            ]
          }
        ),
        l && /* @__PURE__ */ _(Xg, { children: /* @__PURE__ */ Z(
          Rt,
          {
            disabled: !p || h,
            children: [
              /* @__PURE__ */ _(
                Rt.Trigger,
                {
                  render: /* @__PURE__ */ _(
                    Tc,
                    {
                      className: "disabled:pointer-events-auto",
                      disabled: d,
                      isLoading: f,
                      onClick: () => u == null ? void 0 : u(a)
                    }
                  ),
                  children: "Upload"
                }
              ),
              /* @__PURE__ */ _(Rt.Popup, { children: p })
            ]
          }
        ) })
      ] }),
      n && r && /* @__PURE__ */ Z("p", { className: "mt-[6px] text-xs text-foundations-subtle", children: [
        "Supported file types: ",
        n.split(",").join(" ")
      ] }),
      x && /* @__PURE__ */ Z(
        "button",
        {
          type: "button",
          className: "flex items-center justify-center gap-2 px-4 py-[6px] text-foundations-subtle",
          onClick: () => {
            var P;
            return (P = C.current) == null ? void 0 : P.click();
          },
          children: [
            /* @__PURE__ */ _(om, { width: 20, height: 20 }),
            /* @__PURE__ */ _("span", { className: "text-xs font-medium", children: l ? "Browse files" : "Re-upload file" })
          ]
        }
      )
    ] });
  }
);
HV.displayName = "UploadArea";
const YV = fp, g_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Hw,
  {
    "data-slot": "menu-trigger",
    className: le("", e),
    ...t
  }
));
g_.displayName = "MenuTrigger";
const rg = b.forwardRef(
  ({
    children: e,
    className: t,
    sideOffset: n = 4,
    align: r = "end",
    alignOffset: o = 0,
    side: s = "bottom",
    ...i
  }, a) => /* @__PURE__ */ Z(Rw, { children: [
    /* @__PURE__ */ _(Cw, {}),
    /* @__PURE__ */ _(
      Iw,
      {
        align: r,
        alignOffset: o,
        className: "z-50",
        "data-slot": "menu-positioner",
        side: s,
        sideOffset: n,
        children: /* @__PURE__ */ _(
          Pw,
          {
            ref: a,
            className: le(
              "relative flex max-h-[--available-height] w-56 origin-[--transform-origin] overflow-y-auto overflow-x-hidden rounded-md border border-foundations-subtle bg-foundations-default bg-clip-padding p-2 text-foundations-bolder shadow-lg transition-[scale,opacity] data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95",
              t
            ),
            "data-slot": "menu-popup",
            ...i,
            children: /* @__PURE__ */ _("div", { className: "w-full", children: e })
          }
        )
      }
    )
  ] })
);
rg.displayName = "MenuPopup";
const zV = En(
  "relative flex cursor-pointer select-none scroll-m-1 items-center gap-2 rounded px-4 py-2 text-sm text-foundations-bolder outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        destructive: "destructive-menu text-danger"
      }
    }
  }
), m_ = b.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ _(
  Mw,
  {
    ref: r,
    className: le(zV({ variant: t }), e),
    "data-slot": "menu-item",
    "data-variant": t,
    ...n
  }
));
m_.displayName = "MenuItem";
const jV = (e) => /* @__PURE__ */ _(d3, { "data-slot": "menu-sub", ...e }), b_ = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  Yw,
  {
    ref: r,
    className: le(
      "data-disabled:pointer-events-none data-disabled:opacity-64 flex items-center gap-2 rounded-sm px-2 py-1 outline-none data-[highlighted]:bg-foundations-subtlest sm:text-sm",
      e
    ),
    "data-slot": "menu-sub-trigger",
    ...n,
    children: [
      t,
      /* @__PURE__ */ _(Ph, { className: "ms-auto h-4 w-4 text-foundations-subtler" })
    ]
  }
));
b_.displayName = "MenuSubTrigger";
const v_ = b.forwardRef(
  ({ className: e, sideOffset: t = 0, alignOffset: n = -4, align: r = "start", ...o }, s) => /* @__PURE__ */ _(
    rg,
    {
      ref: s,
      align: r,
      alignOffset: n,
      className: e,
      "data-slot": "menu-sub-content",
      side: "inline-end",
      sideOffset: t,
      ...o
    }
  )
);
v_.displayName = "MenuSubPopup";
const y_ = b.forwardRef((e, t) => /* @__PURE__ */ _(Sw, { ref: t, "data-slot": "menu-group", ...e }));
y_.displayName = "MenuGroup";
const w_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Ow,
  {
    ref: n,
    className: le(
      "p-2 text-xs font-medium uppercase text-foundations-subtle",
      e
    ),
    "data-slot": "menu-label",
    ...t
  }
));
w_.displayName = "MenuGroupLabel";
const x_ = b.forwardRef((e, t) => /* @__PURE__ */ _(
  Dw,
  {
    ref: t,
    "data-slot": "menu-radio-group",
    ...e
  }
));
x_.displayName = "MenuRadioGroup";
const C_ = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  Nw,
  {
    ref: r,
    className: le(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1fr_1rem] items-center gap-2 rounded p-2 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[checked]:text-info data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-radio-item",
    ...n,
    children: [
      /* @__PURE__ */ _("span", { className: "col-start-1", children: t }),
      /* @__PURE__ */ _(Aw, { className: "col-start-2", children: /* @__PURE__ */ _(yo, { className: "pointer-events-auto h-4 w-4 shrink-0" }) })
    ]
  }
));
C_.displayName = "MenuRadioItem";
const E_ = b.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ Z(
  Ew,
  {
    ref: o,
    checked: n,
    className: le(
      "relative grid cursor-pointer select-none scroll-m-1 grid-cols-[1rem_1fr] items-center gap-2 rounded px-4 py-2 pe-4 ps-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[highlighted]:bg-foundations-subtlest data-[disabled]:opacity-50 sm:text-sm",
      e
    ),
    "data-slot": "menu-checkbox-item",
    ...r,
    children: [
      /* @__PURE__ */ _(_w, { className: "col-start-1", children: /* @__PURE__ */ _(yo, { className: "pointer-events-auto h-4 w-4 shrink-0" }) }),
      /* @__PURE__ */ _("span", { className: "col-start-2", children: t })
    ]
  }
));
E_.displayName = "MenuCheckboxItem";
const UV = b.forwardRef(({ Icon: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  e,
  {
    ref: r,
    className: le("h-4 w-4", t),
    "aria-hidden": "true",
    ...n
  }
)), GV = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  mw,
  {
    ref: n,
    className: le(
      "-mx-2 my-1.5 border-t border-foundations-subtle",
      e
    ),
    "data-slot": "menu-separator",
    ...t
  }
)), RW = Object.assign(YV, {
  Trigger: g_,
  Popup: rg,
  Group: y_,
  Item: m_,
  Icon: UV,
  CheckboxItem: E_,
  RadioGroup: x_,
  RadioItem: C_,
  GroupLabel: w_,
  Separator: GV,
  Sub: jV,
  SubTrigger: b_,
  SubPopup: v_
}), KV = b.forwardRef(
  ({ steps: e, currentStepIndex: t }, n) => {
    const r = (s) => s === t, o = (s) => s < t;
    return /* @__PURE__ */ _("nav", { ref: n, "aria-label": "progress", children: /* @__PURE__ */ _("ol", { className: "flex flex-wrap", children: e.map((s, i) => /* @__PURE__ */ Z("li", { className: "flex items-center", children: [
      i > 0 && /* @__PURE__ */ _("hr", { className: "mx-2 h-[1px] w-8 bg-foundations-bold" }),
      /* @__PURE__ */ Z("div", { className: "flex flex-wrap items-center justify-center gap-2", children: [
        o(i) ? /* @__PURE__ */ _(qV, {}) : /* @__PURE__ */ _(XV, { isActive: r(i) }),
        /* @__PURE__ */ _(
          "span",
          {
            className: le(
              "text-sm font-medium",
              r(i) ? "text-foundations-boldest" : "text-foundations-subtle"
            ),
            children: s
          }
        )
      ] })
    ] }, `${i}-${s}`)) }) });
  }
);
KV.displayName = "Stepper";
const qV = () => /* @__PURE__ */ _("span", { className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-info-subtler p-1", children: /* @__PURE__ */ _(yo, { className: "h-4 w-4 text-info" }) }), XV = ({ isActive: e }) => /* @__PURE__ */ _(
  "span",
  {
    className: le(
      "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-foundations-subtlest",
      e ? "bg-info-bold" : "bg-foundations-subtlest"
    ),
    children: /* @__PURE__ */ _(
      "span",
      {
        className: le(
          "h-[10px] w-[10px] rounded-full bg-foundations-subtle",
          e ? "bg-white" : "bg-foundations-subtle"
        )
      }
    )
  }
), __ = b.createContext(null), og = () => {
  const e = b.useContext(__);
  if (!e)
    throw new Error("useSheetContext must be used within <SheetContext />");
  return e;
};
function ZV({ noBackdrop: e, container: t, ...n }) {
  return /* @__PURE__ */ _(
    __.Provider,
    {
      value: {
        noBackdrop: e,
        container: t
      },
      children: /* @__PURE__ */ _(
        Ny,
        {
          modal: e ? !1 : n.modal,
          ...n
        }
      )
    }
  );
}
function S_(e) {
  return /* @__PURE__ */ _(_h, { ...e });
}
function QV(e) {
  return /* @__PURE__ */ _(kh, { "data-slot": "sheet-trigger", ...e });
}
function O_({ className: e, ...t }) {
  return /* @__PURE__ */ Z(
    Kl,
    {
      "data-slot": "sheet-close",
      className: le("shrink-0", e),
      ...t,
      children: [
        /* @__PURE__ */ _(
          Ih,
          {
            className: "h-6 w-6 text-foundations-subtler hover:text-foundations-subtle",
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ _("span", { className: "sr-only", children: "Close" })
      ]
    }
  );
}
function M_({ className: e, ...t }) {
  const { container: n } = og();
  return /* @__PURE__ */ _(
    vh,
    {
      className: le(
        "pointer-events-none fixed inset-0 z-50 bg-[rgba(0,0,0,0.40)] transition-opacity duration-300",
        "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
        "data-[ending-style]:ease-in data-[starting-style]:ease-out",
        !!n && "absolute",
        e
      ),
      "data-slot": "sheet-backdrop",
      ...t
    }
  );
}
function T_({
  className: e,
  side: t,
  inset: n,
  ...r
}) {
  const { container: o } = og();
  return /* @__PURE__ */ _(
    Oh,
    {
      className: le(
        // "grid-rows-[1fr_auto_1fr] justify-items-center p-4",
        "pointer-events-none fixed inset-0 z-50 grid",
        t === "bottom" && "grid grid-rows-[1fr_auto] pt-12",
        t === "top" && "grid grid-rows-[auto_1fr] pb-12",
        t === "left" && "flex justify-start",
        t === "right" && "flex justify-end",
        n && "sm:p-3",
        !!o && "absolute",
        e
      ),
      "data-slot": "sheet-viewport",
      ...r
    }
  );
}
function JV({
  className: e,
  children: t,
  side: n = "right",
  inset: r = !0,
  ...o
}) {
  const { noBackdrop: s, container: i } = og();
  return /* @__PURE__ */ Z(S_, { container: i, children: [
    !s && /* @__PURE__ */ _(M_, {}),
    /* @__PURE__ */ _(T_, { side: n, inset: r, children: /* @__PURE__ */ _(
      Eh,
      {
        className: le(
          "pointer-events-auto relative flex max-h-full min-h-0 w-full min-w-0 flex-col overflow-hidden border border-foundations-subtle bg-foundations-default bg-clip-padding shadow-xl transition-all duration-300 ease-in-out will-change-transform",
          "before:pointer-events-none before:absolute before:inset-0 before:shadow-[0_1px_--theme(--color-black/6%)]",
          "data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 dark:before:shadow-[0_-1px_--theme(--color-white/6%)] max-sm:before:hidden",
          n === "bottom" && "row-start-2 border-t data-[ending-style]:translate-y-11 data-[starting-style]:translate-y-11",
          n === "top" && "border-b data-[ending-style]:-translate-y-11 data-[starting-style]:-translate-y-11",
          n === "left" && "max-w-md border-r data-[ending-style]:-translate-x-11 data-[starting-style]:-translate-x-11",
          n === "right" && "col-start-2 max-w-md border-l data-[ending-style]:translate-x-11 data-[starting-style]:translate-x-11",
          r && "sm:**:data-[slot=sheet-footer]:rounded-b-[calc(var(--radius-xl)-1px)] before:hidden sm:rounded-xl sm:before:rounded-[calc(var(--radius-xl)-1px)]",
          e
        ),
        "data-slot": "sheet-popup",
        ...o,
        children: t
      }
    ) })
  ] });
}
const k_ = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ Z(
  "div",
  {
    ref: r,
    className: le(
      "flex items-center justify-between gap-2 border-b border-b-foundations-subtle px-8 py-6 text-lg font-medium text-foundations-boldest",
      e
    ),
    "data-slot": "sheet-header",
    ...n,
    children: [
      /* @__PURE__ */ _("div", { className: "flex min-w-0 flex-1 flex-col gap-1.5", children: t }),
      /* @__PURE__ */ _(O_, { className: "shrink-0" })
    ]
  }
));
k_.displayName = "SheetHeader";
function eW({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: le(
        "mt-auto flex flex-row-reverse gap-4 border-t border-t-foundations-subtle bg-foundations-default px-8 py-6",
        e
      ),
      "data-slot": "sheet-footer",
      ...t
    }
  );
}
const P_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    className: le(
      "text-xs font-medium uppercase leading-6 text-foundations-bold",
      e
    ),
    "data-slot": "sheet-subheading",
    ...t
  }
));
P_.displayName = "SheetSubHeading";
const R_ = b.forwardRef(
  ({ className: e, render: t, ...n }, r) => /* @__PURE__ */ _(
    Mh,
    {
      ref: r,
      render: t || /* @__PURE__ */ _("h3", {}),
      className: le(
        "text-lg font-medium leading-6 text-foundations-boldest",
        e
      ),
      "data-slot": "sheet-title",
      ...n
    }
  )
);
R_.displayName = "SheetTitle";
function tW({
  className: e,
  ref: t,
  ...n
}) {
  return /* @__PURE__ */ _(
    xh,
    {
      ref: t,
      className: le("text-sm text-foundations-subtle", e),
      "data-slot": "sheet-description",
      ...n
    }
  );
}
function nW({ className: e, ...t }) {
  return /* @__PURE__ */ _(
    "div",
    {
      className: le("flex-1 overflow-auto p-8", e),
      "data-slot": "sheet-panel",
      ...t
    }
  );
}
const IW = Object.assign(ZV, {
  Trigger: QV,
  Portal: S_,
  Close: O_,
  Backdrop: M_,
  Popup: JV,
  Header: k_,
  SubHeading: P_,
  Footer: eW,
  Title: R_,
  Description: tW,
  Panel: nW,
  Viewport: T_
}), DW = ie.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "div",
  {
    ref: n,
    className: le(
      "pointer-events-none absolute bottom-0 left-0 z-20 h-16 w-full bg-gradient-to-t from-[theme(backgroundColor.foundations-default)] to-transparent",
      e
    ),
    ...t
  }
)), I_ = b.forwardRef((e, t) => /* @__PURE__ */ _(vw, { ref: t, "data-slot": "collapsible", ...e }));
I_.displayName = "Collapsible";
const sg = b.forwardRef((e, t) => /* @__PURE__ */ _(
  yw,
  {
    ref: t,
    "data-slot": "collapsible-trigger",
    ...e
  }
));
sg.displayName = "CollapsibleTrigger";
const rW = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ww,
  {
    ref: n,
    "data-slot": "collapsible-panel",
    className: le(
      "h-[--collapsible-panel-height] overflow-hidden transition-[height] duration-200 data-[ending-style]:h-0 data-[starting-style]:h-0",
      e
    ),
    ...t
  }
));
sg.displayName = "CollapsiblePanel";
const NW = Object.assign(I_, {
  Trigger: sg,
  Panel: rW
}), AW = ({
  id: e,
  link: t,
  className: n,
  size: r = "sm",
  "data-testid": o
}) => {
  const { name: s, url: i } = t || {};
  return /* @__PURE__ */ Z("div", { className: le("flex min-w-0 items-center gap-1", n), children: [
    /* @__PURE__ */ _(
      Ty,
      {
        size: "sm",
        hoverable: !1,
        render: i ? /* @__PURE__ */ _(
          Sp,
          {
            href: i,
            target: "_blank",
            variant: "standalone",
            showExternalIcon: !1,
            size: r,
            className: "block",
            onClick: (a) => a.stopPropagation(),
            children: s || e
          }
        ) : /* @__PURE__ */ _(
          "span",
          {
            className: le(
              "truncate text-foundations-subtle",
              r === "md" ? "text-sm" : "text-xs"
            ),
            children: e
          }
        )
      }
    ),
    /* @__PURE__ */ _(oW, { id: e, dataTestId: o })
  ] });
}, oW = ({
  id: e,
  dataTestId: t
}) => {
  const [n, r] = _t(!1), { copy: o, isCopied: s } = yx();
  return /* @__PURE__ */ Z(Rt, { open: n, children: [
    /* @__PURE__ */ _(
      Rt.Trigger,
      {
        delay: 0,
        render: /* @__PURE__ */ _(
          Di,
          {
            size: "sm",
            className: "inline-flex shrink-0 px-1 py-0.5",
            onMouseEnter: () => r(!0),
            onMouseLeave: () => r(!1),
            onFocus: () => r(!0),
            onBlur: () => r(!1),
            variant: "tertiary",
            onClick: (i) => {
              i.stopPropagation(), s || o(e);
            },
            "data-testid": t
          }
        ),
        children: s ? /* @__PURE__ */ _(yo, { className: "text-success" }) : /* @__PURE__ */ _(Fy, { className: "" })
      }
    ),
    /* @__PURE__ */ _(Rt.Popup, { size: "sm", children: s ? "Copied!" : "Copy ID" })
  ] });
}, D_ = b.forwardRef(({ ...e }, t) => /* @__PURE__ */ _("nav", { ref: t, "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e }));
D_.displayName = "Breadcrumb";
const N_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "ol",
  {
    ref: n,
    className: le(
      "flex flex-wrap items-center break-words text-sm",
      e
    ),
    "data-slot": "breadcrumb-list",
    ...t
  }
));
N_.displayName = "BreadcrumbList";
const A_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "li",
  {
    ref: n,
    className: le("inline-flex items-center gap-1.5", e),
    "data-slot": "breadcrumb-item",
    ...t
  }
));
A_.displayName = "BreadcrumbItem";
const $_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  Sp,
  {
    ref: n,
    showExternalIcon: !1,
    className: le("rounded-md p-2 hover:bg-foundations-subtlest", e),
    ...t
  }
));
$_.displayName = "BreadcrumbLink";
const F_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "aria-current": "page",
    "aria-disabled": "true",
    className: le("py-2 pl-2 font-medium text-foundations-bolder", e),
    "data-slot": "breadcrumb-page",
    role: "link",
    ...t
  }
));
F_.displayName = "BreadcrumbPage";
const L_ = b.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ _(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: le("text-foundations-subtler [&>svg]:size-4", t),
    "data-slot": "breadcrumb-separator",
    role: "presentation",
    ...n,
    children: e ?? /* @__PURE__ */ _(Ph, {})
  }
));
L_.displayName = "BreadcrumbSeparator";
const V_ = b.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ Z(
  "li",
  {
    ref: r,
    "aria-hidden": "true",
    className: le("text-info", t),
    "data-slot": "breadcrumb-ellipsis",
    role: "presentation",
    ...n,
    children: [
      /* @__PURE__ */ _(xk, { className: "size-4" }),
      /* @__PURE__ */ _("span", { className: "sr-only", children: "More" })
    ]
  }
));
V_.displayName = "BreadcrumbEllipsis";
const $W = Object.assign(D_, {
  List: N_,
  Item: A_,
  Link: $_,
  Page: F_,
  Separator: L_,
  Ellipsis: V_
}), W_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ox,
  {
    ref: n,
    className: le("flex flex-col", e),
    "data-slot": "tabs",
    ...t
  }
));
W_.displayName = "Tabs";
const B_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ax,
  {
    ref: n,
    className: le(
      "flex items-end gap-4 border-b border-foundations-subtler",
      e
    ),
    "data-slot": "tabs-list",
    ...t
  }
));
B_.displayName = "TabsList";
const H_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  sx,
  {
    ref: n,
    className: le(
      // general tab styles
      "-mb-px shrink-0 items-center gap-x-1.5 gap-y-1 whitespace-nowrap rounded-t border-b-2 border-b-transparent px-2 pb-1.5 pt-2 text-left text-sm font-medium text-foundations-subtle outline-none first-of-type:pl-0 [&_svg]:pointer-events-none [&_svg]:shrink-0",
      // layout
      "flex items-center [&:has([data-slot='tab-description'])]:grid [&:has([data-slot='tab-description'])]:grid-cols-[auto_auto_1fr]",
      // hover styles
      "hover:border-foundations-bold hover:text-foundations-bold",
      // focus styles
      "focus:border-foundations-subtle focus:text-info",
      // active tab default styles
      "data-[active]:border-b-2 data-[active]:border-info-bold data-[active]:text-foundations-bolder",
      // active tab hover styles
      "hover:data-[active]:border-info-bolder hover:data-[active]:text-foundations-boldest",
      // active tab focus styles
      "focus:data-[active]:border-info-bolder focus:data-[active]:text-info",
      // disabled tab styles
      "data-[disabled]:pointer-events-none data-[disabled]:border-foundations-subtler data-[disabled]:text-foundations-subtler",
      e
    ),
    ...t
  }
));
H_.displayName = "TabsTab";
const Y_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  ix,
  {
    ref: n,
    className: le("flex-1 pt-6", e),
    "data-slot": "tabs-content",
    ...t
  }
));
Y_.displayName = "TabsPanel";
const z_ = b.forwardRef(({ className: e, variant: t = "light", size: n = "sm", children: r, ...o }, s) => /* @__PURE__ */ Z(Rt, { children: [
  /* @__PURE__ */ _(
    Rt.Trigger,
    {
      ref: s,
      render: /* @__PURE__ */ _(
        "span",
        {
          className: "inline-block rounded-full bg-foundations-subtlest p-0.5",
          "data-slot": "tab-hint"
        }
      ),
      children: /* @__PURE__ */ _(
        Rh,
        {
          "data-slot": "hint-icon",
          className: le("h-4 w-4 text-foundations-subtle", e)
        }
      )
    }
  ),
  /* @__PURE__ */ _(Rt.Popup, { size: n, variant: t, ...o, children: r })
] }));
z_.displayName = "TabsTabHint";
const j_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ _(
  "span",
  {
    ref: n,
    "data-slot": "tab-description",
    className: le("col-span-3 text-xs font-normal", e),
    ...t
  }
));
j_.displayName = "TabsTabDescription";
const FW = Object.assign(W_, {
  List: B_,
  Tab: H_,
  Panel: Y_,
  Hint: z_,
  Description: j_
}), sW = {
  error: Ih,
  info: Rh,
  loading: Mk,
  success: yk,
  warning: Ck
};
function iW(e) {
  const t = e.updateKey ?? 0;
  if (t <= 0)
    return;
  const n = t % 2 === 0;
  return e.type === "error" ? n ? "animate-toast-error-even" : "animate-toast-error-odd" : n ? "animate-toast-success-even" : "animate-toast-success-odd";
}
function aW({ position: e }) {
  const { toasts: t } = G3();
  return /* @__PURE__ */ _(U3, { "data-slot": "toast-portal", children: /* @__PURE__ */ _(
    ux,
    {
      className: le(
        "fixed z-[60] mx-auto flex w-[calc(100%-var(--toast-inset)*2)] max-w-[25rem] [--toast-inset:1rem] sm:[--toast-inset:2rem]",
        // Vertical positioning
        "data-[position*=top]:top-[var(--toast-inset)]",
        "data-[position*=bottom]:bottom-[var(--toast-inset)]",
        // Horizontal positioning
        "data-[position*=left]:left-[var(--toast-inset)]",
        "data-[position*=right]:right-[var(--toast-inset)]",
        "data-[position*=center]:left-1/2 data-[position*=center]:-translate-x-1/2"
      ),
      "data-position": e,
      "data-slot": "toast-viewport",
      children: t.map((n) => {
        const r = n.type ? sW[n.type] : null, o = n.data;
        return /* @__PURE__ */ _(
          dx,
          {
            className: le(
              "absolute z-[calc(9999-var(--toast-index))] h-[var(--toast-calc-height)] w-full select-none rounded-lg border border-foundations-subtle bg-foundations-default bg-clip-padding text-foundations-boldest shadow-lg [transition:transform_.5s_cubic-bezier(.22,1,.36,1),opacity_.5s,height_.15s,background-color_.5s] before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(0.5rem-1px)] before:shadow-[0_1px_rgba(0,0,0,0.04)] dark:before:shadow-[0_-1px_rgba(255,255,255,0.06)]",
              // Base positioning using data-position
              "data-[position*=right]:left-auto data-[position*=right]:right-0",
              "data-[position*=left]:left-0 data-[position*=left]:right-auto",
              "data-[position*=center]:left-0 data-[position*=center]:right-0",
              "data-[position*=top]:bottom-auto data-[position*=top]:top-0 data-[position*=top]:origin-[50%_calc(50%-50%*min(var(--toast-index,0),1))]",
              "data-[position*=bottom]:bottom-0 data-[position*=bottom]:top-auto data-[position*=bottom]:origin-[50%_calc(50%+50%*min(var(--toast-index,0),1))]",
              // Gap fill for hover
              "after:absolute after:left-0 after:h-[calc(var(--toast-gap)+1px)] after:w-full",
              "data-[position*=top]:after:top-full",
              "data-[position*=bottom]:after:bottom-full",
              // Define some variables
              "[--toast-calc-height:var(--toast-frontmost-height,var(--toast-height))] [--toast-gap:0.75rem] [--toast-peek:0.75rem] [--toast-scale:calc(max(0,1-(var(--toast-index)*.1)))] [--toast-shrink:calc(1-var(--toast-scale))]",
              // Define offset-y variable
              "data-[position*=top]:[--toast-calc-offset-y:calc(var(--toast-offset-y)+var(--toast-index)*var(--toast-gap))]",
              "data-[position*=bottom]:[--toast-calc-offset-y:calc(var(--toast-offset-y)*-1+var(--toast-index)*var(--toast-gap)*-1)]",
              // Default state transform
              "data-[position*=top]:[transform:translateY(calc((var(--toast-index)*var(--toast-peek))+(var(--toast-shrink)*var(--toast-calc-height))))_scale(var(--toast-scale))]",
              "data-[position*=bottom]:[transform:translateY(calc(0px-(var(--toast-index)*var(--toast-peek))-(var(--toast-shrink)*var(--toast-calc-height))))_scale(var(--toast-scale))]",
              // Limited state
              "data-[limited]:opacity-0",
              // Expanded state
              "data-[expanded]:h-[var(--toast-height)]",
              "data-[position]:data-[expanded]:[transform:translateY(var(--toast-calc-offset-y))]",
              // Starting and ending animations
              "data-[position*=top]:data-[starting-style]:[transform:translateY(calc(-100%-var(--toast-inset)))]",
              "data-[position*=bottom]:data-[starting-style]:[transform:translateY(calc(100%+var(--toast-inset)))]",
              "data-[ending-style]:opacity-0",
              // Ending animation — position-aware so top-* exits upward and bottom-* exits downward.
              "[&[data-position*=top][data-ending-style]]:[transform:translateY(calc(-100%-var(--toast-inset)))]",
              "[&[data-position*=bottom][data-ending-style]]:[transform:translateY(calc(100%+var(--toast-inset)))]",
              iW(n)
            ),
            ...o == null ? void 0 : o.rootProps,
            "data-position": e,
            swipeDirection: [],
            toast: n,
            children: /* @__PURE__ */ Z(fx, { className: "duration-[250ms] pointer-events-auto flex items-start justify-between gap-1.5 overflow-hidden px-3.5 py-3 text-sm transition-opacity data-[behind]:opacity-0 data-[expanded]:opacity-100 [&:not(:has([data-slot=toast-description]:not(:empty)))]:items-center [&[data-behind]:not([data-expanded])]:pointer-events-none", children: [
              /* @__PURE__ */ Z("div", { className: "flex min-w-0 gap-2", children: [
                r && /* @__PURE__ */ _(
                  "div",
                  {
                    className: "[&>svg]:h-[1lh] [&>svg]:w-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                    "data-slot": "toast-icon",
                    children: /* @__PURE__ */ _(r, { className: "[[data-type=error]_&]:text-danger [[data-type=info]_&]:text-info [[data-type=loading]_&]:animate-spin [[data-type=loading]_&]:opacity-80 [[data-type=success]_&]:text-success [[data-type=warning]_&]:text-warning" })
                  }
                ),
                /* @__PURE__ */ Z("div", { className: "flex min-w-0 flex-col gap-0.5", children: [
                  /* @__PURE__ */ _(
                    px,
                    {
                      className: "font-medium",
                      "data-slot": "toast-title",
                      render: ({ children: s }) => /* @__PURE__ */ _(It, { children: cW(s) })
                    }
                  ),
                  /* @__PURE__ */ _(
                    hx,
                    {
                      className: "text-foundations-subtler",
                      "data-slot": "toast-description"
                    }
                  ),
                  n.actionProps && /* @__PURE__ */ _(
                    mx,
                    {
                      className: le(
                        Rf({ variant: "tertiary", size: "xs" }),
                        "self-start p-0 hover:bg-transparent"
                      ),
                      "data-slot": "toast-action"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ _(
                gx,
                {
                  "aria-label": "Close",
                  className: "focus-visible:outline-foundations-bold -mr-1 -mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-foundations-subtler transition-colors hover:text-foundations-boldest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 [:not(:has([data-slot=toast-description]:not(:empty)))>&]:mt-0",
                  "data-slot": "toast-close",
                  children: /* @__PURE__ */ _(Jl, { className: "h-4 w-4" })
                }
              )
            ] })
          },
          n.id
        );
      })
    }
  ) });
}
const gl = K3();
function as(e, t, n = {}) {
  const { id: r, description: o, duration: s, actionProps: i } = n;
  return gl.add({
    id: r,
    type: e,
    title: t,
    description: o,
    timeout: s,
    actionProps: i
  });
}
const LW = Object.assign(
  (e, t) => as(void 0, e, t),
  {
    success: (e, t) => as("success", e, t),
    error: (e, t) => as("error", e, t),
    loading: (e, t) => as("loading", e, t),
    info: (e, t) => as("info", e, t),
    warning: (e, t) => as("warning", e, t),
    dismiss: (e) => {
      gl.close(e);
    },
    promise(e, t, n) {
      const r = {
        id: n == null ? void 0 : n.id,
        timeout: n == null ? void 0 : n.duration,
        actionProps: n == null ? void 0 : n.actionProps
      };
      return gl.promise(e, {
        loading: { ...r, title: t.loading },
        success: (o) => ({
          ...r,
          title: typeof t.success == "function" ? t.success(o) : t.success
        }),
        error: (o) => ({
          ...r,
          title: typeof t.error == "function" ? t.error(o) : t.error
        })
      });
    }
  }
);
function VW({
  children: e,
  position: t = "bottom-right",
  ...n
}) {
  return /* @__PURE__ */ Z(lx, { toastManager: gl, ...n, children: [
    e,
    /* @__PURE__ */ _(aW, { position: t })
  ] });
}
const cW = (e) => {
  if (b.isValidElement(e))
    return e;
  if (typeof e == "string")
    return /* @__PURE__ */ _("h2", { className: "truncate whitespace-pre-wrap", title: e, children: e });
  if (e instanceof Object) {
    const t = Object.entries(e);
    return /* @__PURE__ */ _("ul", { children: t.map(([n, r], o) => /* @__PURE__ */ Z("li", { children: [
      n,
      " : ",
      U_(r)
    ] }, o)) });
  }
  return /* @__PURE__ */ _(It, { children: e });
}, U_ = (e) => {
  if (typeof e == "string" || typeof (e == null ? void 0 : e[0]) == "string")
    return e;
  if (Array.isArray(e))
    return /* @__PURE__ */ _("ul", { className: "list-disc pl-6", children: e == null ? void 0 : e.map((t) => Object.entries(t).map(([r, o], s) => /* @__PURE__ */ Z("li", { children: [
      r,
      ": ",
      o
    ] }, s))) });
  if (e instanceof Object) {
    const t = Object.entries(e);
    return /* @__PURE__ */ _("ul", { className: "list-disc pl-6", children: t.map(([n, r], o) => /* @__PURE__ */ Z("li", { children: [
      n,
      " : ",
      U_(r)
    ] }, o)) });
  }
  return e;
};
function WW(e) {
  const { fileInputDom: t, accept: n, onSelect: r } = e ?? {}, o = Ue(null), [s, i] = _t(null), [a, c] = _t(!1), [l, u] = _t(null), d = je(() => {
    o.current && (o.current.value = "");
  }, []), f = je(async () => {
    var g, m;
    const p = (m = (g = o.current) == null ? void 0 : g.files) == null ? void 0 : m[0];
    i(p || null);
    try {
      c(!0), p && await (r == null ? void 0 : r(p, d));
    } catch (y) {
      u(y);
    } finally {
      c(!1);
    }
  }, [r]);
  return Ke(() => {
    o.current || (o.current = t ?? document.createElement("input"), o.current.type = "file", o.current.accept = n ?? "*/*", o.current.disabled = (e == null ? void 0 : e.disabled) ?? !1, o.current.addEventListener("change", f));
  }, [t, f]), { file: s, isLoading: a, error: l, selectFile: () => {
    o.current && o.current.click();
  } };
}
function BW({
  currency: e,
  amount: t,
  compact: n = !1
}) {
  const r = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: e,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: n ? "compact" : "standard"
  });
  return n ? r.format(t) : r.format(t).replace(/^(\D+)\s*(.+)$/, "$2$1").trim();
}
function HW({
  value: e,
  compact: t = !1
}) {
  return new Intl.NumberFormat(void 0, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: t ? "compact" : "standard"
  }).format(e);
}
export {
  EW as AccessDeniedIllustration,
  Q3 as Alert,
  X3 as Badge,
  kW as BasePopover,
  $W as Breadcrumb,
  Tc as Button,
  qS as ButtonGroup,
  b0 as ButtonSpinner,
  pC as Calendar,
  e4 as Card,
  mW as Chart,
  Uh as ChartJS,
  s6 as ChartProvider,
  Ox as Checkbox,
  _6 as CircleChart,
  NW as Collapsible,
  c4 as CopyIconButton,
  AW as CopyIdButton,
  cL as DateInput,
  sL as DatePicker,
  fW as Dialog,
  vW as DiffPercentageBadge,
  PW as DropdownSearch,
  yW as EmptyStateIllustration,
  wW as EmptyStateIllustration2,
  xW as EmptyStateIllustration3,
  CW as EmptyStateIllustration4,
  O6 as HorizontalBarsChart,
  Di as IconButton,
  wx as Input,
  _4 as InputOTP,
  Sp as Link,
  t4 as LinkBox,
  n4 as LinkOverlay,
  RW as Menu,
  vx as NoMatchingResultIllustration,
  c9 as Option,
  a9 as OptionsGroup,
  DW as OverflowIndicator,
  Ty as OverflowText,
  lL as Popover,
  MW as PopoverArrow,
  dL as PopoverClose,
  fL as PopoverContent,
  uL as PopoverTrigger,
  rw as Portal,
  TW as ProgressBar,
  aw as ProgressRadial,
  k4 as Radio,
  o_ as SELECT_ALL_VALUE,
  r4 as SearchIllustration,
  WV as Select,
  IW as Sheet,
  YT as Skeleton,
  Os as Slot,
  KV as Stepper,
  _W as Switch,
  FW as Tabs,
  VW as ToastProvider,
  Rt as Tooltip,
  Xg as TooltipProvider,
  VT as TooltipRoot,
  HV as UploadArea,
  Z3 as alertVariants,
  q3 as badgeVariants,
  Rf as buttonVariants,
  le as cn,
  bW as createScale,
  En as cva,
  BW as formatCurrency,
  HW as formatNumber,
  Nr as getColorFromCssVariable,
  XS as iconButtonVariants,
  P4 as linkVariants,
  T4 as switchThumbVariants,
  M4 as switchVariants,
  LW as toast,
  gl as toastManager,
  lf as useCallbackRef,
  aa as useChart,
  en as useCombobox,
  yx as useCopyToClipboard,
  Pn as useDateInput,
  IV as useUncontrolled,
  WW as useUploadFile
};
